/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * account.js: Feature level module
	 * @description This module is used for:
	 *              1. Sign In / Create Account
	 *              2. Forgot Password
	 *              3. My Account sub pages including
	 *                3.1. Account Details
	 *                3.2. Address Book
	 *                3.3. Payment Method
	 *                3.4. My Orders
	 *                3.5. Wish Lists
	 *                3.6. Shopping Lists
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(30), __webpack_require__(4), __webpack_require__(5), __webpack_require__(6), __webpack_require__(7), __webpack_require__(20), __webpack_require__(23), __webpack_require__(25), __webpack_require__(28), __webpack_require__(29), __webpack_require__(1), __webpack_require__(31), __webpack_require__(33), __webpack_require__(34), __webpack_require__(35), __webpack_require__(36), __webpack_require__(38), __webpack_require__(26), __webpack_require__(39), __webpack_require__(40), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (logon, membershipNumber, accountHelper, phelper, addressBook, preferences, renewMembership, paymentMethods, accountDetails, businessDetails, addAdditionalPeople, accountDetailsUpdatePass, myOrdersFSA, membershipValidation, registerUser, costcoPayFob, costcoPayAccountInformation, costcoPayTransactionHistory, secureKeyMemberVerification, timeoutModal, digitalMembershipCard, memberVerification) {
	
		var Account = {
	
			formValid: "",
			/**
	   * Initializes the appropriate submodules for the account feature.
	   * @return {void}
	   */
			init: function init() {
				$(document).keyup(function (e) {
					if (e.keyCode == 27) {
						//27 = keycode for escape
						//Hide tooltip here
						$("div[role='tooltip']").hide();
					}
				});
				accountHelper.init();
				var page = $('[data-page]').data('page') || '';
				switch (page) {
					case 'Home,MyAccount,Preferences':
						preferences.init();
						break;
					case 'Home,MyAccount,RenewMembership':
						renewMembership.init();
						break;
					case 'Home,MyAccount,PaymentMethods':
						paymentMethods.init();
						break;
					case 'Home,MyAccount,AccountAddressBook':
						addressBook.init();
						break;
					case 'Home,MyAccount,AccountDetails':
						accountDetails.init();
						break;
					case 'Home,MyAccount,OrderStatus,FSAOrders':
						myOrdersFSA.init();
						break;
					case 'Home,MyAccount,OrderStatus':
						memberVerification.init();
						break;
					case 'Home,MyAccount,UpdatePassword':
						accountDetailsUpdatePass.init();
						break;
					case 'Home,MyAccount,BusinessDetails':
						businessDetails.init();
						break;
					case 'Home,MyAccount,BusinessDetails,AddAdditionalPeople':
						addAdditionalPeople.init();
						break;
					case 'RegisterUser':
						registerUser.init();
						break;
					case 'LinkMembershipInterrupt':
					case 'SecondaryValidation':
					case 'CanceledMembership':
						$('.co-help').popover();
						membershipValidation.init();
						secureKeyMemberVerification.init();
						break;
					case 'ValidationExceedAttempts':
						membershipValidation.init();
						secureKeyMemberVerification.init();
						break;
					case 'Home,MyAccount,CostcoPay':
						membershipValidation.init();
						costcoPayAccountInformation.init();
						costcoPayFob.init();
						costcoPayTransactionHistory.init();
						break;
					case 'verify-membership':
						secureKeyMemberVerification.init();
						break;
					case 'Home,MyAccount,DigitalMembershipCard':
						digitalMembershipCard.init();
						break;
					default:
						membershipNumber.init();
						logon.init();
				}
	
				accountHelper.reinitDropDownMenu();
				accountHelper.activateDropdownMenuRedirect();
				accountHelper.addAdaComplianceOnLeftNabarForAccount();
				Account.validateAccountRules();
				Account.registerEvents();
				COSTCO.dialog.initializeReturnFocusListener();
				COSTCO.timeoutModal.init();
			},
	
			validateAccountRules: function validateAccountRules() {
				$.validator.addMethod('email', function (value, element) {
					return this.optional(element) || /^.+@(([^.])+\.)+([^.])+$/i.test(value);
				}, messages.ERR_INVALID_EMAIL_ADDRESS);
				$.validator.addMethod('singleemail', function (value, element) {
					var flag = true;
					flag = flag && /^\s*((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?\s*$/.test(value.toLowerCase());
					return this.optional(element) || flag;
				}, messages.ERR_INVALID_EMAIL_ADDRESS);
				$.validator.addMethod('membershipNumber', function (value, element) {
					// costco pins are 12 digits
					return this.optional(element) || /^\d{12,16}$/.test(value);
				}, messages.MEMBERVERIFICATION_MEMBERSHIP__InvalidMembershipNumber);
				$.validator.addMethod('costcoMembership', function (value, element) {
					return this.optional(element) || /^\d{12,16}$/.test(value);
				}, messages.ERR_INVALID_MEMBERSHIP_BD);
	
				Account.formValid = $('.accountEmailForm').validate({
					errorClass: "h8-style-guide error-membership",
					rules: {
						email: {
							required: true,
							email: true,
							singleemail: true,
							maxlength: 251
						},
						email1: {
							required: true,
							email: true,
							singleemail: true,
							maxlength: 251
						},
						userField2: {
							required: true,
							costcoMembership: true
						}
	
					},
					messages: {
						email: {
							required: messages.JS_VALID_REQUIRED,
							email: messages.ERR_INVALID_EMAIL_ADDRESS,
							singleemail: messages.ERR_INVALID_EMAIL_ADDRESS,
							maxlength: messages.ERR_EMAIL_MAX_LENGTH
						},
						email1: {
							required: messages.JS_VALID_REQUIRED,
							email: messages.ERR_INVALID_EMAIL_ADDRESS,
							singleemail: messages.ERR_INVALID_EMAIL_ADDRESS,
							maxlength: messages.ERR_EMAIL_MAX_LENGTH
						},
						userField2: {
							required: messages.ERR_INVALID_MEMBERSHIP_BD,
							costcoMembership: messages.ERR_INVALID_MEMBERSHIP_BD
						}
					},
					submitHandler: function (form) {
						form.submit();
					}.bind(this)
				});
			},
	
			registerEvents: function registerEvents() {
				$(".editMembershipNumber").on("click", function (e) {
					e.preventDefault();
					Account.memberShipUpdateEnable();
				});
				$(".editEmailAddress").on("click", function (e) {
					e.preventDefault();
					$("#emailEditLink").hide();
					$(".email-box-label").hide();
					$("input.email-input-field").val($(".email-box-label").text());
					$("input.email-input-field").show();
					$("button.update-email-button").show();
				});
	
				$(".update-email-button").on("click", function (e) {
					if ($('.accountEmailForm').valid()) {
						e.preventDefault();
						COSTCO.dialog.createExtDialogBox({
							title: messages.CHANGE_EMAIL_NOTIFICATION_TITLE,
							body: messages.CHANGE_EMAIL_NOTIFICATION_TEXT,
							primary: messages.CHANGE_EMAIL_NOTIFICATION_CONT,
							primary_event: function primary_event() {
								$("#emailEditLink").hide();
								$(".email-box-label").hide();
								$("button.update-email-button").hide();
								COSTCO.dialog.close();
								$('.accountEmailForm').submit();
							}
						});
					}
				});
	
				$(".editPreferenceEmail").on("click", function (e) {
					e.preventDefault();
					$("#emailEditLink").hide();
					$('.editPreferenceEmail').hide();
					$(".email-box-label").hide();
					$("input.email-input-field").val($(".email-box-label").text());
					$("input.email-input-field").show();
					$("button.update-preference-email-button").show();
				});
				$("#receiveMail").on("change", function (e) {
					$("#sendMeEmail").val(!this.checked);
				});
			},
			memberShipUpdateEnable: function memberShipUpdateEnable() {
				$("#membershipEditLink").hide();
				$(".member-box-label").hide();
				$("input.member-input-field").val($(".member-box-label").text());
				$("input.member-input-field").show();
				$("button.update-member-button").show();
			}
	
		};
		$(window).on('load', function () {
			if ($('input[name=userField2]').val() == '') {
				Account.memberShipUpdateEnable();
			}
			if ($('#errForEmail').val() == 'true') {
				$('#emailEditLink').click();
			}
		});
	
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = {};
		}
		if (typeof window.COSTCO.Global == 'undefined') {
			document.addEventListener('CostcoGlobalLoaded', Account.init, false);
		} else {
			Account.init();
		}
		window.COSTCO.Account = Account;
		return Account;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title account-details-update.js: Sub-module for Account pages
	 * @description This module is used to handle account details tasks
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (passwordStrength) {
	  var AccountDetailsUpdatePass = {
	    /**
	     * Basic initial function. Sets events, form focus and fires the
	     * needed validation methods.
	     * @return {void}
	     */
	    init: function init() {
	      this.validationRules();
	      this.validate();
	      this.focusInput();
	      passwordStrength.init();
	    },
	    /**
	     * We want to focus the user on the existing password input field
	     */
	    focusInput: function focusInput() {
	      $(window).ready(function () {
	        $("input[name='logonPasswordOld']").focus();
	        window.scrollTo(0, 0);
	      });
	    },
	    /**
	     * The validation rules for the inputs assoicated new password creation.
	     */
	    validationRules: function validationRules() {
	      $.validator.addMethod('passwordRule', function (value, element) {
	        return (/^[^<,>,",\\,\s,\.]{8,20}$/.test(value) && /[a-zA-Z]/.test(value)
	        );
	      }, messages.JS_VALID_REQUIRED);
	    },
	    /**
	     * Validate the given forms.
	     */
	    validate: function validate() {
	
	      $('#ChangePasswordForm').validate({
	        rules: {
	          logonPasswordOld: {
	            required: true
	          },
	          logonPassword: {
	            required: true,
	            passwordRule: true
	          },
	          logonPasswordVerify: {
	            required: true,
	            passwordRule: true,
	            equalTo: 'input[name="logonPassword"]'
	          }
	        },
	        messages: {
	          logonPasswordOld: {
	            required: messages.CONFIRM_PASSWORD
	          },
	          logonPassword: {
	            required: messages.CONFIRM_PASSWORD,
	            passwordRule: messages.ERR_REQUIRED_PASSWORD
	          },
	          logonPasswordVerify: {
	            required: messages.CONFIRM_PASSWORD,
	            passwordRule: messages.ERR_REQUIRED_PASSWORD,
	            equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH
	          }
	        },
	
	        submitHandler: function (form) {
	          form.submit();
	        }.bind(this)
	      });
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.AccountDetailsUpdatePass = AccountDetailsUpdatePass;
	  return AccountDetailsUpdatePass;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Password Strength indiciator
	 *  Used in account.module.js
	 *    for create account
	 *    for forgot password
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var PasswordStrength = {
	    init: function init() {
	      if (!$('#logonPassword').length > 0 || $('#RegisterForm, #ChangePasswordForm, #RegisterFormBD').length == 0) return;
	      $('#logonPassword:not(.nostrength)').keyup(this.passwordStrength).focusin(function () {
	        $('#PasswordStrength').show();
	      });
	      $('#logonPasswordVerify').keyup(this.passwordMatch).focusin(function () {
	        $('#PasswordStrength').show();
	      });
	    },
	    passwordStrength: function passwordStrength() {
	      var value = $(this).val();
	      var entropy = ['short', 'weak', 'fair', 'good', 'strong'];
	      var degree = 0;
	      if (/.{8,20}/.test(value)) {
	        degree++;
	        $('.chars').removeClass('invalid').addClass('valid');
	        if (/.{10,20}/.test(value)) {
	          if (/(?=.*[a-z])/.test(value)) {
	            degree++;
	          }
	          if (/(?=.*[A-Z])/.test(value)) {
	            degree++;
	          }
	          if (/(?=.*\d)/.test(value)) {
	            degree++;
	          }
	          if (/[!,%,&,@,#,$,^,*,?,_,~]/.test(value)) {
	            degree++;
	          }
	          degree--;
	        }
	      } else {
	        $('.chars').removeClass('valid').addClass('invalid');
	      }
	      if (/[a-z,A-Z]/.test(value)) {
	        $('.letters').removeClass('invalid').addClass('valid');
	      } else {
	        $('.letters').removeClass('valid').addClass('invalid');
	      }
	      if (/[<,>,",\\,\s,\.]/.test(value)) {
	        $('.special').removeClass('valid').addClass('invalid');
	      } else {
	        $('.special').removeClass('invalid').addClass('valid');
	      }
	      $('#PasswordStrength').removeClass().addClass(entropy[degree]);
	      if ($('#logonPasswordVerify').val().length > 0) {
	        PasswordStrength.passwordMatch();
	      } else if ($('#logonPassword').val().length == 0 && $('#logonPasswordVerify').val().length == 0) {
	        $('.valid').removeClass('valid');
	        $('.invalid').removeClass('invalid');
	      }
	    },
	    passwordMatch: function passwordMatch() {
	      if ($('#logonPasswordVerify').val().length > 0) {
	        if ($('#logonPasswordVerify').val() == $('#logonPassword').val()) {
	          $('.match').removeClass('invalid').addClass('valid');
	        } else {
	          $('.match').removeClass('valid').addClass('invalid');
	        }
	      }
	      if ($('#logonPassword').val().length == 0 && $('#logonPasswordVerify').val().length == 0) {
	        $('.valid').removeClass('valid');
	        $('.invalid').removeClass('invalid');
	      }
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.PasswordStrength = PasswordStrength;
	  return PasswordStrength;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (passwordStrength) {
	  var Logon = {
	    /**
	     * Initializing the module.
	     */
	    init: function init() {
	
	      COSTCO.util.maskMembershipInput();
	
	      this.allowSignIn();
	      this.validationRules();
	      this.validate();
	      this.validateMemberRestricted();
	      this.popovers();
	      this.focusInput();
	      this.addMaskToZipInput($('#deliveryZipCode'));
	      this.addMaskToZipInput($('#userRegdeliveryZipCode'));
	      passwordStrength.init();
	    },
	    /**
	     * We want to focus the user on the logon id (email) if
	     * it exists, otherwise we want to focus on the password input
	     * in the case of "change password"
	     * @return {void}
	     */
	    focusInput: function focusInput() {
	      // Adding a window load so the focus waits until the login form is drawn.
	      // Causes the footer to be viewed if logon form has been drawn yet.
	      $(window).on('load', function () {
	        var $focusInput = $('#ChangePasswordForm #membershipNumber').length > 0 ? $('#ChangePasswordForm #membershipNumber') : $('#logonId, #register_email1, #logonPasswordOld');
	        var $password = $('#logonPassword');
	        $focusInput.length > 0 ? $focusInput.focus() : $password.focus();
	        window.scrollTo(0, 0);
	      });
	    },
	    /**
	     * ALM2982
	     * We want to disable sign in before the whole logon page is loaded, because clicking sign in button before end of page load, may result in odd behaviour
	     * 
	     * @return {void}
	     */
	    allowSignIn: function allowSignIn() {
	      $('#sign_in_button').attr('disabled', true);
	      $(window).on('load', function () {
	        $('#sign_in_button').attr('disabled', false);
	        referrerURL = document.referrer;
	        url = document.URL;
	
	        // if we're redirectd from the ChangePassword Page, We need to show the success page
	        if ((!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && (referrerURL.indexOf('ChangePassword') > -1 || referrerURL.indexOf('ResetPassword') > -1) || COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && referrerURL.indexOf('AccountPasswordUpdate') > -1) && url.indexOf('LogonForm') > -1 && !$('#passwordSuccessMessage').length > 0) {
	          $('#passwordSuccessLogonMessage').removeClass('hide');
	        } else {
	          $('#passwordSuccessLogonMessage').addClass('hide');
	        }
	      });
	    },
	    /**
	     * Tool tips.
	     */
	    popovers: function popovers() {
	      $('.co-info, .co-help').popover();
	    },
	    /**
	     * The validation rules for the inputs assoicated with signing in,
	     * creating an account, and forgot password.
	     */
	    validationRules: function validationRules() {
	      $.validator.addMethod('email', function (value, element) {
	        return this.optional(element) || /^.+@(([^.])+\.)+([^.])+$/i.test(value);
	      }, messages.JS_VALID_EMAIL);
	      $.validator.addMethod('passwordRule', function (value, element) {
	        return (/^[^<,>,",\\,\s,\.]{8,20}$/.test(value) && /[a-zA-Z]/.test(value)
	        );
	      }, messages.JS_VALID_REQUIRED);
	      $.validator.addMethod('costcoMembership', function (value, element) {
	        return this.optional(element) || /^\d{12,16}$/.test(value);
	      }, messages.ERR_INVALID_MEMBERSHIP_NO);
	      $.validator.addMethod('countryspecificpostalcode', function (value, element, params) {
	        var zip_pattern = new RegExp(document.getElementById('zipcode_patterns').getAttribute('value'));
	        return this.optional(element) || zip_pattern.test($.trim(value));
	      }, messages.ERR_ENTER_ZIPCODE);
	    },
	    /**
	     * Used in the LogonForm submit handler, this logic sets the cookie based
	     * on the user's choice of checking the "Remember Me" checkbox.
	     */
	    rememberMe: function rememberMe() {
	      if ($('#option1').is(':checked')) {
	        $.cookie('rememberedLogonId', $('#logonId').val(), {
	          expires: 14,
	          path: '/'
	        });
	      } else if ($('#option1').length > 0) {
	        $.cookie('rememberedLogonId', null, {
	          path: '/'
	        });
	      }
	    },
	    /**
	     * gets base64 encoded referrer for redirecting user back to the page
	     * they were on after logging in.
	     */
	    getLogonRedirectURL: function getLogonRedirectURL() {
	      var url = void 0;
	      // if there is already a value for this input (pharmacy is always home-delivery),
	      // then don't change the redirect url to the previous page.
	      if ($('#WC_AccountDisplay_FormInput_URL_In_Logon_1').val()) {
	        url = $('#WC_AccountDisplay_FormInput_URL_In_Logon_1').val();
	      } else {
	        url = document.referrer;
	        // if the referrer isn't a category/search/landing/product and isn't our domain,
	        // set the url to homepage
	        if (!((url.indexOf('.html') > -1 || url.indexOf('/CatalogSearch') > -1) && url.indexOf(location.protocol + '//' + location.host) == 0)) {
	          url = '/';
	        }
	      }
	      // need to encode to get past xss filter
	      return COSTCO.util.encode(url);
	    },
	
	    requireMembership: function requireMembership(form, fieldName) {
	      if ($(form).length == 0) {
	        return;
	      }
	
	      form.rules('add', {
	        required: true,
	        costcoMembership: true,
	        messages: {
	          required: messages.JS_VALID_REQUIRED,
	          costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	        }
	      });
	    },
	    /**
	     * Validation for the membership restricted form
	     */
	    validateMemberRestricted: function validateMemberRestricted() {
	      $('#MembershipInformationUpdate').validate({
	        rules: {
	          membershipNumber: {
	            required: true,
	            costcoMembership: true
	          }
	        },
	        messages: {
	          membershipNumber: {
	            required: messages.ERR_INVALID_MEMBERSHIP_NO
	          }
	        },
	        submitHandler: function submitHandler(form) {
	          // This we don't want trailing whitespace.
	          $('#membershipNumber').val($('#membershipNumber').val().trim());
	          form.submit();
	        }
	      });
	    },
	    /**
	     * Add mask to zip input in case US (global var shippingCountries[0] used to determine country)
	     */
	    addMaskToZipInput: function addMaskToZipInput(zipInput) {
	      if (zipInput) {
	        // Add mask to zip input in case US (global var shippingCountries[0] used to determine country)
	        if (shippingCountries != null && shippingCountries.length > 0 && shippingCountries[0] == "US") {
	          zipInput.unmask().mask('00000-0000');
	        }
	      }
	    },
	    /**
	     * Validate the given forms.
	     */
	    validate: function validate() {
	      $('#LogonForm, #LogonFormBD, #ResetPasswordForm').validate({
	        rules: {
	          logonId: {
	            required: true,
	            email: true,
	            maxlength: 251
	          },
	          logonPassword: {
	            required: true
	          },
	          deliveryZipCode: {
	            required: true,
	            countryspecificpostalcode: true
	          }
	        },
	        messages: {
	          logonId: {
	            required: messages.ERR_REQUIRED_LOGON,
	            email: messages.ERR_INVALID_EMAIL,
	            maxlength: messages.ERR_EMAIL_MAX_LENGTH
	          },
	          logonPassword: {
	            required: messages.ERR_REQUIRED_PASSWORD
	          },
	          deliveryZipCode: {
	            required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
	            countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE
	          }
	        },
	        submitHandler: function (form) {
	          this.rememberMe();
	          // This we don't want trailing whitespace.
	          $('#logonId').val($('#logonId').val().trim());
	
	          var url = this.getLogonRedirectURL();
	          $('#WC_AccountDisplay_FormInput_URL_In_Logon_1').val(url);
	
	          //remove changeValidationFlag from storage session
	          sessionStorage.removeItem("changeValidationFlag");
	
	          form.submit();
	        }.bind(this)
	      });
	      if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val())) {
	        $('#ChangePasswordForm').validate({
	          rules: {
	            logonPasswordOld: {
	              required: true
	            },
	            logonPassword: {
	              passwordRule: true
	            },
	            logonPasswordVerify: {
	              required: true,
	              passwordRule: true,
	              equalTo: '#logonPassword'
	            }
	          },
	          messages: {
	            logonPasswordOld: {
	              password: messages.JS_VALID_REQUIRED
	            },
	            logonPassword: {
	              passwordRule: messages.JS_VALID_REQUIRED
	            },
	            logonPasswordVerify: {
	              required: messages.CONFIRM_PASSWORD,
	              passwordRule: messages.ERR_REQUIRED_PASSWORD,
	              equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH
	            }
	          }
	        });
	        $('#RegisterForm').validate({
	          rules: {
	            email1: {
	              required: true,
	              email: true,
	              maxlength: 251
	            },
	            logonPassword: {
	              passwordRule: true
	            },
	            logonPasswordVerify: {
	              required: true,
	              passwordRule: true,
	              equalTo: '#logonPassword'
	            },
	            userField2: {
	              costcoMembership: true
	            },
	            userRegdeliveryZipCode: {
	              required: true,
	              countryspecificpostalcode: true
	            }
	          },
	          messages: {
	            email1: {
	              required: messages.ERR_REQUIRED_LOGON,
	              email: messages.ERR_INVALID_EMAIL,
	              maxlength: messages.ERR_EMAIL_MAX_LENGTH
	            },
	            logonPassword: {
	              passwordRule: messages.ERR_REQUIRED_PASSWORD
	            },
	            logonPasswordVerify: {
	              required: messages.CONFIRM_PASSWORD,
	              passwordRule: messages.ERR_REQUIRED_PASSWORD,
	              equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH
	            },
	            userField2: {
	              costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	            },
	            userRegdeliveryZipCode: {
	              required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
	              countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE
	            }
	          }
	        });
	      } else {
	        $('#RegisterForm, #ChangePasswordForm').validate({
	          rules: {
	            email1: {
	              required: true,
	              email: true,
	              maxlength: 251
	            },
	            logonPassword: {
	              passwordRule: true
	            },
	            logonPasswordVerify: {
	              required: true,
	              passwordRule: true,
	              equalTo: '#logonPassword'
	            },
	            userField2: {
	              costcoMembership: true
	            },
	            userRegdeliveryZipCode: {
	              required: true,
	              countryspecificpostalcode: true
	            }
	          },
	          messages: {
	            email1: {
	              required: messages.ERR_REQUIRED_LOGON,
	              email: messages.ERR_INVALID_EMAIL,
	              maxlength: messages.ERR_EMAIL_MAX_LENGTH
	            },
	            logonPassword: {
	              passwordRule: messages.ERR_REQUIRED_PASSWORD
	            },
	            logonPasswordVerify: {
	              required: messages.CONFIRM_PASSWORD,
	              passwordRule: messages.ERR_REQUIRED_PASSWORD,
	              equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH
	            },
	            userField2: {
	              costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	            },
	            userRegdeliveryZipCode: {
	              required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
	              countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE
	            }
	          }
	        });
	      }
	
	      if (typeof instacartStatic !== 'undefined' && instacartStatic.enabled) {
	        var _$membership = $('[name="userField2"]');
	        COSTCO.Logon.requireMembership(_$membership);
	      }
	      $('#RegisterFormBD').validate({
	        rules: {
	          email1: {
	            required: true,
	            email: true,
	            maxlength: 251
	          },
	          logonPassword: {
	            passwordRule: true
	          },
	          logonPasswordVerify: {
	            required: true,
	            passwordRule: true,
	            equalTo: '#logonPassword'
	          },
	          userField2: {
	            required: true,
	            costcoMembership: true
	          },
	          userRegdeliveryZipCode: {
	            required: true,
	            countryspecificpostalcode: true
	          }
	        },
	        messages: {
	          email1: {
	            required: messages.ERR_REQUIRED_LOGON,
	            email: messages.ERR_INVALID_EMAIL,
	            maxlength: messages.ERR_EMAIL_MAX_LENGTH
	          },
	          logonPassword: {
	            passwordRule: messages.ERR_REQUIRED_PASSWORD
	          },
	          logonPasswordVerify: {
	            required: messages.CONFIRM_PASSWORD,
	            passwordRule: messages.ERR_REQUIRED_PASSWORD,
	            equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH
	          },
	          userField2: {
	            required: messages.ERR_REQUIRED_COSTCO_BD_MEMBERSHIP_NO,
	            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	          },
	          userRegdeliveryZipCode: {
	            required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
	            countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE
	          }
	        }
	      });
	      var $membership = $('#ChangePasswordForm #membershipNumber');
	      if ($membership.length > 0) {
	        // This is for the case where we arrive on the change password
	        // page as part of the manual authentication flow
	        COSTCO.Logon.requireMembership($membership);
	      }
	
	      $('#LinkMembershipForm').validate({
	        rules: {
	          membershipNumber: {
	            required: true,
	            costcoMembership: true
	          }
	        },
	        messages: {
	          membershipNumber: {
	            required: messages.JS_VALID_REQUIRED,
	            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	          }
	        }
	      });
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.Logon = Logon;
	  return Logon;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title account-helper.js: Sub-module for Account pages
	 * @description This module is used to handle various account tasks
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	  var AccountHelper = {
	
	    /**
	     * Initialization of the module.
	     */
	    init: function init() {
	      console.log('Account Helper module intialized.');
	      if (COSTCO.util.isRunningOnMobileApp() && !COSTCO.util.isBusinessDelivery()) {
	        if (document.readyState == 'complete') {
	          $('#my-account-top-nav').on("click", function () {
	            COSTCO.AccountHelper.showMobileMyAccountMenu();
	          });
	        } else {
	          $(window).on('load', function () {
	            $('#my-account-top-nav').on("click", function () {
	              COSTCO.AccountHelper.showMobileMyAccountMenu();
	            });
	          });
	        }
	      }
	    },
	    /**
	     * Constants
	     */
	    notificationType: {
	      SUCCESS: 'SUCCESS',
	      WARNING: 'WARNING',
	      ERROR: 'ERROR'
	    },
	
	    /**
	     * Displays error, warning, or success notification
	     * @param  {String} notificationType Notification type
	     * @param  {Array} notifications     Notification messages
	     * @return {void}
	     */
	    displayTopNotification: function displayTopNotification(notificationType, notifications) {
	
	      this.clearNotification();
	
	      var topNotificationClass = '';
	      var topNotificationInnerHtml = '';
	
	      switch (notificationType) {
	        case this.notificationType.SUCCESS:
	          topNotificationClass = 'success-notification';
	          break;
	        case this.notificationType.WARNING:
	          topNotificationClass = 'warning';
	          break;
	        case this.notificationType.ERROR:
	          topNotificationClass = 'critical-notification';
	          break;
	        default:
	          break;
	      }
	
	      notifications.forEach(function (notification) {
	        topNotificationInnerHtml += '<p automation-id="notificationMessage">' + notification + '</p>';
	      });
	      $('#notification-message').addClass(topNotificationClass);
	      $('#notification-message').html(topNotificationInnerHtml);
	    },
	    /**
	     * Clears top notification
	     */
	    clearNotification: function clearNotification() {
	
	      $('#notification-message').removeClass();
	      $('#notification-message').html('');
	    },
	    /**
	     * Makes dropdown menu options clickable and redirecting to URL stated in
	     * option value attribute, when this HTML class attribute is used.
	     * Used in Top Navigation dropdown menu.
	     */
	    activateDropdownMenuRedirect: function activateDropdownMenuRedirect() {
	      $('.dropdown-menu-redirect').unbind('change').change(function () {
	        window.location.href = $(this).val();
	      });
	    },
	    /**
	     * Reinitializes value selected in  a dropdown manu when the back button is clicked
	     */
	    reinitDropDownMenu: function reinitDropDownMenu() {
	      $('.dropdown-menu-redirect').each(function () {
	        var select = $(this);
	        var selectedValue = select.find('option[selected]').val();
	
	        if (selectedValue) {
	          select.val(selectedValue);
	        } else {
	          select.prop('selectedIndex', 0);
	        }
	      });
	    },
	    /**
	    * Function used to invoke the mobile app My Account navigation
	    */
	    showMobileMyAccountMenu: function showMobileMyAccountMenu() {
	      console.log('Initializing Mobile My Account Menu');
	      try {
	        if (typeof Android != 'undefined') {
	          Android.showMyAccount();
	        } else if (typeof webkit != 'undefined') {
	          webkit.messageHandlers.showMyAccount.postMessage('myaccount');
	        }
	      } catch (e) {
	        console.warn(e);
	      }
	    },
	
	    /**
	        * Adds aria-current for ADA Compliance on "Left Navbar" link for account.
	       * @return void
	       */
	    addAdaComplianceOnLeftNabarForAccount: function addAdaComplianceOnLeftNabarForAccount() {
	      $('#leftnav li.active a').attr('aria-current', "page");
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.AccountHelper = AccountHelper;
	
	  return AccountHelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title product_helper.js: utility module
	 * @description This module is fabulous. A utility
	 * module for the product page.
	 * @author kmedz
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var itemIdMap = new Map();
	  var listOfObjects = [];
	  var OOSMap = new Map();
	  var Product = {
	    /**
	     * This variable corresponds with the kind of product we're looking
	     * at. It gets set in mathtable.js.init as part of the product.module.js.init
	     * process.
	     * @type {[string]}
	     */
	    item_type: undefined,
	    chatWindow: undefined,
	
	    /**
	     * This constant represents top value that can be set for quantity for BD
	     */
	    MAX_QUANTITY_BD: 9999,
	
	    /**
	     * This constant represents bottom value that can be set for quantity
	     */
	    MIN_QUANTITY: 1,
	
	    SKIP_EDD: false,
	    isLocCtrlSmallPck: false,
	    isEDDStatusAvailable: true,
	    isEddItem: false,
	
	    /**
	     * The initializing function modules use
	     * to call.
	     * @return {[type]} [description]
	     */
	    init: function init() {
	
	      if (isBDApplication && isBDApplication === 'BC') {
	        var pageNames = "";
	        if (window.currentPageName !== undefined) {
	          pageNames = window.currentPageName;
	        }
	        if ($("#left-side-content") != undefined && pageNames === 'pdp') {
	          $(window).scroll(function () {
	            var windowWidth = parseInt(window.innerWidth);
	            if (window.pageYOffset > parseFloat($("#left-side-content").offset().top - 50)) {
	              if (windowWidth > 768) {
	                $("#left-side-content").css({
	                  "position": "sticky",
	                  "top": "20px",
	                  "background": "#fff"
	                });
	                if ($("#product-details").height() > $("#zoomViewer").height()) {
	                  if ($(".bottom-content").offset().top - window.pageYOffset - $("#product-details").height() < 0) {
	                    $("#left-side-content").css({
	                      "position": "sticky",
	                      "top": $(".bottom-content").offset().top - window.pageYOffset - $("#product-details").height() + 20 + "px",
	                      "background": "#fff"
	                    });
	                  }
	                } else {
	                  if ($(".bottom-content").offset().top - window.pageYOffset - $("#zoomViewer").height() < 0) {
	                    $("#left-side-content").css({
	                      "position": "sticky",
	                      "top": $(".bottom-content").offset().top - window.pageYOffset - $("#zoomViewer").height() + 20 + "px",
	                      "background": "#fff"
	
	                    });
	                  }
	                }
	              } else {
	                $("#left-side-content").css({
	                  "position": "static",
	                  "top": "20px",
	                  "background": "#fff"
	                });
	                $(".top-content").css({ "background-color": "#fff" });
	                $(".product-interaction").css({ "background-color": "#fff" });
	                $("#fulfillments").css({ "background-color": "#fff" });
	                $(".buyinstoreonly").css({ "background-color": "#fff" });
	              }
	              if (COSTCO.CMath.iskitsbundle) {
	                $(".style-select").addClass("kits-pdp-margin");
	              }
	
	              $("#product-page").css({ "padding-bottom": "0px" });
	              $("#product-info").css({ "background": "#fff" });
	              $("#merkle-recommendations").css({ "background-color": "#fff" });
	              $("#product-vendor-content > div").css({ "background-color": "#fff" });
	            } else {
	              $("#left-side-content").css({
	                "position": "static",
	                "top": "20px",
	                "background": "transparent"
	              });
	            }
	          });
	        }
	      }
	      $('#product-page').attr("data-onloadTracker", "true");
	      if (isBVv2Enabled === 'false') {
	        this.hide_writereview();
	      }
	      this.maskQuantityInput();
	      this.product_details_view_more();
	      this.enablePlainPackagingMessage();
	      this.pop_overs();
	      this.set_option_price_text();
	      this.injectHiddenSwatchesDiv();
	      this.showViewMore();
	      this.setEDDZipCode();
	      if (COSTCO.util.checkElementById('#liveChatEnabled', 'true')) {
	        this.enableChatFeature();
	      }
	      this.scrollToElementOnPdpWithOffset();
	
	      if ($('#liveEDD').length > 0 && $('#liveEDD').val() === 'true') {
	        COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STOPPED;
	        if ($('#backOrdered').val() !== 'true') {
	          COSTCO.Product.eddFormDisplayed = true;
	        }
	        $('#minQtyText').bind("change", function () {
	          if (COSTCO.Product.eddFormDisplayed === false && $.cookie('invCheckPostalCode') != null) {
	            COSTCO.Product.retrieveEDD();
	          }
	        });
	      }
	      $('#minQtyText').bind("click", function () {
	        $('#minQtyText').focus();
	      });
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        this.pdpMakeElementSticky();
	        if (COSTCO.Product.item_type == 'bundle') {
	          this.bundlePageReload();
	          this.bundle_backorder_check();
	        }
	        this.initializeAdaForTabPanel();
	        this.makeTextNonClicableForSR();
	        this.initShippingStatementPopover();
	      }
	
	      document.addEventListener("CostcoSubModulesLoaded", COSTCO.Product.startMutationObserver, false);
	
	      /** INC6205314 - Below code will resize the PDP Review tab content after the BV call back. */
	      window.bvCallback = function (BV) {
	        BV.configure('global', {
	          events: {
	            bvRender: function bvRender(data) {
	              // JavaScript code that executes when the Bazaarvoice application renders.
	              COSTCO.Product.showViewMore();
	            }
	          }
	        });
	      };
	
	      // Binding for Success Notification element Close Icon
	      $('#product-page').on('click', '.success-notification .co-close', function (event) {
	        $('#product-page .success-notification').remove();
	      });
	      this.makeSocialIconsAdaCompliant();
	
	      COSTCO.Product.setShareButtonWidth();
	      COSTCO.Product.startProductActionV2MutationObserver();
	      COSTCO.Product.startVendorActionV2MutationObserver();
	      var ctaEspotAttr = $('.product-cta-espot div').attr('data-bi-placement');
	      if (!((typeof ctaEspotAttr === "undefined" ? "undefined" : _typeof(ctaEspotAttr)) !== ( true ? "undefined" : _typeof(undefined)) && ctaEspotAttr !== false)) {
	        $('.product-cta-espot').addClass("hide");
	      }
	      $('.unit-content').unbind().on('click', function (e) {
	        $('#minQtyText').focus();
	      });
	      var sessionStorageDataModal = sessionStorage.getItem('AddedToCartModalData');
	      if (sessionStorageDataModal && sessionStorageDataModal != null) {
	        this.invokeAddedToCartModalData(sessionStorageDataModal);
	      }
	
	      $('#mattress-statement').hide();
	
	      COSTCO.Product.toggleDeliveryMoleculeOnComingSoon();
	
	      $(window).on('load', function () {
	        COSTCO.Product.unsetBreadcrumbPadding();
	
	        $('.lcrelatedvideos-e2').each(function () {
	          this.style.setProperty('margin-left', '0px', 'important');
	        });
	        try {
	          COSTCO.Product.mobileSharePdp();
	        } catch (e) {}
	        //3 level item variants
	        if (!COSTCO.CMath.iskitsbundle) {
	          for (var i = $('.varis[data-product=0]').length - 1; i > 0; i--) {
	            if ($('#swatches-productOption0' + i + ' .selection-box-v2 input:disabled').length > 0) {
	              var firstSelectedVariant = $('#swatches-productOption0' + i + ' .selection-box-v2 input:not(:disabled)')[0];
	
	              $('#productOption0' + i).val($(firstSelectedVariant).val());
	              $('#productOption0' + i).change();
	            }
	          }
	          if ($('#swatches-productOption00 .selection-box-v2 input:disabled').length > 0) {
	            var _firstSelectedVariant = $('#swatches-productOption00 .selection-box-v2 input:not(:disabled)')[0];
	
	            $('#productOption00').val($(_firstSelectedVariant).val());
	            $('#productOption00').change();
	          } else if ($('.varis-v2').length > 0) {
	            var selectedOptionSpanText = $('.selectedOptionValue').text().trim();
	            var selectedOptionDropdownText = $('.varis-v2').find(":selected").text().trim();
	
	            if (selectedOptionSpanText != selectedOptionDropdownText) {
	              $('.varis-v2 option').filter(function () {
	                return $(this).text() == selectedOptionSpanText;
	              }).prop('selected', true);
	
	              var selectedOptionValue = $('.varis-v2').find(":selected").val();
	              $('.varis').find('option[value=' + selectedOptionValue + ']').prop('selected', true);
	              $('#productOption00').change();
	            }
	          }
	        }
	      });
	
	      //SFSTRY0014266 - SOK iFrame analytics change
	      if ($('ul#tablist a#reqConsultTab').length > 0 && typeof digitalDataEvents !== 'undefined') {
	        digitalDataEvents.push({ update: { product: { inventoryStatus: "Request Consultation" } } });
	      }
	    },
	
	    hide_writereview: function hide_writereview() {
	      if (COSTCO.CMath.iskitsbundle) {
	        var targetObject = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? $('#product-info')[0] : $('#accordion-product-details')[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("childList" === mutation.type && $(mutation.target).find('.bv-content-list-container').length > 0) {
	              $('.bv-submission-button').removeClass("bv-write-review");
	              $('.bv-submission-button').removeClass("bv-first-to-review");
	              $('.bv-submission-button').html("");
	              $('.bv-action-bar').html("");
	              $('.bv-action-bar').removeClass("bv-action-bar");
	            }
	          });
	        });
	        observerObject.observe(targetObject, { attributes: true, attributeOldValue: true,
	          childList: true,
	          subtree: true,
	          characterData: true
	        });
	      }
	    },
	
	    unsetBreadcrumbPadding: function unsetBreadcrumbPadding() {
	      $('#crumbs_ul > div').css('padding', 'unset');
	    },
	
	    mobileSharePdp: function mobileSharePdp() {
	      try {
	
	        if (typeof Android != 'undefined' && typeof Android.onSharePopup != 'undefined') {
	          $("#pdp-share-android-native").show();
	          $(".social-share").hide();
	          $("#pdp-share-android-native").unbind("click").bind("click", function () {
	            Android.onSharePopup($(document).attr('title'), window.location.href);
	          });
	        } else if (typeof webkit != 'undefined' && typeof webkit.messageHandlers != 'undefined' && typeof webkit.messageHandlers.onSharePopup != 'undefined' && typeof webkit.messageHandlers.onSharePopup.postMessage != 'undefined') {
	
	          $("#pdp-share-ios-native").show();
	          $(".social-share").hide();
	          $("#pdp-share-ios-native").unbind("click").bind("click", function () {
	            webkit.messageHandlers.onSharePopup.postMessage(window.location.href);
	          });
	
	          //iOS behaves strange, it needs timeout to run async
	          setTimeout(function () {
	            if ($("#pdp-share-ios-native").is(":hidden") && $("#pdp-share-android-native").is(":hidden")) {
	              $(".social-share").show();
	            }
	          }, 1000);
	        }
	      } catch (e) {
	        $("#pdp-share-android-native").hide();
	        $("#pdp-share-ios-native").hide();
	        $(".social-share").show();
	      }
	    },
	
	    eddObserver: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null
	    },
	
	    productActionV2Observer: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null
	    },
	
	    productActionV2ObserverState: '',
	
	    vendorActionV2Observer: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null
	    },
	
	    vendorActionV2ObserverState: '',
	
	    eddMutationObserverState: '',
	
	    eddFormDisplayed: '',
	
	    displayEDDForm: true,
	
	    sortVariantOptions: false,
	
	    sortVariantOptions_V2: false,
	
	    /**
	     * Function used to watch for changes of catEntryId, calling retrieveEDD in case of observing
	    */
	    startEDDMutationObserver: function startEDDMutationObserver() {
	      var targetObject = $('#ProductForm #catEntryId');
	      if (targetObject.length > 0 && this.displayEDDForm === true) {
	        targetObject = targetObject[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("attributes" === mutation.type) {
	              COSTCO.Product.showEddForm();
	            }
	          });
	        });
	        // Register the target node to observe and specify which DOM changes to watch
	        observerObject.observe(targetObject, {
	          attributes: true
	        });
	
	        this.eddObserver.observer = observerObject;
	      }
	      COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STARTED;
	    },
	
	    /**
	     * Function used to watch for changes of #ctas content, calling changeContentOfExternalButton in case of observing change in first loop
	    */
	    startVendorActionV2MutationObserver: function startVendorActionV2MutationObserver() {
	      var targetObject = $('#ctas');
	      if (targetObject.length > 0) {
	        targetObject = targetObject[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("childList" === mutation.type && COSTCO.Product.vendorActionV2ObserverState !== 'STOPPED') {
	              if ($('#ctas ul li a').length) {
	                COSTCO.Product.changeContentOfExternalButton();
	              }
	              COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STOPPED;
	            }
	          });
	        });
	        // Register the target node to observe and specify which DOM changes to watch
	        observerObject.observe(targetObject, {
	          childList: true,
	          subtree: true
	        });
	        this.vendorActionV2Observer.observer = observerObject;
	      }
	      COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STARTED;
	    },
	
	    /**
	     * Function used to watch for changes of #mr-registry-container content, calling setShareButtonWidth in case of observing
	    */
	    startProductActionV2MutationObserver: function startProductActionV2MutationObserver() {
	      var targetObject = $('#mr-registry-container');
	      if (targetObject.length > 0) {
	        targetObject = targetObject[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("childList" === mutation.type) {
	              COSTCO.Product.setShareButtonWidth();
	              COSTCO.Product.makeGiftRegistryAdaCompliant();
	              if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.item_type == 'bundle') {
	                COSTCO.Product.arrangeBundleButtons();
	              }
	            }
	          });
	        });
	        // Register the target node to observe and specify which DOM changes to watch
	        observerObject.observe(targetObject, {
	          childList: true
	        });
	        this.productActionV2Observer.observer = observerObject;
	      }
	      productActionV2ObserverState = Product.productActionV2Observer.state.STARTED;
	    },
	
	    /**
	     * Mask quantity input field for PDP page
	     */
	    maskQuantityInput: function maskQuantityInput() {
	      $("input[name*='quantity']").unmask().mask(COSTCO.util.isBusinessDelivery() ? '0000' : '000');
	    },
	
	    /**
	     * Function used to change state eddMutationObserverState and disconnect observer in case of showing edd form.
	    */
	    stopEDDMutationObserver: function stopEDDMutationObserver() {
	
	      COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STOPPED;
	      if (!_typeof(this.eddObserver.observer) === "undefined") {
	        this.eddObserver.observer.disconnect();
	      }
	    },
	
	    /**
	     * Function used to show Live Chat Us feature on the PDP page
	    */
	    enableChatFeature: function enableChatFeature() {
	      if ('BC' === $('#applicationType').val() && $("input[name='productBeanId']").length > 0) {
	        /* Get Catentry Id and partnumber of the Product */
	        var catentryid = $("input[name='productBeanId']").val();
	        var partnumber = $("input[name='productPartnumber']").val();
	        if (!(typeof catentryid === "undefined")) {
	
	          COSTCO.util.ajax({
	            url: '/AjaxGetChatDetails',
	            method: 'GET',
	            dataType: 'json',
	            data: {
	              productId: catentryid,
	              signedIn: COSTCO.util.getMemberCookie().signedIn,
	              hostname: window.location.protocol + "//" + window.location.hostname,
	              partnumber: partnumber
	            },
	            done: function done(data, textStatus, jqXHR, options) {
	              if (data.errorMessageKey) {
	                console.log('Error Occured ' + data.errorMessage);
	              } else if (data.showChatURL) {
	                var windowHeight = window.innerHeight;
	                var feedbackWidth = $('button.chat-button').width() + 10; /* 10px spacing between feedback and chat */
	                var feedbackConverted = feedbackWidth * 100 / windowHeight;
	                var finalHeight = 49 + feedbackConverted; /* 49 top of feedback button */
	                $('button.chat-button').css('top', finalHeight + "%");
	                var chatUrl = new DOMParser().parseFromString(data.chatURL, "text/html");
	                var finalChatUrl = chatUrl.body.textContent;
	                COSTCO.Product.showChatWindow(finalChatUrl);
	              } else {
	                var chatButton = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? 'button.chat-button-v2' : 'button.chat-button';
	                $(chatButton).addClass('hidden');
	              }
	            }, fail: function fail(data) {
	              console.log('Unexpected Error Occured');
	            }
	          });
	        }
	      }
	    },
	    /**
	     * This method is used to render a new Chat Window and load the Chat Us Link
	     */
	    showChatWindow: function showChatWindow(customURL) {
	      var liveChatButton;
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        liveChatButton = 'button.chat-button-v2';
	      } else {
	        liveChatButton = 'button.chat-button';
	      }
	      $(liveChatButton).click(function (event) {
	        /**
	         * If chat window already open then focus existing one
	         * else open new window
	         */
	        if (customURL.length > 0) {
	          if (COSTCO.Product.chatWindow != undefined && !COSTCO.Product.chatWindow.closed) {
	            COSTCO.Product.chatWindow.focus();
	          } else {
	            var chatWindowWidth = 320;
	            var chatWindowHeight = 800;
	            var left = $(window).width() - chatWindowWidth;
	            COSTCO.Product.chatWindow = window.open(customURL, 'chatWindow', 'width=' + chatWindowWidth + ',height=' + chatWindowHeight + ',scrollbars=1,top=0,left=' + left);
	            COSTCO.Product.chatWindow.moveTo(left, 0);
	            COSTCO.Product.chatWindow.focus();
	          }
	        }
	      });
	    },
	
	    /**
	     * Setting width for button share on pdp
	     * @return void
	     */
	    setShareButtonWidth: function setShareButtonWidth() {
	      if ($('#add-to-list').html() == undefined && ($('#mr-registry-container').html() == undefined || $('#mr-registry-container').html().contents == undefined)) {
	        $('#mr-registry-container').remove(); //remove container if it is empty
	        $('#product-social-print-mobile').css('width', '100%');
	      }
	    },
	
	    /**
	     * Changing content of external button
	     * @return void
	     */
	    changeContentOfExternalButton: function changeContentOfExternalButton() {
	      var selector = $('div#ctas').find('a').children('input.primary').length ? $('div#ctas').find('a').children('input.primary') : $('div#ctas').find('a.external').children('span');
	      if (selector.length > 0 && selector.text() !== messages.RWD_VENDOR_CTA_BUTTON_TEXT_ORDER_HERE) {
	        if (selector.is('span')) {
	          selector.text(messages.RWD_VENDOR_CTA_BUTTON_TEXT);
	        } else {
	          selector.val(messages.RWD_VENDOR_CTA_BUTTON_TEXT);
	        }
	      }
	      COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STOPPED;
	    },
	    /**
	     * Update the EDD zip code based on the current zip code cookie value.
	     */
	    setEDDZipCode: function setEDDZipCode() {
	      $("#eddZipCodeField").val($.cookie('invCheckPostalCode'));
	    },
	
	    /**
	     * change prive from base 64 to a decimal value
	     */
	    processPrice: function processPrice(value) {
	      value = typeof value !== 'undefined' && value != null ? value : "";
	      value = typeof value == "string" ? COSTCO.util.base64test.test(value) ? COSTCO.util.decode(value) : value : value;
	      if ($.type(value) === 'string') {
	        value = value.split(',').join('');
	      }
	      return this.parseCurrency(value);
	    },
	    /**
	     * round a number down to 2 decimal places
	     */
	    parseCurrency: function parseCurrency(num) {
	      if (typeof num == "number") {
	        num = num.toString();
	      }
	      num = parseFloat(Math.round(num.replace(/\s/g, '') * 100) / 100).toFixed(2).toLocaleString();
	      return num;
	    },
	    focusToNavPdpTabHeader1: function focusToNavPdpTabHeader1() {
	      $("#nav-pdp-tab-header-1").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader2: function focusToNavPdpTabHeader2() {
	      $("#nav-pdp-tab-header-2").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader3: function focusToNavPdpTabHeader3() {
	      $("#nav-pdp-tab-header-3").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader4: function focusToNavPdpTabHeader4() {
	      $("#nav-pdp-tab-header-4").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader5: function focusToNavPdpTabHeader5() {
	      $("#nav-pdp-tab-header-5").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader6: function focusToNavPdpTabHeader6() {
	      $("#nav-pdp-tab-header-6").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader7: function focusToNavPdpTabHeader7() {
	      $("#nav-pdp-tab-header-7").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader8: function focusToNavPdpTabHeader8() {
	      $("#nav-pdp-tab-header-8").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader9: function focusToNavPdpTabHeader9() {
	      $("#nav-pdp-tab-header-9").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader10: function focusToNavPdpTabHeader10() {
	      $("#nav-pdp-tab-header-10").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader11: function focusToNavPdpTabHeader11() {
	      $("#nav-pdp-tab-header-11").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader12: function focusToNavPdpTabHeader12() {
	      $("#nav-pdp-tab-header-12").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader13: function focusToNavPdpTabHeader13() {
	      $("#nav-pdp-tab-header-13").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader14: function focusToNavPdpTabHeader14() {
	      $('html, body').scrollToElem($('.bottom-content'), 500);
	      setTimeout(function () {
	        $('#tablist li').removeClass('active');
	        $('.tab-content div').removeClass('active in');
	        $('#tab-header-bundle').addClass('active');
	        $('.build-bundle-tab').addClass('active in');
	      }, 500);
	      $("#buildabundleTitle").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader15: function focusToNavPdpTabHeader15() {
	      $("#selectedKbOffScreenSwatch").attr("tabindex", -1).focus();
	    },
	
	    formatMoney: function formatMoney(number, has_symbol) {
	      var number = number.toString(),
	          dollars = number.split('.')[0],
	          cents = (number.split('.')[1] || '') + '00';
	      dollars = dollars.split('').reverse().join('').replace(/(\d{3}(?!$))/g, '$1,').split('').reverse().join(''), symbol = has_symbol ? '$' : "";
	      var locale = COSTCO.util.getLocale();
	      var appType = $('#applicationType').val();
	
	      if (locale == 'fr-CA' && appType == 'BD') {
	        return dollars.split(",").join(" ") + ',' + cents.slice(0, 2) + ' ' + symbol;
	      } else if (locale == 'fr-CA' && appType == 'BC') {
	        return dollars.split(",").join(" ") + ',' + cents.slice(0, 2) + symbol;
	      }
	
	      return symbol + dollars + '.' + cents.slice(0, 2);
	    },
	    /**
	     * This function iterates through every variant on a product page and sorts
	     * its option, first by sequence, then price (if single variant) else alphabetically.
	     * @return {[type]} [description]
	     */
	    sort_variant_options: function sort_variant_options() {
	      $('.variantContainer').each(function (i, vContainer) {
	        $(vContainer).find('select.varis').each(function (j, select) {
	          var $options = $(select).find('option:not([value=unselected])'),
	              product_num = $(select).data('product');
	          if (!COSTCO.CMath.iskitsbundle) {
	            $options.detach().sort(function (option_a, option_b) {
	
	              var seq_a = parseFloat(this.get_item_sequence(option_a.value, product_num)),
	                  seq_b = parseFloat(this.get_item_sequence(option_b.value, product_num));
	              if (seq_a == seq_b) {
	                // Same sequences, try sorting by price
	                var item_a = this.findItem(products[product_num], this.get_selected_array($(option_a))),
	                    item_b = this.findItem(products[product_num], this.get_selected_array($(option_b)));
	                if (item_a && item_b) {
	                  var price_a = parseFloat(COSTCO.util.decode(item_a.price).split(',').join('')),
	                      price_b = parseFloat(COSTCO.util.decode(item_b.price).split(',').join(''));
	                  return price_b - price_a;
	                } else {
	                  return option_a.text.toLowerCase() > option_b.text.toLowerCase() ? 1 : -1;
	                }
	              } else {
	                return seq_a > seq_b ? 1 : -1;
	              }
	            }.bind(this));
	            $options.removeAttr("selected");
	            $options.appendTo(select);
	          }
	
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            this.displayVarianceView(select);
	            if ($(vContainer).find('select.varis').length == j + 1) {
	              COSTCO.Product.sortVariantOptions_V2 = true;
	              var preselectOption = COSTCO.util.getParameterByName('preselectOption');
	              if (typeof preselectOption !== 'undefined' && preselectOption != null) {
	                COSTCO.CMath.bindVariantProducts('', preselectOption);
	              } else {
	                COSTCO.CMath.bindVariantProducts();
	              }
	            }
	          } else {
	            if ($(vContainer).find('select.varis').length == j + 1) {
	              COSTCO.Product.sortVariantOptions = true;
	            }
	            COSTCO.CMath.bindVariantProducts();
	          }
	        }.bind(this));
	      }.bind(this));
	    },
	
	    sort_secondary_variant_options: function sort_secondary_variant_options(selectedVariant) {
	      $('.variantContainer').find('select.varis').each(function (j, select) {
	        if ($(select).attr('id') !== $(selectedVariant).attr('id')) {
	          var $options = $(select).find('option:not([value=unselected])'),
	              product_num = $(select).data('product');
	          var selectedOptionVal = $(select).find('option:selected').val();
	          $options.detach().sort(function (option_a, option_b) {
	            var seq_a = parseFloat(COSTCO.Product.get_item_sequence_selectVariant(option_a.value, $(selectedVariant).val(), product_num)),
	                seq_b = parseFloat(COSTCO.Product.get_item_sequence_selectVariant(option_b.value, $(selectedVariant).val(), product_num));
	
	            if (isNaN(seq_a)) {
	              seq_a = 0;
	            } else if (isNaN(seq_b)) {
	              seq_b = 0;
	            }
	            if (seq_a == seq_b) {
	              // Same sequences, try sorting by price
	              var item_a = COSTCO.Product.findItem(products[product_num], COSTCO.Product.get_selected_array($(option_a))),
	                  item_b = COSTCO.Product.findItem(products[product_num], COSTCO.Product.get_selected_array($(option_b)));
	              if (item_a && item_b) {
	                var price_a = parseFloat(COSTCO.util.decode(item_a.price).split(',').join('')),
	                    price_b = parseFloat(COSTCO.util.decode(item_b.price).split(',').join(''));
	                return price_b - price_a;
	              } else {
	                return option_a.text.toLowerCase() > option_b.text.toLowerCase() ? 1 : -1;
	              }
	            } else {
	              return seq_a > seq_b ? 1 : -1;
	            }
	          }.bind(this));
	
	          $options.removeAttr("selected");
	          $options.appendTo(select);
	          var rePrintSortedTiles = '<legend id="variantLegend-productOption0' + j + '" class="sr-only">' + $(select).closest('.vari').find('label').text() + '</legend>';
	          $options.each(function (i, option) {
	            var optionValue = $(option).text();
	            if ($(option).val() === selectedOptionVal) {
	              $(option).prop('selected', true);
	            }
	            var templateName;
	            if (COSTCO.CMath.iskitsbundle) {
	              templateName = 'tmpl_KB_product_variants_v2';
	            } else {
	              templateName = 'tmpl_product_variants_v2';
	            }
	            rePrintSortedTiles += COSTCO.util.tmpl(templateName, {
	              inputName: $(select).prop('name'),
	              inputValue: $(option).val(),
	              variantName: optionValue,
	              disabled: $(select).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
	              tabindex: $(select).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
	              checkedValue: $(option).is(':selected') ? 'checked' : '',
	              ariaChecked: $(option).is(':selected') ? 'true' : 'false'
	            });
	          });
	          var sortedVariantFieldset = $('#swatches-' + $(select).prop('name')).find('fieldset label.variant-v2').parent();
	          sortedVariantFieldset.html('');
	          sortedVariantFieldset.html(rePrintSortedTiles);
	
	          $('#swatches-' + $(select).prop('name') + ' label.selection-box-v2').on('click keypress', function () {
	            $('#isPriceCallInvokedForPickup').val('false');
	            var radioValue = $(this).find('input').val();
	            $('#' + $(select).prop('name')).val(radioValue);
	            $('#' + $(select).prop('name')).trigger('change.vari');
	            $(this).find('input').each(function () {
	              $(this).prop('checked', 'false');
	            });
	            $(this).find('input').prop('checked', 'true');
	          });
	        }
	      }.bind(this));
	    },
	
	    /**
	     * Generate variance view for a PDP Redesign page
	     * @param selectVariant variant selection to generate view from
	     * @return void
	     */
	    displayVarianceView: function displayVarianceView(selectVariant) {
	      var _this = this;
	
	      var tileHtml = '';
	      var variantLabelHtml = '';
	      var selectVariantName = $(selectVariant).prop('name');
	      var selectVariantOptions = $(selectVariant).find('option:not([value=unselected])');
	      var variantSelected = $(selectVariant).find('option:selected').hasClass('opt');
	      var isBundle = $('.bundleQty').length > 0;
	      var variantLabelText = $(selectVariant).closest('.vari').find('label').text().trim();
	      var templateName;
	      if (COSTCO.CMath.iskitsbundle) {
	        templateName = 'tmpl_KB_product_variants_v2_label';
	      } else {
	        templateName = 'tmpl_product_variants_v2_label';
	      }
	
	      variantLabelHtml += COSTCO.util.tmpl(templateName, {
	        selectedOptionKey: variantLabelText,
	        optionId: $(selectVariant).attr('id')
	      });
	
	      if ($(selectVariant).parents('.vari').is('.swatchDropdown[data-swatch-mode=2]')) {
	        if (COSTCO.CMath.iskitsbundle) {
	          var theSwatchesCloned = $('#theKBSwatches').clone(true);
	          $('#theKBSwatches').remove();
	          var $labelForSwatches = $('label[for="theKBSwatches"]');
	          $labelForSwatches.removeClass('hide');
	          $labelForSwatches.after(theSwatchesCloned);
	          $('#theKBSwatches').removeClass('hide');
	        } else {
	          var _theSwatchesCloned = $('#theSwatches').clone(true);
	          $('#theSwatches').remove();
	          $('#pdpSwatches').remove();
	          var _$labelForSwatches = $('label[for="theSwatches"]');
	          _$labelForSwatches.removeClass('hide');
	          _$labelForSwatches.after(_theSwatchesCloned);
	
	          var $labelForPdpSwatches = $('label[for="pdpSwatches"]');
	          $labelForPdpSwatches.removeClass('hide');
	          $labelForPdpSwatches.after(_theSwatchesCloned);
	        }
	      } else if (numberOfOptionsToDisplayAsTiles && selectVariantOptions.length < numberOfOptionsToDisplayAsTiles && !isBundle) {
	
	        selectVariantOptions.each(function (i, option) {
	          var optionValue = $(option).text();
	          if (COSTCO.CMath.iskitsbundle) {
	            tileHtml += COSTCO.util.tmpl('tmpl_KB_product_variants_v2', {
	              inputName: selectVariantName,
	              inputValue: $(option).val(),
	              variantName: optionValue,
	              disabled: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
	              tabindex: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
	              checkedValue: $(option).is(':selected') ? 'checked' : '',
	              ariaChecked: $(option).is(':selected') ? 'true' : 'false',
	              i: i + 1
	            });
	          } else {
	            tileHtml += COSTCO.util.tmpl('tmpl_product_variants_v2', {
	              inputName: selectVariantName,
	              inputValue: $(option).val(),
	              variantName: optionValue,
	              disabled: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
	              tabindex: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
	              checkedValue: $(option).is(':selected') ? 'checked' : '',
	              ariaChecked: $(option).is(':selected') ? 'true' : 'false'
	            });
	          }
	        });
	        var templateName;
	        if (COSTCO.CMath.iskitsbundle) {
	          templateName = 'tmpl_KB_product_variants_v2_row';
	        } else {
	          templateName = 'tmpl_product_variants_v2_row';
	        }
	        $('#product-details').append(COSTCO.util.tmpl(templateName, {
	          swatchesId: selectVariantName,
	          tileDisplay: tileHtml,
	          variantLabel: variantLabelHtml,
	          selectedOptionKey: $(selectVariant).closest('.vari').find('label').text()
	
	        }));
	
	        if (variantSelected) {
	          COSTCO.CMath.update_selected_option_label($(selectVariant).find('option:selected').val());
	        }
	
	        $('#swatches-' + selectVariantName + ' input[type=radio]').change(function () {
	          var radioValue = $(this).val();
	          $('#' + selectVariantName).val(radioValue);
	          $('#isPriceCallInvokedForPickup').val('false');
	          if (selectVariantName === 'productOption00') {
	            COSTCO.Product.sort_secondary_variant_options($(selectVariant));
	          }
	          if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete) {
	            //Following code for reload page if user is clicking dropdown
	            COSTCO.CMath.redirectPDP();
	          } else {
	            $('#' + selectVariantName).trigger('change.vari');
	          }
	        });
	
	        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	          $('#swatches-' + selectVariantName + ' label.selection-box-v2').on('keypress', function () {
	            $('#isPriceCallInvokedForPickup').val('false');
	            var radioValue = $(this).find('input').val();
	            $('#' + selectVariantName).val(radioValue);
	            $('#' + selectVariantName).trigger('change.vari');
	            $(this).find('input').each(function () {
	              $(this).prop('checked', 'false');
	            });
	            $(this).find('input').prop('checked', 'true');
	          });
	        };
	      } else {
	
	        var styleSelect = $(selectVariant).parent('.style-select');
	        if (!isBundle) {
	          $('#product-details').append(variantLabelHtml);
	        }
	        if ($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true') {
	          var dropdownSkeleton = '<div class="style-select form-group dropdown-skeleton-' + selectVariantName + '" id="PDP-dropdown-skeleton"> <select class="dropdown-skeleton-load loading" disabled></select></div>';
	          $('#product-details').append(dropdownSkeleton);
	          $('[name=' + selectVariantName + ']').hide();
	        }
	        var styleSelectCloned = styleSelect.clone();
	        var optionsCloned = styleSelectCloned.find('.varis');
	        optionsCloned.removeAttr('id');
	        optionsCloned.addClass('varis-v2');
	        optionsCloned.removeClass('varis');
	        optionsCloned.attr('autocomplete', 'off');
	        optionsCloned.attr('aria-label', variantLabelText);
	
	        $('#product-details').append(styleSelectCloned);
	
	        if (isBundle) {
	          var i;
	          var a;
	
	          (function () {
	            styleSelectCloned.hide();
	            var bundleArr = document.getElementsByClassName('bundle-info-container');
	            var varArr = document.getElementsByClassName('varis-v2');
	            for (i = 0; i < bundleArr.length; i++) {
	              if (varArr[i] != undefined) {
	                varArr[i].id = "cloned" + varArr[i].name;
	                varArr[i].classList.add("cloned");
	                //Append select to the bundle container
	                for (a = 0; a < bundleArr.length; a++) {
	                  if (varArr[i].dataset.product == bundleArr[a].dataset.product && !bundleArr[a].classList.contains("input-field-v2")) {
	                    bundleArr[a].classList.add("input-field-v2");
	                    bundleArr[a].appendChild(varArr[i]);
	                  }
	                }
	              }
	            }
	            var clonedVarArr = document.getElementsByClassName('cloned');
	            var varianceLabel = $(selectVariant).closest('.vari').find('label').text();
	            for (var _i = 0; _i < clonedVarArr.length; _i++) {
	              if ($('label[for="' + clonedVarArr[_i].id + '"]').length === 0) {
	                _this.add_label_to_variance_select(clonedVarArr[_i], varianceLabel);
	                $('#' + clonedVarArr[_i].id).change(function () {
	                  var labels = $("label[for='" + this.id + "']");
	                  var selectedValue = $(this).children("option:selected").val();
	                  var item;
	                  var p = products[$(this).data('product')];
	                  labels.removeClass("label-outline-error");
	                  labels.filter('.error').hide();
	                  $(this).removeClass("error-in-bundle");
	                  for (var i = 0; i < p.length; i++) {
	                    if ($(this).val() == p[i].options || $(this).val() == p[i].catentry) {
	                      item = p[i];
	                    }
	                  }
	                  if (item) {
	                    var catentryid = item.catentry;
	                    var opPrice = COSTCO.util.decode($('.online-price[data-catentry=' + catentryid + ']').data('opvalue'));
	                    var container = this.parentElement.parentElement;
	                    var bundle = container.parentElement;
	                    var checkbox = $(bundle).find('input:checkbox');
	                    var isBackordered = false;
	                    var varianceBackorderMessage = null;
	                    $(container).find('.price').find('span').text(COSTCO.Product.formatMoney(opPrice, true));
	                    $(bundle).parent().find('#backorder-message').remove();
	                    products.forEach(function (product, index) {
	                      products[index].forEach(function (pro, ind) {
	                        if (selectedValue === pro.options[0]) {
	                          if (pro.inventory === "BACK_ORDER") {
	                            isBackordered = true;
	                            if (typeof pro.backorderMessage !== "undefined" && pro.backorderMessage != null) {
	                              $(bundle).parent().append($('<div id="backorder-message" class="warning"></div>').text(pro.backorderMessage));
	                              varianceBackorderMessage = pro.backorderMessage;
	                            } else {
	                              $(bundle).parent().append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	                              varianceBackorderMessage = messages.BACKORDER_TEXT_MSG5;
	                            }
	                          }
	                        }
	                      });
	                    });
	                    if ($(checkbox).is(':checked')) {
	                      $('#' + selectVariantName).val(selectedValue);
	                      $('#' + selectVariantName).trigger('change.vari');
	                      COSTCO.Product.changeBundleItemVarianceValue($(this).data('product') + 1, varianceLabel.trim(), $(this).children("option:selected").text(), opPrice, isBackordered, varianceBackorderMessage);
	                    }
	                  } else if (selectedValue == "unselected") {
	                    var _container = this.parentElement.parentElement;
	                    var _bundle = _container.parentElement;
	                    var _checkbox = $(_bundle).find('input:checkbox');
	                    if ($(_checkbox).is(':checked')) {
	                      $('#' + selectVariantName).val(selectedValue);
	                      $('#' + selectVariantName).trigger('change.vari');
	                      $(_container).find('.price').find('span').text('');
	                      $(_checkbox).click();
	                    }
	                  }
	                });
	              }
	              $('#' + clonedVarArr[_i].id).trigger('change');
	            }
	            if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	              styleSelectCloned.show();
	            }
	            _this.add_ellipsis_to_variance_select();
	          })();
	        }
	
	        styleSelectCloned.find('.varis-v2').change(function (event) {
	          var selectedOptionValue = $(event.target).find('option:selected').val();
	          $('.varis').find('option[value=' + selectedOptionValue + ']').prop('selected', true);
	          if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete) {
	            //Following code for reload page if user is clicking dropdown
	            COSTCO.CMath.redirectPDP();
	          } else {
	            $('#' + selectVariantName).trigger('change.vari');
	          }
	        });
	      }
	      $(selectVariant).parents('#variants').addClass('visually-hidden');
	    },
	
	    /**
	     * Check if bundle option is backordered
	     */
	    bundle_backorder_check: function bundle_backorder_check() {
	      $('#backorder-message').hide();
	      var containers = $('.variantContainer');
	      var bundleProducts = $('.bundle-product');
	      $(bundleProducts).find('#backorder-message').remove();
	      products.forEach(function (product, index) {
	        if ($(containers[index]).find('select').length) {
	          //Single item with one select box
	          selectedValue = $(containers[index]).find('select > option:selected').val();
	          if (selectedValue === products[index][0].options[0]) {
	            if (products[index][0].inventory === "BACK_ORDER") {
	              if (typeof products[index][0].backorderMessage !== "undefined") {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(products[index][0].backorderMessage));
	              } else {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	              }
	            }
	          }
	        } else if (parseInt($(containers[index]).find('input').val()) != null) {
	          // Single item with no select box (just quantity input shown)
	          var test = $(containers[index]).find('input').val();
	          if (products[index][0].inventory === "BACK_ORDER") {
	            if (bundleProducts[index] != null) {
	              if (typeof backorderMessage !== "undefined") {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(backorderMessage));
	              } else {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	              }
	            }
	          }
	        }
	      });
	    },
	
	    /**
	     *  Adds ellipsis to variance when text overflows select element size
	     */
	    add_ellipsis_to_variance_select: function add_ellipsis_to_variance_select() {
	      $('.varianceContainer').each(function () {
	        if ($(this).find(".viewport").length === 0) {
	          var newDiv = document.createElement("div");
	          newDiv.className = "viewport";
	          var innerDiv = document.createElement("div");
	          innerDiv.className = "innerViewport";
	          innerDiv.innerHTML = $(this).find('select option:selected').get(0).textContent;
	          newDiv.appendChild(innerDiv);
	          this.insertBefore(newDiv, this.firstChild);
	          $(this).find('select').change(function () {
	            $(this).parent().find('.innerViewport').text($("option:selected", this).text());
	          });
	        }
	      });
	    },
	
	    /**
	     * Adds label and error label to cloned variance select list
	     * @param  varianceArray
	     * @param  varianceLabel
	     */
	    add_label_to_variance_select: function add_label_to_variance_select(varianceArray, varianceLabel) {
	      var $label = $("<label>").text(varianceLabel);
	      var $errorLabel = $("<label>").text(messages.ERR_SELECT_VARIANCE + " " + varianceLabel);
	      var wrapper = document.createElement('div');
	      wrapper.classList.add("varianceContainer");
	      varianceArray.parentNode.insertBefore(wrapper, varianceArray);
	      wrapper.appendChild(varianceArray);
	      $label.attr('for', varianceArray.id);
	      $label.addClass("label-outline ");
	      $errorLabel.attr('for', varianceArray.id);
	      $errorLabel.addClass("error");
	      $errorLabel[0].style.display = "none";
	      varianceArray.parentNode.insertBefore($label[0], varianceArray.nextSibling);
	      varianceArray.parentNode.insertBefore($errorLabel[0], varianceArray.nextSibling);
	    },
	
	    /**
	     * Gets the item sequence of a product using the option value
	     * of a variant item select
	     * @param  {[type]} optionVal  [description]
	     * @param  {[type]} productNum [description]
	     * @return {[type]}            [description]
	     */
	    get_item_sequence: function get_item_sequence(optionVal, productNum) {
	      var _sequence = "";
	      for (var i = 0, len = products[productNum].length; i < len; i++) {
	        var item = products[productNum][i];
	        if (COSTCO.util.hasElem(optionVal, item.options)) {
	          _sequence = item.itemSequence;
	          break;
	        }
	      }
	      return _sequence;
	    },
	
	    /**
	     * Gets the item sequence of a product using the option value1 and option value2
	     * of a variant item select
	     * @param  {[type]} optionVal  [description]
	     * @param  {[type]} productNum [description]
	     * @return {[type]}            [description]
	     */
	    get_item_sequence_selectVariant: function get_item_sequence_selectVariant(optionVal1, optionVal2, productNum) {
	      var _sequence = "";
	      for (var i = 0, len = products[productNum].length; i < len; i++) {
	        var item = products[productNum][i];
	        if (COSTCO.util.hasElem(optionVal1, item.options) && COSTCO.util.hasElem(optionVal2, item.options)) {
	          _sequence = item.itemSequence;
	          break;
	        }
	      }
	      return _sequence;
	    },
	
	    /**
	     * Validates EDD zip code format. Returns true if zip code format is valid.
	     */
	    validateZipCode: function validateZipCode(form) {
	
	      if ($('#edd-form').find('.edd-error').length > 0) {
	        $('#edd-form').find('.edd-error').empty();
	      }
	      $.validator.addMethod("countrySpecificZipcode", function (value, element) {
	        if (wcs.storeId == '10301') return (/^(\d{5}(-\d{4})?$)$/.test($.trim(value))
	        );
	        if (wcs.storeId == '10302') return (/^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/.test($.trim(value))
	        );
	      }, messages.ERR_GROCERY_INVALID_ZIP);
	
	      $(form).validate({
	        rules: {
	          eddZipCodeField: { required: true, countrySpecificZipcode: true }
	        },
	        messages: {
	          eddZipCodeField: "<span class=\"sr-only\">" + messages.ERROR + "</span>" + messages.ERR_GROCERY_INVALID_ZIP
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          error.insertAfter(element);
	        },
	        highlight: function highlight(element, errorClass, validClass) {
	          $(element).addClass(errorClass).removeClass(validClass);
	          var enterZipMessageId = $('[id^=enterZipMessage]')[0].id;
	          $(element).attr("aria-describedby", enterZipMessageId);
	        },
	        unhighlight: COSTCO.util.unhighlightWithErrorLabel
	      });
	
	      return $(form).valid();
	    },
	
	    /**
	     * Function to validate delivery zip code
	     * 2 validation will be done
	     * 	 1. Standard form validation postal regex and required
	     *   2. Pass the zipcode to bing to also lookup country and state
	     *   	which we will pass to the command to valid zipcode
	     */
	    validateRefreshEDDZipCode: function validateRefreshEDDZipCode(element) {
	      event.preventDefault();
	      var form = event.currentTarget;
	
	      if (COSTCO.Product.validateZipCode(form)) {
	        if (typeof document.getElementById("isEDDNonNarvarFlow") !== "undefined" && document.getElementById("isEDDNonNarvarFlow") !== null) {
	          document.getElementById("isEDDNonNarvarFlow").value = true;
	        }
	        var deliveryFormZipCode = null;
	        if (wcs.storeId === '10302') {
	          if ($('#eddZipCodeField') !== undefined && $('#eddZipCodeField') !== null) {
	            deliveryFormZipCode = $('#eddZipCodeField').val().toUpperCase();
	          }
	        } else {
	          deliveryFormZipCode = $(form).find("input[name=eddZipCodeField]").val().toUpperCase();
	        }
	
	        window.wioEventBus.publish('changeDeliveryLocation', deliveryFormZipCode);
	      } else {
	        var errorContainer = $('#edd-form-block').find('.edd-error');
	        errorContainer.empty();
	        errorContainer.append(messages.ERR_INVALID_ZIP);
	        errorContainer.show();
	        $('#edd-form-block').removeClass('hide');
	      }
	    },
	
	    /** 
	     * Validates zip code. If valid calls bing and updates cookies for: zip code, state, city.
	     * Then, it invokes get edd service, and update UI with appropriate edd date or error message
	     */
	    refreshEDD: function refreshEDD(event) {
	
	      event.preventDefault();
	      var form = event.currentTarget;
	      var serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	
	      // clear errors
	      if ($('#edd-form').find('.edd-error').length > 0) {
	        $('#edd-form').find('.edd-error').empty();
	      }
	
	      if (COSTCO.Product.validateZipCode(form)) {
	        var zipCode = $(form).find("input[name=eddZipCodeField]").val();
	
	        if (typeof zipCode !== 'undefined') {
	          zipCode = zipCode.toUpperCase();
	        }
	
	        serviceToUpdateCookies(zipCode).then(function () {
	          var qty = $('#minQtyText').val();
	          COSTCO.Product.callServiceAndRefreshEDD(qty, COSTCO.Product.refreshEDDServiceCallback);
	        }).fail(function (data) {
	          // bing failed
	          var errorContainer = $('#edd-form-block').find('.edd-error');
	          errorContainer.empty();
	          errorContainer.append(messages.ERR_INVALID_ZIP);
	          errorContainer.show();
	        });
	      }
	    },
	
	    /**
	     * Shows zip code form whenever change zip is clicked in EDD widget, hides previously
	    * displayed scenario, and resets the states of Add to cart button and OOS overlay
	     */
	    showEddForm: function showEddForm() {
	      COSTCO.Product.hideEddMessagecode();
	      $('#edd-form-block').removeClass('hide');
	      $('#add-to-cart-btn').attr("disabled", true);
	      $('#add-to-cart-btn').attr("value", messages.ADDTOCART);
	      $('.oos-overlay').addClass('hide');
	      $('#eddZipCodeField').focus();
	      if (COSTCO.Product.eddMutationObserverState === Product.eddObserver.state.STARTED) {
	        COSTCO.Product.stopEDDMutationObserver();
	      }
	      $('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
	      $('#link-membership-for-price').removeClass('primary-button-v2').addClass('secondary-button-v2');
	
	      COSTCO.Product.eddFormDisplayed = true;
	    },
	
	    retrieveEDD: function retrieveEDD() {
	      var qty = $('#minQtyText').val();
	      COSTCO.Product.callServiceAndRefreshEDD(qty, COSTCO.Product.refreshEDDServiceCallback);
	      var eddStockStatusUpdateDelay = $('#eddStockStatusUpdateDelay').val();
	      //To capture EDD response for local storage stock status we need this async
	      setTimeout(function () {
	        var itemPartNumber = COSTCO.Product.getPartnumber();
	        COSTCO.Product.updateEDDStockstatusforvariant(itemPartNumber);
	      }, eddStockStatusUpdateDelay);
	    },
	
	    callServiceAndRefreshEDD: function callServiceAndRefreshEDD(quantity, callback) {
	
	      if (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) {
	        //If the product coming soon flag is true, no need to check for EDD
	        return;
	      }
	      if (typeof quantity !== 'undefined' && parseInt(quantity) > 0) {
	        $(" #edd-check-button, #eddZipCodeField").attr("disabled", true);
	        COSTCO.Product.invokeEDDServices(quantity, callback);
	      }
	    },
	    /**
	     *  Method to invoke EDD service
	    **/
	    invokeEDDServices: function invokeEDDServices(quantity, callback) {
	      var itemPartNumber = COSTCO.Product.getPartnumber();
	      var baseUri = $('#baseUriForEDD').val();
	      var clientIdentifier = $('#apigeeClientIdentifierHeader').val();
	      var eddConnectionTime = $('#connectionTimeOutForEDD').val();
	      var smallPackConnectionTime = $('#baseUriConnectionTimeOutForSmallPack').val();
	      var serviceTimeOut = '';
	      var costcoEnv = COSTCO.Product.validateCostcoEnv();
	      var country = COSTCO.Product.getCountry();
	      eddInstallationServicesJSON = {};
	      COSTCO.Product.hideEddMessagecode();
	      var zipCode = COSTCO.Product.getZipcode();
	      var costcoService = "restInventory";
	      var eddVendor;
	      var isGroceryProduct = $('#groceryIdentifier').val();
	      var eddUrl = '';
	      var shipcode = $('#defaultShipCode').val();
	      eddUrl = baseUri + '/' + itemPartNumber + "?destinationState=" + $.cookie('invCheckStateCode') + "&destinationPostalCode=" + zipCode + "&destinationCountryCode=" + country + "&quantity=" + quantity + "&orderItemId=" + "0" + "&shippingCodes=" + shipcode + "&action=EDD";
	      serviceTimeOut = eddConnectionTime;
	
	      var timeOutController = COSTCO.util.getTimeoutController();
	      timeOutController(serviceTimeOut, fetch(eddUrl, {
	        method: 'GET',
	        headers: {
	          "costco.env": costcoEnv,
	          "client-identifier": clientIdentifier,
	          "costco.service": costcoService
	        }
	      })).then(function (response) {
	        return response.json();
	      }).then(function (jsonResponse) {
	
	        //identify backordered or presell status from edd response to prevent edd message display in PDP
	        var skipEddMessage = jsonResponse.availability === COSTCO.util.productConstants.edd_backordered || jsonResponse.availability === COSTCO.util.productConstants.edd_presell;
	        var itemNumber = jsonResponse.itemNumber;
	
	        if ($("#displaybundle").length) {
	          if (null !== jsonResponse.virtualBundleId && undefined !== jsonResponse.virtualBundleId) {
	            $('#displaybundle').removeClass('hidden');
	            COSTCO.CMath.invokeBundleSetForPDP(jsonResponse.virtualBundleId);
	          } else {
	            $('#displaybundle').addClass('hidden');
	          }
	        }
	
	        SKIP_EDD = skipEddMessage;
	        //Set estimatedDeliveryDate if shipmodeDates has valid values present
	        var estimatedDeliveryDate = null !== jsonResponse.shipmodeDates && undefined !== jsonResponse.shipmodeDates && jsonResponse.shipmodeDates.length > 0 ? jsonResponse.shipmodeDates[0].estimatedDeliveryDate : undefined;
	
	        if ($('#vendorName').length > 0 && $('#vendorName').val().toLowerCase().includes('smallpack')) {
	          if (jsonResponse.itemClassification === 'SMALLPACK' && null !== estimatedDeliveryDate && undefined !== estimatedDeliveryDate) {
	            COSTCO.Product.populateSmallPackEDD(estimatedDeliveryDate);
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else if (skipEddMessage) {
	            jsonResponse.messageCode = "EDD_BACKORDERED_PRESELL_ITEM";
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else if (undefined !== isGroceryProduct && isGroceryProduct === 'true') {
	            jsonResponse.messageCode = "EDD_SMALLPACK_GROCERY_UNAVAILABLE";
	          } else {
	            if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
	              jsonResponse.messageCode = 'MSG_CODE_POSTAL_CODE_RESTRICTED';
	              COSTCO.Product.isEDDStatusAvailable = false;
	            } else {
	              jsonResponse.messageCode = "EDD_SMALLPACK_UNAVAILABLE";
	              COSTCO.Product.isEDDStatusAvailable = true;
	            }
	          }
	          callback(jsonResponse);
	        } else if ($('#vendorName').length > 0 && $('#vendorName').val().toLowerCase().includes('chubltl')) {
	          if (jsonResponse.itemClassification === 'CHUBLTL' && null !== estimatedDeliveryDate && undefined !== estimatedDeliveryDate) {
	            COSTCO.Product.populateChubLTLEDD(estimatedDeliveryDate);
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else {
	            if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
	              jsonResponse.messageCode = 'MSG_CODE_POSTAL_CODE_RESTRICTED';
	              COSTCO.Product.isEDDStatusAvailable = false;
	            } else {
	              jsonResponse.messageCode = "EDD_SMALLPACK_UNAVAILABLE";
	              COSTCO.Product.isEDDStatusAvailable = true;
	            }
	          }
	          callback(jsonResponse);
	        } else {
	          var msgCode = COSTCO.Product.buildMessageCodeForEDD(jsonResponse);
	          COSTCO.Product.setEDDdisplay(msgCode, jsonResponse);
	          if (jsonResponse !== undefined && jsonResponse.status !== undefined && jsonResponse.status === "SUCCESS") {
	            if (!COSTCO.util.isCAStore()) {
	              COSTCO.Product.prepareAndCallDeliveryServices();
	            }
	          }
	          callback(jsonResponse);
	          COSTCO.Product.executeAlways();
	        }
	      }).catch(function (err) {
	        COSTCO.Product.externalServiceDown();
	        if (err.message !== undefined && err.message === 'API_TIMEOUT') {
	          console.log('API TIMEOUT');
	        } else {
	          console.log('API Service Fault');
	        }
	      });
	    }, populateSmallPackEDD: function populateSmallPackEDD(estimatedDeliveryDate) {
	      var date = estimatedDeliveryDate.split('T')[0];
	      var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
	      document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
	      document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
	      document.getElementById('edd-heading-text').innerHTML = messages.DATE_TEXT_SMALL_PACK;
	      document.getElementById('edd-heading-text-suffix').innerHTML = messages.DATE_TEXT_ORDER_NOW_SUFFIX;
	      COSTCO.Product.setZipInErrMsg('edd-date-msg');
	      $('#edd-date-msg').removeClass('hide');
	      $('.edd-carrier-text').addClass('hidden');
	    }, populateChubLTLEDD: function populateChubLTLEDD(estimatedDeliveryDate) {
	      var date = estimatedDeliveryDate.split('T')[0];
	      var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
	      document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
	      document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
	      document.getElementById('edd-heading-text').innerHTML = messages.DATE_TEXT_SMALL_PACK;
	      document.getElementById('edd-heading-text-suffix').innerHTML = messages.DATE_TEXT_ORDER_NOW_SUFFIX;
	      COSTCO.Product.setZipInErrMsg('edd-date-msg');
	      $('#edd-date-msg').removeClass('hide');
	      document.getElementById('edd-disclaimer-text').innerHTML = messages.EDD_CHUB_LTL_GUARANTEE_PRECONDITION;
	      $('.edd-carrier-text').removeClass('hidden');
	    },
	    /**
	          *  Method to get selected partnumber for variant items and normal line items
	        **/
	    getPartnumber: function getPartnumber() {
	      var itemPartnumber = '';
	      var variantItem = COSTCO.Header.itemPartNumberSelcted;
	      var normalItem = $('#resultingItemNumbers').val();
	      if (variantItem !== undefined && variantItem !== '') {
	        itemPartnumber = variantItem;
	      } else {
	        itemPartnumber = normalItem.replace(/[[\]]/g, '');
	      }
	      return itemPartnumber;
	    },
	    /**
	          *  Method to get Zipcode for EDD and installation service call
	        **/
	    getZipcode: function getZipcode() {
	      var zipCode = $.cookie('invCheckPostalCode');
	      var finalZip = '';
	      if (zipCode != null && zipCode != '') {
	        var zipCodeWithoutExtraFour = zipCode.split('-');
	        if (zipCodeWithoutExtraFour.length > 1) {
	          finalZip = zipCodeWithoutExtraFour[0];
	        } else {
	          finalZip = zipCode;
	        }
	      }
	      return finalZip;
	    },
	    /**
	          *  Method to hide message code components
	        **/
	    hideEddMessagecode: function hideEddMessagecode() {
	      $('#edd-date-msg').addClass('hide');
	      $('#edd-postal-code-restricted').addClass('hide');
	      $('#edd-oos-select-option').addClass('hide');
	      $('#edd-outofstock').addClass('hide');
	      $('#edd-unknown-error').addClass('hide');
	      $('#edd-addit-trans-time').addClass('hide');
	      $('#edd-msg-code-available-house').addClass('hide');
	      $('#edd-msg-code-external-service-down').addClass('hide');
	      $('#edd-transit-block').addClass('hide');
	      $(" #edd-check-button, #eddZipCodeField").attr("disabled", false);
	      $('#edd-back-order-msg').addClass('hide');
	      $('#edd-form-block').addClass('hide');
	      $('#edd-msg-code-smallpack').addClass('hide');
	      $('#edd-msg-code-grocery-smallpack').addClass('hide');
	    },
	    /**
	          *  Method to disable zipcode field based on refresh edd param
	        **/
	    executeAlways: function executeAlways() {
	      $('#product-page').attr("data-onloadTracker", "false");
	      COSTCO.Product.pdpMakeElementSticky();
	    },
	    /**
	          *  Method to set EDD value from edd response to JSP page
	        **/
	    setEDDdisplay: function setEDDdisplay(msgCode, jsonResponse) {
	      if (msgCode !== undefined && msgCode !== '') {
	        var status = msgCode.split('+')[0];
	        var messageCode = msgCode.split('+')[1];
	        jsonResponse.status = status;
	        jsonResponse.messageCode = messageCode;
	        if (jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== undefined && jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== null && status === "SUCCESS" && COSTCO.Product.checkIfEDDInValidRange(jsonResponse.shipmodeDates[0].estimatedDeliveryDate)) {
	          var date = jsonResponse.shipmodeDates[0].estimatedDeliveryDate.split('T')[0];
	          var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
	          jsonResponse.shipmodeDates[0].estimatedDeliveryDate = dateToDisplay;
	          document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
	          document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-date-msg').removeClass('hide');
	          document.getElementById('edd-disclaimer-text').innerHTML = messages.EDD_AND_CALENDAR_GUARANTEE_PRECONDITION;
	          $('.edd-carrier-text').removeClass('hidden');
	        }
	      }
	    },
	    /**
	          *  Method to disable add to cart button and enable edd form if edd service is down
	          *  NOTE: If item is smallpack, we do not want to disable add to cart button on external service down or timeout
	        **/
	    externalServiceDown: function externalServiceDown() {
	      if ($('#vendorName').length > 0 && ($('#vendorName').val().toLowerCase().includes('smallpack') || $('#vendorName').val().toLowerCase().includes('chubltl'))) {
	        $('#add-to-cart-btn').attr("disabled", false);
	      } else {
	        $('#add-to-cart-btn').attr("disabled", true);
	        COSTCO.CMath.addBorderToShipItMolecule('outOfStock');
	      }
	      $('#add-to-cart-btn').attr("value", messages.ADDTOCART);
	      $('.oos-overlay').addClass('hide');
	      $('#edd-msg-code-external-service-down').removeClass('hide');
	      $('#product-page').attr("data-onloadTracker", "false");
	      COSTCO.Product.pdpMakeElementSticky();
	    },
	    /**
	            *  Method to get country from lang id
	          **/
	    getCountry: function getCountry() {
	      var langId = COSTCO.util.getLangId();
	      var country = 'US';
	      if (langId === '-24' || langId === '-25') {
	        country = 'CA';
	      }
	      return country;
	    },
	    /**
	          * Method to set costco environment for service header
	        **/
	    validateCostcoEnv: function validateCostcoEnv() {
	      var costcoEnv = $('#costcoEnvironmentForEDD').val();
	      var higherEnv = 'QA2';
	      var ecomEnv = 'ECOM';
	      var devEnv = 'DEV';
	      if (costcoEnv === "") {
	        costcoEnv = ecomEnv;
	      } else if (costcoEnv == devEnv) {
	        costcoEnv = higherEnv;
	      }
	      return costcoEnv;
	    },
	    /**
	          * Method to invoke installation API service
	        **/
	    invokeInstallationServices: function invokeInstallationServices(eddServiceResponse, itemPartNumber, zipCode) {
	      var installationServiceUri = $('#baseUriForEDDInstallationServices').val();
	      var clientIdentifier = $('#apigeeClientIdentifierHeader').val();
	      var installationConnetionTime = $('#connectionTimeOutForEDD').val();
	      var costcoEnv = COSTCO.Product.validateCostcoEnv();
	      var installationUri = installationServiceUri + '/' + itemPartNumber + "?destinationPostalCode=" + zipCode + "&fulfilledBy=" + eddServiceResponse.fulfilledBy + "&orderItemId=" + "0";
	      var timeOutController = COSTCO.util.getTimeoutController();
	      timeOutController(installationConnetionTime, fetch(installationUri, {
	        method: 'GET',
	        headers: {
	          "costco.env": costcoEnv,
	          "client-identifier": clientIdentifier
	        }
	      })).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        eddInstallationServicesJSON = data.services;
	      }).catch(function (err) {
	        if (err.message !== undefined && err.message === 'API_TIMEOUT') {
	          console.log('API TIMEOUT');
	        } else {
	          console.log('API Service Fault');
	        }
	      });
	    },
	    /**
	     * Callback function which updates Add to cart button state and OOS overlay based on service response
	     */
	    refreshEDDServiceCallback: function refreshEDDServiceCallback(response) {
	      if (typeof response !== 'undefined' && !SKIP_EDD) {
	
	        if (COSTCO.util.islocationControlledInventoryFlow()) {
	          //fetch inventory from inventory service response
	          var inventoryStatus = $('.online-price[data-catentry=' + $('#catEntryId').val() + ']').data('inv');
	          // Handling of EDD messages of location controlled items - to avoid multiple message displays
	          // Item failing in CMath.handleContractSpecificRules() will not display EDD messages.
	          if (inventoryStatus === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	            $('.edd-container').hide();
	            $('#edd-message-block').hide();
	          }
	          if (inventoryStatus !== COSTCO.util.productConstants.inv_backorderd && inventoryStatus !== COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	            if (response.messageCode === "MSG_CODE_POSTAL_CODE_RESTRICTED") {
	              COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	              document.getElementById('postal-code-restricted-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	              $('#edd-postal-code-restricted').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK" && COSTCO.Product.isVariantAvailable()) {
	              if (isPDPVariantGreyOutEnabled == 'false') {
	                $('.oos-overlay').removeClass('hide');
	              }
	              $('#edd-oos-select-option').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK") {
	              if (isPDPVariantGreyOutEnabled == 'false') {
	                $('.oos-overlay').removeClass('hide');
	              }
	              $('#edd-oos-select-option').addClass('hide');
	              document.getElementById('out-of-stock-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	              $('#edd-outofstock').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_EXTERNAL_SERVICE_DOWN") {
	              $('.oos-overlay').addClass('hide');
	              $('#edd-msg-code-external-service-down').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_ADDITIONAL_TRANSIT_TIME") {
	              $('.oos-overlay').addClass('hide');
	              document.getElementById('edd-postal-code-transit-time').innerHTML = $.cookie('invCheckPostalCode');
	              $('#edd-addit-trans-time').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_AVAILABLE_INHOUSE") {
	              $('.oos-overlay').addClass('hide');
	              document.getElementById('edd-postal-code-available-inhouse').innerHTML = $.cookie('invCheckPostalCode');
	              $('#edd-msg-code-available-house').removeClass('hide');
	            } else if (response.messageCode === "EDD_SMALLPACK_GROCERY_UNAVAILABLE") {
	              $('.oos-overlay').addClass('hide');
	              document.getElementById('edd-postal-code-grocery-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	              $('#edd-msg-code-grocery-smallpack').removeClass('hide');
	            } else if (response.messageCode === "EDD_SMALLPACK_UNAVAILABLE") {
	              COSTCO.Product.isLocCtrlSmallPck = true;
	              $('.oos-overlay').addClass('hide');
	              if (COSTCO.CMath.invAvailableAjax) {
	                //condition for depozipin small pck edd msg hide
	                $('#edd-msg-code-smallpack').removeClass('hide');
	                document.getElementById('edd-postal-code-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	              } else {
	                $('#edd-msg-code-smallpack').addClass('hide');
	              }
	            } else if (response.status === "FAILURE" || response.messageCode === "MSG_CODE_UNKNOWN_ERROR") {
	              $('#edd-unknown-error').removeClass('hide');
	            } else {
	              $('.oos-overlay').addClass('hide');
	            }
	          }
	        } else if (response.messageCode === "MSG_CODE_POSTAL_CODE_RESTRICTED") {
	          $('.edd-container').show();
	          $('#edd-message-block').show();
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          document.getElementById('postal-code-restricted-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	          $('#edd-postal-code-restricted').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK" && COSTCO.Product.isVariantAvailable()) {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          if (isPDPVariantGreyOutEnabled == 'false') {
	            $('.oos-overlay').removeClass('hide');
	          }
	          $('#edd-oos-select-option').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK") {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART_OUTOFSTOCK);
	          if (isPDPVariantGreyOutEnabled == 'false') {
	            $('.oos-overlay').removeClass('hide');
	          }
	          $('#edd-oos-select-option').addClass('hide');
	          document.getElementById('out-of-stock-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	          $('#edd-outofstock').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_EXTERNAL_SERVICE_DOWN") {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          $('#edd-msg-code-external-service-down').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_ADDITIONAL_TRANSIT_TIME") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          document.getElementById('edd-postal-code-transit-time').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-addit-trans-time').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_AVAILABLE_INHOUSE") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          document.getElementById('edd-postal-code-available-inhouse').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-msg-code-available-house').removeClass('hide');
	        } else if (response.messageCode === "EDD_SMALLPACK_GROCERY_UNAVAILABLE") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          document.getElementById('edd-postal-code-grocery-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-msg-code-grocery-smallpack').removeClass('hide');
	        } else if (response.messageCode === "EDD_SMALLPACK_UNAVAILABLE") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#edd-msg-code-smallpack').removeClass('hide');
	          document.getElementById('edd-postal-code-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	        } else if (response.status === "FAILURE" || response.messageCode === "MSG_CODE_UNKNOWN_ERROR") {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          $('#edd-unknown-error').removeClass('hide');
	        } else {
	          if (!COSTCO.CMath.siteControllOOS) {
	            $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	            $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	            $('.oos-overlay').addClass('hide');
	          }
	        }
	      }
	      COSTCO.Product.eddFormDisplayed = false;
	    },
	
	    prepareAndCallDeliveryServices: function prepareAndCallDeliveryServices() {
	
	      var deliveryServicesRequestMap = new Map();
	      var itemPartNumber = COSTCO.Product.getPartnumber();
	      var zipCode = COSTCO.Product.getZipcode();
	      var deliveryServicesUri = $('#baseUriForEDDDeliveryServices').val();
	      installationUri = deliveryServicesUri + '/' + itemPartNumber + "?destinationPostalCode=" + zipCode + "&orderItemId=0";
	      var defaultShipcode = $('#defaultShipCode').val();
	      if (defaultShipcode) {
	        installationUri += "&shipMode=" + defaultShipcode;
	      }
	      deliveryServicesRequestMap.set(0, installationUri);
	      COSTCO.EDD.invokeDeliveryServices(deliveryServicesRequestMap, {});
	    },
	
	    isVariantAvailable: function isVariantAvailable() {
	      return $('#product-page').attr('data-onloadTracker') === "true" && !COSTCO.Product.isSingleAvailableSKU(products) && (COSTCO.Product.item_type === 'single_variant' || COSTCO.Product.item_type === 'multi_variant') ? true : false;
	    },
	    enableAddtoCart: function enableAddtoCart() {
	      $('#add-to-cart-btn').attr("disabled", false);
	      $('#add-to-cart-btn').attr("value", messages.ADDTOCART);
	      $('.oos-overlay').addClass('hide');
	      $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	      $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	      $('#add-to-list').show();
	      COSTCO.CMath.addBorderToShipItMolecule();
	    },
	    disableAddtoCart: function disableAddtoCart(buttonMessage) {
	      $('#add-to-cart-btn').attr("disabled", true);
	      $('#add-to-cart-btn').attr("value", buttonMessage);
	      $('.oos-overlay').addClass('hide');
	      COSTCO.CMath.addBorderToShipItMolecule();
	
	      if (buttonMessage == messages.ADDTOCART_OUTOFSTOCK) {
	        $('#add-to-list').hide();
	        COSTCO.CMath.addBorderToShipItMolecule('outOfStock');
	      } else {
	        $('#add-to-list').show();
	      }
	    },
	    /**
	          * Method used to replace latest zipcode in message code string
	        **/
	    setZipInErrMsg: function setZipInErrMsg(component) {
	      var zipCode = $.cookie('invCheckPostalCode');
	      var prevZipcode = document.getElementById('prevZipCode').value;
	      var str = document.getElementById(component).innerHTML;
	      if (prevZipcode !== undefined && prevZipcode !== "" && zipCode !== prevZipcode) {
	        document.getElementById(component).innerHTML = str.replace(prevZipcode, zipCode);
	        document.getElementById('prevZipCode').value = zipCode;
	      } else if (prevZipcode === "") {
	        document.getElementById(component).innerHTML = str.replace("null", zipCode);
	        document.getElementById('prevZipCode').value = zipCode;
	      }
	    },
	    /**
	        * Method return EDD Date in Day,Month date (Thursday, October 1) format
	        **/
	    getDateFormattedToDisplay: function getDateFormattedToDisplay(date) {
	      var splitDate = date.split('-');
	      var year = splitDate[0];
	      var month = splitDate[1] - 1;
	      var day = splitDate[2];
	      var langId = COSTCO.util.getLangId();
	      var daysOfWeek;
	      var monthName;
	      if (langId === '-25') {
	        dateFormat = new Date(year, month, day).toLocaleDateString('fr-CA', { weekday: 'long', month: 'long', day: 'numeric' });
	      } else {
	        dateFormat = new Date(year, month, day).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
	      }
	      return dateFormat;
	    },
	    /**
	        *    Method return true if EDD date is in range after validating xapp entry EDD_MAX_FUTURE_DATE_DIFF
	       **/
	    checkIfEDDInValidRange: function checkIfEDDInValidRange(date) {
	      if (null != date) {
	        date = date.split('T')[0].split('-');
	        var rangeValid = false;
	        var eddMaxFutureDateDiff = parseInt($('#eddMaxFutureDateDiff').val());
	        var year = date[0];
	        var month = date[1] - 1;
	        var day = date[2];
	        var eddDate = new Date(year, month, day);
	        var today = new Date();
	        var diffTime = Math.abs(eddDate - today);
	        var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	        if (diffDays <= eddMaxFutureDateDiff) {
	          rangeValid = true;
	        }
	        return rangeValid;
	      }
	    },
	    /**
	             * Method used to form and return  message code from EDD response
	           **/
	    buildMessageCodeForEDD: function buildMessageCodeForEDD(jsonResponse) {
	      var msgString = '';
	      if (jsonResponse.availability === COSTCO.util.productConstants.edd_backordered || jsonResponse.availability === COSTCO.util.productConstants.edd_presell) {
	        //Backordered or Presell item messages will be displayed by inventory service flow
	        msgString = 'SUCCESS+EDD_BACKORDERED_PRESELL_ITEM';
	        COSTCO.Product.isEDDStatusAvailable = true;
	      } else if (typeof jsonResponse.availableForSale != 'undefined' && jsonResponse.availableForSale) {
	        if (typeof jsonResponse.shipmodeDates[0].estimatedDeliveryDate === 'undefined' || jsonResponse.shipmodeDates[0].estimatedDeliveryDate == null || jsonResponse.shipmodeDates[0].estimatedDeliveryDate != null && jsonResponse.shipmodeDates[0].estimatedDeliveryDate.trim().length === 0) {
	          if (COSTCO.Product.isAdditionalTransitTimeRequired()) {
	            msgString = 'SUCCESS+MSG_CODE_ADDITIONAL_TRANSIT_TIME';
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else {
	            msgString = 'SUCCESS+MSG_CODE_AVAILABLE_INHOUSE';
	            COSTCO.Product.isEDDStatusAvailable = true;
	          }
	        } else if (COSTCO.Product.checkIfEDDInValidRange(jsonResponse.shipmodeDates[0].estimatedDeliveryDate)) {
	          msgString = 'SUCCESS+';
	          COSTCO.Product.isEDDStatusAvailable = true;
	        } else {
	          msgString = 'FAILURE+MSG_CODE_ITEM_OUT_OF_STOCK';
	          COSTCO.Product.isEDDStatusAvailable = false;
	        }
	      } else if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
	        // If fulfilled by comes back with "ship restricted", show a different error message
	        msgString = 'FAILURE+MSG_CODE_POSTAL_CODE_RESTRICTED';
	        COSTCO.Product.isEDDStatusAvailable = false;
	      } else if (jsonResponse.fulfilledBy != null && 'UNKNOWN' === jsonResponse.fulfilledBy.toUpperCase()) {
	        // if fulfilledBy = 'UNKNOWN' then an exception happened - date will be null
	        msgString = 'FAILURE+MSG_CODE_UNKNOWN_ERROR';
	        COSTCO.Product.isEDDStatusAvailable = false;
	      } else {
	        msgString = 'FAILURE+MSG_CODE_ITEM_OUT_OF_STOCK';
	        COSTCO.Product.isEDDStatusAvailable = false;
	      }
	      return msgString;
	    },
	
	    updateEDDStockstatusforvariant: function updateEDDStockstatusforvariant(itemNumber) {
	      if ((COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') && isPDPVariantGreyOutEnabled == 'true') {
	        var uptitemarrayStatus = {};
	        var uptvariantitemArray = {};
	        var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
	        var len = optionsSelected.length;
	        var lowerSwatch = $('#swatches-productOption0' + parseInt(len - 1) + '').length > 0;
	        var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0;
	        if (COSTCO.CMath.variantJSON.length > 0) {
	          for (var i in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[i];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == itemNumber && (!COSTCO.Product.isEDDStatusAvailable || COSTCO.CMath.isErrorlocationControlleditem)) {
	                uptitemarrayStatus["OL"] = '0';
	                uptitemarrayStatus["WH"] = sub_val.WH;
	                uptvariantitemArray[itemNumber] = uptitemarrayStatus;
	                COSTCO.CMath.variantJSON[i] = uptvariantitemArray;
	                localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	              }
	            }
	          }
	          for (var i in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[i];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == itemNumber) {
	                if (sub_val.OL == '0' && sub_val.WH == '0') {
	                  if (COSTCO.Product.item_type === 'multi_variant') {
	                    if (lowerSwatch) {
	                      COSTCO.CMath.ajaxStrikeSwatches();
	                    } else if (lowerDropDown) {
	                      COSTCO.CMath.ajaxGrayOutDropDown();
	                    }
	                  } else if (COSTCO.Product.item_type === 'single_variant') {
	                    if ($('#swatches-productOption00').length > 0) {
	                      COSTCO.CMath.ajaxStrikeSwatches();
	                    } else if ($('.varis-v2[data-product=0]').length > 0) {
	                      COSTCO.CMath.ajaxGrayOutDropDown();
	                    }
	                  }
	                } else {
	                  //Following code for remove css of previous selected swatches
	
	                  if (lowerSwatch) {
	                    // pills
	                    if (COSTCO.Product.item_type === 'multi_variant') {
	
	                      variable = $('input[value=' + optionsSelected[len - 1] + ']').next().attr("automation-id");
	                    } else if (COSTCO.Product.item_type === 'single_variant') {
	                      $('.selection-item').removeClass("select-span1-OOS");
	                      variable = $('input[value=' + optionsSelected[0] + ']').next().attr("automation-id");
	                    }
	                    $('span[automation-id=' + variable + ']').removeClass("select-span1-OOS");
	                    $('span[automation-id=' + variable + ']').removeClass("span1-outofstock");
	                    $('span[automation-id=' + variable + ']').children("p").remove(); // for removing P tag
	                  } else if (lowerDropDown) {
	                    // lower level drop-down
	                    $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').removeClass("out-of-stock");
	                    $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').children("span").remove();
	                  }
	                  COSTCO.CMath.update_selected_option_label(optionsSelected[len - 1]);
	                }
	                if ($('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0) {
	                  COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	                } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0) {
	                  COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    /**
	             * Method return true if additional transit time  required for selected state by checking  xapp entry EDD_STATES_THAT_REQUIRE_ADDITIONAL_TRANSIT_TIME
	           **/
	    isAdditionalTransitTimeRequired: function isAdditionalTransitTimeRequired() {
	      var additionalTransitTimeStates = $('#additionalTransitTimeStates').val();
	      var additionTransitTimeRequired = false;
	      var state = $.cookie('invCheckStateCode');
	      if (null !== state) {
	        state = state.toUpperCase();
	        if (additionalTransitTimeStates != null) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = additionalTransitTimeStates.split(",")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var stateFromConf = _step.value;
	
	              if (stateFromConf.toUpperCase() === state) {
	                additionTransitTimeRequired = true;
	                break;
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	      }
	      return additionTransitTimeRequired;
	    },
	
	    /**
	     * This function appends price (and backordered text) to every Single Variant product's
	     * We will only show price if the item is not member only pricing if the member is not signed in
	     * select options so that they show something like this Color: "Brown - $194.99".
	     * @return {[void]}
	     */
	    set_option_price_text: function set_option_price_text() {
	      $('.variantContainer').each(function (i, vContainer) {
	        var product_num = $(vContainer).find('[data-product]').data('product');
	        if (this.isSingleVariant([products[product_num]], true)) {
	          $(vContainer).find('select.varis option').each(function (i, option) {
	            if ($(option).val() != 'unselected') {
	              var item = this.findItem(products[product_num], this.get_selected_array($(option))),
	                  back_ordered = item.inventory == 'BACK_ORDER' ? ' - ' + messages.BACKORDER_TEXT : item.inventory == 'OUT_STOCK' ? ' - ' + messages.OUT_OF_STOCK_TEXT : "";
	              var memberOnly = $('#memberItem').val() == "true" ? true : false,
	                  userInfo = COSTCO.util.getMemberCookie(),
	                  signedIn = userInfo.signedIn,
	                  costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false;
	              var variantOptionText = $(option).text() + back_ordered;
	              if (!memberOnly || memberOnly && signedIn && costcoMember) {
	                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                  variantOptionText = variantOptionText;
	                } else {
	                  variantOptionText = variantOptionText + ' - ' + this.formatMoney(this.processPrice(item.price), true);
	                }
	              }
	              $(option).text(variantOptionText);
	              $variant_option_input = $('input[value=' + $(option)[0].value + ']');
	              if (typeof $variant_option_input.siblings('.selection-item')[0] !== "undefined") {
	                $variant_option_input.siblings('.selection-item')[0].innerHTML = variantOptionText;
	                $variant_option_input.removeAttr('checked');
	                if ($('.variantContainer select.varis').find('option:selected').val() == $(option).val()) {
	                  $('label[for=' + $('.variantContainer select.varis').find('option:selected').parent().attr('id') + ']').find('.selectedOptionValue').html(' ' + variantOptionText);
	                  $variant_option_input.prop('checked', true);
	                }
	              }
	              if (back_ordered.includes(messages.OUT_OF_STOCK_TEXT)) {
	                $(option).attr("disabled", "disabled");
	                $variant_option_input.attr("disabled", "disabled");
	                $variant_option_input.parents('label.variant-v2').addClass('disabled');
	              } else {
	                $variant_option_input.removeAttr('disabled');
	                $variant_option_input.parents('label.variant-v2').removeClass('disabled');
	              }
	            }
	          }.bind(this));
	        }
	      }.bind(this));
	    },
	    /**
	     * The popover for fees associated with a product. These are the "tool-tips" part
	     * of the line items in math table.
	     * @return {[void]}
	     */
	    pop_overs: function pop_overs() {
	      $('.co-info').popover({
	        container: '.math-table'
	      });
	
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        COSTCO.util.socialNetworksPopover('social-share-link');
	      }
	    },
	    /**
	     * If span.view-more-height is set by the business within
	     * a product's long description, this function sets the
	     * product details product-info-description to that designated
	     * max-height and appends a "View More Details" button.
	     * @return {[void]}
	     */
	    product_details_view_more: function product_details_view_more() {
	      $('#product-page .panel-body').each(function (index, el) {
	        var tab_max_height = $(el).find('.view-more-height').length > 0 ? $(el).find('.view-more-height').data('height') : $(el).find('.view-more-height-default').data('height'),
	            $content = $(el).find('.product-info-description');
	        var productType = $('#product-info').data('product');
	        //for BD specific, we want to show the content in its entirety
	        if (tab_max_height && productType !== 'tobacco') {
	          // Append the view more html
	          if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            $content.after(COSTCO.util.tmpl('tmpl_view_more', {}));
	          } else {
	            $content.after(COSTCO.util.tmpl('tmpl_view_more_v2', {}));
	          }
	          // Set the max-height to the business controlled max-height
	          $content.css({
	            'max-height': tab_max_height
	          });
	        }
	      });
	    },
	    /**
	     * Event listener for button allocated by product_details_view_more
	     * that removes the max-height attribute and then removes itself to
	     * view the entire product details.
	     * @return {[void]}
	     */
	    view_more: function view_more() {
	      if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        $(this).parents('.view-more').siblings('.product-info-description').css({
	          'max-height': 'none'
	        });
	        $(this).parents('.view-more').remove();
	      } else {
	        $(this).parents('.view-more-v2').siblings('.product-info-description').css({
	          'max-height': 'none'
	        });
	        try {
	          var focusableElements = $(this).parents('.view-more-v2').siblings('.section-title');
	          focusableElements.attr('tabindex', '0');
	          $(focusableElements).focus();
	          if ($(this).parents('.panel-body').attr('id') === "nav-pdp-tab-header-13") {
	            COSTCO.Product.changeVisibilityOfReviewContents("show");
	          }
	          focusableElements.removeAttr('tabindex');
	        } catch (err) {}
	        $(this).parents('.view-more-v2').remove();
	      }
	    },
	    findItem: function findItem(p, o) {
	      if (o.length == 0 && p.length > 0) {
	        return p[0];
	      }
	      for (var i = 0; i < p.length; i++) {
	        if (this.areArraysEqual(o, p[i].options) || o == p[i].catentry) {
	          return p[i];
	        }
	      }
	      return null;
	    },
	    areArraysEqual: function areArraysEqual(array1, array2) {
	      var temp = new Array();
	      if (!array1[0] || !array2[0]) {
	        // If either is not an array
	        return false;
	      }
	      if (array1.length != array2.length) {
	        return false;
	      }
	      for (var i = 0; i < array1.length; i++) {
	        key = _typeof(array1[i]) + "~" + array1[i];
	        if (temp[key]) {
	          temp[key]++;
	        } else {
	          temp[key] = 1;
	        }
	      }
	      for (var i = 0; i < array2.length; i++) {
	        key = _typeof(array2[i]) + "~" + array2[i];
	        if (temp[key]) {
	          if (temp[key] == 0) {
	            return false;
	          } else {
	            temp[key]--;
	          }
	        } else {
	          // Key didn't appear in array1, arrays are not equal.
	          return false;
	        }
	      }
	      return true;
	    },
	    isSingleItem: function isSingleItem(productsArray) {
	      var no_variant_container = $('.variantContainer').length == 0;
	      return productsArray.length === 1 && productsArray[0].length === 1 && no_variant_container ? true : false;
	    },
	    isSingleAvailableSKU: function isSingleAvailableSKU(productsArray) {
	      return productsArray.length === 1 && productsArray[0].length === 1 ? true : false;
	    },
	
	    isBundle: function isBundle(productsArray) {
	      return productsArray.length > 1 || $('.bundleQty').length > 0;
	    },
	    /**
	     * On product page search for collection tab.
	     * 
	     * @return true if collection tab exist, otherwise false
	     */
	    isCollectionPage: function isCollectionPage() {
	      return $('#product-page').find('.collection-tab').length > 0 ? true : false;
	    },
	    isSingleVariant: function isSingleVariant(productsArray, override) {
	      if (productsArray != undefined && productsArray[0] != undefined && productsArray.length === 1 && $('.bundleQty').length === 0 || override) {
	        for (var i = 0, len = productsArray[0].length; i < len; i++) {
	          if (productsArray[0][i].options) if (productsArray[0][i].options.length === 1) return true;
	        }
	      } else {
	        return false;
	      }
	      return false;
	    },
	    isMultiVariant: function isMultiVariant(productsArray, override) {
	      if (productsArray.length === 1 && $('.bundleQty').length === 0 || override) {
	        for (var i = 0, len = productsArray[0].length; i < len; i++) {
	          if (productsArray[0][i].options) if (productsArray[0][i].options.length > 1) return true;
	        }
	      } else {
	        return false;
	      }
	      return false;
	    },
	    isSelectedSingleVariantBackOrdered: function isSelectedSingleVariantBackOrdered(selectedOption, product) {
	      var isBackordered = false,
	          selectedOptionValue = selectedOption.val();
	      product.forEach(function (opt, i) {
	        if (selectedOptionValue === opt.options[0]) {
	          if (opt.inventory === "BACK_ORDER") isBackordered = true;
	          return;
	        }
	      });
	      return isBackordered;
	    },
	    isSelectedMultiVariantBackOrdered: function isSelectedMultiVariantBackOrdered(selectedOptions, product) {
	      var isBackordered = false;
	      product.forEach(function (opt, i) {
	        var options = opt.options,
	            count = 0;
	        selectedOptions.each(function (chosen, k) {
	          if (COSTCO.util.hasElem(this.value, options)) count++;
	        });
	        if (count === options.length) {
	          if (opt.inventory === "BACK_ORDER") isBackordered = true;
	          return;
	        }
	      });
	      return isBackordered;
	    },
	    areAnySelectedFromBundleBackordered: function areAnySelectedFromBundleBackordered(containers) {
	      var isBackordered = false;
	      products.forEach(function (product, index) {
	        // interogate each product from 'products' array; find out what kind of item it is
	        var selectedValue;
	        if (this.isSingleItem([products[index]])) {
	          if ($(containers[index]).find('select').length) {
	            // Single item with a select box with only one option
	            selectedValue = $(containers[index]).find('select > option:selected').val();
	            if (selectedValue === products[index][0].options[0]) if (products[index][0].inventory === "BACK_ORDER") isBackordered = true;
	            return;
	          } else if (parseInt($(containers[index]).find('input').val()) > 0) {
	            // Single item with no select box (just quantity input shown)
	            if (products[index][0].inventory === "BACK_ORDER") isBackordered = true;
	            return;
	          }
	        } else if (this.isSingleVariant([products[index]], true)) {
	          if (this.isSelectedSingleVariantBackOrdered($(containers[index]).find('select > option:selected'), products[index])) {
	            isBackordered = true;
	            return;
	          }
	        } else if (this.isMultiVariant([products[index]], true)) {
	          if (this.isSelectedMultiVariantBackOrdered($(containers[index]).find('select > option:selected'), products[index])) {
	            isBackordered = true;
	            return;
	          }
	        }
	      }.bind(this));
	      return isBackordered;
	    },
	    bindSubmitToBackOrderModal: function bindSubmitToBackOrderModal() {
	      $("#ProductForm input[name='add-to-cart']").unbind('click').click(function () {
	        if (this.item_type == 'single') {
	          // Its a single product aka only "add to cart" button exists
	          typeof products[0][0].inventory !== "undefined" && products[0][0].inventory === 'BACK_ORDER' ? this.backorder_modal(products[0][0]) : $('#ProductForm').submit();
	        } else if (this.item_type == 'single_variant') {
	          // Its a single item with options (ie color or size, etc.)
	          var $options = $('#ProductForm select option:selected'),
	              selected_arr = this.get_selected_array($options);
	          this.isSelectedSingleVariantBackOrdered($options, products[0]) ? this.backorder_modal(this.findItem(products[0], selected_arr)) : $('#ProductForm').submit();
	        } else if (this.item_type == 'multi_variant') {
	          // Its a single item with multiple options (ie color and size, etc.)
	          var $options = $('#ProductForm select option:selected'),
	              selected_arr = this.get_selected_array($options);
	          this.isSelectedMultiVariantBackOrdered($options, products[0]) ? this.backorder_modal(this.findItem(products[0], selected_arr)) : $('#ProductForm').submit();
	        } else if (this.item_type == 'bundle') {
	          // Its bundle which can contain variants/singleItems - check the option(s) selected and see if they're backordered
	          this.areAnySelectedFromBundleBackordered($('.variantContainer')) ? this.backorder_modal() : $('#ProductForm').submit();
	        } else {
	          // fallback - always try to add to cart.
	          $('#ProductForm').submit();
	        }
	      }.bind(this));
	    },
	    is_sku_resolved: function is_sku_resolved(item_type, quantity_obj) {
	      var resolved = false;
	      if (item_type == 'single_variant' || item_type == 'multi_variant') {
	        // Get values of variant options selected
	        var selected_arr = this.get_selected_array($('.varis option:selected'));
	        // Are any of the select options "unselected"?
	        var any_unselected = COSTCO.util.any(selected_arr, function (value) {
	          return value == 'unselected';
	        });
	        if (!any_unselected) resolved = true;
	      } else if (item_type == 'bundle') {
	        quantity_obj.product_indices.forEach(function (indice) {
	          var product_num = indice;
	          var productArray = products && products[product_num] ? products[product_num] : [];
	          var optionsSelected = this.get_selected_array($('.varis[data-product=' + product_num + ']').find('option:selected'));
	          var product_selected = this.findItem(productArray, optionsSelected);
	          if (product_selected) {
	            // If at least one product is resolved, we're good.
	            resolved = true;
	            return;
	          }
	        }.bind(this));
	      } else {
	        // We're a single item. We always resolve.
	        resolved = true;
	      }
	      return resolved;
	    },
	    /**
	     * Returns the option:selected ($options) values as an array of strings
	     * aka ['7000000000000053', '7000000000000623']
	     * @param  {[object]} $options - The jQuery selector representing option:selected
	     * @return {[array]} Returns an array of strings
	     */
	    get_selected_array: function get_selected_array($options) {
	      return $.map($options, function (option) {
	        return $(option).val();
	      });
	    },
	    maxQuantity: function maxQuantity() {
	      return COSTCO.util.isBusinessDelivery() ? COSTCO.Product.MAX_QUANTITY_BD : Number($('#cartTotalLimitBC').val());
	    },
	    /**
	     * Returns an object with two properties. The first property, 'valid',
	     * is set to true/false based on whether or not we have (at least one) valid
	     * quantity. The product_indices property correlates with bundles; specifically
	     * their 'data-product=' attributes and is used to validate skus in the next step
	     * of validation.
	     * @param  {[string]} item_type - string representing item type. Corresponds
	     * with phelper.item_type
	     * @param quantityId quantity input element reference
	     * @return {[object]} quantity_obj - The object containing valid quantity p
	     * property (and product_indicies in case of bundles)
	     */
	    is_valid_quantity: function is_valid_quantity(item_type, quantityId) {
	      var quantityStep = COSTCO.Product.getQuantityStep(quantityId);
	      var unitOfMeasure = COSTCO.Product.getUnitOfMeasure(quantityId);
	      var err_msgs = {
	        min: "<p class='sr-only'>" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_INVALID_QTY.replace("{0}", COSTCO.Product.getQuantityStep(quantityId, unitOfMeasure)),
	        max: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_HIGHER_QTY_2.replace("{0}", COSTCO.Product.maxQuantity()),
	        badQtyIncrement: "<p class='sr-only'>" + messages.ERROR + "</p>" + quantityId.data("error-message") + ' ' + COSTCO.Product.getQuantityStep(quantityId, unitOfMeasure)
	      };
	      var quantity_obj = {
	        valid: true,
	        message: err_msgs.min
	      };
	      var product_indices = [];
	      var maxQnty = COSTCO.Product.maxQuantity();
	      var bundleQuantity = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE == true ? 'input[name^=bundle-quantity-]' : 'input[name^=quantity-]';
	      if (item_type == 'bundle') {
	        // At least one quantity must be valid
	        $(bundleQuantity).each(function (i, input) {
	          var quantity_str = $(input).val();
	          var quantity_int = parseInt(quantity_str);
	          if (!COSTCO.Product.testInput(quantity_str, quantity_int, maxQnty, quantityStep)) {
	            product_indices.push($(input).data('product'));
	            $(input).attr('aria-invalid', 'false');
	          } else {
	            //set aria-invalid to reflect invalid entry
	            $(input).attr('aria-invalid', 'true');
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	              quantity_obj.valid = false;
	              if (quantity_int <= 0) {
	                quantity_obj.message = err_msgs.min;
	              }
	              if (quantity_int > maxQnty) {
	                quantity_obj.message = err_msgs.max;
	              }
	            }
	          }
	        });
	        if (product_indices.length == 0) {
	          quantity_obj.valid = false;
	        }
	      } else {
	        var quantity_str = $('input[name=quantity]').val();
	        var quantity_int = parseInt(quantity_str);
	        if (COSTCO.Product.testInput(quantity_str, quantity_int, maxQnty, quantityStep)) {
	          $('input[name=quantity]').attr('aria-invalid', 'true');
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            quantity_obj.valid = false;
	            $('input[name=quantity]').addClass('error-qty');
	            if (quantity_int <= 0) {
	              quantity_obj.message = err_msgs.min;
	            } else if (quantity_int > maxQnty) {
	              quantity_obj.message = err_msgs.max;
	            } else if (quantity_int % quantityStep != 0) {
	              quantity_obj.message = err_msgs.badQtyIncrement;
	            }
	          }
	        } else {
	          $('input[name=quantity]').attr('aria-invalid', 'false');
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            $('input[name=quantity]').removeClass('error-qty');
	          }
	        }
	      }
	      quantity_obj.product_indices = product_indices;
	      return quantity_obj;
	    },
	    /**
	     * Returns unit of measure of input quantity value (empty string if there is no unit of measure)
	     * @param quantityId quantity input element reference
	     * @return quantity value unit of measure
	     */
	    getUnitOfMeasure: function getUnitOfMeasure(quantityId) {
	      return quantityId.next('.unit').text();
	    },
	    /**
	     * Returns true if iput value is vlaid or false otherwise
	     * @param quantity_str quantity input value in form of string
	     * @param quantity_int quantity input value in form of integer
	     * @param maxQty maximum quantity input value
	     * @param increment increment/step of quantity input value
	     * @return true if iput value is vlaid or false otherwise
	     */
	    testInput: function testInput(quantity_str, quantity_int, maxQty, increment) {
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        return isNaN(quantity_int) || quantity_int <= 0 || quantity_int > maxQty || quantity_int.toString() != quantity_str || quantity_int % increment != 0;
	      } else {
	        return isNaN(quantity_int) || quantity_int <= 0 || quantity_int > maxQty || quantity_int.toString() != quantity_str;
	      }
	    },
	
	    backorder_modal: function backorder_modal(product) {
	      // The user must select "add to cart" in the backorder modal to switch this to true
	      var add_obj = {
	        isAdd: false
	      };
	      COSTCO.dialog.showModal({
	        title: messages.RWD_ITEM_BACKORDERED,
	        body: this.backorder_message(product),
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.ADDTOCART,
	        primary_event: function () {
	          // user selected "add to cart"
	          this.isAdd = true;
	          $('#costcoModal').modal('hide');
	        }.bind(add_obj),
	        afterclose: function () {
	          if (this.isAdd) {
	            // If primary event was selected, add to cart
	            $('#ProductForm').submit();
	          }
	          this.isAdd = false; // reset state
	        }.bind(add_obj)
	      });
	    },
	    backorder_message: function backorder_message(product) {
	      if (isBDApplication && isBDApplication === 'BC') {
	        var message = product.backorderMessage + ' ' + messages.BACKORDER_TEXT_ADD;
	        var locmessage = $('#backorder-message').text();
	        if (product.isLocInvItem || (typeof locmessage === "undefined" ? "undefined" : _typeof(locmessage)) !== undefined && null != locmessage) {
	          message = locmessage + ' ' + messages.BACKORDER_TEXT_ADD;
	        }
	        return message;
	      }
	      var message_key = 'BACKORDER_TEXT_',
	          message_num = product && product.message || '5',
	          date_1 = product && product.date || '',
	          date_2 = product && product.date2 || '';
	
	      if (product) {
	        if (product.allBackorderable == 0) {
	          message_key += 'PART_MSG';
	        } else {
	          message_key += 'MSG';
	        }
	        switch (message_num) {
	          case '1':
	            message_key += message_num;
	            break;
	          case '2':
	            message_key += message_num;
	            break;
	          case '3':
	            date_1 == date_2 ? message_key += 1 : message_key += message_num;
	            break;
	          case '4':
	            date_1 == date_2 ? message_key += 2 : message_key += message_num;
	            break;
	          default:
	            message_key += message_num;
	        }
	      } else {
	        message_key += 'MSG' + message_num;
	      }
	      return messages[message_key].replace('{0}', date_1).replace('{1}', date_2) + ' ' + messages.BACKORDER_TEXT_ADD;
	    },
	    /**
	     * Add to cart modal. Invoked after the "done" promise resolves
	     * when calling AddToCart.ajaxAddToCart.
	     * @param  {[array]} selected_products Array of objects representing
	     * the items that went into the cart
	     * @return {[void]}
	     */
	    added_modal: function added_modal(selected_products, orderItemId, qtyBought, originalQty) {
	      this.related_products_member_pricing();
	      $('.modal-footer').addClass('hide');
	      var items_html = "",
	          partsandservices = this.getPartsAndServices($('#configuredInfo').val()),
	          partsandservicesType = $('#configuredInfoType').val(),
	          service_html = "",
	          parts_html = "",
	          remark_html = "",
	          parts_and_services_html = "",
	          partandserviceArray = "";
	      if ($('#reactkitsandbundle').val() != 'true') {
	        var $related_products_template = $('#product-page .related-products');
	        $('#product-page .related-products').remove();
	      } else {
	        var selectedVirtualParentPartnumber = $('#productPartnumberVal').val();
	        $related_products_template = $('#product-page #RelatedProducts_' + selectedVirtualParentPartnumber);
	      }
	      var installationFlag = undefined;
	      if (partsandservices != "") {
	        var installationFlag = JSON.parse(partsandservices).installationAvailable;
	      }
	
	      //show if installation is not available
	      if (installationFlag != undefined && !installationFlag) {
	        remark_html += COSTCO.util.tmpl('tmpl_selected_delivery_parts_no_installation', {
	          remark: messages.SCHED_DELIV_NO_INSTALLATION_ALERT
	        });
	      }
	
	      //Parts and service section for Added to cart model box
	      if (partsandservicesType == 7) {
	        if (partsandservices != 'undefined' && partsandservices.length > 0 && partsandservices != "") {
	          partandserviceArray = JSON.parse(partsandservices).services;
	          if (partandserviceArray != 'undefined' && partandserviceArray != "" && partandserviceArray.length > 0) {
	            $.each(partandserviceArray, function (index, value) {
	              if (value.serviceType == 'Service') {
	                service_html += COSTCO.util.tmpl('tmpl_services', {
	                  description: value.description,
	                  selected: value.selected ? "Yes" : "No"
	                });
	              } else if (value.serviceType == 'Part') {
	                if (!value.hidden && value.selected && value.availabilityType != 'hidden') {
	                  parts_html += COSTCO.util.tmpl('tmpl_delivery_parts_service_list', {
	                    description: value.description
	                  });
	                } else if (!value.hidden && !value.selected && value.availabilityType != 'hidden') {
	                  parts_html += COSTCO.util.tmpl('tmpl_delivery_parts_service_list', {
	                    description: value.description + " : No"
	                  });
	                }
	              }
	            });
	
	            parts_and_services_html = COSTCO.util.tmpl('tmpl_parts_and_services_addedtocart', {
	              services: service_html,
	              parts: parts_html,
	              remarks: remark_html != "" ? remark_html : ""
	            });
	          }
	        }
	      }
	
	      selected_products.forEach(function (product, orderItemId) {
	        // this is for the added to cart review modal
	        var ecofeeIncludedPrice = (document.getElementById("ecoFeeHiddenLayout_" + product.catentry) || {}).value || "0";
	        items_html += COSTCO.util.tmpl(product.isFsaChdItem == 'true' ? 'tmpl_addtocart_item_FsaChd' : 'tmpl_addtocart_item', {
	          img_url: product.img_url ? product.img_url : product.parent_img_url,
	          item_name: product.productName,
	          item_url: product.productUrl,
	          item_number: product.item_number,
	          model_number: product.manufacturerPartNumber,
	          price: ecofeeIncludedPrice != "0" ? ecofeeIncludedPrice : product.final_price,
	          quantity: product.quantity,
	          orderItemId: orderItemId,
	          parts_and_services_html: parts_and_services_html != "" ? parts_and_services_html : "",
	          linkFee: COSTCO.Product.displayLinkFee(product.feeOptions)
	        });
	      });
	
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.RELATED_PRODUCT_ADDED_TO_CART,
	        dialogclasses: 'medium',
	        body: COSTCO.util.tmpl('tmpl_addtocart_modal', {
	          items: items_html,
	          related_products: $related_products_template.length > 0 ? $related_products_template[0].outerHTML : ''
	        }),
	        onclose: function onclose() {
	          //COSTCO.Header.refreshMiniBanner();
	          $('.modal-footer').removeClass('hide');
	          if ($related_products_template.length > 0) {
	            $('#product-page').append($related_products_template[0].outerHTML);
	          }
	          window.wioEventBus.publish('focusPickUpButton', { focusPickUpButton: true });
	        }
	      });
	      $('input[name="parentOrderItemId"]').val(orderItemId);
	      $('input[name="relatedQty"]').val(originalQty);
	      console.log("Related Quantity Incoming :: " + originalQty + " :: Document source " + $('input[name="relatedQty"]').val());
	      if ($('#related-products-container:not(.hide)').find('div[name="RelatedProductFormDiv"]:not(.hide)').length > 0) {
	        $('.modal-body .related-products').removeClass('hide');
	
	        if (relProductLinkFee !== undefined && relProductLinkFee != null) {
	          Object.entries(relProductLinkFee).forEach(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                key = _ref2[0],
	                value = _ref2[1];
	
	            if ($('#relLinkFee_' + key).length > 0) {
	              $('#relLinkFee_' + key).html(COSTCO.Product.displayLinkFee(value));
	            }
	          });
	        }
	      }
	      $('.co-help.eco-fee').popover();
	    },
	    /**
	     * If a related product is a member only item, show pricing based on member cookie.
	     * @return {[void]}
	     */
	    related_products_member_pricing: function related_products_member_pricing() {
	      var userInfo = COSTCO.util.getMemberCookie(),
	          signedIn = userInfo.signedIn,
	          costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
	          validated = userInfo.validated != 'undefined' ? userInfo.validated : false;
	      active = userInfo.active != 'undefined' ? userInfo.active : false;
	      // This check is added to keep BD flow unaffected by the change in BC flow
	      var showPricingForMember = COSTCO.util.isBusinessDelivery() ? costcoMember : costcoMember && validated && active;
	      if (!signedIn) {
	        $('.sign-in').show();
	        $('.price-details.moi,.productFormContent.moi-atcf,.mem-button.moi').hide();
	      } else {
	        if (showPricingForMember) {
	          $('.sign-in, .mem-button').hide();
	        } else {
	          $('.price-details.moi,.productFormContent.moi-atcf,.sign-in').hide();
	        }
	      }
	    },
	
	    displayLinkFee: function displayLinkFee(feeOptions) {
	      var _this2 = this;
	
	      var linkFeeContenty = '';
	      if (feeOptions !== 'undefined' && feeOptions != null) {
	        var feesConfiguration;
	        var i;
	
	        (function () {
	          var region = $.cookie('C_LOC');
	          feesConfiguration = typeof feesConfigurations !== 'undefined' ? feesConfigurations : null;
	
	          if (feesConfiguration !== 'undefined' && feesConfiguration != null) {
	            var regionalFeeConfig = feesConfiguration[region] || feesConfiguration["ALL"];
	            if (regionalFeeConfig !== undefined && regionalFeeConfig != null) {
	              var _loop = function _loop() {
	                var feeCatConfig = regionalFeeConfig[i];
	                var feeTypeLis = feeCatConfig.feeType.split(',');
	                var categoryWiseFeeOpt = feeOptions.filter(function (fee) {
	                  return fee.region == region && fee.feeCategory == feeCatConfig.feeCategory;
	                });
	                if (categoryWiseFeeOpt !== undefined && categoryWiseFeeOpt != null) {
	                  var hasHybridFee = categoryWiseFeeOpt.some(function (fee) {
	                    return feeTypeLis[0] != 'ALL' && !feeTypeLis.includes(fee.feeType);
	                  });
	                  var isRegionFee = categoryWiseFeeOpt.some(function (fee) {
	                    return feeTypeLis[0] != 'ALL' && feeTypeLis.includes(fee.feeType);
	                  });
	                  var feeCategory = '',
	                      display = '',
	                      feeDesc = '';
	                  var feeAmount = 0,
	                      sameFeeCategoryCount = 0;
	                  var _iteratorNormalCompletion2 = true;
	                  var _didIteratorError2 = false;
	                  var _iteratorError2 = undefined;
	
	                  try {
	                    for (var _iterator2 = categoryWiseFeeOpt[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                      var feeOption = _step2.value;
	
	                      if (feeOption.feeCategory === feeCatConfig.feeCategory) {
	                        if (feeTypeLis.includes(feeOption.feeType) || feeCatConfig.feeType === "ALL" || hasHybridFee && !isRegionFee) {
	                          sameFeeCategoryCount++;
	                          if (!hasHybridFee || hasHybridFee && !isRegionFee) {
	                            feeAmount += parseFloat(feeOption.price);
	                          }
	                          feeCategory = feeOption.feeCategory;
	                          display = hasHybridFee ? 'STANDARD' : feeCatConfig.display.Browse;
	                          feeDesc = COSTCO.util.sentenceToPascalCase(feeOption.desc.trim());
	                        } else if (hasHybridFee) {
	                          feeAmount += parseFloat(feeOption.price);
	                        }
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                      }
	                    } finally {
	                      if (_didIteratorError2) {
	                        throw _iteratorError2;
	                      }
	                    }
	                  }
	
	                  if (sameFeeCategoryCount > 0) {
	                    linkFeeContenty += COSTCO.util.tmpl('tmpl_addtocart_linkFee_display', {
	                      "feeCategory": feeCategory,
	                      "display": display,
	                      "fee": feeAmount > 0 ? _this2.formatMoney(_this2.processPrice(feeAmount), true) : '',
	                      "feeDesc": feeDesc,
	                      "ecoFeeToolTipContent": ecoFeeToolTipContent
	                    });
	                  }
	                }
	              };
	
	              for (i = 0; i < regionalFeeConfig.length; i++) {
	                _loop();
	              }
	            }
	          }
	        })();
	      }
	      return linkFeeContenty;
	    },
	
	    /**
	     * Gets an array of item objects that are selected on the page with positive quantity
	     * @return {[array]} an array of item objects
	     */
	    getSelectedBundleAndVariantItems: function getSelectedBundleAndVariantItems() {
	      var selectedItems = [];
	      $('.variantContainer').each(function (index) {
	        var qty = $('input[name=quantity]').val(); //for non-bundle
	        var bundleQty = $(this).find('input[name^=quantity-]').val(); //for bundle
	        if (qty > 0 || bundleQty > 0) {
	          if ($(this).find('.swatchDropdown').length > 0) {
	            //variant
	            var options = [];
	            $(this).find('.varis :selected').each(function () {
	              options.push($(this).val());
	            });
	            selectedItems.push(COSTCO.Product.findItem(products[index], options));
	          } else {
	            //not a variant
	            selectedItems.push(products[index][0]);
	          }
	        }
	      });
	      return selectedItems;
	    },
	    /**
	     * Shows plain packaging option on variant selection and/or bundle quantity change
	     * based on plainPackaging property of selected item(s) on the page. Immediately
	     * shows plain packaging option for a single item page.
	     * @return {[void]}
	     */
	    enablePlainPackagingMessage: function enablePlainPackagingMessage() {
	      //shows or hides plain packaging message based on given option
	      function showHideMessage(ppOption) {
	        //for bundles and variants ppOption will be array.
	        //call the function again based on what's in the array.
	        if ($.isArray(ppOption)) {
	          if ($.inArray("0", ppOption) > -1) {
	            showHideMessage("0");
	          } else if ($.inArray("1", ppOption) > -1) {
	            showHideMessage("1");
	          } else if ($.inArray("3", ppOption) > -1) {
	            showHideMessage("3");
	          } else {
	            showHideMessage(null);
	          }
	          return;
	        }
	        if (ppOption == "1") {
	          //available
	          $("#plain-packaging-available").show();
	          $("#plain-packaging-not-available").hide();
	          $("#plain-packaging-mandatory").hide();
	        } else if (ppOption == "0") {
	          //not available
	          $("#plain-packaging-available").hide();
	          $("#plain-packaging-not-available").show();
	          $("#plain-packaging-mandatory").hide();
	        } else if (ppOption == "3") {
	          //mandatory plain packaging option
	          $("#plain-packaging-available").hide();
	          $("#plain-packaging-not-available").hide();
	          $("#plain-packaging-mandatory").show();
	        } else {
	          //don't show a message. This will be a value of null for item's plainPackaging property
	          $("#plain-packaging-available").hide();
	          $("#plain-packaging-not-available").hide();
	          $("#plain-packaging-mandatory").hide();
	        }
	      }
	
	      //returns an array of plainPackaging properties of the given items
	      function getPPOptions(items) {
	        var ppOptions = [];
	        $(items).each(function () {
	          ppOptions.push(this.plainPackaging);
	        });
	
	        return ppOptions;
	      }
	
	      if (typeof products == 'undefined') {
	        return;
	      }
	      if (COSTCO.Product.isSingleItem(products)) {
	        showHideMessage(products[0][0].plainPackaging);
	      } else {
	        //bind change event on variant selection and quantity change
	        $('.variantContainer').on('change', '.swatchDropdown:last, input[name^=quantity]', function () {
	          var selectedItems = COSTCO.Product.getSelectedBundleAndVariantItems();
	          showHideMessage(getPPOptions(selectedItems));
	        });
	      }
	    },
	
	    addToWishList: function addToWishList(baseURL) {
	      if ($('#ProductForm').valid()) {
	        var target = baseURL + '&catentryId=' + $('#ProductForm .catentryInput').map(function () {
	          return $(this).val();
	        }).get().join(',');
	        window.location = target;
	      }
	    },
	
	    openWishListSuccess: function openWishListSuccess() {
	      var queryString = COSTCO.util.getQueryStringArray();
	      if (queryString['addToWishlistSuccessMessageKey']) {
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.RWD_WISH_LIST_CONFIRM_TITLE,
	          body: messages.WISHLIST_ITEM_ADD_CONFIRMATION_MESSAGE,
	          primary: messages.RWD_VIEW_WISH_LIST,
	          primary_event: function primary_event() {
	            window.location = '/NonAjaxAccountWishListDisplayView?listId=.';
	          },
	          secondary: messages.CONTINUE_SHOPPING
	        });
	      }
	    },
	    /**
	     * Select options modal for GE. Invoked after the "done" promise resolves
	     * @param data = Parts and Services JSON
	     * @return {[void]}
	     */
	    show_options_modal: function show_options_modal(data) {
	      var locale = COSTCO.util.getLocale();
	      var selected_product = undefined;
	      if (this.isSingleItem(products)) selected_product = this.findItem(products[0], []);else selected_product = this.getSelectedBundleAndVariantItems()[0];
	
	      selected_product.quantity = messages.RWD_QUANTITY + ' ' + $('input[name=quantity]').val();
	      selected_product.item_number = $('span.item-number').text();
	      selected_product.final_price = (locale == 'en-US' || locale == 'en-CA' ? ' $' : '') + $('.your-price .value').text() + (locale == 'fr-CA' ? ' $' : '');
	
	      this.related_products_member_pricing();
	      $('.modal-footer').addClass('hide');
	      var items_html = "",
	          $related_products_template = $('#product-page .related-products');
	      $('#product-page .related-products').remove();
	
	      //call function to create parts and services form
	      var options_htmls = COSTCO.ScheduledDeliverable.create_parts_and_services_list(data);
	
	      partsservices_html = options_htmls['partsservices_html'];
	      remark_html = options_htmls['remark_html'];
	
	      items_html += COSTCO.util.tmpl('tmpl_selected_delivery_Item', {
	        img_url: selected_product.img_url ? selected_product.img_url : selected_product.parent_img_url,
	        item_name: selected_product.productName,
	        item_url: selected_product.productUrl,
	        item_number: selected_product.item_number,
	        price: selected_product.final_price,
	        quantity: selected_product.quantity,
	        partsservices: partsservices_html,
	        remarksContainer: remark_html,
	        model_number: null
	      });
	
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.SCHED_DELIV_SELECT_OPTIONS_HEADING,
	        body: COSTCO.util.tmpl('tmpl_select_options_modal', {
	          items: items_html,
	          related_products: $related_products_template.length > 0 ? $related_products_template[0].outerHTML : ''
	        }),
	        onclose: function onclose() {
	          $('.modal-footer').removeClass('hide');
	          if ($related_products_template.length > 0) {
	            $('#product-page').append($related_products_template[0].outerHTML);
	          }
	        }
	      });
	      $('.modal-body .related-products').removeClass('hide');
	    },
	    /**
	     * this function is to prevent rich media from injecting swatches
	     * onto our page when product has no buyable items or is out of stock.
	     * We don't include theSwatches div in these cases on the jsp so we add
	     * it here.
	     */
	    injectHiddenSwatchesDiv: function injectHiddenSwatchesDiv() {
	      if ($('#theSwatches').length == 0) {
	        $('<div id="theSwatches" class="hide"></div>').appendTo('#zoomViewer');
	      }
	    },
	    /**
	     * Function used to check if any modifications have been appended
	     * to the product details accordion
	     */
	
	    startMutationObserver: function startMutationObserver() {
	      //STRY0141473 - fire showViewMore() anyway if none of the mutations occur
	      COSTCO.Product.showViewMore(observerObject);
	
	      var targetObject = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? $('#product-info')[0] : $('#accordion-product-details')[0];
	      try {
	        if (!$('#CostcoBVContainer').length > 0) {
	          var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("attributes" === mutation.type) {
	                COSTCO.Product.showViewMore(observerObject);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          observerObject.observe(targetObject, {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	
	          //INC3616033 add a seperate mutationObserver for product-info-description
	          var prodInfoObserverObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("attributes" === mutation.type || "childList" === mutation.type) {
	                COSTCO.Product.showViewMore(prodInfoObserverObject);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          prodInfoObserverObject.observe($('.product-info-description')[0], {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	        } else {
	          // Observe Reviews section on PDP
	          var observerObjectReview = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("childList" === mutation.type && ($(mutation.target).find('#bv_review_maincontainer').length > 0 || $(mutation.target).find('.bv-content-list-container').length > 0)) {
	                COSTCO.Product.showViewMore(observerObjectReview);
	
	                if (isBVv2Enabled === 'false') {
	                  // Auto popup BV Write a Review for relogin user
	                  // bveventid is appended to logonform by BV when not logged in user tries WAR
	                  var bveventid = COSTCO.util.getParameterByName('bveventid');
	                  var summaryWAR = $('#WAR');
	                  if (bveventid !== null && summaryWAR.length > 0) {
	                    summaryWAR.trigger('click');
	                  }
	                }
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          observerObjectReview.observe(targetObject, {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	
	          //INC3616033 add a seperate mutationObserver for product-info-description
	          var prodInfoObserverObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("attributes" === mutation.type || "childList" === mutation.type) {
	                COSTCO.Product.showViewMore(prodInfoObserverObject);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          prodInfoObserverObject.observe($('.product-info-description')[0], {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	        }
	        //If < IE 10 then display the product details in its entirety
	      } catch (e) {
	        COSTCO.Product.view_more(this);
	        return;
	      }
	    },
	
	    /**
	     * Function used to show the View More Details button
	     * depend on the the height of the product info content.
	     */
	    showViewMore: function showViewMore(observer) {
	      var integrationContentIds = ['#wc-power-page', '#wc-pp', '#SP_ProductImage', '#wc-button', '#easy2-demo', '#ccslogos', '#inline_showcase', '#flix-minisite', '#flix-inpage'];
	      var doesnIntegrationIdExists = false;
	      for (var i = 0; i < integrationContentIds.length; i++) {
	        if ($(integrationContentIds[i]).length > 0) {
	          doesnIntegrationIdExists = true;
	          break;
	        }
	      }
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        $('.product-info-description').each(function (index) {
	          var height = $(this).prop('scrollHeight');
	          var productType = $('#product-info').data('product');
	          var screenSize = screen.width;
	
	          //for BD specific, we do want to show the product info in its entirety for tobacco product
	          if ((height > 600 || index == 0 && doesnIntegrationIdExists) && productType !== 'tobacco') {
	            $(this).next().removeClass("hide");
	            if (observer) {
	              observer.disconnect();
	            }
	          }
	        });
	      } else {
	        var height = $('.product-info-description').prop('scrollHeight');
	        var productType = $('#product-info').data('product');
	        var screenSize = screen.width;
	        //need to take into account the height of the product manual
	        var $productManual = $('.product-info-description').find('.product-manuals');
	        //if item has product manual and it is view on screen larger than 768
	        //product manual should be taken into account because it would be hidden
	        if ($productManual.length && screenSize > 768) {
	          var productManualHeight = $productManual.prop('scrollHeight');
	          //if product manual is hidden in case of large display, do not count its height
	          height = height - productManualHeight;
	        }
	
	        //for BD specific, we do want to show the product info in its entirety for tobacco product
	        if ((height > 600 || doesnIntegrationIdExists) && productType !== 'tobacco') {
	          $('.view-more').removeClass("hide");
	          if (observer) {
	            observer.disconnect();
	          }
	        } else {
	          if (!$('.view-more').hasClass('hide')) {
	            $('.view-more').addClass('hide');
	          }
	        }
	      }
	    },
	    getPartsAndServices: function getPartsAndServices(data) {
	      var configuredInfoArray = [];
	      var showablePartsAndServices = [];
	
	      if (data && data.length > 0) {
	        configuredInfoArray = JSON.parse(data);
	
	        //determine which GE dishwasher parts are not to be displayed
	        if (configuredInfoArray.services.length > 0) {
	          $.each(configuredInfoArray.services, function (index, value) {
	            if (!(value.groupId == 1 && value.serviceType.toUpperCase() == 'PART' && value.dependent_service_ids.length > 0) && !(value.groupId == 1 && value.serviceType.toUpperCase() == 'PART' && value.selected == false)) {
	              showablePartsAndServices.push(value);
	            }
	          });
	          if (showablePartsAndServices.length > 0) {
	            configuredInfoArray.services = showablePartsAndServices.slice(0);
	          }
	          data = JSON.stringify(configuredInfoArray);
	        }
	      }
	
	      return data;
	    },
	
	    showReplacementProductModal: function showReplacementProductModal(partNumber) {
	      var $relatedProducts = partNumber ? $('#RelatedProducts_' + partNumber) : $('.related-products');
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.TEMP_REPLACED_ITEM_MODAL_TITLE,
	        dialogclasses: 'medium',
	        onshow: function onshow() {
	          if (window.checkoutPage) {
	            $('#costcoModal .close').hide();
	          }
	        },
	        preventClose: window.checkoutPage ? true : false,
	        body: COSTCO.util.tmpl('tmpl_related_products', {
	          related_products: $relatedProducts.html()
	        })
	      });
	    },
	    /**
	     * Triggers click event, binded to social images, by pressing Enter key
	     * @return {[void]}
	     */
	    makeSocialIconsAdaCompliant: function makeSocialIconsAdaCompliant() {
	      $(".social.list-inline.social-icons img").each(function () {
	        $(this).on('keydown', function (event) {
	          if (event.which === 13) {
	            $(this).click();
	          }
	        });
	      });
	    },
	
	    showSuccessMessage: function showSuccessMessage(message) {
	      var messsages_html = '';
	      messsages_html += COSTCO.util.tmpl('tmpl_succes_notification', { message: message });
	      $('#message-area').html(messsages_html);
	    },
	    /**
	     * Changes the quantity displayed in input element on plus/minus click
	     * @param element element user clicked on (plus or minus button)
	     * @return void
	     */
	    changeQuantityValue: function changeQuantityValue(element) {
	      var $inputElement = $('[name=quantity]');
	      var qtyValue = parseInt($inputElement.val());
	      if (!qtyValue && qtyValue != 0) {
	        qtyValue = 0;
	      } else {
	        var quantityStep = COSTCO.Product.getQuantityStep($inputElement);
	        var isIncrement = undefined;
	        if ($(element).attr('name') === 'plusQty') {
	          isIncrement = true;
	          var maxQnty = COSTCO.Product.maxQuantity();
	          qtyValue += quantityStep;
	          var residual = qtyValue % quantityStep;
	          qtyValue = qtyValue - residual;
	        } else if ($(element).attr('name') === 'minusQty') {
	          isIncrement = false;
	          var _residual = qtyValue % quantityStep;
	          if (_residual == 0) {
	            qtyValue -= quantityStep;
	          } else {
	            qtyValue -= _residual;
	          }
	        } else if (qtyValue == 0) {
	          isIncrement = false;
	        }
	
	        $inputElement.val(qtyValue);
	
	        COSTCO.Product.validateQuantityValue($inputElement, '.product-error', 'span');
	        COSTCO.Product.expendErrorOnQtyUnit($inputElement, 'span');
	        COSTCO.Product.discardInvalidQtyValues(qtyValue, $inputElement, isIncrement);
	      }
	      COSTCO.util.announceSRMessage("Quantity " + qtyValue);
	    },
	    ChangeQuantityField: function ChangeQuantityField(element) {
	      var $inputElement = $('[name=quantity]');
	      var qtyValue = parseInt($inputElement.val());
	      COSTCO.Product.validateQuantityValue($inputElement, '.product-error', 'span');
	      if (qtyValue == 0) {
	        $inputElement.val(1);
	      }
	      COSTCO.util.announceSRMessage("Quantity " + qtyValue);
	    },
	    /** /reset error class if it is applyed/reseted on quanty value itself
	     * @param quantityId quantity value element reference
	     * @param nextElement element behind input
	     */
	    expendErrorOnQtyUnit: function expendErrorOnQtyUnit(quantityId, nextElement) {
	      if (COSTCO.util.isPDPCartCheckoutEnabled()) {
	        var inputError = COSTCO.Product.getErrorArea(quantityId, nextElement);
	        if (inputError !== quantityId) {
	          var inputParent = quantityId.parent();
	          var hasError = quantityId.hasClass('error');
	          if (hasError) {
	            inputParent.addClass('error');
	          } else {
	            inputParent.removeClass('error');
	          }
	        }
	      }
	    },
	    /**
	    * Get quantity step (which is also treated as minimal quantity value as well) plust (optional) unit of measure
	    * @param quantityId quantity value element reference
	    * @param unitOfMeasure unit of measure
	    * @return quantity step (min quantity value)
	    */
	    getQuantityStep: function getQuantityStep(quantityId, unitOfMeasure) {
	      var stepIncrement = quantityId.attr('data-quantity-increment') ? parseInt(quantityId.attr('data-quantity-increment')) : 1;
	      if (typeof unitOfMeasure === "undefined") {
	        return stepIncrement;
	      } else return stepIncrement + " " + unitOfMeasure;
	    },
	    /**
	     * Discard invalid quantity values
	     * @param value current value in quantity input element
	     * @param quantityId quantity input element reference
	     * @param isIncrement undefined value means value is entered not incremented/decremented
	     * @return void
	     */
	    discardInvalidQtyValues: function discardInvalidQtyValues(value, quantityId, isIncrement) {
	      var quantityStep = COSTCO.Product.getQuantityStep(quantityId);
	      if (isIncrement != undefined && value <= 0) {
	        quantityId.val(quantityStep);
	      }
	      var max = COSTCO.Product.maxQuantity();
	      if (value > max) {
	        var remainder = max % quantityStep;
	        quantityId.val(max - remainder);
	      }
	    },
	
	    /**
	     * Test validity of quantity value and applay result.
	     * @param quantityId quantity input element reference
	     * @param errorSelector elements, classes and IDs
	     * @param nextElement if next element is label or span (they contain unit of measure) then error area is bigger then just input field
	     * @return void
	     */
	    validateQuantityValue: function validateQuantityValue(quantityId, errorSelector, nextElement) {
	      if (COSTCO.util.isPDPCartCheckoutEnabled()) {
	        var quantity_obj = COSTCO.Product.is_valid_quantity(COSTCO.Product.item_type, quantityId);
	        var $product_error = $(errorSelector);
	        var inputError = COSTCO.Product.getErrorArea(quantityId, nextElement);
	        // Check if we have a valid quantity
	        if (!quantity_obj.valid) {
	          $product_error.html(quantity_obj.message);
	          inputError.addClass('error');
	          if (quantityId !== inputError) {
	            quantityId.addClass('error');
	          }
	        } else {
	          $product_error.empty();
	          inputError.removeClass('error');
	          if (quantityId !== inputError) {
	            quantityId.removeClass('error');
	          }
	        }
	      }
	    },
	    /**
	     * Find HTML element on which error class should be applyed.
	     * @param quantityId quantity input element reference
	     * @param qtyUnitElement possible next element with quantity unit
	     * @return void
	     */
	    getErrorArea: function getErrorArea(quantityId, qtyUnitElement) {
	      var errObj = quantityId;
	      if (COSTCO.util.isPDPCartCheckoutEnabled() && qtyUnitElement) {
	        var nextElement = quantityId.next();
	        if (nextElement.is(qtyUnitElement)) {
	          errObj = quantityId.parent();
	        }
	      }
	      return errObj;
	    },
	    /**
	        * Shows the sticky element on tablet/desktop view and makes sticky element for mobile view for BC and BD
	        * @return void
	        */
	    pdpMakeElementSticky: function pdpMakeElementSticky() {
	      var userInfo = COSTCO.util.getMemberCookie();
	      var signedIn = userInfo.signedIn;
	      var costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false;
	      var validated = userInfo.validated;
	      var verified = userInfo.verified;
	      var memberActive = userInfo.active;
	      var $qtyInput = $('#qty-input');
	      var isBundle = COSTCO.Product.item_type == 'bundle';
	      var isTwoDayDeliveryZipIn = ($('.two-day-delivery').length > 0 || $('.frozen-foods-badge').length > 0) && COSTCO.Header.hasInvPostalCodeCookie();
	      var $addButtonContainer = $('input[name="isOOSItem"]').length > 0 ? $('.notify-me-btn-area') : $('#ctas ul'); //notify-me-btn-area
	      var $isAppliance = $('#productCategory').val() === messages.APPLIANCES && ($('#submit-delivery-area').length > 0 || $('#edd-check-button').length > 0);
	      var $addButtonGroup = void 0;
	
	      if ($isAppliance || COSTCO.CMath.iskitsbundle) {
	        if ($('#edd-check-button').is(':visible') && !COSTCO.CMath.iskitsbundle) {
	          $addButtonGroup = $('#check-availability-sticky');
	          $('#sticky-price').hide();
	          $('#sticky-qty').hide();
	        } else if ($('#add-to-cart').is(':visible')) {
	          $addButtonGroup = $('#add-to-cart');
	          $('#sticky-price').show();
	          $('#sticky-qty').show();
	        } else if (COSTCO.CMath.iskitsbundle && $('#bundle-button').is(':visible')) {
	          $('#sticky-price').show();
	          $('#sticky-qty').hide();
	          $('#bundle-button-container').append($('#bundle-button'));
	          $addButtonGroup = $('#bundle-button-container');
	        } else if ($('#renew-membership-for-price').is(':visible')) {
	          $addButtonGroup = $('#renew-membership-for-price');
	          $('#sticky-price').hide();
	          $('#sticky-qty').hide();
	        } else {
	          if (!signedIn) {
	            if ($('#mapItem').val() == "true") {
	              $addButtonGroup = $('#sign-in-to-buy');
	            } else {
	              $addButtonGroup = $('#sign-in-to-buy-button-v2');
	            }
	          } else {
	            if (!costcoMember) {
	              $addButtonGroup = $('#link-membership-for-price');
	            }
	          }
	        }
	      } else if ($('input[name="isOOSItem"]').length > 0) {
	        $addButtonGroup = $addButtonContainer.find('input');
	      } else {
	        $addButtonGroup = $addButtonContainer.children().not('#qty-input');
	      }
	      var $detailsBazaarVoice = $('#details-bazaar-voice');
	      var $price = $('#pull-right-price');
	      var $clonedPrice = $price.clone();
	      var $hiddenSticky = $('#hidden-sticky');
	      var $stickyAddBtn = $('#sticky-add-btn');
	      var isHidden = true;
	      var isSticky = false;
	      var topOfBottomContent = void 0;
	      var topOfWindow = void 0;
	      var bottomOfWindow = void 0;
	      $('#pdp-sticky-desktop .tablist').hide();
	
	      var showStickyElementForDesktopAndTablet = function showStickyElementForDesktopAndTablet() {
	        if (topOfWindow < topOfBottomContent && isHidden == false) {
	          if (isBundle) {
	            if ($('#addBundleBtn').attr('disabled')) {
	              $('#sticky-price').empty();
	              $('#bundle-button-container').append($('#bundle-button'));
	            } else {
	              $('#sticky-price').empty();
	              $('#bundle-items-container').append($('#addBundleBtn'));
	            }
	          } else {
	            $addButtonContainer.prepend($addButtonGroup);
	            $addButtonContainer.prepend($qtyInput);
	            $addButtonContainer.prepend($('#sticky-add-btn li'));
	            //2 day delivery not zipped in
	            $('#postal-popup-form-inline').append($('#postal-code-submit-btn'));
	          }
	          if (isBDApplication && isBDApplication === 'BD') {
	            $('#delivery-zipcode-form .get-zip-code-form').append($('#formProductDetails'));
	            $('#formProductDetails .outline').removeClass('hide');
	            $('#formProductDetails').validate();
	          }
	          $('#sticky-qty #minQtyText').off();
	          $('#bazaar-container').append($detailsBazaarVoice);
	          $('.math-table .your-price').append($price);
	          $('#check-availability-sticky').hide();
	          $hiddenSticky.hide(500);
	          isHidden = true;
	          $('#pdp-sticky-desktop .tablist').hide();
	        } else if (topOfWindow >= topOfBottomContent + 10 && isHidden == true) {
	
	          var selected_product = undefined;
	          if (COSTCO.Product.isSingleItem(products)) selected_product = COSTCO.Product.findItem(products[0], []);else selected_product = COSTCO.Product.getSelectedBundleAndVariantItems()[0];
	
	          var stickyImageUrl = typeof selected_product === 'undefined' ? products[0][0].img_url ? products[0][0].img_url : products[0][0].parent_img_url : selected_product.img_url ? selected_product.img_url : selected_product.parent_img_url;
	          $('#initialProductImageSticky').attr('src', stickyImageUrl);
	
	          $('#sticky-qty').append($qtyInput);
	          if (isBundle) {
	            $stickyAddBtn.append($('#addBundleBtn').attr('disabled') ? $('#bundle-button') : $('#addBundleBtn'));
	          } else {
	            // If item is OOS, set variables again beacause of updated content after Ajax call
	            if ($('input[name="isOOSItem"]').length > 0) {
	              $addButtonContainer = $('input[name="isOOSItem"]').length > 0 ? $('.notify-me-btn-area') : $('#ctas ul');
	              $addButtonGroup = $isAppliance ? $('#check-availability-sticky') : $('input[name="isOOSItem"]').length > 0 ? $addButtonContainer.find('input') : $addButtonContainer.children().not('#qty-input');
	            }
	            $('#check-availability-sticky').show();
	            $stickyAddBtn.append($addButtonGroup);
	            $stickyAddBtn.append($('#ctas ul li'));
	            //2 day delivery not zipped in
	            if (!isTwoDayDeliveryZipIn || $('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) {
	              $stickyAddBtn.on('click', function (event) {
	                event.preventDefault();
	                $(window).scrollTop(0);
	              });
	            }
	          }
	          if (isBDApplication && isBDApplication === 'BD' && !$('#bdZipCookie').val().length > 0) {
	            $stickyAddBtn.append($('#formProductDetails'));
	            $('#formProductDetails .outline').addClass('hide');
	            $stickyAddBtn.on('click', function (event) {
	              event.preventDefault();
	              $(window).scrollTop(0);
	              $('#formProductDetails').validate();
	              $('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').rules('add', {
	                required: true,
	                'countryspecificpostalcode': true,
	                messages: {
	                  required: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER,
	                  countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER
	                }
	              });
	            });
	          }
	          $('#sticky-qty #minQtyText').on('keypress', function (event) {
	            COSTCO.Product.ChangeQuantityField($('#sticky-qty #minQtyText'));
	            if (event.keyCode === 13) {
	              console.log('test event');
	              $('#add-to-cart-btn').click();
	            }
	          });
	          $('#sticky-bazaar').append($detailsBazaarVoice);
	          if (isBundle) {
	            $clonedPrice = $price.clone();
	            $('#sticky-price').append($clonedPrice);
	            var $isChecked = $('[id^="checkbox-bundle-"]').is(':checked');
	            $isChecked ? $('#sticky-price').show() : $('#sticky-price').hide();
	            $isChecked ? $('.product-numbers').show() : $('.product-numbers').hide();
	          } else if (isTwoDayDeliveryZipIn && !(($('.two-day-delivery').length > 0 || $('.frozen-foods-badge').length > 0) && $price.text().includes("- -.- -")) || $('.two-day-delivery').length === 0 && $('.frozen-foods-badge').length === 0 && $price.is(':visible')) {
	            $('#sticky-price').append($price);
	            $('.product-numbers').hide();
	          } else {
	            $('.product-numbers').show();
	          }
	          $hiddenSticky.show(500);
	          $hiddenSticky.css('display', 'flex');
	          isHidden = false;
	          $('#pdp-sticky-desktop .tablist').show();
	        }
	        $('#sticky').css('width', $('#product_tabs').width());
	      };
	
	      var makeElementStickyForMobile = function makeElementStickyForMobile() {
	        var $isChecked = $('[id^="checkbox-bundle-"]').is(':checked');
	        var $stickyContent = $isChecked ? $('#bundle-items-container') : $('#build-bundle-sticky');
	        var $addButtonContainer = isBundle ? $stickyContent : $('input[name="isOOSItem"]').length > 0 ? $('.notify-me-btn-area') : $('#ctas ul');
	        var $isWarningMsg = $("#prod-page-delivery").length > 0 && !$("#prod-page-delivery").hasClass('hide') || $("#edd-form-block").length > 0 && !$("#edd-form-block").hasClass('hide') || $("#edd-message-block .warning").length > $("#edd-message-block .warning.hide").length || $("#deliveryFailMessage").length > 0 && !$("#deliveryFailMessage").hasClass('hide');
	        var $appContent = $isWarningMsg ? $('#check-availability-sticky') : $('input[name="isOOSItem"]').length > 0 ? $addButtonContainer.find('input') : $addButtonContainer;
	        if ($('#ctas').val() !== undefined) {
	          var $buildABundle = $('#build-a-bundle');
	          var bottomOfElement = void 0;
	          $('#mobile-bazaar').append($detailsBazaarVoice);
	          if ($('input[name="isOOSItem"]').length > 0) {
	            bottomOfElement = isBundle ? $buildABundle.offset().top + $buildABundle.outerHeight() : $('.notify-me-body').offset().top + $('.notify-me-body').outerHeight();
	          } else {
	            bottomOfElement = isBundle ? $buildABundle.offset().top + $buildABundle.outerHeight() : $('#ctas').offset().top + $('#ctas').outerHeight();
	          }
	          if (topOfWindow < bottomOfElement && isSticky == true) {
	            $('#build-bundle-sticky').attr("hidden", true);
	            $('#check-availability-sticky').attr("hidden", true);
	            $addButtonContainer = isBundle ? $stickyContent : $('input[name="isOOSItem"]').length > 0 ? $('#pdp-sticky-mobile') : $('#pdp-sticky-mobile ul');
	            $appContent = $isWarningMsg ? $('#check-availability-sticky') : $('input[name="isOOSItem"]').length > 0 ? $addButtonContainer.find('input') : $addButtonContainer;
	            $appContent.children('#product-social-print-mobile').length > 0 && $appContent.children('#product-social-print-mobile').removeClass('hide');
	            if (isBundle) {
	              $('#bundle-container').prepend($appContent);
	              $('#bundle-accordion-collapse').removeClass('collapse');
	              $('#bundle-accordion-collapse').css('height', '');
	            } else {
	              if ($('input[name="isOOSItem"]').length > 0) {
	                $('.notify-me-btn-area').prepend($appContent);
	              } else {
	                $('#ctas').prepend($appContent);
	              }
	            }
	            //2 day delivery not zipped in
	            if (!isTwoDayDeliveryZipIn || $('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) {
	              $('#postal-popup-form-inline').append($('#postal-code-submit-btn'));
	            }
	            isSticky = false;
	            $('#chatInlay').removeClass('mobile-inlay-sticker-shown');
	          } else if (topOfWindow >= bottomOfElement && isSticky == false) {
	            $('#build-bundle-sticky').removeAttr('hidden');
	            $('#check-availability-sticky').removeAttr('hidden');
	            $appContent.children('#product-social-print-mobile').length > 0 && $appContent.children('#product-social-print-mobile').addClass('hide');
	            $('#pdp-sticky-mobile').append($appContent);
	            $('#footer-bottom').addClass('sticky-pdp-footer');
	            if (!isTwoDayDeliveryZipIn || $('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) {
	              $('#pdp-sticky-mobile').append($('#postal-code-submit-btn'));
	              $('#pdp-sticky-mobile').on('click', function (event) {
	                event.preventDefault();
	                $(window).scrollTop($('.product-interaction').offset().top - 1.2 * $('.product-interaction').outerHeight());
	              });
	            }
	            var interectionElement = $('#pdp-sticky-mobile ul li:visible').length > 0 ? $('#pdp-sticky-mobile ul li:visible') : $('#pdp-sticky-mobile ul div:visible').not('.error');
	            if ($('#ctas').hasClass('hide') || interectionElement.length === 0 && !isBundle && !$isAppliance && isTwoDayDeliveryZipIn && !($('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) && !$isWarningMsg) {
	              $('#pdp-sticky-mobile').hide();
	            }
	            if (isBundle) {
	              $('#bundle-accordion-collapse').addClass('collapse');
	            }
	            isSticky = true;
	            $('#chatInlay').addClass('mobile-inlay-sticker-shown');
	          }
	        }
	      };
	
	      var makeElementStickyForMobileBD = function makeElementStickyForMobileBD() {
	        var $stickyElement = $('#pdp-sticky-mobile');
	        var bottomOfElement = $('.product-interaction').offset().top + $('.product-interaction').outerHeight();
	        if (topOfWindow < bottomOfElement) {
	          $('#zipFormatterFlag').after($('#formProductDetails'));
	          $('#formProductDetails .outline').removeClass('hide');
	          $('#formProductDetails').validate();
	        } else if (topOfWindow >= bottomOfElement) {
	          //check out if sticky element should be displayed
	          $stickyElement.append($('#formProductDetails'));
	          $('#footer-bottom').addClass('sticky-pdp-footer');
	          $('#formProductDetails .outline').addClass('hide');
	          $stickyElement.on('click', function (event) {
	            event.preventDefault();
	            $(window).scrollTop(0);
	            //generate validation on input field of zip code
	            $('#formProductDetails').validate();
	            $('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').rules('add', {
	              required: true,
	              'countryspecificpostalcode': true,
	              messages: {
	                required: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER,
	                countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER
	              }
	            });
	          });
	        }
	      };
	      window.addEventListener('load', function (event) {
	        $(window).scroll(function (event) {
	          if ($('#productPage').val() && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            if (isBundle) {
	              topOfBottomContent = $('#addBundleBtn').attr('disabled') ? $('.bottom-content').offset().top : $('#bundle-container').offset().top + $('#bundle-container').outerHeight(true);
	            } else if ($('#displaybundle').length > 0) {
	              topOfBottomContent = $('.bottom-content').offset().top + $('#displaybundle').outerHeight();
	            } else {
	              topOfBottomContent = $('.bottom-content').offset().top;
	            }
	            topOfWindow = $(window).scrollTop();
	            bottomOfWindow = topOfWindow + $(window).height();
	
	            //checks if page is in MOBILE or TABLET/DESKTOP display view, and calls the appropriate function
	            if (window.innerWidth > 768) {
	              showStickyElementForDesktopAndTablet();
	            } else if (isBDApplication === 'BD') {
	              if ($('#bdZipCookie').val().length > 0) {
	                makeElementStickyForMobile();
	              } else {
	                makeElementStickyForMobileBD();
	              }
	            } else {
	              window.onbeforeunload = function () {
	                window.scrollTo(0);
	              };
	              makeElementStickyForMobile();
	            }
	          }
	        });
	        var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
	        if ((COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') && !scheduledDeliverable && $('#isBDAppVar').val() != 'BD' && !COSTCO.CMath.pdpPageloadComplete && isPDPVariantGreyOutEnabled == 'true' && !(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag)) {
	          if (COSTCO.CMath.isErrorlocationControlleditem) {
	            if ($('div.buyinstoreonly.MuiBox-root').length > 0) {
	              COSTCO.CMath.isWarehouseEnabled = true;
	            } else {
	              COSTCO.CMath.isWarehouseEnabled = false;
	            }
	          }
	          if (!COSTCO.CMath.iskitsbundle) {
	            COSTCO.Product.findOOSitem(true);
	          }
	        } else {
	          if ($('#isBDAppVar').val() != 'BD' && (isPDPVariantGreyOutEnabled == 'false' || Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag || scheduledDeliverable) && !COSTCO.CMath.pdpPageloadComplete && (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant')) {
	            COSTCO.CMath.pdpPageloadComplete = true;
	          }
	        }
	        if (COSTCO.CMath.iskitsbundle) {
	          var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
	          COSTCO.CMath.onloadSelectOption = optionsSelected;
	          for (var i = 0; i <= optionsSelected.length; i++) {
	            $('#swatchesID-productOption0' + i + ' span.selection-item').each(function () {
	              var selectedTile = $(this).attr("automation-id");
	              var tileId = selectedTile.split('_')[1];
	            });
	          }
	          COSTCO.CMath.setKbLabel();
	          $('#theSwatches').remove();
	
	          if (COSTCO.Product.item_type === 'single_variant' || COSTCO.Product.item_type === 'multi_variant') {
	            COSTCO.CMath.hideKBSkeletone();
	          }
	        }
	        var currentUrl = window.location.href;
	        var swatchParam = window.location.href.split('?')[1];
	        if (COSTCO.CMath.iskitsbundle && swatchParam == 'isSwatchReload') {
	          COSTCO.Product.focusToNavPdpTabHeader15();
	        }
	        COSTCO.CMath.kbPageloadComplete = true;
	        if (window.innerWidth > 768) {
	          if ($('#bazaar-container').length > 0 && $('#bazaar-container').html().trim() == '') {
	            $('#bazaar-container').append($detailsBazaarVoice);
	          }
	        } else {
	          if ($('#mobile-bazaar').length > 0 && $('#mobile-bazaar').html().trim() == '') {
	            $('#mobile-bazaar').append($detailsBazaarVoice);
	          }
	        }
	      });
	
	      $(window).resize(function () {
	        if (!$("input").is(":focus")) {
	          if ($('#productPage').val() && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            if (isBundle) {
	              topOfBottomContent = $('#addBundleBtn').attr('disabled') ? $('.bottom-content').offset().top : $('#bundle-container').offset().top + $('#bundle-container').outerHeight(true);
	            } else if ($('#displaybundle').length > 0) {
	              topOfBottomContent = $('.bottom-content').offset().top + $('#displaybundle').outerHeight();
	            } else {
	              topOfBottomContent = $('.bottom-content').offset().top;
	            }
	            topOfWindow = $(window).scrollTop();
	            bottomOfWindow = topOfWindow + $(window).height();
	
	            //checks if page is in MOBILE or TABLET/DESKTOP display view, and modifies sticky element accordingly
	            if (window.innerWidth > 768 && isBDApplication === 'BC') {
	              if ($('#pdp-sticky-mobile ul').length > 0 || $('#bundle-container').hasClass('fixed-footer-bundle')) {
	                $addButtonContainer = isBundle ? $('#bundle-items-container') : $('#pdp-sticky-mobile ul');
	                isBundle ? $('#bundle-container').prepend($addButtonContainer) : $('#ctas').prepend($addButtonContainer);
	                if (isBundle) {
	                  $('#bundle-accordion-collapse').removeClass('collapse');
	                  $('#bundle-accordion-collapse').css('height', '');
	                }
	                isSticky = false;
	                showStickyElementForDesktopAndTablet();
	              }
	              if ($('#bazaar-container').length > 0 && $('#bazaar-container').html().trim() == '') {
	                $('#bazaar-container').append($detailsBazaarVoice);
	              }
	            } else {
	              if (isBundle) {
	                $('#bundle-button-container').append($('#addBundleBtn').attr('disabled') ? $('#bundle-button') : $('#addBundleBtn'));
	              } else {
	                if (!($('input[name="isOOSItem"]').length > 0)) {
	                  $addButtonContainer.prepend($addButtonGroup);
	                  $addButtonContainer.prepend($qtyInput);
	                  $addButtonContainer.prepend($('#sticky-add-btn li'));
	                }
	              }
	              $('.math-table .your-price').append($price);
	              $('#product-body-model-number').after($detailsBazaarVoice);
	              $hiddenSticky.hide();
	              isHidden = true;
	              if (isBDApplication && isBDApplication === 'BD') {
	                makeElementStickyForMobileBD();
	              } else {
	                makeElementStickyForMobile();
	              }
	            }
	          }
	        }
	      });
	
	      $(document).on("click", '.tablist a', function () {
	        var clickedTab = $(this);
	        var clickedTabHref = $(this).attr('href');
	        $('.tablist li').removeClass("active");
	        $('.tablist li a').removeClass("active");
	        $('.tablist li a').attr("aria-current", "false");
	        $('.tablist a[href=' + clickedTabHref + ']').addClass("active");
	        $('.tablist a[href=' + clickedTabHref + ']').parent().addClass("active");
	        $('.tablist a[href=' + clickedTabHref + ']').attr("aria-current", "true");
	      });
	
	      $(document).on('keydown', '.tablist a', function (e) {
	        if (e.which === 13) {
	          var clickedTabHref = $(this).attr('href');
	          this.click();
	          $('div' + clickedTabHref + ' h3').attr('tabindex', '0');
	          $('div' + clickedTabHref + ' h3').focus().on('focusout', function () {
	            $(this).attr('tabindex', '-1');
	          });
	        }
	      });
	    },
	
	    invokeInventoryBatchAPIcallforSingleitem: function invokeInventoryBatchAPIcallforSingleitem(itemId) {
	      var isBopiw = $('#isBOPIWItemForMemberInfo').val();
	      var selectedWarehouse = "";
	      if (isEnableBOPIWUpdatesSync == 'true' && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isBopiwEnabled && !COSTCO.CMath.isWioEnabled && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && !COSTCO.CMath.isBopiwEnabled && isBopiw == 'false') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && COSTCO.CMath.isBopiwEnabled) {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      }
	      var _data = {
	        "distributionCenters": [""],
	        "selectedWarehouse": selectedWarehouse,
	        "itemNumbers": [itemId]
	      };
	      var clientIdentifier = $('#besBatchCLientIdentifier').val();
	      var batchApiURL = $('#baseUriForInventoryBatch').val();
	      var costcoEnv = $('#costcoEnvironmentForBatchInv').val(); //COSTCO.Product.validateCostcoEnv();
	      var costcoEnvECOMEnabled = $('#batchApiCostcoEnvECOMEnabled').val();
	      if (typeof costcoEnvECOMEnabled !== "undefined" && costcoEnvECOMEnabled === "true") {
	        if (costcoEnv === "" || costcoEnv === null || costcoEnv === 'null') {
	          costcoEnv = "ECOM";
	        }
	      }
	      var costcoService = "restInventory";
	
	      var inventoryBatchAkamaiCacheEnabled = $('#inventoryBatchAkamaiCacheEnabled').val();
	      var inventoryBatchEnabledV2 = $('#inventoryBatchEnabledV2').val();
	      var akamaiHeaders = {};
	      akamaiHeaders["Content-type"] = "application/json; charset=UTF-8";
	      akamaiHeaders["costco.env"] = costcoEnv;
	      akamaiHeaders["client-identifier"] = clientIdentifier;
	      akamaiHeaders["costco.service"] = costcoService;
	
	      if (inventoryBatchAkamaiCacheEnabled === "true") {
	        var batchVariantCacheKey = itemId + "-" + COSTCO.Product.getZipcode() + "-" + selectedWarehouse;;
	        akamaiHeaders["batch-variant-cache-key"] = batchVariantCacheKey;
	      }
	      var batchApiURL;
	      if (inventoryBatchEnabledV2 === "true") {
	        batchApiURL = $('#baseUriForInventoryBatchV2').val();
	      } else {
	        batchApiURL = $('#baseUriForInventoryBatch').val();
	      }
	
	      fetch(batchApiURL, {
	        method: "POST",
	        body: JSON.stringify(_data),
	        headers: akamaiHeaders
	      }).then(function (response) {
	        if (response.status >= 200 && response.status <= 299) {
	          return response.json();
	        } else {
	          throw Error(response.statusText);
	        }
	      }).then(function (jsonResponse) {
	        var programType = jsonResponse[0].programTypes;
	        var inwarehousepgType;
	        if (programType != null && programType.hasOwnProperty("inWarehouse") && Array.isArray(programType.inWarehouse)) {
	          if (programType.inWarehouse[0].length != 0) {
	            inwarehousepgType = programType.inWarehouse[0];
	          }
	        } else {
	          inwarehousepgType = programType.inWarehouse;
	        }
	        if (null != inwarehousepgType && inwarehousepgType.availability == 'NOSTOCK' && COSTCO.CMath.isWarehouseEnabled || null == inwarehousepgType || !COSTCO.CMath.isWarehouseEnabled) {
	          $('.crumbs').show();
	          $('#product-page').addClass('hide');
	          $('#not_found_error_pdp').removeClass('hide');
	
	          // set city and zip code
	          var storeLocation = COSTCO.LWSearch.getCookie('STORELOCATION');
	          console.log("storeLocation : " + storeLocation);
	          if (storeLocation !== "" || storeLocation != null) {
	            var storeLocation_ = JSON.parse(unescape(storeLocation));
	            var notfound_deliveryWarehouse = storeLocation_.storeLocation.city;
	            $('#notfound_deliveryWarehouse').html(notfound_deliveryWarehouse);
	          }
	          var notfound_deliveryLocation = COSTCO.LWSearch.getCookie('invCheckPostalCode');
	          $('#notfound_deliveryLocation').html(notfound_deliveryLocation);
	
	          $('#pdp-sticky-desktop').hide();
	          $('#pdp-sticky-mobile').hide();
	        }
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    pickUpinDistribution: function pickUpinDistribution(cookieDistributionCenters, pickUpCenters) {
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = pickUpCenters[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var centers = _step3.value;
	
	          if (!cookieDistributionCenters.includes(centers)) cookieDistributionCenters.push(centers);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return cookieDistributionCenters;
	    },
	    /**
	     * This method is for checkingwarehouse cookie to see whether 3pl location and pickupcenters is present and 
	     * return flag
	     */
	    checkifOutofNetworkLocation: function checkifOutofNetworkLocation() {
	      var cookieDistributionCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('distributionCenters');
	      var pickUpCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('pickUpCenters');
	      var isOutOfNetworkLocation = false;
	      if (pickUpCenters != undefined && pickUpCenters.length != 0 && cookieDistributionCenters != undefined && cookieDistributionCenters.length != 0 && !cookieDistributionCenters.includes('-3pl')) {
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = pickUpCenters[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var centers = _step4.value;
	
	            if (!cookieDistributionCenters.includes(centers)) {
	              isOutOfNetworkLocation = true;
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	      return isOutOfNetworkLocation;
	    },
	    /**
	        * This method is for call inventory batch API call
	        * @return void
	        */
	    invokeInventoryBatchAPIcall: function invokeInventoryBatchAPIcall(optionsSelected) {
	      var isBopiw = $('#isVariantBopiw').val();
	      var ltlFeatureFlag = $('#isLtlFeatureFlagOn').val();
	      var selectedWarehouse = "";
	      if (isEnableBOPIWUpdatesSync == 'true' && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isBopiwEnabled && !COSTCO.CMath.isWioEnabled && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && !COSTCO.CMath.isBopiwEnabled && isBopiw == 'false') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && COSTCO.CMath.isBopiwEnabled) {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      }
	      var distributionCenters = [];
	      var cookieDistributionCenters = [];
	      var cookieGroceryCenters = [];
	      var pickUpCenters = [];
	      var hasLTLPgType = false;
	      cookieDistributionCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('distributionCenters');
	      pickUpCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('pickUpCenters');
	      if (ltlFeatureFlag === "true" && pickUpCenters != undefined && pickUpCenters.length != 0) {
	        for (var i = 0; i < listOfObjects.length; i++) {
	          if (listOfObjects[i].programType.includes('LTLPickUp')) {
	            hasLTLPgType = true;
	            break;
	          }
	        }
	      }
	      if (hasLTLPgType == true) {
	        cookieDistributionCenters = COSTCO.Product.pickUpinDistribution(cookieDistributionCenters, pickUpCenters);
	      }
	      cookieGroceryCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('groceryCenters');
	      distributionCenters = cookieDistributionCenters.concat(cookieGroceryCenters);
	      var JsonResponseSum = 0;
	      itemIdMap.forEach(function (itemIdArray, keys) {
	        var _data = {
	          "distributionCenters": distributionCenters,
	          "selectedWarehouse": selectedWarehouse,
	          "itemNumbers": itemIdArray
	        };
	
	        var costcoEnv = $('#costcoEnvironmentForBatchInv').val(); //COSTCO.Product.validateCostcoEnv();
	        var costcoEnvECOMEnabled = $('#batchApiCostcoEnvECOMEnabled').val();
	        if (typeof costcoEnvECOMEnabled !== "undefined" && costcoEnvECOMEnabled === "true") {
	          if (costcoEnv === "" || costcoEnv === null || costcoEnv === 'null') {
	            costcoEnv = "ECOM";
	          }
	        }
	        var costcoService = "restInventory";
	        var clientIdentifier = $('#besBatchCLientIdentifier').val();
	
	        var inventoryBatchAkamaiCacheEnabled = $('#inventoryBatchAkamaiCacheEnabled').val();
	        var inventoryBatchEnabledV2 = $('#inventoryBatchEnabledV2').val();
	        var akamaiHeaders = {};
	        akamaiHeaders["Content-type"] = "application/json; charset=UTF-8";
	        akamaiHeaders["costco.env"] = costcoEnv;
	        akamaiHeaders["client-identifier"] = clientIdentifier;
	        akamaiHeaders["costco.service"] = costcoService;
	        var itemIdArraysort = itemIdArray.sort(function (a, b) {
	          return a - b;
	        });
	        if (inventoryBatchAkamaiCacheEnabled === "true") {
	          var batchVariantCacheKey = itemIdArraysort + "-" + COSTCO.Product.getZipcode() + "-" + selectedWarehouse;;
	          akamaiHeaders["batch-variant-cache-key"] = batchVariantCacheKey;
	        }
	
	        var batchApiURL;
	        if (inventoryBatchEnabledV2 === "true") {
	          batchApiURL = $('#baseUriForInventoryBatchV2').val();
	        } else {
	          batchApiURL = $('#baseUriForInventoryBatch').val();
	        }
	        fetch(batchApiURL, {
	          method: "POST",
	          body: JSON.stringify(_data),
	          headers: akamaiHeaders
	        }).then(function (response) {
	          if (response.status >= 200 && response.status <= 299) {
	            return response.json();
	          } else {
	            throw Error(response.statusText);
	          }
	        }).then(function (jsonResponse) {
	          if (!window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi) {
	            COSTCO.CMath.varItemJSON.push(jsonResponse);
	            window.reactObj.batchApiResponse.apiResponse = COSTCO.CMath.varItemJSON;
	            try {
	              if (COSTCO.CMath.varItemJSON.length > 0) {
	                window.wioEventBus.publish('notifyBatchApiComplete', COSTCO.CMath.varItemJSON);
	              }
	            } catch (e) {
	              console.log(e);
	            }
	          }
	          Object.entries(jsonResponse).forEach(function (entry) {
	            var _entry = _slicedToArray(entry, 2),
	                key = _entry[0],
	                value = _entry[1];
	
	            var itemarrayStatus = {};
	            var variantitemArray = {};
	
	            var programType = value.programTypes;
	            var siteControlledpgType, locationControlledpgType, inwarehousepgType, ltlPickUpPgType;
	
	            if (programType != null && programType.hasOwnProperty("locationControlledInventory") && Array.isArray(programType.locationControlledInventory)) {
	              locationControlledpgType = programType.locationControlledInventory[0];
	            } else if (programType.locationControlledInventory != undefined) {
	              locationControlledpgType = programType.locationControlledInventory;
	            }
	            if (programType != null && programType.hasOwnProperty("siteControlledInventory") && Array.isArray(programType.siteControlledInventory)) {
	              siteControlledpgType = programType.siteControlledInventory[0];
	            } else if (programType.siteControlledInventory != undefined) {
	              siteControlledpgType = programType.siteControlledInventory;
	            }
	            if (programType != null && programType.hasOwnProperty("inWarehouse") && Array.isArray(programType.inWarehouse)) {
	              if (programType.inWarehouse[0].length != 0) {
	                inWarehousepgType = programType.inWarehouse[0];
	              }
	            } else {
	              inWarehousepgType = programType.inWarehouse;
	            }
	            if (programType != null && programType.hasOwnProperty("ltlPickUp") && Array.isArray(programType.ltlPickUp)) {
	              ltlPickUpPgType = programType.ltlPickUp[0];
	            } else if (programType.ltlPickup != undefined) {
	              ltlPickUpPgType = programType.ltlPickUp;
	            }
	
	            if (undefined != siteControlledpgType && siteControlledpgType.availability == 'NOSTOCK' || undefined != locationControlledpgType && locationControlledpgType.availability == 'NOSTOCK' || COSTCO.CMath.isErrorlocationControlleditem) {
	
	              itemarrayStatus["OL"] = '0';
	            } else {
	              itemarrayStatus["OL"] = '1';
	            }
	
	            if (null != inWarehousepgType && (inWarehousepgType.availability == 'INSTOCK' || inWarehousepgType.availability == 'LOWSTOCK') && COSTCO.CMath.isWarehouseEnabled || ltlPickUpPgType != undefined && ltlPickUpPgType.availability == 'INSTOCK') {
	
	              itemarrayStatus["WH"] = '1';
	            } else if (null != inWarehousepgType && inWarehousepgType.availability == 'NOSTOCK' && COSTCO.CMath.isWarehouseEnabled || null == inWarehousepgType || !COSTCO.CMath.isWarehouseEnabled) {
	              itemarrayStatus["WH"] = '0';
	            }
	            variantitemArray[value.itemNumber] = itemarrayStatus;
	            COSTCO.CMath.variantJSON.push(variantitemArray);
	
	            JsonResponseSum++;
	            if (JsonResponseSum == listOfObjects.length) {
	
	              var len = optionsSelected.length;
	              localStorage.setItem("variantStatus", JSON.stringify(COSTCO.CMath.variantJSON));
	              if ($('#swatches-productOption0' + parseInt(len - 1) + '').length > 0) {
	                COSTCO.Product.strikeOosSwatches(optionsSelected);
	              } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0) {
	                COSTCO.Product.grayOutDropDown(optionsSelected);
	              }
	            }
	          });
	        }).catch(function (err) {
	          return console.log(err);
	        });
	      });
	    },
	    /**
	        * This method is for Strike out lower level Swatches
	        * @return void
	        */
	    strikeOosSwatches: function strikeOosSwatches(optionsSelected) {
	      var len = optionsSelected.length;
	      var option = "option" + parseInt(len);
	      if (len == 3) {
	        var option0 = "option" + parseInt(len - 2);
	        var level0 = optionsSelected[len - 3];
	        var option1 = "option" + parseInt(len - 1);
	        var level1 = optionsSelected[len - 2];
	      } else if (len == 2) {
	        var option0 = "option" + parseInt(len - 1);
	        var level0 = optionsSelected[len - 2];
	      }
	
	      for (var i = 0; i < listOfObjects.length; i++) {
	        var obj = listOfObjects[i];
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	
	              if (COSTCO.CMath.isWarehouseEnabled) {
	                var uptitemarrayStatus = {};
	                var uptvariantitemArray = {};
	
	                uptitemarrayStatus["OL"] = sub_val.OL;
	                if (listOfObjects[i].isaVariant == 'true') {
	                  uptitemarrayStatus["WH"] = '0';
	                } else {
	                  uptitemarrayStatus["WH"] = sub_val.WH;
	                }
	                uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	              }
	            }
	          }
	        }
	        /*following if condtion for skipping strike out for current selected. 
	        * Even selected product is NOSTOCK in batch API call and it is INSTOCK in Ajax call(means INSTOCK in wcs DB) prioprity is given to WCS response
	        *  */
	        if (COSTCO.CMath.invokeAjaxCall) {
	          for (var k in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[k];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == listOfObjects[i].itemId) {
	                if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && (COSTCO.CMath.invAvailableAjax || COSTCO.CMath.isBackOrderFlag) && COSTCO.Product.isEDDStatusAvailable) {
	                  if (len == 3 && level1 == obj[option1]) {
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  } else {
	
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  }
	                } else {
	
	                  if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && ((!COSTCO.CMath.invAvailableAjax || !COSTCO.CMath.isBackOrderFlag) && !COSTCO.Product.isEddItem || !COSTCO.Product.isEDDStatusAvailable || !COSTCO.CMath.invAvailableAjax && COSTCO.Product.isEDDStatusAvailable)) {
	                    if (len == 3 && level1 == obj[option1]) {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    } else {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	              if (sub_val.OL == '0' && sub_val.WH == '0') {
	                var _variable = void 0;
	                _variable = $('input[value=' + obj[option] + ']').next().attr("automation-id");
	                if (COSTCO.Product.item_type === 'multi_variant') {
	                  if ($("input[automation-id='variationOptions_" + obj[option] + "']:checked").length) {
	                    $('span[automation-id=' + _variable + ']').addClass("select-span1-OOS");
	                    //folowing  code for appending OOS label in lower level
	                    var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 1) + ']');
	                    var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	                    if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                      $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                    }
	                    $selectedOptionValue.show();
	                  } else {
	                    $('span[automation-id=' + _variable + ']').removeClass("select-span1-OOS");
	                  }
	                  if (!$('span[automation-id=' + _variable + ']').hasClass('span1-outofstock')) {
	                    $('span[automation-id=' + _variable + ']').addClass("span1-outofstock");
	                  }
	                  if (!$('span[automation-id=' + _variable + ']').children('p').length) {
	                    $('span[automation-id=' + _variable + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	                    $('span[automation-id=' + _variable + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                  }
	                } else if (COSTCO.Product.item_type === 'single_variant') {
	                  // $('.selection-item').removeClass("select-span1-OOS");
	                  if ($("input[automation-id='variationOptions_" + obj[option] + "']:checked").length) {
	                    $('span[automation-id=' + _variable + ']').addClass("select-span1-OOS");
	                    //folowing  code for appending OOS label in lower level
	                    var $selectedOptionLabel = $('label[for=productOption00]');
	                    var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	                    if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                      $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                    }
	                    $selectedOptionValue.show();
	                  } else {
	                    $('span[automation-id=' + _variable + ']').removeClass("select-span1-OOS");
	                  }
	                  if (!$('span[automation-id=' + _variable + ']').hasClass('span1-outofstock')) {
	                    $('span[automation-id=' + _variable + ']').addClass("span1-outofstock");
	                    if (!$('span[automation-id=' + _variable + ']').children('p').length) {
	                      $('span[automation-id=' + _variable + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	                      $('span[automation-id=' + _variable + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	
	      // following code striking upper swatch and dropdown
	
	      if ($('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0) {
	        COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	      } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0) {
	        COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
	      }
	      //For 3 level varaints in order to retain  top level strike when swaping between other top levels
	      COSTCO.CMath.strikealllevelvariants();
	    },
	    /**
	        * This method is for OOS Drop down
	        * @return void
	        */
	    grayOutDropDown: function grayOutDropDown(optionsSelected) {
	      var len = optionsSelected.length;
	      var option = "option" + parseInt(len);
	      if (len == 3) {
	        var option0 = "option" + parseInt(len - 2);
	        var level0 = optionsSelected[len - 3];
	        var option1 = "option" + parseInt(len - 1);
	        var level1 = optionsSelected[len - 2];
	      } else if (len == 2) {
	        var option0 = "option" + parseInt(len - 1);
	        var level0 = optionsSelected[len - 2];
	      }
	      for (var i = 0; i < listOfObjects.length; i++) {
	        var option = "option" + parseInt(len);
	        var obj = listOfObjects[i];
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	
	              if (COSTCO.CMath.isWarehouseEnabled) {
	                var uptitemarrayStatus = {};
	                var uptvariantitemArray = {};
	
	                uptitemarrayStatus["OL"] = sub_val.OL;
	                if (listOfObjects[i].isaVariant == 'true') {
	                  uptitemarrayStatus["WH"] = '0';
	                } else {
	                  uptitemarrayStatus["WH"] = sub_val.WH;
	                }
	                uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	              }
	            }
	          }
	        }
	        /*following if condtion for skipping strike out for current selected. 
	           	 * Even selected product is NOSTOCK in batch API call and it is INSTOCK in Ajax call(means INSTOCK in wcs DB) prioprity is given to WCS response
	           	 *  */
	        if (COSTCO.CMath.invokeAjaxCall) {
	          for (var k in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[k];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == listOfObjects[i].itemId) {
	
	                if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && (COSTCO.CMath.invAvailableAjax || COSTCO.CMath.isBackOrderFlag) && COSTCO.Product.isEDDStatusAvailable) {
	                  if (len == 3 && level1 == obj[option1]) {
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  } else {
	
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  }
	                } else {
	                  if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && ((!COSTCO.CMath.invAvailableAjax || !COSTCO.CMath.isBackOrderFlag) && !COSTCO.Product.isEddItem || !COSTCO.Product.isEDDStatusAvailable || !COSTCO.CMath.invAvailableAjax && COSTCO.Product.isEDDStatusAvailable)) {
	                    if (len == 3 && level1 == obj[option1]) {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    } else {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	              if (sub_val.OL == '0' && sub_val.WH == '0') {
	                var _variable2 = void 0;
	                var obj = listOfObjects[i];
	                var len = optionsSelected.length;
	                if (!$('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').hasClass('out-of-stock')) {
	                  $('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').append('<span class="out-of-stock-text"></span>');
	                  $('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                  $('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').addClass("out-of-stock");
	                  var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 1) + ']');
	                  var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	                  if (optionsSelected[len - 1] == obj[option] && !$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                    var textToReplace = $selectedOptionValue.text();
	                    var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
	                    $selectedOptionValue.text(newText);
	                    $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                  }
	                  $selectedOptionValue.show();
	                }
	              }
	            }
	          }
	        }
	      }
	      if ($('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0) {
	        COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	      } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0) {
	        COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
	      }
	      //For 3 level varaints in order to retain  top level strike when swaping between other top levels
	      COSTCO.CMath.strikealllevelvariants();
	    },
	    /**
	        * This method is for strike upper level swatch
	        * @return void
	        */
	    grayOutUpperLevelDropDown: function grayOutUpperLevelDropDown(optionsSelected) {
	      var lowerLevelOOSCount;
	      var lowerLevelCount;
	      var lowerSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 1) + '').length > 0;
	      var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').length > 0;
	      //following code for checking lower level is drop down or pills. if  all lower level items are OOS will strike out upper level
	      if (lowerDropDown) {
	        lowerLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.opt:not(:disabled)').length;
	        lowerLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.out-of-stock:not(:disabled)').length;
	      } else if (lowerSwatch) {
	        lowerLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.selection-box-v2:visible').length;
	        lowerLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.span1-outofstock').length;
	      }
	      if (lowerLevelOOSCount != "" && lowerLevelCount != "" && lowerLevelCount === lowerLevelOOSCount) {
	        var option = "option" + parseInt(optionsSelected.length - 1);
	        if (!$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').hasClass('out-of-stock')) {
	          $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').append('<span class="out-of-stock-text"></span>');
	          $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	          $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').addClass("out-of-stock");
	          var $selectedOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 2) + ']');
	          var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	          if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	            //$selectedOptionValue.prepend('Out of Stock - ' );
	            var textToReplace = $selectedOptionValue.text();
	            var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
	            $selectedOptionValue.text(newText);
	            $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	          }
	          $selectedOptionValue.show();
	        }
	        if (optionsSelected.length == 3) {
	          var midLevelOOSCount;
	          var midLevelCount;
	          var midSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0;
	          var midDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0;
	          //following code for checking mid level is drop down or pills. if  all mid level items are OOS will strike out upper level
	          if (midDropDown) {
	            midLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.opt:not(:disabled)').length;
	            midLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.out-of-stock:not(:disabled)').length;
	          } else if (midSwatch) {
	            midLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.selection-box-v2:visible').length;
	            midLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.span1-outofstock').length;
	          }
	          if (midLevelOOSCount != "" && midLevelCount != "" && midLevelCount === midLevelOOSCount) {
	            var option = "option" + parseInt(optionsSelected.length - 2);
	            if (!$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').hasClass('out-of-stock')) {
	              $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').append('<span class="out-of-stock-text"></span>');
	              $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	              $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').addClass("out-of-stock");
	              var $selectedOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 3) + ']');
	              var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	              if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                //$selectedOptionValue.prepend('Out of Stock - ' );
	                var _textToReplace = $selectedOptionValue.text();
	                var _newText = _textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
	                $selectedOptionValue.text(_newText);
	                $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	              }
	              $selectedOptionValue.show();
	            }
	          }
	        }
	      } else {
	        var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 2) + ']');
	        var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	        $dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
	
	        var $dropDownOOSOption = $('.varis-v2 option[value=' + optionsSelected[optionsSelected.length - 2] + ']').attr("automation-id");
	        $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
	        $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
	        if (optionsSelected.length == 3) {
	          var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 3) + ']');
	          var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	          $dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
	
	          var $dropDownOOSOption = $('.varis-v2 option[value=' + optionsSelected[optionsSelected.length - 3] + ']').attr("automation-id");
	          $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
	          $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
	        }
	      }
	    },
	    /**
	        * This method is for strike upper level swatch
	        * @return void
	        */
	    strikeUpperLevelVariant: function strikeUpperLevelVariant(optionsSelected) {
	      var element;
	      var noOfLevel = optionsSelected.length;
	      // below code for appending OOS label in upper level swatch if all
	      // item in lower level is OOS
	      var lowerLevelOOSCount;
	      var lowerLevelCount;
	      var lowerSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 1) + '').length > 0;
	      var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').length > 0;
	      //following code for checking lower level is drop down or pills. if  all lower level items are OOS will strike out upper level
	      if (lowerDropDown) {
	        lowerLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.opt:not(:disabled)').length;
	        lowerLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.out-of-stock:not(:disabled)').length;
	      } else if (lowerSwatch) {
	        lowerLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.selection-box-v2:visible').length;
	        lowerLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.span1-outofstock').length;
	      }
	      if (lowerLevelOOSCount != "" && lowerLevelCount != "" && lowerLevelCount === lowerLevelOOSCount) {
	
	        if ($('#swatches-productOption0' + parseInt(noOfLevel - 2) + '').length > 0) {
	          // if upper layer is pills
	          element = $('input[value=' + optionsSelected[noOfLevel - 2] + ']').next().attr("automation-id");
	          if ($('input[value=' + optionsSelected[noOfLevel - 2] + ']').attr('checked') === 'checked') {
	            $('span[automation-id=' + element + ']').addClass("select-span1-OOS");
	          }
	          if (!$('span[automation-id=' + element + ']').hasClass('span1-outofstock')) {
	            $('span[automation-id=' + element + ']').addClass("span1-outofstock");
	            if (!$('span[automation-id=' + element + ']').children('p').length) {
	              // if upper layer is dropdown
	              $('span[automation-id=' + element + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	              $('span[automation-id=' + element + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	            }
	          }
	        }
	        COSTCO.Product.appendLabelSwatches(noOfLevel - 2);
	        if (noOfLevel == 3) {
	          var midLevelOOSCount;
	          var midLevelCount;
	          var midSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0;
	          var midDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0;
	          if (midDropDown) {
	            midLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.opt:not(:disabled)').length;
	            midLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.out-of-stock:not(:disabled)').length;
	          } else if (midSwatch) {
	            midLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.selection-box-v2:visible').length;
	            midLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.span1-outofstock').length;
	          }
	          if (midLevelOOSCount != "" && midLevelCount != "" && midLevelOOSCount === midLevelCount) {
	
	            if ($('#swatches-productOption0' + parseInt(noOfLevel - 3) + '').length > 0) {
	              // if upper layer is pills
	              element = $('input[value=' + optionsSelected[noOfLevel - 3] + ']').next().attr("automation-id");
	              if ($('input[value=' + optionsSelected[noOfLevel - 3] + ']').attr('checked') === 'checked') {
	                $('span[automation-id=' + element + ']').addClass("select-span1-OOS");
	              }
	              if (!$('span[automation-id=' + element + ']').hasClass('span1-outofstock')) {
	                $('span[automation-id=' + element + ']').addClass("span1-outofstock");
	              }
	              if (!$('span[automation-id=' + element + ']').children('p').length) {
	                // if upper layer is dropdown
	                $('span[automation-id=' + element + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	                $('span[automation-id=' + element + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	              }
	            }
	            COSTCO.Product.appendLabelSwatches(noOfLevel - 3);
	          }
	        }
	      } else {
	        var $selectedUpperLabel = $('label[for=productOption0' + parseInt(noOfLevel - 2) + ']');
	        var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	        $selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS);
	
	        var $selectedOOSOption = $('input[value=' + optionsSelected[noOfLevel - 2] + ']').next().attr("automation-id");
	        $('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
	        $('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
	        $('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
	        if (noOfLevel == 3) {
	          var $selectedUpperLabel = $('label[for=productOption0' + parseInt(noOfLevel - 3) + ']');
	          var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	          $selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS);
	
	          var $selectedOOSOption = $('input[value=' + optionsSelected[noOfLevel - 3] + ']').next().attr("automation-id");
	          $('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
	          $('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
	          $('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
	        }
	      }
	    },
	    /**
	        * This method is for getting array of object
	        * object having item id and what are the options associated with the item
	        * @return void
	        */
	    getLowerLevelItemDetails: function getLowerLevelItemDetails(optionsSelected) {
	      //following for loop for getting item and option associated with that item 
	      var selected_first = $('#productOption00').val();
	      var count50 = 0;
	
	      var numberOfChunks = 0;
	      var itemIdchunk = [];
	      for (var i = 0; i < product.length; i++) {
	        for (var j = 0; j < products[i].length; j++) {
	          var singleObj = {}; // this object for holding item id and what are the options belong to that item ID
	          singleObj['itemId'] = products[i][j].partNumber;
	          singleObj['isaVariant'] = products[i][j].isaVariant;
	          singleObj['programType'] = products[i][j].programType;
	          // following for lopp for ordering options in object
	          if (COSTCO.Product.item_type === 'multi_variant') {
	            for (var m = 0; m < optionsSelected.length - 1; m++) {
	              if (products[i][j].options.includes(optionsSelected[m])) {
	                if (m == optionsSelected.length - 2) {
	                  // if upto 2nd last layer all options are macthed then only we are passing that item to batch API
	                  for (var m = 0; m < optionsSelected.length; m++) {
	                    if (products[i][j].options.includes(optionsSelected[m])) {
	                      // folloeing code finding common elements and adding accoding to the index of selected option
	                      var findCommonOption = products[i][j].options.find(function (element) {
	                        return element == optionsSelected[m];
	                      });
	                      singleObj['option' + parseInt(m + 1)] = findCommonOption;
	                    } else {
	                      //finding different option and adding to the bottom of the array
	                      var differentElement = products[i][j].options.filter(function (x) {
	                        return !optionsSelected.includes(x);
	                      });
	                      singleObj['option' + parseInt(optionsSelected.length)] = differentElement[0];
	                    }
	                  }
	
	                  listOfObjects.push(singleObj);
	                  itemIdchunk.push(products[i][j].partNumber);
	                  count50++;
	                }
	              } else {
	                break;
	              }
	            }
	          } else {
	            for (var k = 0; k < products[i][j].options.length; k++) {
	              singleObj['option' + parseInt(k + 1)] = products[i][j].options[k];
	            }
	            listOfObjects.push(singleObj);
	            itemIdchunk.push(products[i][j].partNumber);
	            count50++;
	          }
	
	          /*following code for check item pushed in the array reached the limit(which is configured in appconfigparam) or it loop is completed
	           * in bot scenario pushing all element to the map. this map later used for callling batch API
	          */
	          if (count50 == numberOfBatchApiIds || j == products[i].length - 1 && itemIdchunk.length > 0) {
	            count50 = 0;
	            numberOfChunks++;
	            itemIdMap.set(numberOfChunks, itemIdchunk);
	            itemIdchunk = [];
	          }
	        }
	      }
	    },
	    /**
	        * This method is for OOS item using batch API
	        * @return void
	        */
	    appendLabelSwatches: function appendLabelSwatches(labelLevel) {
	      var $selectedOptionLabel = $('label[for=productOption0' + parseInt(labelLevel) + ']');
	      var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	      if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	        $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	      }
	      $selectedOptionValue.show();
	    },
	
	    /**
	        * This method is for OOS item using batch API
	        * @return void
	        */
	    findOOSitem: function findOOSitem(invokeBatchAPICall) {
	      itemIdMap = new Map();
	      listOfObjects = [];
	      OOSMap = new Map();
	
	      //folowing code for avoiding 2nd method call
	      var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
	      COSTCO.CMath.selectedswatches = optionsSelected;
	
	      // following code for setting 2nd swatch items for selected first swatch
	
	      COSTCO.Product.getLowerLevelItemDetails(optionsSelected); //for setting array of item id and listOfObjects which has  itemid and option associated with that item 
	      if (invokeBatchAPICall) {
	        COSTCO.Product.invokeInventoryBatchAPIcall(optionsSelected); // following code for call bact API call
	      } else {
	        var len = optionsSelected.length;
	        if ($('#swatches-productOption0' + parseInt(len - 1) + '').length > 0) {
	          COSTCO.Product.strikeOosSwatches(optionsSelected);
	        } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0) {
	          COSTCO.Product.grayOutDropDown(optionsSelected);
	        }
	      }
	      //following code for remove lower skeleton and append swatches
	      $('#PDPSwatchSkeletone-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
	      $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').show();
	      $('.dropdown-skeleton-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
	      $('[name=productOption0' + parseInt(optionsSelected.length - 1) + ']').show();
	      COSTCO.CMath.pdpPageloadComplete = true;
	      COSTCO.CMath.invokebatchCall = false;
	    },
	    /**
	        * Changes the variance value displayed in bundle element
	        * @param id of variance select element user changed
	        * @param  variance label
	        * @param new variance value
	        * @param product price
	        * @param varianceIsBackordered
	        * @param varianceBackorderMessage
	        * @return void
	        */
	    changeBundleItemVarianceValue: function changeBundleItemVarianceValue(varianceId, varianceLabel, varianceValue, variancePrice, varianceIsBackordered, varianceBackorderMessage) {
	      var $varianceValue = $('#bundle-item-value-' + varianceId);
	      $varianceValue.find('span').text(varianceLabel + ': ' + varianceValue);
	      var $variancePrice = $('#bundle-item-price-' + varianceId);
	      $variancePrice.find('span').text(COSTCO.Product.formatMoney(variancePrice, true));
	      var $bundleItem = $('#bundle-item-' + varianceId);
	      $bundleItem.find('#backorder-message').remove();
	      if (varianceIsBackordered && varianceBackorderMessage) {
	        $bundleItem.append($('<div id="backorder-message" class="warning"></div>').text(varianceBackorderMessage));
	      }
	    },
	
	    /**
	        * Changes the quantity displayed in bundle input element on plus/minus click
	        * @param index ID of quantity element user clicked on
	        * @param isIncrement boolean showing if user clicked on plus or minus button
	        * @return void
	        */
	    changeBundleItemQuantityValue: function changeBundleItemQuantityValue(index, isIncrement) {
	      var qtyInput = $('#bundle-quantity-' + index);
	      var qtyValue = parseInt(qtyInput.val());
	      var quantityStep = 1;
	
	      if (isIncrement === true) {
	        var maxQnty = COSTCO.Product.maxQuantity();
	        if (qtyValue + quantityStep <= maxQnty + 1) {
	          qtyValue += quantityStep;
	        }
	      } else if (isIncrement === false) {
	        if (qtyValue - quantityStep >= 0) {
	          qtyValue -= quantityStep;
	        }
	      }
	
	      qtyInput.val(qtyValue);
	
	      COSTCO.Product.validateQuantityValue(qtyInput, '.bundle-item #bundle-error-' + index);
	      COSTCO.Product.discardInvalidQtyValues(qtyValue, qtyInput, isIncrement);
	
	      if (!qtyInput.hasClass("error")) {
	        $('[name=quantity-' + index + ']').val(qtyValue);
	        $('[name=quantity-' + index + ']').trigger('change');
	      }
	    },
	
	    /**
	     * Adds item to the bundle and shows it in the bundle section
	     * @param bundleItemObj product that is added to bundle
	     * @return void
	     */
	    addBundleItem: function addBundleItem(bundleItemObj) {
	      $('#bundle-div-empty').hide();
	      if (bundleItemObj.varianceLabel && bundleItemObj.varianceValue) {
	        $('#bundle-div').append(COSTCO.util.tmpl('tmpl_bundle_item_variance', {
	          item_desc: bundleItemObj.desc,
	          item_url: bundleItemObj.url,
	          item_price: bundleItemObj.price,
	          item_id: bundleItemObj.itemId,
	          item_label: bundleItemObj.varianceLabel,
	          item_value: bundleItemObj.varianceValue,
	          item_data_product: parseInt(bundleItemObj.itemId) - 1
	        }));
	        if (bundleItemObj.backordered) {
	          if (typeof bundleItemObj.beckorderedMessage !== "undefined") {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(bundleItemObj.beckorderedMessage));
	          } else {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	          }
	        }
	      } else {
	        $('#bundle-div').append(COSTCO.util.tmpl('tmpl_bundle_item', {
	          item_desc: bundleItemObj.desc,
	          item_url: bundleItemObj.url,
	          item_price: bundleItemObj.price,
	          item_id: bundleItemObj.itemId,
	          item_data_product: parseInt(bundleItemObj.itemId) - 1
	        }));
	        if (bundleItemObj.backordered) {
	          if (typeof backorderMessage !== "undefined") {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(backorderMessage));
	          } else {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	          }
	        }
	      }
	      var $qtyInput = $('#bundle-quantity-' + bundleItemObj.itemId);
	      COSTCO.Product.changeBundleItemQuantityValue(bundleItemObj.itemId);
	      var numberOfItems = $('.bundle-item').length;
	      if (numberOfItems == 1) {
	        $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.ITEM + ')');
	        $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.ITEM + ')');
	      } else {
	        $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	        $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	      }
	      $('#bundle-container').append($('#bundle-items-container'));
	      $('#bundle-items-container').show();
	      var topOfWindow = $(window).scrollTop();
	      var $buildABundle = $('#build-a-bundle');
	      var bottomOfElement = $buildABundle.offset().top + $buildABundle.outerHeight();
	      if (topOfWindow >= bottomOfElement && $(window).width() < 769) {
	        $('#pdp-sticky-mobile').append($('#bundle-items-container'));
	        $('#build-bundle-sticky').detach();
	      }
	      $('#addBundleBtn').removeAttr('disabled');
	    },
	
	    /**
	     * Removes the item from the bundle section
	     * @param bundleItemNumber ID number of bundle item that is being removed
	     * @return void
	     */
	    removeBundleItem: function removeBundleItem(bundleItemNumber) {
	      $('#ProductForm #quantity-' + bundleItemNumber).val('0');
	      $('#ProductForm #quantity-' + bundleItemNumber).trigger('change');
	      if ($('#checkbox-bundle-' + bundleItemNumber).is(':checked')) {
	        $('#checkbox-bundle-' + bundleItemNumber).prop('checked', false);
	        $('#checkbox-bundle-' + bundleItemNumber).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADD_TO_BUNDLE);
	      }
	      $('#bundle-item-' + bundleItemNumber).remove();
	      var numberOfItems = $('.bundle-item').length;
	      if (numberOfItems == 0) {
	        $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE_ITEMS);
	        $('#accordion-item-number').text('');
	        $('#bundle-div-empty').show();
	        var topOfWindow = $(window).scrollTop();
	        var $buildABundle = $('#build-a-bundle');
	        var bottomOfElement = $buildABundle.offset().top + $buildABundle.outerHeight();
	        if (topOfWindow >= bottomOfElement && $(window).width() < 769) {
	          $('#bundle-container').append($('#bundle-items-container'));
	          $('#pdp-sticky-mobile').append($('#build-bundle-sticky'));
	        }
	        $('#addBundleBtn').attr('disabled', true);
	      } else {
	        if (numberOfItems == 1) {
	          $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.ITEM + ')');
	          $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.ITEM + ')');
	        } else {
	          $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	          $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	        }
	      }
	    },
	
	    /**
	     * Calls addBundleItem/removeBundleItem when the bundle checkbox is clicked
	     * @param element checkbox element that is being clicked
	     * @param bundleItemNumber ID number of bundle item
	     * @return void
	     */
	    bundleCheckboxClick: function bundleCheckboxClick(element, bundleItemNumber) {
	      if ($(element).is(':checked')) {
	        var clonedVarArr = document.getElementsByClassName('cloned');
	        var select = $("select[data-product=" + (bundleItemNumber - 1) + "]");
	        //Check if item is backordered
	        var isBackordered = false;
	        if ($(element).closest('.bundle-product').find('#backorder-message').length > 0) {
	          isBackordered = true;
	        }
	        if (clonedVarArr.length > 0 && select.length > 0) {
	          var selectedOption = $("select[data-product=" + (bundleItemNumber - 1) + "] option:selected");
	          var selectVariantName = $(select).prop('name');
	          var labels = '';
	          //check if bundle item has variance to select
	          labels = $("label[for='" + select[1].id + "']");
	          //check value of the cloned select 
	          if (selectedOption[1].value == "unselected") {
	            $(element).prop("checked", false);
	            select.addClass("error-in-bundle");
	            labels.addClass("label-outline-error");
	            labels.show();
	            return;
	          } else {
	            $('#' + selectVariantName).val(selectedOption[1].value);
	            $('#' + selectVariantName).trigger('change.vari');
	          }
	          var $bundleItemLink = $(element).closest('.vari').find('.desc');
	          var bundleItemObj = {
	            desc: $bundleItemLink.text(),
	            url: $bundleItemLink.attr('href'),
	            price: $(element).closest('.vari').find('.price span').text(),
	            itemId: bundleItemNumber,
	            varianceLabel: labels[1].textContent.trim(),
	            varianceValue: selectedOption[1].text,
	            backordered: isBackordered,
	            beckorderedMessage: $(element).closest('.bundle-product').find('#backorder-message').text()
	          };
	          $(element).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADDED_TO_BUNDLE);
	          COSTCO.Product.addBundleItem(bundleItemObj);
	        } else {
	          var _$bundleItemLink = $(element).closest('.vari').find('.desc');
	          var _bundleItemObj = {
	            desc: _$bundleItemLink.text(),
	            url: _$bundleItemLink.attr('href'),
	            price: $(element).closest('.vari').find('.price span').text(),
	            itemId: bundleItemNumber,
	            backordered: isBackordered
	          };
	          $(element).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADDED_TO_BUNDLE);
	          COSTCO.Product.addBundleItem(_bundleItemObj);
	        }
	      } else {
	        $(element).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADD_TO_BUNDLE);
	        COSTCO.Product.removeBundleItem(bundleItemNumber);
	      }
	    },
	
	    /**
	     * Scroll to section from product info sticky element. 
	     * Sets offset approximately for the width of sticky element.   
	     */
	    scrollToElementOnPdpWithOffset: function scrollToElementOnPdpWithOffset() {
	      $('a.scrollLink').click(function (event) {
	        event.preventDefault();
	        var stickyOffset = $('#hidden-sticky').is(':hidden') ? 190 : 140;
	        $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top - stickyOffset }, 500);
	      });
	    },
	
	    /**
	     * Changes bundle accordion header text when accordion is expanded/collapsed
	     * @return void
	     */
	    bundleAccordionClick: function bundleAccordionClick() {
	      if ($('#bundle-accordion-collapse').hasClass('in')) {
	        $('#accordion-header-text').text(messages.PDP_REDESIGN_V2_VIEW_ORDER_SUMMARY);
	        $('#bundle-accordion-header a i').removeClass('rotate270');
	        $('#bundle-accordion-header a i').addClass('rotate90');
	      } else {
	        $('#accordion-header-text').text(messages.PDP_REDESIGN_V2_HIDE_ORDER_SUMMARY);
	        $('#bundle-accordion-header a i').removeClass('rotate90');
	        $('#bundle-accordion-header a i').addClass('rotate270');
	      }
	    },
	    /**
	     * Scrolls the page to tablist and shows the buld a bundle tab
	     * @return void
	     */
	    focusBuildABundle: function focusBuildABundle() {
	      $('html, body').scrollToElem($('.bottom-content'), 500);
	      $('#build-bundle-tab').focus();
	      setTimeout(function () {
	        $('#tablist li').removeClass('active');
	        $('.tab-content div').removeClass('active in');
	        $('#tab-header-bundle').addClass('active');
	        $('.bundle-tab').addClass('active in');
	      }, 500);
	    },
	    /**
	     * Scrolls the page to the top and focuses on the Zip Code field
	     * @return void
	     */
	    focusZipCodeField: function focusZipCodeField() {
	      var x = $('#edd-message-block').length > 0 ? $("#edd-message-block").offset() : $('#delivery-zip').offset();
	      $('html, body').animate({ scrollTop: x.top - 200 }, 'slow');
	      if ($('#edd-message-block').length > 0) {
	        $('#edd-message-block').focus();
	      } else {
	        $('#delivery-zip').focus();
	      }
	    },
	
	    /**
	     * Makes Add to Registry button reachable by keyboard,
	     * and enables click on the button via keyboard 
	     */
	    makeGiftRegistryAdaCompliant: function makeGiftRegistryAdaCompliant() {
	      var addToRegistryDivContent = $('.mr-registry-container a');
	      addToRegistryDivContent.attr('tabindex', '0');
	      addToRegistryDivContent.attr('role', 'button');
	
	      addToRegistryDivContent.on('keypress click', function (event) {
	        if (event.which === 13 || event.which === 1) {
	          addToRegistryDivContent.click();
	          return false;
	        }
	      });
	    },
	    /**
	     * ADA compliance
	     * Initializes aria-current value for tab panel
	     * @return void
	     */
	    initializeAdaForTabPanel: function initializeAdaForTabPanel() {
	      $('.tablist li.active a').attr('aria-current', "true");
	    },
	    /**
	     * Sets all bundle checkboxes to unchecked on load
	     * @return void
	     */
	    bundlePageReload: function bundlePageReload() {
	      $('[id^="checkbox-bundle-"]').prop('checked', false);
	      $('[id^="clonedproductOption"]').prop("selectedIndex", 0);
	    },
	
	    arrangeBundleButtons: function arrangeBundleButtons() {
	      if (!$('#mr-registry-container').is(':empty')) {
	        $('#bundle-button').addClass('not-alone');
	      }
	    },
	
	    /** envent for determing if quantity-selector-v2 buttons shoud be enabled/disabled. This event is triggering when user changes quantity box
	     * 
	     */
	    initializeQuantityBtns: function initializeQuantityBtns() {
	      $('#minQtyText').unbind('keyup').bind('keyup', function () {
	        COSTCO.Product.changeQuantityButtonsBehaviour();
	      });
	    },
	
	    /** function for disabling '+' and '-' buttons for quantity-selector-v2
	     * @param disblebuttonSelector - selector for buttton which needs to be disabled.
	     * @return void
	     * 
	     */
	    disableButton: function disableButton(disblebuttonSelector) {
	      disblebuttonSelector.get(0).setAttribute('disabled', true);
	      disblebuttonSelector.addClass("disabled");
	    },
	
	    /** function for enabling '+' and '-' buttons for quantity-selector-v2
	     * @param enablebuttonSelector - selector for buttton which needs to be enabled.
	     * @return void
	     * 
	     */
	    enableButton: function enableButton(enablebuttonSelector) {
	      enablebuttonSelector.removeAttr("disabled");
	      enablebuttonSelector.removeClass("disabled");
	    },
	    /**
	     * this function has logic for determing should '+' or '-' buttons be enabled or disabled
	     * @return void
	     */
	    changeQuantityButtonsBehaviour: function changeQuantityButtonsBehaviour() {
	      var quantityStep = $('#minQtyText').attr('data-quantity-increment') ? parseInt($('#minQtyText').attr('data-quantity-increment')) : 1;
	      var currentQut = $('[name=quantity]').val();
	      if (currentQut > 999 - quantityStep) {
	        COSTCO.Product.disableButton($("#plusQty"));
	      } else if (currentQut <= quantityStep) {
	        COSTCO.Product.disableButton($("#minusQty"));
	      } else {
	        COSTCO.Product.enableButton($("#minusQty"));
	        COSTCO.Product.enableButton($("#plusQty"));
	      }
	    },
	    makeTextNonClicableForSR: function makeTextNonClicableForSR() {
	      $('#product-details').off('click');
	      $('#product-details').find('*').off('click');
	    },
	
	    initShippingStatementPopover: function initShippingStatementPopover() {
	      $('.popup-help').attr('aria-haspopup', 'true');
	      $('.popup-help').attr('aria-expanded', 'false');
	      var sr_message = messages.RWD_HELP;
	      $('.popup-help i').append("<span class='sr-only'>" + sr_message + "</span>");
	      $('.popup-help').popover({
	        trigger: 'click'
	      }).on('keypress', function (e) {
	        if (e.which === 13 || e.which === 32 || e.which === 1) {
	          // mozilla condition
	          if ($('.popover').length === 1) {
	            return;
	          } else {
	            $(this).click();
	          }
	        }
	      }).on('shown.bs.popover', function () {
	        COSTCO.util.announceSRMessage('expanded');
	        $('.popover').on('focusout ', function (e) {
	          $('.popup-help').popover('hide').on('keydown', function (e) {
	            if (event.shiftKey && event.keyCode === 9) {
	              $('.popup-help').popover('hide');
	            }
	          });
	        });
	        $('body').on('click', function (e) {
	          var $popupContainer = $('.shipping-statement .popup-help');
	          if (!$popupContainer.is(e.target) && $popupContainer.has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
	            $popupContainer.popover('hide');
	          }
	        });
	      });
	    },
	    /**
	      * this function has logic to show/hide review contents
	      * param action
	      * @return void
	      */
	    changeVisibilityOfReviewContents: function changeVisibilityOfReviewContents(action) {
	      var $bvReviewContents = $('.bv-content-item.bv-content-top-review.bv-content-review');
	      $bvReviewContents.each(function (index) {
	        if (index != 0 && action === "hide") {
	          $(this).attr("style", "display: none !important");
	        } else if (action === "show") {
	          $(this).attr("style", "display: flex !important");
	        }
	      });
	    },
	    invokeAddedToCartModalData: function invokeAddedToCartModalData(sessionStorageDataModal) {
	      var addedToCartModalData = $.parseJSON(sessionStorageDataModal);
	      COSTCO.AddToCart.product_form_done(addedToCartModalData);
	      sessionStorage.removeItem("AddedToCartModalData");
	    },
	    /**
	    * Show/Hide the EDD details and message based on whether Product is coming soon.
	    * @param product isComingSoon and feature flag are true shows the coming soon message else shows EDD details.
	    */
	    toggleDeliveryMoleculeOnComingSoon: function toggleDeliveryMoleculeOnComingSoon() {
	      if (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) {
	        $('#comingsoon-alert-id').removeClass('hide');
	        $('#product-form-and-action').addClass('hide');
	        $('#product-estimated-date').addClass('hide');
	        $('#sticky-content').addClass('hide');
	      } else {
	        $('#comingsoon-alert-id').addClass('hide');
	        $('#product-form-and-action').removeClass('hide');
	        if (!COSTCO.CMath.iskitsbundle) {
	          $('#product-estimated-date').removeClass('hide');
	        }
	        $('#sticky-content').removeClass('hide');
	      }
	    }
	  };
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.Product = Product;
	  return Product;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * @title addressBook.js: Feature level module
	 * @description Module associated with address book section
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var CAddressBook = {
	    url: {
	      MANAGE_ADDRESS_UPDATE: '/AjaxManageAddressCmd?mode=UPDATE',
	      MANAGE_ADDRESS_ADD: '/AjaxManageAddressCmd?mode=ADD',
	      MANAGE_ADDRESS_SET_DEFAULT: '/AjaxManageAddressCmd?mode=SET_DEFAULT',
	      MANAGE_ADDRESS_REMOVE: '/AjaxManageAddressCmd?mode=DELETE',
	      MANAGE_ADDRESSTYPE_UPDATE: '/AjaxManageAddressCmd?mode=SET_ADDRESSTYPE'
	    },
	
	    /**
	     * Constants
	     */
	    DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT: 114,
	
	    DEFAULT_ADDRESS_CELL_HEIGHT: 140,
	
	    DEFAULT_ADDRESS_CELL_TITLE_HEIGHT: 24,
	
	    ENTRIES_PER_PAGE_LG: 8,
	    ENTRIES_PER_PAGE_NON_LG: 7,
	
	    //    ADDRESS_TYPE_SHIPPING: 'Shipping',
	    //    ADDRESS_TYPE_BILLING: 'Billing',
	
	    ADDRESS_TYPE_SHIPPING: 'S',
	    ADDRESS_TYPE_BILLING: 'B',
	
	    ADDRESS_TYPE_S: 'S',
	    ADDRESS_TYPE_B: 'B',
	
	    ADDRESS_SORT_MOST_RECENT: '1',
	    ADDRESS_SORT_FIRST_A_Z: '2',
	    ADDRESS_SORT_FIRST_Z_A: '3',
	    ADDRESS_SORT_LAST_A_Z: '4',
	    ADDRESS_SORT_LAST_Z_A: '5',
	    ADDRESS_SORT_COMPANY_NAME_A_Z: '6',
	    ADDRESS_SORT_COMPANY_NAME_Z_A: '7',
	
	    currentShippingPage: 1,
	    currentBillingPage: 1,
	    resizeTimer: 0,
	    activeTab: 'S',
	
	    /**
	     * Adjust add button height to be equal to address cells.
	     */
	    adjustAddButtonHeight: function adjustAddButtonHeight() {
	      var currentBtnHeight = $('.add-new-address > .caption').height();
	      var topPadding = (CAddressBook.DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT - currentBtnHeight) / 2;
	      if ($('#xs-sm-visible-indicator').css('display') === 'none') {
	        // Btn height should be same as address cell next to it, otherwise it should be square.
	        var addressCellHeight = $('.address-cell').length > 0 ? $('.address-cell:first').height() - 2.75 : $('.add-new-address').width(); // -1 for fine cells alignment
	        if (addressCellHeight != null && addressCellHeight > CAddressBook.DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT) {
	          topPadding = (addressCellHeight - currentBtnHeight) / 2;
	          $('.add-new-address').height(addressCellHeight - 1);
	        }
	      } else {
	        // Subtracting 2.5 from desired height because of border-box box-sizing 
	        $('.add-new-address').height(CAddressBook.DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT - 2.5);
	      }
	      $('.add-new-address > .caption').css('margin-top', topPadding + 'px');
	    },
	
	    /**
	     * Adjust cell title section height when label breaks to two lines
	     */
	    adjustAddressCellTitleSection: function adjustAddressCellTitleSection() {
	      var aHrefHeight = $('.address-cell > .style-check > a').length > 0 ? $('.address-cell > .style-check > a:last').height() : 0;
	      var pHeight = $('.address-cell > .style-check > p').length > 0 ? $('.address-cell > .style-check > p:last').height() : 0;
	      var higher = aHrefHeight > pHeight ? aHrefHeight : pHeight;
	      var cellHeight = $('.address-cell > .style-check').height();
	      if (cellHeight < CAddressBook.DEFAULT_ADDRESS_CELL_TITLE_HEIGHT) {
	        cellHeight = CAddressBook.DEFAULT_ADDRESS_CELL_TITLE_HEIGHT;
	      }
	      var finalHeight = higher > cellHeight ? higher : cellHeight;
	      finalHeight = finalHeight + parseInt($('.address-cell > .style-check').css('padding-top')) + parseInt($('.address-cell > .style-check').css('padding-bottom'));
	      $('.address-cell > .style-check').map(function () {
	        $(this).innerHeight(finalHeight);
	      });
	    },
	
	
	    /**
	     * Adjust cell matrix element's size
	     * @param alignClass - class of elements which will be processed
	     */
	    addjustCells: function addjustCells(alignClass) {
	      if (this.getColumnNumber() > 1) {
	        // 4 rows maximum
	        COSTCO.util.adjustDivHeights(alignClass + '-0', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT);
	        COSTCO.util.adjustDivHeights(alignClass + '-1', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT);
	        COSTCO.util.adjustDivHeights(alignClass + '-2', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT);
	        COSTCO.util.adjustDivHeights(alignClass + '-3', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT);;
	      }
	      this.adjustAddressCellTitleSection();
	      this.adjustAddButtonHeight();
	    },
	
	    init: function init() {
	      // Case where user is timed out from address page and clicks back in browser tab without logging in. This reloads the page so that the user relands on the logon page rather than the auth address page.
	      if (window.performance && window.performance.getEntriesByType("navigation")[0].type === 'back_forward' && !$.cookie('hashedUserId')) {
	        window.location.reload(true);
	      }
	
	      // this.currentPage = 1;
	      this.setActiveAddressType();
	      this.bindEvents();
	      if (COSTCO.util.isBusinessDelivery()) {
	        COSTCO.CAddressForm.initiatePopovers();
	      }
	
	      if (document.readyState == 'complete') {
	        this.initializeAddresses();
	      } else {
	        $(window).on('load', function () {
	          COSTCO.CAddressBook.initializeAddresses();
	        });
	      }
	      COSTCO.CAddressBook.addressbookTabAriaExpandedSwitch();
	      COSTCO.CAddressBook.analytics();
	    },
	
	    initializeAddresses: function initializeAddresses(addressType) {
	      COSTCO.util.resetAddressLoadState();
	      COSTCO.util.getAddressBatch(COSTCO.CAddressBook.ADDRESS_TYPE_SHIPPING, 'ALL', 'RECENT', '1', '100000', function (data) {
	        COSTCO.CAddressBook.validateShippingAddressPhoneNumber(data.addresses);
	        COSTCO.util.getAddressBatch(COSTCO.CAddressBook.ADDRESS_TYPE_BILLING, 'ALL', 'RECENT', '1', '100000', function (data) {
	          COSTCO.CAddressBook.populate(data);
	        });
	      });
	    },
	
	    populate: function populate(data) {
	
	      COSTCO.CAddressBook.createNewAddressButton('add-new-address-btn-box');
	      COSTCO.CAddressBook.populateAddressSection('addresses-list-box', 1);
	    },
	
	    /**
	     * Events binding for address section elements
	     */
	    bindEvents: function bindEvents() {
	      $('#billingTab a').click(function () {
	        COSTCO.CAddressBook.activeTab = CAddressBook.ADDRESS_TYPE_BILLING;
	        $('#shippingTab').removeClass('active');
	        $('#billingTab').addClass('active');
	        COSTCO.CAddressBook.populateAddressSection('addresses-list-box');
	      });
	      $('#shippingTab a').click(function () {
	        COSTCO.CAddressBook.activeTab = CAddressBook.ADDRESS_TYPE_SHIPPING;
	        $('#shippingTab').addClass('active');
	        $('#billingTab').removeClass('active');
	        COSTCO.CAddressBook.populateAddressSection('addresses-list-box');
	      });
	      $('a[href="#address"]').on('shown.bs.tab', function () {
	        COSTCO.CAddressBook.populateAddressSection('addresses-list-box');
	      });
	
	      // TODO: Try to find more optimal solution!!!!
	      // $(window).resize(function() {
	      //   if ($('#address-book').length) {
	      //     clearTimeout(CAddressBook.resizeTimer);
	      //     CAddressBook.resizeTimer = setTimeout(function() {
	      //       COSTCO.CAddressBook.resizedw();
	      //     }, 100);
	      //   }
	      // });
	      // TODO: Kurt says: Perhaps debouncing this function will work. Essentially
	      // resize gets invoked constantly, this will stop function execution
	      // until N seconds pass.
	      //$(window).resize(COSTCO.util.debounce(
	      //  COSTCO.CAddressBook.resizedw.bind(this), 300)).bind(this);
	
	      $(window).resize(function () {
	        if ($('#address-book').length) {
	          clearTimeout(CAddressBook.resizeTimer);
	          CAddressBook.resizeTimer = setTimeout(function () {
	            COSTCO.CAddressBook.resizedw();
	          }, 100);
	        }
	      });
	    },
	
	    /**
	     * Callback on resize event. Refresh address and paging section.
	     */
	    resizedw: function resizedw() {
	      this.populateAddressSection('addresses-list-box');
	    },
	
	    /**
	     * Returns number of displayed addresses on page depending on screen size
	     * @return entries per page
	     */
	    getEntriesPerPage: function getEntriesPerPage() {
	      if ($('#lg-visible-indicator').css('display') === 'none') {
	        return CAddressBook.ENTRIES_PER_PAGE_NON_LG;
	      } else {
	        return CAddressBook.ENTRIES_PER_PAGE_LG;
	      }
	    },
	
	
	    /**
	     * Returns number of columns in address matrix
	     * @return number of columns
	     */
	    getColumnNumber: function getColumnNumber() {
	      var columnNumber = 1;
	      if ($('#xl-visible-indicator').css('display') != undefined && $('#xl-visible-indicator').css('display') != 'none') {
	        columnNumber = 4;
	      } else if ($('#lg-visible-indicator').css('display') != undefined && $('#lg-visible-indicator').css('display') != 'none') {
	        columnNumber = 3;
	      } else if ($('#md-visible-indicator').css('display') != undefined && $('#md-visible-indicator').css('display') != 'none') {
	        columnNumber = 2;
	      } else {
	        columnNumber = 1;
	      }
	      return columnNumber;
	    },
	
	
	    /**
	     * Sort addresses
	     * @param addresses - addresses list to be sorted
	     * @return sorted addresses list
	     */
	    sort: function sort(addresses) {
	      var sortedAddressList = [];
	
	      var sortType = $('option:selected', $('#sort_by')).val();
	      if (sortType === CAddressBook.ADDRESS_SORT_MOST_RECENT) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var id1 = parseInt(elem1.addressId);
	          var id2 = parseInt(elem2.addressId);
	          return id1 > id2 ? -1 : id1 < id2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_FIRST_A_Z) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.firstName.toLowerCase();
	          var name2 = elem2.firstName.toLowerCase();
	          return name1 < name2 ? -1 : name1 > name2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_FIRST_Z_A) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.firstName.toLowerCase();
	          var name2 = elem2.firstName.toLowerCase();
	          return name1 > name2 ? -1 : name1 < name2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_LAST_A_Z) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.lastName.toLowerCase();
	          var name2 = elem2.lastName.toLowerCase();
	          return name1 < name2 ? -1 : name1 > name2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_LAST_Z_A) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.lastName.toLowerCase();
	          var name2 = elem2.lastName.toLowerCase();
	          return name1 > name2 ? -1 : name1 < name2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_COMPANY_NAME_A_Z) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.company.toLowerCase();
	          var name2 = elem2.company.toLowerCase();
	          return name1 < name2 ? -1 : name1 > name2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_COMPANY_NAME_Z_A) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.company.toLowerCase();
	          var name2 = elem2.company.toLowerCase();
	          return name1 > name2 ? -1 : name1 < name2 ? 1 : 0;
	        });
	      }
	
	      return sortedAddressList;
	    },
	
	    /**
	     * Populate address range which is currently displayed.
	     * @param start - range bottom index
	     * @param end - range up index
	     * @param numberOfEntries - overall number of addresses of particular ttype( shipping or billing )
	     */
	    populateDisplayedEntriesRange: function populateDisplayedEntriesRange(start, end, numberOfEntries) {
	      $('.results > label').map(function () {
	        $(this).text(addressBoxLabels.addressesRange);
	        $(this).text($(this).text().replace('{0}', start));
	        $(this).text($(this).text().replace('{1}', end));
	        $(this).text($(this).text().replace('{2}', numberOfEntries));
	      });
	    },
	
	    /**
	     * Get addresses for particular page
	     * @param addresses - address list
	     * @param pageNum - number of page to be displayed
	     * @return address list for particular page
	     */
	    getEntriesForPage: function getEntriesForPage(addresses, pageNum) {
	      var addressesPerPage = this.getEntriesPerPage();
	      var totalPagesNum = addresses.length % addressesPerPage == 0 ? parseInt(addresses.length / addressesPerPage) : parseInt(addresses.length / addressesPerPage) + 1;
	      if (pageNum > totalPagesNum) {
	        pageNum = totalPagesNum;
	        this.setCurrentPageNumber(pageNum);
	      }
	      var startIndex = (pageNum - 1) * addressesPerPage;
	      var endIndex = pageNum * addressesPerPage < addresses.length ? pageNum * addressesPerPage - 1 : addresses.length - 1;
	      var resultArr = [];
	      $.each(addresses, function (index, value) {
	        if (startIndex <= index && index <= endIndex) {
	          resultArr.push(value);
	        }
	      });
	      this.populateDisplayedEntriesRange(startIndex + 1, endIndex + 1, addresses.length);
	      return resultArr;
	    },
	
	    /**
	     * Dynamically populate addresses.
	     * @param  - id of block which will contain created content
	     * @param newAddressBtnId - id of section which holds new address button.
	     * @pageNum - page number for display
	     */
	    populateAddressSection: function populateAddressSection(blockId, pageNum) {
	      if (typeof pageNum === 'undefined') {
	        pageNum = this.getCurrentPageNumber();
	      } else {
	        this.setCurrentPageNumber(pageNum);
	      }
	
	      var addresses = this.filterAddressesByType(this.activeTab);
	      if (addresses.length > 0) {
	        $('#sort-section').show();
	        addresses = this.sort(addresses);
	      } else {
	        $('#sort-section').hide();
	      }
	
	      var addressesForDisplay = this.getEntriesForPage(addresses, pageNum);
	
	      this.createAddressesMatrix(blockId, addressesForDisplay);
	      this.addjustCells('.resizable');
	      this.populatePagingSection('search-results', addresses.length);
	      // TODO Kurt says: This is slightly disorienting on desktop resolution
	      if (COSTCO.util.getScreenType() != 'DESKTOP') {
	        this.backToTop();
	      }
	    },
	
	    /**
	     * [description]
	     * @param  {[type]} newAddressBtnId [description]
	     * @return {[type]}                 [description]
	     */
	    createNewAddressButton: function createNewAddressButton(newAddressBtnId) {
	      $('#' + newAddressBtnId).html('');
	      var btnTemplate = COSTCO.util.tmpl('add_new_address_btn_tmpl', {});
	      btnTemplate = $(btnTemplate);
	      $('#' + newAddressBtnId).append(btnTemplate);
	    },
	
	    /**
	     * Create address matrix
	     * @param blockId - id of block which will contain created content
	     * @addressesForDisplay - array of addresses which will be displayed
	     */
	    createAddressesMatrix: function createAddressesMatrix(blockId, addressesForDisplay) {
	      var columnNumber = this.getColumnNumber();
	      $('#' + blockId).html('');
	      $.each(addressesForDisplay, function (index, value) {
	        var template = value.isPrimary ? COSTCO.util.tmpl('address_box_default', value) : COSTCO.util.tmpl('address_box', value);
	        template = $(template);
	        template.find('#address-info-container').addClass('resizable-' + parseInt((index + 1) / columnNumber));
	        // Adjust checkbox style and label text
	        var checkboxElem = template.find('#setDefault_' + value.addressIndex);
	        COSTCO.CAddressBook.setAHrefCellLook($(checkboxElem), !value.isPrimary);
	
	        $('#' + blockId).append(template);
	      });
	    },
	
	    createDefaultShippingAddressErrorDiv: function createDefaultShippingAddressErrorDiv(errorDivId) {
	      var defaultShippingAddress = this.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING)[0];
	      var errorDivTemplate = COSTCO.util.tmpl('tmpl_default_address_error', defaultShippingAddress);
	      $('#' + errorDivId).append(errorDivTemplate);
	      $('#' + errorDivId).show();
	    },
	
	    /**
	     * Populate paging section
	     * @param blockId - id of block which will contain created content
	     */
	    populatePagingSection: function populatePagingSection(blockId, addressListSize) {
	      var addressesPerPage = this.getEntriesPerPage();
	      var currentPage = this.getCurrentPageNumber();
	      if (addressListSize > addressesPerPage) {
	        $('#' + blockId).show();
	        var elem = $('#' + blockId + ' div > ul');
	        elem.html('');
	        elem.append('<li class="back"><a id="previous-page" class="body-copy-link" href="javascript:void(0)"><i class="co-arrow-left"></i></a></li>');
	
	        var pagesNum = addressListSize % addressesPerPage == 0 ? parseInt(addressListSize / addressesPerPage) : parseInt(addressListSize / addressesPerPage) + 1;
	        var pagesArray = [];
	        for (i = 1; i <= pagesNum; i++) {
	          pagesArray.push({
	            'containerId': '\'addresses-list-box\'',
	            'pageNum': i
	          });
	        }
	        var pageIndex = currentPage - 1;
	        $.each(pagesArray, function (index, value) {
	          var template = COSTCO.util.tmpl('address_pagination_box', value);
	          template = $(template);
	          var pageBtn = template.find('.btn');
	          if (index == pageIndex) {
	            pageBtn.addClass('btn-primary');
	          } else {
	            pageBtn.removeClass('btn-primary');
	          }
	          elem.append(template);
	        });
	        elem.append('<li class="forward"><a id="next-page" class="body-copy-link" href="javascript:void(0)"><i class="co-arrow-right"></i></a></li>');
	        if (currentPage == 1 || pagesNum == 1) {
	          $('#previous-page').parent().hide();
	        } else {
	          $('#previous-page').parent().show();
	          $('#previous-page').unbind().on('click', function () {
	            COSTCO.CAddressBook.populateAddressSection('addresses-list-box', currentPage - 1);
	          });
	        }
	        if (currentPage == pagesNum || pagesNum == 1) {
	          $('#next-page').parent().hide();
	        } else {
	          $('#next-page').parent().show();
	          $('#next-page').unbind().on('click', function () {
	            COSTCO.CAddressBook.populateAddressSection('addresses-list-box', currentPage + 1);
	          });
	        }
	        //	    		$('.results > label').map(function() {
	        //	    			$(this).show();
	        //	    		});
	      } else {
	        $('#' + blockId).hide();
	        //	    		$('.results > label').map(function() {
	        //	    			$(this).hide();
	        //	    		});
	      }
	    },
	
	    /**
	     * Returns active address type
	     * @return address type string: Shipping or Billing
	     */
	    getActiveAddressType: function getActiveAddressType() {
	      var addressType = $('#shippingTab').hasClass('active') ? CAddressBook.ADDRESS_TYPE_SHIPPING : CAddressBook.ADDRESS_TYPE_BILLING;
	      return addressType;
	    },
	
	    setActiveAddressType: function setActiveAddressType() {
	      if (this.activeTab === CAddressBook.ADDRESS_TYPE_SHIPPING) {
	        $('#billingTab').removeClass('active');
	        $('#shippingTab').addClass('active');
	      } else {
	        $('#shippingTab').removeClass('active');
	        $('#billingTab').addClass('active');
	      }
	    },
	
	    getCurrentPageNumber: function getCurrentPageNumber() {
	      var pageNumber = $('#shippingTab').hasClass('active') ? this.currentShippingPage : this.currentBillingPage;
	      return pageNumber;
	    },
	
	    setCurrentPageNumber: function setCurrentPageNumber(pageNum) {
	      if ($('#shippingTab').hasClass('active')) {
	        this.currentShippingPage = pageNum;
	      } else {
	        this.currentBillingPage = pageNum;
	      }
	    },
	
	    /**
	     * Filters addresses by type: Shipping or Billing
	     * @param address type
	     * @return address list of particular type
	     */
	    filterAddressesByType: function filterAddressesByType(addressType) {
	      var result = [];
	      $.each(COSTCO.util.addresses, function (index, value) {
	        if (value.addressType.trim() === addressType) {
	          var addressObj = {};
	          addressObj.addressIndex = index;
	          addressObj.defaultAddressType = addressType;
	          addressObj.addressId = value.id;
	          addressObj.isPrimary = value.isPrimary === '1';
	          addressObj.company = value.company;
	          addressObj.firstName = value.first;
	          addressObj.lastName = value.last;
	          addressObj.addressLine0 = value.line1;
	          addressObj.addressLine1 = value.line2;
	          addressObj.city = value.city;
	          addressObj.state = value.state;
	          addressObj.postalCode = value.zip;
	          addressObj.phoneNo = value.phone ? value.phone.substring(0, 3) + '-' + value.phone.substring(3, 6) + '-' + value.phone.substring(6) : "";
	          addressObj.email = value.email;
	          addressObj.addressField1 = '';
	          addressObj.userAddressType = value.userAddressType;
	          addressObj.showAddressType = value.showAddressType;
	          addressObj.showAddressTypeEdit = value.showAddressTypeEdit;
	
	          result.push(addressObj);
	        }
	      });
	      return result;
	    },
	
	    /**
	     * Adds new address
	     * @param setDefault - sets newly added address as default one
	     */
	    addNewAddress: function addNewAddress(setDefault) {
	      var addressType = $('#shippingTab').hasClass('active') ? 'S' : 'B';
	      var addressOptions = {};
	      if (setDefault != undefined) {
	        addressOptions.setAsDefaultAddress = setDefault;
	      }
	      this.createNewAddress(addressType, addressOptions);
	    },
	
	    /**
	     * Prepares data for add address modal display
	     * @param {String} addressType	Type of address to create ('S' - shipping, 'B' - billing)
	     * @param addressOptions - address options
	     */
	    createNewAddress: function createNewAddress(addressType, addressOptions) {
	      if (addressOptions == undefined) {
	        addressOptions = {};
	      }
	
	      addressOptions.url = CAddressBook.url.MANAGE_ADDRESS_ADD;
	      addressOptions.tmplFooterText = 'tmpl_rx_add_edit_address_footer';
	      //National delivery UX change to remove Terms and Condition Modal in Address book for BD US
	      if (COSTCO.util.isBusinessDelivery() && addressType === 'S' && !COSTCO.util.isNdEnabled()) {
	        this.termsAndCond(addressType, undefined, 'add', addressOptions);
	      } else {
	        this.openAddressAddModal(addressType, undefined, 'add', addressOptions);
	      }
	    },
	
	    /**
	     * Opens add/edit address modal
	     * If it is edit modal, jQuery validator is triggered immediately
	     * @param {String} addressType			Type of address to create ('S' - shipping, 'B' - billing)
	     * @param {Object} addressObj			If mode 'edit', address object to prepopulate input fields in modal
	     * @param {String} mode					Mode of address modal ('add' - add new address, 'edit' - edit existing address)
	     * @param {String} addressOptions		Various options for address add/edit
	     */
	    openAddressAddModal: function openAddressAddModal(addressType, addressObj, mode, addressOptions) {
	      if (addressOptions.tmplFooterText) {
	        var footerText = COSTCO.util.tmpl(addressOptions.tmplFooterText, {});
	      }
	
	      var openAddress = function openAddress(error) {
	        var _COSTCO$CAddress$base;
	
	        var htmlBody = COSTCO.CAddressForm.createHtml(addressType, addressObj, mode, undefined, undefined, undefined, error);
	        var key = "footerText";
	        var isEditDefaultShippingAddress = false;
	        if (mode == "edit") {
	          if (addressOptions.setAsDefaultAddress) {
	            key = "footerText2";
	            isEditDefaultShippingAddress = true;
	          }
	
	          COSTCO.CAddressForm.validate(addressType, htmlBody, isEditDefaultShippingAddress);
	        }
	
	        COSTCO.CAddress.baseModal(addressType, mode, (_COSTCO$CAddress$base = {
	          body: htmlBody
	        }, _defineProperty(_COSTCO$CAddress$base, key, footerText), _defineProperty(_COSTCO$CAddress$base, 'primary_event', function primary_event() {
	          if (COSTCO.CAddressForm.validate(addressType)) {
	            addressOptions.addressBookReinit = true;
	            COSTCO.CAddressForm.submit(addressType, false, addressOptions);
	          }
	        }), _defineProperty(_COSTCO$CAddress$base, 'onshown', function onshown() {
	
	          if (addressOptions.setAsDefaultAddress) {
	            $('#set-default').val('true');
	            $('#set-default').attr('checked', true);
	          } else {
	            $('#set-default').val('false');
	            $('#set-default').attr('checked', false);
	          }
	
	          if ($('input[name=invalid-ship-addr]').length > 0 && $('input[name=invalid-ship-addr]').val() === 'true') {
	            var formId = $('#address-modal-modal');
	            var addressField = '#address1Id';
	            COSTCO.dialog.sameAddressValidation(formId, addressField);
	          }
	          COSTCO.CAddressForm.updateAddressModal();
	        }), _COSTCO$CAddress$base));
	      };
	
	      openAddress(undefined);
	
	      $('body').unbind('costco.address.error').bind('costco.address.error', function (event, error) {
	        openAddress(error);
	      });
	
	      $('.country-select').on('change', function () {
	        var stateProvList = COSTCO.CAddressForm.addressVal;
	        var country = $('.country-select').val();
	        var stateOptions = COSTCO.CAddressForm.getStateOptions(stateProvList, addressType, { country: country });
	        $('.stateprov-select').empty().append(stateOptions);
	        $('#postalId').val('');
	        $('#cityId').val('');
	
	        if ($('.country-select').val() === 'US') {
	          $('[name=postal]').unmask().mask('00000-0000');
	          COSTCO.CAddressBook.updateCountryLabels(country);
	        } else if ($('.country-select').val() === 'CA') {
	          $('[name=postal]').unmask().mask('S0S 0S0');
	          COSTCO.CAddressBook.updateCountryLabels(country);
	        }
	      });
	
	      if (mode === 'add' && $('#address-same-as-ship').length > 0 && this.getActiveAddressType() === CAddressBook.ADDRESS_TYPE_BILLING) {
	        $('#address-same-as-ship').removeClass('hide');
	      }
	
	      if ($('#rx-email-address').length > 0) {
	        $('#emailId').val($('#rx-email-address').html().trim());
	      }
	      var legendTypeName = 'legendBillingText';
	      if (addressType == 'S') {
	        legendTypeName = 'legendShippingText';
	      }
	      $('#address-modal-modal fieldset legend').text($("input[name=" + legendTypeName + "]:hidden").val());
	    },
	
	    updateCountryLabels: function updateCountryLabels(country) {
	      var $form = COSTCO.CAddressForm.getForm();
	      var $postal = $form.find('label[for="postalId"]');
	      var $state = $form.find('label[for="stateId"]');
	      if (country == 'US') {
	        $postal.html(messages.RWD_US_ZIP_LABEL);
	        $state.html(messages.RWD_US_STATE_LABEL);
	      } else {
	        $postal.html(messages.RWD_CA_ZIP_LABEL);
	        $state.html(messages.RWD_CA_STATE_LABEL);
	      }
	    },
	
	    /**
	     * Prepares data for edit address modal display
	     * @param {String} addressType	Type of address to edit ('S' - shipping, 'B' - billing)
	     * @param {Object} obj 					Address object to be edited
	     */
	    editAddress: function editAddress(obj) {
	      var addressType = $('#shippingTab').hasClass('active') ? 'S' : 'B';
	      var addressJson = COSTCO.CAddress.getAddressJson(obj)[0];
	      var validateAddressTypeModal = [];
	      data = addressJson;
	      var addressOptions = {};
	      addressOptions.url = CAddressBook.url.MANAGE_ADDRESS_UPDATE;
	      addressOptions.tmplFooterText = 'tmpl_rx_add_edit_address_footer';
	      if (data.userAddressType != 'U') {
	        validateAddressTypeModal[3] = data.userAddressType;
	      }
	      if (addressJson.isPrimary && addressJson.isPrimary === '1') {
	        addressOptions.setAsDefaultAddress = addressJson.isPrimary;
	        addressOptions.tmplFooterText = 'tmpl_add_edit_address_footer';
	      }
	      if (addressType === 'B') {
	        addressOptions.tmplFooterText = 'tmpl_add_edit_billing_address_footer';
	      }
	      addressOptions.validateParams = validateAddressTypeModal;
	      //National delivery UX change to remove Terms and Condition Modal in Address book for BD US
	      if (COSTCO.util.isBusinessDelivery() && addressType === 'S') {
	        if (COSTCO.util.isNdEnabled()) {
	          COSTCO.CAddressBook.openAddressAddModal(addressType, data, 'edit', addressOptions);
	        } else {
	          this.termsAndCond(addressType, data, 'edit', addressOptions);
	        }
	      } else {
	        CAddressBook.openEditAddressModal(addressType, data, addressOptions);
	      }
	    },
	
	    openEditAddressModal: function openEditAddressModal(addressType, data, addressOptions) {
	      if (data.addressType === 'S' && data.isPrimary === '1') {
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE,
	          body: $('#tmpl_default_address_info_dialog').html(),
	          primary: messages.JS_DIALOG_ACCEPT,
	          primary_event: function primary_event() {
	            CAddressBook.openAddressAddModal(addressType, data, 'edit', addressOptions);
	            $('#costcoModal').modal('hide');
	          },
	          secondary: messages.JS_DIALOG_CANCEL
	        });
	      } else {
	        CAddressBook.openAddressAddModal(addressType, data, 'edit', addressOptions);
	      }
	    },
	
	    /**
	     * Sets address to be default
	     * @param {String} addressId 		Address id to be set as default
	     */
	    setDefault: function setDefault(addressId, onDoneCallback) {
	
	      if (typeof onDoneCallback === 'undefined') {
	        onDoneCallback = function onDoneCallback() {
	          COSTCO.CAddressBook.init();
	        };
	      }
	      COSTCO.Checkout.ajax_update_state({
	        url: CAddressBook.url.MANAGE_ADDRESS_SET_DEFAULT,
	        method: 'POST',
	        dataType: 'json',
	        data: {
	          authToken: COSTCO.Checkout.getAuthToken(),
	          mode: 'SET_DEFAULT',
	          formdata: encodeURIComponent(JSON.stringify({
	            'id': addressId
	          }))
	        },
	        done: onDoneCallback
	      });
	    },
	
	    /**
	     * Removes address
	     * @param {String} addressId - Address id to be removed
	     */
	    remove: function remove(addressId) {
	      COSTCO.Checkout.ajax_update_state({
	        url: CAddressBook.url.MANAGE_ADDRESS_REMOVE,
	        method: 'POST',
	        dataType: 'json',
	        data: {
	          authToken: COSTCO.Checkout.getAuthToken(),
	          mode: 'DELETE',
	          formdata: encodeURIComponent(JSON.stringify({
	            'id': addressId
	          }))
	        },
	        done: function done() {
	          COSTCO.CAddressBook.init();
	        }
	      });
	    },
	
	    /**
	     * Opens default address confirmation modal and executes appropriate action
	     * @param addressId - address id
	     * @param element - html element which is going to be updated
	     */
	    setDefaultAddress: function setDefaultAddress(addressId, element) {
	      if ($('#shippingTab').hasClass('active') && CAddressBook.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING).length > 0 && !COSTCO.util.isBusinessDelivery()) {
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE,
	          body: $('#tmpl_default_address_info_dialog').html(),
	          primary: messages.JS_DIALOG_ACCEPT,
	          primary_event: function primary_event() {
	            CAddressBook.setDefault(addressId);
	            $('#costcoModal').modal('hide');
	          },
	          secondary: messages.JS_DIALOG_CANCEL
	        });
	      } else {
	        CAddressBook.setDefault(addressId);
	      }
	    },
	
	    /**
	     * Opens remove confirmation modal
	     * @param addressId - id of address for removal
	     */
	    removeAddress: function removeAddress(addressId) {
	      COSTCO.dialog.createExtDialogBox({
	        title: addressBoxLabels.removeAddressTitle,
	        body: $('#tmpl_remove_address_info_dialog').html(),
	        primary: addressBoxLabels.removeLink,
	        primary_event: function primary_event() {
	          CAddressBook.remove(addressId);
	          $('#costcoModal').modal('hide');
	        },
	        secondary: messages.JS_DIALOG_CANCEL,
	        onshown: function onshown() {
	          COSTCO.CAddressForm.updateAddressModal();
	        }
	      });
	    },
	
	    setAHrefCellLook: function setAHrefCellLook(element, toDefault) {
	      var parentDiv = element.parent().closest('div');
	      var aElem = void 0;
	      if (toDefault) {
	        aElem = parentDiv.find('a').attr('id', $(element).attr('id'));
	      } else {
	        aElem = parentDiv.find('p');
	      }
	
	      var linkText = $('#shippingTab').hasClass('active') ? toDefault ? addressBoxLabels.setShippingAddress : addressBoxLabels.defaultShippingAddress : toDefault ? addressBoxLabels.setBillingAddress : addressBoxLabels.defaultBillingAddress;
	      aElem.html(linkText);
	    },
	
	    /**
	     * Returns default address of particular address type.
	     * @return default address
	     */
	    getDefaultAddress: function getDefaultAddress(addressType) {
	      var defaultAddress = [];
	      $.each(CAddressBook.filterAddressesByType(addressType), function (index, value) {
	        if (value.isPrimary) {
	          defaultAddress.push(value);
	        }
	      });
	      return defaultAddress;
	    },
	
	    /**
	     * Function which populates new billing address fields with
	     * default shipping address data.
	     * @param input
	     */
	    handleBillingSameAsShipping: function handleBillingSameAsShipping(input) {
	      if (input.checked) {
	        var defaultShippingAddress = this.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING);
	        if (defaultShippingAddress.length > 0) {
	          COSTCO.util.getAddressBatchPage('S', 'FIRSTNAME', 'ASC', '1', '96', function (data) {
	            data = COSTCO.CAddress.getAddressJson(defaultShippingAddress[0].addressId)[0];
	
	            if (data != null) {
	              delete data['id'];
	              delete data['nickname'];
	              // delete data['isPrimary'];
	              COSTCO.CAddressForm.populateAddressModal($(input.form), data, 'modal');
	            }
	          });
	        }
	      } else {
	        COSTCO.CAddressForm.populateAddressModal($(input.form), '', 'modal');
	      }
	    },
	
	    backToTop: function backToTop() {
	      document.body.scrollTop = 0; // For Chrome, Safari and Opera
	      document.documentElement.scrollTop = 0; // For IE and Firefox
	    },
	    /**
	    * This function is used for showing the  and condition in cased of BD
	    * shipping address
	    */
	    termsAndCond: function termsAndCond(addressType, addressObj, mode, addressOptions) {
	
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.BD_DELIVERY_ADDRESS_TERMS,
	        body: $('#tmpl_delivery_warning').html(),
	        primary: messages.JS_DIALOG_AGREE,
	        primary_event: function primary_event() {
	          COSTCO.CAddressBook.openAddressAddModal(addressType, addressObj, mode, addressOptions);
	        },
	        secondary: messages.JS_DIALOG_CANCEL
	      });
	    },
	    /**
	     * This method shows the Address type popup for change link in Address Book
	     * Calls the 'AjaxManageAddressCmd' to save user selected Address type to DB
	    */
	    addUserSelectionFromAddressBook: function addUserSelectionFromAddressBook(addressId) {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.SET_ADDRESS_TYPE,
	        body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
	        primary: messages.SET_ADDRESS_TYPE,
	        popover: true,
	        primary_event: function primary_event() {
	          if (document.querySelector('input[name="addrtype"]:checked') == null) {
	            $('.addresstype-setup-notification').removeClass("hidden");
	            $('.addresstype-setup-notification').find("div").html(messages.ERR_ADDRESS_TYPE_NOT_SELECTED);
	          } else {
	            userAddressType = document.querySelector('input[name="addrtype"]:checked').value;
	            onDoneCallback = function onDoneCallback() {
	              COSTCO.CAddressBook.init();
	            };
	            COSTCO.Checkout.ajax_update_state({
	              url: CAddressBook.url.MANAGE_ADDRESSTYPE_UPDATE,
	              method: 'POST',
	              dataType: 'json',
	              data: {
	                authToken: COSTCO.Checkout.getAuthToken(),
	                mode: 'SET_ADDRESSTYPE',
	                formdata: encodeURIComponent(JSON.stringify({
	                  'id': addressId, 'userAddressType': userAddressType
	                }))
	              },
	              done: onDoneCallback
	            });
	            COSTCO.dialog.close();
	          }
	        }
	      });
	      $('.close').addClass("hidden");
	    },
	
	    addressbookTabAriaExpandedSwitch: function addressbookTabAriaExpandedSwitch() {
	      $('.costco-tabs-alternate .table-cell .active').find('a').attr('aria-expanded', 'true');
	
	      $('.costco-tabs-alternate .table-cell a').on('click', function (e) {
	        if ($('#shippingTab').attr('class').includes('active')) {
	          $('#shippingTab').find('a').attr('aria-selected', 'true');
	          $('#billingTab').find('a').attr('aria-selected', 'false');
	        } else {
	          $('#shippingTab').find('a').attr('aria-selected', 'false');
	          $('#billingTab').find('a').attr('aria-selected', 'true');
	        }
	      });
	    },
	    //Checks to see if the default shipping address has a valid phone number and email address
	    //Prompts the user to verify default shipping address if there is a problem with either 
	    validateShippingAddressPhoneNumber: function validateShippingAddressPhoneNumber() {
	      var PHONE_NUMBER_REGEX = new RegExp("^\\(?([2-9]{1}[0-9]{2})\\)?[-.\\s]?([0-9]{3})[-.\\s]?([0-9]{4})$");
	      var defaultShippingAddress = this.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING);
	      if (defaultShippingAddress.length > 0) {
	        var hasValidPhoneNumber = PHONE_NUMBER_REGEX.test(defaultShippingAddress[0].phoneNo.substring(0, 12));
	        var hasEmail = Boolean(defaultShippingAddress[0].email);
	        if (!hasValidPhoneNumber || !hasEmail) {
	          COSTCO.CAddressBook.createDefaultShippingAddressErrorDiv('invalidAddressError');
	        }
	      }
	    },
	
	    analytics: function analytics() {
	      var addressBookPage = document.getElementById("address-book");
	      if (typeof addressBookPage != 'undefined' && addressBookPage != null) {
	        window.digitalData = window.digitalData || {};
	        digitalData.pageName = "My Account | Address Book";
	        digitalData.pageType = "My Account";
	      }
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.CAddressBook = CAddressBook;
	  return CAddressBook;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title preferences.js: Sub-module for Account pages
	 * @description This module is used to handle account preferences tasks
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(11), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util, membershipHelper, verification) {
	  var Preferences = {
	    /**
	     * Initialization of the module.
	     */
	    init: function init() {
	      verification.init();
	      this.clearNotification();
	      // @TODO MembershipMetaData chooses which URL to use to get the membership
	      // meta data. If its a citiCardRequest, use this one. This might be
	      // appropriate in the membership-data.js.getMembershipData
	      //
	      // Preferences.ajaxHandler(COSTCO.util.makeUrl(
	      //   '/AjaxCitiMembershipMetaDataView', {
	      //     pseudo: new Date().getTime(),
	      //   }), null);
	    },
	    /**
	     * When you select a preference checkbox, this function will remove any
	     * success or error messages that may be at the top of the page.
	     * @return {void}
	     */
	    clearNotification: function clearNotification() {
	      $('#CommunicationPrefForm input[type=checkbox]').unbind('click').on('click', function () {
	        $('#notification-message').removeClass();
	        $('#notification-message').children().remove();
	      });
	    },
	    /**
	     * Grab the communication preferences from the server. This is invoked
	     * by the renderMarketing function when a user switches between their
	     * WCS and CRM emails.
	     * @return {jQuery.Deferred} The promise to be chained to the calling
	     *                               function.
	     */
	    getCommunicationPreferences: function getCommunicationPreferences() {
	      return COSTCO.util.ajax({
	        url: '/MemberCommunicationPreferencesRetrieveCmd',
	        type: 'POST',
	        dataType: 'json',
	        data: $('#CommunicationPrefForm').serialize()
	      });
	    },
	    /**
	     * This is a wrapper to setting the user's preferences. By default it will
	     * call /MemberCommunicationPreferencesRetrieveCmd to grab this data. This
	     * service returns an array representing the marketing data. Passing true
	     * indicates that we want to call getMembershipData
	     * (/AjaxMembershipMetaDataView) to grab this marketing data which has a
	     * slightly different data structure.
	     * @param  {Boolean} isMemetaDataResp If we're calling this function
	     * @return {void}
	     */
	    renderMarketing: function renderMarketing(isMemetaDataResp) {
	      var _this = this;
	
	      var emailData = $('#comm_prefs_email_dropdown').val();
	      $('#email').val(emailData);
	      isMemetaDataResp ? membershipHelper.getMembershipData().done(function (data) {
	        _this.setInputs(data);
	      }) : this.getCommunicationPreferences().done(function (data) {
	        _this.setInputs(data);
	      });
	    },
	    /**
	     * Actually sets the preferences inputs using the values returned from
	     * whichever service response we retreive.
	     * @param  {Array|Object} data The data to use to set inputs. Array if
	     *                             from /MemberCommunicationPreferencesRetrieveCmd
	     *                             Object if /AjaxMembershipMetaDataView
	     * @return {void}
	     */
	    setInputs: function setInputs(data) {
	      var _this2 = this;
	
	      var marketingArr = Array.isArray(data) ? data : data.caller && data.caller.marketing ? data.caller.marketing : [];
	      marketingArr.forEach(function (mkt) {
	        var key = mkt.name.value;
	        var value = mkt.value.value;
	        var id = void 0;
	        switch (key) {
	          case 'THIRDPARTYINFORMATIONSHARING':
	            id = 'receivePromoAndMarketingMaterialsThirdParty';
	            _this2.checkBox(id, value);
	            break;
	          case 'COSTCOMAILANDCOUPONS':
	            id = 'receivePromosAndMarketingMail';
	            _this2.radioButton(value);
	            break;
	          case 'EMAILCONTACT':
	            id = 'receivePromosAndMarketingEMail';
	            _this2.radioButton(value);
	            break;
	          case 'TEXTMSGALERT':
	            id = 'receivePromosAndMarketingTextMsg';
	            _this2.checkBox(id, value);
	            break;
	          case 'COSTCOCONNECTION':
	            id = 'receiveCostcoConnectionMail';
	            _this2.checkBox(id, value);
	            break;
	          case 'DIGITALCOSTCOCONNECTION':
	            id = 'receiveCostcoConnectionDigital';
	            _this2.checkBox(id, value);
	            break;
	          case 'TOBACCOSHARING':
	            id = 'receiveTobacco';
	            _this2.checkBox(id, value);
	            break;
	          case 'PRODUCTRECOMMEND':
	            id = 'showProdRecommend';
	            _this2.checkBox(id, value);
	            break;
	          default:
	            void 0;
	        }
	      });
	    },
	    /**
	     * Special handling for setting the appropritate checkboxes.
	     * @param  {String} id    The id of the input we're checking
	     * @param  {String} value The value 'YES', 'NO', comes from the service
	     *                        response and is interpreted to mean check/unchecked
	     * @return {void}
	     */
	    checkBox: function checkBox(id, value) {
	      if (typeof value != 'undefined' && value.toUpperCase() == 'YES') {
	        $('[name=' + id + ']').prop('checked', true);
	      } else {
	        $('[name=' + id + ']').prop('checked', false);
	      };
	    },
	    radioButton: function radioButton(value) {
	      if (typeof value != 'undefined' && value.toUpperCase() == 'YES') {
	        $('[id=receivePromosAndMarketingEMail]').prop('checked', true);
	        $('[id=receivePromosAndMarketingEMail2]').prop('checked', false);
	      } else {
	        $('[id=receivePromosAndMarketingEMail2]').prop('checked', true);
	        $('[id=receivePromosAndMarketingEMail]').prop('checked', false);
	      };
	    },
	    unCheckRadioOptIn: function unCheckRadioOptIn() {
	      $('[id=receivePromosAndMarketingEMail]').prop('checked', false);
	    },
	    unCheckRadioOptOut: function unCheckRadioOptOut() {
	      $('[id=receivePromosAndMarketingEMail2]').prop('checked', false);
	    },
	    /**
	     * The hanlder on the 'update preferences' button that saves the users
	     * preferences that they checked.
	     * @return {jQuery.Deferred} The chainable promise.
	     */
	    saveData: function saveData() {
	      console.log('Entering CommunicationPrefWidget.saveData');
	      return COSTCO.util.ajax({
	        type: 'POST',
	        // dataType: 'json',
	        url: COSTCO.util.makeUrl('/MemberCommunicationPreferencesUpdateCmd', {
	          membershipNumber: $('input[name=membershipNumber]').val(),
	          langId: wcs.langId,
	          storeId: wcs.storeId,
	          catalogId: wcs.catalogId
	        }),
	        data: $('#CommunicationPrefForm').serialize()
	      }).done(function (dataResponse) {
	        if (dataResponse == null || dataResponse == '' || !JSON.parse(dataResponse).error) {
	          util.notification.displayNotification(util.notification.type.SUCCESS, [messages.COMMUNICATION_PREFERENCES_SUCCESS_MESSAGE]);
	        } else {
	          var notifications = [];
	          JSON.parse(dataResponse).errorMessages.forEach(function (element) {
	            if (!notifications.includes(element)) {
	              notifications.push(element);
	            }
	          });
	          //notifications.push(messages.COMMUNICATION_PREFERENCES_ERROR_MESSAGE);
	          if (notifications.includes(messages._ERR_GENERIC_CRM_DOWN)) {
	            notifications = [messages._ERR_GENERIC_SAVE_COMMUNICATION_PREFERENCES];
	          }
	          util.notification.displayNotification(util.notification.type.ERROR, notifications);
	        }
	      }).fail(function (x, t, m) {
	        util.notification.displayNotification(util.notification.type.ERROR, [messages.COMMUNICATION_PREFERENCES_ERROR_MESSAGE]);
	        if (t === 'timeout') {
	          console.log('Session timed out.');
	        } else {
	          console.log('Couldn\'t update preferences.');
	        }
	      });
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.Preferences = Preferences;
	  return Preferences;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title utility.js: Global sub-module - combination of utility1.js and utility2.js
	 * @description A collection of functions used
	 * application wide. This module should contain
	 * generic utility code. No module specifics.
	 * 
	 * 07/27/2022
	 * utility.js was split into two files, utility1.js and utility2.js
	 * utility2.js contains fucntions that are not invoked on Home, Browse 
	 * and Product pages. Rest of the functions are in utility1.js
	 * 
	 * Only utility1.js is imported into new global module called global.hbp.js for Home, Browser & Product (HBP) pages
	 * Rest of the site will continue to load existing global.module.js which will inlcude both utility1.js and utility2.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util1, util2) {
	    var util = Object.assign({}, util1, util2);
	    if (typeof window.COSTCO == 'undefined') {
	        window.COSTCO = new Object();
	    }
	    window.COSTCO.util = util;
	    return util;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title utility1.js: Global sub-module
	 * @description A collection of functions used
	 * application wide. This module should contain
	 * generic utility code. No module specifics.
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var util = {
	    POSTAL_CODE_REGEX_US: /^(\d{5}(-\d{4})?$)$/,
	    POSTAL_CODE_REGEX_CA: /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/,
	    ATLEAST_ONE_ALPHABET: /^(?=.*[A-Za-z\u00C0-\u017F]).+/,
	    CC_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\&\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    /**
	     * John Resig's micro-templating function
	     * @param  {[string]} str  String ID of template
	     * @param  {[object]} data Object representing dynamic values
	     * @return {[string]}      HTML representation as
	     * a string
	     */
	    tmpl: function tmpl(str, data) {
	      var fn = !/\W/.test(str) ? this.tmpl(document.getElementById(str).innerHTML) : new Function('obj', 'var p=[],print=function(){p.push.apply(p,arguments);};' + 'with(obj){p.push(\'' + str.replace(/[\r\t\n]/g, ' ').split('<&').join('\t').replace(/((^|&>)[^\t]*)'/g, '$1\r').replace(/\t=(.*?)&>/g, '\',$1,\'').split('\t').join('\');').split('&>').join('p.push(\'').split('\r').join('\\\'') + '\');}return p.join(\'\');');
	      return data ? fn(data) : fn;
	    },
	    /**
	     * http://kenwheeler.github.io/slick/
	     * Generalized intialization of carousel.
	     * [carousel description]
	     * @param  {[string]} id        [description]
	     * @param  {[object]} options   [description]
	     * @param  {[object]} settings  [description]
	     * @return {[void]}             [description]
	     */
	    carousel: function carousel(id, options, settings) {
	      options = options || {};
	      $slider = $(id);
	      if (settings && settings.initFn) {
	        $slider.on('init', settings.initFn);
	      }
	      // Initialize the carousel. Waits for the application style sheet
	      // to load before initializing to ensure we have the correct
	      // CSS attributes attached to DOM elements
	      if (window.stylesLoaded) {
	        COSTCO.util.initCarousel($slider, options, settings);
	      } else {
	        document.addEventListener('styles-loaded', function initCarouselEvent() {
	          this.util.initCarousel(this.slider, options, settings);
	        }.bind({
	          util: COSTCO.util,
	          slider: $slider
	        }), false);
	      }
	    },
	
	    /**
	     * Initializes the carousel and does any additional bindings and/or
	     * settings.
	     * @param  {[type]} $slider  [description]
	     * @param  {[type]} options  [description]
	     * @param  {[type]} settings [description]
	     * @return {void}
	     */
	    initCarousel: function initCarousel($slider, options, settings) {
	      $slider.slick(options);
	      if (settings && settings.hasPause) {
	        // append a pause button
	        $slider.find('.slick-dots').append('<li class="pause"><button class="playToggle" role="button" type="button" aria-label="' + messages.PAUSE + '"></button></li>');
	        $slider.find('.pause button').unbind().on('click', function () {
	          // define slider to pause/play as the closest parent of the play/pause button
	          // cannot use $slider as by the time the page is initialized $slider points to a different carousel
	          var mySlider = $(this).closest('.slick-slider');
	          $(this).toggleClass('active');
	          if ($(this).hasClass('active')) {
	            mySlider.slick('slickPause');
	            $(this).attr('aria-label', messages.PLAY);
	          } else {
	            mySlider.slick('slickPlay');
	            $(this).attr('aria-label', messages.PAUSE);
	          }
	        });
	      }
	
	      if (options && options.arrows) {
	        // Update the aria label on the arrows
	        $slider.find('.slick-next').attr('aria-label', settings != undefined && settings.nextLabel != undefined ? settings.nextLabel : messages.NEXT_SLIDE);
	        $slider.find('.slick-prev').attr('aria-label', settings != undefined && settings.prevLabel != undefined ? settings.prevLabel : messages.PREV_SLIDE);
	      }
	
	      // put descriptive text for carousel dot buttons for ADA
	      $slider.each(function () {
	        $(this).find('li button[data-role=none]').each(function (index) {
	          $(this).text('slide set ' + (index + 1));
	        });
	        $(this).find('li').removeAttr('aria-hidden');
	      });
	
	      // Are there any events beforeChange/afterChange we are binding?
	      if (settings && settings.beforeFn) {
	        $slider.on('beforeChange', settings.beforeFn);
	      }
	      if (settings && settings.afterFn) {
	        $slider.on('afterChange', settings.afterFn);
	      }
	      if (settings && settings.destroyFn) {
	        $slider.on('destroy', settings.destroyFn);
	      }
	    },
	    setStyleRule: function setStyleRule(selector, rule) {
	      var stylesheet = document.styleSheets[document.styleSheets.length - 1];
	      COSTCO.util.safe(function () {
	        for (var i in document.styleSheets) {
	          if (document.styleSheets[i].href && document.styleSheets[i].href.indexOf('rwd') >= 0) {
	            stylesheet = document.styleSheets[i];
	            break;
	          }
	        }
	      })();
	      if (stylesheet.addRule) {
	        stylesheet.addRule(selector, rule);
	      } else if (stylesheet.insertRule) {
	        stylesheet.insertRule(selector + ' { ' + rule + ' }', stylesheet.cssRules.length);
	      }
	    },
	    /**
	     * Function decorator that wraps a provided function in a try/catch
	     * to mitigate breaking JS execution. Returns a new function which
	     * must be called.
	     * @param {[function]} fn
	     * @param {[string]} signature
	     * @return {[function]}
	     */
	    safe: function safe(fn, signature) {
	      return function util_safe() {
	        try {
	          fn.apply(this, arguments);
	        } catch (e) {
	          console.error(e, 'at ' + signature);
	        }
	      };
	    },
	    /**
	     * Function used to call bing to obtain location data based on query value
	     *
	     * Param
	     * 	  postalCode -> postalCode that we want to get the city or state for
	     * 	  sucessCallback -> function to be fired after the sucess of the ajax request
	     *
	     */
	    callBing: function callBing(postalCode, successCallback, errorCallback) {
	
	      var globalBingStaticKeyVar = $('#globalBingStaticKey').val();
	      var geocodeRequest = 'https://dev.virtualearth.net/REST/v1/Locations?postalCode=' + postalCode + '&includeNeighborhood=true&include=ciso2&maxResults=5&key=' + globalBingStaticKeyVar;
	
	      $.ajax({
	        url: geocodeRequest,
	        dataType: 'jsonp',
	        jsonp: 'jsonp',
	        error: function error(XMLHttpRequest, textStatus, errorThrown) {
	          console.log('error getting City / State' + postalCode);
	          if (errorCallback) errorCallback(XMLHttpRequest, textStatus, errorThrown);
	        },
	        success: function success(data, textstatus, XMLHttpRequest) {
	          console.log('BING - Success retrieving location');
	          successCallback(data, textstatus, XMLHttpRequest);
	        }
	      });
	    },
	
	    /**
	     * Calls the GeocodeAPI to obtain location data based on the provided postal code.
	     *
	     * @param {string} postalCode - The postal for which to get city/state data.
	     * @param {function} successCallback - The function to be called on successful AJAX request.
	     * @param {function} errorCallback - The function to be called if the AJAX request fails.
	     */
	    callGeocodeAPI: function callGeocodeAPI(postalCode, successCallback, errorCallback) {
	      var country = 'USA';
	      if (COSTCO.util.isCAStore() || COSTCO.util.isCABDStore()) {
	        country = 'CAN';
	        postalCode = postalCode.toUpperCase();
	      }
	
	      var geocodeRequestUrl = $('#geocodeServiceEndpoint').val() + '?q=' + postalCode + '&country=' + country;
	
	      var deriveCityStateFromZipCodeEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === 'true';
	      var allowedCityTypes = deriveCityStateFromZipCodeEnabled ? ['A', 'D'] : ['D'];
	
	      errorCallback = errorCallback || successCallback;
	      var handleError = function handleError() {
	        console.log('Error getting City/State for ' + postalCode);
	        var errData = [{ invalidZip: true }];
	        errorCallback(errData);
	      };
	
	      $.ajax({
	        url: geocodeRequestUrl,
	        dataType: 'json',
	        error: function error(jqXHR, textStatus, errorThrown) {
	          if (textStatus === 'error') {
	            handleError();
	          }
	        },
	        success: function success(data, textStatus, jqXHR) {
	          var filteredElements = data && data.length > 0 ? data.filter(function (element) {
	            return allowedCityTypes.includes(element.cityType);
	          }) : [];
	          if (filteredElements.length) {
	            console.log('GeocodeAPI - Success retrieving location');
	            successCallback(filteredElements, textStatus, jqXHR);
	          } else {
	            handleError();
	          }
	        }
	      });
	    },
	
	    /**
	     * BD only: calls Bing Location service and updates WC_BD_LOC cookie as pipe-separated City|ST|CC value.
	     * @param {string} zipCode
	     * @returns {object} Deferred
	     */
	    callBingAndUpdateBDLocationCookie: function callBingAndUpdateBDLocationCookie(zipCode) {
	      var deferred = $.Deferred();
	      var updateCookie = function updateCookie(data) {
	        if (data && data.resourceSets && data.resourceSets[0] && data.resourceSets[0].estimatedTotal > 0) {
	          var city = '' + data.resourceSets[0].resources[0].address.locality;
	          var state = '' + data.resourceSets[0].resources[0].address.adminDistrict;
	          var countryCode = '' + data.resourceSets[0].resources[0].address.countryRegionIso2;
	          var locationCookie = encodeURI(city.trim() + '|' + state.trim() + '|' + countryCode.trim());
	          var expiration = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
	          document.cookie = 'WC_BD_LOC=' + locationCookie + '; expires=' + expiration + '; path=/';
	          deferred.resolve(data);
	        } else {
	          document.cookie = 'WC_BD_LOC=; expires=' + new Date(0) + '; path=/';
	          console.log('BING - No location for ZIP/postal code: ' + zipCode + ', location cookie deleted.');
	          deferred.resolve(data);
	        }
	      };
	      COSTCO.util.callBing(zipCode, updateCookie);
	      return deferred.promise();
	    },
	    /**
	     * BD only: calls Geocode API service and updates WC_BD_LOC cookie as pipe-separated City|ST|CC value.
	     * @param {string} zipCode
	     * @returns {object} Deferred
	     */
	    callGeocodeApiAndUpdateBDLocationCookie: function callGeocodeApiAndUpdateBDLocationCookie(zipCode) {
	      var deferred = $.Deferred();
	      var updateCookie = function updateCookie(data) {
	        var totalResponses = data.length;
	        if (totalResponses != 0) {
	          var city = '' + data[0].city;
	          var state = '' + data[0].stateProvinceAbbreviation;
	          var countryCode = '' + data[0].country === "USA" ? "US" : "CA";
	          var locationCookie = encodeURI(city.trim() + '|' + state.trim() + '|' + countryCode.trim());
	          var expiration = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
	          document.cookie = 'WC_BD_LOC=' + locationCookie + '; expires=' + expiration + '; path=/';
	          COSTCO.util.setInSession("finalZipcode", data[0].postalCode);
	          deferred.resolve(data);
	        } else {
	          document.cookie = 'WC_BD_LOC=; expires=' + new Date(0) + '; path=/';
	          console.log('Geocode API - No location for ZIP/postal code: ' + zipCode + ', location cookie deleted.');
	          deferred.resolve(data);
	        }
	      };
	      COSTCO.util.callGeocodeAPI(zipCode, updateCookie);
	      return deferred.promise();
	    },
	    /**
	     * Calls bing and updates zip/state/city cookies
	     * @retrns jquery Deferred object
	     */
	    callBingAndUpdateCookies: function callBingAndUpdateCookies(zipcode) {
	
	      var deferred = $.Deferred();
	
	      var updateCookieValues = function updateCookieValues(data) {
	        var totalResponses = data.resourceSets[0].estimatedTotal;
	        if (totalResponses != 0) {
	          var province = null;
	          var country = null;
	          var city = data.resourceSets[0].resources[0].address.locality;
	          try {
	            //Check out if country is Puerto Rico specific
	            country = data.resourceSets[0].resources[0].address.countryRegionIso2;
	            if (country != undefined && country === 'PR') {
	              province = data.resourceSets[0].resources[0].address.countryRegionIso2;
	              country = 'US';
	            } else {
	              province = data.resourceSets[0].resources[0].address.adminDistrict;
	            }
	          } catch (e) {
	            province = "";
	          }
	          $.cookie("invCheckPostalCode", zipcode);
	          $.cookie("invCheckStateCode", province);
	          $.cookie("invCheckCity", city);
	          deferred.resolve(data);
	        } else {
	          deferred.reject();
	        }
	      };
	
	      COSTCO.util.callBing(zipcode, updateCookieValues);
	
	      return deferred.promise();
	    },
	    /**
	     * Calls GeocodeAPI and updates zip/state/city cookies
	     * @retrns jquery Deferred object
	     */
	    callGeocodeAPIAndUpdateCookies: function callGeocodeAPIAndUpdateCookies(zipcode) {
	
	      var deferred = $.Deferred();
	
	      var updateCookieValues = function updateCookieValues(data) {
	        var province = null;
	        var country = null;
	        var city = null;
	        var totalResponses = data.length;
	        if (totalResponses != 0) {
	          try {
	            city = data[0].city;
	            province = data[0].stateProvinceAbbreviation;
	            if (province == null) {
	              province = data[0].stateProvince;
	            }
	            country = data[0].country;
	          } catch (e) {
	            console.error('Error: ' + e.message);
	          }
	
	          //SFSTRY0035043 don't update header zip on multishipping page
	          if (typeof checkoutPage == 'undefined' || checkoutPage !== 'multi-shipping') {
	            $.cookie("invCheckPostalCode", zipcode);
	            $.cookie("invCheckStateCode", province);
	            $.cookie("invCheckCity", city);
	          }
	
	          deferred.resolve(data);
	        } else {
	          deferred.reject();
	        }
	      };
	
	      COSTCO.util.callGeocodeAPI(zipcode, updateCookieValues);
	
	      return deferred.promise();
	    },
	
	    hover_click_popover: function hover_click_popover(selector, _content, trigger, placement) {
	      var hoverClickElement = $(selector);
	      hoverClickElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false'
	      });
	      hoverClickElement.popover({
	        html: true,
	        sanitize: false,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content).html();
	        },
	        container: selector,
	        placement: placement || 'bottom',
	        trigger: trigger || 'hover click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('mouseleave focusout', '.popover', {
	        selector: selector,
	        content: _content,
	        placement: placement || 'bottom'
	      }, this.popoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        if (('#warehouse-locations' == selector || '#warehouse-locations-t' == selector) && $.cookie('WC_BD_ZIP') != null) {
	          $('#warehouse-search-field').val($.cookie('WC_BD_ZIP').replace('+', ' '));
	        }
	        $(this).attr('aria-expanded', 'true');
	
	        // used to create ada required attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '-id');
	        // Add tabindex of -1 to the content to prevent a safari bug where the relatedTarget
	        // is not populated when no tabindex is specified this caused all a and input
	        // to not function on click event
	        $(this).find('.popover-content').attr('tabindex', '-1');
	        // New requirement to focus on the first visible input on popover shown
	        var firstInput = $(this).find('a,input[type!=hidden]')[0];
	        $(this).removeAttr('aria-describedby');
	        $(this).find('.popover-content').removeAttr('aria-label');
	        $(this).find('.popover').removeAttr('role');
	        if (firstInput) $(firstInput).focus();
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      })
	      // stry0123297 - issue with IE with user having to double-click on text boxes in pop-overs
	      // solution to trigger the focus on text boxes on mousedown event
	      .on('mousedown', 'input[type=search], input[type=text]', function () {
	        $(this).trigger('focus');
	      });
	    },
	    click_popover: function click_popover(selector, _content2, trigger, placement) {
	      var ClickElement = $(selector);
	      ClickElement.attr({
	        'aria-expanded': 'false'
	      });
	      ClickElement.popover({
	        html: true,
	        sanitize: false,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content2).html();
	        },
	        container: selector,
	        placement: placement || 'bottom',
	        trigger: trigger || 'click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('click focusout', '.popover', {
	        selector: selector,
	        content: _content2,
	        placement: placement || 'bottom'
	      }, this.clickpopoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        if (('#warehouse-locations' == selector || '#warehouse-locations-t' == selector) && $.cookie('WC_BD_ZIP') != null) {
	          $('#warehouse-search-field').val($.cookie('WC_BD_ZIP').replace('+', ' '));
	        }
	        $(this).attr('aria-expanded', 'true');
	
	        if (_content2 === '#ca-grocery-delivery-postal-code-popover') {
	          $(this).find('#postal-code-input').val($('.user-entered-zip:first').text());
	        }
	
	        $('#delivery-postal-change,  #set-delivery-zipcode').removeAttr('aria-describedby');
	        $('#delivery-postal-change,  #set-delivery-zipcode').find('.popover').removeAttr('role');
	
	        // used to create ada required attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '-id');
	        // Add tabindex of -1 to the content to prevent a safari bug where the relatedTarget
	        // is not populated when no tabindex is specified this caused all a and input
	        // to not function on click event
	        $(this).find('.popover-content').attr('tabindex', '-1');
	        $(this).find('.popover-content').removeAttr('aria-label');
	        // New requirement to focus on the first visible input on popover shown
	        var firstInput = $(this).find('a,input[type!=hidden]')[0];
	        if (firstInput) $(firstInput).focus();
	        var firstBDInput = $(this).find('div > input[type!=hidden]')[0];
	        setTimeout(function () {
	          if (firstBDInput) {
	            $(firstBDInput).focus();
	          }
	        }, 100);
	        $('#postal-code-input-grocery').on('focusout', function () {
	          var content = $('#postal-code-input-grocery').val();
	          if (content !== undefined && content != '') {
	            $('#postal-code-input-grocery-label').addClass('active');
	          }
	        });
	        var nameOfCategoryInput = $('#delivery-postal-code-popover-container').parent().parent().parent().attr('id');
	        $('#delivery-postal-form').append('<input type="hidden" name="category-grocery-delivery" value="' + nameOfCategoryInput + '">');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      })
	      // stry0123297 - issue with IE with user having to double-click on text boxes in pop-overs
	      // solution to trigger the focus on text boxes on mousedown event
	      .on('mousedown', 'input[type=search], input[type=text]', function () {
	        $(this).trigger('focus');
	      });
	    },
	    hover_click_popover_nav: function hover_click_popover_nav(selector, _content3, trigger) {
	      var hoverClickElement = $(selector);
	      hoverClickElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false'
	      });
	      hoverClickElement.popover({
	        html: true,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content3).html();
	        },
	        container: selector,
	        placement: 'bottom',
	        trigger: trigger || 'hover click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('mouseleave focusout', '.popover', {
	        selector: selector,
	        content: _content3
	      }, this.popoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	        $(this).find('.popover').addClass('top50pixels');
	        $(this).find('.popover-content').attr('role', 'region');
	        // used to create ada attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '_id');
	        $(this).find('.popover-content').attr('aria-label', identifierSrting + '_label');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    /*
	     * Function used to handle closing the pop-over based on which element is receiving focus
	     * If it is not a child element of the pop-over the pop-over will close
	     */
	    popoverLeave: function popoverLeave(event) {
	      var eventType = event.type;
	      var isInput = $(event.target).is('input');
	      // relatedTarget of a focusout event is the element which is receiving focus.
	      var relatedTargetIsContained = $(event.data.selector).get(0) == event.relatedTarget || $.contains($(event.data.selector).get(0), event.relatedTarget);
	      // the first condition is to stop popover from closing if the user tries to select from the browser autocomplete box
	      // the second condition is to keep popover open if focus stays within the popover.
	      if (eventType == 'mouseleave' && !isInput || eventType == 'focusout' && event.target && !relatedTargetIsContained) {
	        if (eventType == 'mouseleave' && COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.zipCodeModal) {
	          // If ZIP code is set by Akamai, force-submit on popover leave
	          COSTCO.zipCodeModal.forceSubmitZipCode();
	        } else {
	          $(event.data.selector).popover('destroy');
	          COSTCO.util.hover_click_popover(event.data.selector, event.data.content, undefined, event.data.placement);
	        }
	      }
	    },
	    clickpopoverLeave: function clickpopoverLeave(event) {
	      event.stopPropagation();
	      var eventType = event.type;
	      var isInput = $(event.target).is('input');
	      // relatedTarget of a focusout event is the element which is receiving focus.
	      var relatedTargetIsContained = $(event.data.selector).get(0) == event.relatedTarget || $.contains($(event.data.selector).get(0), event.relatedTarget);
	      // the first condition is to stop popover from closing if the user tries to select from the browser autocomplete box
	      // the second condition is to keep popover open if focus stays within the popover.
	      if (eventType == 'click' && !isInput && isInput.length === 0 || eventType == 'focusout' && event.target && !relatedTargetIsContained) {
	        if (eventType == 'mouseleave' && COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.zipCodeModal) {
	          // If ZIP code is set by Akamai, force-submit on popover leave
	          COSTCO.zipCodeModal.forceSubmitZipCode();
	        } else {
	          setTimeout(function () {
	            $(event.data.selector).popover('destroy');
	            COSTCO.util.click_popover(event.data.selector, event.data.content, undefined, event.data.placement);
	          }, 100);
	        }
	      }
	    },
	    /*
	     * Function used to get whether or not the element is within the last or first
	     * link within the target level container
	     *
	     * If the need arise we can actually return the decimal position of the element
	     * by looping through the array not exactly needed here
	     *
	     * If the element is the first function will return 0
	     * If the element is the last function will return 1
	     * If other -1
	     */
	    get_element_position: function get_element_position(element, searchCriteria) {
	      var containerDivLinkArr = $(searchCriteria);
	      if (containerDivLinkArr.first()[0] == element) return 0;
	      if (containerDivLinkArr.last()[0] == element) return 1;
	      return -1;
	    },
	    /**
	     * This function makes icons in social networks popover content tabbable for ADA purposes
	     * @param {string} selector - the element which contains a social networks popover
	     * @return {void}
	     */
	    socialNetworksPopover: function socialNetworksPopover(selector) {
	      var popoverElement = $('.' + selector);
	      var popoverContent = $(".social-popover-container").html();
	      popoverElement.attr({
	        'data-content': popoverContent,
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false',
	        'tabindex': 0,
	        'role': 'tooltip'
	      });
	      popoverElement.popover({ sanitize: false }).on('keydown', function (event) {
	        //Enter event keycode
	        if (event.which === 13) {
	          $(this).popover('toggle');
	          //Esc event keycode
	        } else if (event.which === 27) {
	          $(this).popover('hide');
	          //Shift+Tab event keycode
	        } else if (event.shiftKey && event.keyCode === 9) {
	          $(this).popover('hide');
	        }
	      }).on('focus', function () {
	        $(this).popover('toggle');
	        var tooltipElement = $(this);
	        var lastIconArr = document.getElementsByClassName('last-icon');
	        var popoverContentId = $(this).attr('aria-describedby');
	        $.each(lastIconArr, function (index, value) {
	          if (popoverContentId !== undefined && $(lastIconArr[index]).length !== 0) {
	            $(lastIconArr[index]).on('blur', function () {
	              tooltipElement.popover('hide');
	            });
	          }
	        });
	        var contentElements = $('body').find('.social-popover');
	        contentElements.find('img').each(function () {
	          $(this).on('keypress', function () {
	            this.onclick();
	          });
	        });
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	      $(':not(.' + selector + ')').on('click', function () {
	        $('.co-help').each(function () {
	          if ($(this).attr('aria-expanded') === 'true') {
	            $(this).popover('hide');
	          }
	        });
	      });
	    },
	
	    /**
	     * Function used to simply show/hide popover capability to add accesibility features
	     * function popover parameters are expected to be defined in the element as normal bootsrap popover
	     *  hover and focus been triggered using data-trigger functionality. 
	     */
	    swatch_accesible_popover: function swatch_accesible_popover(selector) {
	      var popoverElement = $(selector);
	      popoverElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false',
	        'tabindex': 0,
	        'role': 'tooltip'
	      });
	      popoverElement.popover().on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    signupFormValidation: function signupFormValidation(element) {
	      $(element).validate({
	        rules: {
	          emailSignUp: {
	            required: true,
	            email: true
	          }
	        },
	        messages: {
	          emailSignUp: messages.ERR_INVALID_EMAIL
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          var p = element.parent('div');
	          error.addClass('emailSignUp');
	          p.after(error);
	        }
	      });
	      if ($(element).valid()) {
	        util.emailSubmit(element);
	      }
	      return false;
	    },
	    getMemberCookie: function getMemberCookie() {
	      var isSignedIn = void 0,
	          isMember = false,
	          isValidated = false,
	          isVerified = false,
	          isActive = false,
	          usage = '',
	          membershipNumber = '';
	      var m = $.cookie('wcMember'),
	          h = $.cookie('hashedUserId'),
	          p = $.cookie('rrDisabledPref'),
	          r = $.cookie('rrStoreFlag');
	      if (h != null && h == '""' || h == null && p == null && r == null || h == null && (p != null && p == '""' || r != null && r == '""')) {
	        isSignedIn = false;
	      } else if (h != null && h == '' || h == null && p == null && r == null || h == null && (p != null && p == '' || r != null && r == '')) {
	        isSignedIn = false;
	      } else if (h != null & h != '""' || h == null && p != null && p != '""' && r != null && r != '""') {
	        isSignedIn = true;
	      } else {
	        isSignedIn = 'undefined';
	      }
	      if (m != null && m != 'undefined') {
	        var cArray = m.split(',');
	        if (cArray.length > 1) {
	          if (cArray[1] == '1') {
	            isMember = true;
	          }
	          if (typeof cArray[3] !== 'undefined') {
	            usage = cArray[3];
	          }
	          if (cArray[4] == '1') {
	            isValidated = true;
	          }
	          if (cArray[5] == '1') {
	            isVerified = true;
	          }
	          if (cArray[6] == 'E0002') {
	            isActive = true;
	          }
	          if (typeof cArray[8] !== 'undefined') {
	            membershipNumber = cArray[8];
	          }
	        }
	      } else {
	        isMember = 'undefined';
	      }
	      return {
	        signedIn: isSignedIn,
	        costcoMember: isMember,
	        validated: isValidated,
	        verified: isVerified,
	        active: isActive,
	        usage: usage,
	        membershipNumber: membershipNumber
	      };
	    },
	    /**
	     * This function checks if the user has signed in
	     */
	    isUserSignedIn: function isUserSignedIn() {
	      return this.getMemberCookie().signedIn === "true";
	    },
	    checkSsoLogin: function checkSsoLogin(aTag) {
	      aTag.href += aTag.href.indexOf("?") < 0 ? "?redirectLogin=" + COSTCO.util.isUserLoggedIn() : "&redirectLogin=" + COSTCO.util.isUserLoggedIn();
	    },
	    disbleElementById: function disbleElementById(id) {
	      $("#" + id).hide();
	    },
	    checkAndDisableSignInButton: function checkAndDisableSignInButton() {
	      if (this.isUserLoggedIn()) this.disbleElementById("bd-specific-sign-in-button");
	    },
	
	    /**
	     * This function checks if the user has valid membership
	     */
	    isCostcoMember: function isCostcoMember() {
	      return this.getMemberCookie().costcoMember != 'undefined' ? userInfo.costcoMember : false;
	    },
	    /**
	     * sets a cookie with given name, value, expiration and domain
	     *
	     * @param  {[string]} cookieName - The name of the cookie to set
	     * @param  {[string]} cookieValue - The value for the cookie to set
	     * @param  {[int]} cookieExpires - The number of days until the cookie expires
	     * @parm   {[string]} cookieDomain - The domain of the cookie to set
	     * @return {void}
	     */
	    setCookie: function setCookie(cookieName, cookieVal, cookieExpires, cookieDomain) {
	      cookieExpires = parseInt(cookieExpires);
	      if (typeof cookieDomain !== 'undefined') {
	        $.cookie(cookieName, cookieVal, {
	          expires: cookieExpires,
	          path: '/',
	          domain: cookieDomain
	        });
	      } else {
	        $.cookie(cookieName, cookieVal, {
	          expires: cookieExpires,
	          path: '/'
	        });
	      }
	    },
	
	    /**
	     * Gets the language id of the users's session. default is -1(English)
	     * for US and -24(English) for CA
	     * @return {[int]} the langId
	     */
	    getLangId: function getLangId() {
	      var selectedLang = $.cookie(cookies.SELECTED_LANG_COOKIE);
	      var host = window.location.host;
	      var cookieDomain = wcs.domain;
	      if (host.indexOf('bd-cmc.vqa') > -1 || host.indexOf('bd-cmc.vuat') > -1 || host.indexOf('bd-cmc.ecom') > -1) {
	        cookieDomain = '.costco.com';
	      }
	      if (typeof selectedLang == 'undefined' || !selectedLang) {
	        if (wcs.hasOwnProperty('langId')) {
	          COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, wcs.langId, cookies.SELECTED_LANG_EXPIRES, cookieDomain);
	          return parseInt(wcs.langId);
	        } else {
	          // check for stgbrowse costco domains
	          if (host.indexOf('stgbrowseca') > -1 || host.indexOf('stgbrowse-ca') > -1 || host.indexOf('ca-cmc') > -1 || host.indexOf('ca-stage') > -1) {
	            return -24;
	          }
	          if (host.indexOf('.com') > -1) {
	            return -1; // Default .com lang
	          } else {
	            COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, "-24", cookies.SELECTED_LANG_EXPIRES, cookieDomain);
	            return -24; // Default .ca lang
	          }
	        }
	      } else {
	        // The selectedLanguage cookie exists and the selectedLanguageOld cookie does not exist. 
	        this.registerLanguageListener();
	      }
	      return selectedLang;
	    },
	    /**
	     * Get the warehouse number for the user's session - used mainly for image templates
	     */
	    getWarehouseNumber: function getWarehouseNumber() {
	      var langId = this.getLangId();
	      if (langId < -1) {
	        return 894;
	      } else {
	        return 847;
	      }
	    },
	    /**
	     * Gets the string value of the user's region. Default is null.
	     * @return {[string]} the string value of SELECTED_REGION_COOKIE
	     */
	    getRegion: function getRegion() {
	      var selectedRegion = $.cookie(cookies.SELECTED_REGION_COOKIE);
	      if (typeof selectedRegion == 'undefined' || !selectedRegion) {
	        selectedRegion = null;
	      }
	      return selectedRegion;
	    },
	    getScreenType: function getScreenType() {
	      var width = $(window).width();
	      if (width >= 1025) return 'DESKTOP';
	      if (width >= 769) return 'TABLET-LANDSCAPE';
	      if (width >= 668) return 'TABLET-PORTRAIT';
	      if (width >= 376) return 'PHONE-LANDSCAPE';
	      return 'PHONE-PORTRAIT';
	    },
	    is_touch_device: function is_touch_device() {
	      return 'ontouchstart' in window // works on most browsers
	      || navigator.maxTouchPoints; // works on IE10/11 and Surface
	    },
	    emailSubmit: function emailSubmit(form) {
	      var locale = COSTCO.util.getLocale();
	      var isWhatCountsEnabled = $("input[name='whatCountsEventsFeatureFlagFooter']").val();
	      var isAdobeEnabled = $("input[name='adobePreferencesFeatureFlagFooter']").val();
	      if (isAdobeEnabled == 'true') {
	        if (locale != 'en-US') {
	          var url = form.action;
	          document.location.href = url;
	        } else {
	          var data = {
	            memberNumber: '',
	            emailAddress: $('#footer-email-offers').val().trim(),
	            listSource: 'Footer SignUp'
	          };
	          COSTCO.AdobeEvents.sendEmailSubscriptionEvent($("input[name='adobeSubscribeEndpointFooter']").val(), contextVariables, data);
	        }
	      }
	      if (isWhatCountsEnabled == 'true' || isWhatCountsEnabled === '1') {
	        if (locale != 'en-US') {
	          var _url = form.action;
	          document.location.href = _url;
	        } else {
	          $.ajax({
	            type: 'POST',
	            url: form.action,
	            data: 'emailSignUp=' + form['emailSignUp'].value,
	            success: function success() {
	              $(form).find('input[type=text]').each(function () {
	                $(this).val('');
	              });
	            }
	          });
	        }
	      }
	      var successP = '<p class=\'success emailSignUp\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
	      $(form).after(successP);
	      $(form).addClass('hide');
	      return false;
	    },
	
	    emailSubscribeForm: function emailSubscribeForm(element) {
	      $.validator.addMethod('countryspecificpostalcodePassCountrySelectorModal', function (value, element) {
	        return !(COSTCO.util.getLangId() == -1) ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
	      }, messages.ERR_ENTER_ZIPCODE);
	      $.validator.addMethod('email', function (value, element) {
	        return (/^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/.test(value.toLowerCase())
	        );
	      }, messages.JS_VALID_EMAIL);
	      $(element).validate({
	        rules: {
	          emailAddress: {
	            required: true,
	            email: true
	          },
	          deliveryZipCode: {
	            required: true,
	            countryspecificpostalcodePassCountrySelectorModal: true
	          }
	        },
	        messages: {
	          emailAddress: messages.ERR_INVALID_EMAIL,
	          deliveryZipCode: messages.ERR_ENTER_ZIPCODE
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          if (element.attr('name') == 'emailAddress') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=emailAddress]'));
	          } else if (element.attr('name') == 'deliveryZipCode') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=deliveryZipCode]'));
	          } else {
	            error.insertAfter(element);
	          }
	        }
	      });
	      if ($(element).valid()) {
	        util.emailSubscribeSubmit(element);
	      }
	      return false;
	    },
	
	    emailSubscribeSubmit: function emailSubscribeSubmit(form) {
	      $.ajax({
	        type: 'POST',
	        url: form.action,
	        data: 'emailAddress=' + form['emailAddress'].value + '&deliveryZipCode=' + form['deliveryZipCode'].value + '&newLocation=' + form['newLocation'].value,
	        success: function success() {
	          $(form).find('input[type=text]').each(function () {
	            $(this).val('');
	          });
	        }
	      });
	      var successP = '<p class=\'success emailAddress\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
	      $(form).after(successP);
	      $(form).addClass('hide');
	      return false;
	    },
	
	    emailTruckloadSubscribeForm: function emailTruckloadSubscribeForm(element) {
	      var errorElement = null; // Variable to store the first error element
	      $.validator.addMethod('email', function (value, element) {
	        return this.optional(element) || /^.+@(([^.])+\.)+([^.])+$/i.test(value);
	      }, messages.ERR_INVALID_EMAIL);
	      $.validator.addMethod('costcoMembership', function (value, element) {
	        return this.optional(element) || /^\d{12,16}$/.test(value);
	      }, messages.ERR_INVALID_MEMBERSHIP_NO_BD);
	      $(element).validate({
	        rules: {
	          userName: { required: true },
	          membershipNo: { required: true, costcoMembership: true },
	          emailAddress: { required: true, email: true }
	        },
	        messages: {
	          userName: messages.ERR_USERNAME_REQUIRED,
	          membershipNo: { required: messages.ERR_MEMBERSHIP_NUMBER_REQUIRED, costcoMembership: messages.ERR_INVALID_MEMBERSHIP },
	          emailAddress: { required: messages.ERR_REQUIRED_EMAIL_MY, email: messages.ERR_INVALID_EMAIL }
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          if (!errorElement) {
	            // Store the first error element
	            errorElement = element;
	          } else if (element.attr('name') == 'userName') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=userName]'));
	          } else if (element.attr('name') == 'membershipNo') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=membershipNo]'));
	          } else if (element.attr('name') == 'emailAddress') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=emailAddress]'));
	          } else {
	            error.insertAfter(element);
	          }
	        }
	      });
	      if ($(element).valid()) {
	        util.emailTruckloadSubscribeSubmit(element);
	      } else {
	        errorElement.focus();
	      }
	      return false;
	    },
	
	    emailTruckloadSubscribeSubmit: function emailTruckloadSubscribeSubmit(form) {
	      event.preventDefault();
	      $.ajax({
	        type: 'POST',
	        url: form.action,
	        data: 'emailAddress=' + form['emailAddress'].value + '&userName=' + form['userName'].value + '&membershipNo=' + form['membershipNo'].value + '&BusinessName=' + form['BusinessName'].value + '&Address1=' + form['Address1'].value + '&Address2=' + form['Address2'].value + '&City=' + form['City'].value + '&State=' + form['State'].value + '&zipcode=' + form['zipcode'].value + '&phonenumber=' + form['phonenumber'].value + '&items=' + form['items'].value,
	        success: function success() {
	          $(form).find('input[type=text]').each(function () {
	            $(this).val('');
	          });
	          $(form).find('input[type=email]').each(function () {
	            $(this).val('');
	          });
	        }
	      });
	      var successP = '<p id="successP" tabindex="0" class=\'success emailAddress\'><i class=\'co-checkmark\'></i>' + " " + messages.MSG_EMAIL_RECEIVED + '.</p>';
	      $(form).before(successP);
	      $(form).addClass('hide');
	      document.getElementById('successP').focus();
	      return false;
	    },
	
	    /**
	     * This function appends an additional panel to an existing accordion using
	     * the accordion_id. The header and body represent the HTML that will display
	     * for this add on.
	     * @param  {[string]} accordion_id - The accordion data structure's id
	     * @param  {[string]} header - String (html) to display as the panel header
	     * @param  {[string]} body - String (html) to display as the panel body
	     * @return {[void]}
	     */
	    accordion_addon: function accordion_addon(accordion_id, header, body, handlers, parent) {
	      var position = $('#' + accordion_id).children().length + 1;
	      var handlerTemplate = void 0;
	      if (typeof handlers == 'undefined') {
	        handlerTemplate = '';
	      } else {
	        handlerTemplate = handlers;
	      }
	      $('#' + accordion_id).append(this.tmpl('tmpl_accordion_addon', {
	        accordion_id: accordion_id,
	        pos: position,
	        header: header,
	        body: body,
	        handlers: handlerTemplate,
	        parent: parent !== 'undefined' ? parent : true
	      }));
	    },
	    /**
	     * Retrieve the value of the 'rememberedShowMemberItem' cookie
	     * used to display member-only pricing without the need to sign in
	     */
	    getRememberedShowMemberItem: function getRememberedShowMemberItem() {
	      var rememberMeCookie = $.cookie('rememberedShowMemberItem');
	      var cookieExists = rememberMeCookie === undefined || rememberMeCookie === null ? false : true;
	      return cookieExists;
	    },
	    /**
	     * If the user is signed in and has a Costco membership number stored,
	     * show the member-only prices else don't.
	     * @return {[void]}
	     */
	    display_member_prices: function display_member_prices() {
	      var member_cookie = this.getMemberCookie(),
	          signed_in = member_cookie.signedIn || false,
	          is_member = member_cookie.costcoMember || false,
	          is_validated = member_cookie.validated || false,
	          is_active = member_cookie.active || false,
	          is_bd = util.isBusinessDelivery();
	      var rememberMe = this.getRememberedShowMemberItem();
	      // This check is added to keep BD flow unaffected by the change in BC flow
	      var display_moi_price = COSTCO.util.isBusinessDelivery() ? signed_in && is_member : signed_in && is_member && is_validated && is_active;
	      if (display_moi_price) {
	        $('.moi,.mapi').show();
	      } else if (signed_in) {
	        $('.mapi').show();
	        $('.moi').hide();
	      } else if (rememberMe) {
	        $('.mapi').hide();
	        $('.moi').show();
	      } else {
	        $('.moi,.mapi').hide();
	        $('.mapi').parent().find('.map-item').removeClass('hide');
	      }
	    },
	
	    /**
	     * If the user is signed in and has a Costco membership number stored,
	     * show the Select Options or Sign in for Price Button
	     * @return {[void]}
	     */
	    display_SelectOrSignInButton: function display_SelectOrSignInButton() {
	      var member_cookie = this.getMemberCookie();
	      $('.product-tile-set').each(function (element, index) {
	        if ($(this).find('.member-only').length > 0) {
	          if (member_cookie.signedIn) {
	            $(this).find('.select-option-button, .see-details-button').removeClass('hide');
	          } else {
	            $(this).find('.sign-in-button').removeClass('hide');
	          }
	        } else if ($(this).find('#mapItem').length > 0 && !member_cookie.signedIn) {
	          $(this).find('.sign-in-button').removeClass('hide');
	        } else {
	          $(this).find('.select-option-button, .see-details-button').removeClass('hide');
	        }
	      });
	    },
	    /**
	     * This is used by inline links to pop the email offers modal. It is
	     * attached to the TopRow_ESpot_4 "Sign Up" link but can be used anywhere
	     * a "get email offers" modal is necessary.
	     * @return {[void]}
	     */
	    get_email_offers: function get_email_offers() {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.RWD_GET_EMAIL_OFFERS,
	        body: this.tmpl('tmpl_email_offers', {}),
	        primary: messages.EMAIL_BUTTON_TITLE,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          !$('#costcoModal p.success').length > 0 ? $('#costcoModal form').submit() : $('#costcoModalBtn2').hide();
	        }
	      });
	    },
	    /**
	     * This function is the entry point for the front-end citi credit card
	     * application process.  The business includes this javascript in an <a onclick/>,
	     * which will initiate the ajax call.  From here, the path can go 2 different ways
	     * 1.  	If the user has authorized users, they are provided with a dialog, allowing
	     * 		them to choose from a list of authorized users, or none at all.
	     * 2.	If the baseUrl is not included an the whitelist, it will show the
	     * 		external link dialog to user, otherwise it will open a new tab to the url.
	     */
	    getBrandFolderVideo: function getBrandFolderVideo(assetKey, folderkey) {
	      var baseUriForBrandfolder = $('#baseUriForBrandfolder' + folderkey).val();
	      var bearerTokenForBrandfolder = $('#bearerTokenForBrandfolder').val();
	      var bfHeaders = {};
	      bfHeaders["Authorization"] = bearerTokenForBrandfolder;
	      fetch(baseUriForBrandfolder + assetKey, {
	        method: "GET",
	        headers: bfHeaders
	      }).then(function (response) {
	        if (response.status >= 200 && response.status <= 299) {
	          return response.json();
	        } else {
	          throw Error(response.statusText);
	        }
	      }).then(function (jsonResponse) {
	        var title = "";
	        try {
	          title = jsonResponse.data[0].attributes.name;
	        } catch (e) {
	          console.log('Title could not be retrieved from BrandFolder');
	        }
	        window.eventBus.publish('popupShow', { asset_key: assetKey, title: title, bfFolderType: folderkey });
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    applyForCostcoCredit: function applyForCostcoCredit(baseUrl, authorizedMemNum) {
	      COSTCO.util.ajaxSend();
	      if (typeof PageAnalyticsInfo !== 'undefined') {
	        var pageType = PageAnalyticsInfo.pageType;
	      }
	      $.ajax({
	        type: 'POST',
	        url: 'https://' + location.hostname + '/ApplyForCostcoCredit',
	        dataType: 'jsonp',
	        data: {
	          'authorizedMemNum': authorizedMemNum,
	          'pageType': pageType
	        },
	        success: function success(parsedDataJson) {
	          // Show dropdown of member numbers to choose
	          if (parsedDataJson.errorCode) {
	            if (parsedDataJson.errorCode == 2510) // session timeout
	              {
	                document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
	                return;
	              }
	          }
	
	          var data = parsedDataJson.applicationPrepopData;
	          var token = '';
	          var citiRedirectUrl = '';
	          var authorizedMembersJsonArray = [];
	
	          if (data) {
	            token = data.CITI_MEMBERDATA_SIGNED_ENCRYPTED;
	          }
	
	          if (baseUrl && token) {
	            citiRedirectUrl = '' + baseUrl + token;
	          }
	
	          var payloadJson = {
	            'applicationPrepopData': data
	          };
	
	          if (parsedDataJson.authorizedMembers) {
	            authorizedMembersJsonArray = $.parseJSON(parsedDataJson.authorizedMembers);
	          }
	          //TO-DO: hiding authorizedMember selection modal until funitonality is implemented on backend. 
	          // if (authorizedMembersJsonArray != undefined && authorizedMembersJsonArray.length > 0) {
	          //   util.createMemberNumberSelectDialog(baseUrl, payloadJson, authorizedMembersJsonArray);
	          // } else 
	          if (citiRedirectUrl) {
	            util.createCostcoCreditApplyExtPrefillDialog(citiRedirectUrl);
	          } else {
	            util.createCostcoCreditApplyExtPrefillDialog(baseUrl);
	          }
	        },
	        error: function error(x, t, m) {
	          COSTCO.util.LoginTimeout.updateActivity();
	          if (t === 'timeout') {
	            console.log('timout with server');
	          } else {
	            console.log('unexpected error TODO');
	          }
	          console.log('set return codes for caller of this service TODO');
	        },
	        complete: function complete() {
	          COSTCO.util.ajaxComplete();
	        }
	      });
	      return false;
	    },
	    /**
	     * This is the dialog, allowing users to select authorized users for their citi
	     * application.  This function is referenced solely in applyForCostcoCredit().
	     */
	    createMemberNumberSelectDialog: function createMemberNumberSelectDialog(baseUrl, payloadJson, authorizedMembersJsonArray) {
	      var dialogDiv = $(this.tmpl('tmpl_costco_cc_additional_member', {}));
	      dialogDiv.find(':selected').val(payloadJson);
	      var memberSelect = dialogDiv.find('select');
	      for (var i = 0; i < authorizedMembersJsonArray.length; i++) {
	        memberSelect.append($('<option>', {
	          value: {
	            'applicationPrepopData': authorizedMembersJsonArray[i].memberPayload
	          }
	        }).text(authorizedMembersJsonArray[i].name));
	      }
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_AUTHORIZED_USER_TITLE,
	        body: dialogDiv,
	        primary: messages.JS_DIALOG_AUTHORIZED_USER_OK,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          var authorizedMemNum = $('#authorized-member-select').val();
	          COSTCO.util.dynamicExternalFormPost(baseUrl, payloadJson);
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    createCostcoCreditApplyExtDialog: function createCostcoCreditApplyExtDialog(baseUrl, payloadJson) {
	      var dialogDiv = $(this.tmpl('tmpl_costco_cc_apply_confirm', {}));
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_LEAVING_SITE_TITLE,
	        body: dialogDiv,
	        primary: messages.JS_DIALOG_AUTHORIZED_USER_OK,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          COSTCO.util.dynamicExternalFormPost(baseUrl, payloadJson);
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    /**
	    * External link dialog for Citi application prefill.
	    */
	    createCostcoCreditApplyExtPrefillDialog: function createCostcoCreditApplyExtPrefillDialog(url) {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_EXTERNAL_LINK,
	        body: messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.JS_DIALOG_EXTERNAL_LINK,
	        primary_event: function primary_event() {
	          document.location.href = url;
	          COSTCO.dialog.close();
	        }
	      });
	    },
	    /**
	     * This shows or hides all citi application links based on certain criteria.
	     */
	    showAllCappLinks: function showAllCappLinks(isShow) {
	      if (isShow == undefined || isShow) {
	        $('.citi_credit_app_link').show();
	      } else {
	        $('.citi_credit_app_link').hide();
	      }
	    },
	    /**
	     * This processes the business cases for when users should not be allowed to apply
	     * for citi credit cards.  Links will be hidden, and other text will be shown instead.
	     * For the case where text is shown instead, the business must set this up via CMC.  Please
	     * reference the run documentation provided.
	     */
	    processCappLogic: function processCappLogic() {
	      var capp_json = util.getCappJson();
	      if (capp_json != null) {
	        if (capp_json.coBrandedCreditMax) {
	          // hide all application links
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForRenew) {
	          // show message and hide all application link
	          $('#displayErrorForRenew').show();
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForCancel) {
	          // show message and hide all application links
	          $('#displayErrorForCancel').show();
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForRenewGSHousehold) {
	          // show message and hide all application links
	          $('#displayErrorForRenewGSHousehold').show();
	          util.showAllCappLinks(false);
	        } else {
	          // show credit app links
	          util.showAllCappLinks(true);
	        }
	      } else {
	        // show credit app links
	        util.showAllCappLinks(true);
	      }
	    },
	    /**
	     * Updates the cookie json with the business logic encapsulated in these
	     * attributes.
	     */
	    updateCappJson: function updateCappJson(data) {
	      var capp_json = {};
	      capp_json.coBrandedCreditMax = typeof data !== 'undefined' ? data.coBrandedCreditMax : MembershipMetaData.payload.caller.coBrandedCreditMax;
	      capp_json.displayErrorForRenew = typeof data !== 'undefined' ? data.displayErrorForRenew : MembershipMetaData.payload.caller.displayErrorForRenew;
	      capp_json.displayErrorForCancel = typeof data !== 'undefined' ? data.displayErrorForCancel : MembershipMetaData.payload.caller.displayErrorForCancel;
	      capp_json.displayErrorForRenewGSHousehold = typeof data !== 'undefined' ? data.displayErrorForRenewGSHousehold : MembershipMetaData.payload.caller.displayErrorForRenewGSHousehold;
	      $.cookie('capp_json', JSON.stringify(capp_json), {
	        expires: 30,
	        path: '/'
	      });
	    },
	    /**
	     * Retrieves citi cookie and converts to json.
	     */
	    getCappJson: function getCappJson() {
	      var capp_json = $.cookie('capp_json');
	      if (capp_json != null) {
	        capp_json = JSON.parse(capp_json);
	      }
	      return capp_json;
	    },
	    /**
	     * Create external post form, to be used in a dialog (if on whitelist)
	     * or incorporated into the external link dialog.  dataJson is converted
	     * into hidden inputs to pass in the form. Form opens to new tab.
	     */
	    dynamicExternalFormPost: function dynamicExternalFormPost(url, dataJson) {
	      var dynamicPostForm = $('<form method=\'POST\' action=\'' + url + '\' target=\'_blank\' enctype=\'multipart/form-data\'></form>');
	      for (var key in dataJson) {
	        if (dataJson.hasOwnProperty(key)) {
	          dynamicPostForm.append($('<input type=\'hidden\' name=\'' + key + '\' value=\'' + dataJson[key] + '\'/>'));
	        }
	      }
	      // Pushing the form into the DOM and then submitting, IE complains if not done.
	      $('body').append($('<div id=\'external_link\' style=\'display:hidden\'/>').append(dynamicPostForm.clone()));
	      $('#external_link form').submit();
	      $('#external_link form').remove();
	    },
	    /**
	     * Ajax spinner for send.
	     */
	    ajaxSend: function ajaxSend() {
	      if ($('#dataGlobalSpinner').length == 0) {
	        var spinner = '<div class="ui-widget-overlay ui-front r1_spinner" id="dataGlobalSpinner"></div>';
	        $('body').append(spinner);
	      } else {
	        $('#dataGlobalSpinner').append('<div/>');
	      }
	    },
	    /**
	     * Ajax spinner for completion.  Multiple ajax spinners could be going, so this
	     * will only take one out with each call.
	     */
	    ajaxComplete: function ajaxComplete() {
	      var spinner = $('#dataGlobalSpinner');
	      if (spinner.length > 0 && spinner.children().length == 0) {
	        spinner.remove();
	      } else {
	        $(spinner.children()[0]).remove();
	      }
	    },
	    /**
	     * Login timeout logic incorporated from legacy js that is referenced.
	     */
	    LoginTimeout: {
	      redirectView: '/LogonForm',
	      lastActivity: '',
	      checkTimeout: function checkTimeout() {
	        if (COSTCO.util.LoginTimeout.lastActivity == '') {
	          return;
	        }
	        var now = new Date().getTime();
	        var diff = now - COSTCO.util.LoginTimeout.lastActivity;
	        if (diff > wcs.loginTimeOut) {
	          window.location.href = COSTCO.util.LoginTimeout.redirectView;
	          throw new Error('Stale browser - redirecting');
	        }
	      },
	      updateActivity: function updateActivity() {
	        COSTCO.util.LoginTimeout.lastActivity = new Date().getTime();
	      }
	    },
	    /**
	     * Get a parsed object from localStorage (if localStorage is available).
	     * @param  {[item]} item - the key to pull from localStorage
	     * @return {[object]} storage_item - the object representing the string
	     *  in local storage (or empty object in the case of the item not existing)
	     */
	    getFromStorage: function getFromStorage(item) {
	      var storage_item = {};
	      if (localStorage) {
	        storage_item = localStorage.getItem(item) ? JSON.parse(localStorage.getItem(item)) : {};
	      }
	      return storage_item;
	    },
	    /**
	     * Set a string/object in localStorage for later use (if localStorage is available)
	     * @param {[string]} name - key to reference the value
	     * @param {[string|object]} item - value to store in localStorage
	     */
	    setInStorage: function setInStorage(name, item) {
	      var item = typeof item === 'string' ? item : JSON.stringify(item);
	      if (localStorage) {
	        localStorage.setItem(name, item);
	      }
	    },
	    /**
	     * Get a parsed object from sessionStorage (if sessionStorage is available).
	     * @param  {[item]} item - the key to pull from sessionStorage
	     * @return {[object]} storage_item - the object representing the string
	     *  in session storage (or empty object in the case of the item not existing)
	     */
	    getFromSession: function getFromSession(item) {
	      var storage_item = {};
	      if (sessionStorage) {
	        storage_item = sessionStorage.getItem(item) ? JSON.parse(sessionStorage.getItem(item)) : {};
	      }
	      return storage_item;
	    },
	    /**
	     * Set a string/object in sessionStorage for later use (if sessionStorage
	     * is available)
	     * @param {[string]} name - key to reference the value
	     * @param {[string|object]} item - value to store in sessionStorage
	     */
	    setInSession: function setInSession(name, item) {
	      var item = typeof item === 'string' ? item : JSON.stringify(item);
	      if (sessionStorage) {
	        sessionStorage.setItem(name, item);
	      }
	    },
	    /**
	     * Remove object from sessionStorage (if sessionStorage is available).
	     * @param  {[name]} name - key for item to be removed from sessionStorage
	     * @return none
	     *
	     */
	    removeFromSession: function removeFromSession(name) {
	      if (sessionStorage) {
	        sessionStorage.removeItem(name);
	      }
	    },
	    /**
	     * Shamelessly stolen from stackoverflow. Get the query string by name
	     * @param  {[type]}
	     * @param  {[type]}
	     * @return {[type]}
	     */
	    getParameterByName: function getParameterByName(name, url) {
	      if (!url) url = window.location.href;
	      name = name.replace(/[\[\]]/g, '\\$&');
	      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	          results = regex.exec(url);
	      if (!results) return null;
	      if (!results[2]) return '';
	      return decodeURIComponent(results[2].replace(/\+/g, ' '));
	    },
	    /**
	     * Shamelessly stolen from stackoverflow. Adds a single parameter to the URL 
	     * @param  {[type]}
	     * @param  {[type]}
	     * @return {[type]}
	     */
	    insertParamInUrl: function insertParamInUrl(key, value) {
	      key = encodeURIComponent(key);
	      value = encodeURIComponent(value);
	      var kvp = document.location.search.substr(1).split('&');
	      var i = 0;
	      for (; i < kvp.length; i++) {
	        if (kvp[i].startsWith(key + '=')) {
	          var pair = kvp[i].split('=');
	          pair[1] = value;
	          kvp[i] = pair.join('=');
	          break;
	        }
	      }
	      if (i >= kvp.length) {
	        kvp[kvp.length] = [key, value].join('=');
	      }
	      var params = kvp.join('&');
	      return params;
	    },
	    /**
	     * Returns an object representing query string parameters.
	     * @return {[object]} The object represeting query strings
	     *                        &isAwesome=true becomes
	     *                        {"isAwesome":"true"}
	     */
	    get_parameters_as_object: function get_parameters_as_object() {
	      return document.location.search.replace(/(^\?)/, '').split('&').map(function (n) {
	        return n = n.split('='), this[n[0]] = n[1], this;
	      }.bind({}))[0];
	    },
	    all: function all(arr, p) {
	      // from haskell's data.list
	      var test = true;
	      arr.forEach(function (x) {
	        if (!p(x)) {
	          test = false;
	          return;
	        }
	      });
	      return test;
	    },
	    /**
	     * Returns True if at least one item in the array fulfills the condition
	     * @param  {[array]}    arr - the array to test
	     * @param  {[function]} p - the predicate function to test against the array
	     * @return {Boolean}
	     */
	    any: function any(arr, p) {
	      var answer = false;
	      for (var i = 0, len = arr.length; i < len; i++) {
	        if (answer) break;
	        if (p(arr[i])) {
	          answer = true;
	          break;
	        }
	      }
	      return answer;
	    },
	    hasElem: function hasElem(elem, array) {
	      var hasit = false;
	      array.forEach(function (e, i) {
	        if (elem === e) hasit = true;
	        return;
	      });
	      return hasit;
	    },
	    localeSpecificCurrency: function localeSpecificCurrency(v, loc, c) {
	      var n = parseFloat(v);
	      if (isNaN(v)) return v;
	      c = typeof c != 'undefined' ? c : 2;
	      switch (loc) {
	        case 'fr':
	          return this.formatCurrency(n, c, ',', ' ') + ' $';
	        default:
	          return '$' + this.formatCurrency(n, c, '.', ',');
	      }
	    },
	    formatCurrency: function formatCurrency(n, c, d, t) {
	      var c = isNaN(c = Math.abs(c)) ? 2 : c,
	          d = d == undefined ? ',' : d,
	          t = t == undefined ? '.' : t,
	          s = n < 0 ? '-' : '',
	          i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + '',
	          j = (j = i.length) > 3 ? j % 3 : 0;
	      return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
	    },
	    formatMoney: function formatMoney(number, has_symbol) {
	      var number = (Math.round(number * 100) / 100).toString(),
	          dollars = number.split('.')[0],
	          cents = (number.split('.')[1] || '') + '00';
	      dollars = dollars.split('').reverse().join('').replace(/(\d{3}(?!$))/g, '$1,').split('').reverse().join(''), symbol = has_symbol ? '$' : '';
	      var locale = COSTCO.util.getLocale();
	      if (locale == 'fr-CA') {
	        return dollars.split(',').join(' ') + ',' + cents.slice(0, 2) + ' ' + symbol;
	      }
	      return symbol + dollars + '.' + cents.slice(0, 2);
	    },
	    formatPhone: function formatPhone(number) {
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
	        return number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
	      } else {
	        return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
	      }
	    },
	    // public method for encoding
	    encode: function encode(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0,
	          enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = COSTCO.util._utf8_encode(input);
	      while (i < input.length) {
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	        enc1 = chr1 >> 2;
	        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	        enc4 = chr3 & 63;
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	        output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
	      }
	      return output;
	    },
	    // public method for decoding
	    decode: function decode(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0;
	      var enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	      while (i < input.length) {
	        enc1 = this._keyStr.indexOf(input.charAt(i++));
	        enc2 = this._keyStr.indexOf(input.charAt(i++));
	        enc3 = this._keyStr.indexOf(input.charAt(i++));
	        enc4 = this._keyStr.indexOf(input.charAt(i++));
	        chr1 = enc1 << 2 | enc2 >> 4;
	        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	        chr3 = (enc3 & 3) << 6 | enc4;
	        output = output + String.fromCharCode(chr1);
	        if (enc3 != 64) {
	          output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	          output = output + String.fromCharCode(chr3);
	        }
	      }
	      output = COSTCO.util._utf8_decode(output);
	      return output;
	    },
	    // private method for UTF-8 decoding
	    _utf8_decode: function _utf8_decode(utftext) {
	      var string = '';
	      var i = 0;
	      var c = c1 = c2 = 0;
	      while (i < utftext.length) {
	        c = utftext.charCodeAt(i);
	        if (c < 128) {
	          string += String.fromCharCode(c);
	          i++;
	        } else if (c > 191 && c < 224) {
	          c2 = utftext.charCodeAt(i + 1);
	          string += String.fromCharCode((c & 31) << 6 | c2 & 63);
	          i += 2;
	        } else {
	          c2 = utftext.charCodeAt(i + 1);
	          c3 = utftext.charCodeAt(i + 2);
	          string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
	          i += 3;
	        }
	      }
	      return string;
	    },
	    // private method for UTF-8 encoding
	    _utf8_encode: function _utf8_encode(string) {
	      string = string.replace(/\r\n/g, '\n');
	      var utftext = '';
	      for (var n = 0; n < string.length; n++) {
	        var c = string.charCodeAt(n);
	        if (c < 128) {
	          utftext += String.fromCharCode(c);
	        } else if (c > 127 && c < 2048) {
	          utftext += String.fromCharCode(c >> 6 | 192);
	          utftext += String.fromCharCode(c & 63 | 128);
	        } else {
	          utftext += String.fromCharCode(c >> 12 | 224);
	          utftext += String.fromCharCode(c >> 6 & 63 | 128);
	          utftext += String.fromCharCode(c & 63 | 128);
	        }
	      }
	      return utftext;
	    },
	    /**
	     * Hard coded the locales as our current implementation only supports 3
	     * locales. Also application logic can override the default browser
	     * locale
	     */
	    getLocale: function getLocale() {
	      var langId = this.getLangId();
	      if (langId == -1) return 'en-US';
	      if (langId == -24) return 'en-CA';
	      if (langId == -25) return 'fr-CA';
	      return 'en-US';
	    },
	    isSafari: function isSafari() {
	      var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
	      var is_safari = navigator.userAgent.indexOf('Safari') > -1;
	      if (is_chrome && is_safari) {
	        is_safari = false;
	      }
	      return is_safari;
	    },
	    /**
	     * Function once ran will copy the dom to nodes as needed - helps to avoid a server "DOM Bomb", but places that load on the client
	     *
	     * Required to define placement and content params
	     *
	     * Options can be overriden as needed to use different classes depending how the responsive content is setup.
	     */
	    responsivePlacement: function responsivePlacement(options) {
	      var opt = {
	        placement: '',
	        content: '',
	        useInnerContent: true,
	        display: 'block',
	        DESKTOP: '.visible-xl-',
	        TABLETLANDSCAPE: '.visible-lg-',
	        TABLETPORTRAIT: '.visible-md-',
	        PHONELANDSCAPE: '.visible-sm-',
	        PHONEPORTRAIT: '.visible-xs-'
	      };
	      $.extend(opt, options);
	      var node = $(opt.placement + opt.content);
	      if (node.length < 1) {
	        console.log('Missing Content for RespnsivePlacement');
	        return;
	      }
	      var content = '';
	      if (opt.useInnerContent) content = node.html();else {
	        content = node;
	      }
	      if ($(opt.placement).find('[itemprop=name]')) {
	        $(opt.placement).find('[itemprop=name]').removeAttr('itemprop');
	      }
	
	      COSTCO.util.responsiveContent(opt.placement, opt.DESKTOP + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.TABLETLANDSCAPE + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.TABLETPORTRAIT + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.PHONELANDSCAPE + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.PHONEPORTRAIT + opt.display, content);
	      return;
	    },
	    responsiveContent: function responsiveContent(selector, nodeClass, content) {
	      var node = $(selector + nodeClass);
	      if (node.length <= 0) {
	        return;
	      }
	      if (node.html().trim().length <= 0) {
	        node.append(content);
	      }
	      return;
	    },
	    getQueryStringArray: function getQueryStringArray() {
	      var queryString = [];
	      var a = window.location.search.substr(1).split('&'),
	          b = void 0;
	      for (var i = 0; i < a.length; i++) {
	        b = a[i].split('=');
	        queryString[decodeURIComponent(b[0])] = decodeURIComponent(b[1]);
	      }
	      return queryString;
	    },
	    /**
	     * Taken from Underscore.js (http://underscorejs.org/)
	     * Returns a function, that, as long as it continues to be invoked, will not
	     * be triggered. The function will be called after it stops being called for
	     * N milliseconds. If `immediate` is passed, trigger the function on the
	     * leading edge, instead of the trailing.
	     */
	    debounce: function debounce(func, wait, immediate) {
	      var timeout = void 0;
	      return function () {
	        var context = this,
	            args = arguments;
	        clearTimeout(timeout);
	        timeout = setTimeout(function () {
	          timeout = null;
	          if (!immediate) func.apply(context, args);
	        }, wait);
	        if (immediate && !timeout) func.apply(context, args);
	      };
	    },
	    isElementInViewport: function isElementInViewport(el) {
	      if (el.length <= 0) {
	        return false;
	      }
	      var rect = el[0].getBoundingClientRect();
	      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 600 && /* or $(window).height() */rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */;
	    },
	    onVisibilityChange: function onVisibilityChange(el, callback) {
	      return function () {
	        var visible = COSTCO.util.isElementInViewport(el);
	        if (visible == true) {
	          if (typeof callback == 'function') {
	            callback();
	          }
	        }
	      };
	    },
	    /**
	     * Decode an HTML encoded string. Turns stuff like this
	     * '&lt;p&gt;name&lt;/p&gt;&lt;' and converts it to '<p>name</p>'
	     * @param  {String} encodedHtmlString The html string to decode
	     * @return {String}                   The decoded html string.
	     */
	    get_decoded_html: function get_decoded_html(encodedHtmlString) {
	      var textArea = document.createElement('textarea');
	      textArea.innerHTML = encodedHtmlString;
	      return textArea.value;
	    },
	    /**
	     * Inject an arbitrary number of hidden inputs into a given form. Meant
	     * to be a utility to prevent statically adding key/values to $.ajax.
	     * Just use this function and then serialize the form with $.fn.serialize.
	     * Note that this function will only inject an input into a form if the
	     * named input doesn't already exist.
	     * @param  {String} form   The form selector
	     * @param  {Object} inputs The object representing the key/values to
	     *                         be inserted into the form as inputs
	     *                         {key:'value'}
	     * @return {void}
	     */
	    input_injector: function input_injector(form, inputs) {
	      var html = '';
	      Object.keys(inputs).forEach(function (key) {
	        if ($(form + ' input[name=' + key + ']').length == 0) {
	          html += '<input type=\'hidden\' name=\'' + key + '\' value=\'' + inputs[key] + '\'/>';
	        } else if (key === 'prescriptionId' || key === 'isPharmacy') {
	          $(form + ' input[name=' + key + ']').val(inputs[key]);
	        }
	      });
	      $(form).append(html);
	    },
	    iosModalWhiteSpace: function iosModalWhiteSpace(selectorArray) {
	      // hide the native soft keyboards
	      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
	        selectorArray.forEach(function (selector) {
	          var formElements = $(selector + ' input,' + selector + ' select,' + selector + ' textarea');
	          $(formElements).unbind('focus.iosModalWhiteSpace').on('focus.iosModalWhiteSpace', function () {
	            $(selector).css({
	              position: 'absolute'
	            });
	          });
	          $(formElements).unbind('blur.iosModalWhiteSpace').on('blur.iosModalWhiteSpace', function () {
	            $(selector).css({
	              position: 'fixed'
	            });
	            window.scrollTo(0, 0);
	          });
	        });
	      }
	    },
	    /**
	     * This fixes the case where the cursor sits outside of the focused input
	     * on iOS devices. It has the unfortunate side effect of scrolling
	     * to the top of the page when the modal is overlayed.
	     * @return {void}
	     */
	    iosPositionFix: function iosPositionFix() {
	      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
	        var style = $('<style>body.modal-open { position: fixed; }</style>');
	        $('html > head').append(style);
	      }
	    },
	    /**
	     * Check if the application is running on the costco mobile app
	     */
	    isRunningOnMobileApp: function isRunningOnMobileApp() {
	      return typeof Android != 'undefined' || typeof webkit != 'undefined';
	      //return true;
	    },
	    /**
	     * This function compares UserAgent header with mobile pattern regex. If mobile browser is not detected with this way,
	     * it checks if screen width is 1024 or less, which is also being treated as a mobile browser.
	     * 
	     * @returns True if mobile browser is detected
	     */
	    isMobile: function isMobile() {
	      var detectedMobileWithRegex = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune|Nokia|UCWEB/i.test(navigator.userAgent.toLowerCase());
	      var detectedMobileByScreenSize = $(window).width() <= 1024;
	      return detectedMobileWithRegex || detectedMobileByScreenSize;
	    },
	    /**
	     * Generates random UUID number
	     */
	    createUUID: function createUUID() {
	      var dt = new Date().getTime();
	      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = (dt + Math.random() * 16) % 16 | 0;
	        dt = Math.floor(dt / 16);
	        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	      });
	      return uuid;
	    },
	    /**
	     * Generic ajax wrapper. Set promise handlers inside the options
	     * object. ie options.done: function(){} will be called when the
	     * request is finished. Options object also gets passed back the
	     * the promise functions. Look at the signures below.
	     * @param  {Object} options The object used to pass options.
	     *                          {done: function(){}, hi: 'robert'}
	     * @return {jQuery.Deferred} The deferred object generated by calling
	     *                           $.ajax which can be chained.
	     */
	    ajax: function ajax(options) {
	      var done = void 0;
	      var fail = void 0;
	      var always = void 0;
	      var beforeSend = options.beforeSend || undefined;
	      var complete = options.complete || undefined;
	      options.done ? done = options.done : undefined;
	      options.fail ? fail = options.fail : undefined;
	      options.always ? always = options.always : undefined;
	      // Defaulting adding/removing the "busy" class as a decorator
	      // for beforeSend and complete
	      beforeSend ? options.beforeSend = function (jqXHR, settings) {
	        $('.order-ajax').addClass('ajax-busy');
	        beforeSend(jqXHR, settings);
	      } : options.beforeSend = function (jqXHR, settings) {
	        $('.order-ajax').addClass('ajax-busy');
	      };
	      complete ? options.complete = function (jqXHR, textStatus) {
	        $('.order-ajax, .permanent-ajax-busy').removeClass('ajax-busy');
	        complete(jqXHR, textStatus);
	      } : options.complete = function (jqXHR, textStatus) {
	        $('.order-ajax, .permanent-ajax-busy').removeClass('ajax-busy');
	      };
	      return $.ajax(options).done(function (data, textStatus, jqXHR) {
	        if (done) done(data, textStatus, jqXHR, options);
	      }).fail(function (jqXHR, textStatus, errorThrown) {
	        if (fail) fail(jqXHR, textStatus, errorThrown, options);
	      }).always(function (data, textStatus, jqXHR) {
	        if (always) always(data, textStatus, jqXHR, options);
	      });
	    },
	    /**
	     * Used by jquery.validate on "validate" function options to scroll to the
	     * first error in the list.
	     * @param  {object} event     The event on the form
	     * @param  {object} validator The validator object associated with the form
	     * @return {void}
	     */
	    invalid_handler: function invalid_handler(event, validator) {
	      if (!validator.numberOfInvalids()) return;
	      var base = $('#costcoModal').hasClass('in') ? '#costcoModal' : 'html, body';
	      base == '#costcoModal' ? $(base).scrollTo(validator.errorList[0].element, 100) : $(base).scrollToElem(validator.errorList[0].element, 100);
	      validator.errorList[0].element.focus();
	    },
	    /**
	     * Check to see if a particular path is part of the checkout flow.
	     * @param  {String}  pathname The path (document.location.pathname)
	     * @return {Boolean}          Is this path part of the checkout flow?
	     */
	    isCheckout: function isCheckout(pathname) {
	      var isCheckout = false;
	      if (pathname == '/CheckoutCartView' || pathname == '/CheckoutCartDisplayView' || pathname == '/CheckoutPaymentView' || pathname == '/CheckoutShippingView' || pathname == '/CheckoutReviewView') {
	        isCheckout = true;
	      }
	      return isCheckout;
	    },
	    triggerClickOnEnterKeyPress: function triggerClickOnEnterKeyPress(inputSelector, clickSelector) {
	      $(inputSelector).unbind('keypress').on('keypress', function (event) {
	        if (event.which == 13) {
	          $(clickSelector).click();
	          return false;
	        }
	      });
	    },
	    /**
	     * Takes a base url and appends query strings to it. Joining the
	     * base and querystring with the appropriate separator '&' or '?'
	     * @param  {string} base           The string to append query strings to
	     *                                 '/order-item-update' or 'www.costco.com'
	     * @param  {object} querystringObj The object representing the querystrings
	     *                                 to append ie '{checkoutPage: 'review'}'
	     * @return {string}                The made url with querystrings attached.
	     */
	    makeUrl: function makeUrl(base, querystringObj) {
	      var sep = base.indexOf('?') > -1 ? '&' : '?';
	      return base + sep + $.param(querystringObj);
	    },
	    /**
	     * Did the ajax response object return any application or system errors?
	     * @param  {object}  response_obj The parsed response object from calling
	     *                                any backend class that resolves to
	     *                                JSONLayout.jsp
	     * @return {Boolean}              Does it have application or system errors?
	     */
	    has_errors: function has_errors(response_obj) {
	      var application = response_obj.error.application;
	      var exception = response_obj.error.exception;
	      return application.length > 0 || exception.length > 0;
	    },
	    messageFormat: function messageFormat(format) {
	      var args = Array.prototype.slice.call(arguments, 1);
	      return format.replace(/{(\d+)}/g, function (match, number) {
	        return typeof args[number] != 'undefined' ? args[number] : match;
	      });
	    },
	    /**
	     * This function restricts membership number inputs to numeric user input.
	     * The input must be of type=text for it to work.
	     * @return {void}
	     */
	    maskMembershipInput: function maskMembershipInput() {
	      $('[name=userField2], [name=membershipNumber], [name=membershipId], [name=membershipNumberToVerify]').mask('#');
	    },
	    addToWishList: function addToWishList(catentryId, fromPage) {
	      window.location.href = COSTCO.util.makeUrl('/AddToWishListView', {
	        catentryId: catentryId,
	        fromPage: fromPage || ''
	      });
	    },
	    isBusinessDelivery: function isBusinessDelivery() {
	      if ($('#isBDAppVar') && $('#isBDAppVar').length > 0) {
	        currentSite = $('#isBDAppVar').val();
	        if (currentSite == 'BD') {
	          return true;
	        }
	      }
	      return false;
	    },
	
	    /**
	     * To initialize global grocery flag. Determine whether grocery product is displayed in the page or not.
	     * @return {Boolean} hasGroceryProducts
	     */
	    hasGroceryProducts: function hasGroceryProducts() {
	      var hasGroceryProducts = false;
	      if ($('#hasGroceryPdts').length > 0) {
	        var globalFlag = $('#hasGroceryPdts').val();
	        if (null != globalFlag && globalFlag == 'true') {
	          hasGroceryProducts = true;
	        }
	      }
	      return hasGroceryProducts;
	    },
	    /**
	     * Determine the default grocery home page url
	     * @return {String} groceryHomepageURL
	     */
	    groceryDefaultHomepage: function groceryDefaultHomepage() {
	      var groceryHomepageURL = '';
	      if ($('#groceryDefaultHomepage').length > 0) {
	        groceryHomepageURL = $('#groceryDefaultHomepage').val();
	      }
	      return groceryHomepageURL;
	    },
	    isCAStore: function isCAStore() {
	      var isCAStore = false;
	      if (null != wcs.storeId && wcs.storeId == '10302') {
	        isCAStore = true;
	      }
	      return isCAStore;
	    },
	    isCABDStore: function isCABDStore() {
	      var isCAStore = false;
	      if (null != wcs.storeId && wcs.storeId == '11303') {
	        isCAStore = true;
	      }
	      return isCAStore;
	    },
	    isUSBDStore: function isUSBDStore() {
	      var isBDStore = false;
	      if (null != wcs.storeId && wcs.storeId == '11301') {
	        isBDStore = true;
	      }
	      return isBDStore;
	    },
	    isBDStore: function isBDStore() {
	      var isBDStore = false;
	      if (null != wcs.storeId && wcs.storeId != '10301' && wcs.storeId != '10302') {
	        isBDStore = true;
	      }
	      return isBDStore;
	    },
	    isUSStore: function isUSStore() {
	      var isUSStore = false;
	      if (null != wcs.storeId && wcs.storeId == '10301') {
	        isUSStore = true;
	      }
	      return isUSStore;
	    },
	    is2DayEligbleRegn: function is2DayEligbleRegn() {
	      var isRegionValid = 'false';
	      if ($.cookie('C_2LOC') != null) {
	        isRegionValid = $.cookie('C_2LOC');
	      }
	      if (isRegionValid != null && COSTCO.util.isCAStore() && isRegionValid == 'false') {
	        return false;
	      }
	      return true;
	    },
	    logToClickTale: function logToClickTale(message, url, lineNumber) {
	      if (typeof window.onerror !== 'function') {
	        console.log('onerror is not a function');
	      }
	      try {
	        if ((typeof message === 'undefined' ? 'undefined' : _typeof(message)) === 'object') {
	          message = JSON.stringify(message);
	        }
	        window.onerror(message, url, lineNumber);
	      } catch (e) {
	        console.log('Unknown error logging to Clicktale');
	      }
	    },
	    getSource: function getSource() {
	      var locale = util.getLocale().slice(3, 5).toUpperCase();
	      var store = util.isBDStore() ? 'BD' : 'BC';
	      return locale + store;
	    },
	    // Begin Business Delivery Client Cookies
	    getBDZipCookie: function getBDZipCookie() {
	      var z = $.cookie('WC_BD_ZIP'),
	          w = $.cookie('WC_BD_WHS'),
	          ec = '',
	          originalZipCode = $.cookie('WC_BD_ZIP_ORIGINAL');
	      if (z == null || z == '""') {
	        z = '';
	      }
	      if (originalZipCode == null || originalZipCode == '""') {
	        originalZipCode = '';
	      }
	      if (w == null || w == '""') {
	        w = '';
	      } else {
	        if (w.indexOf('-') != -1) {
	          //STRY0140687 BD-National Delivery-Check the presence of EC to identify the residential flow.
	          if (w.indexOf('ND') != -1) {
	            var whsArray = w.split('-');
	            if (whsArray.includes('ND')) {
	              ec = 'ND';
	            }
	          }
	          w = w.substring(0, w.indexOf('-'));
	        }
	      }
	      z = z.replace(/\+/g, ' ');
	      originalZipCode = originalZipCode.replace(/\+/g, ' ');
	      return {
	        zipCode: z,
	        warehouseNumber: w,
	        externalCarrier: ec,
	        originalZipCode: originalZipCode
	      };
	    },
	    getMaxOutherHeight: function getMaxOutherHeight(elems) {
	      return Math.max.apply(null, elems.map(function () {
	        return $(this).outerHeight(true);
	      }).get());
	    },
	    isDepotCatalogEnabled: function isDepotCatalogEnabled() {
	      var depotCatalogEnableFlag = $('#depotCatalogEnableFlag').length > 0 && $('#depotCatalogEnableFlag').val() == 'true' ? true : false;
	      return depotCatalogEnableFlag;
	    },
	    isNdEnabled: function isNdEnabled() {
	      if ($('#isNdEnabled').val() == 'true') {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    isEDDEnabled: function isEDDEnabled() {
	      var eddEnabled = true;
	      if (COSTCO.util.checkElementById('#vendorName', 'EDD:CHUBSmallPack') && !COSTCO.util.checkElementById('#eddSmallPackEnabled', 'true')) {
	        eddEnabled = false;
	      }
	      return eddEnabled;
	    },
	
	    isExternalCarrierShipmode: function isExternalCarrierShipmode() {
	      var shipmodeId = '';
	      if (COSTCO.util.isNdEnabled() && ($('input[name="deliveryMethod"]').length > 0 || $('#shipmodeId').length > 0)) {
	        shipmodeId = $('input[name="deliveryMethod"]').length > 0 ? $('input[name="deliveryMethod"]:checked').val() : $('#shipmodeId').val();
	      }
	      if (shipmodeId == '10102' || shipmodeId == '10104') {
	        return true;
	      } else {
	        return false;
	      }
	    },
	
	    isExternalCarrierShipmodeValue: function isExternalCarrierShipmodeValue(shipmodeId) {
	      if (COSTCO.util.isNdEnabled() && shipmodeId.length > 0 && (shipmodeId == '10102' || shipmodeId == '10104')) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	
	    /**
	     * Check if first search suggestion exists and set it to
	     * screen reader announcement div
	     */
	    setFirstSuggestionAnnouncement: function setFirstSuggestionAnnouncement() {
	      if ($('.tt-suggestion').length > 0 && $('#announce-first-suggestion').length > 0 && $('.tt-menu').find('.tt-cursor').length === 0) {
	        var firstSuggestion = $('.tt-suggestion:first').text();
	        $('#announce-first-suggestion').text(firstSuggestion);
	      }
	    },
	
	    /**
	       * Announce first suggestion (if any) after user's inactivity 
	       */
	    announceFirstSuggestion: function announceFirstSuggestion() {
	      if ($('#announce-first-suggestion').length > 0) {
	        $('#announce-first-suggestion').text('');
	      }
	      window.clearTimeout(this.timeout);
	      timeout = window.setTimeout(this.setFirstSuggestionAnnouncement, 2000);
	    },
	    /**
	     * This is to define the constants for the product availablity check
	     */
	    productConstants: {
	      inv_backorderd: 'BACK_ORDER',
	      inv_outOfStock: 'OUT_STOCK',
	      inv_invalidSku: 'INVALID_ITEM',
	      zipcodeAvailCheck_StatusFail: 'FAIL',
	      check_StatusSuccess: 'success',
	      edd_shiprestricted: 'SHIPRESTRICTED',
	      edd_backordered: 'BACKORDERED',
	      edd_presell: 'PRESELL'
	    },
	    /**
	     * Notification object for notification message display.
	     */
	    notification: {
	      /**
	       * Constants for notification display.
	       */
	      type: {
	        SUCCESS: 'SUCCESS',
	        WARNING: 'WARNING',
	        ERROR: 'ERROR'
	      },
	      /**
	       * Displays notification on screen.
	       * @param {string}  notificationType     Type of notification message to display (SUCCESS | WARNING | ERROR)
	       * @param {Array}   notifications        Array of notification messages to be displayed in the notification box
	       * @param {boolean} scrollToNotification Scroll window to notification message
	       * @param {Jquery element}  element           Jquery element for notification display
	       */
	      displayNotification: function displayNotification(notificationType, notifications, scrollToNotification, $element, wrapper) {
	        $element = $element && $($element).length > 0 ? $($element) : $('#notification-message');
	        scrollToNotification = scrollToNotification ? scrollToNotification : false;
	
	        this.clearNotification($element);
	
	        var topNotificationClass = '';
	        var topNotificationInnerHtml = '';
	
	        switch (notificationType) {
	          case this.type.SUCCESS:
	            topNotificationClass = 'success-notification';
	            break;
	          case this.type.WARNING:
	            topNotificationClass = 'warning';
	            break;
	          case this.type.ERROR:
	            topNotificationClass = 'critical-notification';
	            break;
	          default:
	            break;
	        }
	        var elementWrapper = wrapper ? wrapper : 'p';
	        notifications.forEach(function (notification) {
	          if ((typeof notification === 'undefined' ? 'undefined' : _typeof(notification)) === 'object') {
	            for (var errorKey in notification) {
	              topNotificationInnerHtml += '<' + elementWrapper + ' role=\"alert\">' + notification[errorKey] + '</' + elementWrapper + '>';
	            }
	          } else {
	            topNotificationInnerHtml += '<' + elementWrapper + ' role=\"alert\">' + notification + '</' + elementWrapper + '>';
	          }
	        });
	
	        $element.addClass(topNotificationClass);
	
	        topNotificationInnerHtml = COSTCO.util.get_decoded_html(topNotificationInnerHtml);
	        $element.html(topNotificationInnerHtml);
	
	        if (scrollToNotification) {
	          $('body, html').animate({
	            scrollTop: $element.offset().top - 30
	          }, 800);
	        }
	
	        $element.attr('tabindex', -1);
	        $element.focus();
	      },
	      /**
	       * Clears displayed notifications on screen.
	       * @param {Jquery element} Jquery element for notification display.
	       */
	      clearNotification: function clearNotification($element) {
	        $element = $element ? $($element) : $('#notification-message');
	
	        $element.removeClass();
	        $element.html('');
	      }
	    },
	
	    /**
	     * Redirects the pages to generic error/cart on inactive conditions
	     * @param page 
	     * @param orderStatus 
	     */
	    redirectCartOnInactive: function redirectCartOnInactive(page, status) {
	      if ($('#orderStatus').val() !== '' && $('#orderStatus').val() !== undefined) {
	        if ((page === 'SHIPPING' || page === 'payment' || page === 'review') && status === 'INACTIVE') {
	          window.location.href = "/CheckoutCartView";
	        } else if ((page === 'quick-membership' || page === 'quick-membership-renew') && status === 'INACTIVE') {
	          window.location.href = "/GenericError";
	        }
	      }
	    },
	
	    /**
	     * Gets element with back to top link
	     * and (if exists) binds keydown and click event
	     * that moves focus to top of the page
	     * @param backToTopLink
	     */
	    setEventOnBackToTopLink: function setEventOnBackToTopLink(backToTopLinkClass) {
	      var $backToTopLink = $(backToTopLinkClass).find("a").length > 0 ? $(backToTopLinkClass).find("a") : $(backToTopLinkClass);
	      /* ADA STRY0169325 - Back to top functionality */
	      $backToTopLink.attr("href", "#headerskip");
	      $backToTopLink.click(function () {
	        COSTCO.util.scrollToTop();
	      });
	      $backToTopLink.keydown(function (e) {
	        if (e.keyCode === 13) COSTCO.util.scrollToTop();
	      });
	    },
	
	    /**
	     * Function used to add a label with error message accessible only to screen reader
	     * @param element that error label should be attached to
	     */
	    addErrorLabelForAda: function addErrorLabelForAda(element) {
	      if (typeof element !== 'undefined' && element !== null) {
	        var $element = $(element);
	        if ($element.hasClass("error") && !$element.siblings('.sr-only').length) {
	          $element.before("<span for=\"" + $element[0].id + "\" class=\"sr-only\">" + messages.ERROR + "</span>");
	        }
	      }
	    },
	
	    /**
	     * Function used for fetching first global error message on page
	     * @param containerElement - specifies the element in which the global error is searched for
	     * @return first element with global error class
	     */
	    getFirstGlobalErrorOnPage: function getFirstGlobalErrorOnPage(containerElement) {
	      var errorClasses = COSTCO.util.globalErrorElementClasses;
	      //create jquery selector from an array of classes
	      var selector = errorClasses.join(", .");
	      var firstElementWithClass = containerElement.find('.' + selector).html() !== undefined ? containerElement.find('.' + selector).first() : null;
	      var iterationValue = firstElementWithClass;
	      while (iterationValue !== undefined && iterationValue !== null) {
	        firstElementWithClass = iterationValue;
	        iterationValue = COSTCO.util.getFirstGlobalErrorOnPage(firstElementWithClass);
	      }
	      return firstElementWithClass;
	    },
	
	    /**
	     * Function that creates an error label accessible only to screen reader
	     * @param errorMessage that should be appended with screen reader label
	     * @return string containing both the error message and the screen reader only error label
	     */
	    createErrorAdaLabel: function createErrorAdaLabel(errorMessage) {
	      return "<span class='sr-only'>" + messages.ERROR + "</span>" + errorMessage;
	    },
	
	    /**
	     * Function used to remove a label with error message accessible only to screen reader
	     * @param element whose label should be removed
	     */
	    removeErrorLabelForAda: function removeErrorLabelForAda(element) {
	      if (typeof element !== 'undefined' && element !== null) {
	        var $element = $(element);
	        $element.siblings('label').remove(".sr-only");
	        $element.siblings().children('label').remove(".sr-only");
	        $element.parent().siblings('label').remove(".sr-only");
	      }
	    },
	
	    /**
	     * jquery validator 'highlight' method,
	     * with ADA error label added
	     */
	    highlightWithErrorLabel: function highlightWithErrorLabel(element, errorClass, validClass) {
	
	      if (element.type === 'radio') {
	        this.findByName(element.name).addClass(errorClass).removeClass(validClass);
	      } else {
	        $(element).addClass(errorClass).removeClass(validClass);
	        $(element).attr("aria-describedby", this.idOrName(element) + this.settings.idSuffix);
	      }
	      COSTCO.util.addErrorLabelForAda(element);
	    },
	
	    /**
	        * jquery validator 'unhighlight' method,
	        * with ADA error label added
	        */
	    unhighlightWithErrorLabel: function unhighlightWithErrorLabel(element, errorClass, validClass) {
	      if (element.type === 'radio') {
	        this.findByName(element.name).removeClass(errorClass).addClass(validClass);
	      } else {
	        $(element).removeClass(errorClass).addClass(validClass);
	        $(element).removeAttr("aria-describedby");
	      }
	      COSTCO.util.removeErrorLabelForAda(element);
	    },
	
	    /**
	     * Function used to inject message in screen reader placeholder announcement div
	     * @param message to be injected
	     */
	    announceSRMessage: function announceSRMessage(message) {
	      var adaMessageDiv = $('#screen-reader-announcement');
	      if (message !== undefined && message.length !== 0 && message !== "") {
	        adaMessageDiv.empty();
	        adaMessageDiv.html(message);
	
	        //after a 2sec delay, remove the message so SR users don't unneccessarily revisit it when navigating DOM
	        setTimeout(function () {
	          adaMessageDiv.empty();
	        }, 2000);
	      }
	    },
	
	    /**
	     * Calling function onclick by pressing enter key (keyCode = 13)
	     * @param id
	     */
	    clickElementOnEnter: function clickElementOnEnter(elementId) {
	      if (event.keyCode === 13 && $('#' + elementId).length > 0) {
	        $('#' + elementId).click();
	      }
	    },
	
	    /**
	     * Calling function onclick by pressing enter key (keyCode = 13)
	     * or pressing space key (keyCode = 32)
	     * @param id
	     */
	    clickElementOnEnterOrSpace: function clickElementOnEnterOrSpace(elementId) {
	      if ((event.keyCode === 13 || event.keyCode === 32) && $('#' + elementId).length > 0) {
	        //Prevents from window scrolling
	        if (event.keyCode === 32) {
	          event.preventDefault();
	        }
	        //If element is tooltip, do not perfrom action
	        if ($(".span-inline-block").is(":focus")) {
	          return false;
	        }
	        $('#' + elementId).click();
	      }
	    },
	
	    //Workarround for FireFox locked tabbing on radio buttons ALM #22811
	    /**
	     * Calling function onfocus event 
	     * and changing label tabindex attr to -1
	     */
	    changeTabIndex: function changeTabIndex() {
	      var element = $("label[role=radio]");
	      element.each(function () {
	        $(this).attr('tabindex', '-1');
	      });
	    },
	
	    /**
	     * Calling function onblur event making element unfocusable
	     * and changing label tabindex attr back to 0
	     * @param el (date input name)
	     */
	    changeTabIndexOut: function changeTabIndexOut(el) {
	      if (el) {
	        $(el).attr('tabindex', '0');
	      }
	      var element = $("label[role=radio]");
	      element.each(function () {
	        $(this).attr('tabindex', '0');
	      });
	    },
	
	    /**
	     * Calling function onfocus event making date input focusable
	     * @param element (date input name)
	     */
	    setTabIndex: function setTabIndex(el) {
	      var element = $("input[name=" + el + "]");
	      element.attr('tabindex', '0');
	    },
	
	    /**
	     * Calling function onclick by pressing Space key (keyCode = 32) 
	     * referencing element by element's ID
	     * @param elementId
	     */
	    clickElementOnSpaceBtn: function clickElementOnSpaceBtn(elementId) {
	      if (event.keyCode === 32 && $('#' + elementId).length > 0) {
	        //Prevents from window scrolling
	        event.preventDefault();
	        //If element is tooltip, do not perfrom action
	        if ($(".span-inline-block").is(":focus")) {
	          return false;
	        }
	        $('#' + elementId).click();
	      }
	    },
	    /**
	     * Returns all focusable elements inside parent element
	     * @parentElement
	     */
	    returnAllFocusableElements: function returnAllFocusableElements(parentElement) {
	      var focusableElements = parentElement.querySelectorAll('a[href]:not([disabled]), button:not([disabled]),' + 'textarea:not([disabled]),input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]),' + 'input[type="checkbox"]:not([disabled]), select:not([disabled]), *[tabindex="0"], area');
	      return focusableElements;
	    },
	    /**
	     * Returns all visible focusable elements from list of elements
	     * @focusableElements
	     */
	    returnAllFocusableVisibleElements: function returnAllFocusableVisibleElements(focusableElements) {
	      var visibleFocusable = [];
	
	      function findVisibleElements(item, index) {
	        $(item).unbind('keydown');
	        //Does element or its parent has display none
	        if (item.style.display !== "none" && item.offsetParent !== null) {
	          if ($(item).is(':visible')) {
	            visibleFocusable.push(item);
	          }
	        }
	      }
	
	      for (var i = 0; i < focusableElements.length; i++) {
	        findVisibleElements(focusableElements[i]);
	      }
	      return visibleFocusable;
	    },
	    /**
	     * Returns focus to first/last focusable element in modal
	     */
	    setElementFocus: function setElementFocus(firstElement, lastElement, e) {
	      var KEYCODE_TAB = 9;
	      if (e.key === 'Tab' || e.keyCode === KEYCODE_TAB) {
	        if (e.shiftKey && document.activeElement === firstElement) /* shift + tab */{
	            lastElement.focus();
	            e.preventDefault();
	          } else if (!e.shiftKey && document.activeElement === lastElement) {
	          firstElement.focus();
	          e.preventDefault();
	        }
	      }
	    },
	
	    /**
	     * Scrolls page to top
	     */
	    scrollToTop: function scrollToTop() {
	      $('#headerskip').get(0).scrollIntoView(true);
	      $('#headerskip').focus();
	    },
	
	    /**
	     * Focuses on an element without scrolling to it
	     */
	    focusWithoutScroll: function focusWithoutScroll(elem) {
	      var x = window.scrollX;
	      var y = window.scrollY;
	      elem.focus();
	      window.scrollTo(x, y);
	    },
	
	    /**
	     * Sets lisener on first and last
	     * element on modal, and traps focus inside them
	     */
	    bindModalFocusEvents: function bindModalFocusEvents(firstElement, lastElement) {
	      $(firstElement).unbind('keydown').bind('keydown', function (e) {
	        COSTCO.util.setElementFocus(firstElement, lastElement, e);
	      });
	      $(lastElement).unbind('keydown').bind('keydown', function (e) {
	        COSTCO.util.setElementFocus(firstElement, lastElement, e);
	      });
	    },
	    trapFocusInsideModal: function trapFocusInsideModal() {
	      var modalBody = $(".modal-dialog").get(0);
	      if (modalBody != undefined) {
	        var focusableElements = COSTCO.util.returnAllFocusableElements(modalBody);
	        var focusableVisible = COSTCO.util.returnAllFocusableVisibleElements(focusableElements);
	        if (focusableVisible.length > 0) {
	          var firstElement = focusableVisible[0];
	          var lastElement = focusableVisible[focusableVisible.length - 1];
	          COSTCO.util.bindModalFocusEvents(firstElement, lastElement);
	        }
	      }
	    },
	    /**
	     * Showes and hides elemenet based on flag parameter
	     * @param element
	     * @param flag
	     */
	    showHtmlElementByFlag: function showHtmlElementByFlag(element, flag) {
	      if (element == undefined || flag == undefined) {
	        return false;
	      }
	      if (flag === true) {
	        element.removeClass('hide');
	      } else {
	        element.addClass('hide');
	      }
	    },
	    /**
	     * Test if this page is part of new design.
	     * @return true if page is part of new design, false otherwise
	     */
	    isPDPCartCheckoutEnabled: function isPDPCartCheckoutEnabled() {
	      return costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE;
	    },
	
	    /**
	     * Method to convert the date input string to Timestamp format
	     */
	    convertDateToTimestamp: function convertDateToTimestamp(dateSring) {
	      var dateTimeParts = dateSring,
	          dateParts = dateTimeParts.split('-'),
	          date;
	      date = new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2], '00', '00');
	      return date.getTime();
	    },
	    globalErrorElementClasses: ['critical-notification', 'error', 'lists-error', 'form-error-text'],
	    base64test: /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/,
	    _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
	    _keyStrExcl: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
	    getUrlToLangMap: function getUrlToLangMap() {
	      var urlToLanguageMap = sessionStorage.getItem("urlToLanguageMap");
	      if (urlToLanguageMap == null) {
	        return JSON.parse("{}");
	      } else {
	        return JSON.parse(urlToLanguageMap);
	      }
	    },
	    addUrlToLangMap: function addUrlToLangMap(url, selectedLang) {
	      var urlToLanguageMap = COSTCO.util.getUrlToLangMap();
	      // Checked with business and we will accommodate 50 items in history to 
	      // check for language to reasonably meet most of customers' activities.
	      if (Object.keys(urlToLanguageMap).length >= 50) {
	        var keyToDelete = Object.keys(urlToLanguageMap)[0];
	        delete urlToLanguageMap[keyToDelete];
	      }
	      urlToLanguageMap[url] = selectedLang;
	      sessionStorage.setItem("urlToLanguageMap", JSON.stringify(urlToLanguageMap));
	    },
	    removeUrlFromLangMap: function removeUrlFromLangMap(url) {
	      var urlToLanguageMap = COSTCO.util.getUrlToLangMap();
	      delete urlToLanguageMap[url];
	      sessionStorage.setItem("urlToLanguageMap", JSON.stringify(urlToLanguageMap));
	    },
	    /**
	     * 1. Create a map of url pathname and the language at the time the url was accessed 
	     * 2. During browser history back and forward, if the selectedLanguage and value of the language from the map
	     * 		do not match, then do a hard load of the page
	     */
	    registerLanguageListener: function registerLanguageListener() {
	      // Register event if event function is not already defined
	      if (typeof window.onpageshow !== "function") {
	        window.onpageshow = function (event) {
	          var currentLang = $.cookie(cookies.SELECTED_LANG_COOKIE);
	          var currentUrl = window.location.pathname;
	          // event.persisted is faulty, so use window.performance.navigation.type also
	          if (event.persisted || window.performance && window.performance.navigation.type == 2) {
	            // window.performance.navigation.type = 2 means back or forward
	            var langSettingForCurrentUrl = COSTCO.util.getUrlToLangMap()[currentUrl];
	            if (langSettingForCurrentUrl !== undefined && langSettingForCurrentUrl !== currentLang) {
	              console.log("Doing hard reload since language has changed");
	              COSTCO.util.removeUrlFromLangMap(currentUrl);
	              if (isMobileApp == 'true') {
	                COSTCO.myLocation.reloadWithNewLanguage(currentLang);
	              }
	            }
	          } else {
	            COSTCO.util.addUrlToLangMap(currentUrl, currentLang);
	          }
	        };
	      }
	    },
	    /*
	     * A11Y STRY0166460
	     */
	    closeDropdownWhenOutOfFocus: function closeDropdownWhenOutOfFocus() {
	      $('.list-group-item').find('a').focusin(function () {
	        if (!$(this).parents('.dropdown-container').hasClass('open')) {
	          $('.dropdown-container.open').removeClass('open');
	        }
	      });
	      $('#search-field').focusin(function () {
	        $('.dropdown-container.open').removeClass('open');
	      });
	    },
	
	    /* A screen reader user should only be able to access one search field 
	     * ADA STRY0166458
	     */
	
	    addAriaHiddenToHiddenInput: function addAriaHiddenToHiddenInput() {
	      $("input[type=text].tt-hint").attr("aria-hidden", "true");
	    },
	
	    /** DSR Membership Enquiry - used to open Membership inquiry modal
	     * 
	    */
	    membershipDetailedEnquiry: function membershipDetailedEnquiry() {
	      var modalOptions = {
	        title: messages.RWD_MEMBERSHIP_NUMBER,
	        body: COSTCO.util.tmpl('tmpl_membership_modal'),
	        primary: messages.CLOSE,
	        primary_button_fullspan: false,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	        }
	      };
	      COSTCO.dialog.showAndHideModal(modalOptions);
	    },
	    /**
	        * Method return timeout function for fetch method to call API services
	        */
	    getTimeoutController: function getTimeoutController() {
	      /**
	        * Timeout function
	        * @param {Integer} time (miliseconds)
	        * @param {Promise} promise
	        */
	      var timeout = function timeout(time, promise) {
	        return new Promise(function (resolve, reject) {
	          setTimeout(function () {
	            reject(new Error('API_TIMEOUT'));
	          }, time);
	          promise.then(resolve, reject);
	        });
	      };
	      return timeout;
	    },
	    /**
	        * Method to check if a DOM element is present using its ID and verify the value of the element
	        * return true if the value matches, else false.
	        */
	    checkElementById: function checkElementById(elementId, value) {
	      var elementValueMatch = false;
	      if ($(elementId).length > 0 && $(elementId).val() === value) {
	        elementValueMatch = true;
	      }
	      return elementValueMatch;
	    },
	
	    parseURL: function parseURL(url) {
	      var a = document.createElement('a');
	      a.href = url;
	      return {
	        source: url,
	        protocol: a.protocol.replace(':', ''),
	        host: a.hostname,
	        port: a.port,
	        query: a.search,
	        params: function () {
	          var ret = {},
	              seg = a.search.replace(/^\?/, '').split('&'),
	              len = seg.length,
	              i = 0,
	              s;
	          for (; i < len; i++) {
	            if (!seg[i]) {
	              continue;
	            }
	            s = seg[i].split('=');
	            ret[s[0]] = s[1];
	          }
	          return ret;
	        }(),
	        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
	        hash: a.hash.replace('#', ''),
	        path: a.pathname.replace(/^([^\/])/, '/$1'),
	        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
	        segments: a.pathname.replace(/^\//, '').split('/')
	      };
	    },
	
	    getParamVal: function getParamVal(url, key) {
	      var urlMap = COSTCO.util.parseURL(url);
	      return urlMap.params[key];
	    },
	
	    /**
	     * Utility function detect is browser IE11 or older version
	     * return boolean
	     */
	    isIE11OrOlder: function isIE11OrOlder() {
	      var ua = window.navigator.userAgent;
	      var msie = ua.indexOf('MSIE ');
	      if (msie > 0) {
	        // IE 10 or older 
	        return true;
	      }
	      var trident = ua.indexOf('Trident/');
	      if (trident > 0) {
	        // IE 11 
	        return true;
	      }
	      return false;
	    },
	
	    /**
	     * Utility function to check if user is logged in
	     * return boolean
	     */
	    isUserLoggedIn: function isUserLoggedIn() {
	
	      try {
	        $.cookie("hashedUserId").length;
	        return true;
	      } catch (e) {
	        return false;
	      }
	    },
	
	    objectExistsAndNonEmpty: function objectExistsAndNonEmpty(obj) {
	      if (typeof obj == 'undefined') {
	        return false;
	      } else if (obj == null) {
	        return false;
	      } else if (obj == '') {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    filterItems: function filterItems(arr, query) {
	      return arr.filter(function (el) {
	        return el.toLowerCase() != query.toLowerCase();
	      });
	    },
	
	    signoutNextAuth: function signoutNextAuth() {
	      // Fetch CSRF token
	      fetch("/api/auth/csrf", {
	        method: "GET",
	        headers: {
	          "Accept": "*/*",
	          "Cache-Control": "no-cache",
	          "Content-Type": "application/json",
	          "Pragma": "no-cache",
	          "Sec-Fetch-Mode": "cors",
	          "Sec-Fetch-Site": "same-origin",
	          "Credentials": "include"
	        }
	      }).then(function (response) {
	        if (!response.ok) {
	          throw new Error('Failed to fetch CSRF token');
	        }
	        return response.json();
	      }).then(function (data) {
	        var csrfToken = data.csrfToken;
	
	        // Sign out using CSRF token
	        return fetch("/api/auth/signout", {
	          method: "POST",
	          headers: {
	            "Accept": "*/*",
	            "Cache-Control": "no-cache",
	            "Content-Type": "application/x-www-form-urlencoded",
	            "Pragma": "no-cache",
	            "Sec-Fetch-Mode": "cors",
	            "Sec-Fetch-Site": "same-origin",
	            "Credentials": "include"
	          },
	          body: new URLSearchParams({
	            csrfToken: csrfToken,
	            callbackUrl: new URL(window.location.href).origin + "/?ao=yes",
	            json: true
	          })
	        });
	      }).then(function (response) {
	        if (!response.ok) {
	          throw new Error('Failed to sign out');
	        }
	        return response.json();
	      }).then(function (data) {
	        console.log(data.message);
	        // Handle success message as needed
	      }).catch(function (error) {
	        console.error('Error signing out:', error);
	        // Provide user feedback here if needed
	      });
	    },
	    logoutSso: function logoutSso(obj, logOffUrls, isSsoEnabled, isMobileApp) {
	      sessionStorage.removeItem("SelectedPatientIndex");
	      $.cookie('PrescriptionCount', null, { path: '/' });
	      try {
	        console.log("Sign out ");
	        if (typeof Android != 'undefined') {
	          console.log("Android sign out ");
	          Android.onSignOut();
	        } else if (typeof webkit != 'undefined') {
	          console.log("Webkit sign out ");
	          webkit.messageHandlers.onSignOut.postMessage('');
	        }
	        console.log("Sign out finished");
	        if (isSsoEnabled == '0' || isSsoEnabled == null || isSsoEnabled == '' || isSsoEnabled == false || isMobileApp == null || isMobileApp == '' || isMobileApp == 'true') {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	          return;
	        }
	
	        var logOffAcion = "/security/v1/users/session/ssologoff";
	
	        //New home page support.
	        try {
	          COSTCO.util.signoutNextAuth();
	        } catch (k) {}
	
	        $.cookie('C_GOP', null, { path: '/' });
	        if (logOffUrls == null || logOffUrls == undefined || logOffUrls == "") {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	          return;
	        }
	
	        logOffUrls = logOffUrls.split(",");
	        logOffUrls = COSTCO.util.filterItems(logOffUrls, window.location.origin);
	
	        if (logOffUrls != null && logOffUrls.length > 0) {
	          var targetUri = '';
	
	          if (costcoStoreFeatures.OCUCO_LOGOUT_ENABLED === true) {
	            targetUri = logOffUrls[0] + logOffAcion + '?' + 'a=' + logOffUrls[1] + logOffAcion + '&b=' + logOffUrls[2] + logOffAcion + '&c=' + logOffUrls[3] + "/Account/Logout";
	          } else {
	            targetUri = logOffUrls[0] + logOffAcion + '?' + 'a=' + logOffUrls[1] + logOffAcion + '&b=' + logOffUrls[2] + logOffAcion;
	          }
	          var logoffWindow = window.open(targetUri, '_blank');
	          setTimeout(function () {
	            logoffWindow.close();
	            window.location = window.location.origin + "/Logoff?usrClk=true";
	          }, 3800); //milliseconds
	        } else {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	        }
	      } catch (e) {
	        console.log(e);
	        window.location = window.location.origin + "/Logoff?usrClk=true";
	      }
	    },
	
	    /**
	    * This function strips anything that isn't a number
	     * Intended for quantity selector 
	    * @param {[string] inputValue}  
	    * @returns {[number] outputValue}
	    */
	    stripStringOfNonNumberTypes: function stripStringOfNonNumberTypes(inputValue) {
	      var outputValue = inputValue.replace(/[^\d]/g, "");
	      return outputValue;
	    },
	    /**
	     * Checks if the current context is related to a locationControlledInventory product. 
	     */
	    islocationControlledInventoryFlow: function islocationControlledInventoryFlow() {
	      var islocationControlledInventoryFlow = $('#regionalIdentifier').length > 0 && $('#regionalIdentifier').val() == 'true' ? true : false;
	      return islocationControlledInventoryFlow;
	    },
	
	    /**
	     * Checks if the current context is related to a siteControlledInventory product. 
	     */
	    issiteControlledInventoryFlow: function issiteControlledInventoryFlow() {
	      var issiteControlledInventoryFlow = $('#regionalIdentifier').length > 0 && $('#regionalIdentifier').val() == 'false' ? true : false;
	      return issiteControlledInventoryFlow;
	    },
	
	    getFiveDigitPostalCode: function getFiveDigitPostalCode(postalCode) {
	      var zipCode = postalCode;
	      var finalZip = '';
	      var zipCodeWithoutExtraFour = zipCode.split('-');
	      if (zipCodeWithoutExtraFour.length > 1) {
	        finalZip = zipCodeWithoutExtraFour[0];
	      } else {
	        finalZip = zipCode;
	      }
	      return finalZip;
	    },
	
	    formatPhoneNumber: function formatPhoneNumber(number) {
	      var phNumber = number.replace(/\D/g, '');
	      return phNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
	    },
	
	    cancelMemberApplication: function cancelMemberApplication(partNumber) {
	      var appTrackingCookie = $.cookie('APPLICATION_TRACKING_COOKIE');
	      var currentPage = window.location.pathname.substr(1);
	
	      if (document.referrer === "") {
	        window.location.href = '/CheckoutCartView';
	      } else {
	
	        if (appTrackingCookie !== 'null' || 'undefined') {
	          if ($('#isBDAppVar').val() === 'BD' && $.cookie('cartCountCookie') > 1) {
	            path = '/MembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
	          } else {
	            path = '/QuickMembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
	          }
	          console.log('path: ', path);
	          window.location.href = path;
	          return;
	        }
	        window.location.href = COSTCO.util.scrubSpecialChars(document.referrer);
	      }
	    },
	
	    /** selects the input radio buttons inside the given element
	    * used for all the radio buttons/selection-boxes combined elements */
	    selectRadioBox: function selectRadioBox(element) {
	      $(element).find('input').prop('checked', true);
	    },
	
	    /** used on onblur event of all fields so that the screen reader 
	    * would announce the error when focus moves out of the field */
	    alertScreenReader: function alertScreenReader(element) {
	      if ($(element).attr('aria-invalid') === 'true') {
	        var elementName = $(element).attr('name');
	        var errorElement = $('#' + elementName + 'Error');
	
	        errorElement.removeAttr('role');
	        errorElement.attr('role', 'alert');
	      }
	    },
	
	    ariaSetElementAsValid: function ariaSetElementAsValid(element) {
	      if (element) {
	        element.removeAttr('aria-describedby');
	        element.attr('aria-invalid', 'false');
	      }
	    },
	
	    ariaSetElementAsInvalid: function ariaSetElementAsInvalid(element, describedByElementId) {
	      if (element) {
	        element.attr('aria-describedby', describedByElementId);
	        element.attr('aria-invalid', 'true');
	      }
	    },
	    /**
	     * Gets element with back to top link and (if exists) binds keydown and click event
	     * that moves focus to top of the page. For Gatsby enabled pages # routing is implemented
	     * so we have add event to div rather than adding a new hash to current url
	     *
	     * @param backToTopLink
	     */
	    setEventOnBackToTopLinkGatsby: function setEventOnBackToTopLinkGatsby(backToTopLinkClass) {
	      /* ADA to move focus on skip link click */
	      var $backToTopLink = $(backToTopLinkClass).find("a").length > 0 ? $(backToTopLinkClass).find("a") : $(backToTopLinkClass);
	      //Added for gatsby body focus
	      $backToTopLink.click(function () {
	        $backToTopLink.attr("href", window.location.href);
	        COSTCO.util.scrollToTopGatsby();
	      });
	      $backToTopLink.keydown(function (e) {
	        $backToTopLink.attr("href", window.location.href);
	        if (e.keyCode === 13) COSTCO.util.scrollToTopGatsby();
	      });
	    },
	
	    /**
	    * This function opens and closes accordion that contains drugs list
	    * @param  {String} letter capital letter of drugs
	    * @param  {String} html element that was clicked
	    * @param  {String} hostProtocolURL 
	    * @return {void}
	    */
	    show_drug_list_by_capital_letter: function show_drug_list_by_capital_letter(letter, hostProtocolURL, element) {
	      if ($('#cmpp-drugs-by-letter-accordion-collapse').hasClass('in') && $('#cmpp-drugs-by-letter-accordion-collapse').attr('data-letter') == letter) {
	        $('#cmpp-drugs-by-letter-accordion-collapse').collapse('hide');
	        $(element).children(".cmpp-close").addClass("hidden");
	        $(element).removeClass("cmpp-title-active");
	        $('html, body').animate({ scrollTop: $(element).offset().top }, 800);
	      } else {
	
	        if ($('#cmpp-drugs-by-letter-accordion-collapse').hasClass('in')) {
	
	          $('#cmpp-drugs-by-letter-accordion-collapse').collapse('hide');
	
	          setTimeout(function () {
	            COSTCO.util.drug_list_by_capital(letter, hostProtocolURL, element);
	          }, 700);
	        } else {
	          COSTCO.util.drug_list_by_capital(letter, hostProtocolURL, element);
	        }
	      }
	    },
	    /**
	     * This function handles building the drug list that corresponds
	     * with first letter of drug name.
	     * @param  {String} stateCode used to filter list of all cmpps
	     * @param  {String} html element that was clicked
	     * @param  {String} hostProtocolURL
	     * @return {void}
	     */
	    drug_list_by_capital: function drug_list_by_capital(letter, hostProtocolURL, element) {
	
	      $('#cmpp-drugs-by-letter-accordion-collapse').remove();
	      $('html, body').animate({ scrollTop: $(element).offset().top }, 800);
	
	      $(".panel-group div div div").removeClass("cmpp-title-active");
	      $(".panel-group div div .cmpp-close").addClass("hidden");
	      $(element).addClass("cmpp-title-active");
	      $(element).children(".cmpp-close").removeClass("hidden");
	
	      $(element).parent().after(COSTCO.util.tmpl('tmpl_drugs_by_letter', {
	        letter: letter
	      }));
	      var windowWidth = $(window).width();
	      var colNum = 1;
	      if (windowWidth > 1025) {
	        colNum = 3;
	      } else if (windowWidth > 667) {
	        colNum = 2;
	      };
	      var drugNamesObj = JSON.parse(allDrugNamesMap[0].jsonDrugNameURL);
	      var drugArr = [];
	      for (var el in drugNamesObj) {
	        if (el.substring(0, 1) === letter) {
	          var obj = {
	            drugName: el,
	            drugUrl: drugNamesObj[el]
	          };
	          drugArr.push(obj);
	        }
	      }
	      var numOfItems = drugArr.length;;
	      var numOfRows = Math.ceil(numOfItems / colNum);
	      for (var i = 0; i < numOfRows; i++) {
	        $('#cmpp-drugs-by-letter-accordion-collapse-panel').append(COSTCO.util.tmpl('tmpl_drugs_list_by_capital_letter', {
	          drugLink1: drugArr[i] && hostProtocolURL + drugArr[i].drugUrl,
	          drugLink2: drugArr[i + numOfRows] && hostProtocolURL + drugArr[i + numOfRows].drugUrl,
	          drugLink3: drugArr[i + 2 * numOfRows] && hostProtocolURL + drugArr[i + 2 * numOfRows].drugUrl,
	          drugName1: drugArr[i].drugName && drugArr[i].drugName,
	          drugName2: drugArr[i + numOfRows] && drugArr[i + numOfRows].drugName,
	          drugName3: drugArr[i + 2 * numOfRows] && drugArr[i + 2 * numOfRows].drugName,
	          numOfCol: colNum
	
	        }));
	      }
	      $('#cmpp-drugs-by-letter-accordion-collapse').collapse('show');
	    },
	    /**
	     * Scrolls page to top
	    */
	    scrollToTopGatsby: function scrollToTopGatsby() {
	      document.getElementById("gatsbyIndex").scrollIntoView(true);
	      document.getElementById("gatsbyIndex").focus();
	    },
	
	    /**
	      * Util to give an interactive character count down
	      * @param  {ojbect} label    pass the jquery obj where you want the
	      *                           countdown to reflect
	      * @param  {object} textarea pass a 'text' input
	      *                           (input[type='text'],textarea) to count
	      * @return {void}
	    */
	    character_count: function character_count(label, textarea) {
	      if ($(label).length > 0 && $(textarea).length > 0) {
	        var updateLabelCount = function updateLabelCount(textarea, label) {
	          var count = $(textarea).val().length;
	          $(label).text(max - count);
	        };
	
	        var max = parseInt($(textarea).attr('maxlength'));
	        $(label).text(max - $(textarea).val().length);
	        $(textarea).unbind('keyup').on('keyup', function () {
	          updateLabelCount(this, label);
	        });
	        $(textarea).unbind('change').on('change', function () {
	          updateLabelCount(this, label);
	        });
	      }
	    },
	    getCookieByName: function getCookieByName(name) {
	      var value = '; ' + document.cookie;
	      var parts = value.split('; ' + name + '=');
	      if (parts.length === 2) return parts.pop().split(';').shift();
	    },
	
	    // function for sanitizing data to prevent XSS attacks
	    replaceSpecialChars: function replaceSpecialChars(obj) {
	      var result = new String(obj);
	
	      result = result.replace(/&/g, "&amp;");
	      result = result.replace(/</g, "&lt;");
	      result = result.replace(/>/g, "&gt;");
	      result = result.replace(/'/g, "&#39;");
	      result = result.replace(/"/g, "&quot;");
	      result = result.replace(/\//g, "&#47;");
	      result = result.replace(/\\/g, "&#92;");
	
	      return result;
	    },
	    /**
	     * Async SHA256 encryption
	     * @param {} message text that will be hashed
	     * @param {} callback 
	     */
	    sha256: function sha256(message, callback) {
	      var encoder = new TextEncoder();
	      var data = encoder.encode(message);
	      crypto.subtle.digest('SHA-256', data).then(function (hashBuffer) {
	        var hashArray = Array.from(new Uint8Array(hashBuffer));
	        var hashHex = hashArray.map(function (byte) {
	          return byte.toString(16).padStart(2, '0');
	        }).join('');
	        callback(hashHex);
	      }).catch(function (error) {
	        console.error('Error calculating SHA-256 hash: ', error);
	        callback(null);
	      });
	    },
	    getCookieStartingWith: function getCookieStartingWith(prefix) {
	      var cookies = document.cookie.split(';');
	
	      for (var i = 0; i < cookies.length; i++) {
	        var cookie = cookies[i].trim();
	
	        // Check if the cookie starts with the specified prefix
	        if (cookie.startsWith(prefix)) {
	          // Extract the value of the cookie
	          return cookie.substring(prefix.length + 1);
	        }
	      }
	
	      // Return null if no matching cookie is found
	      return null;
	    },
	
	    /**
	     * Decode JWT and check for validity.  
	     * */
	    checkJWTExpiry: function checkJWTExpiry(JWT) {
	      var expired = true;
	      var JWT_payload = JSON.parse(atob(JWT.split('.')[1]));
	      if (typeof JWT_payload != 'undefined' && JWT_payload != null) {
	        var currentTimeInMiliseconds = Date.now();
	        var validUntil = Number(JWT_payload.created_at) + Number(JWT_payload.expires_in) - 3600000;
	        if (currentTimeInMiliseconds < validUntil) {
	          expired = false;
	        }
	      }
	      return expired;
	    },
	    sentenceToPascalCase: function sentenceToPascalCase(sentence) {
	      return sentence.split(' ').map(function (word) {
	        // Keeps only letters and numbers (including accented/Unicode letters)
	        return (word.match(/[A-Za-zÀ-ÖØ-öø-ÿ0-9]+/g) || []).join('');
	      }).map(function (word) {
	        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
	      }).join(' ');
	    },
	    isElementEmpty: function isElementEmpty(elementValue) {
	      if (typeof elementValue === 'undefined' || elementValue === null || elementValue === '') return true;
	      return false;
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.util = util;
	
	  return util;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title utility2.js: Global sub-module
	 * @description A collection of functions used application wide, except Home, Browse & Product pages.
	 * Functions that are not needed for Home, Browse & Product pages should live in this file
	 * This module should contain generic utility code. No module specifics.
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var util = {
	    POSTAL_CODE_REGEX_US: /^(\d{5}(-\d{4})?$)$/,
	    POSTAL_CODE_REGEX_CA: /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/,
	    ATLEAST_ONE_ALPHABET: /^(?=.*[A-Za-z\u00C0-\u017F]).+/,
	    CC_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\&\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    LAST_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    /*
	     * Function used to escape double ticks (ADA)
	     **/
	    encode_html: function encode_html(input) {
	      input = input.replace('"', '&#34');
	      input = input.replace('\'', '&#39');
	      input = input.replace(';', '&#59');
	      return input;
	    },
	    /**
	     * Function used to "extend" the bootstap popover capability to add accesibility features
	     * function add a couple of the ADA needed attributes and a couple of keyboard navigation listener
	     * popover parameters are expected to be defined in the element as normal bootsrap popover
	     */
	    accesible_popover: function accesible_popover(selector) {
	      var popoverElement = $(selector);
	      popoverElement.popover().on('keydown', function (event) {
	        if (event.which == 13) $(this).popover('toggle');
	        if (event.which == 27) $(this).popover('hide');
	      }).on('blur', function () {
	        $(this).popover('hide');
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    /**
	     * This function makes images in popover content tabbable for ADA purposes
	     * @param {string} tooltipClass - Tooltip class.
	     * @return {void}
	     */
	    activateKeyboardAccesiblePopover: function activateKeyboardAccesiblePopover(selector) {
	      var popoverElement = $('.' + selector);
	      popoverElement.popover().on('keydown', function (event) {
	        //Enter event keycode
	        if (event.which === 13) {
	          $(this).popover('toggle');
	          //Esc event keycode
	        } else if (event.which === 27) {
	          $(this).popover('hide');
	          //Shift+Tab event keycode
	        } else if (event.shiftKey && event.keyCode === 9) {
	          $(this).popover('hide');
	        }
	      }).on('focus', function () {
	        $(this).popover('toggle');
	        var tooltipElement = $(this);
	        var popoverContentId = $(this).attr('aria-describedby');
	        if (popoverContentId !== undefined && $('#' + popoverContentId).find('img').length !== 0) {
	          $('#' + popoverContentId).find('img').on('blur', function () {
	            tooltipElement.popover('hide');
	          });
	        }
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	      $(':not(.' + selector + ')').on('click', function () {
	        $('.co-help').each(function () {
	          if ($(this).attr('aria-expanded') === 'true') {
	            $(this).popover('hide');
	          }
	        });
	      });
	    },
	    isMinimumScreen: function isMinimumScreen(min) {
	      var width = $(window).width();
	      if (min == 'DESKTOP' && width >= 1025) return true;
	      if (min == 'TABLET-LANDSCAPE' && width >= 769) return true;
	      if (min == 'TABLET-PORTRAIT' && width >= 668) return true;
	      if (min == 'PHONE-LANDSCAPE' && width >= 376) return true;
	      if (min == 'PHONE-PORTRAIT' && width >= 0) return true;
	      return false;
	    },
	    isMaxScreen: function isMaxScreen(min) {
	      var width = $(window).width();
	      if (min == 'DESKTOP' && width < 1024) return true;
	      if (min == 'TABLET-LANDSCAPE' && width < 769) return true;
	      if (min == 'TABLET-PORTRAIT' && width < 668) return true;
	      if (min == 'PHONE-LANDSCAPE' && width < 376) return true;
	      if (min == 'PHONE-PORTRAIT' && width >= 0) return true;
	      return false;
	    },
	    /**
	     * External link dialog for FORMS ONLY.
	     */
	    createExternalLinkDialogForForm: function createExternalLinkDialogForForm(link, form, submitButtonTitle) {
	      var dialogDiv = $('<div id="external_link_dialog">' + $('<div>').append(form.clone()).html() + '<span>' + messages.JS_LEAVING_DOMAIN_ALERT.replace('{0}', this.hostname) + '</span></div>');
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_EXTERNAL_LINK,
	        body: dialogDiv,
	        primary: submitButtonTitle,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          $('#external_link_dialog form').submit();
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    /**
	     * Return an array with only unique members. unique([1,2,1])
	     * returns [2,1]
	     * @param  {[array]} arr - The array with duplicated members
	     * @return {[array]} out - The array with unique members
	     */
	    unique: function unique(arr) {
	      var seen = {},
	          out = [],
	          len = arr.length,
	          j = 0;
	      for (var i = 0; i < len; i++) {
	        var item = arr[i];
	        if (seen[item] !== 1) {
	          seen[item] = 1;
	          out[j++] = item;
	        }
	      }
	      return out;
	    },
	    /**
	     * Return an array with a string interpolated between
	     * each member i.e. interpolate([1,2],'+') returns [1,"+",2]
	     * @param  {[array]} array - The array to interpolate
	     * @param  {[type]} string - the element to interpolate in the array
	     * @return {[type]} _array - The interpolated array
	     */
	    interpolate: function interpolate(array, _string) {
	      var _array = [];
	      for (var i = 0, len = array.length; i < len; i++) {
	        _array.push(array[i]);
	        if (i != array.length - 1) {
	          _array.push(_string);
	        }
	      }
	      return _array;
	    },
	    // Added for submitting encoded values without special characters
	    encodeExclSpecialChars: function encodeExclSpecialChars(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0,
	          enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = COSTCO.util._utf8_encode(input);
	      while (i < input.length) {
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	        enc1 = chr1 >> 2;
	        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	        enc4 = chr3 & 63;
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	        output = output + this._keyStrExcl.charAt(enc1) + this._keyStrExcl.charAt(enc2) + this._keyStrExcl.charAt(enc3) + this._keyStrExcl.charAt(enc4);
	      }
	      return output;
	    },
	    // public method for decoding
	    decodeExclSpecialChars: function decodeExclSpecialChars(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0;
	      var enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	      while (i < input.length) {
	        enc1 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc2 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc3 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc4 = this._keyStrExcl.indexOf(input.charAt(i++));
	        chr1 = enc1 << 2 | enc2 >> 4;
	        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	        chr3 = (enc3 & 3) << 6 | enc4;
	        output = output + String.fromCharCode(chr1);
	        if (enc3 != 64) {
	          output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	          output = output + String.fromCharCode(chr3);
	        }
	      }
	      output = COSTCO.util._utf8_decode(output);
	      output = output.replace(/[\u0000-\u0019]+/g, ''); // For removing the non-printable & Invalid JSON characters.
	      return output;
	    },
	    addresses: [],
	    addressLoadState: {
	      shipping: {
	        requested: 0,
	        loaded: 0
	      },
	      billing: {
	        requested: 0,
	        loaded: 0
	      }
	    },
	    resetAddressLoadState: function resetAddressLoadState() {
	      COSTCO.util.addresses = [];
	      COSTCO.util.addressLoadState = {
	        shipping: {
	          requested: 0,
	          loaded: 0
	        },
	        billing: {
	          requested: 0,
	          loaded: 0
	        }
	      };
	    },
	    getAddressBatchPage: function getAddressBatchPage(addressType, filterName, filterOrder, total, processBatch, processPagination) {
	      var start = 1,
	          end = total;;
	      if (addressType == 'S') {
	        addressLoadState = COSTCO.util.addressLoadState.shipping;
	      } else {
	        addressLoadState = COSTCO.util.addressLoadState.billing;
	      }
	      if (addressLoadState.requested == 0) {
	        COSTCO.util.getAddressBatch(addressType, filterName, filterOrder, start, total, processBatch, processPagination);
	      } else {
	        if (total > addressLoadState.requested) {
	          COSTCO.util.getAddressBatch(addressType, filterName, filterOrder, addressLoadState, total + addressLoadState.requested, processBatch, processPagination);
	        } else {
	          if (typeof processBatch === 'function') processBatch(COSTCO.util.addresses);
	          if (typeof processPagination === 'function') processPagination(COSTCO.util.addresses);
	        }
	      }
	    },
	    /* getAddresses
	     * arguments can contain a list of callback functions to be executed on .done.  The last arg is a optional addressType (S || B) that retrieves a filtered list of addresses
	     * */
	    getAddressBatch: function getAddressBatch(addressType, filterName, filterOrder, start, end, processBatch, processPagination) {
	      // request the user's addresses 
	
	      COSTCO.util.ajax({
	        url: '/AjaxCostcoGetAddressCmd?requesttype=ajax',
	        method: 'GET',
	        dataType: 'json',
	        data: {
	          addressType: encodeURIComponent(addressType),
	          filterName: encodeURIComponent(filterName),
	          filterOrder: encodeURIComponent(filterOrder),
	          start: encodeURIComponent(start),
	          end: encodeURIComponent(end)
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          try {
	            if (addressType == 'S') {
	              COSTCO.util.addressLoadState.shipping.requested += parseInt(end);
	              COSTCO.util.addressLoadState.shipping.loaded += parseInt(data.totalrecords);
	            } else {
	              COSTCO.util.addressLoadState.billing.requested += parseInt(end);
	              COSTCO.util.addressLoadState.billing.loaded += parseInt(data.totalrecords);
	            }
	            if (typeof data.addresses !== 'undefined') {
	              COSTCO.util.mergeAddresses(JSON.parse(data.addresses));
	            }
	          } catch (err) {
	            //
	            console.error(err, 'Parse error');
	          }
	          if (typeof processBatch === 'function') processBatch(data);
	          if (typeof processPagination === 'function') processPagination(data);
	        }
	      });
	    },
	    mergeAddresses: function mergeAddresses(data) {
	      for (var i = 0; i < data.length; i++) {
	        if (data[i].hasOwnProperty('addressId')) {
	          COSTCO.util.renameArray(data[i], COSTCO.util.addressNamingMap);
	        }
	      }
	      COSTCO.util.addresses = COSTCO.util.addresses.concat(data);
	    },
	    /**
	     * Add every unique address from 'addresses' to
	     * COSTCO.util.addresses
	     * @param  {array} addresses [
	     * @return {void}
	     */
	    concatNonDuplicates: function concatNonDuplicates(addresses) {
	      var _this = this;
	
	      addresses.forEach(function (address) {
	        if (!_this.any(_this.addresses, function (x) {
	          return x.id == address.id;
	        })) {
	          _this.addresses.push(address);
	        }
	      });
	    },
	    /*
	     * Address naming is a mess
	     */
	    addressNamingMap: {
	      addressId: 'id',
	      addressTypeId: 'addressType',
	      addressLine1: 'line1',
	      addressLine2: 'line2',
	      firstName: 'first',
	      lastName: 'last',
	      companyName: 'company',
	      primary: 'isPrimary',
	      postalCode: 'zip',
	      middleName: 'mInitial',
	      emailAddress: 'email',
	      fName: 'first',
	      lName: 'last',
	      pNumber: 'phone'
	    },
	    renameArray: function renameArray(data, map) {
	      for (var key in data) {
	        if (data.hasOwnProperty(key) && map.hasOwnProperty(key)) {
	          data[map[key]] = data[key];
	          delete data[key];
	        }
	      }
	    },
	    unbindEvents: function unbindEvents(obj) {
	      Object.keys(obj).forEach(function (key) {
	        $(obj[key]).unbind('click').unbind('blur').unbind('change').unbind('touchstart');
	      });
	    },
	    /**
	     * Function used to notify the native web application that the user has been sucessfully
	     * logged out of the costco website. This is needed as the app relies upon web view
	     */
	    notifyAppLogout: function notifyAppLogout() {
	      console.log('notifying app of logout');
	      try {
	        if (typeof Android != 'undefined') {
	          Android.logoutCostcoApp();
	        } else if (typeof webkit != 'undefined') {
	          webkit.messageHandlers.logoutAction.postMessage('success');
	        }
	      } catch (e) {
	        console.warn(e);
	      }
	    },
	    removeParam: function removeParam(key, sourceURL) {
	      var rtn = sourceURL.split('?')[0],
	          param = void 0,
	          params_arr = [],
	          queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
	      if (queryString !== '') {
	        params_arr = queryString.split('&');
	        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
	          param = params_arr[i].split('=')[0];
	          if (param === key) {
	            params_arr.splice(i, 1);
	          }
	        }
	        rtn = rtn + '?' + params_arr.join('&');
	      }
	      return rtn;
	    },
	    /**
	     * Politically incorrect method for turning an array of objects in the form
	     * of [{name:'hi',value:'robert'},{}..] into an equivalent object
	     * '{hi: 'robert', hey: 'robert'}'. $(form).serializeArray() will return
	     * the array of objects we're looking to convert
	     * @param  {Array} arr The array of objects.
	     * @return {Object}    The object equivalent of arr
	     */
	    objectifyArray: function objectifyArray(arr) {
	      var obj = {};
	      arr.forEach(function (arrObj) {
	        obj[arrObj.name] = arrObj.value;
	      });
	      return obj;
	    },
	
	    /**
	     * Utility function for adjusting heights of arbitrary numbner of divs, setting it to the 'tallest' value
	     * For this to happen two things must be the case:
	     * #1 All the DIVs that need to be aligned should have same unique css class applied (convention is costco-align-height-some-arbitrary-name)
	     * #2 call the function with string denoting applied class name, e.g. :
	     *		adjustDivHeights('.costco-align-height-some-arbitrary-name');
	     */
	
	    /* Compare heights of all divs with applied css class and increase the 'smaller' ones to the height of the tallest */
	    adjustDivHeights: function adjustDivHeights(alignClass, defaultHeight) {
	      $arrDivs = $(alignClass);
	      if ($arrDivs != null && $arrDivs.length > 0) {
	        max = 0;
	        $arrDivs.each(function () {
	          max = Math.max(max, parseInt($(this).height()));
	        });
	        if (max == 0 && typeof defaultHeight != 'undefined') {
	          max = defaultHeight;
	        }
	        $arrDivs.each(function () {
	          if ($(this).height() != max) {
	            $(this).height(max);
	          }
	        });
	      }
	    },
	    /**
	     * Capitalize a given string. Takes a string of form "Hi there Robert" and
	     * returns "Hi There Robert".
	     * @param  {String} str The string to capitalize
	     * @return {String}     The capitalized string.
	     */
	    capitalize: function capitalize(str) {
	      return str.split(' ').map(function (x) {
	        return x.charAt().toUpperCase().concat(x.substr(1));
	      }).join(' ');
	    },
	    isUsOrCaZipCode: function isUsOrCaZipCode() {
	      if ($('#B_countryId').length > 0 || $('#countryId').length > 0) {
	        return COSTCO.util.isUSOrCaAddressZip();
	      } else {
	        var storeId = wcs.storeId;
	        switch (storeId) {
	          case '10301':
	            return true;
	          case '10302':
	            return false;
	          case '11301':
	            return true;
	          default:
	            return false;
	        }
	      }
	    },
	    isUSOrCaAddressZip: function isUSOrCaAddressZip() {
	      var selCountry = $('#B_countryId').length > 0 ? $('#B_countryId').val() : $('#countryId').val();
	      selCountry = selCountry + wcs.storeId;
	      switch (selCountry) {
	        case 'US10301':
	          return true;
	        case 'CA10301':
	          return false;
	        case 'US10302':
	          return true;
	        case 'CA10302':
	          return false;
	        case 'US11301':
	          return true;
	        case 'CA11301':
	          return false;
	        case 'US11303':
	          return true;
	        case 'CA11303':
	          return false;
	        default:
	          return 'false';
	      }
	    },
	    getMaxHeight: function getMaxHeight(elems) {
	      return Math.max.apply(null, elems.map(function () {
	        return $(this).height();
	      }).get());
	    },
	    /**
	     * Checks if the current context is related to a grocery product. 
	     */
	    is2DayFlow: function is2DayFlow() {
	      var is2DayFlow = $('#groceryIdentifier').length > 0 && $('#groceryIdentifier').val() == 'true' ? true : false;
	      return is2DayFlow;
	    },
	    isLTLDeliveryServicesEnabled: function isLTLDeliveryServicesEnabled() {
	      var ltlDeliveryServicesEnableFlag = $('#deliveryServicesEnabled').length > 0 && $('#deliveryServicesEnabled').val() == 'true' ? true : false;
	      return ltlDeliveryServicesEnableFlag;
	    },
	
	    /**
	     * dob Validation- Month and date range validation and leap year validation.
	     * @param month 
	     * @param day
	     * @param year 
	     */
	    dateValidation: function dateValidation(month, day, year) {
	      var isDateValid = false;
	      var currentYear = new Date().getFullYear();
	      var beginningYear = currentYear - 100;
	      if (typeof year !== 'undefined' && year !== "" && (year < beginningYear || year > currentYear)) {
	        isDateValid = false;
	      } else if ((month === "04" || month === "06" || month === "09" || month === "11") && day <= 30 && day >= 1) {
	        isDateValid = true;
	      }
	      // check for february 29th
	      else if (month === "02") {
	          var isleap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	          if (day >= 1 && (day < 29 || day === "29" && isleap)) {
	            isDateValid = true;
	          }
	        }
	        // Check for month and day range
	        else if (month >= 1 && month <= 12 && day <= 31 && day >= 1) {
	            isDateValid = true;
	          } else {
	            if ((month === "" || typeof month === 'undefined') && (year === "" || typeof year === 'undefined') && (COSTCO.util.isCAStore() || day === "" || typeof day === 'undefined')) {
	              isDateValid = true;
	            }
	          }
	      return isDateValid;
	    },
	    /**
	     * Function used to check if Global error exists on page.
	     * @return {Boolean}
	     */
	    isGlobalErrorOnPage: function isGlobalErrorOnPage() {
	      var isGlobalError = false;
	      var errorClasses = COSTCO.util.globalErrorElementClasses;
	
	      jQuery.each(errorClasses, function (index, value) {
	        $('.' + value).each(function () {
	          if ($(this) !== 'undefined' && $(this).html() !== 'undefined' && $(this).html().trim().lenght > 0 || $(this).children() !== 'undefined' && $(this).children().html() !== undefined && $(this).children().html().trim().length > 0) {
	            var innerContent = $(this).children().html() !== undefined ? $(this).children().html() : $(this).html();
	            if ($(this).length > 0 && innerContent.length > 1) {
	              isGlobalError = true;
	            }
	          }
	        });
	      });
	
	      return isGlobalError;
	    },
	
	    /**
	     * Populates announcement screen reader div on page load
	     */
	    announceSRGlobalErrorMessage: function announceSRGlobalErrorMessage() {
	      if (COSTCO.util.isGlobalErrorOnPage()) {
	        var errorElement = COSTCO.util.getFirstGlobalErrorOnPage($('body'));
	        if (errorElement !== undefined && errorElement !== null && errorElement.text() !== "") {
	          var eMessage = errorElement.text();
	          COSTCO.util.announceSRErrorMessage(eMessage);
	        }
	      }
	    },
	
	    /**
	     * Function used to monitor screen reader announcement div element for changes
	     */
	    resetScreenReaderAnnouncement: function resetScreenReaderAnnouncement() {
	      var targetObject = document.querySelector("#screen-reader-announcement");
	      var observerObject = new MutationObserver(function (mutationRecordsList) {
	        mutationRecordsList.forEach(function (mutation) {
	          if ("attributes" === mutation.type || "childList" === mutation.type || "subtree" === mutation.type) {
	            setTimeout(function () {
	              $(targetObject).empty();
	            }, 2000);
	          }
	        });
	      });
	      if (targetObject !== undefined && targetObject !== null) {
	        observerObject.observe(targetObject, {
	          attributes: true,
	          attributeOldValue: true,
	          childList: true,
	          subtree: true,
	          characterData: true
	        });
	      }
	    },
	
	    /**
	     * Function used to inject error message in screen reader placeholder announcement div
	     * @param error message to be injected
	     */
	
	    announceSRErrorMessage: function announceSRErrorMessage(errorMessage) {
	      try {
	        errorMessage = errorMessage.trim();
	        var htmlContent = $.parseHTML(errorMessage);
	
	        if (htmlContent != null && !htmlContent.filter(function (e) {
	          return e instanceof HTMLElement;
	        }).length) {
	          errorMessage = '<p>' + errorMessage + '</p>';
	        }
	
	        var errorToAnnounce = $(errorMessage).html() !== undefined ? $(errorMessage).html() : errorMessage;
	        COSTCO.util.announceSRMessage(messages.ERROR + ' ' + errorToAnnounce);
	      } catch (error) {
	        console.log("Error occurred while announcing SR message! Error: " + error);
	      }
	    },
	
	    /**
	     * Moves the specified section to keep it in view when user scrolls.
	     * The section only moves if the screen is Tablet Landscape or wider.
	     * @param {string} elementId	ID of html element which is in view when user scrolls
	     * @param {string} topReferenceElementId	ID of element which is initially top-aligned with "sticky element"
	     * @param {string} bottomReferenceElementId ID of an element which presents a bottom limit to a moving "sticky element"
	     */
	    makeElementSticky: function makeElementSticky(elementId, topReferenceElementId, bottomReferenceElementId) {
	
	      var makeElementStickyFunction = function makeElementStickyFunction() {
	
	        var stickyElement = $('#' + elementId);
	        var topReferenceElement = $('#' + topReferenceElementId);
	        var bottomReferenceElement = $('#' + bottomReferenceElementId);
	
	        var bottomReference = bottomReferenceElement.offset().top;
	
	        if (stickyElement.length > 0 && topReferenceElement.length > 0) {
	          var topReference = topReferenceElement.offset().top + topReferenceElement.height();
	
	          var currentTranslateY = parseFloat(stickyElement.css('transform').split(',')[5]) || 0;
	          var translateY = -stickyElement[0].getBoundingClientRect().top + currentTranslateY;
	          var maxDistance = bottomReference - topReference - stickyElement.height();
	
	          if (translateY > maxDistance) {
	            translateY = maxDistance;
	          } else if (translateY < 0) {
	            translateY = 0;
	          }
	
	          stickyElement.css({
	            '-webkit-transform': 'translateY(' + translateY + 'px)',
	            '-moz-transform': 'translateY(' + translateY + 'px)',
	            '-ms-transform': 'translateY(' + translateY + 'px)',
	            '-o-transform': 'translateY(' + translateY + 'px)',
	            'transform': 'translateY(' + translateY + 'px)'
	          });
	        }
	      };
	      $(window).on('scroll wheel DOMMouseScroll mousewheel resize', function (evt) {
	        // remove all transforms if screen is not at least tablet landscape
	        if (COSTCO.util.isMaxScreen('TABLET-LANDSCAPE')) {
	          $('#' + elementId).css({
	            '-webkit-transform': '',
	            '-moz-transform': '',
	            '-ms-transform': '',
	            '-o-transform': '',
	            'transform': ''
	          });
	        } else {
	          makeElementStickyFunction();
	        }
	      });
	    },
	    preventBackButtonForSso: function preventBackButtonForSso(referer) {
	
	      try {
	        setTimeout(function () {
	          history.pushState(null, null, window.location);
	          window.addEventListener('popstate', function (event) {
	            if (referer != null && referer != undefined && referer != '' && (referer.indexOf('signin-qa.costco.com') > -1 || referer.indexOf('signin.costco.com') > -1)) {
	              alert(1);
	              history.pushState(null, null, window.location);
	            }
	          });
	        }, 5000);
	      } catch (e) {
	        console.error(e);
	      }
	    },
	    /**
	     * Method return date in yyyy-dd-mm-dd format
	     */
	    formatCalendarDate: function formatCalendarDate(date, separator) {
	      var d = new Date(date),
	          month = '' + (d.getMonth() + 1),
	          day = '' + d.getDate(),
	          year = d.getFullYear();
	
	      if (month.length < 2) month = '0' + month;
	      if (day.length < 2) day = '0' + day;
	      if (separator === '-') {
	        return [year, month, day].join('-');
	      } else {
	        return [month, day, year.toString().substr(-2)].join('/');
	      }
	    },
	    getAllCalendarAvailableDates: function getAllCalendarAvailableDates(dates) {
	      var availableDates = [];
	      dates.forEach(function (allowed_obj) {
	        if (allowed_obj.date_str) {
	          var date = new Date(allowed_obj.date_obj);
	          var timeZoneCorrectDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
	          // East of GMT
	          if (date.getTimezoneOffset() < 0) {
	            timeZoneCorrectDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
	          }
	          var formattedDate = timeZoneCorrectDate.toJSON().split("T")[0];
	          var availableFormatedDate = formattedDate.split('-')[1] + '/' + formattedDate.split('-')[2] + '/' + formattedDate.split('-')[0];
	          availableDates.push(availableFormatedDate);
	        }
	      });
	      return availableDates;
	    },
	
	    //Controls continue button on Membership Privileges and Conditions page
	    continueAfterTermsAccepted: function continueAfterTermsAccepted() {
	      if ($("#tnc-checkbox").attr("value") == "true") {
	        if ($('#upgradeOnly').val() == "true") {
	          window.location.href = '/QuickMembershipCheckoutCmd?isTandCAccepted=true&upgradeOnly=true';
	        } else {
	          window.location.href = '/QuickMembershipCheckoutCmd?isTandCAccepted=true';
	        }
	      } else {
	
	        $(".membership-tnc-checkbox-main").css({ 'border': '2px solid #D32029', 'margin': '0px' });
	        $("#terms-conditions-error").removeClass("hidden").css('margin-bottom', '20px');
	        $('#tnc-checkbox').focus();
	        $("#tnc-checkbox").attr("aria-describedby", "terms-conditions-error");
	      }
	    },
	
	    //Functionality for accept check box on Membership Privileges and Conditions page 
	    toggleTermsCheckbox: function toggleTermsCheckbox() {
	      if ($("#tnc-checkbox").attr("value") == "false") {
	        $("#tnc-checkbox").removeAttr("aria-describedby");
	        $("#tnc-checkbox").attr("value", "true");
	        $("#tnc-checkbox").attr("checked", "checked");
	        if (!$("#terms-conditions-error").hasClass("hidden")) {
	          $("#terms-conditions-error").addClass("hidden");
	          $(".membership-tnc-checkbox-main").css({ 'border': '1px solid #cccccc', 'margin': '5px 0px 20px 0px' });
	        }
	      } else {
	        $("#tnc-checkbox").attr("value", "false");
	        $("#tnc-checkbox").removeAttr("checked");
	      }
	    },
	
	    // function for sanitizing data to prevent XSS attacks
	    replaceSpecialChars: function replaceSpecialChars(obj) {
	      var result = new String(obj);
	
	      result = result.replace(/&/g, "&amp;");
	      result = result.replace(/</g, "&lt;");
	      result = result.replace(/>/g, "&gt;");
	      result = result.replace(/'/g, "&#39;");
	      result = result.replace(/"/g, "&quot;");
	      result = result.replace(/\//g, "&#47;");
	      result = result.replace(/\\/g, "&#92;");
	
	      return result;
	    },
	
	    scrubSpecialChars: function scrubSpecialChars(obj) {
	      var result = new String(obj);
	      result = result.replace(/[\%\$\`\\\*\<\>\(\)]*/g, '');
	      return result;
	    },
	
	    scrubSpecialCharsFromCompanyName: function scrubSpecialCharsFromCompanyName(obj) {
	      var result = new String(obj);
	      result = result.replace(/[\%\$\`\~\*\<\>]*/g, '');
	      return result;
	    }
	
	  };
	
	  return util;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title membership-helper.js: utility module
	 * @description Helper for membership specific modules
	 * @author kmedz
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12), __webpack_require__(13), __webpack_require__(14), __webpack_require__(17), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (membershipData, addressForm, address, addressVerification, accountHelper) {
	  var MembershipHelper = {
	    /**
	     * Initializes the module with the specific membership type, which is
	     * defined in MembershipApplication_PreloadData.jspf
	     * @return {void} [description]
	     */
	    init: function init() {
	      this.membershipType = membershipType;
	
	      if (typeof totalFee !== 'undefined') {
	        this.totalFee = totalFee;
	      }
	      if (typeof membershipFee !== 'undefined') {
	        this.membershipFee = membershipFee;
	      }
	
	      $('#postalcode').val('');
	      $('#businessZipCode').val('');
	    },
	    isQuickMembership: false,
	    /**
	     * When we create an affiliate form we need to populate things like
	     * the date of birth selectors, do the fancy bing zip thing, etc.
	     * @param {jQuery.Element} form - The form containing the inputs we want
	     *                              to modify
	     * @return {void}
	     */
	    formWizBangs: function formWizBangs(form) {
	      // 5.2 Populate the appropriate inputs. Do the fancy masking stuff.
	      // Date of birth inputs
	      this.dobPopulate('#' + form.attr('id'), 100);
	
	      /** Membership DOB month field numeric restriction and appending 0 before 1-9 value */
	      form.find('[name=month],[name=household_month],[name=householdDobMonth],[name=dobmonth],[name=MembershipCrmCallerInfo_dobEditMonth]').on({
	        'focusout': function focusout(event) {
	          MembershipHelper.prependZero(event);
	        }
	      });
	
	      /** Membership DOB day field numeric restriction and appending 0 before 1-9 value */
	      form.find('[name=day],[name=household_day],[name=householdDobDay],[name=dobday],[name=MembershipCrmCallerInfo_dobEditDay]').on({
	        'focusout': function focusout(event) {
	          MembershipHelper.prependZero(event);
	        }
	      });
	
	      /** Membership DOB year field numeric restriction */
	      form.find('[name=year],[name=household_year],[name=householdDobYear],[name=dobyear],[name=MembershipCrmCallerInfo_dobEditYear]').on({});
	
	      var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	      // Populate state select box if the DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED feature is not enabled.
	      if (form.find('.state-select').length) {
	        var stateProvList = this.getStateProvJson();
	        var stateOptions = this.getStateOptions(stateProvList);
	        var $selects = isDeriveCityStateEnabled ? form.find('.state-select') : form.find('.state-select').append(stateOptions);
	        $selects.each(function (i, select) {
	          // If the select has a readonly attribute, disable all options
	          // except the currently selected option.
	          if ($(select).attr('readonly')) {
	            // will return "readonly"
	            $(select).find('option').attr('disabled', 'disabled');
	          }
	        });
	      }
	      // Bing City State autocomplete
	      // Personal information
	      form.find('[name=postalcode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	
	        if (value != null && value != '' && value.trim().length > 4) {
	          var region = COSTCO.util.isUsOrCaZipCode();
	          if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	            this.bingCityState(event.currentTarget, '[name=city]', '[name=state]');
	          }
	          if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	            if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	              this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	            }
	            if (!region) {
	              if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	            }
	          }
	        }
	      }.bind(this));
	      // Employee Add On (Acocunt Details)
	      form.find('[name=employeeAddon_zip]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
	          }
	        }
	      }.bind(this));
	      // Business information
	      form.find('[name=businessZipCode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	          }
	        }
	      }.bind(this));
	      // Affiliate
	      form.find('[name=zip]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=city]', '[name=state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	          }
	        }
	      }.bind(this));
	      // Account Details - Membership Information
	      form.find('[name=MembershipCrmCallerInfo_zipCode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=MembershipCrmCallerInfo_city]', '[name=MembershipCrmCallerInfo_stateDropDown_state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmCallerInfo_city]', '[name=MembershipCrmCallerInfo_stateDropDown_state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmCallerInfo_city]', '[name=MembershipCrmCallerInfo_stateDropDown_state]');
	          }
	        }
	      }.bind(this));
	
	      //Business Details - Business Information
	      form.find('[name=MembershipCrmBusiness_zipCode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=MembershipCrmBusiness_city]', '[name=MembershipCrmBusiness_stateDropDown_state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmBusiness_city]', '[name=MembershipCrmBusiness_stateDropDown_state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmBusiness_city]', '[name=MembershipCrmBusiness_stateDropDown_state]');
	          }
	        }
	      }.bind(this));
	
	      // Mask inputs
	      this.maskInput(form);
	    },
	    /**
	     * Determine if we're working with a business membership.
	     * @return {Boolean} Is business membership?
	     */
	    isBusinessMembership: function isBusinessMembership() {
	      return this.membershipType === this.membershipTypes.ADDMEMBER_BUSINESS || this.membershipType === this.membershipTypes.ADDMEMBER_BUSINESS_EXECUTIVE;
	    },
	    /**
	     * Sets some static keys representing membership types.
	     * @type {Object}
	     */
	    membershipTypes: {
	      ADDMEMBER_BUSINESS: 'ADDMEMBER_BUSINESS',
	      ADDMEMBER_BUSINESS_EXECUTIVE: 'ADDMEMBER_BUSINESS_EXECUTIVE',
	      ADDMEMBER_GOLDSTAR: 'ADDMEMBER_GOLDSTAR',
	      ADDMEMBER_GOLDSTAR_EXECUTIVE: 'ADDMEMBER_GOLDSTAR_EXECUTIVE'
	    },
	    /**
	     * The selectors for address fields in personal information
	     * @type {Object}
	     */
	    personalAddressSelectors: {
	      label: '[name=primaryAddress]',
	      line1: '[name=address1]',
	      line2: '[name=address2]',
	      city: '[name=city]',
	      state: '[name=state]',
	      country: '[name=country]',
	      zip: '[name=postalcode]'
	    },
	    /**
	     * The selectors for address fields in business information.
	     * @type {Object}
	     */
	    businessAddressSelectors: {
	      label: '[name=businessAddress]',
	      line1: '[name=businessAddressLine1]',
	      line2: '[name=businessAddressLine2]',
	      city: '[name=businessCity]',
	      state: '[name=businessState]',
	      country: '[name=businessCountry]',
	      zip: '[name=businessZipCode]'
	    },
	    /**
	     * The selectors for address fields in the affiliate modal.
	     * @type {Object}
	     */
	    affiliateAddressSelectors: {
	      label: '[name=affiliateAddress]',
	      line1: '[name=line1]',
	      line2: '[name=line2]',
	      city: '[name=city]',
	      state: '[name=state]',
	      country: '[name=country]',
	      zip: '[name=zip]',
	      fName: '[name=fname]',
	      lName: '[name=lname]'
	    },
	    /**
	     * The selectors for address fields in the Account Details
	     * Membership Information - Primary Information.
	     * @type {Object}
	     */
	    primaryInformationSelectors: {
	      label: '.membership-address-container .title label',
	      line1: '[name=MembershipCrmCallerInfo_addressLine1]',
	      line2: '[name=MembershipCrmCallerInfo_addressLine2]',
	      city: '[name=MembershipCrmCallerInfo_city]',
	      state: '[name=MembershipCrmCallerInfo_stateDropDown_state]',
	      country: '[name=MembershipCrmCallerInfo_stateDropDown_country]',
	      zip: '[name=MembershipCrmCallerInfo_zipCode]',
	      month: '[name=MembershipCrmCallerInfo_dobEditMonth]',
	      day: '[name=MembershipCrmCallerInfo_dobEditDay]',
	      year: '[name=MembershipCrmCallerInfo_dobEditYear]'
	    },
	    /**
	     * The selectors for address fields in the Business Details
	     * Membership Information - Primary Information.
	     * @type {Object}
	     */
	    businessInformationSelectors: {
	      label: '.business-address-container .title label',
	      line1: '[name=MembershipCrmBusiness_addressLine1]',
	      line2: '[name=MembershipCrmBusiness_addressLine2]',
	      city: '[name=MembershipCrmBusiness_city]',
	      state: '[name=MembershipCrmBusiness_stateDropDown_state]',
	      country: '[name=MembershipCrmBusiness_stateDropDown_country]',
	      zip: '[name=MembershipCrmBusiness_zipCode]'
	    },
	    /**
	     * The selectors for address fields in the employee add on section for when
	     * the user is a Employee Primary.
	     * @type {Object}
	     */
	    employeeAddOnSelectors: {
	      label: '.employee-addon > .title span',
	      line1: '[name=employeeAddon_addressLine1]',
	      line2: '[name=employeeAddon_addressLine2]',
	      city: '[name=employeeAddon_city]',
	      state: '[name=employeeAddon_state]',
	      country: '[name=employeeAddon_country]',
	      zip: '[name=employeeAddon_zip]',
	      fName: '[name=employeeAddon_first_name]',
	      lName: '[name=employeeAddon_last_name]'
	    },
	
	    /**
	     * Business specific rules object. Used for clientside validation
	     * @type {Object}
	     */
	    business: {
	      rules: {
	        first_name: { required: true, firstNameValidation: true },
	        lastName: { required: true, lastNameValidation: true },
	        month: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        day: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        year: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        address1: {
	          required: true,
	          valid_address: true,
	          maxlength: 60
	        },
	        address2: {
	          valid_address: true,
	          maxlength: 40
	        },
	        city: {
	          required: true,
	          valid_cityState: true
	        },
	        state: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        postalcode: {
	          required: true,
	          minlength: 5
	        },
	        email: {
	          required: true,
	          singleemail: true,
	          email: false
	        },
	        emailConfirm: {
	          required: true,
	          singleemail: true,
	          equalTo: '#email',
	          email: false
	        },
	        // country : 'required',
	        contactPhoneNumber: {
	          required: true,
	          phone: true
	        },
	        mobilePhoneNumber: {
	          required: false,
	          phone: true,
	          promo: true
	        },
	        // awarenessCode: {required: false, validCode : true},
	        shippingNickname: {
	          copyAddress: true
	        },
	        billingNickname: {
	          copyAddress: true
	        },
	        businessNameEdit: 'required',
	        businessAddressLine1: {
	          required: true,
	          valid_address: true,
	          maxlength: 30
	        },
	        businessAddressLine2: {
	          valid_address: true,
	          maxlength: 30
	        },
	        businessCity: {
	          required: true,
	          valid_cityState: true
	        },
	        businessState: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        // businessCountry : 'required',
	        businessZipCode: {
	          required: true,
	          minlength: 5
	        },
	        businessPhone: {
	          required: true,
	          phone: true
	        },
	        businessEmail: {
	          required: true,
	          singleemail: true,
	          email: false
	        },
	        businessEmailConfirm: {
	          required: true,
	          singleemail: true,
	          email: false,
	          equalTo: '#businessEmail'
	        }
	      },
	
	      messages: function (_messages) {
	        function messages() {
	          return _messages.apply(this, arguments);
	        }
	
	        messages.toString = function () {
	          return _messages.toString();
	        };
	
	        return messages;
	      }(function () {
	        return {
	          month: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          year: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          businessNameEdit: messages.ERR_INVALID_BUSINESS_NAME,
	          businessAddressLine1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          businessAddressLine2: {
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          businessCity: { required: messages.ERR_INVALID_CITY_REQUIRED, valid_cityState: messages.ERR_INVALID_CITY_NAME },
	          businessState: { required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED, valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED },
	          // businessCountry : messages.ERR_INVALID_COUNTRY,
	          businessZipCode: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          businessPhone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          businessEmail: messages.ERR_INVALID_EMAIL_ADDRESS,
	          businessEmailConfirm: {
	            required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
	            equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH
	          },
	          first_name: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          lastName: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          address1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE
	          },
	          address2: {
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          city: { required: messages.ERR_INVALID_CITY_REQUIRED, valid_cityState: messages.ERR_INVALID_CITY_NAME },
	          state: { required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED, valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED },
	          postalcode: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          email: messages.ERR_INVALID_EMAIL_ADDRESS,
	          emailConfirm: {
	            required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
	            equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH
	          },
	          // country : messages.ERR_INVALID_COUNTRY,
	          contactPhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          mobilePhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // awarenessCode : messages.ERR_AWARENESS_CODE,
	          shippingNickname: messages.ERR_ENTER_UNIQUE_NICKNAME,
	          billingNickname: messages.ERR_INVALID_SHIPPINGNICKNAME
	        };
	      })
	    },
	    /**
	     * Goldstar specific rules object. Used for clientside validation
	     * @type {Object}
	     */
	    goldstar: {
	      rules: {
	        // primary
	        first_name: { required: true, firstNameValidation: true },
	        // alternate name for affiliate
	        fname: { required: true, firstNameValidation: true },
	        // alternate name for employee addon
	        employeeAddon_first_name: { required: true, firstNameValidation: true },
	        lastName: { required: true, lastNameValidation: true },
	        // alternate name for affiliate
	        lname: { required: true, lastNameValidation: true },
	        // alternamte name for employee addon
	        employeeAddon_last_name: { required: true, lastNameValidation: true },
	        month: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        MembershipCrmCallerInfo_dobEditMonth: {
	          required: false,
	          dob: true
	        },
	        MembershipCrmCallerInfo_dobEditDay: {
	          required: false,
	          dob: true
	        },
	        MembershipCrmCallerInfo_dobEditYear: {
	          required: false,
	          dob: true
	        },
	
	        // alternate name for affiliate
	        dobmonth: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        day: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        // alternate name for affiliate
	        dobday: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        year: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        // alternate name for affiliate
	        dobyear: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        address1: {
	          required: true,
	          valid_address: true,
	          maxlength: 60
	        },
	        address2: {
	          maxlength: 40,
	          valid_address: true
	        },
	        // alternate names for employee addon
	        employeeAddon_addressLine1: {
	          required: true,
	          valid_address: true
	        },
	        employeeAddon_addressLine2: {
	          valid_address: true
	        },
	        employeeAddon_city: {
	          required: true,
	          valid_cityState: true
	        },
	        employeeAddon_state: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        employeeAddon_zip: {
	          required: true,
	          minlength: 5
	        },
	        // alternate name for affiliate
	        line1: {
	          required: true,
	          valid_address: true
	        },
	        line2: {
	          valid_address: true
	        },
	        city: {
	          required: true,
	          valid_cityState: true
	        },
	        state: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        postalcode: {
	          required: true,
	          minlength: 5
	        },
	        // alternate name for affiliate
	        zip: {
	          required: true,
	          minlength: 5
	        },
	        email: {
	          required: true,
	          singleemail: true,
	          email: false,
	          emailEmpty: true
	        },
	        emailConfirm: {
	          required: true,
	          singleemail: true,
	          equalTo: '#email',
	          email: false,
	          emailEmpty: true
	        },
	        // alternate name for employee add on
	        employeeAddon_email: {
	          required: false,
	          singleemail: true
	        },
	        employeeAddOn_email_confirm: {
	          required: false,
	          singleemail: true,
	          equalTo: '#employeeAddon_email'
	        },
	        // country : 'required',
	        contactPhoneNumber: {
	          required: true,
	          phone: true
	        },
	        // alternate name for affiliate
	        cphone: {
	          required: false,
	          phone: true
	        },
	        mobilePhoneNumber: {
	          required: false,
	          phone: true,
	          promo: true
	        },
	        // alternate name for affiliate
	        mphone: {
	          required: false,
	          phone: true,
	          promo: true
	        },
	        // alternate name for employee add on
	        employeeAddon_contact_phone: {
	          required: true,
	          phone: true
	        },
	        employeeAddon_mobile: {
	          required: false,
	          phone: true,
	          promo: true
	        }
	      },
	      messages: function (_messages2) {
	        function messages() {
	          return _messages2.apply(this, arguments);
	        }
	
	        messages.toString = function () {
	          return _messages2.toString();
	        };
	
	        return messages;
	      }(function () {
	        return {
	          first_name: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          month: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          year: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          dobmonth: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          householdDobYear: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          householdDobMonth: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          dobyear: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          // alternate for affiliate
	          fname: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          // For Account Details
	          householdFname: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          // For Employee Add On
	          employeeAddon_first_name: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          lastName: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          // alternate for affiliate
	          lname: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          // For Account Details
	          householdLname: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          // For Employee Add On
	          employeeAddon_last_name: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          address1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE
	          },
	          address2: {
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          // alternate for employee add on
	          employeeAddon_addressLine1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          employeeAddon_addressLine2: {
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          employeeAddon_city: {
	            required: messages.ERR_INVALID_CITY_REQUIRED,
	            valid_cityState: messages.ERR_INVALID_CITY_NAME
	          },
	          employeeAddon_state: {
	            required: messages.ERR_INVALID_STATE_NAME,
	            valid_cityState: messages.ERR_INVALID_STATE_NAME
	          },
	          employeeAddon_zip: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          // alternate for affiliate
	          line1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          line2: {
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          city: {
	            required: messages.ERR_INVALID_CITY_REQUIRED,
	            valid_cityState: messages.ERR_INVALID_CITY_NAME
	          },
	          state: {
	            required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED,
	            valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED
	          },
	          postalcode: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          // alternate for affiliate
	          zip: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          email: messages.ERR_INVALID_EMAIL,
	          emailConfirm: {
	            required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
	            equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH
	          },
	          equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH,
	          // alternate for employee add on
	          employeeAddon_email: messages.ERR_INVALID_EMAIL,
	          // country : messages.ERR_INVALID_COUNTRY,
	          contactPhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // alternate for affiliate
	          cphone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          mobilePhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // alternate for affiliate
	          mphone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // alternate for employee add on
	          employeeAddon_contact_phone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          employeeAddon_mobile: messages.ERR_INVALID_PHONE_10_DIGIT
	        };
	      })
	    },
	    /**
	     * Extend a 'business' or 'goldstar' rules object with household
	     * rules.
	     * @param  {Object} rules The rules object to extend
	     * @param  {boolean} required OPTIONAL make something required
	     * @return {void}
	     */
	    addHouseholdRules: function addHouseholdRules(rules, required, validator_messages) {
	      required = required || false;
	      $.extend(rules, {
	        household_first_name: {
	          required: false,
	          firstNameValidation: true,
	          household_gold: true
	        },
	        // Affiliate alternate
	        householdFname: {
	          required: required || false,
	          firstNameValidation: true,
	          household_gold: required === true ? false : true
	        },
	        household_lastName: {
	          required: false,
	          lastNameValidation: true,
	          household_gold: true
	        },
	        // Affiliate alternate
	        householdLname: {
	          required: required || false,
	          lastNameValidation: true,
	          household_gold: required === true ? false : true
	        },
	        household_month: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        // Affiliate alternate
	        householdDobMonth: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        household_day: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        // Affiliate alternate
	        householdDobDay: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        household_year: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        // Affiliate alternate
	        householdDobYear: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        household_email: {
	          required: false,
	          singleemail: true,
	          household_gold: false,
	          email: false,
	          emailEmpty: true
	        },
	        household_emailConfirm: {
	          required: false,
	          singleemail: true,
	          equalTo: '#household_email',
	          email: false,
	          emailEmpty: true
	        },
	        // Affiliate alternate
	        householdEmail: {
	          required: false,
	          singleemail: true,
	          household_gold: false,
	          email: false,
	          emailEmpty: true
	        },
	        // Affiliate alternate
	        householdEmailConfirm: {
	          required: false,
	          singleemail: true,
	          equalTo: '#household_email_affiliate',
	          email: false,
	          emailEmpty: true
	        },
	        // Alternate for Account Details
	        householdEmailConfirmdetails: {
	          required: false,
	          singleemail: true,
	          equalTo: '#email-details',
	          email: false,
	          emailEmpty: true
	        },
	        household_primaryPhoneNumber: {
	          required: false,
	          phone: true,
	          household_gold: false
	        },
	        // Affiliate alternate
	        householdPrimaryPhoneNumber: {
	          required: false,
	          phone: true,
	          household_gold: false
	        }
	      });
	      $.extend(validator_messages, {
	        household_month: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	        household_year: { required: messages.ERR_INVALID_YEAR_REQUIRED }
	      });
	    },
	    /**
	     * Validation methods for membership specific forms.
	     * @param  {jQuery} form The form we're validating
	     * @return {void}
	     */
	    addValidationMethods: function addValidationMethods(form) {
	      var memberValidationRegex = new RegExp($('#memberValidationRegex').val());
	      var addressValidationRegex = new RegExp($('#addressValidationRegex').val());
	      var cityStateValidationRegex = new RegExp($('#cityStateValidationRegex').val());
	      $.validator.addMethod('notEqual', function (value, element, param) {
	        return this.optional(element) || value != param;
	      }, messages.ERR_INVALID_STATE_NAME);
	      $.validator.addMethod("hasvalidationerror", function (value, element) {
	        return element.getAttribute('hasvalidationerror') == undefined || element.getAttribute('hasvalidationerror') == null || element.getAttribute('hasvalidationerror') == "false";
	      }, messages.ERR_INVALID_STATE);
	      // custom validate mobile phone number when promo notification via text message is selected.
	      $.validator.addMethod('promo', function (value, element, param) {
	        var valid = true;
	        var phone = $.trim(form.find('input[name=mobilePhoneNumber]').val());
	        var promo = $('input[name=receivePromosAndMarketingTxtMsg]').val();
	        if (promo == 'on' && phone.length == 0) {
	          valid = false;
	        }
	        return valid;
	      }, '');
	      // custom validation for date of birth
	      $.validator.addMethod('dob', function (value, element, param) {
	        var valid = true;
	        var month = void 0;
	        var day = void 0;
	        var year = void 0;
	        var monthVal = void 0;
	        var dayVal = void 0;
	        var yearVal = void 0;
	        var errField = void 0;
	        var message = void 0;
	        var dateCondition = false;
	        var idate = void 0;
	        var isFuture = false;
	        var isFutureDate = function isFutureDate(idate) {
	          var today = new Date().getTime();
	          idate = idate.split('/');
	          idate = new Date(idate[2], idate[0] - 1, idate[1]).getTime();
	          return today - idate < 0 ? true : false;
	        };
	        if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
	          month = form.find('[name=month]');
	          day = form.find('[name=day]');
	          year = form.find('[name=year]');
	          errField = '#dob_error';
	        } else if (element.name == 'MembershipCrmCallerInfo_dobEditMonth' || element.name == 'MembershipCrmCallerInfo_dobEditDay' || element.name == 'MembershipCrmCallerInfo_dobEditYear') {
	          month = form.find('[name=MembershipCrmCallerInfo_dobEditMonth]');
	          day = form.find('[name=MembershipCrmCallerInfo_dobEditDay]');
	          year = form.find('[name=MembershipCrmCallerInfo_dobEditYear]');
	          errField = '#MembershipCrmCallerInfo-dob-error';
	        } else if (element.name == 'household_month' || element.name == 'household_day' || element.name == 'household_year') {
	          month = form.find('[name=household_month]');
	          day = form.find('[name=household_day]');
	          year = form.find('[name=household_year]');
	          errField = '#household_dob_error';
	        } else if (element.name == 'dobmonth' || element.name == 'dobday' || element.name == 'dobyear') {
	          month = form.find('[name=dobmonth]');
	          day = form.find('[name=dobday]');
	          year = form.find('[name=dobyear]');
	          errField = '#dob_error_affiliate';
	        } else if (element.name == 'householdDobMonth' || element.name == 'householdDobDay' || element.name == 'householdDobYear') {
	          month = form.find('[name=householdDobMonth]');
	          day = form.find('[name=householdDobDay]');
	          year = form.find('[name=householdDobYear]');
	          errField = element.form.id == 'household-form-details' ? '#household_dob_error_details' : '#household_dob_error_affiliate';
	        }
	
	        var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	        var isDayElement = element.name === 'day' || element.name == 'household_day' || element.name == 'dobday' || element.name == 'householdDobDay';
	
	        monthVal = month.val();
	        dayVal = day.val();
	        if (dayIsOptional && dayVal == "") {
	          dayVal = "1";
	        }
	        yearVal = year.val();
	
	        if (!dayIsOptional) {
	          if (wcs.storeId == '10301') {
	            dateCondition = monthVal == 'Month' && dayVal == 'Day' && yearVal == 'Year' || monthVal != 'Month' && dayVal != 'Day' && yearVal != 'Year';
	            if (monthVal.length > 0 || dayVal.length > 0 || yearVal.length > 0) {
	              if (monthVal.length == 0 || dayVal.length == 0 || yearVal.length == 0) {
	                dateCondition = false;
	              }
	            }
	          } else if (wcs.storeId == '10302') {
	            dayVal = 1;
	            dateCondition = monthVal == 'Month' && yearVal == 'Year' || monthVal != 'Month' && yearVal != 'Year';
	            if (monthVal.length > 0 || yearVal.length > 0) {
	              if (monthVal.length == 0 || yearVal.length == 0) {
	                dateCondition = false;
	              }
	            }
	          }
	        } else {
	          dateCondition = true;
	        }
	        if (monthVal != 'Month' && dayVal != 'Day' && yearVal != 'Year') {
	          idate = monthVal + '/' + dayVal + '/' + yearVal;
	          if (isFutureDate(idate)) isFuture = true;
	        }
	        if (dateCondition && !isFuture && COSTCO.util.dateValidation(monthVal, dayVal, yearVal)) {
	          $(errField).hide();
	          month.removeClass('error');
	          day.removeClass('error');
	          year.removeClass('error');
	          valid = true;
	        } else {
	          if (dayIsOptional && day.val() === "" && month.val() === "" && year.val() === "" && isDayElement) {
	            valid = true;
	          } else {
	            month.addClass('error');
	            if (!dayIsOptional) {
	              day.addClass('error');
	            } else {
	              if (day.val() !== "") {
	                day.addClass('error');
	              }
	            }
	            year.addClass('error');
	            $(errField).show();
	            $(errField)[0].innerHTML = messages.ERR_ENTER_DOB;
	            valid = false;
	          }
	        }
	        return valid;
	      }, '');
	      // custom validation for checking if the member is over 18
	      $.validator.addMethod('isMinor', function (value, element, param) {
	        var errorField = void 0;
	        var year = void 0;
	        var month = void 0;
	        var day = void 0;
	        var now = new Date();
	        var graymsg = false;
	        var houseHoldForm = false;
	        var employeeAddOn = false;
	
	        if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
	          month = form.find('[name=month]');
	          day = form.find('[name=day]');
	          year = form.find('[name=year]');
	          errorField = '.member-dob-disclaimer';
	          graymsg = true;
	        } else if (element.name == 'household_month' || element.name == 'household_day' || element.name == 'household_year') {
	          month = form.find('[name=household_month]');
	          day = form.find('[name=household_day]');
	          year = form.find('[name=household_year]');
	          errorField = '#is_minor_household';
	          houseHoldForm = true;
	        } else if (element.name == 'householdDobMonth' || element.name == 'householdDobDay' || element.name == 'householdDobYear') {
	          month = form.find('[name=householdDobMonth]');
	          day = form.find('[name=householdDobDay]');
	          year = form.find('[name=householdDobYear]');
	          errorField = element.form.id == 'household-form-details' ? '#is_minor_household' : '.household-dob-disclaimer';
	          graymsg = element.form.id == 'household-form-details' ? false : true;
	          houseHoldForm = true;
	        } else if (element.name == 'dobmonth' || element.name == 'dobday' || element.name == 'dobyear') {
	          month = form.find('[name=dobmonth]');
	          day = form.find('[name=dobday]');
	          year = form.find('[name=dobyear]');
	          errorField = '.member-dob-disclaimer';
	          graymsg = true;
	        }
	
	        var ageYears = now.getFullYear() - year.val();
	        var ageMonths = now.getMonth() - month.val();
	        var ageDays = now.getDate() - day.val();
	        var isValidAge = true;
	        var primaryMinAge = $('#membership_primary_min_age').val();
	        var addOnMinAge = $('#employee-addOn').val();
	
	        var isAgeAllowed = function isAgeAllowed(minAge) {
	          var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	          var d = day.val();
	          if (dayIsOptional && d == "") {
	            d = "1";
	          }
	          var idate = new Date(year.val(), month.val() - 1, d);
	          var today = new Date();
	          var birthDate = new Date(idate);
	          var age = today.getFullYear() - birthDate.getFullYear();
	          var m = today.getMonth() - birthDate.getMonth();
	          if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
	            age--;
	          }
	          return age >= minAge ? true : false;
	        };
	
	        //household member age dropped from 18 to 16
	        if (!month.val() == "" && !year.val() == "") {
	          if (houseHoldForm) {
	            if (!isAgeAllowed(16)) {
	              isValidAge = false;
	            }
	          } else if (addOnMinAge) {
	            if (!isAgeAllowed(addOnMinAge)) {
	              isValidAge = false;
	            }
	          } else {
	            if (!isAgeAllowed(primaryMinAge)) {
	              isValidAge = false;
	            }
	          }
	        }
	
	        if (!isValidAge) {
	          month.addClass('error');
	          day.addClass('error');
	          year.addClass('error');
	          if (graymsg) {
	            $(errorField).css('color', '#d32029');
	          } else {
	            $(errorField).show();
	            if (houseHoldForm) {
	              $(errorField).innerHTML = messages.ERR_HOUSE_DOB_MINOR;
	            } else {
	              $(errorField).innerHTML = messages.ERR_DOB_MINOR.replace('{0}', primaryMinAge);
	            }
	          }
	          return false;
	        } else {
	          if (graymsg) {
	            $(errorField).css('color', '#707070');
	          } else {
	            month.removeClass('error');
	            day.removeClass('error');
	            year.removeClass('error');
	            $(errorField).hide();
	          }
	          return true;
	        }
	      }, '');
	      $.validator.addMethod('valid_address', function (value, element) {
	        return value !== null && value !== '' ? addressValidationRegex.test(value.trim()) : true;
	      }, '');
	      $.validator.addMethod('valid_cityState', function (value, element) {
	        return value !== null && value !== '' ? cityStateValidationRegex.test(value.trim()) : true;
	      }, '');
	      // custom validation for household_goldstar
	      $.validator.addMethod('household_gold', function (value, element, param) {
	        var fName = void 0;
	        var lName = void 0;
	        var email = void 0;
	        var emailConf = void 0;
	        var phone = void 0;
	        var errorFirst = void 0;
	        var errorLast = void 0;
	        var valid = true;
	        if (element.name == 'household_first_name' || element.name == 'household_lastName' || element.name == 'household_email' || element.name == 'household_primaryPhoneNumber' || element.name == 'household_emailConfirm') {
	          fName = form.find('input[name=household_first_name]').val();
	          lName = form.find('input[name=household_lastName]').val();
	          email = form.find('input[name=household_email]').val();
	          emailConf = form.find('input[name=household_emailConfirm]').val();
	          phone = form.find('input[name=household_primaryPhoneNumber]').val();
	          errorFirst = '#household_first_name_error';
	          errorLast = '#household_last_name_error';
	        } else if (element.name == 'householdFname' || element.name == 'householdLname' || element.name == 'householdEmail' || element.name == 'householdPrimaryPhoneNumber' || element.name == 'householdEmailConfirm') {
	          fName = form.find('input[name=householdFname]').val();
	          lName = form.find('input[name=householdLname]').val();
	          email = form.find('input[name=householdEmail]').val();
	          emailConf = form.find('input[name=householdEmailConfirm]').val();
	          phone = form.find('input[name=householdPrimaryPhoneNumber]').val();
	          errorFirst = '#household_first_name_error_affiliate';
	          errorLast = '#household_last_name_error_affiliate';
	        }
	        $(errorFirst).hide();
	        $(errorLast).hide();
	        if (fName.length == 0 && lName.length == 0 && email.length == 0 && emailConf.length == 0 && phone.length == 0) {
	          $(errorFirst).hide();
	          $(errorLast).hide();
	          valid = true;
	        } else if (fName.length == 0 && lName.length == 0 && (email.length > 0 || phone.length > 0 || emailConf.length > 0)) {
	          $(errorFirst).innerHTML = messages.ERR_INVALID_FNAME_REQUIRED;
	          $(errorLast).innerHTML = messages.ERR_INVALID_LNAME_REQUIRED;
	          $(errorFirst).show();
	          $(errorLast).show();
	          valid = false;
	        } else if (!(fName.length > 0 && lName.length > 0)) {
	          if (fName.length > 0 && lName.length == 0) {
	            $(errorFirst).hide();
	            $(errorLast).innerHTML = messages.ERR_INVALID_LNAME_REQUIRED;
	            $(errorLast).show();
	            if (element.name == 'household_first_name' || element.name == 'householdFname') {
	              valid = true;
	            } else if (element.name == 'household_lastName' || element.name == 'householdLname') {
	              valid = false;
	            }
	          } else if (fName.length == 0 && lName.length > 0) {
	            $(errorLast).hide();
	            $(errorFirst).innerHTML = messages.ERR_INVALID_FNAME_REQUIRED;
	            $(errorFirst).show();
	            if (element.name == 'household_first_name' || element.name == 'householdFname') {
	              valid = false;
	            } else if (element.name == 'household_lastName' || element.name == 'householdLname') {
	              valid = true;
	            }
	          }
	        }
	        return valid;
	      }, '');
	      $.validator.addMethod('copyAddress', function (value, element, param) {
	        var valid = true;
	        var checked = $('input[name=copyMembershipAddressToShippingBilling]').attr('checked');
	        if (checked == 'checked' && ($(element).val() == '' || $('input[name=shippingNickname]').val() == $('input[name=billingNickname]').val())) {
	          valid = false;
	        }
	        return valid;
	      }, '');
	      $.validator.addMethod('phone', function (value, element) {
	        if (value.startsWith("0") || value.startsWith("1")) {
	          return false;
	        }
	        // costco phone numbers are 10 digits with optional .-() and space
	        else return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
	      }, messages.ERR_INVALID_PHONE_10_DIGIT);
	      // custom validation rule for single email
	      $.validator.addMethod('singleemail', function (value, element) {
	        var flag = true;
	        flag = flag && /^\s*((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?\s*$/.test(value.toLowerCase());
	        return this.optional(element) || flag;
	      }, messages.ERR_INVALID_EMAIL_ADDRESS);
	      $.validator.addMethod('equalTo', function (value, element, param) {
	        var flag = true;
	        flag = flag && value === $(param).val();
	        return this.optional(element) || flag;
	      }, messages.ERR_CONFIRM_EMAIL_MISMATCH);
	      $.validator.addMethod('emailEmpty', function (value, element) {
	        var email = void 0;
	        if (element.name == 'household_emailConfirm') {
	          email = form.find('input[name=household_email]').val();
	        } else if (element.name == 'householdEmailConfirm' || element.name == 'householdEmailConfirmdetails') {
	          email = form.find('input[name=householdEmail]').val();
	        } else if (element.name == 'household_email') {
	          email = form.find('input[name=household_emailConfirm]').val();
	        } else if (element.name == 'householdEmail') {
	          if (form.find('input[name=householdEmailConfirm]').length) {
	            email = form.find('input[name=householdEmailConfirm]').val();
	          } else {
	            email = form.find('input[name=householdEmailConfirmdetails]').val();
	          }
	        } else if (element.name == 'emailConfirm') {
	          if ($(element).attr('id') == 'affiliate-emailConfirm') {
	            email = form.find('input[name=email]').val();
	          } else {
	            return true;
	          }
	        } else if (element.name == 'email') {
	          if ($(element).attr('id') == 'affiliate-email') {
	            email = form.find('input[name=emailConfirm]').val();
	          } else {
	            return true;
	          }
	        }
	        var isOtherFieldEmpty = email == null || email == '';
	        if (!isOtherFieldEmpty && (value == null || value == '')) {
	          return false;
	        } else return true;
	      }, messages.ERR_INVALID_EMAIL_ADDRESS);
	      /** STRY0157080 Require at least ONE alphabet in each of the name fields */
	      $.validator.addMethod("firstNameValidation", function (value, element) {
	        return value !== null && value !== '' ? COSTCO.util.ATLEAST_ONE_ALPHABET.test(value) && memberValidationRegex.test(value.trim()) : true;
	      }, messages.ERR_INVALID_FNAME);
	      $.validator.addMethod("lastNameValidation", function (value, element) {
	        return value !== null && value !== '' ? COSTCO.util.ATLEAST_ONE_ALPHABET.test(value) && memberValidationRegex.test(value.trim()) : true;
	      }, messages.ERR_INVALID_LNAME);
	    },
	    /**
	     * If 'configProduct' exists with the appropriate properties,
	     * prepopulate the inputs. This function uses the data-configproduct
	     * attribute on inputs in the MembershipApplicationTemplates.jsp.
	     * @param {Object} data The data returned from a call to the server
	     *                      for application meta data.
	     * @return {Object} The data passed to the function
	     */
	    prepopulateForm: function prepopulateForm(data) {
	      var configProduct = data.configProduct || this.getConfigProduct();
	      if (configProduct) {
	        var locale = COSTCO.util.getLocale();
	        // Do the populating
	        Object.keys(configProduct).forEach(function (key) {
	          // These keys have to handled specialy because of our Canadian friends.
	          if (key == 'thirdPartyInformationSharing' || key == 'costcoMail' || key == 'costcoEmail') {
	            if (locale == 'en-US' || locale != 'en-US' && key == 'costcoMail') {
	              // The old logic in NewMembershipApplicationHelper.js says
	              // only prepopulate the costcoMail preference if we're in Canada
	              configProduct[key].toLowerCase() == 'yes' ? $('[data-configproduct=' + key + ']').prop('checked', true) : $('[data-configproduct=' + key + ']').prop('checked', false);
	            }
	          } else {
	            $('[data-configproduct=' + key + ']').val(configProduct[key]);
	          }
	        });
	        if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	          COSTCO.MembershipHelper.populateCityStateForDefaultZip(configProduct);
	        }
	      }
	      return data;
	    },
	    /**
	     * Uses the default address zip code obtained from the 'configProduct' (from
	     * the data returned from a call to the server), in order to make a geocodeAPI 
	     * call and populate the city and state fields with the values from the service 
	     * response for the user to choose from (if editing the address)
	     */
	    populateCityStateForDefaultZip: function populateCityStateForDefaultZip(configProduct) {
	
	      if ($('#postalcode')) {
	        var defaultAddrCity = configProduct.city;
	        var defaultAddrState = configProduct.state;
	        var defaultAddrZip = configProduct.zip || configProduct.zipCode;
	        if (defaultAddrZip && defaultAddrCity && defaultAddrState && $('#postalcode').val()) {
	          COSTCO.CAddress.geocodeApiCityState($('#postalcode'), '[name=city]', '[name=state]', defaultAddrCity, defaultAddrState);
	        }
	      }
	
	      if ($('#businessZipCode')) {
	        var defaultCompAddrCity = configProduct.companyCity;
	        var defaultCompAddrState = configProduct.companyState;
	        var defaultCompAddrZip = configProduct.companyZip || configProduct.companyZipCode;
	        if (defaultCompAddrZip && defaultCompAddrCity && defaultCompAddrState && $('#businessZipCode').val()) {
	          COSTCO.CAddress.geocodeApiCityState($('#businessZipCode'), '[name=businessCity]', '[name=businessState]', defaultCompAddrCity, defaultCompAddrState);
	        }
	      }
	    },
	
	    /**
	     * Populates a given element with keys from the obj who's property
	     * names match data-configProduct assigned on inputs of the element.
	     * @param  {jQuery} element The element we want to populate.
	     * @param  {Object} obj  The object who's keys want want to iterate
	     *                       through
	     * @return {jQuery}      Returns the processed element to manipulate further.
	     */
	    populateElement: function populateElement(element, obj) {
	      Object.keys(obj).forEach(function (key) {
	        $(element).find('[data-configproduct=' + key + ']').val(obj[key]);
	      });
	      if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	        COSTCO.MembershipHelper.populateCityStateForDefaultZip(obj);
	      }
	
	      return element;
	    },
	
	    /**
	     * Populate a form using a serilized array ($.fn.serializeArray).
	     * serilizeArray returns an array of objects where each object represents
	     * an input/select/... element who's "name" attribute matches the "name"
	     * property
	     * @param  {jQuery.Object}  form  The form to populate
	     * @param  {Array}          arr   The array of objects to use to populate
	     * @return {void}
	     */
	    populateByName: function populateByName(form, arr) {
	      arr.forEach(function (obj) {
	        $(form).find('[name=' + obj.name + ']').val(obj.value);
	      });
	    },
	
	    /**
	     * Uses the provided affiliate object to build a serialized array of
	     * objects using the form fields from the affiliate template.
	     * @param  {Object} affiliate The object which is the source
	     * @return {Array}            The array of objects
	     */
	    getSerializedAffiliateData: function getSerializedAffiliateData(affiliate) {
	      var $form = $(COSTCO.util.tmpl('tmpl_affiliate', {
	        affiliateHousehold: COSTCO.util.tmpl('tmpl_household_info_affiliate', {})
	      }));
	      // We need to populate the options for dob
	      this.dobPopulate($form, 100);
	      if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	        // We need to populate the form's state drop down
	        if ($form.find('.state-select').length) {
	          var stateProvList = this.getStateProvJson();
	          var stateOptions = this.getStateOptions(stateProvList);
	          $form.find('.state-select').append(stateOptions);
	        }
	      }
	      // Prepopulate the form with existing affiliate data
	      $form = this.populateElement($form, affiliate);
	      // If theres a household attached to affiliate, populate it
	      if (affiliate.houseHold) {
	        $form.find('#affiliate-household').prop('checked', true);
	        $form.find('#affiliate-household').val(true);
	        this.populateElement($form.find('#affiliate-household-container'), affiliate.houseHold);
	      } else {
	        $form.find('#affiliate-household').prop('checked', false);
	        $form.find('#affiliate-household').val(false);
	      }
	      return $form.serializeArray();
	    },
	
	    /**
	     * TRAIL: Refactor - this is not the best way how this function should be
	     * implemented
	     * Populate date of birth selects: month, day, year
	     * Structure of html
	     * <div class="dobPopulate">
	     * <select class="month"/>
	     * <select class="day"/>
	     * <select class="year"/>
	     * </div>
	     * Using this JS - dobPopulate("100") Populates the difference of 100 from
	     * the current year (20XX - 100)
	     * @param  {[type]} template      [description]
	     * @param  {[type]} appConfigYear [description]
	     * @return {void}               [description]
	     */
	    dobPopulate: function dobPopulate(template, appConfigYear) {
	      var elements = $(template).find('.dobPopulate');
	      elements.each(function (index, el) {
	        var currentYear = new Date().getFullYear();
	        var beginningYear = currentYear - parseInt(appConfigYear);
	        var $monthSelect = $(el).find('.month');
	        var $daySelect = $(el).find('.day');
	        var $yearSelect = $(el).find('.year');
	        // Populate year select
	        var _yearSelect = $('<select>');
	        for (var i = currentYear; i >= beginningYear; i--) {
	          _yearSelect.append($('<option></option>').val(i).html(i));
	        }
	        if ($yearSelect.find('option').length <= 1) {
	          $yearSelect.append(_yearSelect.html());
	        }
	        // Populate month select
	        var _monthSelect = $('<select>');
	        for (var _i = 1; _i <= 12; _i++) {
	          _monthSelect.append($('<option></option>').val(_i).html(_i));
	        }
	        if ($monthSelect.find('option').length <= 1) {
	          $monthSelect.append(_monthSelect.html());
	        }
	        // Initialize day select options
	        var _daySelect = $('<select>');
	        for (var _i2 = 1; _i2 <= 31; _i2++) {
	          _daySelect.append($('<option></option>').val(_i2).html(_i2));
	        }
	        if ($daySelect.find('option').length <= 1) {
	          $daySelect.append(_daySelect.html());
	        }
	        // Event handler for changing year and month
	        $yearSelect.change(function () {
	          MembershipHelper.getDaysOfMonth({
	            year: $yearSelect.find('option:selected').val(),
	            month: $monthSelect.find('option:selected').val(),
	            daySelect: $daySelect
	          });
	        });
	        $monthSelect.change(function () {
	          MembershipHelper.getDaysOfMonth({
	            year: $yearSelect.find('option:selected').val(),
	            month: $monthSelect.find('option:selected').val(),
	            daySelect: $daySelect
	          });
	        });
	        $monthSelect.add($daySelect).add($yearSelect).each(function (i, select) {
	          // If the select has a readonly attribute, disable all options
	          // except the currently selected option.
	          if ($(select).attr('readonly')) {
	            // will return "readonly"
	            $(select).find('option').attr('disabled', 'disabled');
	          }
	        });
	      });
	    },
	    /**
	     * Get the days of the month specific to the context year/month
	     * @param  {Object} options The object with year, month and the day <select>
	     * @return {void}
	     */
	    getDaysOfMonth: function getDaysOfMonth(options) {
	      var selected = void 0;
	      var $daySelect = options.daySelect;
	      if (!isNaN(parseInt($daySelect.find('option:selected').val()))) {
	        selected = $daySelect.find('option:selected').val();
	      }
	      if (!isNaN(parseInt(options.year)) && !isNaN(parseInt(options.month))) {
	        // Remove numbered options from day select
	        $daySelect.find('option').each(function (index, element) {
	          if (!isNaN(element.value)) {
	            try {
	              element.remove(); // ie fail
	            } catch (err) {}
	          }
	        });
	        var daysInMonth = new Date(options.year, options.month, 0).getDate();
	        var _daySelect = $('<select>');
	        for (var i = 1; i <= daysInMonth; i++) {
	          _daySelect.append($('<option></option>').val(i).html(i));
	        }
	        $daySelect.append(_daySelect.html());
	        if (typeof selected != 'undefined') {
	          $daySelect.find('option[value="' + selected + '"]').prop('selected', true);
	        }
	      }
	    },
	    /**
	     * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val()
	     * to get unformatted value
	     * @param  {[type]} template [description]
	     * @return {void}          [description]
	     */
	    maskInput: function maskInput(template) {
	      $(template).find('[name=contactPhoneNumber],[name=cphone],[name=MembershipCrmCallerInfo_phone]').unmask().mask('000-000-0000');
	      $(template).find('[name=mobilePhoneNumber],[name=mphone],[name=MembershipCrmCallerInfo_mobile]').unmask().mask('000-000-0000');
	      $(template).find('[name=businessPhone]').unmask().mask('000-000-0000');
	      $(template).find('[name=household_primaryPhoneNumber],[name=householdPrimaryPhoneNumber]').unmask().mask('000-000-0000');
	      $(template).find('[name=month],[name=household_month],[name=householdDobMonth],[name=dobmonth],[name=MembershipCrmCallerInfo_dobEditMonth],[name=day],[name=household_day],[name=householdDobDay],[name=dobday],[name=MembershipCrmCallerInfo_dobEditDay]').unmask().mask('00');
	
	      $(template).find('[name=year],[name=household_year],[name=householdDobYear],[name=dobyear],[name=MembershipCrmCallerInfo_dobEditYear]').unmask().mask('0000');
	      if (addressForm.isUS()) {
	        $(template).find('[name=postalcode],[name=zip],[name=MembershipCrmCallerInfo_zipCode]').unmask().mask('00000-0000');
	        $(template).find('[name=businessZipCode]').unmask().mask('00000-0000');
	        $(template).find('[name=employeeAddon_zip]').unmask().mask('00000-0000');
	      } else {
	        $(template).find('[name=postalcode],[name=zip],[name=MembershipCrmCallerInfo_zipCode]').unmask().mask('S0S 0S0');
	        $(template).find('[name=businessZipCode]').unmask().mask('S0S 0S0');
	        $(template).find('[name=employeeAddon_zip]').unmask().mask('S0S 0S0');
	      }
	    },
	    /**
	     * This function is used showing server side errors returned from
	     * calling various membership related ajax services. If we have an
	     * error, we show it at the top and scroll to it.
	     * @param  {Object} data The membership application meta data
	     * @return {Object}      The membership application meta data
	     */
	    handleErrors: function handleErrors(data) {
	      var hasErrors = data && data.error && data.errorMessages && data.errorMessages.length > 0;
	      var errorHtml = '';
	      var $selectors = $('#server-error, #notification-message');
	      if (data && !data.retainNotification || hasErrors) {
	        $selectors.addClass('hide').children().remove();
	      }
	      if (data && data.status && data.status === 500) {
	        data = {
	          error: true,
	          errorMessages: ['Unexpected Error']
	        };
	      }
	      if (data && data.error && data.errorMessages) {
	        // First clear div#notification-message (needed on Add People Outside Renewal page)
	        COSTCO.util.notification.clearNotification();
	        $selectors.addClass('critical-notification');
	        for (var i = 0, len = data.errorMessages.length; i < len; i++) {
	          if (data.errorMessages[i] === '_ERR_INVALID_SHIP_ADDR') {
	            data.errorMessages[i] = messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR;
	            var formId = $('#MemberAddressBookForm');
	            var addressField = '#address1';
	            COSTCO.dialog.sameAddressValidation(formId, addressField);
	          }
	          console.error(data.errorMessages[i]);
	          errorHtml += i === len - 1 ? '<span>' + data.errorMessages[i] + '</span>' : '<p>' + data.errorMessages[i] + '</p>';
	          if (data.errorMessages[0] == 'APPLICATION_ORDER_ITEM_ID_MISSING') {
	            var appType = $('#applicationType').val();
	            // Stale browser
	            if (appType === 'BD') {
	              window.location.href = '/CheckoutCartView';
	              return;
	            }
	          }
	        };
	        $selectors.removeClass('hide').append(errorHtml);
	        $('html, body').scrollToElem($selectors, 100);
	      } else {
	        $selectors.removeClass('critical-notification');
	        // Clear previous error on success (needed on Add People Outside Renewal page)
	        COSTCO.util.notification.clearNotification();
	      }
	      return data;
	    },
	    /**
	     * A wrapper around membershipData. We use this so we dont need to
	     * include membershipData everywhere
	     * @return {Object} The object from sessionStorage representing the
	     *                      configProduct application metadata
	     */
	    getConfigProduct: function getConfigProduct() {
	      return membershipData.getConfigProduct();
	    },
	    /**
	     * A wrapper around membershipData. We use this so we dont need to
	     * include membershipData everywhere
	     * @param  {Object} data The object (represetning the membership application
	     *                       metadata) to set in sessionStorage.
	     * @return {Object}      Returns the same data object passed as an argument
	     *                               (meant to be a chainable action)
	     */
	    setConfigProduct: function setConfigProduct(data) {
	      return membershipData.setConfigProduct(data);
	    },
	    /**
	     * Pull a specific address by label from an array of addresses. For example
	     * 'Primary' in theory return the primary address if it matches the label.
	     * @param  {[type]} addressLabel [description]
	     * @param  {[type]} addressArray [description]
	     * @return {[type]}              [description]
	     */
	    findAddressByLabel: function findAddressByLabel(addressLabel, addressArray) {
	      var address = {};
	      $(addressArray).each(function (index, value) {
	        if (value.label == addressLabel) {
	          address = value;
	          return false;
	        }
	      });
	      return address;
	    },
	    /**
	     * Returns a chainable address verification object. Right now this
	     * is specific to the membership application. Maybe parameterize this
	     * to accept a specific form and selectors.
	     * @param {Object} selectors The object that contains selectors
	     * @return {jQuery.Deferred} Returns a deferred, thenable object.
	     */
	    verifyAddresses: function verifyAddresses(selectors) {
	      var addressObjects = this.buildAddressArray($(selectors.form), {
	        primary: selectors.primary,
	        business: selectors.business
	      });
	      $('.order-ajax').addClass('ajax-busy');
	      return COSTCO.util.ajax({
	        url: '/AjaxAddressVerificationCmd',
	        type: 'POST',
	        dataType: 'json',
	        timeout: 15000,
	        // Turn off glboal event handlers. ajaxComplete and ajaxError are
	        // global events defined in global.js
	        global: false,
	        data: {
	          formdata: encodeURIComponent(JSON.stringify(addressObjects))
	        },
	        always: function always() {
	          $('.permanent-ajax-busy').removeClass('ajax-busy');
	        },
	        complete: function complete() {}
	      });
	    },
	    /**
	     * [description]
	     * @param  {[type]} form [description]
	     * @param  {[type]} obj  [description]
	     * @return {[type]}      [description]
	     */
	    buildAddressArray: function buildAddressArray(form, obj) {
	      var addressObjects = [];
	      var primaryAVSObj = addressVerification.buildRequestElement(form, obj.primary);
	      if (typeof primaryAVSObj.fName == 'undefined' || primaryAVSObj.fName == '') {
	        primaryAVSObj.fName = $("#MemberAddressBookForm input[name='first_name']").val();
	        primaryAVSObj.lName = $("#MemberAddressBookForm input[name='lastName']").val();
	      }
	      addressObjects.push(primaryAVSObj);
	      if (this.isBusinessMembership() && obj.business) {
	        var businessAVSObj = addressVerification.buildRequestElement(form, obj.business);
	        if (typeof businessAVSObj.fName == 'undefined' || businessAVSObj.fName == '') {
	          businessAVSObj.fName = $("#MemberAddressBookForm input[name='first_name']").val();
	          businessAVSObj.lName = $("#MemberAddressBookForm input[name='lastName']").val();
	        }
	        addressObjects.push(businessAVSObj);
	      }
	      $.each(addressObjects, function (index, value) {
	        if (value.id == '') {
	          addressObjects[index].id = index;
	        }
	      });
	      return addressObjects;
	    },
	    /**
	     * This function serves as an intermediary to invoking the verification
	     * modal. It prepares data appropriately and then invokes. If the verification
	     * response has all "no suggestions", we simply invoke the callback on the
	     * entered addresses.
	     * @param  {Object}   addressObj The response from calling
	     *                               /AjaxAddressVerificationCmd. The data
	     *                               structure looks like
	     *                                {Address:[], Validated_Address: []}
	     * @param  {Function} callback   The function which ends up being the
	     *                               primary event on the verification modal.
	     *                               It could submit a form, etc.
	     * @return {void}
	     */
	    invokeMultiAVS: function invokeMultiAVS(addressObj, callback) {
	      $('.order-ajax').removeClass('ajax-busy');
	      if (typeof addressObj !== 'undefined' && addressObj != null && addressObj.Validated_Address != null) {
	        var multiAVSModal = addressVerification.showMultiAddressVerificationModal;
	
	        if (addressVerification.hasAllNoSuggestion(addressObj.Validated_Address)) {
	          // In this case we just want to use the user inputted addresses
	          callback(addressObj.Address);
	          COSTCO.dialog.close();
	        } else if (addressVerification.hasAllSameAsSuggested(addressObj)) {
	          // Prefering the validate_address as it will contain the 4 digits
	          // appended to the zip code.
	          callback(addressObj.Validated_Address);
	          COSTCO.dialog.close();
	        } else {
	          // We have at least one suggested address. We want to show the modal.
	          var validAddresses = MembershipHelper.removeValidAddressFromArray(addressObj);
	          multiAVSModal(validAddresses, callback);
	        }
	      } else {
	        elementObj = $('[name=' + addressObj.errorMessageParam[0] + ']');
	        if (elementObj.length > 0) {
	          elementObj.parent().addClass('error');
	          elementObj.attr('hasvalidationerror', true);
	          $(elementObj).parent().parents("form:first").valid();
	        }
	      }
	    },
	    /**
	     * This function populates a given form. Its meant to replace the values
	     * of each designated field with what the addresses selected after the
	     * verification process. We then can just serialize the form to send to the
	     * backend.
	     * @param  {jQuery} form        The form to populate
	     * @param  {Array} addresses    Array of validated addresses to get address
	     *                              details from it and send with membership
	     *                              application form.
	     * @param  {boolean} isAffiliate Are we populating the affiliate form?
	     * @return {void}
	     */
	    populateAddressData: function populateAddressData(form, addresses, isAffiliate) {
	      var primaryAddress = isAffiliate ? this.findAddressByLabel('Affiliate Address', addresses) : this.findAddressByLabel('Primary Address', addresses);
	      form.find('input[name=address1],input[name=line1]').val(primaryAddress.line1 != null ? primaryAddress.line1.trim() : "");
	      form.find('input[name=address2],input[name=line2]').val(primaryAddress.line2);
	      form.find('input[name=city]').val(primaryAddress.city);
	      form.find('select[name=state]').val(primaryAddress.state);
	      form.find('input[name=postalcode],input[name=zip]').val(primaryAddress.zip);
	      form.find('input[name=country]').val(primaryAddress.country);
	      if (this.isBusinessMembership() && !isAffiliate) {
	        var businessAddress = this.findAddressByLabel('Business Address', addresses);
	        form.find('input[name=businessAddressLine1]').val(businessAddress.line1);
	        form.find('input[name=businessAddressLine2]').val(businessAddress.line2);
	        form.find('input[name=businessCity]').val(businessAddress.city);
	        form.find('select[name=businessState]').val(businessAddress.state);
	        form.find('input[name=businessZipCode]').val(businessAddress.zip);
	        form.find('input[name=businessCountry]').val(businessAddress.country);
	      }
	    },
	    /**
	     * Removes valid addresses from he AVS response array
	     * @param  {Array} addressObj AVS address array
	     * @return {Array} Array of addresses to be validated
	     */
	    removeValidAddressFromArray: function removeValidAddressFromArray(addressObj) {
	      var addressesToVerify = {
	        Address: [],
	        Validated_Address: [],
	        No_Suggestion: [],
	        size: 0
	      };
	      $.each(addressObj.Validated_Address, function (indexNew, valueNew) {
	        var entered = addressVerification.findAddressById(valueNew.id, addressObj.Address);
	        addressesToVerify.Validated_Address.push(addressObj.Validated_Address[indexNew]);
	        addressesToVerify.Address.push(entered);
	      });
	      addressesToVerify.size = addressesToVerify.Address.length;
	      return addressesToVerify;
	    },
	    /**
	     * [description]
	     * @param  {[type]} stateProvList [description]
	     * @return {[type]}               [description]
	     */
	    getStateOptions: function getStateOptions(stateProvList) {
	      return addressForm.getStateOptions(stateProvList);
	    },
	    /**
	     * Make a call to grab the application meta data from
	     * the membershipData module.
	     * @return {jQuery.Promise} The returned promise to chain
	     */
	    getApplicationData: function getApplicationData() {
	      return membershipData.getApplicationData();
	    },
	    /**
	     * Get the membership meta data from the server
	     * @return {jQuery.Promise} The returned promise to chain
	     */
	    getMembershipData: function getMembershipData() {
	      return membershipData.getMembershipData();
	    },
	    /**
	     * [description]
	     * @return {[type]} [description]
	     */
	    getStateProvJson: function getStateProvJson() {
	      return address.getStateProvJson();
	    },
	    /**
	     * [description]
	     * @param  {[type]} x [description]
	     * @param  {[type]} y [description]
	     * @param  {[type]} z [description]
	     * @return {[type]}   [description]
	     */
	    bingCityState: function bingCityState(x, y, z) {
	      return address.bingCityState(x, y, z);
	    },
	    geocodeApiCityState: function geocodeApiCityState(x, y, z) {
	      return address.geocodeApiCityState(x, y, z);
	    },
	    /**
	     * Builds the existing affiliates block. Provide a template and a target
	     * to append the HTML too.
	     * @param  {[type]} template [description]
	     * @param  {[type]} target   [description]
	     * @return {void}
	     */
	    buildExistingAffiliates: function buildExistingAffiliates(template, target) {
	      $('.affiliate-block, .affiliate-clearfix').remove();
	      var affiliateHtml = '';
	
	      this.getAffiliates().forEach(function (affiliate, i) {
	        affiliateHtml += COSTCO.util.tmpl(template, {
	          affiliate: affiliate,
	          // Needed to inject clearfix where ever needed
	          index: i + 1
	        });
	      });
	      $(target).prepend(affiliateHtml);
	    },
	    /**
	     * Gets the array of affiliates attached to the configProduct
	     * @return {Array} The array of objects representing the affiliates
	     */
	    getAffiliates: function getAffiliates() {
	      var affiliates = [];
	      var c = this.getConfigProduct();
	      if (!$.isEmptyObject(c) && c.affilatedMemberships && c.affilatedMemberships.affilatedMember) {
	        affiliates = c.affilatedMemberships.affilatedMember.map(function (affiliate) {
	          // These fields are used by MemberApplicationAffiliateUpdateCmd
	          // Some of them are duplicates of whats already defined
	          // on configProduct.affilatedMemberships.affilatedMember because
	          // theres no standard
	          affiliate.affiliateMembershipNumber = affiliate.membershipNumber || '';
	          affiliate.parentMembershipNumber = c.membershipNumber || '';
	          affiliate.organizationId = c.organizationId || '';
	          affiliate.first = affiliate.firstName || '';
	          affiliate.last = affiliate.lastName || '';
	          affiliate.mi = affiliate.mi || '';
	          return affiliate;
	        });
	      }
	      return affiliates;
	    },
	    /**
	     * Using the AllMembershipInfoDataBean as the source of data, locate the
	     * specific affiliate by number
	     * @param  {Object} data   The AllMembershipInfoDataBean serielized
	     *                         as a JS object
	     * @param  {Number} number The affiliate membership number
	     * @return {Object}        The JS object representing the affiliate from
	     *                             AllMembershipInfoDataBean
	     */
	    getAffiliateFromDataBeanByNumber: function getAffiliateFromDataBeanByNumber(data, number) {
	      var affiliate = undefined;
	      if (data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        var affiliates = data.caller.businessInfo.affiliates;
	        affiliates.forEach(function (aff) {
	          if (aff.cardNumber && aff.cardNumber.value && aff.cardNumber.value == number) {
	            affiliate = aff;
	          }
	        });
	      }
	      return affiliate;
	    },
	
	    /**
	     * Gets the affiliate object from the configProduct if one exists.
	     * @param  {Number} membershipNumber The affiliate membershipNumber
	     * @return {Object}                  The affiliate object
	     */
	    getAffiliateByNumber: function getAffiliateByNumber(membershipNumber) {
	      var affiliate = undefined;
	      this.getAffiliates().forEach(function (aff) {
	        if (membershipNumber == aff.membershipNumber) {
	          affiliate = aff;
	          return;
	        }
	      });
	      return affiliate;
	    },
	
	    /**
	     * Gets the affiliate household from the configProduct if one exists
	     * @param  {Number} membershipNumber The affiliate household membership number
	     * @return {Object}                  The affiliate household object
	     */
	    getAffiliateHouseholdByNumber: function getAffiliateHouseholdByNumber(membershipNumber) {
	      var affHousehold = undefined;
	      this.getAffiliates().forEach(function (aff) {
	        if (aff.houseHold && aff.houseHold.membershipNumber == membershipNumber) {
	          affHousehold = aff.houseHold;
	          return;
	        }
	      });
	      return affHousehold;
	    },
	
	    /**
	     * Gets the affiliate object using the affiliate's household membership number.
	     * @param  {Number} membershipNumber The affiliate household membership number
	     * @return {Object}                  The affiliate object
	     */
	    getAffiliateByHouseholdNumber: function getAffiliateByHouseholdNumber(membershipNumber) {
	      var affiliate = undefined;
	      this.getAffiliates().forEach(function (aff) {
	        if (aff.houseHold && aff.houseHold.membershipNumber == membershipNumber) {
	          affiliate = aff;
	          return;
	        }
	      });
	      return affiliate;
	    },
	
	    /**
	     * Gets the affiliate object using the affiliate's household membership number.
	     * @param  {Object} data   The AllMembershipInfoDataBean serielized
	     *                         as a JS object
	     * @param  {Number} membershipNumber The affiliate household membership number
	     * @return {Object}                  The affiliate object
	     */
	    getAffByHouseholdNumber: function getAffByHouseholdNumber(data, membershipNumber) {
	      var affiliate = undefined;
	      if (data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        var affiliates = data.caller.businessInfo.affiliates;
	        affiliates.forEach(function (aff) {
	          if (aff.household && aff.household.cardNumber && aff.household.cardNumber.value == membershipNumber) {
	            affiliate = aff;
	            return;
	          }
	        });
	      }
	      return affiliate;
	    },
	
	    /**
	     * Takes the request data serialized from the affiliate form template
	     * (tmpl_affiliate) and transforms it to the appropriate namespace for
	     * the MemberAffiliateAddCmd used by renew membership / business
	     * details flows.
	     * @method
	     * @param  {Object} requestData The object representing the form inputs
	     *                              from form#affiliate-form
	     * @return {Object}             The transformed inputs in an object.
	     */
	    transformAffiliateInputNames: function transformAffiliateInputNames(requestData) {
	      var newRequestData = {};
	      var prefix = 'MembershipCrmAddAffiliate_';
	      Object.keys(requestData).forEach(function (key) {
	        switch (key) {
	          case 'fname':
	            newRequestData[prefix + 'firstName'] = requestData[key];
	            break;
	          case 'lname':
	            newRequestData[prefix + 'lastName'] = requestData[key];
	            break;
	          case 'dobday':
	            newRequestData[prefix + 'dobEditDay'] = requestData[key];
	            break;
	          case 'dobmonth':
	            newRequestData[prefix + 'dobEditMonth'] = requestData[key];
	            break;
	          case 'dobyear':
	            newRequestData[prefix + 'dobEditYear'] = requestData[key];
	            break;
	          case 'line1':
	            newRequestData[prefix + 'addressLine1'] = requestData[key];
	            break;
	          case 'line2':
	            newRequestData[prefix + 'addressLine2'] = requestData[key];
	            break;
	          case 'cphone':
	            newRequestData[prefix + 'phone'] = requestData[key];
	            break;
	          case 'mphone':
	            newRequestData[prefix + 'mobile'] = requestData[key];
	            break;
	          case 'householdPrefix':
	            newRequestData[prefix + 'household_prefix'] = requestData[key];
	            break;
	          case 'householdFname':
	            newRequestData[prefix + 'household_firstName'] = requestData[key];
	            break;
	          case 'householdMi':
	            newRequestData[prefix + 'household_mi'] = requestData[key];
	            break;
	          case 'householdLname':
	            newRequestData[prefix + 'household_lastName'] = requestData[key];
	            break;
	          case 'householdSuffix':
	            newRequestData[prefix + 'household_suffix'] = requestData[key];
	            break;
	          case 'householdDobMonth':
	            newRequestData[prefix + 'household_dobEditMonth'] = requestData[key];
	            break;
	          case 'householdDobDay':
	            newRequestData[prefix + 'household_dobEditDay'] = requestData[key];
	            break;
	          case 'householdDobYear':
	            newRequestData[prefix + 'household_dobEditYear'] = requestData[key];
	            break;
	          case 'householdEmail':
	            newRequestData[prefix + 'household_email'] = requestData[key];
	            break;
	          case 'householdPrimaryPhoneNumber':
	            newRequestData[prefix + 'household_phone'] = requestData[key];
	            break;
	          case 'householdCheckbox':
	            newRequestData[prefix + 'includeHousehold'] = requestData[key];
	            break;
	          default:
	            newRequestData['' + prefix + key] = requestData[key];
	        }
	      });
	      return newRequestData;
	    },
	    /**
	     * Similar to above method. Take the old input names and transform them to
	     * what the backend is expecting (for /MemberHouseholdAddCmd)
	     * @param  {Object} requestData The object representing the form inputs
	     *                              from form#affiliate-form
	     * @return {Object}             The transformed inputs in an object.
	     */
	    transformAffiliateHouseholdInputNames: function transformAffiliateHouseholdInputNames(requestData) {
	      var newRequestData = {};
	      Object.keys(requestData).forEach(function (key) {
	        switch (key) {
	          case 'householdPrefix':
	            newRequestData['prefix'] = requestData[key];
	            break;
	          case 'householdFname':
	            newRequestData['first_name'] = requestData[key];
	            break;
	          case 'householdMi':
	            newRequestData['middle_name'] = requestData[key];
	            break;
	          case 'householdLname':
	            newRequestData['last_name'] = requestData[key];
	            break;
	          case 'householdSuffix':
	            newRequestData['suffix'] = requestData[key];
	            break;
	          case 'householdDobMonth':
	            newRequestData['month'] = requestData[key];
	            break;
	          case 'householdDobDay':
	            newRequestData['day'] = requestData[key];
	            break;
	          case 'householdDobYear':
	            newRequestData['year'] = requestData[key];
	            break;
	          case 'householdEmail':
	            newRequestData['email'] = requestData[key];
	            break;
	          case 'householdPrimaryPhoneNumber':
	            newRequestData['contact_phone'] = requestData[key];
	            break;
	          default:
	            newRequestData[key] = requestData[key];
	        }
	      });
	      return newRequestData;
	    },
	    /**
	     * First show the user the affiliates as registered with their
	     * xorderitems.crmmemberinfo (configProduct) on the application page.
	     * If they have 6, we don't allow anymore.
	     * @param  {[type]} data [description]
	     * @return {[type]}      [description]
	     */
	    reflectAffiliates: function reflectAffiliates(data) {
	      // First show the affiliates returned from submission
	      COSTCO.MembershipHelper.buildExistingAffiliates('tmpl_affiliate_block', '#add-person-container');
	      // Hide add person button if we're >= 6 affiliates
	      COSTCO.AffiliateForm.checkAffiliateNumber(data);
	      return data;
	    },
	    /**
	     * Build the affiliate list for renew / account details view using the response
	     * from some crud operation.
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    reflectAffiliatesAlternate: function reflectAffiliatesAlternate(data) {
	      if (data && data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        COSTCO.RenewMembership.membershipData = /* COSTCO.AccountDetails.membershipData = */data;
	        var affiliateHtml = '';
	        var affiliates = data.caller.businessInfo.affiliates || [];
	        affiliates.length > 0
	        // Remove the empty class (if it exists), which has a border-top
	        // attribute. The following affiliate blocks have border-tops.
	        ? $('#affiliate-list-container').removeClass('empty') : $('#affiliate-list-container').addClass('empty');
	        affiliates.forEach(function (a) {
	          affiliateHtml += COSTCO.util.tmpl('tmpl_affiliate_row', {
	            affiliateCardNumber: a.cardNumber.value,
	            affiliateFirstName: a.firstName.value,
	            affiliateLastName: a.lastName.value,
	            isNewAffiliate: a.statusReasonDesc && a.statusReasonDesc.value == 'Created',
	            hasHousehold: a.household && a.household.cardNumber.value,
	            affiliateHouseholdNumber: a.household.cardNumber.value,
	            affiliateHouseholdFirstName: a.household.firstName.value,
	            affiliateHouseholdLastName: a.household.lastName.value
	          });
	        });
	        $('#affiliate-list-container').html(affiliateHtml);
	      }
	      return data;
	    },
	    /**
	     * Build the affiliate list for Add Additional People outside renewal view using
	     * the response from some crud operation.
	     * @param {Object} data The JSON object representing the AllMembershipInfoDataBean.
	     * @return {Object} Same as parameter - used for chaining to the next method.
	     */
	    reflectAffiliatesBussinessOutsideRenewal: function reflectAffiliatesBussinessOutsideRenewal(data) {
	      COSTCO.AddAdditionalPeople.membershipData = /* COSTCO.AccountDetails.membershipData = */data;
	      var newAffiliateHtml = '';
	      var affiliateHtml = '';
	      var affiliates = data.caller.businessInfo.affiliates || [];
	      var newAffiliatesCount = 0;
	      var individualFee = 0;
	      affiliates.forEach(function (a) {
	        if (a.statusReasonDesc && a.statusReasonDesc.value == 'Created') {
	          newAffiliatesCount++;
	        }
	      });
	      var totalFee = parseFloat(data.caller.addAffiliateAmount);
	      if (newAffiliatesCount > 0) {
	        // Remove the empty class (if it exists), which has a border-top
	        // attribute. The following affiliate blocks have border-tops.
	        $('#new-people-on-my-membership').removeClass('empty');
	        individualFee = totalFee / newAffiliatesCount;
	        // Display info message if there are no errors
	        if (!$('#notification-message').hasClass('critical-notification')) {
	          COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [messages.ACCOUNT_RWD__AddAdditionalPeople_AdditionalPersonCost_InfoText]);
	        }
	      } else {
	        $('#new-people-on-my-membership').addClass('empty');
	        // Remove info message if there are no errors
	        if (!$('#notification-message').hasClass('critical-notification')) {
	          COSTCO.util.notification.clearNotification();
	        }
	      }
	      affiliates.forEach(function (a) {
	        if (a.statusReasonDesc && a.statusReasonDesc.value == 'Created') {
	          newAffiliateHtml += COSTCO.util.tmpl('tmpl_add_new_affiliate_row', {
	            affiliateCardNumber: a.cardNumber.value,
	            affiliateFirstName: a.firstName.value,
	            affiliateLastName: a.lastName.value,
	            isNewAffiliate: true,
	            hasHousehold: a.household && a.household.cardNumber.value,
	            affiliateHouseholdNumber: a.household.cardNumber.value,
	            affiliateHouseholdFirstName: a.household.firstName.value,
	            affiliateHouseholdLastName: a.household.lastName.value,
	            individualFeeJS: individualFee.toFixed(2)
	          });
	        } else {
	          affiliateHtml += COSTCO.util.tmpl('tmpl_affiliate_row', {
	            affiliateCardNumber: a.cardNumber.value,
	            affiliateFirstName: a.firstName.value,
	            affiliateLastName: a.lastName.value,
	            isNewAffiliate: false,
	            hasHousehold: a.household && a.household.cardNumber.value,
	            affiliateHouseholdNumber: a.household.cardNumber.value,
	            affiliateHouseholdFirstName: a.household.firstName.value,
	            affiliateHouseholdLastName: a.household.lastName.value
	          });
	        }
	      });
	      $('#new-people-on-my-membership').html(newAffiliateHtml);
	      $('#affiliate-list-container').html(affiliateHtml);
	      if (totalFee) {
	        $('#total-fee').html('$' + totalFee.toFixed(2));
	      }
	      // In border cases, when newAffiliatesCount changes from 0 to 1, or from 1 to 0,
	      // hide/show appropriate sections to have verbiage in singular/plural, show/hide
	      // total cost, and enable/disable Add to Cart button.
	      if (newAffiliatesCount == 0) {
	        $('#add-a-person-outside-renewal').removeClass('hide');
	        $('#add-another-person-outside-renewal').addClass('hide');
	        $('#total-price-section').addClass('hide');
	        $('#add-to-cart').attr('disabled', 'disabled');
	      } else if (newAffiliatesCount == 1 && $('#add-another-person-outside-renewal').hasClass('hide')) {
	        $('#add-a-person-outside-renewal').addClass('hide');
	        $('#add-another-person-outside-renewal').removeClass('hide');
	        $('#total-price-section').removeClass('hide');
	        $('#add-to-cart').removeAttr('disabled');
	      }
	      // Hide the option to add more affiliates if there are more than six
	      if (affiliates.length >= 6) {
	        $('#add-another-person-outside-renewal').addClass('hide');
	      }
	      return data;
	    },
	    /**
	     * If the response has affiliates, we want the the link to show
	     * "Add Another Person". If we have zero, we want the link to say
	     * "Add a Person".
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    addPersonLink: function addPersonLink(data) {
	      if (data && data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates && data.caller.businessInfo.affiliates.length > 0) {
	        $('#add-another-person-text').removeClass('hide');
	        $('#add-a-person-text').addClass('hide');
	      } else {
	        $('#add-another-person-text').addClass('hide');
	        $('#add-a-person-text').removeClass('hide');
	      }
	      return data;
	    },
	    /**
	     * If we already have 6 newly added affiliates, we don't want to allow the
	     * user to add any more. This function checks that and then hides/disables
	     * the "Add Another Person" link.
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    canAddAffiliate: function canAddAffiliate(data) {
	      var counter = 0;
	      if (data && data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        (data.caller.businessInfo.affiliates || []).forEach(function (a) {
	          if (a.statusReasonDesc && a.statusReasonDesc.value == 'Created') {
	            counter++;
	          }
	        });
	        // Handle hide/show of Add Person/Add Another Person
	        if (COSTCO.MembershipHelper.isQuickMembership) {
	          if (counter == 0) {
	            $('#add-a-person-text').removeClass('hide');
	            $('#add-another-person-text').addClass('hide');
	          } else if (counter > 0 && counter < 6) {
	            $('#add-a-person-text').addClass('hide');
	            $('#add-another-person-text').removeClass('hide');
	          } else {
	            $('#add-a-person-text').addClass('hide');
	            $('#add-another-person-text').addClass('hide');
	          }
	        } else if (counter >= 6) {
	          $('#add-another-person').addClass('hide');
	        } else {
	          $('#add-another-person').removeClass('hide');
	        }
	      }
	      return data;
	    },
	    /**
	     * This takes the renewal price from the AllMembershipInfoDataBean
	     * (caller.renewAmount) and replaces the value of span#renewal-amount
	     * located at MembershipRenewInfo_Business_UI.jspf
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @param  {Boolean} isUpgrade
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    updateTotalPrice: function updateTotalPrice(data, isUpgrade) {
	      if (data && data.caller && data.caller.renewAmount) {
	        var locale = COSTCO.util.getLocale().substr(0, 2);
	        $('#renewal-amount').text(COSTCO.util.localeSpecificCurrency(isUpgrade ? data.caller.renewAndUpgradeAmount : data.caller.renewAmount, locale));
	      }
	      return data;
	    },
	    /**
	     * In Account Details, when a user has a validated profile with a internal
	     * card (usage = 'Z050') wants to change their email address, we invalidate
	     * them unless they're changing their email that includes the costco domain.
	     * (<username>@costco.com)
	     * @param  {DOMElement} form The form to pull the profile email from
	     * @return {boolean}     Does this profile need to be invalidated?
	     */
	    isInternalInvalidated: function isInternalInvalidated(form) {
	      var email = $(form).find('#update-email').val();
	      return COSTCO.util.getMemberCookie().usage == 'Z050' && !(email.includes('@costco.com') || email.includes('@costco.ca'));
	    },
	    /** Adding zero the left of the input if its lenght is 1 */
	    prependZero: function prependZero(event) {
	      var value = $(event.currentTarget).val();
	      if (value != null && value != '') {
	        if (value.length == 1 && value != '0') {
	          value = '0' + value;
	        }
	        $(event.currentTarget).val(value);
	      }
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.MembershipHelper = MembershipHelper;
	  return MembershipHelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title membership-data.js: Submodule
	 * @description A submodule that retrieves the users membership data. Used
	 *              for prepopulating forms.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var MembershipData = {
	    /**
	     * Returns a 'thenable' promise  that contains a 'configproduct' from
	     * the database. On the backend this ajax request maps to
	     * MembershipApplicationDataBeanAjax.java. The 'configproduct' is the user's
	     * data and the command builds this object with the following priority:
	     *  1. If CRM data exists for this user, use it
	     *  2. Else if the user has a defaulted billing address, use it.
	     * @return {Object} The promise to be used for further processing. Use it
	     *                      like ...getApplicationData().done(callbackFn(data))
	     */
	    getApplicationData: function getApplicationData() {
	      var configProduct = this.getConfigProduct();
	      var deferred = $.Deferred();
	      var orderItemId = applicationTrackingCookie || $.cookie('APPLICATION_TRACKING_COOKIE');
	      var querystrings = {
	        requesttype: 'ajax',
	        orderItemId: orderItemId || ''
	      };
	      var url = '/AjaxMembershipApplicationMetaDataView?' + $.param(querystrings);
	      // If we have the data already, lets use it instead of making a call.
	      if (!$.isEmptyObject(configProduct) && orderItemId == configProduct.applicationTrackingCookie) {
	        var data = {};
	        data.configProduct = configProduct;
	        return deferred.resolve(data);
	      }
	      COSTCO.util.ajax({
	        url: url,
	        type: 'GET',
	        dataType: 'json',
	        done: function done(data, textStatus, jqXHR, options) {
	          // We'll set this in cache in case we want to use it elsewhere
	          if (data.configProduct) {
	            // If we returned with a configProduct, we cool
	            MembershipData.setConfigProduct(data);
	          } else {
	            // Otherwise, set this to empty and dont track this orderItemsId
	            data.configProduct = {};
	            MembershipData.setConfigProduct(data, true);
	          }
	          if (data.error) {
	            deferred.reject(data, textStatus, jqXHR, options);
	          }
	          deferred.resolve(data, textStatus, jqXHR, options);
	        },
	        fail: function fail(jqXHR, textStatus, errorThrown, options) {
	          deferred.reject(jqXHR, textStatus, errorThrown, options);
	        }
	      });
	      return deferred.promise();
	    },
	    /**
	     * Makes a call to the server to fetch the membership meta data. Stores
	     * it in sessionStorage and returns it with subsequent calls instead of
	     * making additional calls.
	     * @return {jQuery.Deferred} Returns a thenable promise that resolves the
	     *                                   membership meta data.
	     */
	    getMembershipData: function getMembershipData() {
	      var _this = this;
	
	      var membershipData = this._getMembershipData();
	      if (!$.isEmptyObject(membershipData)) {
	        return $.Deferred().resolve(membershipData);
	      }
	      return COSTCO.util.ajax({
	        url: COSTCO.util.makeUrl('/AjaxMembershipMetaDataView', {
	          pseudo: new Date().getTime()
	        }),
	        dataType: 'json'
	      }).then(function (data) {
	        // 	@KMED - COPY HOW WE HANDLE ERRORS FROM MEMBERSHIP APPLICATION
	        // 	<%-- Print Global errors --%>
	        // 	if (MembershipMetaData.payload.errorMessages.length > 0){
	        // 		for (var i = 0; i < MembershipMetaData.payload.errorMessages.length; ++i) {
	        // 			$('#crmMetaDataGlobalError').html(MembershipMetaData.payload.errorMessages[i]);
	        // 		}
	        // 		$('#crmMetaDataGlobalError').show();
	        // 		$('html, body').animate({ scrollTop: $('#crmMetaDataGlobalError') });
	        // 	}else{
	        // 		$('#crmMetaDataGlobalError').hide();
	        // 	}
	        // 	if(data.caller.usageRole != '01'){
	        // 		$('#digitalConnection').remove();
	        // 		$('#mailConnection').remove();
	        // 	}
	        //
	        //  @KMED - WE NEED TO DECOUPLE CITI STUFF. NEED TO FIGURE OUT
	        //  WHATS HAPPENING HERE
	        // 	COSTCO.util.updateCappJson();
	        // 	COSTCO.util.processCappLogic();
	        //
	        // 	@KMED - HERE WE SET AND RETURN
	        return _this.setMembershipData(data);
	      });
	    },
	    /**
	     * Sets the membership meta data in session storage.
	     * @param  {Object} data The membership meta data to set
	     * @return {Object}      Returns the membership meta data for chainable
	     *                               processing.
	     */
	    setMembershipData: function setMembershipData(data) {
	      var u = COSTCO.util;
	      if (data) {
	        u.setInSession('membershipData', data);
	      }
	      return data;
	    },
	    /**
	     * Private method used by "getMembershipData" to return the membership
	     * meta data.
	     * @return {[type]} [description]
	     */
	    _getMembershipData: function _getMembershipData() {
	      return COSTCO.util.getFromSession('membershipData');
	    },
	    /**
	     * If configProduct exists as part of the response, store it. Return
	     * the data for further processing. applicationTrackingCookie = orderItemsId
	     * @param  {Object} data        The application meta data
	     * @param  {Boolean} notTracking The flag to say 'dont use this orderItemsId'.
	     *                               If not included, will add property
	     *                               applicationTrackingCookie
	     * @return {Object}             The application meta data
	     */
	    setConfigProduct: function setConfigProduct(data, notTracking) {
	      var u = COSTCO.util;
	      if (data && data.configProduct) {
	        if (!notTracking) {
	          data.configProduct.applicationTrackingCookie = applicationTrackingCookie;
	        }
	        u.setInSession('configProduct', data.configProduct);
	      }
	      return data;
	    },
	    /**
	     * Gets the configProduct from the session storage
	     * @return {Object} The object representing the configProduct
	     */
	    getConfigProduct: function getConfigProduct() {
	      return COSTCO.util.getFromSession('configProduct');
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.MembershipData = MembershipData;
	  return MembershipData;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * @title addressForm.js: Feature level module
	 * @description Address utility module
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14), __webpack_require__(17), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (address, addressVerification, preauthchargesmodal) {
		var CAddressForm = {
			addressVal: address,
			validationRulesApplied: false,
			// Set of rules used only for address validation
			// This method should be ran once with initialization
			validationRules: function validationRules() {
	
				if (!CAddressForm.validationRulesApplied) {
	
					$.validator.setDefaults({ ignore: ".ignoreHide" });
					$.validator.addMethod("companyrequiredcheck", function (value, element) {
						if ($('#isBDAppVar').val() == 'BD') {
							return value != "";
						} else {
							return true;
						}
					}, messages.ERR_INVALID_COMPANY);
					$.validator.addMethod("pobox", function (value, element) {
						if ($('#isBDAppVar').val() == 'BD') {
							var addressBookBool = typeof element.form.addressType[0] !== 'undefined' ? element.form.addressType[0].value == 'S' ? true : false : false;
							var poRegex = /^[^a-z]*(((num(ber)?|#) *\d+)|((box|bin|b)[-. \/\\]? *(num(ber)?|#)? *\d+)|((.*[^a-z])?p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(num(ber)?|#)?\d+)([^a-z]|$))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *(num(ber)?|#)? *\d+)|(p *-?\/?(o)? *-?box([^a-z]|$))|post office box)/i;
							var poCheck = element.form.addressType.value == 'S' || addressBookBool ? !poRegex.test(value) : true;
							return this.optional(element) || poCheck;
						} else {
							return true;
						}
					}, messages.ERR_INVALID_POBOX);
					$.validator.addMethod("notEqual", function (value, element, param) {
						return this.optional(element) || value != param;
					}, messages.ERR_INVALID_STATE);
					$.validator.addMethod("countryspecificpostalcodePassCountrySelectorModal", function (value, element) {
						var form = element.form;
						var country = $(form).find('[name=country]');
						if (country.val() === undefined) {
							return !COSTCO.CAddressForm.isUS({ input: element }) ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
						}
						return country.val() != 'US' ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
					}, messages.ERR_ENTER_ZIPCODE);
					$.validator.addMethod("hasvalidationerror", function (value, element) {
						return element.getAttribute('hasvalidationerror') == undefined || element.getAttribute('hasvalidationerror') == null || element.getAttribute('hasvalidationerror') == "false";
					}, messages.ERR_INVALID_STATE);
					$.validator.addMethod("validateAdditionalTerritories", function (value, element, param) {
						var form = element.form;
						var stateCode = $(form).find('[name=state]').val();
						var additionalBillingStatesCode = CAddressForm.getAdditionalBillingStates();
						if (wcs.isPharmacy === "true") {
							if (!additionalBillingStatesCode.includes(stateCode)) {
								return true;
							} else {
								return false;
							}
						}
						if (param == 'S') {
							if (!additionalBillingStatesCode.includes(stateCode)) {
								return true;
							} else {
								return false;
							}
						} else {
							return true;
						}
					}, messages.ERR_INVALID_STATE);
					$.validator.addMethod("email", function (value, element) {
						return (/^[_a-zA-Z0-9-+]+(\.[_a-zA-Z0-9-+]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,10})$/.test(value.toLowerCase())
						);
					}, messages.JS_VALID_EMAIL);
					$.validator.addMethod("phone", function (value, element) {
						if (value.startsWith("0") || value.startsWith("1")) {
							return false;
						}
						//Method phone is already used for Patient Insurance phone, when there is an address creation this overrides the old bind
						try {
							if (element && element.id === "insurancePhone") {
								return this.optional(element) || /\(?([0-9]{3})\)\s([0-9]{3})\2?([-]?)([0-9]{4})/.test(value);
							}
						} catch (e) {
							console.log(e);
							return true; //if element is empty , no validation required
						}
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
					$.validator.addMethod("contactPhone", function (value, element) {
						if (value.startsWith("0") || value.startsWith("1")) {
							return false;
						}
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
					/** STRY0157080 Require at least ONE alphabet in each of the name fields */
					$.validator.addMethod("firstNameValidation", function (value, element) {
						return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
					}, messages.ERR_INVALID_FNAME);
					$.validator.addMethod("lastNameValidation", function (value, element) {
						return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
					}, messages.ERR_INVALID_LNAME);
					/** SFSTRY0039312 Implement special characters restrictions for Company name as First and Last Name fields */
					$.validator.addMethod("companyNameValidation", function (value, element) {
						if ($('#isBDAppVar').val() == 'BD') {
							return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
						} else {
							return true;
						}
					}, messages.ERR_INVALID_COMPANY);
					CAddressForm.validationRulesApplied = true;
				}
			},
	
			/**
	   * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val() to get unformatted value
	   */
			maskInput: function maskInput(template) {
				$(template).find('[name=phone]').unmask().mask('000-000-0000');
				$(template).find('#contactPhNo').unmask().mask('000-000-0000');
				$(template).find('#contactPhNo-inline').unmask().mask('000-000-0000');
				$(template).find('.phoneNumber').unmask().mask('000-000-0000');
	
				if (COSTCO.CAddressForm.isUS({ form: template })) {
					$(template).find('[name=postal]').unmask().mask('00000-0000');
				} else {
					$(template).find('[name=postal]').unmask().mask('S0S 0S0');
				}
			},
			/**
	   * Determine if the form or input is should be interpretted as US.
	   * In the case of a form, we look at the select[name=country]. In the case
	   * of a input, we use the data-country attribute to get the value of
	   * a designated select[name=country] which will have the US/CA value,
	   * otherwise we check the lang ID as a last resort.
	   * @param {object} elementsObj - OPTIONAL - Object with the structure
	   * of {form: formElement, input: inputElement}. Pass inputElement must 
	   * contain a data-attribute that maps to the country select to pull the value.
	   */
			isUS: function isUS(elementsObj) {
				var $form = elementsObj && elementsObj.form ? $(elementsObj.form) : COSTCO.CAddressForm.getForm();
				var $input = elementsObj && elementsObj.input ? $(elementsObj.input) : $('');
				var country = 'US';
	
				if ($input.data('country')) {
					// If passed an input, it needs to have a data-country attribute
					// that maps to the country select we want to interogate if we're
					// US or not.
					var countrySelectId = $input.data('country');
					country = $(countrySelectId).val();
				} else if ($form.find('[name=country]').val()) {
					// Interrogates the form to see if we have a select[name=country] 
					// to determine if US
					country = $form.find('[name=country]').val();
				} else {
					// Last resort is to use the lang ID
					if (COSTCO.util.getLangId() != -1) {
						country = 'CA';
					}
				}
	
				return country == 'US';
			},
	
			createAddressForm: function createAddressForm(obj) {
				var data;
				if (typeof obj === 'number') {
					var addressJson = address.getAddressJson(obj)[0];
					if (addressJson.length == 0) return '';
					data = addressJson[0];
				} else {
					data = obj;
				}
	
				return COSTCO.util.tmpl('tmpl_address_form', obj);
			},
			/**
	   * 
	   * Function used to setup the data and parameter to open the
	   * Address Form modal.
	   * 
	   * Param
	   * 	type		- 1 character denoting S for Shipping B for Billing
	   *  obj			- can be either address id or the address json object
	   *  orderItemId - order item id that we are trying to edit the address for
	   *  multiAddress	- whether or not the order is multiShipping address
	   * 
	   */
			editAddress: function editAddress(type, obj, orderItemId, multiAddress) {
				var data;
				if (typeof obj === 'number') {
					var addressJson = address.getAddressJson(obj, null, type)[0];
					data = addressJson;
				} else {
					data = obj;
				}
	
				if (data == null) {
					data = window['ajaxAddressObject_' + obj];
				}
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
	
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'UPDATE' });
					}
	
				if (multiAddress) {
					addressOptions.orderItemId = orderItemId;
					addressOptions.multiAddress = multiAddress;
				}
				//National delivery UX change to remove Terms and Condition Modal in Address book for BD US
				if ($('#isBDAppVar').val() == 'BD' && type == 'S' && !COSTCO.util.isNdEnabled()) {
					CAddressForm.showBusinessDeliveryQuestionnaireModal(type, data, 'edit', addressOptions);
				} else {
					CAddressForm.openAddressAddModal(type, data, 'edit', addressOptions);
				}
			},
	
			editAddress_v2: function editAddress_v2(type, obj, orderItemId, multiAddress) {
				var data;
				if (typeof obj === 'number') {
					var addressJson = address.getAddressJson(obj, null, type)[0];
					data = addressJson;
				} else {
					data = obj;
				}
	
				if (data == null) {
					data = window['ajaxAddressObject_' + obj];
				}
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
	
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'UPDATE' });
					}
	
				if (multiAddress) {
					addressOptions.orderItemId = orderItemId;
					addressOptions.multiAddress = multiAddress;
				}
	
				if ($('#isBDAppVar').val() == 'BD' && type == 'S') {
					CAddressForm.showBusinessDeliveryQuestionnaireModal_v2(type, data, 'edit', addressOptions);
				} else {
					CAddressForm.openAddressAddModal_v2(type, data, 'edit', addressOptions);
				}
			},
			/**
	   * Opens an edit address modal directly on the page (without first opening choose address modal).
	   * 
	   * This is because regularly the address batch retrieve is being invoked on the choose address modal opening
	   */
			directEditAddress: function directEditAddress(type, addressId, orderItemId, multiAddress) {
				if (typeof COSTCO.util == 'undefined' || COSTCO.util.addresses.length == 0) {
					COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function (data) {
						CAddressForm.editAddress(type, addressId, orderItemId, multiAddress);
					});
				} else {
					CAddressForm.editAddress(type, addressId, orderItemId, multiAddress);
				}
			},
	
			createNewAddress: function createNewAddress(type, orderItemId, multiAddress) {
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
				if (typeof orderItemId !== 'undefined' && orderItemId > 0) {
					addressOptions.orderItemId = orderItemId;
				}
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'ADD' });
					}
				//National delivery UX change to remove Terms and Condition Modal in Address book for BD US
				if ($('#isBDAppVar').val() == 'BD' && type == 'S' && !COSTCO.util.isNdEnabled()) {
					CAddressForm.showBusinessDeliveryQuestionnaireModal(type, undefined, 'add', addressOptions);
				} else {
					CAddressForm.openAddressAddModal(type, undefined, 'add', addressOptions);
				}
			},
	
			createNewAddress_v2: function createNewAddress_v2(type, orderItemId, multiAddress) {
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
				if (typeof orderItemId !== 'undefined' && orderItemId > 0) {
					addressOptions.orderItemId = orderItemId;
				}
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'ADD' });
					}
	
				if ($('#isBDAppVar').val() == 'BD' && type == 'S') {
					CAddressForm.showBusinessDeliveryQuestionnaireModal_v2(type, undefined, 'add', addressOptions);
				} else {
					CAddressForm.openAddressAddModal_v2(type, undefined, 'add', addressOptions);
				}
			},
	
			createInline: function createInline(selector, type, checkoutPage, multi) {
	
				var html = COSTCO.CAddressForm.createHtml(type, undefined, 'add', 'inline', checkoutPage, multi);
	
				$(selector).html(html);
	
				COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function (data) {
	
					if (data.totalRecords > 0) {
						COSTCO.CAddressForm.createChooseLink(selector, type);
					} else {
						$(selector).find('#select-saved').addClass('hide');
					}
				});
			},
	
			createInline_v2: function createInline_v2(selector, type, checkoutPage, multi, smsNotificationData) {
				var html;
				if (typeof smsNotificationData !== 'undefined') {
					html = COSTCO.CAddressForm.createHtml_v2(type, undefined, 'add', 'inline', checkoutPage, multi, null, smsNotificationData);
				} else {
					html = COSTCO.CAddressForm.createHtml_v2(type, undefined, 'add', 'inline', checkoutPage, multi);
				}
	
				$(selector).html(html);
	
				COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function (data) {
	
					if (data.totalRecords > 0) {
						COSTCO.CAddressForm.createChooseLink(selector, type);
					} else {
						$(selector).find('#select-saved').addClass('hide');
					}
				});
	
				var isPreventSameAddressEnabled = $('input[name="isPreventSameAddressEnabled"]');
	
				if (isPreventSameAddressEnabled.length > 0 && isPreventSameAddressEnabled.val()) {
					$('body').unbind("costco.address.error").bind("costco.address.error", function (event, error) {
						if (typeof error != 'undefined') {
							if (error == '_ERR_INVALID_SHIP_ADDR') {
								COSTCO.CAddress.closeModal();
								$('#notification-message').html(messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR).addClass('critical-notification');
								var formId = $('#address-modal-inline');
								var addressField = '#S_address1Id';
								COSTCO.dialog.sameAddressValidation(formId, addressField);
							}
						}
					});
				}
			},
	
			createChooseLink: function createChooseLink(selector, type) {
	
				var chooseLink = "<a href=\"javascript:void(0)\" onclick=\"COSTCO.CAddressSelectionDialog.showAddressSelectionDialog(null,'{0}');return false;\">{1}</a>";
	
				var html = COSTCO.util.messageFormat(chooseLink, type, addressInputLabels.choosesaved);
	
				$(selector).find('#select-saved div').html(html);
			},
	
			insertSmsNotificationAgreement: function insertSmsNotificationAgreement(orderId, orderSmsPhone) {
	
				var check = orderSmsPhone.length > 0 ? 'checked' : '';
				if (orderSmsPhone.length == 10) {
					// Insert '-' to avoid onchange event fired on tab and other keys which don't change input field value. 
					var formatted = orderSmsPhone.substr(0, 3) + '-' + orderSmsPhone.substr(3, 3) + '-' + orderSmsPhone.substr(6, 4);
					orderSmsPhone = formatted;
				}
				var hide = orderSmsPhone.length > 0 ? '' : 'hidden';
				var data = {
					orderId: orderId,
					smsPhone: orderSmsPhone,
					check: check,
					hide: hide
				};
				var template = COSTCO.util.tmpl('tmpl_sms_notification_agreement_block', data);
				$('.smsNotificationBlock').html(template);
			},
	
			insertSmsNotificationAgreement_v2: function insertSmsNotificationAgreement_v2(arg, smsPhoneNumber, updateAction, checkCheckbox) {
				var check = smsPhoneNumber.length > 0 ? 'checked' : '';
				if (smsPhoneNumber.length == 10) {
					// Insert '-' to avoid onchange event fired on tab and other keys which don't change input field value. 
					var formatted = smsPhoneNumber.substr(0, 3) + '-' + smsPhoneNumber.substr(3, 3) + '-' + orderSmsPhone.substr(6, 4);
					smsPhoneNumber = formatted;
				}
				var hide = smsPhoneNumber.length > 0 ? '' : 'hidden';
				var data = {
					arg: arg,
					smsPhoneNumber: smsPhoneNumber,
					updateAction: updateAction,
					checkCheckbox: checkCheckbox,
					hide: hide
				};
				var template = COSTCO.util.tmpl('tmpl_sms_notification_agreement_block_v2', data);
				$('.smsNotificationBlock').html(template);
			},
	
			createHtml: function createHtml(type, addressObj, mode, modaltypeOverride, checkoutPage, multi, error) {
	
				var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	
				var stateProvList = address.getStateProvJson();
				COSTCO.CAddressForm.addressVal = stateProvList;
				var stateOptions = CAddressForm.getStateOptions(stateProvList, type, addressObj);
				var countryOptions = CAddressForm.getCountryOptions(type);
	
				var data = addressInputLabels;
	
				var headerLabels = address.getHeaderLabels(type, mode);
	
				data.primaryMessage = headerLabels.primaryMessage;
				var modaltype = 'modal';
				if (typeof modaltypeOverride !== 'undefined') {
					modaltype = modaltypeOverride;
				}
	
				var template = COSTCO.util.tmpl('tmpl_address_form_' + modaltype, data);
				template = $(template);
	
				if (!isDeriveCityStateEnabled) {
					template.find('.stateprov-select').append(stateOptions);
				}
	
				template.find('.country-select').append(countryOptions).change(function () {
	
					var country = $(this).val();
					var stateOptions = CAddressForm.getStateOptions(stateProvList, type, { country: country });
					if (!isDeriveCityStateEnabled) {
						template.find('.stateprov-select').empty().append(stateOptions);
					}
					updateCountryLabels(country);
					CAddressForm.maskInput(template);
				});
	
				if (typeof error != 'undefined') {
					if (error == '_ERR_INVALID_SHIP_ADDR') {
						template.append('<input type="hidden" name="invalid-ship-addr" value="true" />');
					} else {
						template.find('.error').html(error);
					}
				}
	
				var updateCountryLabels = function updateCountryLabels(country) {
					if (country == 'US') {
						template.find('label[for="postalId"]').html(data.uspostallabel);
						template.find('label[for="stateId"]').html(data.usstatelabel);
					} else {
						template.find('label[for="postalId"]').html(data.capostallabel);
						template.find('label[for="stateId"]').html(data.castatelabel);
					}
				};
	
				if (addressObj) {
					updateCountryLabels(addressObj.country);
				}
	
				template.find('[name=postal]').on('input', { modaltype: modaltype }, function (event) {
					var value = $(this).val();
					var region = COSTCO.util.isUsOrCaZipCode();
					if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
						COSTCO.CAddress.bingCityState(this, '[name=city]', '[name=state]');
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
					if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
						if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
							COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
						}
						if (!region) {
							if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
						}
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
				});
	
				if (type == 'B') {
					template.find('#country-row').removeClass('hide');
				}
				if (mode == 'add') {
					template.find('[name=email]').val($('#defaultEmail').val());
				}
				if (type == 'S') {
					template.find('#delIntsr-row').removeClass('hide');
					template.find('#contactName').removeClass('ignoreHide');
					template.find('#contactPhNo').removeClass('ignoreHide');
				}
	
				if (mode == 'edit') {
					template.find('.address-checkboxes').hide();
					if (addressObj.isPrimary == '1' && type == 'S') {
						template.find(".defaultWarning").removeClass('hide');
					} else {
						template.find(".defaultWarning").addClass('hide');
					}
				}
	
				/*
	    * Show the default shipping warning
	    */
	
				var updateWarning = function updateWarning(modaltype) {
	
					if (template.find('#set-default-' + modaltype).prop('checked')) {
						template.find(".defaultWarning").removeClass('hide');
					} else {
						template.find(".defaultWarning").addClass('hide');
					}
				};
	
				if (mode == 'add') {
					if (type == 'S') {
	
						/* Below click binding function was added to the set-default checkbox to toggle setAsDefaultShippingAddress hidden field 
	      * on the page. This hidden field has to change based on the checkbox status so that page submit reads the right value to
	      * set on IsPrimary field of address record. */
						template.find('#set-default-' + modaltype).bind("click", function () {
							if ($('#set-default-' + modaltype).is(':checked')) {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('true');
							} else {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('false');
							}
						});
	
						template.find('#set-default-' + modaltype).click(function () {
							updateWarning(modaltype);
						});
					}
	
					var detectedCheckoutPage = typeof checkoutPage !== 'undefined' ? checkoutPage : window.checkoutPage;
	
					if (detectedCheckoutPage === 'shipping' || detectedCheckoutPage === 'multi-shipping' || detectedCheckoutPage === 'payment') {
						template.find('#set-default-' + modaltype).prop('checked', modaltype === 'inline');
					} else if (detectedCheckoutPage === 'review' || detectedCheckoutPage === 'live-tickets') {
						template.find('#set-default-' + modaltype).prop('checked', false);
					}
					updateWarning(modaltype);
				}
	
				template.find('#set-default-' + modaltype).click(function () {
					if ($(this).prop('checked')) {
						template.find('#save-address-' + modaltype).prop('checked', true);
					}
					if (checkoutPage == 'shipping') {
						updateWarning(modaltype);
					}
				});
	
				template.find('#save-address-' + modaltype).click(function () {
					if (!$(this).prop('checked')) {
						$('#set-default-' + modaltype).prop('checked', false);
					}
					if (checkoutPage == 'shipping') {
						updateWarning(modaltype);
					}
				});
	
				if (typeof addressObj !== 'undefined') {
					CAddressForm.populateAddressModal(template, addressObj, modaltype);
				} else {
					template.find('[name=addressType]').val(type);
				}
	
				if ((checkoutPage === 'payment' || checkoutPage === 'review' || checkoutPage === 'live-tickets') && type == 'B' && modaltype == 'inline') {
					template.find('#address-same-as-ship').removeClass('hide');
				}
	
				if (type == 'B') {
					template.find(".defaultWarning").addClass('hide');
				}
	
				CAddressForm.maskInput(template);
	
				return template;
			},
			// returns id of matching template element, or null
			findTemplateId_v2: function findTemplateId_v2(type, templateName, modalType) {
				var result = null;
				modalType = modalType == null || modalType == undefined || modalType == '' ? '' : '_' + modalType;
				var template = $('#tmpl_' + type + '_' + templateName + modalType + '_v2');
				if (template.length == 0) {
					// look for template with the "_gift" suffix
					template = $('#tmpl_' + type + '_' + templateName + modalType + '_gift_v2');
				}
				if (template.length == 0) {
					var orderItemInputs = $('input[name^="orderItem_"]');
					for (var i = 0; i < orderItemInputs.length && template.length == 0; i++) {
						var orderItemId = orderItemInputs.get(i).value;
						// look for template with the orderItemId
						template = $('#tmpl_' + type + '_' + templateName + modalType + ('_' + orderItemId) + '_v2');
						if (template.length == 0) {
							// look for template with the orderItemId and the "_gift" suffix
							template = $('#tmpl_' + type + '_' + templateName + modalType + ('_' + orderItemId) + '_gift_v2');
						}
					}
				}
				if (template.length == 1) {
					result = template.attr('id');
				}
				return result;
			},
	
			createHtml_v2: function createHtml_v2(type, addressObj, mode, modaltypeOverride, checkoutPage, multi, error, smsNotificationData) {
	
				var stateProvList = address.getStateProvJson();
	
				var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	
				var stateOptions = CAddressForm.getStateOptions(stateProvList, type, addressObj);
				var countryOptions = CAddressForm.getCountryOptions(type);
	
				var addrType = typeof addressObj == 'undefined' ? type : addressObj.addressType;
	
				var data = addressInputLabels;
				if (typeof smsNotificationData !== 'undefined') {
					data.smsNotificationData = smsNotificationData;
					data.showSMSNotificationCheckbox = true;
				} else {
					data.smsNotificationData = {};
					data.showSMSNotificationCheckbox = false;
				}
				var headerLabels = address.getHeaderLabels(type, mode);
	
				data.primaryMessage = headerLabels.primaryMessage;
	
				var modaltype = 'modal';
				if (typeof modaltypeOverride !== 'undefined') {
					modaltype = modaltypeOverride;
				}
	
				var templateId = CAddressForm.findTemplateId_v2(type, 'address_form', modaltype);
				var template = COSTCO.util.tmpl(templateId, data);
	
				template = $(template);
				if (!data.showSMSNotificationCheckbox) {
					template.find('#smsNotificationCheckBox').remove();
				}
	
				if (!isDeriveCityStateEnabled) {
					template.find('.stateprov-select').append(stateOptions);
				}
	
				template.find('.country-select').append(countryOptions).change(function () {
	
					var country = $(this).val();
					var stateOptions = CAddressForm.getStateOptions(stateProvList, type, { country: country });
					if (!isDeriveCityStateEnabled) {
						template.find('.stateprov-select').empty().append(stateOptions);
					}
					template.find('#city-state').addClass('hide');
					template.find('input[id=' + addrType + '_postalId]').val('');
					template.find('label[for=' + addrType + '_postalId]').removeClass('active');
					updateCountryLabels(country);
					CAddressForm.maskInput(template);
				});
	
				if (typeof error != 'undefined') {
					if (error == '_ERR_INVALID_SHIP_ADDR') {
						template.append('<input type="hidden" name="invalid-ship-addr" value="true" />');
						template.find('.error').html(messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR).addClass('critical-notification cds-u-space-mb-md');
					} else {
						template.find('.error').html(error);
					}
				}
	
				var updateCountryLabels = function updateCountryLabels(country) {
					if (country == 'US') {
						template.find('label[for="' + addrType + '_postalId"]').html(data.uspostallabel);
						template.find('label[for="' + addrType + '_stateId"]').html(data.usstatelabel);
						template.find('label[id="zip-info-text"]').html(data.usZipInfoText);
					} else {
						template.find('label[for="' + addrType + '_postalId"]').html(data.capostallabel);
						template.find('label[for="' + addrType + '_stateId"]').html(data.castatelabel);
						template.find('label[id="zip-info-text"]').html(data.caZipInfoText);
					}
				};
	
				if (addressObj) {
					updateCountryLabels(addressObj.country);
				}
	
				template.find('[name=postal]').on('input', { modaltype: modaltype }, function (event) {
					var value = $(this).val();
					var region = COSTCO.util.isUsOrCaZipCode();
					if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
						COSTCO.CAddress.bingCityState(this, '[name=city]', '[name=state]');
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
					if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
						if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
							COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
						}
						if (!region) {
							if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) {
								COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
							}
						}
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
				});
				if (type == 'B') {
					template.find('#country-row').removeClass('hide');
				}
				if (mode == 'add') {
					template.find('[name=email]').val($('#defaultEmail').val());
				}
				if (type == 'S') {
					template.find('#delIntsr-row').removeClass('hide');
					template.find('#contactName').removeClass('ignoreHide');
					template.find('#contactPhNo').removeClass('ignoreHide');
					$('#contact-information-phone').css('padding-left', '0');
				}
	
				if (mode == 'edit') {
					if (addressObj.addressType !== 'T') {
						template.find('#save-to-address-book').hide();
					}
					if (addressObj.isPrimary == '1') {
						template.find('#set-default-address').hide();
					}
					if (addressObj.isPrimary == '1' && type === 'S') {
						template.find(".defaultWarning").show();
					} else {
						template.find(".defaultWarning").hide();
					}
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
						if (template.find('#save-to-address-book').is(':hidden') === true && template.find('#set-default-address').is(':hidden') === true) {
							template.find('.checkbox-separator').addClass('hide');
						}
					}
				}
	
				/*
	    * Show the default shipping warning
	    */
	
				var updateWarning = function updateWarning(modaltype) {
	
					if (template.find('#set-default-' + modaltype).prop('checked')) {
						template.find(".defaultWarning").removeClass('hide');
					} else {
						template.find(".defaultWarning").addClass('hide');
					}
				};
	
				if (mode == 'add') {
					if (type == 'S') {
	
						/* Below click binding function was added to the set-default checkbox to toggle setAsDefaultShippingAddress hidden field 
	      * on the page. This hidden field has to change based on the checkbox status so that page submit reads the right value to
	      * set on IsPrimary field of address record. */
						template.find('#set-default-' + modaltype).bind("click", function () {
							if ($('#set-default-' + modaltype).is(':checked')) {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('true');
							} else {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('false');
							}
						});
	
						template.find('#set-default-' + modaltype).click(function () {
							updateWarning(modaltype);
						});
					}
	
					var detectedCheckoutPage = typeof checkoutPage !== 'undefined' ? checkoutPage : window.checkoutPage;
	
					if (detectedCheckoutPage === 'multi-shipping') {
						template.find('#set-default-' + modaltype).prop('checked', modaltype === 'inline');
					} else if (detectedCheckoutPage === 'review') {
						template.find('#set-default-' + modaltype).prop('checked', false);
					}
					updateWarning(modaltype);
				}
	
				template.find('#set-default-' + modaltype).click(function () {
					if ($(this).prop('checked')) {
						template.find('#save-address-' + modaltype).prop('checked', true);
						$('#set-default-' + modaltype).prop('value', true);
						$('.defaultWarning.kb-OOS-banner').show();
					} else {
						$('#set-default-' + modaltype).prop('value', false);
						$('.defaultWarning.kb-OOS-banner').hide();
					}
				});
	
				template.find('#save-address-' + modaltype).click(function () {
					if (!$(this).prop('checked')) {
						$('#set-default-' + modaltype).prop('checked', false);
						$('.defaultWarning.kb-OOS-banner').hide();
					}
					if (checkoutPage == 'shipping') {
						updateWarning(modaltype);
					}
				});
	
				if (typeof addressObj !== 'undefined') {
					CAddressForm.populateAddressModal_v2(template, addressObj, modaltype);
				} else {
					template.find('[name=addressType]').val(type);
				}
	
				if (type === 'B' && modaltype === 'inline') {
					template.find('#address-same-as-ship').removeClass('hide');
				}
	
				if (type == 'B') {
					template.find(".defaultWarning").addClass('hide');
				}
	
				CAddressForm.maskInput(template);
	
				//SFSTRY0015679 make company name mandatory in USBD for Local Business Delivery
				var isLocalBusinessDelivery = typeof shipModeLocalND !== 'undefined' && ($("input[name='deliveryMethod']:checked").val() == shipModeLocalND || $("input[name='deliveryMethod']:checked").val() == shipModeLocal);
				if ($('#isBDAppVar').val() === 'BD') {
					//SFSTRY0020930 - check if xapp flag for company name mandate is enabled
					var isCompanyMandateEnabled = $("#isCompanyMandateEnabled").val();
					if (wcs.storeId === '11303' || wcs.storeId === '11301' && isLocalBusinessDelivery && isCompanyMandateEnabled === "true") {
						$(template).find('[name=company]').parent().parent().removeClass('hide');
						$(template).find('#showCompanyField').parent().addClass('hide');
					}
				}
	
				return template;
			},
	
			populateAddressModal: function populateAddressModal(template, addressObject, modaltype) {
	
				template.find('[name=addressId]').val(addressObject['id']);
				template.find('#firstId').val(addressObject['first']);
				template.find('#lastId').val(addressObject['last']);
				var companyName = COSTCO.util.get_decoded_html(addressObject['company']);
				if (companyName != undefined && companyName != "undefined" && companyName != "") {
					template.find('#companyId').val(companyName);
				} else {
					template.find('#companyId').val("");
				}
				template.find('[name=country]').val(addressObject['country']);
				template.find('[name=address1]').val(addressObject['line1']);
				template.find('[name=address2]').val(addressObject['line2']);
				template.find('[name=postal]').val(addressObject['zip']);
	
				if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
					var editAddrCity = addressObject['city'];
					var editAddrState = addressObject['state'];
					var postalField = template.find('[name=postal]');
					COSTCO.CAddress.geocodeApiCityState(postalField, '[name=city]', '[name=state]', editAddrCity, editAddrState);
				} else {
					template.find('[name=city]').val(addressObject['city']);
					template.find('[name=state]').val(addressObject['state']);
					template.find('#city-state').removeClass('hide');
				}
	
				if (addressObject['phone'] != undefined && addressObject['phone'] != "") {
					if ($('#isBDAppVar').val() == 'BD') {
						template.find('#phoneId').val(addressObject['phone'].split(/EXT.|x/g)[0]);
						var extension = addressObject['phone'].split(/EXT.|x/g)[1];
						if (extension) {
							template.find('[name=ext1]').val(extension.trim());
						}
					} else {
						template.find('#phoneId').val(addressObject['phone'].split('x')[0]);
						template.find('[name=ext1]').val(addressObject['phone'].split('x')[1]);
					}
				} else {
					template.find('#phoneId').val(addressObject['phone']);
					template.find('[name=ext1]').val(addressObject['phone']);
				}
				template.find('[name=nickname]').val(addressObject['nickname']);
				template.find('[name=email]').val(addressObject['email']);
				template.find('[name=addressType]').val(addressObject.addressType);
				template.find('[name=addressId]').val(addressObject.id);
				if (addressObject['deliveryInstructions']) {
					var deliveryInst = COSTCO.util.get_decoded_html(addressObject['deliveryInstructions']);
				} else if (addressObject['deliveryInst']) {
					var deliveryInst = COSTCO.util.get_decoded_html(addressObject['deliveryInst']);
				}
				template.find('[name=deliveryInstructions]').val(deliveryInst);
				template.find('[name=contactName]').val(addressObject['contactName']);
				template.find('[name=contactPhone]').val(addressObject['contactPhNo']);
	
				if (addressObject.addressType != 'T') {
					template.find('#save-address-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary == '1') {
					template.find('#set-default-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary === '1' && addressObject.addressType === 'S' && typeof checkoutPage !== 'undefined' && checkoutPage === 'shipping') {
					template.find('.defaultWarning').removeClass('hide');
				}
				$(template).find('#phoneId').unmask().mask('000-000-0000');
			},
	
			populateAddressModal_v2: function populateAddressModal_v2(template, addressObject, modaltype) {
	
				template.find('[name=addressId]').val(addressObject['id']);
	
				template.find('[name=firstModal]').val(addressObject['first']);
				template.find('label[for="' + addressObject.addressType + '_firstId"]').addClass('active');
	
				template.find('[name=lastModal]').val(addressObject['last']);
				template.find('label[for="' + addressObject.addressType + '_lastId"]').addClass('active');
	
				var companyName = COSTCO.util.get_decoded_html(addressObject['company']);
				if (companyName !== undefined && companyName !== "undefined" && companyName !== "") {
					template.find('#' + addressObject.addressType + '_companyId').val(companyName);
					template.find('label[for="' + addressObject.addressType + '_companyId"]').addClass('active');
					COSTCO.CAddressForm.showInputFiled(template.find('#showCompanyField'));
				} else {
					template.find('#' + addressObject.addressType + '_companyId').val('');
				}
				template.find('[name=country]').val(addressObject['country']);
				template.find('label[for="' + addressObject.addressType + '_countryId"]').addClass('active');
	
				template.find('[name=address1]').val(addressObject['line1']);
				template.find('label[for="' + addressObject.addressType + '_address1Id"]').addClass('active');
	
				if (addressObject['line2'] !== undefined && addressObject['line2'] !== "undefined" && addressObject['line2'] !== "") {
					template.find('[name=address2]').val(addressObject['line2']);
					template.find('label[for="' + addressObject.addressType + '_address2Id"]').addClass('active');
					COSTCO.CAddressForm.showInputFiled(template.find('#showAptField'));
				} else {
					template.find('[name=address2]').val('');
				}
	
				template.find('[name=postal]').val(addressObject['zip']);
				template.find('label[for="' + addressObject.addressType + '_postalId"]').addClass('active');
	
				if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
					var editAddrCity = addressObject['city'];
					var editAddrState = addressObject['state'];
					var postalField = template.find('[name=postal]');
					COSTCO.CAddress.geocodeApiCityState(postalField, '[name=city]', '[name=state]', editAddrCity, editAddrState);
				} else {
					template.find('[name=city]').val(addressObject['city']);
					template.find('[name=state]').val(addressObject['state']);
				}
	
				template.find('label[for="' + addressObject.addressType + '_cityId"]').addClass('active');
				template.find('label[for="' + addressObject.addressType + '_stateId"]').addClass('active');
	
				template.find('#city-state').removeClass('hide');
	
				if (addressObject['phone'] != undefined && addressObject['phone'] != "") {
					if ($('#isBDAppVar').val() == 'BD') {
						template.find('[name=phone]').val(addressObject['phone'].split(/EXT.|x/g)[0]);
						template.find('label[for="' + addressObject.addressType + '_phoneId"]').addClass('active');
						var extension = addressObject['phone'].split(/EXT.|x/g)[1];
						if (extension) {
							template.find('[name=ext1]').val(extension.trim());
							template.find('label[for="ext1"]').addClass('active');
						}
					} else {
						template.find('[name=phone]').val(addressObject['phone'].split('x')[0]);
						template.find('label[for="' + addressObject.addressType + '_phoneId"]').addClass('active');
						template.find('[name=ext1]').val(addressObject['phone'].split('x')[1]);
					}
				} else {
					template.find('[name=phone]').val(addressObject['phone']);
					template.find('[name=ext1]').val(addressObject['phone']);
				}
				template.find('[name=nickname]').val(addressObject['nickname']);
	
				template.find('[name=email]').val(addressObject['email']);
				template.find('label[for="' + addressObject.addressType + '_emailId"]').addClass('active');
	
				template.find('[name=addressType]').val(addressObject.addressType);
				template.find('[name=addressId]').val(addressObject.id);
				template.find('[name=deliveryInstructions]').val(addressObject['deliveryInstructions']);
				if (addressObject['deliveryInstructions'] != undefined && addressObject['deliveryInstructions'].length > 0) {
					template.find('label[for=deliveryInstructions-modal]').addClass('active');
				}
				template.find('[name=contactName]').val(addressObject['contactName']);
				if (addressObject['contactName'] != undefined && addressObject['contactName'].length > 0) {
					template.find('label[for=contactName]').addClass('active');
				}
				template.find('[name=contactPhone]').val(addressObject['contactPhNo']);
				if (addressObject['contactPhNo'] != undefined && addressObject['contactPhNo'].length > 0) {
					template.find('label[for=contactPhNo]').addClass('active');
				}
	
				if (addressObject.addressType != 'T') {
					template.find('#save-address-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary == '1') {
					template.find('#set-default-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary === '1' && addressObject.addressType === 'S' && typeof checkoutPage !== 'undefined' && checkoutPage === 'shipping') {
					template.find('.defaultWarning').removeClass('hide');
				}
	
				if (addressObject === '') {
					COSTCO.CAddressForm.restoreLabelsAndHiddenFieldsForEmptyAddressObject(template);
				}
				template.find('#' + addressObject.addressType + '_phoneId').unmask().mask('000-000-0000');
	
				if (template.find('#phoneId').length > 0) {
					$(template).find('#phoneId').unmask().mask('000-000-0000');
				}
			},
	
			restoreLabelsAndHiddenFieldsForEmptyAddressObject: function restoreLabelsAndHiddenFieldsForEmptyAddressObject(template) {
				template.find('#city-state').addClass('hide');
				template.find('label').each(function () {
					if ($(this).hasClass("active")) {
						$(this).removeClass("active");
					}
				});
				COSTCO.CAddressForm.hideInputFiled(template.find('#showAptField'));
				COSTCO.CAddressForm.hideInputFiled(template.find('#showCompanyField'));
			},
	
			/**
	   * function that populates address form with given address
	   * @param input
	   * 			input address form that needs to be populated
	   * @param addressId
	   * 			address that will be populated in address form
	   * @param modaltype
	   * 			param that determines if form is modal or inline
	   */
			populateAddressFormWithAddressData: function populateAddressFormWithAddressData(input, addressId, modaltype) {
	
				var data = '';
				if (input.checked && addressId !== '') {
					data = window['ajaxAddressObject_' + addressId];
					delete data['id'];
					delete data['nickname'];
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === false) {
						data.isPrimary = '1';
					}
				}
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
					// Add right prefix for address form input ids
					data.addressType = $(input).get(0).name === "same-as-billing" ? 'S' : 'B';
					CAddressForm.populateAddressModal_v2($(input.form), data, modaltype);
				} else {
					CAddressForm.populateAddressModal($(input.form), data, modaltype);
				}
			},
			addressNotServicedModal: function addressNotServicedModal(verifiedAddress, cancelFn, submitFn, message) {
				// Workaround for undefined verifiedAddress 
				var addressObject = {
					addressNotServicedMsg1: messages.ERR_MODAL_ADDRESS_NOT_SERVICED,
					firstName: '',
					lastName: '',
					address1: '',
					city: '',
					state: '',
					zip: '',
					addressNotServicedMsg2: messages.MODAL_ADDRESS_NOT_SERVICED
				};
				if (typeof verifiedAddress !== 'undefined') {
					addressObject = {
						addressNotServicedMsg1: messages.ERR_MODAL_ADDRESS_NOT_SERVICED,
						firstName: verifiedAddress.first,
						lastName: verifiedAddress.last,
						address1: verifiedAddress.line1,
						city: verifiedAddress.city,
						state: verifiedAddress.state,
						zip: verifiedAddress.zip,
						addressNotServicedMsg2: messages.MODAL_ADDRESS_NOT_SERVICED
					};
				}
				if (COSTCO.util.isNdEnabled()) {
					var modalAddressNotServicedForResidentialMessage = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true ? messages.MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL_v2 : messages.MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL;
					if (message != null && message == "residentialNotServiced") {
						addressObject.addressNotServicedMsg1 = messages.ERR_MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL;
						addressObject.addressNotServicedMsg2 = modalAddressNotServicedForResidentialMessage;
					} else {
						addressObject.addressNotServicedMsg1 = messages.ERR_MODAL_ADDRESS_NOT_SERVICED_CART_MERGE;
						addressObject.addressNotServicedMsg2 = messages.MODAL_ADDRESS_NOT_SERVICED_CART_MERGE;
					}
					addressObject.address2 = verifiedAddress.line2;
				}
				var template = COSTCO.util.tmpl('tmpl_address_not_serviced_modal', addressObject);
				address.baseModal('S', 'addrnotserviced', {
					title: messages.MODAL_ADDRESS_NOT_SERVICED_TITLE,
					body: template,
					primary: messages.ADDRESS_NOT_SERVICED_SHOP,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (submitFn) {
							submitFn();
						} else {
							COSTCO.dialog.close();
						}
					},
					secondary_event: function secondary_event() {
						if (cancelFn) {
							cancelFn();
						} else {
							COSTCO.dialog.close();
						}
					}
				});
			},
	
			openAddressAddModal: function openAddressAddModal(type, addressObj, mode, addressOptions) {
				var openAddress = function openAddress(error) {
					var htmlBody = CAddressForm.createHtml(type, addressObj, mode, undefined, undefined, undefined, error);
					// if it is edit mode, trigger jQuery validation immediately
					if (mode == "edit") {
						CAddressForm.validate(type, htmlBody);
					}
					var validateAddressTypeModal = [];
					if (addressObj != undefined) {
						validateAddressTypeModal[0] = addressObj.line1;
						validateAddressTypeModal[1] = addressObj.zip;
						validateAddressTypeModal[2] = addressObj.city;
						if (addressObj.userAddressType != 'U') {
							validateAddressTypeModal[3] = addressObj.userAddressType;
						}
					}
					addressOptions.validateParams = validateAddressTypeModal;
					address.baseModal(type, mode, {
						body: htmlBody,
						primary_event: function primary_event() {
							if (CAddressForm.validate(type)) {
								var addressEnteredForCheck = $('#addressEnteredForCheck');
								var address1 = $('FORM[id="address-modal-modal"]').find("#address1Id").val();
								if (!addressEnteredForCheck.length) {
									addressEnteredForCheck = $('<INPUT TYPE="hidden" ID="addressEnteredForCheck" />').appendTo(document.body);
								}
								addressEnteredForCheck.val(address1);
								CAddressForm.submit(type, false, addressOptions);
							}
						},
						onshown: function onshown() {
							if (addressOptions.setAsDefaultAddress) {
								$('#set-default').val('true').attr('checked', true);
							} else {
								$('#set-default').val('false').attr('checked', false);
							}
							var invalidShipAddr = $('input[name=invalid-ship-addr]');
							if (invalidShipAddr.length > 0 && invalidShipAddr.val() === 'true') {
								var formId = $('#address-modal-modal');
								var addressField = '#address1Id';
								COSTCO.dialog.sameAddressValidation(formId, addressField);
							}
						}
					});
				};
				openAddress(undefined);
	
				$('body').unbind("costco.address.error").bind("costco.address.error", function (event, error) {
					openAddress(error);
				});
			},
	
			openAddressAddModal_v2: function openAddressAddModal_v2(type, addressObj, mode, addressOptions) {
				var openAddress = function openAddress(error) {
					var htmlBody = CAddressForm.createHtml_v2(type, addressObj, mode, undefined, undefined, undefined, error);
					if (mode == "edit") {
						CAddressForm.validate(type, htmlBody);
					}
					address.baseModal(type, mode, {
						body: htmlBody,
						primary_event: function primary_event() {
	
							if (CAddressForm.validate(type)) {
								CAddressForm.submit(type, false, addressOptions);
							}
						},
						onshown: function onshown() {
							if ($('input[name=invalid-ship-addr]').length > 0 && $('input[name=invalid-ship-addr]').val() === 'true') {
								var formId = $('#address-modal-modal');
								var addressField = '#S_address1Id';
								COSTCO.dialog.sameAddressValidation(formId, addressField);
							}
						}
					});
				};
				openAddress(undefined);
	
				$('body').unbind("costco.address.error").bind("costco.address.error", function (event, error) {
					openAddress(error);
				});
			},
	
			/**This function checks if the address line has reached max length, and if that is the case shows friendly message
	   * 
	   * Param 
	   * data:	data from children's element 
	   */
			validateAddressLineLength: function validateAddressLineLength(data) {
				var maxLength = 30;
				var errorElement = document.getElementById("address-error-message-" + data.id);
				if (data.value.length === maxLength) {
					//check if errorElement has error class
					if ($(errorElement).hasClass("hide")) {
						$(errorElement).removeClass("hide");
					}
				} else {
					$(errorElement).addClass("hide");
				}
			},
			submit: function submit(type, preventHtmlReload, addressOptions) {
				var addressArray = CAddressForm.buildAddressArray(type);
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
				if ($('#isBDAppVar').val() == 'BD' && type == 'S') {
					var page = $('div#address').data('page') || '';
	
					if (!COSTCO.CAddressForm.isFormCompleted('S') && !(page === 'Home,MyAccount,AccountAddressBook') && !COSTCO.util.isNdEnabled()) {
						CAddressForm.showBDQuestionnaireModalForInlineForm(type, preventHtmlReload, addressOptions, addressArray);
					} else {
						addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
						addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
					}
				} else {
					// BEGIN
					// NOTE: Below code is introduced with following commit/fix:
					// Grocery- Defect Fix 9968 Change-Id: Ifdb9bcbc501a5abc9c95733eeffe5140cd7ac55b
					//
					// We probably do not need it any more.
					// If encountering issues, please contact developer
					// 
					// if(typeof orderItemId != 'undefined'){
					// 	if(typeof(orderItemId) == 'number'){
	
					// 		addressOptions.orderItemId=orderItemId;
					// 	}
					// 	else{
					//  	addressOptions.orderItemId=orderItemId.orderItemId;
	
					// 	}
					// }
					// else{
					// 	addressOptions.orderItemId='';
					// }
					// END
					addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
	
					addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
				}
			},
			/**
	   * Callback function for address form, on completed address verification service call
	   * @param {}
	   */
			addressVerifiedCallback: function addressVerifiedCallback(addressObj, type, preventajaxhtml, addressOptions) {
	
				if (typeof addressObj !== 'undefined' && addressObj != null && addressObj.Validated_Address != undefined && addressObj.Validated_Address != null) {
					if (addressObj.errorMessage != null && addressObj.errorMessage.length > 0) {
						$('.address-text-error').text(addressObj.errorMessage);
					} else if (addressObj.Validated_Address[0].result == 'ADDRESS_SUGGESTION_AVAILABLE' || addressObj.Validated_Address[0].result == 'ADDRESS_WRONG_NO_SUGGESTION' || addressObj.Validated_Address[0].result == 'ADDRESS_CORRECT_NO_SUGGESTION') {
						var additionalBillingStates = CAddressForm.getAdditionalBillingStates();
						if (addressObj.Validated_Address[0].result == 'ADDRESS_SUGGESTION_AVAILABLE' && additionalBillingStates.includes(addressObj.Validated_Address[0].state) && type == 'S') {
							// SFSTRY0038578: Do not suggest address from unsupported territories for shipping address
							addressObj.Validated_Address[0].result = 'ADDRESS_WRONG_NO_SUGGESTION';
						}
						if (addressVerification.isSuggestedSameAsEntered(addressObj)) {
							var validatedAddress = addressVerification.extractValidatedAddress(addressObj, type);
							COSTCO.CAddressVerification.entered = validatedAddress;
							addressVerification.useAddress(preventajaxhtml, addressOptions);
							//address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
						} else {
							addressVerification.showAddressVerificationModal(addressObj, preventajaxhtml, addressOptions);
						}
					} else if (addressObj.Validated_Address[0].result == 'ADDRESS_SERVICE_UNAVAILABLE') {
						var validatedAddress = addressObj.Validated_Address[0];
						address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
					} else {
						var validatedAddress = addressVerification.extractValidatedAddress(addressObj, type);
						address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
					}
				} else {
					if (addressObj.errorMessageParam != null && addressObj.errorMessageParam.length > 0) {
						elementObj = $('[name=' + addressObj.errorMessageParam[0] + ']');
	
						if (elementObj.length > 0) {
	
							elementObj.parent().addClass('error');
							elementObj.attr('hasvalidationerror', true);
							elementObj.attr('firstNameValidation', true);
							elementObj.attr('lastNameValidation', true);
							COSTCO.CAddressForm.getForm().valid();
						}
					} else if (addressObj.errorMessage != null && addressObj.errorMessage.length > 0) {
						if ($('#address-modal-inline').length > 0) {
							COSTCO.CAddress.closeModal();
						}
						$('.address-text-error').text(addressObj.errorMessage);
					}
				}
			},
	
			getAdditionalBillingStates: function getAdditionalBillingStates() {
				var states = [];
				var territories = $('#additional_Billling_Territories').val();
				if (territories !== null && territories !== undefined && territories !== "") {
					var codeAndDisplayNameOfTerritories = territories.split('|');
					if (codeAndDisplayNameOfTerritories.length !== 0) {
						$.each(codeAndDisplayNameOfTerritories, function (index, codeAndDisplayName) {
							var code = codeAndDisplayName.split(':')[0];
							if (code !== null && code !== undefined && code !== "") {
								var displayName = codeAndDisplayName.split(':')[1];
								if (displayName !== null && displayName !== undefined && displayName !== "") {
									var state = { code: code, displayName: displayName };
									states.push(state);
								}
							}
						});
						return states.map(function (state) {
							return state.code;
						});
					}
				}
				return states;
			},
	
			getStateOptions: function getStateOptions(stateProvList, type, address) {
				var locale = 'en-US';
				locale = COSTCO.util.getLocale();
	
				var defaultCountry = locale.split('-')[1];
				var additionalBillingStatesCode = CAddressForm.getAdditionalBillingStates();
	
				$('#state').on('change', function () {
					CAddressForm.hideCheckboxForAdditionalTerritories(this.value, additionalBillingStatesCode);
				});
	
				if (type == 'S') {
					var _states = CAddressForm.getStates(stateProvList, defaultCountry);
					var filterOutStates = [].concat(_toConsumableArray(additionalBillingStatesCode), ['VI']);
					var filteredStates = _states.filter(function (state) {
						return !filterOutStates.includes(state.code);
					});
					return CAddressForm.getStateProvDropDown(filteredStates);
				} else {
					var states = '';
					if (typeof address !== 'undefined' && typeof address.country !== 'undefined') {
						states = CAddressForm.getStates(stateProvList, address.country);
					} else {
						states = CAddressForm.getStates(stateProvList, defaultCountry);
					}
					if (wcs.isPharmacy === "true") {
						var _filteredStates = states.filter(function (state) {
							return !additionalBillingStatesCode.includes(state.code);
						});
						return CAddressForm.getStateProvDropDown(_filteredStates);
					}
					return CAddressForm.getStateProvDropDown(states);
				}
	
				return '';
			},
			hideCheckboxForAdditionalTerritories: function hideCheckboxForAdditionalTerritories(enteredCode, additionalBilllingStatesCodes) {
				if (additionalBilllingStatesCodes !== null && additionalBilllingStatesCodes !== undefined) {
					if (additionalBilllingStatesCodes.length !== 0) {
						if ($.inArray(enteredCode, additionalBilllingStatesCodes) !== -1) {
							$('#set-default').prop('checked', false);
							$('.save-address-in-book').prop('checked', false);
							$('.defaultWarning').addClass('hide');
							$('#default-address-checkbox').addClass('hide');
							$("#add-to-address-book-checkbox").addClass('hide');
						} else {
							$('.save-address-in-book').prop('checked', true);
							$('#default-address-checkbox').removeClass('hide');
							$('#add-to-address-book-checkbox').removeClass('hide');
						}
					}
				}
			},
	
			getCountryOptions: function getCountryOptions(type) {
	
				if (type == 'S') {
					return CAddressForm.getCountryDropDown(shippingCountries);
				} else {
					return CAddressForm.getCountryDropDown(billingCountries);
				}
	
				return '';
			},
	
			getStates: function getStates(stateProvList, country) {
	
				for (var i = 0; i < stateProvList.length; i++) {
					var stateProvCountry = stateProvList[i].code;
					if (stateProvCountry == country) {
						return stateProvList[i].states;
					}
				}
			},
	
			getStateProvDropDown: function getStateProvDropDown(states) {
	
				html = '';
				for (var i = 0; i < states.length; i++) {
					html += '<option value="' + states[i].code + '">' + states[i].displayName + '</option>';
				}
				return html;
			},
	
			getCityDropDown: function getCityDropDown(cities) {
	
				html = '';
				for (var i = 0; i < cities.length; i++) {
					html += '<option value="' + cities[i] + '">' + cities[i] + '</option>';
				}
				return html;
			},
	
			getCountryDropDown: function getCountryDropDown(countriesList) {
	
				html = '';
	
				var langId = COSTCO.util.getLangId();
				if (langId == -1) {
					countries.sort(function (a, b) {
						return a.code < b.code ? 1 : -1;
					});
				}
	
				for (var k = 0; k < countries.length; k++) {
	
					if (countriesList.indexOf(countries[k].code) >= 0) {
						html += '<option value="' + countries[k].code + '">' + countries[k].displayName + '</option>';
					}
				}
				return html;
			},
	
			getForm: function getForm() {
	
				var forms = $('.address-form');
	
				if (forms.length > 1) {
					return $('#address-modal-modal');
				} else {
					return forms;
				}
			},
	
			validate: function validate(type, formToValidate, isEditDefaultShippingAddress) {
	
				CAddressForm.validationRules();
	
				function getAddressLine1MaxCharLength() {
					var addressLine1MaxChar = 30;
					if ($('#isBDAppVar').val() == 'BD') {
						addressLine1MaxChar = 35;
					}
					return addressLine1MaxChar;
				}
	
				function getFirstLastNameRule() {
					var firstLastNameMaxChar = 40;
					var firstLastNameRule = {
						required: true
					};
					if ($('#isBDAppVar').val() == 'BD') {
						firstLastNameRule.maxlength = firstLastNameMaxChar;
					}
					return firstLastNameRule.required;
				}
	
				function isCompanyRequired() {
					if ($('#isBDAppVar').val() == 'BD') {
						//SFSTRY0020930 - check if xapp flag for company name mandate is enabled
						var isCompanyMandateEnabled = $("#isCompanyMandateEnabled").val();
						var isLocalDelivery = typeof shipModeLocalND !== 'undefined' && ($("input[name='deliveryMethod']:checked").val() == shipModeLocalND || $("input[name='deliveryMethod']:checked").val() == shipModeLocal);
						var modalTitle = $('#costcoModalTitle').text();
						window.digitalDataEvents = window.digitalDataEvents || [];
						if (type == 'S') {
							//SFSTRY0015679 - Company name mandated for Local business delivery.
							if (shippingCountries[0] == "US") {
								if (isCompanyMandateEnabled === "true" && isLocalDelivery) {
									if (typeof modalTitle != 'undefined' && modalTitle != null && $("#S_companyId").val() == '') {
										if (modalTitle.toLocaleLowerCase() === 'add new address') {
											digitalDataEvents.push({ uimsg: "Add New Address Modal | Enter your company name" });
										}
										if (modalTitle.toLocaleLowerCase() === 'edit delivery address') {
											digitalDataEvents.push({ uimsg: "Edit Address Modal | Enter your company name" });
										}
									}
									return true;
								}
								return false;
							} else {
								return true;
							}
						}
						if (type == 'B') {
							if (shippingCountries[0] == "US" && isCompanyMandateEnabled === "true" && isLocalDelivery) {
								if (typeof modalTitle != 'undefined' && modalTitle != null && $("#B_companyId").val() == '') {
									if (modalTitle.toLocaleLowerCase() === 'add new address') {
										digitalDataEvents.push({ uimsg: "Add New Address Modal | Enter your company name" });
									}
									if (modalTitle.toLocaleLowerCase() === 'edit billing address') {
										digitalDataEvents.push({ uimsg: "Edit Address Modal | Enter your company name" });
									}
								}
								return true;
							}
							return false;
						}
					}
					// Was always false before change related to STRY0144246
					return false;
				}
				//Tries to reach the form. First attempt form parameter, second attempt throw COSTCO.CAddressForm.getForm. 
				//And if the form is not undefined, do validation
				var form = void 0;
				if (formToValidate != undefined) {
					form = formToValidate;
				}
				if (form == undefined && COSTCO.CAddressForm.getForm().length != 0) {
					form = COSTCO.CAddressForm.getForm();
				}
				if (form != undefined) {
					if (!isEditDefaultShippingAddress) {
						form.validate({
							rules: {
								firstModal: { required: getFirstLastNameRule(), firstNameValidation: true },
								lastModal: { required: getFirstLastNameRule(), lastNameValidation: true },
								country: "required",
								address1: { required: true, maxlength: getAddressLine1MaxCharLength, pobox: true },
								address2: { maxlength: 30, pobox: true },
								//company : {maxlength: 40, companyrequiredcheck: true},
								company: { required: isCompanyRequired(), maxlength: 40, companyNameValidation: true },
								postal: { required: true, countryspecificpostalcodePassCountrySelectorModal: true },
								city: "required",
								state: { required: true, notEqual: "NO_STATE_TYPE_SELECTED", hasvalidationerror: true, validateAdditionalTerritories: type },
								phone: { required: true, phone: true },
								email: { required: true, email: true, maxlength: 254 },
								deliveryInstructions: { required: false },
								contactName: "required",
								contactPhone: "phone",
								ext1: "digits"
							},
							messages: {
								firstModal: { required: messages.ERR_INVALID_FIRSTNAME, firstNameValidation: messages.ERR_INVALID_FNAME },
								lastModal: { required: messages.ERR_INVALID_LASTNAME, lastNameValidation: messages.ERR_INVALID_LNAME },
								country: messages.ERR_INVALID_COUNTRY,
								address1: { required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE, pobox: messages.ERR_INVALID_POBOX },
								address2: { maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX },
								company: { maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH, required: messages.ERR_COMPANY_REQUIRED, companyrequiredcheck: messages.ERR_INVALID_COMPANY, companyNameValidation: messages.ERR_INVALID_COMPANY },
								postal: messages.ERR_ENTER_ZIPCODE,
								city: messages.ERR_INVALID_CITY,
								state: messages.ERR_INVALID_STATE,
								phone: { required: messages.ERR_INVALID_PHONE1, phone: messages.ERR_INVALID_PHONE1 },
								email: { required: messages.ERR_REQUIRED_EMAIL_MY, email: messages.ERR_INVALID_EMAIL, maxlength: messages.ERR_INVALID_EMAIL },
								contactName: messages.ERR_INVALID_CONTACT_NAME,
								contactPhone: messages.ERR_INVALID_PHONE1,
								ext1: messages.ERR_INVALID_EXTN_NUMBER
							},
							invalidHandler: COSTCO.util.invalid_handler,
							highlight: COSTCO.util.highlightWithErrorLabel,
							unhighlight: COSTCO.util.unhighlightWithErrorLabel,
							errorPlacement: function errorPlacement(error, element) {
								if (element.attr("name") == "state") {
									element.parent().addClass('error');
									error.insertAfter($('[name=state]').parent());
								} else if (element.attr("name") == "country") {
									element.parent().addClass('error');
									error.insertAfter($('[name=country]').parent());
								} else {
									error.insertAfter(element);
								}
							}
						}).form();
					} else {
						// validation rules and messages for edit default shipping address
						form.validate({
							rules: {
								firstModal: { required: getFirstLastNameRule(), firstNameValidation: true },
								lastModal: { required: getFirstLastNameRule(), lastNameValidation: true },
								country: "required",
								address1: { required: true, maxlength: getAddressLine1MaxCharLength, pobox: true },
								address2: { maxlength: 30, pobox: true },
								//company : {maxlength: 40, companyrequiredcheck: true},
								company: { required: isCompanyRequired(), maxlength: 40, companyNameValidation: true },
								postal: { required: true, countryspecificpostalcodePassCountrySelectorModal: true },
								city: "required",
								state: { required: true, notEqual: "NO_STATE_TYPE_SELECTED", hasvalidationerror: true, validateAdditionalTerritories: type },
								phone: { required: true, phone: true },
								email: { required: true, email: true, maxlength: 254 },
								deliveryInstructions: { required: false },
								contactName: "required",
								contactPhone: "phone",
								ext1: "digits"
							},
							messages: {
								firstModal: { required: messages.ERR_INVALID_FIRSTNAME, firstNameValidation: messages.ERR_INVALID_FNAME },
								lastModal: { required: messages.ERR_INVALID_LASTNAME, lastNameValidation: messages.ERR_INVALID_LNAME },
								country: messages.ERR_INVALID_COUNTRY,
								address1: { required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE, pobox: messages.ERR_INVALID_POBOX },
								address2: { maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX },
								company: { maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH, required: messages.ERR_INVALID_COMPANY, companyrequiredcheck: messages.ERR_INVALID_COMPANY, companyNameValidation: messages.ERR_INVALID_COMPANY },
								postal: messages.ERR_ENTER_ZIPCODE,
								city: messages.ERR_INVALID_CITY,
								state: messages.ERR_INVALID_STATE,
								phone: { required: messages.ERR_INVALID_PHONE2, phone: messages.ERR_INVALID_PHONE2 },
								email: { required: messages.ERR_EMAIL_ADDRESS_REQUIRED, email: messages.ERR_INVALID_EMAIL, maxlength: messages.ERR_INVALID_EMAIL },
								contactName: messages.ERR_INVALID_CONTACT_NAME,
								contactPhone: messages.ERR_INVALID_PHONE1,
								ext1: messages.ERR_INVALID_EXTN_NUMBER
							},
							invalidHandler: COSTCO.util.invalid_handler,
							highlight: COSTCO.util.highlightWithErrorLabel,
							unhighlight: COSTCO.util.unhighlightWithErrorLabel,
							errorPlacement: function errorPlacement(error, element) {
								if (element.attr("name") == "state") {
									element.parent().addClass('error');
									error.insertAfter($('[name=state]').parent());
								} else if (element.attr("name") == "country") {
									element.parent().addClass('error');
									error.insertAfter($('[name=country]').parent());
								} else {
									error.insertAfter(element);
								}
							}
						}).form();
					}
	
					var selectsValid = true;
	
					form.find('.style-select > select').each(function () {
						$(this).unbind('change').change(function () {
							if ($(this).val() === "NO_STATE_TYPE_SELECTED") {
								selectsValid = false;
								$(this).parent().addClass('error');
							} else {
								$(this).parent().removeClass('error');
								if ($(this).attr('hasvalidationerror') != undefined && $(this).attr('hasvalidationerror') != null) {
									$(this).attr('hasvalidationerror', false);
								}
							}
						});
					});
	
					form.find('.style-select > select').change();
	
					return form.valid() && selectsValid;
				}
			},
	
			/*
	   * Build Address Array from a query selector
	   */
			buildAddressArray: function buildAddressArray(type) {
				var addressObject = {};
				var addressArray = [];
				var _baseAddr = COSTCO.CAddressForm.getForm();
				var addressPrefix = '';
	
				if (_baseAddr.length > 0 && _baseAddr[0].id == 'quick-renew-address-form') {
					if (type == "S" || type == 'S') addressPrefix = 'shipping_';else addressPrefix = 'billing_';
				}
	
				addressObject['id'] = _baseAddr.find('[name=' + addressPrefix + 'addressId]').val();
				addressObject['fName'] = _baseAddr.find('[name=' + addressPrefix + 'firstModal]').val();
				addressObject['lName'] = _baseAddr.find('[name=' + addressPrefix + 'lastModal]').val();
				addressObject['company'] = _baseAddr.find('[name=' + addressPrefix + 'company]').val();
				addressObject['country'] = _baseAddr.find('[name=' + addressPrefix + 'country]').val();
				addressObject['line1'] = _baseAddr.find('[name=' + addressPrefix + 'address1]').val();
				addressObject['line2'] = _baseAddr.find('[name=' + addressPrefix + 'address2]').val();
				addressObject['zip'] = _baseAddr.find('[name=' + addressPrefix + 'postal]').val();
				addressObject['city'] = _baseAddr.find('[name=' + addressPrefix + 'city]').val();
				addressObject['state'] = _baseAddr.find('[name=' + addressPrefix + 'state]').val();
				addressObject['pNumber'] = _baseAddr.find('[name=' + addressPrefix + 'phone]').unmask().val();
				addressObject['ext1'] = _baseAddr.find('[name=' + addressPrefix + 'ext1]').val();
				addressObject['nickname'] = _baseAddr.find('[name=' + addressPrefix + 'nickname]').val();
				addressObject['email'] = _baseAddr.find('[name=' + addressPrefix + 'email]').val();
				addressObject['mInitial'] = _baseAddr.find('[name=mInitial]').val();
				addressObject['saveAddress'] = address.getSaveAddress(addressObject['id'], _baseAddr.find('[name=' + addressPrefix + 'save-address]:checked').length > 0);
				addressObject['setDefault'] = address.getDefaultAddress(addressObject['id'], _baseAddr.find('[name=' + addressPrefix + 'set-default]:checked').length > 0);
				addressObject['addressType'] = address.getAddressType(addressObject['id'], type);
				addressObject['addressType2'] = address.getAddressType(addressObject['id'], type);
				addressObject['deliveryInst'] = _baseAddr.find('[name=' + addressPrefix + 'deliveryInstructions]').val();
				addressObject['contactName'] = _baseAddr.find('[name=' + addressPrefix + 'contactName]').val();
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
					addressObject['contactPhNo'] = _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').length > 0 ? _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').cleanVal() : _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').val();
				} else {
					addressObject['contactPhNo'] = _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').val();
				}
				addressObject['smsPhone'] = $('#receiveSMS').is(':checked') ? _baseAddr.find('#' + addressPrefix + 'smsPhoneId').cleanVal() : "";
	
				if (addressObject.addressType == '') {
					addressObject.addressType = type;
				}
	
				addressArray.push(addressObject);
				return addressArray;
			},
	
			populateCityState: function populateCityState(form, city, state, cityQuery, stateQuery) {
	
				var form = $(form);
	
				var cityQueryNameValue = cityQuery.match(/\[name=(.*?)\]/)[1];
				var cityFieldType = COSTCO.CAddressForm.getCityFieldType(form, cityQueryNameValue);
				if (form.find('select' + cityQuery).length) {
					COSTCO.CAddressForm.setCorrectCityField(form, cityQueryNameValue, cityFieldType);
				}
	
				form.find(cityQuery).val(city);
				form.find(stateQuery).val(state);
				form.find(cityQuery).focusout().change();
				form.find(stateQuery).focusout().change();
				//STRY0148134 checkout redesign - show city state inputs
				form.find('#' + cityFieldType + 'city-state').removeClass('hide');
			},
	
			matchCityOption: function matchCityOption(citySelect, editAddrCity) {
	
				var options = citySelect.find('option');
				var matchingValue = null;
				var normalizedEditAddrCity = editAddrCity.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
	
				options.each(function () {
					var optionValue = $(this).val();
					var normalizedOptionValue = optionValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
					if (normalizedOptionValue == normalizedEditAddrCity) {
						matchingValue = optionValue;
						return false;
					}
				});
	
				return matchingValue;
			},
	
			/* ALM52674 - This method is used for the modal to display the correct city field type
	   * depending on the geo location service response - if the service is down, 
	   * a text input field is used, while if the service call is successful, a 
	   * select field with valid city options for the given zip/postal code is displayed
	  */
			setCorrectCityField: function setCorrectCityField(form, cityQueryNameValue, cityFieldType) {
	
				var alternativeCityQueryNameValue = cityFieldType + 'city2';
	
				//correctCityField is the city field that should be displayed, instead of the incorrectCityField
				var correctCityField = '[name=' + alternativeCityQueryNameValue + ']';
				var incorrectCityField = '[name=' + cityQueryNameValue + ']';
	
				/*whatever city field is displayed, it should have the idForCurrentCityField and nameForCurrentCityField
	   values as the 'id', and 'name' attribute values, while the alternative field (not displayed) should have
	   idForAltCityField and nameForAltCityField as 'id' and 'name'*/
	
				var idForCurrentCityField = form.find('[name=' + cityQueryNameValue + ']').attr('id');
				var idForAltCityField = form.find('[name=' + alternativeCityQueryNameValue + ']').attr('id');
	
				var nameForCurrentCityField = cityQueryNameValue;
				var nameForAltCityField = alternativeCityQueryNameValue;
	
				var parentDivId = cityFieldType + 'city-state';
	
				var incorrParentDiv = form.find(incorrectCityField).parent();
				while (incorrParentDiv.attr('id') !== parentDivId) {
					incorrParentDiv.addClass('hide');
					incorrParentDiv = incorrParentDiv.parent();
				}
				form.find(incorrectCityField).removeAttr('id required aria-required');
	
				var corrParentDiv = form.find(correctCityField).parent();
				while (corrParentDiv.attr('id') !== parentDivId) {
					corrParentDiv.removeClass('hide');
					corrParentDiv = corrParentDiv.parent();
				}
				form.find(correctCityField).attr('id', idForCurrentCityField);
				form.find('#' + idForCurrentCityField).removeAttr('name required aria-required');
				form.find('#' + idForCurrentCityField).attr({
					'required': 'true',
					'aria-required': 'true'
				});
	
				form.find(incorrectCityField).attr('id', idForAltCityField);
				form.find('#' + idForAltCityField).attr('name', nameForAltCityField);
	
				form.find('#' + idForCurrentCityField).attr('name', nameForCurrentCityField);
	
				CAddressForm.moveMissplacedElements(form, idForAltCityField, idForCurrentCityField);
			},
	
			moveMissplacedElements: function moveMissplacedElements(form, idForAltCityField, idForCurrentCityField) {
				var altParentDiv = form.find('#' + idForAltCityField).parent();
				var currElements = altParentDiv.find('[for=' + idForCurrentCityField + ']');
				if (currElements.length) {
					form.find('#' + idForCurrentCityField).parent().append(currElements);
				}
				return currElements;
			},
	
			/* SFSTRY0028209 - The address modal City and State fields will be displayed/populated
	   *  based on the geo location service response 
	  */
			populateCityStateForZipPostalCode: function populateCityStateForZipPostalCode(form, cityList, stateList, cityQuery, stateQuery, editAddrCity, editAddrState) {
	
				var form = $(form);
	
				var editAddrCityOptionMatch = undefined;
				var cityQueryNameValue = cityQuery.match(/\[name=(.*?)\]/)[1];
				var cityFieldType = COSTCO.CAddressForm.getCityFieldType(form, cityQueryNameValue);
	
				if (cityList.length && stateList.length) {
	
					if (form.find(cityQuery).attr('type') == "text") {
						COSTCO.CAddressForm.setCorrectCityField(form, cityQueryNameValue, cityFieldType);
					}
					var cityOptions = CAddressForm.getCityDropDown(cityList);
	
					var stateOptions = CAddressForm.getStateProvDropDown(stateList);
					form.find(cityQuery).empty().append(cityOptions);
					form.find(stateQuery).empty().append(stateOptions);
	
					if (editAddrCity != undefined) {
						editAddrCityOptionMatch = COSTCO.CAddressForm.matchCityOption(form.find(cityQuery), editAddrCity);
					}
				} else {
					var stateProvList = address.getStateProvJson();
					var stateOptions = CAddressForm.getStateOptions(stateProvList);
					form.find(stateQuery).empty().append(stateOptions);
					form.find(cityQuery).empty();
					var alternativeCityQuery = '[name=' + cityFieldType + 'city2]';
					if (form.find(alternativeCityQuery).length > 0 && form.find(alternativeCityQuery).attr('type') == "text") {
						COSTCO.CAddressForm.setCorrectCityField(form, cityQueryNameValue, cityFieldType);
					} else {
						form.find(cityQuery).val('');
					}
				}
	
				if (editAddrState != undefined && editAddrCity != undefined) {
					var editAddrSavedCity = editAddrCityOptionMatch ? editAddrCityOptionMatch : editAddrCity;
					form.find(cityQuery).val(editAddrSavedCity);
					form.find(stateQuery).val(editAddrState);
				}
	
				form.find(cityQuery).focusout().change();
				form.find(stateQuery).focusout().change();
				//STRY0148134 checkout redesing - show city state inputs
				//form.find('#city-state').removeClass('hide');
	
				form.find('#' + cityFieldType + 'city-state').removeClass('hide');
			},
	
			/**
	   * Gets the City field form type 
	   */
			getCityFieldType: function getCityFieldType(form, cityQueryNameValue) {
				var fieldType = '';
				if (cityQueryNameValue.indexOf('business') !== -1) {
					fieldType = 'business_';
				} else if (cityQueryNameValue.indexOf('shipping') !== -1) {
					fieldType = 'shipping_';
				} else if (cityQueryNameValue.indexOf('billing') !== -1) {
					fieldType = 'billing_';
				} else if (cityQueryNameValue.indexOf('affiliate') !== -1 || form.attr('id').indexOf('affiliate') !== -1) {
					fieldType = 'affiliate_';
				}
	
				return fieldType;
			},
	
			/**
	   * Gets shipping address id from html address display block
	   */
			getShippingId: function getShippingId() {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true && !COSTCO.MembershipHelper.isQuickMembership) {
					return $('#shipping .address-display').data('addressid');
				} else {
					return $('.address-display').data('addressid');
				}
			},
	
			/**
	   * Gets billing address id from html address display block
	   */
			getBillingId: function getBillingId() {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true && !COSTCO.MembershipHelper.isQuickMembership) {
					return $('#billing .address-display').data('addressid');
				} else {
					return $('.address-display').data('addressid');
				}
			},
	
			/**
	   * Checks if address form has been completed. For give address type if address block with address id is found on page,
	   * it is considered that address form is completed.
	   */
			isFormCompleted: function isFormCompleted(type) {
				if (type === 'S') {
					return this.getShippingId() != null;
				} else {
					return this.getBillingId() != null;
				}
			},
			initiatePopovers: function initiatePopovers() {
				var helper = "#deliveryInstructionsPopover";
	
				var popOverSettings = {
					trigger: 'focus',
					placement: 'top',
					html: true,
					selector: helper,
					content: function content() {
						return $(helper).data().popupcontent;
					}
				};
				$('body').popover(popOverSettings);
			},
			showBusinessDeliveryQuestionnaireModal: function showBusinessDeliveryQuestionnaireModal(type, data, action, addressOptions) {
				address.baseModal(type, 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (action == 'edit') {
							CAddressForm.openAddressAddModal(type, data, 'edit', addressOptions);
						} else {
							CAddressForm.openAddressAddModal(type, data, 'add', addressOptions);
						}
					}
				});
			},
			showBusinessDeliveryQuestionnaireModal_v2: function showBusinessDeliveryQuestionnaireModal_v2(type, data, action, addressOptions) {
				address.baseModal(type, 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (action == 'edit') {
							CAddressForm.openAddressAddModal_v2(type, data, 'edit', addressOptions);
						} else {
							CAddressForm.openAddressAddModal_v2(type, data, 'add', addressOptions);
						}
					}
				});
			},
			showBDQuestionnaireModalForInlineForm: function showBDQuestionnaireModalForInlineForm(type, preventHtmlReload, addressOptions, addressArray) {
				COSTCO.dialog.createExtDialogBox({
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						CAddressForm.agreeFromBDQuestionnaireModal(type, preventHtmlReload, addressOptions, addressArray);
					}
				});
			},
			agreeFromBDQuestionnaireModal: function agreeFromBDQuestionnaireModal(type, preventHtmlReload, addressOptions, addressArray) {
				addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
				addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
			},
			//hides the link, shows input field
			showInputFiled: function showInputFiled(input) {
				var selectedElementParent = $(input).parent();
				selectedElementParent.siblings().removeClass('hide');
				selectedElementParent.siblings().find('input').focus();
				selectedElementParent.siblings().find('input').select();
				//timout set so that NVDA can focus the input field
				setTimeout(function () {
					selectedElementParent.addClass('hide');
				}, 120);
			},
	
			hideInputFiled: function hideInputFiled(input) {
				$(input).parent().siblings().addClass('hide');
				$(input).parent().removeClass('hide');
			},
	
			/**
	   * This function is used to trigger character counting functionality
	   */
			countTextareaCharacters: function countTextareaCharacters(element) {
				var additionalParam = $(element).data('param-type') !== undefined ? $(element).data('param-type') : null;
				$('body').trigger('count.delivery.inst.characters', additionalParam);
			},
	
			/**
	   * This function finds the textArea and character label and calls the character counting functionality
	   * @param {the expand element for the delivery instructions area} expandLink 
	   */
			countTextareaCharactersAddressBook: function countTextareaCharactersAddressBook(expandLink) {
				var textArea = $(expandLink).parent().siblings().find('textarea');
				var countLabel = textArea.siblings().find('#delivery-message-count');
				COSTCO.util.character_count(countLabel, textArea);
			},
	
			/**
	  * This function is used to open edit block for Delivery Information
	  */
			showDeliveryInstructionsBlock: function showDeliveryInstructionsBlock(paramType) {
				$('#delivery-instructions-text').addClass('hide');
				$('#edit-delivery-instructions-text').removeClass('hide');
				var textAreaId = 'deliveryInstructions' + (paramType ? '-' + paramType : '');
				var textArea = $('#edit-delivery-instructions-text textarea[id=' + textAreaId + ']');
				textArea.attr('tabindex', 0);
				textArea.focus();
				textArea.select();
			},
			/**
	  * This function is used to open edit block for Contact Information
	  */
			showContactInformationBlock: function showContactInformationBlock() {
				$('#contact-information-text').addClass('hide');
				$('#edit-contact-information-text').removeClass('hide');
				if ($('input[id=contactPhNo-inline]').val() !== "") {
					$('label[for=contactPhNo-inline]').addClass('active');
				}
				if ($('input[id=contactName-inline]').val() !== "") {
					$('label[for=contactName-inline]').addClass('active');
				}
				$('#contactPhNo-inline').unmask().mask('000-000-0000');
			},
			/**
	  * This function is used for updating different contact information for specific addressId
	  * depending on xAddressInfoType (delivery instructions, contact name, contact phone etc.)
	  */
			updateXAddressInformation: function updateXAddressInformation(inputElement, addressId) {
				var xAddressInfoType = $(inputElement).data('xaddress-info-type');
				var inputValue = $(inputElement).val();
				var preventHtmlResponse = false;
				var nextElement = event.relatedTarget;
				if (nextElement !== null) {
					if (nextElement.name === "contactPhone" || nextElement.name === "contactName") {
						preventHtmlResponse = true;
					}
				}
				var data = [{
					name: "addressId",
					value: addressId || ""
				}, {
					name: "xAddressInfoType",
					value: xAddressInfoType || ""
				}, {
					name: "inputValue",
					value: inputValue || ""
				}, {
					name: "preventHtmlResponse",
					value: preventHtmlResponse
				}];
	
				COSTCO.AjaxModular.ajax_update_state({
					url: 'AjaxXAddressUpdateCmd',
					method: 'POST',
					dataType: 'json',
					data: data,
					scrollToError: false,
					done: function done(data, textStatus, jqXHR, options) {
						COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
						for (var i = 0; i < COSTCO.util.addresses.length; i++) {
							if (COSTCO.util.addresses[i] !== undefined && COSTCO.util.addresses[i]["addressType"] === 'S') {
								COSTCO.util.addresses[i][xAddressInfoType] = inputValue;
							}
						}
					},
					always: function always() {
						if (COSTCO.CreditCard !== undefined) {
							COSTCO.CreditCard.initComplete = false;
						}
						if (COSTCO.util.isBusinessDelivery()) {
							COSTCO.Header.miniShopCartRefresh();
							COSTCO.preauthchargesmodal.init();
						}
					}
				});
			},
			validateContactInformation: function validateContactInformation() {
				if ($.validator.methods.contactInformationPhone === undefined) {
					$.validator.addMethod("contactInformationPhone", function (value, element) {
						if (value.startsWith("0") || value.startsWith("1")) {
							return false;
						}
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
				}
				var form = $('#contact-information-form');
				form.validate({
					rules: {
						contactName: { required: true, maxlength: 40 },
						contactPhone: { contactInformationPhone: true }
					},
					messages: {
						contactName: messages.ERR_INVALID_CONTACT_NAME,
						contactPhone: messages.ERR_INVALID_PHONE1
					},
					invalidHandler: COSTCO.util.invalid_handler,
					highlight: COSTCO.util.highlightWithErrorLabel,
					unhighlight: COSTCO.util.unhighlightWithErrorLabel,
					errorPlacement: function errorPlacement(error, element) {
						error.insertAfter(element);
					}
				});
	
				return form.valid();
			},
			updateContactInformation: function updateContactInformation(inputElement, addressId) {
				if (COSTCO.CAddressForm.validateContactInformation()) {
					CAddressForm.updateXAddressInformation(inputElement, addressId);
				}
			},
	
			toggleSmsBlock: function toggleSmsBlock() {
				if ($('#receiveSMS').is(':checked')) {
					$('.smsPhoneBlock').removeClass('hidden');
				} else {
					$('.smsPhoneBlock').addClass('hidden');
				}
			},
			/*
	   * QuestionnaireModal for BD National Delivery version 2
	   */
			showNationalDeliveryQuestionnaireModal: function showNationalDeliveryQuestionnaireModal(verifiedAddress, preventhtmlajax, addressOptions, message, userSelection) {
				var deliveryMethod;
				if ($('input[name="deliveryMethod"]').length > 0) {
					deliveryMethod = $("input[name='deliveryMethod']:checked").val();
				} else if ($('#shipmodeId').length > 0) {
					deliveryMethod = parseFloat($('#shipmodeId').val());
				}
				var delObj = {
					espotContent: deliveryMethod
				};
				var template = COSTCO.util.tmpl('tmpl_bd_questionnaire_modal', delObj);
				address.baseModal('S', 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: template,
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						verifiedAddress.userAddressType = userSelection;
						address.addEditAddress(verifiedAddress, preventhtmlajax, addressOptions, message);
					}
				});
			},
			/*
	   * QuestionnaireModal for BD National Delivery
	   */
			showNationalDeliveryQuestionnaireModal_v2: function showNationalDeliveryQuestionnaireModal_v2(form, data, params, verifiedAddress) {
				var deliveryMethod;
				if ($('input[name="deliveryMethod"]').length > 0) {
					deliveryMethod = $("input[name='deliveryMethod']:checked").val();
				} else if ($('#shipmodeId').length > 0) {
					deliveryMethod = parseFloat($('#shipmodeId').val());
				}
				var delObj = {
					espotContent: deliveryMethod
				};
				var template = COSTCO.util.tmpl('tmpl_bd_questionnaire_modal', delObj);
				address.baseModal('S', 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: template,
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (typeof checkoutPage !== 'undefined') {
							if (checkoutPage == 'review' || checkoutPage == 'shipping') {
								isCheckoutFlow = true;
							}
						}
						if (isCheckoutFlow && !verifiedAddress) {
							COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip, form, params, data);
						} else if (isCheckoutFlow && !data.WarehouseChange && data.StatusMessage == data.ZipStatusMessageList[7]) {
							COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip, form, params, data, verifiedAddress);
						} else {
							COSTCO.zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
						}
					}
				});
			},
			/**
	   * Reads 'Form End' when focus gets out of form
	   * @param formElement - form
	   */
			makeFormAdaCompatible: function makeFormAdaCompatible(formElement) {
				if (formElement == undefined) {
					return false;
				}
				//Adds event on all focusable elements of form
				formElement.find('a, input, select').each(function () {
					$(this).blur(function () {
						setTimeout(function () {
							//timeout is needed to wait for setting focus on next element
							if (!$.contains(formElement.get(0), document.activeElement)) {
								COSTCO.util.announceSRMessage(messages.FORM_END);
							}
						}, 30);
					});
				});
			},
	
			//Adds analytics for save/cancel/remove address buttons on the address form. 
			updateAddressModal: function updateAddressModal() {
				var modalTitle = document.getElementById('costcoModalTitle');
				var modalBtn1 = document.getElementById('costcoModalBtn1');
				var modalBtn2 = document.getElementById('costcoModalBtn2');
	
				if (typeof modalTitle != 'undefined' && modalTitle != null) {
					var text = modalTitle.innerText;
				}
	
				if (typeof modalBtn1 != 'undefined' && modalBtn1 != null) {
					$('#costcoModalBtn1').attr("data-bi-tc", "ui:My Account | Address Book | Cancel Address");
				}
				if (typeof modalBtn2 != 'undefined' && modalBtn2 != null) {
	
					if (text.toLocaleLowerCase() === 'edit shipping address' || text.toLocaleLowerCase() === 'add new address') {
						$('#costcoModalBtn2').attr("data-bi-tc", "ui:My Account | Address Book | Save Address");
					}
	
					if (text.toLocaleLowerCase() === 'remove address') {
						$('#costcoModalBtn2').attr("data-bi-tc", "ui:My Account | Address Book | Remove Address");
					}
				}
			}
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
		window.COSTCO.CAddressForm = CAddressForm;
		return CAddressForm;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title address.js: Feature level module
	 * @description Module associated with address handling
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (preauthchargesmodal) {
	  var CAddress = {
	    stateprov: '',
	    addressTools: {
	      applyAddressToOrder: "false",
	      applyAddressToOrderItems: "false",
	      addressType: '',
	      cachedAddressId: '',
	      errorContainer: ''
	    },
	    urlDelete: 'AjaxAddressAddCmd?mode=DELETE&addressId=',
	    form: '',
	    initialize: function initialize(isReloaded) {
	      COSTCO.util.getInitialAddressBatch();
	    },
	    // Hierarchy Setup for Modals -> Mode -> Type
	    getHeaderLabels: function getHeaderLabels(type, mode) {
	      var typeLabel, modeLabel;
	      if (typeof mode !== 'undefined') {
	        modeLabel = addressLabels[mode];
	      }
	      if (typeof type !== 'undefined') {
	        if (type.trim() == 'S') {
	          typeLabel = $.extend({}, addressLabels.shipping);
	          if (typeof modeLabel.shipping !== 'undefined') {
	            typeLabel = $.extend(typeLabel, modeLabel.shipping);
	          }
	        } else {
	          typeLabel = $.extend({}, addressLabels.billing);
	          if (typeof modeLabel.billing !== 'undefined') {
	            typeLabel = $.extend(typeLabel, modeLabel.billing);
	          }
	        }
	      }
	      //added empty object as the first argument so that addressHeaderLabels stays in its original state
	      return $.extend({}, addressHeaderLabels, modeLabel, typeLabel);
	    },
	    previousOptions: [],
	    previousMode: [],
	    previousType: [],
	    pushModal: function pushModal(type, mode, options) {
	      COSTCO.CAddress.previousOptions.push(options);
	      COSTCO.CAddress.previousMode.push(mode);
	      COSTCO.CAddress.previousType.push(type);
	    },
	    resetQueue: function resetQueue() {
	      COSTCO.CAddress.previousOptions = [];
	      COSTCO.CAddress.previousMode = [];
	      COSTCO.CAddress.previousType = [];
	    },
	    closeModal: function closeModal() {
	      COSTCO.CAddress.resetQueue();
	      COSTCO.dialog.closeAndUnbind();
	    },
	    baseModal: function baseModal(type, mode, options, poppin) {
	      if (COSTCO.CAddress.previousOptions.length > 0 && typeof options.secondary_event === 'undefined') {
	        var s_options = COSTCO.CAddress.previousOptions.pop();
	        var s_mode = COSTCO.CAddress.previousMode.pop();
	        var s_type = COSTCO.CAddress.previousType.pop();
	        options.secondary_event = options.close = options.afterclose = function () {
	          COSTCO.CAddress.baseModal(s_type, s_mode, s_options, true);
	        };
	      }
	      var labels = CAddress.getHeaderLabels(type, mode);
	      var addressOptions = {
	        title: labels.modalTitle,
	        primary: labels.primaryButton,
	        secondary: messages.JS_DIALOG_CANCEL,
	        secondary_event: function secondary_event() {
	          COSTCO.CAddress.closeModal();
	        },
	        close: function close() {
	          $('.order-ajax').removeClass('ajax-busy');
	          COSTCO.CAddress.closeModal();
	        },
	        afterclose: function afterclose(e) {
	          COSTCO.CAddress.closeModal();
	        }
	      };
	      options = $.extend(addressOptions, options);
	      if (typeof poppin === 'undefined') {
	        COSTCO.CAddress.pushModal(type, mode, options);
	      } else {
	        COSTCO.CAddress.resetQueue();
	        COSTCO.CAddress.pushModal(type, mode, options);
	      }
	
	      COSTCO.dialog.showAndHideModal(options);
	    },
	    urlAddUpdate: function urlAddUpdate(addressOptions) {
	      if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
	        document.getElementById("calendarServiceResponse").value = "";
	      }
	
	      var url = '';
	      if (typeof addressOptions === 'undefined') {
	        url = '/AjaxAddressAddCmd';
	      } else {
	        url = addressOptions.url ? addressOptions.url : '/AjaxAddressAddCmd';
	      }
	      var orderItemId = '';
	      var multiAddress = '';
	      var addressIdsToUpdate = [];
	
	      if (typeof checkoutPage !== 'undefined' && typeof addressOptions !== 'undefined') {
	        if (!COSTCO.util.isBusinessDelivery()) {
	          orderItemId = addressOptions.orderItemId;
	        }
	        if (checkoutPage === 'multi-shipping') {
	          multiAddress = 'true';
	          var cartCount = $.cookie('cartCountCookie');
	          for (i = 0; i < cartCount; i++) {
	            addressIdsToUpdate[i] = $('#addressId_' + (i + 1)).val();
	          }
	          var addressIdsToUpdateString = encodeURIComponent(JSON.stringify(addressIdsToUpdate));
	        } else if (checkoutPage === 'shipping') {
	          multiAddress = 'false';
	        }
	      }
	
	      var queryObject = {
	        addressType: CAddress.addressTools.addressType,
	        applyAddressToOrder: CAddress.addressTools.applyAddressToOrder,
	        applyAddressToOrderItems: CAddress.addressTools.applyAddressToOrderItems,
	        orderItemId: orderItemId,
	        multiAddress: multiAddress,
	        modular: 'true',
	        requesttype: 'ajax',
	        addressIdsToUpdate: addressIdsToUpdateString
	      };
	
	      return COSTCO.util.makeUrl(url, queryObject);
	    },
	
	    urlAdd: function urlAdd(addressOptions) {
	      if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
	        document.getElementById("calendarServiceResponse").value = "";
	      }
	      var url = '';
	      if (typeof addressOptions === 'undefined') {
	        url = '/AjaxAddressAddCmd';
	      } else {
	        url = addressOptions.url ? addressOptions.url : '/AjaxAddressAddCmd';
	      }
	      var orderItemId = '';
	      var multiAddress = '';
	      var addressIdsToUpdate = [];
	
	      if (typeof checkoutPage !== 'undefined' && typeof addressOptions !== 'undefined') {
	        if (!COSTCO.util.isBusinessDelivery()) {
	          orderItemId = addressOptions.orderItemId;
	        }
	        if (checkoutPage === 'multi-shipping') {
	          multiAddress = 'true';
	          var cartCount = $.cookie('cartCountCookie');
	          for (i = 0; i < cartCount; i++) {
	            addressIdsToUpdate[i] = $('#addressId_' + (i + 1)).val();
	          }
	          var addressIdsToUpdateString = encodeURIComponent(JSON.stringify(addressIdsToUpdate));
	          CAddress.addressTools.applyAddressToOrderItems = false;
	        } else if (checkoutPage === 'shipping') {
	          multiAddress = 'false';
	        }
	      }
	      var queryObject = {
	        addressType: CAddress.addressTools.addressType,
	        applyAddressToOrder: CAddress.addressTools.applyAddressToOrder,
	        applyAddressToOrderItems: CAddress.addressTools.applyAddressToOrderItems,
	        orderItemId: orderItemId,
	        multiAddress: multiAddress,
	        modular: 'true',
	        requesttype: 'ajax',
	        addressIdsToUpdate: addressIdsToUpdateString,
	        preventHtmlReload: costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && $((CAddress.addressTools.addressType === 'S' ? '#shipping' : '#billing') + ' #address-modal-inline').length > 0
	      };
	
	      return COSTCO.util.makeUrl(url, queryObject);
	    },
	    urlChoose: function urlChoose(orderItemId) {
	      return '/AjaxAddressAddCmd?mode=CHOOSE&addressType=' + CAddress.addressTools.addressType + '&applyAddressToOrder=' + CAddress.addressTools.applyAddressToOrder + '&applyAddressToOrderItems=' + CAddress.addressTools.applyAddressToOrderItems + '&orderItemId=' + orderItemId + '&modular=true&requesttype=ajax';
	    },
	    applyAddressToWhat: function applyAddressToWhat(type) {
	      // stateful change of addressTools url params
	      if (type === 'B') {
	        CAddress.addressTools.addressType = 'B';
	        CAddress.addressTools.applyAddressToOrder = 'true';
	        CAddress.addressTools.applyAddressToOrderItems = 'false';
	      } else if (type === 'S') {
	        CAddress.addressTools.addressType = 'S';
	        CAddress.addressTools.applyAddressToOrder = 'false';
	        CAddress.addressTools.applyAddressToOrderItems = 'true';
	      } else {
	        CAddress.addressTools.addressType = 'T';
	        CAddress.addressTools.applyAddressToOrder = 'false';
	        CAddress.addressTools.applyAddressToOrderItems = 'false';
	      }
	    },
	    chooseAddress: function chooseAddress(oldAddyId, newAddyId, orderItemId) {
	      var oldAddy = CAddress.getAddressElement(oldAddyId, '', true);
	      var newAddy = CAddress.getAddressElement(newAddyId, '', true);
	      var oldZipcode;
	      var orderHasEddItems = $('#orderHasEddItems').val();
	      if (newAddy.addressType === 'S' && undefined !== orderHasEddItems) {
	        if (orderHasEddItems === 'true') {
	          oldZipcode = $.cookie("invCheckPostalCode");
	          if (typeof sessionStorage !== "undefined" && null !== oldZipcode) {
	            sessionStorage.setItem('oldZipcode', oldZipcode);
	          }
	          $.cookie("invCheckPostalCode", newAddy.zip.toUpperCase());
	          $.cookie("invCheckStateCode", newAddy.state);
	          $.cookie("invCheckCity", newAddy.city);
	        }
	      }
	
	      //update WAREHOUSEDELIVERY_WHS cookie when changing shipping address
	      if (!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof oldZipcode !== 'undefined' && typeof newAddy.zip !== 'undefined') {
	        if (oldZipcode.toUpperCase() != newAddy.zip.toUpperCase()) {
	          CAddress.updateWarehouseCookie(newAddy.zip.toUpperCase());
	        }
	      }
	
	      if (!oldAddy) {
	        oldAddy = newAddy;
	      }
	      oldAddy['newAddressId'] = newAddy.id;
	      CAddress.applyAddressToWhat(oldAddy.addressType);
	      var labels = CAddress.getHeaderLabels(oldAddy['addressType'], 'choose');
	      var inputContainer = '#address_change_' + newAddyId;
	      if (orderItemId) {
	        inputContainer = '#address_change_' + newAddyId + '_' + orderItemId;
	      }
	
	      var callChooseAddress = function callChooseAddress() {
	
	        COSTCO.Checkout.ajax_update_state({
	          url: CAddress.urlChoose(orderItemId),
	          method: "POST",
	          dataType: 'json',
	          data: {
	            'authToken': COSTCO.Checkout.getAuthToken(),
	            'oldZipcode': oldZipcode,
	            formdata: encodeURIComponent(JSON.stringify(oldAddy))
	          },
	          replaceKey: {
	            original: 'address-block',
	            replace: labels.replaceKey
	          },
	          done: function done(data, textStatus, jqXHR, options) {
	            if (checkoutPage === 'review' && costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
	              COSTCO.CreditCard.initComplete = false;
	            }
	            COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	          },
	          ajax_update_post_done: function ajax_update_post_done() {
	            if (typeof checkoutPage != 'undefined') {
	              apiAlreadyCalled = undefined;
	              COSTCO.OrderItems.init();
	
	              if (checkoutPage == 'review') {
	                COSTCO.CreditCard.initComplete = false;
	                COSTCO.CreditCard.init();
	                if (COSTCO.util.isBusinessDelivery()) {
	                  COSTCO.Header.miniShopCartRefresh();
	                }
	              }
	            }
	            if (COSTCO.util.isBusinessDelivery() && newAddy.addressType == 'B') {
	              COSTCO.dialog.close();
	            }
	            $('body').trigger('costco.address.selected', newAddy);
	          },
	          ajax_handle_errors: function ajax_handle_errors(response_obj) {
	
	            var $errorContainer = $('#header-error-container');
	
	            var application = response_obj.error.application || [];
	            var exception = response_obj.error.exception || [];
	            var error_html = '';
	            if (exception.length > 0) {
	              error_html += '<p>An unexpected error has occured</p>';
	            }
	            application.forEach(function (error_message) {
	              error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
	            });
	
	            if (response_obj.error.redirect && error_html && error_html.indexOf(messages.ERR_INVALID_DUALCART_MSG) > -1) {
	              document.location.href = '/' + response_obj.error.redirect;
	              return;
	            }
	
	            var warning_data = response_obj.payload.data[0] || [];
	            var warning_status = warning_data["warning"] || [];
	            if (warning_status.length > 0) {
	              var warning_message = warning_data["message"];
	              error_html += '<p>' + warning_message + '</p>';
	            }
	
	            if (error_html == '' || error_html.length == 0) {
	              $('body').trigger('costco.ajax.content.update.sucess', response_obj);
	
	              if ($errorContainer.length > 0) {
	                $errorContainer.children().remove();
	                $errorContainer.removeClass('critical-notification');
	              }
	            } else {
	              if ($errorContainer.length > 0) {
	                $errorContainer.children().remove();
	                $errorContainer.addClass('critical-notification');
	                $errorContainer.append(error_html);
	              }
	
	              if (COSTCO.util.has_errors(response_obj)) {
	                $('body').trigger('costco.ajax.content.update.error', response_obj);
	              }
	            }
	          },
	          always: function always() {
	            COSTCO.Checkout.ajax_update_default_always(inputContainer);
	            COSTCO.preauthchargesmodal.init();
	          },
	          inputContainer: inputContainer,
	          scrollToError: false
	        });
	      };
	
	      if (newAddy.addressType === 'S' && (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) || checkoutPage != 'shipping' && checkoutPage != 'review')) {
	        var submitZipCodeForValidation = function submitZipCodeForValidation() {
	          var submitParams = [orderItemId];
	          var form = $('#formshipping');
	          var callBack = COSTCO.CAddress.addressValidateSuccessOnChooseAddress;
	          if (checkoutPage == 'review') {
	            form = $('#formreview');
	          }
	          form.find("input[name=zipCodeFormDeliveryZipCode]").val(newAddy.zip);
	          COSTCO.zipCodeModal.submitZipCodeForValidation(form, callBack, null, submitParams, oldAddy, newAddy);
	        };
	
	        var serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	        serviceToUpdateCookies(newAddy.zip).then(function () {
	          if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping')) {
	            submitZipCodeForValidation();
	          } else {
	            callChooseAddress();
	          }
	        }, function () {
	          //Allow the flow for CABD here, as we allow all codes if FSA is right, and delivery not segmented
	          if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isCABDStore() && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping')) {
	            submitZipCodeForValidation();
	          }
	        });
	      } else {
	        callChooseAddress();
	      }
	    },
	    addressSetZipSuccess: function addressSetZipSuccess(data, params, form, newAddy) {
	      if (data.errorMessage) {
	        $('#addressFormInlineButton').removeAttr('disabled');
	        COSTCO.CAddressForm.addressNotServicedModal(newAddy, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        });
	      } else {
	        //AJAX CALL to Merge Contract
	        $.ajax({
	          url: '/CheckoutCartView',
	          type: 'POST',
	          data: { skipCartRedirect: true
	          },
	          dataType: 'html',
	          success: function success(data, textStatus, xhr) {
	            if (typeof checkoutPage != 'undefined') {
	              COSTCO.OrderItems.order_prepare();
	
	              // USBD only: force re-init of COSTCO.CreditCard when changing to delivery address ZIP on Place Order
	              if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && checkoutPage == 'review' && typeof COSTCO.CreditCard !== 'undefined') {
	                COSTCO.CreditCard.initComplete = false;
	              }
	            } else {
	              window.location.reload();
	            }
	          },
	          error: function error(xhr, textStatus, errorThrown) {
	            if (typeof checkoutPage != 'undefined') {
	              COSTCO.OrderItems.order_prepare();
	            } else {
	              window.location.reload();
	            }
	          }
	        });
	      }
	    },
	    /**
	     * Choose new address.
	     * @return {void}
	     */
	    callChooseAddressNew: function callChooseAddressNew(orderItemId, oldAddy, newAddy, data) {
	      var labels = CAddress.getHeaderLabels(oldAddy['addressType'], 'choose');
	      var inputContainer = '#address_change_' + newAddy.id;
	      if (orderItemId) {
	        inputContainer = '#address_change_' + newAddy.id + '_' + orderItemId;
	      }
	
	      var options = {
	        url: CAddress.urlChoose(orderItemId),
	        method: "POST",
	        dataType: 'json',
	        data: {
	          'authToken': COSTCO.Checkout.getAuthToken(),
	          formdata: encodeURIComponent(JSON.stringify(oldAddy)),
	          userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
	        },
	        replaceKey: {
	          original: 'address-block',
	          replace: labels.replaceKey
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
	            COSTCO.CreditCard.initComplete = false;
	          }
	          // BD only: Update WC_BD_LOC cookie if ZIP is also changed on address change
	          if (COSTCO.util.isBusinessDelivery() && options.changeZip) {
	            if ($('#isGeocodeService').val() != "true") {
	              COSTCO.util.callBingAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	            } else {
	              COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	            }
	          }
	          COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	        },
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          /* Default function body, extracted so it can be combined with promises. */
	          function postDone(data) {
	            COSTCO.CAddress.closeModal();
	            COSTCO.CAddress.bindEvents();
	            COSTCO.OrderItems.init();
	
	            if (checkoutPage === 'review') {
	              COSTCO.CreditCard.initComplete = false;
	              COSTCO.CreditCard.init();
	              if (COSTCO.util.isBusinessDelivery()) {
	                COSTCO.Header.miniShopCartRefresh();
	              }
	            }
	            if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && $('#residential-address-notification').length) {
	              $('#residential-address-notification').remove();
	            }
	          }
	          if (typeof checkoutPage != 'undefined') {
	            // STRY0183851: BD only - in case of mismatch with Accertify.jspf cookie data, ajax-refresh Payment section
	            if (COSTCO.util.isBusinessDelivery() && checkoutPage != 'cart' && $('input#whs-cookie-accertify').length && COSTCO.util.getBDZipCookie().warehouseNumber != $('input#whs-cookie-accertify').val()) {
	              COSTCO.Checkout.ajaxRefreshAllCheckoutSections().then(function () {
	                postDone(data);
	              });
	            } else {
	              postDone(data);
	            }
	          }
	        },
	
	        always: function always() {
	          COSTCO.Checkout.ajax_update_default_always(inputContainer);
	          COSTCO.preauthchargesmodal.init();
	        },
	        inputContainer: inputContainer,
	        scrollToError: false,
	        changeZip: oldAddy.zip != newAddy.zip
	      };
	      COSTCO.Checkout.ajax_update_state(options);
	    },
	    addressValidateSuccessOnChooseAddress: function addressValidateSuccessOnChooseAddress(data, params, form, chosenAddress, oldAddy) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      //Set address type
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (data.WarehouseChange && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (data.WarehouseChange && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	        data.userSelectionDeliveryMethod = userDeliveryMethod;
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        if (oldAddy == null) {
	          COSTCO.CAddress.callAddressAddNew(params[2], params[3], chosenAddress, params[4]);
	        } else {
	          COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, chosenAddress);
	        }
	      } else if ((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local') && isUserCurrentOrderItemsAvailable) {
	        COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod, oldAddy, chosenAddress);
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod, oldAddy, chosenAddress);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[2] || data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
	              COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod, oldAddy, chosenAddress);
	            } else {
	              if (oldAddy == null) {
	                COSTCO.CAddress.callAddressAddNew(params[2], params[3], chosenAddress, params[4], data);
	              } else {
	                COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, chosenAddress, data);
	              }
	            }
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    launchModalOnAddrChange: function launchModalOnAddrChange(data, params, form, verifiedAddress, userDeliveryMethod, oldAddy, newAddy) {
	
	      var fromZipCodeToDisplay = data.bdZipCookieOriginal;
	      if (fromZipCodeToDisplay == null || fromZipCodeToDisplay == "undefined" || fromZipCodeToDisplay == "") {
	        fromZipCodeToDisplay = data.CurrentDeliveryZip;
	      }
	
	      var popupMsg = "";
	      var isCheckoutFlow = false;
	      if (typeof checkoutPage !== 'undefined') {
	        if (checkoutPage == 'review' || checkoutPage == 'shipping') {
	          isCheckoutFlow = true;
	        }
	      }
	      if (!COSTCO.util.isNdEnabled()) {
	        // ND disabled flow
	        popupMsg = COSTCO.util.isUSBDStore() ? messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF_USBD : messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF;
	        popupMsg = popupMsg.replace(/\{0\}/g, fromZipCodeToDisplay);
	        popupMsg = popupMsg.replace(/\{1\}/g, data.SetDeliveryZip);
	      } else if (data.RegisteredUser) {
	        // ND enabled flow
	        if (data.InactiveZipMessage.length > 0) {
	          popupMsg = data.InactiveZipMessage;
	        } else if (data.NewWarehouseAlert.length > 0) {
	          popupMsg = data.NewWarehouseAlert;
	        } else if (!isCheckoutFlow && (data.ExternalCarrierChange || data.WarehouseChange) || isCheckoutFlow && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data.WarehouseChange && userDeliveryMethod == 'Local') {
	          var errorMessage2;
	          if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
	            errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
	          } else {
	            errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
	          }
	          errorMessage2 = errorMessage2.replace(/\{0\}/g, fromZipCodeToDisplay);
	          errorMessage2 = errorMessage2.replace(/\{1\}/g, data.SetDeliveryZip);
	          popupMsg = errorMessage2;
	        } else {
	          var errorMessage3;
	          if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
	            errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
	          } else {
	            errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
	          }
	          errorMessage3 = errorMessage3.replace(/\{0\}/g, fromZipCodeToDisplay);
	          errorMessage3 = errorMessage3.replace(/\{1\}/g, data.SetDeliveryZip);
	          popupMsg = errorMessage3;
	        }
	      } else {
	        var errorMessage1;
	        if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
	          errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
	        } else {
	          errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
	        }
	        errorMessage1 = errorMessage1.replace(/\{0\}/g, fromZipCodeToDisplay);
	        errorMessage1 = errorMessage1.replace(/\{1\}/g, data.SetDeliveryZip);
	        popupMsg = errorMessage1;
	      }
	
	      if (data.StatusMessage == data.ZipStatusMessageList[5]) {
	        COSTCO.zipCodeModal.dialogAlert(popupMsg, form);
	      } else if (data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7] && userDeliveryMethod && !(data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data.WarehouseChange && userDeliveryMethod == 'Local')) {
	        COSTCO.CAddress.changeZipDialogOnAddrChange(data, params, popupMsg, form, verifiedAddress, userDeliveryMethod, oldAddy, newAddy);
	      } else {
	        if (COSTCO.util.isNdEnabled()) {
	          COSTCO.CAddress.dialogOnAddrChange(data.SetDeliveryZip, params, popupMsg, form, data, userDeliveryMethod, oldAddy, newAddy);
	        } else {
	          COSTCO.CAddress.dialogOnAddrChange(data.SetDeliveryZip, params, popupMsg, form, null, null, oldAddy, newAddy);
	        }
	      }
	    },
	    changeZipDialogOnAddrChange: function changeZipDialogOnAddrChange(data, params, popupMsg, form, verifiedAddress, userAddressType, oldAddy, newAddy) {
	      var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
	      var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
	      var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
	      COSTCO.dialog.createExtDialogBox({
	        title: titleMsg,
	        body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode', {
	          messageTxt: popupMsg,
	          msgQuestion: messageQues }),
	        primary: primaryButton,
	        secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
	        primary_event: function primary_event() {
	          if (data != null && data.ShowAddressTypePopup && data.redirectURL[0] == "SetDeliveryZip") {
	            if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
	              $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val('Local');
	              COSTCO.zipCodeModal.submitZipCode(form);
	            } else {
	              COSTCO.zipCodeModal.viewAddressTypeModal(form, data, params);
	            }
	          } else if (COSTCO.util.isNdEnabled() && data && (data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) && data.ShowDeliveryMethodPopup) {
	            COSTCO.CAddressVerification.viewDeliveryMethodModal(form, data, params, oldAddy, newAddy);
	          } else {
	            if (oldAddy == null) {
	              //add address flow
	              COSTCO.CAddress.callAddressAddNew(params[2], params[3], newAddy, params[4]);
	            } else {
	              COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, newAddy);
	            }
	          }
	        }
	      });
	      $('.close').removeClass("hidden");
	    },
	    dialogOnAddrChange: function dialogOnAddrChange(currentZip, optParams, popupMsg, form, data, userDeliveryMethod, oldAddy, newAddy) {
	      var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
	      var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
	      var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
	      COSTCO.dialog.createExtDialogBox({
	        title: titleMsg,
	        body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode', {
	          messageTxt: popupMsg,
	          msgQuestion: messageQues }),
	        primary: primaryButton,
	        secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
	        primary_event: function primary_event() {
	          if (COSTCO.util.isNdEnabled() && data && data.StatusMessage == data.ZipStatusMessageList[7] && data.ShowDeliveryMethodPopup) {
	            COSTCO.CAddressVerification.viewDeliveryMethodModal(form, data, optParams, oldAddy, newAddy);
	          } else {
	            if (oldAddy == null) {
	              //add address flow
	              COSTCO.CAddress.callAddressAddNew(optParams[2], optParams[3], newAddy, optParams[4], data);
	            } else {
	              COSTCO.CAddress.callChooseAddressNew(optParams[2], oldAddy, newAddy, data);
	            }
	          }
	        }
	      });
	    },
	    /**
	     * Add new address.
	     * @return {void}
	     */
	    callAddressAddNew: function callAddressAddNew(addressType, addressOptions, verifiedAddress, preventajaxhtml, data) {
	
	      CAddress.applyAddressToWhat(addressType);
	      if (checkoutPage == 'review' || checkoutPage == 'shipping') {
	        isCheckoutFlow = true;
	      }
	      if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && !isCheckoutFlow) {
	        CAddress.addressTools.applyAddressToOrderItems = 'false';
	      }
	      var labels = CAddress.getHeaderLabels(addressType, 'add');
	      var options = {
	        url: verifiedAddress.id !== "" ? CAddress.urlAddUpdate(addressOptions) : CAddress.urlAdd(addressOptions),
	        method: "POST",
	        dataType: 'json',
	        data: {
	          'authToken': COSTCO.Checkout.getAuthToken(),
	          formdata: encodeURIComponent(JSON.stringify(verifiedAddress)),
	          userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
	        },
	        replaceKey: {
	          original: 'address-block',
	          replace: labels.replaceKey
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && COSTCO.CreditCard !== undefined) {
	            COSTCO.CreditCard.initComplete = false;
	          }
	          if (!data.errorMessage) {
	            COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	          } else {
	            var parentNode = document.getElementById("costcoModalText");
	            if (parentNode !== null) {
	              var newDiv = document.createElement("div");
	              newDiv.innerHTML = data.errorMessage;
	              newDiv.className = 'error';
	              parentNode.prepend(newDiv);
	            }
	          }
	        },
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          /* Default function body, extracted so it can be combined with promises. */
	          function postDone(data) {
	            var application = data.error.application;
	            if (application.length === 0) {
	              COSTCO.util.resetAddressLoadState();
	              COSTCO.CAddress.closeModal();
	              $('body').trigger("costco.address.added", data.payload.data[1]);
	            } else {
	              $('body').trigger("costco.address.error", application);
	            }
	            CAddress.bindEvents();
	            if (addressOptions.addressBookReinit) {
	              COSTCO.CAddressBook.init();
	            }
	            if (checkoutPage) {
	              COSTCO.OrderItems.init();
	
	              if (checkoutPage === 'review') {
	                COSTCO.CreditCard.initComplete = false;
	                COSTCO.CreditCard.init();
	                if (COSTCO.util.isBusinessDelivery()) {
	                  COSTCO.Header.miniShopCartRefresh();
	                  COSTCO.preauthchargesmodal.init();
	                }
	              }
	              if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && $('#residential-address-notification').length) {
	                $('#residential-address-notification').remove();
	              }
	            }
	          }
	          // STRY0183851: BD only - in case of mismatch with Accertify.jspf cookie data, ajax-refresh Payment section
	          if (typeof checkoutPage != 'undefined' && checkoutPage != 'cart' && COSTCO.util.isBusinessDelivery() && $('input#whs-cookie-accertify').length && COSTCO.util.getBDZipCookie().warehouseNumber != $('input#whs-cookie-accertify').val()) {
	            COSTCO.Checkout.ajaxRefreshAllCheckoutSections().then(function () {
	              postDone(data);
	            });
	          } else {
	            postDone(data);
	          }
	        }
	      };
	      if (preventajaxhtml) {
	        options.ajax_replace_content = function () {};
	      }
	      COSTCO.Checkout.ajax_update_state(options);
	    },
	    addressValidateSuccess: function addressValidateSuccess(data, params, form, verifiedAddress) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (!data.ShowDeliveryMethodPopup && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (!data.ShowDeliveryMethodPopup && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (!data.ShowDeliveryMethodPopup && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(verifiedAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        COSTCO.CAddress.submitAddress(data, params, form, verifiedAddress);
	        $('body').bind('costco.address.added', function (event, address) {
	          $('#NewAddressSingleShippingForm input[name="addressId"]').val(address.addressId);
	          $('#NewAddressSingleShippingForm').submit();
	        });
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.zipCodeModal.launchModal(data, params, form, verifiedAddress);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[2] || data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data)) {
	              COSTCO.zipCodeModal.launchModal(data, params, form, verifiedAddress);
	            } else {
	              if (COSTCO.util.isNdEnabled() && (data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) && userDeliveryMethod == 'Local') {
	                COSTCO.CAddressForm.showNationalDeliveryQuestionnaireModal_v2(form, data, params, verifiedAddress);
	              } else {
	                data.userSelectionDeliveryMethod = userDeliveryMethod;
	                COSTCO.CAddress.submitAddress(data, params, form, verifiedAddress);
	                $('body').bind('costco.address.added', function (event, address) {
	                  $('#NewAddressSingleShippingForm input[name="addressId"]').val(address.addressId);
	                  $('#NewAddressSingleShippingForm').submit();
	                });
	              }
	            }
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(verifiedAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    submitAddress: function submitAddress(data, params, form, verifiedAddress) {
	      if (data != null && data.BargeOrderZip == false) {
	        COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
	        COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	        $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
	      }
	      var addressType = '';
	      if (verifiedAddress.addressType == null) {
	        addressType = verifiedAddress.addressType2.trim();
	      } else {
	        addressType = verifiedAddress.addressType.trim();
	      }
	      CAddress.applyAddressToWhat(addressType);
	      var labels = CAddress.getHeaderLabels(addressType, 'add');
	      var options = {
	        url: verifiedAddress.id != "" ? CAddress.urlAddUpdate() : CAddress.urlAdd(),
	        method: "POST",
	        dataType: 'json',
	        data: {
	          'authToken': COSTCO.Checkout.getAuthToken(),
	          formdata: encodeURIComponent(JSON.stringify(verifiedAddress)),
	          userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
	        },
	        replaceKey: {
	          original: 'address-block',
	          replace: labels.replaceKey
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          if (!data.errorMessage) {
	            COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	          } else {
	            var parentNode = document.getElementById("costcoModalText");
	            if (parentNode != null) {
	              var newDiv = document.createElement("div");
	              newDiv.innerHTML = data.errorMessage;
	              newDiv.className = 'error';
	              parentNode.prepend(newDiv);
	            }
	          }
	        },
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          var application = data.error.application;
	          if (application.length == 0) {
	            COSTCO.util.resetAddressLoadState();
	            COSTCO.CAddress.closeModal();
	            $('body').trigger("costco.address.added", data.payload.data[1]);
	          } else {
	            $('body').trigger("costco.address.error", application);
	          }
	          CAddress.bindEvents();
	          if (typeof checkoutPage != 'undefined' && checkoutPage) {
	            COSTCO.OrderItems.init();
	            if (checkoutPage == 'review' && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
	              COSTCO.CAddress.initializeCreditCardModule();
	            } else if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && $('#shipping #address-modal-inline').length === 0) {
	              COSTCO.CAddress.initializeCreditCardModule();
	            }
	          }
	        }
	      };
	      COSTCO.Checkout.ajax_update_state(options);
	    },
	    initializeCreditCardModule: function initializeCreditCardModule() {
	      COSTCO.CreditCard.initComplete = false;
	      COSTCO.CreditCard.init();
	    },
	    addressValidateSuccessOnPlaceOrder: function addressValidateSuccessOnPlaceOrder(data, params, form, chosenAddress) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      //Set address type
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (data.WarehouseChange && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (data.WarehouseChange && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	        data.userSelectionDeliveryMethod = userDeliveryMethod;
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        COSTCO.OrderSummary.placeOrder();
	      } else if ((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local') && isUserCurrentOrderItemsAvailable) {
	        COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form, undefined, userDeliveryMethod);
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
	              COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	            } else {
	              COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
	              COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	              $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
	              COSTCO.OrderSummary.placeOrder();
	            }
	          } else if (data.StatusMessage == data.ZipStatusMessageList[2]) {
	            COSTCO.OrderSummary.placeOrder();
	          } else if (data.StatusMessage == data.ZipStatusMessageList[5] && data.NewWarehouseAlert.length > 0) {
	            COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form);
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    addressValidateSuccessOnSubmitShipping: function addressValidateSuccessOnSubmitShipping(data, params, form, chosenAddress) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      //Set address type
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (data.WarehouseChange && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (data.WarehouseChange && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	        data.userSelectionDeliveryMethod = userDeliveryMethod;
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
	        $('#NewAddressSingleShippingForm').submit();
	      } else if ((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local') && isUserCurrentOrderItemsAvailable) {
	        COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form, undefined, userDeliveryMethod);
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
	              COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	            } else {
	              COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
	              COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	              $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
	              $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
	              $('#NewAddressSingleShippingForm input[name="orderShipmodeId"]').val($('form#CheckoutReviewForm input[name=orderShipmodeId]').val());
	              $('#NewAddressSingleShippingForm').submit();
	            }
	          } else if (data.StatusMessage == data.ZipStatusMessageList[2]) {
	            $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
	            $('#NewAddressSingleShippingForm').submit();
	          } else if (data.StatusMessage == data.ZipStatusMessageList[5] && data.NewWarehouseAlert.length > 0) {
	            COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form);
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    addEditAddress: function addEditAddress(verifiedAddress, preventajaxhtml, addressOptions, message) {
	
	      if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && !COSTCO.CAddressForm.isFormCompleted('S') && verifiedAddress.addressType != 'B' && checkoutPage) {
	        if (checkoutPage === 'shipping') {
	          //COSTCO.CAddress.submitAddress(null, verifiedAddress.id, $('#formshipping'), verifiedAddress);
	          $('#formshipping').find('[name=zipCodeFormDeliveryZipCode]').val(verifiedAddress.zip);
	          COSTCO.zipCodeModal.submitZipCodeForValidation($('#formshipping'), COSTCO.CAddress.addressValidateSuccess, COSTCO.CAddress.addressSetZipSuccess, verifiedAddress.id, undefined, verifiedAddress);
	        } else if (checkoutPage === 'review') {
	          $('#formreview').find('[name=zipCodeFormDeliveryZipCode]').val(verifiedAddress.zip);
	          COSTCO.zipCodeModal.submitZipCodeForValidation($('#formreview'), COSTCO.CAddress.addressValidateSuccess, COSTCO.CAddress.addressSetZipSuccess, verifiedAddress.id, undefined, verifiedAddress);
	        }
	      } else {
	        var callAddressAdd = function callAddressAdd(addressType) {
	          CAddress.applyAddressToWhat(addressType);
	          if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val())) {
	            CAddress.addressTools.applyAddressToOrderItems = 'false';
	          }
	          var labels = CAddress.getHeaderLabels(addressType, 'add');
	          var oldZipcode;
	          var orderHasEddItems = $('#orderHasEddItems').val();
	          if (!addressOptions.addressBookReinit && verifiedAddress.addressType === 'S' && undefined !== orderHasEddItems) {
	            if (orderHasEddItems === 'true') {
	              oldZipcode = $.cookie("invCheckPostalCode");
	              if (typeof sessionStorage !== "undefined" && null !== oldZipcode) {
	                sessionStorage.setItem('oldZipcode', oldZipcode);
	              }
	              $.cookie("invCheckPostalCode", verifiedAddress.zip.toUpperCase());
	              $.cookie("invCheckStateCode", verifiedAddress.state);
	              $.cookie("invCheckCity", verifiedAddress.city);
	            }
	
	            //update WAREHOUSEDELIVERY_WHS cookie
	            if (!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof verifiedAddress.zip !== 'undefined') {
	              CAddress.updateWarehouseCookie(verifiedAddress.zip.toUpperCase());
	            }
	          }
	          var options = {
	            url: verifiedAddress.id !== "" ? CAddress.urlAddUpdate(addressOptions) : CAddress.urlAdd(addressOptions),
	            method: "POST",
	            dataType: 'json',
	            data: { 'authToken': COSTCO.Checkout.getAuthToken(), 'oldZipcode': oldZipcode, formdata: encodeURIComponent(JSON.stringify(verifiedAddress)) },
	
	            replaceKey: {
	              original: 'address-block',
	              replace: labels.replaceKey
	            },
	            done: function done(data, textStatus, jqXHR, options) {
	              if (!data.errorMessage) {
	                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
	                  COSTCO.CreditCard.initComplete = false;
	                }
	                COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	              } else {
	                var parentNode = document.getElementById("costcoModalText");
	                if (parentNode !== null) {
	                  var newDiv = document.createElement("div");
	                  //BD ALM-3463 fix repetitive error msg
	                  if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val())) {
	                    var errorDiv = document.getElementById("addressValidationError");
	                    if (errorDiv !== null) {
	                      errorDiv.remove();
	                    }
	                    newDiv.id = 'addressValidationError';
	                  }
	                  newDiv.innerHTML = data.errorMessage;
	                  newDiv.className = 'error';
	                  parentNode.prepend(newDiv);
	                }
	              }
	            },
	            ajax_update_post_done: function ajax_update_post_done(data) {
	              var application = data.error.application;
	              if (application.length === 0) {
	                COSTCO.util.resetAddressLoadState();
	                COSTCO.CAddress.closeModal();
	                $('body').trigger("costco.address.added", data.payload.data[1]);
	              } else {
	                $('body').trigger("costco.address.error", application);
	              }
	              CAddress.bindEvents();
	              if (addressOptions.addressBookReinit) {
	                COSTCO.CAddressBook.init();
	              }
	              if (typeof checkoutPage !== 'undefined' && checkoutPage) {
	                apiAlreadyCalled = undefined;
	                COSTCO.OrderItems.init();
	
	                if (checkoutPage === 'review') {
	                  COSTCO.CreditCard.initComplete = false;
	                  COSTCO.CreditCard.init();
	                  if (COSTCO.util.isBusinessDelivery()) {
	                    COSTCO.Header.miniShopCartRefresh();
	                  }
	                }
	              }
	            },
	            always: function always() {
	              COSTCO.preauthchargesmodal.init();
	            }
	          };
	          if (preventajaxhtml) {
	            options.ajax_replace_content = function () {};
	          }
	          COSTCO.Checkout.ajax_update_state(options);
	        };
	
	        var addressType = '';
	        if (verifiedAddress.addressType === null) {
	          addressType = verifiedAddress.addressType2 !== null ? verifiedAddress.addressType2.trim() : '';
	        } else {
	          addressType = verifiedAddress.addressType.trim();
	          var uniquePageSelector = '';
	          if (typeof checkoutPage !== 'undefined' && checkoutPage) {
	            if (checkoutPage === 'multi-shipping') {
	              uniquePageSelector = '#single-page-checkout-multi-address';
	            } else {
	              uniquePageSelector = '#shipping';
	            }
	          } else {
	            uniquePageSelector = '#shippingTab';
	          }
	          $(uniquePageSelector).find('input[id="addressEnteredForCheck"]').remove();
	          $(uniquePageSelector).append('<input type="hidden" id="addressEnteredForCheck" value="' + verifiedAddress.line1 + '"/>');
	        }
	        // Prevent code breaking if checkoutPage is undefined to fix STRY0158367-Use-
	        // address-functionality-does-notrespond-from-the-address-validation-modal
	        var checkoutPageName = typeof checkoutPage === 'undefined' ? false : checkoutPage;
	
	        if (addressType === 'S' && !addressOptions.addressBookReinit && (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) || checkoutPageName != 'shipping' && checkoutPageName != 'review')) {
	          var submitZipCodeForValidation = function submitZipCodeForValidation() {
	            var submitParams = [addressType, addressOptions, preventajaxhtml];
	            var form = $('#formshipping');
	            var callBack = COSTCO.CAddress.addressValidateSuccessOnChooseAddress;
	            if (checkoutPage == 'review') {
	              form = $('#formreview');
	            }
	            form.find("input[name=zipCodeFormDeliveryZipCode]").val(verifiedAddress.zip);
	            COSTCO.zipCodeModal.submitZipCodeForValidation(form, callBack, null, submitParams, null, verifiedAddress);
	          };
	          var serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	          serviceToUpdateCookies(verifiedAddress.zip).then(function () {
	            if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping') && message != 'editAddressType') {
	              submitZipCodeForValidation();
	            } else {
	              callAddressAdd(addressType);
	            }
	          }, function () {
	            //Allow the flow for CABD here, as we allow all codes if FSA is right, and delivery not segmented
	            if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isCABDStore() && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping') && message != 'editAddressType') {
	              submitZipCodeForValidation();
	            }
	          });
	        } else {
	          callAddressAdd(addressType);
	        }
	      }
	    },
	    getAddressType: function getAddressType(addressId, type) {
	      var string = '';
	      for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	        if (COSTCO.util.addresses[i].id == addressId) {
	          string = COSTCO.util.addresses[i].addressType.toUpperCase();
	          break;
	        }
	      }
	      if (string == '' && typeof type !== 'undefined') {
	        string = type;
	      }
	      return string;
	    },
	    getAddressElement: function getAddressElement(addyId, prop, wholeObj) {
	      for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	        // return specific obj
	        if (wholeObj == true) {
	          if (COSTCO.util.addresses[i].id == addyId) {
	            return COSTCO.util.addresses[i];
	          }
	        } else if (COSTCO.util.addresses[i].id == addyId) {
	          // return specific property
	          return COSTCO.util.addresses[i][prop];
	        }
	      }
	    },
	    getSaveAddress: function getSaveAddress(addressId, isChecked) {
	      return addressId != '' ? CAddress.getAddressElement(addressId, 'addressType') == 'T' ? 'off' : 'on' : isChecked ? 'on' : 'off';
	    },
	    getDefaultAddress: function getDefaultAddress(addressId, isChecked) {
	      if (isChecked) return 'on';
	      return 'off';
	    },
	    isEmptyAddressType: function isEmptyAddressType(type, addyObj) {
	      for (obj in addyObj) {
	        if (addyObj[obj].addressType === type) return false;
	      }
	      return true;
	    },
	    handleServerError: function handleServerError(msg) {
	      // put msg and show associated modal
	      $(CAddress.addressTools.errorContainer).text(msg).show();
	      if ($('.address-edit[addressid=' + CAddress.addressTools.cachedAddressId + ']').length > 0) {
	        $('.address-edit[addressid=' + CAddress.addressTools.cachedAddressId + ']').click();
	      } else if (CAddress.addressTools.errorContainer == '#address-form .text-error') {
	        $('#address-form-modal').costcoModal('showPartial full-page');
	      }
	      $('div').scrollTop($(CAddress.addressTools.errorContainer).offset().top - $('div').offset().top + $('div').scrollTop());
	    },
	    /**
	     * If the user changes their address for grocery items, associate the
	     * new address with all of the grocery items. Where 'this' is the select
	     * DOM element. Called inline on MultiShippingItemAddress.jsp.
	     * @return {void}
	     */
	    groceryItemAddress: function groceryItemAddress() {
	      var selectedGroceryAddress = $(this).val();
	      var $groceryAddresses = $('.grocery-address [name^=addressId_]');
	      $groceryAddresses.val(selectedGroceryAddress);
	    },
	    //-End-Grocery changes
	    getAddressJson: function getAddressJson(addressId, startAddress, type) {
	      if (typeof addressId == 'undefined') {
	        return COSTCO.util.addresses;
	      }
	
	      if (typeof COSTCO.util == 'undefined' || COSTCO.util.addresses.length == 0) {
	        return [];
	      }
	      var returnArray = [];
	      if (isNaN(addressId)) {
	        for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	          if (COSTCO.util.addresses[i].addressType.trim() == addressId) {
	            returnArray.push(COSTCO.util.addresses[i]);
	          }
	        }
	      } else {
	        for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	          if (COSTCO.util.addresses[i].id == addressId) {
	            returnArray.push(COSTCO.util.addresses[i]);
	          }
	        }
	      }
	      if (typeof startAddress !== 'undefined') {
	        var foundIndex = 0;
	        for (var i = 0; i < returnArray.length; i++) {
	          if (returnArray[i].id == startAddress) {
	            foundIndex = i;
	          }
	        }
	        if (foundIndex > 0) {
	          var arrayElement = returnArray.splice(foundIndex, 1)[0];
	          returnArray.unshift(arrayElement);
	        }
	      }
	      // Need to trim address types
	      for (var i = 0; i < returnArray.length; i++) {
	        returnArray[i].addressType = returnArray[i].addressType.trim();
	      }
	      return returnArray;
	    },
	    getStateProvJson: function getStateProvJson(callback) {
	      return countries;
	    },
	    /**
	     * Function used to populate city and state in the responsive address form
	     * Function is tied to the postal code element
	     * 
	     * Params
	     * 		element -> jquery query that contain the postalCode input value
	     * 		cityQuery -> jquery query that locate the input for city
	     * 		stateQuery -> jquery query that locate the input for state
	     * 
	     */
	    bingCityState: function bingCityState(element, cityQuery, stateQuery) {
	      var query = $(element).val();
	
	      var updateFormElements = function updateFormElements(data) {
	        var province = null;
	        var country = null;
	        try {
	          //Check out if country is Puerto Rico specific
	          country = data.resourceSets[0].resources[0].address.countryRegionIso2;
	          if (country != undefined && country === 'PR') {
	            province = data.resourceSets[0].resources[0].address.countryRegionIso2;
	            country = 'US';
	          } else {
	            province = data.resourceSets[0].resources[0].address.adminDistrict;
	          }
	        } catch (e) {
	          province = "";
	        }
	        var city = null;
	        try {
	          city = data.resourceSets[0].resources[0].address.locality;
	        } catch (e) {
	          city = "";
	        }
	
	        if (COSTCO.CAddressForm !== undefined) {
	          COSTCO.CAddressForm.populateCityState(element.form, city, province, cityQuery, stateQuery);
	          //COSTCO.CAddressForm.validate();
	        }
	      };
	      COSTCO.util.callBing(query, updateFormElements);
	    },
	    /**
	        * Function used to populate city and state in the responsive address form
	        * Function is tied to the postal code element
	        * 
	        * Params
	        * 		element -> jquery query that contain the postalCode input value
	        * 		cityQuery -> jquery query that locate the input for city
	        * 		stateQuery -> jquery query that locate the input for state
	        * 
	        */
	    geocodeApiCityState: function geocodeApiCityState(element, cityQuery, stateQuery, editAddrCity, editAddrState) {
	
	      var query = $(element).val();
	
	      var updateFormElements = function updateFormElements(data) {
	        var province = null;
	        var country = null;
	        var city = null;
	        try {
	          city = data[0].city;
	          province = data[0].stateProvinceAbbreviation;
	          if (province == null) {
	            province = data[0].stateProvince;
	          }
	          country = data[0].country;
	        } catch (e) {
	          console.error('Error: ' + e.message);
	        }
	
	        if (COSTCO.CAddressForm !== undefined) {
	          COSTCO.CAddressForm.populateCityState(element.form, city, province, cityQuery, stateQuery);
	        }
	      };
	
	      var updateFormElementsFromZipPostalCode = function updateFormElementsFromZipPostalCode(data) {
	        var provinceList = [];
	        var countryList = [];
	        var cityList = [];
	        try {
	          for (var i = 0; i < data.length; i++) {
	            if (data[i].city != undefined && !cityList.find(function (city) {
	              return city === data[i].city;
	            })) {
	              cityList.push(data[i].city);
	            }
	
	            var existingProv = provinceList.find(function (prov) {
	              return prov.code === data[i].stateProvinceAbbreviation;
	            });
	            if (data[i].stateProvinceAbbreviation != undefined && !existingProv) {
	              var prov = new Object();
	              prov.code = data[i].stateProvinceAbbreviation;
	              prov.displayName = data[i].stateProvince != null ? data[i].stateProvince : data[i].stateProvinceAbbreviation;
	              provinceList.push(prov);
	            }
	
	            if (data[i].country != undefined && !countryList.find(function (country) {
	              return country === data[i].country;
	            })) {
	              countryList.push(data[i].country);
	            }
	          }
	        } catch (e) {
	          console.error('Error: ' + e.message);
	        }
	
	        if (COSTCO.CAddressForm !== undefined) {
	          var form = undefined;
	          if ($(element).form) {
	            form = $(element).form;
	          } else if ($(element).prevObject) {
	            form = $(element).prevObject;
	          } else if ($(element).closest('form')) {
	            form = $(element).closest('form');
	          }
	          if (form != undefined) {
	            COSTCO.CAddressForm.populateCityStateForZipPostalCode(form, cityList, provinceList, cityQuery, stateQuery, editAddrCity, editAddrState);
	            // COSTCO.CAddressForm.validate();
	          }
	        }
	      };
	
	      var geocodeCallback = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true" ? updateFormElementsFromZipPostalCode : updateFormElements;
	
	      COSTCO.util.callGeocodeAPI(query, geocodeCallback);
	    },
	
	    bindEvents: function bindEvents() {
	      if (typeof checkoutPage !== "undefined" && checkoutPage === 'multi-shipping') {
	        $('.addressid-selection').unbind('change').change(function () {
	          var selectedOption = $(this).find(':selected');
	          var name = selectedOption.attr('name');
	          if (typeof name !== 'undefined' && name === 'add-new-address-option') {
	            COSTCO.CAddressForm.createNewAddress('S', selectedOption.attr('orderitem-id'), true);
	          }
	        });
	        if ($('#addressId_1 option').length == 1) {
	          $('.addressid-selection').unbind('click').click(function () {
	            var selectedOption = $(this).find(':selected');
	            var name = selectedOption.attr('name');
	            if (typeof name !== 'undefined' && name === 'add-new-address-option') {
	              COSTCO.CAddressForm.createNewAddress('S', selectedOption.attr('orderitem-id'), true);
	            }
	          });
	        }
	      }
	      COSTCO.CAddressForm.initiatePopovers();
	    },
	    /**
	    * Changes the cookie and appends/removes EC as per condition
	    * 
	    */
	    isZipOrDeliveryMethodChange: function isZipOrDeliveryMethodChange(data, userSelection) {
	      var isChanged = false;
	      currentCookie = $.cookie('WC_BD_WHS');
	      if (COSTCO.util.isNdEnabled() && data && userSelection) {
	        if ((userSelection == "Nationwide" || !data.ShowAddressTypePopup) && currentCookie.search("-ND") == -1) {
	          isChanged = true;
	        } else if (userSelection == "Local" && currentCookie.search("-ND") != -1 && data.ShowAddressTypePopup) {
	          isChanged = true;
	        }
	      }
	      if (data && data.CurrentDeliveryZip != data.SetDeliveryZip) {
	        isChanged = true;
	      }
	      return isChanged;
	    },
	    /**
	     * The method sets all the required field so as to save the user selected address type to DB
	     * and calls function to show the Address Type popup
	    */
	    addUserSelectionFromDelivery: function addUserSelectionFromDelivery(obj) {
	
	      var addressJson = COSTCO.CAddress.getAddressJson(obj)[0];
	      var addresstype = addressJson.userAddressType;
	      if (document.querySelector('input[name="nd-radio-group-input"]:checked') != null) {
	        addresstype = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
	      }
	      COSTCO.CAddressVerification.entered = addressJson;
	      COSTCO.CAddressVerification.entered.addressType = "S";
	      COSTCO.CAddressVerification.entered.saveAddress = "on";
	      COSTCO.CAddressVerification.entered.setDefault = "on";
	      COSTCO.CAddressVerification.entered.addressType2 = "S";
	      COSTCO.CAddressVerification.entered.userAddressType = addresstype;
	      COSTCO.CAddressVerification.entered.userAddrTypeUpdate = "Y";
	      COSTCO.CAddressVerification.viewAddressTypeModal(undefined, {}, 'editAddressType');
	    },
	    //update WAREHOUSEDELIVERY_WHS cookie
	    updateWarehouseCookie: function updateWarehouseCookie(zipcode) {
	
	      var parsedCookie = JSON.parse($.cookie('WAREHOUSEDELIVERY_WHS'));
	      var responseJson;
	      var distCenterServiceUrl = $('#distributionCentersUrl').val() + '?destinationPostalCode=' + zipcode.toUpperCase();
	      var headers = {
	        'costco.env': $('#distributionCentersEnv').val(),
	        'costco.service': 'restInventory',
	        'client-identifier': $('#distributionCentersClientId').val()
	      };
	
	      try {
	        $.ajax({
	          url: distCenterServiceUrl,
	          type: 'GET',
	          headers: headers,
	          dataType: 'json',
	          async: false,
	          success: function success(data) {
	            responseJson = data;
	            parsedCookie.distributionCenters = responseJson.distributionCenters;
	            parsedCookie.groceryCenters = responseJson.groceryCenters;
	            $.cookie('WAREHOUSEDELIVERY_WHS', JSON.stringify(parsedCookie));
	          },
	          error: function error(data) {
	            responseJson = data;
	            console.log("Error in updateWarehouseCookie: " + JSON.stringify(responseJson));
	          }
	        });
	      } catch (e) {
	        console.error("Error in updateWarehouseCookie: " + e);
	      }
	    }
	  };
	  if (typeof window.COSTCO === "undefined") {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.CAddress = CAddress;
	  return CAddress;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title preauthchargesmodal.js: Sub-module for Global pages
	 * @description This module is used to display the preauthcharges modal
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (dialog) {
	
		var preauthchargesmodal = {
	
			init: function init() {
				this.attachExternalClass();
			},
	
			attachExternalClass: function attachExternalClass() {
				$('.preauthcharges-text').unbind().on('click', this.bind_external);
			},
	
			bind_external: function bind_external(event) {
				var callerElement = event.target;
				COSTCO.dialog.returnFocusOnCallerElement(callerElement);
				preauthchargesmodal.createDialogBox(this.href);
				event.preventDefault();
			},
	
			createDialogBox: function createDialogBox(url) {
				dialog.createExtDialogBox({
					title: messages.CHECKOUT_PREAUTH_MSG,
					body: COSTCO.util.tmpl('tmpl_preauthcharges_modal', {}),
					primary: messages.CLOSE
				});
			}
	
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.preauthchargesmodal = preauthchargesmodal;
	
		return preauthchargesmodal;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title costcodialog.js: Sub-module for Global pages
	 * @description This module is used to creating Modal
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var dialog = {
	    dialogSettings: null,
	    triggerEvent: null,
	    /**
	     * Create a BS style modal that is customizable
	     * @param  {Object} settings Object with following properties:
	     * - title : string appears in the header portion of the modal
	     * - body : HTML/string that represents the body of the modal
	     * - primary : primary action button name.
	     * - secondary : secondary action button name.z
	     * - primary_event : OPTIONAL custom event to attach to primary button
	     * - url : OPTIONAL url for external link. Used if a primary_event is not provided.
	     * @return {void}
	     */
	    createExtDialogBox: function createExtDialogBox(settings) {
	      // show onetimepopup?
	      if (settings.oneTimePopup && this.isPresentInLocalStorage(settings.url)) {
	        window.open(settings.url);
	        return;
	      }
	      dialog.showAndHideModal(settings);
	    },
	
	    modalObserver: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null,
	      modalObserverState: '',
	      elementCausedModal: undefined,
	      elementCausedSecondModalId: undefined,
	      showingSecondModal: undefined
	    },
	
	    /**
	     * Function used to watch for changes of costco modal
	    */
	    returnFocusOnCallerElement: function returnFocusOnCallerElement(activeElement) {
	      if (dialog.modalObserver.modalObserverState != dialog.modalObserver.state.STARTED) {
	        dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STARTED;
	        if (activeElement !== undefined) {
	          dialog.modalObserver.elementCausedModal = activeElement;
	        }
	        var targetObject = COSTCO.dialog.getModal();
	        if (targetObject.length > 0) {
	          targetObject = targetObject[0];
	          var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              var eventOnClick = false;
	              if (event !== undefined) {
	                eventOnClick = event.target.onclick ? true : false;
	              }
	              //On modal close
	              if (mutation.target.className === "modal fade" && !dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
	                $(dialog.modalObserver.elementCausedModal).focus();
	                dialog.modalObserver.elementCausedModal = undefined;
	                COSTCO.dialog.stopModalObserver();
	              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
	                dialog.modalObserver.showingSecondModal = undefined;
	              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedModal && eventOnClick) {
	                COSTCO.dialog.addParentElementForModalObserver(event.target);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          observerObject.observe(targetObject, {
	            attributes: true,
	            attributeFilter: ["class"]
	          });
	          if (observerObject) {
	            this.modalObserver.observer = observerObject;
	          }
	        }
	      }
	    },
	
	    addParentElementForModalObserver: function addParentElementForModalObserver(activeElement) {
	      dialog.modalObserver.elementCausedSecondModalId = activeElement.id;
	      dialog.modalObserver.showingSecondModal = true;
	    },
	
	    removeParentElementForModalObserver: function removeParentElementForModalObserver(activeElement) {
	      if ($('#' + dialog.modalObserver.elementCausedSecondModalId).get(0)) {
	        $('#' + dialog.modalObserver.elementCausedSecondModalId).get(0).focus();
	        $(document).keyup(function (e) {
	          if (e.key === "Escape") {
	            $(dialog.modalObserver.elementCausedModal).focus();
	            dialog.modalObserver.elementCausedModal = undefined;
	            COSTCO.dialog.stopModalObserver();
	          }
	        });
	      }
	
	      dialog.modalObserver.elementCausedSecondModalId = undefined;
	    },
	
	    stopModalObserver: function stopModalObserver() {
	
	      dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STOPPED;
	
	      this.modalObserver.observer.disconnect();
	    },
	
	    /**
	     * Get the Modal for instances where you need to bind certain events
	     * @return {jQuery.Object} The costcoModal jquery object
	     */
	    getModal: function getModal() {
	      return $('#costcoModal');
	    },
	    /**
	     * [description]
	     * @return {[type]} [description]
	     */
	    isVisible: function isVisible() {
	      if ($('#costcoModal').css('display') == 'none') {
	        return false;
	      } else {
	        return $('#costcoModal').is(':visible');
	      }
	    },
	    /**
	     * [description]
	     * @param  {[type]} settings [description]
	     * @return {void}          [description]
	     */
	    showAndHideModal: function showAndHideModal(settings) {
	      dialog.captureDataBeforeShowingModal(settings);
	      if (COSTCO.dialog.isVisible()) {
	        $('#costcoModal').on('hidden.bs.modal', function () {
	          // Load up a new modal...
	          COSTCO.dialog.showModal(settings);
	        });
	        $('#costcoModal').modal('hide');
	      } else {
	        this.showModal(settings);
	      }
	    },
	    /**
	     * [description]
	     * @param  {[type]} settings [description]
	     * @return {void}          [description]
	     */
	    showModal: function showModal(settings) {
	      dialog.captureDataBeforeShowingModal(settings);
	      //modification for ReturnDialogMOdal.jsp
	      if (settings.url) {
	        $('#select-page').addClass('hidden');
	        $('#add-edit-page').removeClass('hidden');
	      }
	      if (settings.hideCloseButton) {
	        $('.close').addClass('hidden');
	      }
	      //end modification for ReturnDialogMOdal.jsp
	      if (settings.dialogclasses) {
	        $('.modal-dialog').addClass(settings.dialogclasses);
	      }
	      if (settings.hideHeader) {
	        $('.modal-header').hide();
	      } else {
	        $('.modal-header').show();
	        $('#costcoModalTitle').text(settings.title);
	        var modaltitle = settings.title;
	        if (modaltitle == 'Edit Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Shipping Address | X Close");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Shipping Address | Save Address");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Edit Shipping Address | Cancel");
	        }
	        if (modaltitle == 'Add New Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Add New Address Modal | X Close");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Add New Address Modal | Save Address");
	          $("#costcoModalBtn1").removeAttr("data-bi-tc");
	          $("#costcoModalBtn1").attr("data-bi-tc", "ui:Add New Address | Cancel");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Add New Address Modal | Cancel");
	        }
	        if (modaltitle == 'Select Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Select Address Modal | X Close");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Select Address Modal | Cancel");
	        }
	        if (modaltitle == 'Change Pick Up Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	        }
	        if (modaltitle == 'Edit Delivery Address' || modaltitle == 'Edit Billing Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Address | Close Button");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Address | Save Address");
	          $("#costcoModalBtn1").removeAttr("data-bi-tc");
	          $("#costcoModalBtn1").attr("data-bi-tc", "ui:Edit Address | Cancel");
	        }
	        if (settings.close) {
	          $('.close').unbind().on('click', function () {
	            settings.close();
	          });
	        }
	      }
	      // if there is a modal Label specified in the setting used it
	      // otherwise we will use the modal title
	      if (settings.modalLabel) {
	        $('#costcoModal').attr('aria-label', settings.modalLabel);
	        $('#costcoModal').removeAttr('aria-labelledby');
	      } else {
	        if (!settings.hideHeader && settings.title) {
	          $('#costcoModal').attr('aria-labelledby', 'costcoModalTitle');
	          $('#costcoModal').removeAttr('aria-label');
	        }
	      }
	
	      $('#costcoModalText').html(settings.body);
	      if (settings.replaceFooter) {
	        $('#costcoModal .modal-footer').html(settings.replaceFooter);
	      }
	      if (settings.showVerifyMeModal || settings.primary && (settings.primary_event || settings.url)) {
	        $('#costcoModalBtn2').text(settings.primary).show();
	        $('#costcoModalBtn2').removeAttr('automation-id');
	        $('#costcoModalBtn2').attr('automation-id', settings.primary.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() + "_button");
	        if (settings.primary_button_style !== undefined && settings.primary_button_style.includes('rounded')) {
	          $('#costcoModalBtn2').addClass('primary-button-v2');
	        }
	        //since primary button is visible, make the secondary button half the row again
	        if (settings.secondary != undefined || settings.setHalfButtons) {
	          $('.costcoModalBtn1').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
	          $('#costcoModalBtn2').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
	          $('.costcoModalBtn1').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
	          $('#costcoModalBtn2').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
	        } else {
	          $('#costcoModalBtn2').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
	          $('#costcoModalBtn2').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
	        }
	        if (settings.showVerifyMeModal) {
	          $('#costcoModalBtn2').html(settings.showVerifyMeModalText);
	          $('#costcoModalBtn2').addClass('verify-me-button');
	          $('#costcoModalBtn2').removeClass('primary-button-v2');
	          $('#costcoModalBtn2').removeClass('btn-primary');
	          $('#costcoModalBtn2').addClass('no-padding');
	        } else {
	          $('#costcoModalBtn2').removeClass('verify-me-button');
	        }
	      } else {
	        $('#costcoModalBtn2').hide();
	        //since primary event button is hidden, make the secondary button span the whole row
	        $('.costcoModalBtn1').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
	        $('.costcoModalBtn1').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
	      }
	      if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('rounded')) {
	        $('.costcoModalBtn1').addClass('secondary-button-v2');
	      } else if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('tertiary')) {
	        $('.costcoModalBtn1').addClass('tertiary-alternative-button-v2');
	        $('.costcoModalBtn1').removeClass('btn-tertiary secondary-button-v2');
	      }
	
	      if (settings.hideFooter) {
	        $('.modal-footer').hide();
	      } else {
	        $('.modal-footer').show();
	      }
	      if (settings.primaryDisabled) {
	        $('#costcoModalBtn2').addClass('btn-disabled');
	      } else {
	        $('#costcoModalBtn2').removeClass('btn-disabled');
	      }
	      if (settings.secondary) {
	        $('.costcoModalBtn1').text(settings.secondary).show();
	      } else {
	        $('.costcoModalBtn1').hide();
	      }
	      if (settings.close) {
	        $('.close').unbind().on('click', function () {
	          //modification for ReturnDialogMOdal.jsp
	          if (settings.url == undefined) {
	            $('#select-page').removeClass('hidden');
	            $('#add-edit-page').addClass('hidden');
	          }
	          //end modification for ReturnDialogMOdal.jsp
	
	          settings.close();
	        });
	      }
	
	      if (settings.footerText) {
	        $('#costcoModalFooterText').html(settings.footerText);
	        $('#costcoModalFooterText').removeClass('hide');
	      } else {
	        $('#costcoModalFooterText').addClass('hide');
	      }
	      // Hides the default modal footer and shows the alternate modal footer
	      if (settings.footerText2) {
	        $('#costcoModalFooterText2').html(settings.footerText2);
	        $('#costcoModalFooterText2').removeClass('hide');
	      } else {
	        $('#costcoModalFooterText2').addClass('hide');
	      }
	
	      $('#commercial-indicator, #residental-indicator').unbind().on('keydown keypress', function (event) {
	        if (event.which === 32) {
	          $(this).click();
	        } else if (event.which === 38 || event.which === 40) {
	          //cursors up and down
	          var $controlIndicators = $(this).closest('.control-group').find('.control__indicator');
	          var total = $controlIndicators.length;
	          var index = $controlIndicators.index(this);
	          if (event.which == 38) {
	            //cursor up
	            index = index == 0 ? total - 1 : index - 1;
	          } else if (event.which == 40) {
	            //cursor down
	            index = (index + 1) % total;
	          }
	          $controlIndicators[index].click();
	        }
	      });
	
	      $('#commercial-indicator, #residental-indicator').unbind('click').on('click', function (event) {
	        if ($(event.target).hasClass('control__indicator')) {
	          var passiveElement = $(event.target).attr('id') === "commercial-indicator" ? $('#residental-indicator') : $('#commercial-indicator');
	          COSTCO.dialog.setRadioButtonsAttributes($(event.target), passiveElement);
	        }
	        $(event.target).find('input').click();
	      });
	
	      $('#costcoModalBtn2').unbind().on('click', function () {
	        if (COSTCO.timeoutModal && COSTCO.timeoutModal.state === COSTCO.timeoutModal.TIMEDOUT) {
	          var url = "ReLogonFormView?URL=" + window.location.pathname;
	          document.location.href = url;
	        }
	        if (settings.primary_event) {
	          if (settings.primary == 'View List' || settings.primary == 'Voir la liste') {
	            COSTCO.Global.updateSelectedMenuItem('Lists.label');
	          }
	          settings.primary_event();
	        } else {
	          $('#costcoModal').modal('hide');
	          if (settings.url) {
	            window.open(settings.url);
	
	            // check for onetimepopup and add to local storage
	            if (settings.oneTimePopup) {
	              COSTCO.util.setInStorage(settings.url, {
	                'url': settings.url
	              });
	            }
	          }
	        }
	      });
	      $('.costcoModalBtn1').unbind().on('click', function () {
	        //modification for ReturnDialogMOdal.jsp
	        if (settings.url == undefined) {
	          $('#select-page').removeClass('hidden');
	          $('#add-edit-page').addClass('hidden');
	        }
	        //end modification for ReturnDialogMOdal.jsp
	
	        if (settings.secondary_event) {
	          settings.secondary_event();
	        } else {
	          $('#costcoModal').modal('hide');
	        }
	      });
	      if (settings.popover) {
	        $('#costcoModal').find('[data-toggle="popover"]').popover();
	      }
	      this.bindEvents(settings);
	      $('#costcoModal').modal({
	        backdrop: settings.preventClose ? 'static' : true,
	        keyboard: settings.preventClose ? false : true,
	        show: true
	      });
	      //Handle page load by opening in new tab
	      $('#costcoModal').show();
	      $('#costcoModal').css('display', 'block');
	    },
	
	    sameAddressValidation: function sameAddressValidation(formSelector, fieldSelector) {
	      var addressEnteredForCheck = $('#addressEnteredForCheck').val();
	      $(fieldSelector).val(addressEnteredForCheck);
	      $(fieldSelector).focus();
	      var forms = $(fieldSelector).parents('FORM');
	      var addressEnteredForCheck2 = $('#addressEnteredForCheck2');
	      if (forms.length && addressEnteredForCheck2.length) {
	        var form = $(forms[0]);
	        var address2 = addressEnteredForCheck2.val();
	        var city = $('#addressEnteredForCheckCity').val();
	        var state = $('#addressEnteredForCheckState').val();
	        var postalCode = $('#addressEnteredForCheckPostalCode').val();
	        var formFields = form.find('INPUT[type="text"]');
	        for (var i = 0; i < formFields.length; i++) {
	          var field = formFields[i];
	          if (/address2/.test(field.name)) {
	            field.value = address2;
	          } else if (/city/.test(field.name)) {
	            field.value = city;
	          } else if (/.*(zip|postal).*/.test(field.name)) {
	            field.value = postalCode;
	          }
	        }
	        formFields = form.find('SELECT');
	        for (var i = 0; i < formFields.length; i++) {
	          var field = formFields[i];
	          if (/.*(province|state).*/.test(field.name)) {
	            field.value = state;
	          }
	        }
	      }
	      $.validator.addMethod("sameAddressValidationRule", function (inputValue) {
	        return addressEnteredForCheck === inputValue ? false : true;
	      }, messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR_FIELD_VALIDATION);
	
	      $(formSelector).validate().resetForm();
	      $(formSelector).validate();
	      $(fieldSelector).rules('add', 'sameAddressValidationRule');
	      $(fieldSelector).valid();
	    },
	
	    /**
	     * Updates the modal title, body, buttons, bindings etc without closing the modal
	     * @param  {Object} settings @see COSTCO.dialog.createExtDialogBox()
	     */
	    updateModal: function updateModal(settings) {
	      dialog.showModal(settings);
	    },
	    /**
	     * [description]
	     * @return {void} [description]
	     */
	    close: function close() {
	      $('#costcoModal').modal('hide');
	      dialog.returnFocusOnPreviousElement();
	    },
	    /**
	     * [description]
	     * @return {void} [description]
	     */
	    closeAndUnbind: function closeAndUnbind() {
	      $('#costcoModal').unbind('shown.bs.modal');
	      $('#costcoModal').unbind('hidden.bs.modal');
	      $('#costcoModal').unbind('hide.bs.modal');
	      this.close();
	    },
	    /**
	     * Binds the "hidden/shown" events (ie modal is closed/opened) with some
	     * clear/show actions. Additionally you can pass a function as part
	     * of your settings object to execute custom thangs.
	     * @param  {Object} settings  The settings object that contains
	     *                            the event handlers used for various
	     *                            modal actions.
	     * @return {void}
	     */
	    bindEvents: function bindEvents(settings) {
	      $('#costcoModal').unbind('shown.bs.modal').on('shown.bs.modal', function (e) {
	        // This event is fired when the modal has been made visible to the user
	        // (will wait for CSS transitions to complete). If caused by a click,
	        // the clicked element is available as the relatedTarget property of
	        // the event.
	        if (settings.onshown) settings.onshown(e);
	        if (dialog.modalObserver.elementCausedSecondModalId && !e.target.onclick && !dialog.modalObserver.showingSecondModal) {
	          COSTCO.dialog.removeParentElementForModalObserver();
	        };
	        COSTCO.util.trapFocusInsideModal();
	      });
	      $('#costcoModal').unbind('hidden.bs.modal').on('hidden.bs.modal', function (e) {
	        if (typeof settings.dialogclasses != 'undefined') {
	          $('.modal-dialog').removeClass(settings.dialogclasses);
	        }
	        // clear and show. Execute fn if it exists
	        if (settings.onclose) settings.onclose(e);
	        $('#costcoModalTitle').empty().show();
	        if ($('#react-video-holder').length && $('#videoViewer-popup').length) $('#react-video-holder').append($('#videoViewer-popup'));
	        $('#costcoModalText').empty().show();
	        $('.costcoModalBtn1').empty().show();
	        $('#costcoModalBtn2').empty().show();
	
	        if (settings.afterclose) settings.afterclose(e);
	      });
	      $('#costcoModal').unbind('show.bs.modal').on('show.bs.modal', function (e) {
	        if (settings.onshow) settings.onshow(e);
	      });
	      $('#costcoModal').unbind('hide.bs.modal').on('hide.bs.modal', function (e) {
	        // This event is fired when the modal is going to close.
	        if (settings.onhide) settings.onhide(e);
	      });
	    },
	    /**
	     * [description]
	     * @param  {[type]} hostname [description]
	     * @return {boolean}
	     */
	    isPresentInLocalStorage: function isPresentInLocalStorage(hostname) {
	      if (JSON.stringify(COSTCO.util.getFromStorage(hostname)).indexOf(hostname) > 0) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    /**
	     * Holds previous options object used to instantiate a modal with.
	     * This is the modal stack used by modalStack function.
	     * @type {Array}
	     */
	    modalStackPreviousOptions: [],
	    /**
	     * Create a sequential stack of modals by calling this function
	     * successively.
	     *  ex.
	     *    1. COSTCO.dialog.modalStack({title:'hi', body:'robert'})
	     *      -> Invoke a hi-robert modal, pushes options to stack.
	     *    2. COSTCO.dialog.modalStack({title:'hi', body:'kurt'})
	     *      -> Closes the hi-robert modal and invokes/pushes the hi-kurt
	     *         modal to stack.
	     *    3. (Escape key, Exit Arrow, or blur)
	     *      -> Pops the currently invoked modal from the stack and
	     *         closes it. Invokes the previous modal from the stack
	     *         until the stack b gone or we call this function again.
	     * @param  {Object} options The settings object for the modal.
	     * @return {void}
	     */
	    modalStack: function modalStack(options) {
	      var stack = this.modalStackPreviousOptions;
	      options.index = stack.length + 1;
	      stack.push(options);
	      options.afterclose = function () {
	        var stack = dialog.modalStackPreviousOptions;
	        if (stack.length === this.index && stack.length !== 1) {
	          // we need to go backward
	          dialog.showAndHideModal(stack[this.index - 2]);
	          COSTCO.dialog.modalStackPreviousOptions.pop();
	        } else if (stack.length > this.index) {
	          dialog.showAndHideModal(stack[this.index]);
	        } else {
	          COSTCO.dialog.clearStack();
	        }
	      }.bind(options);
	      if (stack.length === 1) {
	        this.showAndHideModal(options);
	      } else {
	        this.close();
	      }
	    },
	
	    /**
	     * set radio buttons attributes
	     */
	    setRadioButtonsAttributes: function setRadioButtonsAttributes(activeElement, passiveElement) {
	      activeElement.addClass('active').attr('aria-checked', true).find('div').removeClass('hide');
	      passiveElement.removeClass('active').attr('aria-checked', false).find('input').removeAttr('checked');
	      passiveElement.find('div').addClass('hide');
	    },
	
	    /**
	     * Clears the modal stack.
	     * @return {void} [description]
	     */
	    clearStack: function clearStack() {
	      this.modalStackPreviousOptions = [];
	    },
	    /*
	     * Listener for opening/closing modals 
	     * to help with returning focus to original 
	     * element or input 
	     */
	    initializeReturnFocusListener: function initializeReturnFocusListener() {
	      $(document).on('hidden.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnPreviousElement();
	      });
	      $(document).on('shown.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnInput();
	      });
	    },
	    /*
	     * This function utilizes the triggerEvent variable
	     * to return focus on elements 
	     */
	    returnFocusOnPreviousElement: function returnFocusOnPreviousElement() {
	      var previousElement = null;
	      if (dialog.triggerEvent != null) {
	        previousElement = dialog.triggerEvent.srcElement;
	      } else if (dialog.triggerEvent == null && COSTCO.timeoutModal != null && COSTCO.timeoutModal.lastActiveElement != null) {
	        previousElement = COSTCO.timeoutModal.lastActiveElement;
	      } else {
	        previousElement = $('body');
	      }
	      $(previousElement).focus();
	    },
	
	    /*
	     * This function's use case is to return 
	     * focus to the element within a modal
	     */
	    returnFocusOnInput: function returnFocusOnInput() {
	      var previousElement = null;
	      if (COSTCO.timeoutModal != null && COSTCO.timeoutModal.lastActiveElement != null && dialog.dialogSettings.title !== messages.TIMEOUT_MODAL_HEADER) {
	        previousElement = COSTCO.timeoutModal.lastActiveElement;
	        COSTCO.timeoutModal.lastActiveElement = null;
	      }
	      $(previousElement).focus();
	    },
	
	    /*
	     * This function captures 
	     */
	    triggerEventUtil: function triggerEventUtil() {
	      if (window.event !== undefined) {
	        if (dialog.getSettings() != null && dialog.getSettings().title === messages.BD_QUESTIONNAIRE_TITLE) {
	          return;
	        } else if (dialog.getSettings() != null && dialog.getSettings().title === messages.TIMEOUT_MODAL_HEADER) {
	          return;
	        } else {
	          dialog.triggerEvent = window.event;
	        }
	      }
	    },
	    /*
	     * returns the current dialog's settings
	     */
	    getSettings: function getSettings() {
	      return dialog.dialogSettings;
	    },
	    /*
	     * Captures data upon opening a modal
	     * to grab the event and copy settings
	     */
	    captureDataBeforeShowingModal: function captureDataBeforeShowingModal(settings) {
	      dialog.triggerEventUtil();
	      dialog.dialogSettings = settings;
	    }
	
	  }; // end costcoDialog object
	  // Expose costcoDialog to the global scope.
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.dialog = dialog;
	  return dialog;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title addressVerification.js: Feature level module
	 * @description Address verification module
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14), __webpack_require__(18)], __WEBPACK_AMD_DEFINE_RESULT__ = function (address, addressDisplay) {
	  var CAddressVerification = {
	    entered: '',
	    suggested: '',
	    buildAddressVerificationModal: function buildAddressVerificationModal(entered, suggested, result) {
	      var verificationModal = $($('#tmpl_address_verification').html());
	      // Need to create a temp object for extending through jQuery
	      var tempEntered = JSON.parse(JSON.stringify(entered));
	      var extendedSuggest = $.extend(tempEntered, suggested);
	      if (result === 'ADDRESS_WRONG_NO_SUGGESTION') {
	        var enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_address_display_verification');
	        $(verificationModal).find('#entered-address .address').append(enteredHtml);
	        $(verificationModal).find('#entered-address input').attr('tabindex', '-1');
	        $(verificationModal).find('[role="radio"]').attr("aria-labelledby", "orderAddrVerfication_" + entered.id);
	        $(verificationModal).find('#suggested-address').hide();
	        $(verificationModal).find('#no-match').show();
	        $(verificationModal).find('#address-verify-warningInfo-header').hide();
	        $(verificationModal).find('#address-verify-warningInfo-header-no-match').show();
	        COSTCO.CAddressVerification.entered = entered;
	      } else {
	        var _enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_address_display_verification');
	        $(verificationModal).find('#entered-address .address').append(_enteredHtml);
	        $(verificationModal).find('#entered-address input').attr('tabindex', '-1');
	        $(verificationModal).find('[role="radio"]').attr("aria-labelledby", "orderAddrVerfication_" + entered.id);
	        var suggestedHtml = addressDisplay.createAddressVerificationDisplay(extendedSuggest, 'tmpl_address_display_verification');
	        $(verificationModal).find('#suggested-address .address').append(suggestedHtml);
	        $(verificationModal).find('#suggested-address input').attr('checked', 'true');
	        $(verificationModal).find('#suggested-address input').parent().attr('aria-checked', 'true');
	        $(verificationModal).find('#suggested-address input').attr('tabindex', '-1');
	        if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore()) {
	          if (!COSTCO.util.isNdEnabled() && "N" == suggested.isCommercial) {
	            $(verificationModal).find('#address-modal-notification').text(messages.MODAL_ADDRESS_RESIDENTIAL_WARNING);
	          }
	        }
	        COSTCO.CAddressVerification.entered = entered;
	        COSTCO.CAddressVerification.suggested = extendedSuggest;
	      }
	      return verificationModal;
	    },
	    showAddressVerificationModal: function showAddressVerificationModal(addressObj, preventhtmlajax, addressOptions) {
	      var suggested = addressObj.Validated_Address[0];
	      var entered = addressObj.Address[0];
	      var result = suggested.result;
	      var modalBody = CAddressVerification.buildAddressVerificationModal(entered, suggested, result);
	      var primaryDisabled = result === 'ADDRESS_WRONG_NO_SUGGESTION';
	      $('.order-ajax').removeClass('ajax-busy');
	      if (typeof addressOptions.primaryEventCallback === 'undefined') {
	        addressOptions.primaryEventCallback = CAddressVerification.useAddressCallback;
	      }
	      if (addressOptions.isModalStack) {
	        var labels = address.getHeaderLabels('S', 'verify');
	        COSTCO.dialog.modalStack({
	          title: labels.modalTitle,
	          body: modalBody,
	          primary_event: function primary_event() {
	            addressOptions.primaryEventCallback(preventhtmlajax, addressOptions);
	          },
	          primaryDisabled: primaryDisabled,
	          primary: labels.primaryButton,
	          secondary: messages.JS_DIALOG_CANCEL
	        });
	      } else {
	        address.baseModal(addressOptions.successCallback.arguments[1], 'verify', {
	          body: modalBody,
	          primary_event: function primary_event() {
	            addressOptions.primaryEventCallback(preventhtmlajax, addressOptions);
	          },
	          primaryDisabled: primaryDisabled
	        });
	      }
	    },
	    buildMultiAddressVerificationModal: function buildMultiAddressVerificationModal(addressObj) {
	      var verificationModal = $($('#tmpl_multi_address_verification').html());
	      $.each(addressObj.Address, function (index, value) {
	        // If we only have 1 address, we won't show the label in the modal.
	        value.numOfAddresses = addressObj.Address.length;
	        var entered = addressObj.Address[index];
	        var suggested = CAddressVerification.matchValidatedAddress(value.id, addressObj.Validated_Address);
	        var verificationLineBlockHtml = '';
	        if (suggested.result != 'ADDRESS_WRONG_NO_SUGGESTION') {
	          var tempEntered = JSON.parse(JSON.stringify(entered));
	          var extendedSuggest = $.extend(tempEntered, suggested);
	          var enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_multi_address_verification_display_addr_element');
	          verificationLineBlockHtml = $(COSTCO.util.tmpl('tmpl_multi_address_verification_line_block', value));
	          $(verificationLineBlockHtml).find('.entered-address .address').append(enteredHtml);
	          var suggestedHtml = addressDisplay.createAddressVerificationDisplay(extendedSuggest, 'tmpl_multi_address_verification_display_addr_element');
	          $(verificationLineBlockHtml).find('.suggested-address .address').append(suggestedHtml);
	          $(verificationLineBlockHtml).find('.suggested-address input').attr('checked', 'checked');
	        }
	        $(verificationModal).find('#address-verify-form').append(verificationLineBlockHtml);
	      });
	      return verificationModal;
	    },
	    showMultiAddressVerificationModal: function showMultiAddressVerificationModal(addressObj, callback) {
	      var modalBody = CAddressVerification.buildMultiAddressVerificationModal(addressObj);
	      COSTCO.dialog.modalStack({
	        title: addressLabels.verify.modalTitle,
	        body: modalBody,
	        primary: addressLabels.verify.primaryButton,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          $('.permanent-ajax-busy').addClass('ajax-busy');
	          // create final address array and pass it to callback
	          var selectedInputs = $(modalBody).find('input[name^=verify]:checked');
	          var finalAddressArray = [];
	          $.each(selectedInputs, function (index, value) {
	            var action = $(value).val();
	            var addressId = $(value).attr('data-id');
	            if (action === 'suggested') {
	              finalAddressArray.push(CAddressVerification.findAddressById(addressId, addressObj.Validated_Address));
	            } else {
	              finalAddressArray.push(CAddressVerification.findAddressById(addressId, addressObj.Address));
	            }
	          });
	          COSTCO.dialog.clearStack();
	          COSTCO.dialog.close();
	          if (callback) callback(finalAddressArray);
	          // addressOptions.primaryEventCallback(preventhtmlajax, addressOptions, finalAddressArray);
	        }
	      });
	    },
	    /**
	     * Callback function for addressForm, used for primaryEventCallback
	     * @param  {[type]} preventhtmlajax [description]
	     * @param  {[type]} addressOptions  [description]
	     * @return {void}                 [description]
	     */
	    useAddressCallback: function useAddressCallback(preventhtmlajax, addressOptions) {
	      COSTCO.CAddressVerification.useAddress(preventhtmlajax, addressOptions);
	    },
	    setAddressEnteredForCheck: function setAddressEnteredForCheck(address) {
	      var parentEl = document.body;
	      var address1 = $('#addressEnteredForCheck');
	      if (address1.length) {
	        parentEl = address1.parent().get(0);
	      } else {
	        address1 = $('<INPUT TYPE="hidden" ID="addressEnteredForCheck" />').appendTo(parentEl);
	      }
	      var address2 = $('#addressEnteredForCheck2');
	      if (!address2.length) {
	        address2 = $('<INPUT TYPE="hidden" ID="addressEnteredForCheck2" />').appendTo(parentEl);
	      }
	      var city = $('#addressEnteredForCheckCity');
	      if (!city.length) {
	        city = $('<INPUT TYPE="hidden" ID="addressEnteredForCheckCity" />').appendTo(parentEl);
	      }
	      var state = $('#addressEnteredForCheckState');
	      if (!state.length) {
	        state = $('<INPUT TYPE="hidden" ID="addressEnteredForCheckState" />').appendTo(parentEl);
	      }
	      var postalCode = $('#addressEnteredForCheckPostalCode');
	      if (!postalCode.length) {
	        postalCode = $('<INPUT TYPE="hidden" ID="addressEnteredForCheckPostalCode" />').appendTo(parentEl);
	      }
	      address1.val(address.line1);
	      address2.val(address.line2);
	      city.val(address.city);
	      state.val(address.state);
	      postalCode.val(address.zip);
	    },
	    useAddress: function useAddress(preventhtmlajax, addressOptions, action) {
	      var verifiedAddress;
	      var message = action;
	      if ($('input[name=verify]:checked').val() != undefined) {
	        action = $('input[name=verify]:checked').val();
	      }
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      if (action == 'suggested') {
	        verifiedAddress = COSTCO.CAddressVerification.suggested;
	        digitalDataEvents.push({ ui: "Address Verification Modal | Use Address |  Suggested  Address" });
	      } else {
	        verifiedAddress = COSTCO.CAddressVerification.entered;
	        digitalDataEvents.push({ ui: "Address Verification Modal | Use Address | Entered Address" });
	        // SFSTRY0039755 - Limit zip code editing to US only
	        if (COSTCO.util.isUSStore()) {
	          // SFSTRY0034758 - Use 9 digit zip code if AddressDoctor suggestion matches address
	          if (COSTCO.CAddressVerification.suggested !== 'undefined' && COSTCO.CAddressVerification.suggested !== '') {
	            if (COSTCO.CAddressVerification.suggested.zip.substring(0, 5) === COSTCO.CAddressVerification.entered.zip.substring(0, 5)) {
	              verifiedAddress.zip = COSTCO.CAddressVerification.suggested.zip;
	            }
	          }
	        }
	        //Save suggested isCommercial(RDI) flag if available, even if user selects entered address:
	        if ($('input[name=verify]:checked').val() != undefined) {
	          verifiedAddress.isCommercial = COSTCO.CAddressVerification.suggested.isCommercial;
	        }
	      }
	      COSTCO.CAddressVerification.suggested = '';
	      COSTCO.CAddressVerification.setAddressEnteredForCheck(verifiedAddress);
	      address.addEditAddress(verifiedAddress, preventhtmlajax, addressOptions, message);
	    },
	    handleRadioButtonClick: function handleRadioButtonClick(element) {
	      var passiveElementParent = $(element).parent().attr('id') === "suggested-address" ? $('#entered-address') : $('#suggested-address');
	      COSTCO.CAddressVerification.setRadioAttributes($(element), passiveElementParent);
	      $('#costcoModalBtn2').removeClass('btn-disabled');
	    },
	    addressVerification: function addressVerification(addressArray, type, preventajaxhtml, addressOptions) {
	      $('.order-ajax').addClass('ajax-busy');
	      var _dataType = 'json';
	      var _data = {};
	      _data['formdata'] = encodeURIComponent(JSON.stringify(addressArray));
	      $.ajax({
	        url: '/AjaxAddressVerificationCmd',
	        type: 'POST',
	        dataType: _dataType,
	        data: _data,
	        timeout: 15000
	      }).done(function (addressObj) {
	        addressOptions.successCallback(addressObj, type, preventajaxhtml, addressOptions);
	      }).fail(function (addressObj) {
	        // Timeout or error sets verifiedAddress to inputted array
	        // Error Calling Verification Service
	        console.log('Verification Address : ' + JSON.stringify(addressObj));
	      }).always(function () {
	        $('.order-ajax').removeClass('ajax-busy');
	      });
	    },
	    extractValidatedAddress: function extractValidatedAddress(addressObj, type) {
	      console.log('Extracting Validated Address : ' + JSON.stringify(addressObj));
	      var suggested = addressObj.Validated_Address[0];
	      var entered = addressObj.Address[0];
	      suggested.fName = entered.fName;
	      suggested.lName = entered.lName;
	      suggested.company = entered.company;
	      suggested.pNumber = entered.pNumber;
	      suggested.ext1 = entered.ext1;
	      suggested.nickname = entered.nickname;
	      suggested.saveAddress = entered.saveAddress;
	      suggested.setDefault = entered.setDefault;
	      suggested.addressType = type;
	      suggested.addressType2 = entered.addressType2;
	      suggested.mInitial = entered.mInitial;
	      suggested.email = entered.email;
	      suggested.deliveryInst = entered.deliveryInst;
	      suggested.contactName = entered.contactName;
	      suggested.contactPhNo = entered.contactPhNo;
	      return suggested;
	    },
	    isSuggestedSameAsEntered: function isSuggestedSameAsEntered(addressObj) {
	      // web service down or service reports address suggestion for correctly entered address
	      var suggested = addressObj.Validated_Address[0];
	      var entered = addressObj.Address[0];
	      if (suggested.result != 'ADDRESS_WRONG_NO_SUGGESTION' && suggested.line1.toUpperCase() === entered.line1.toUpperCase() && suggested.line2.toUpperCase() === entered.line2.toUpperCase() && suggested.city.toUpperCase() === entered.city.toUpperCase() && suggested.state === entered.state && suggested.zip.substring(0, 5) === entered.zip.substring(0, 5) && suggested.country === entered.country) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    /**
	     * Builds one element of the AVS request object array
	     * @param  {Object} form jquery form object which contains fields of address to be verified
	     * @param  {Object} selectors JSON object containing selectors that should be used in the form to get data from form to build request
	     * @return {Object} One element of the array to be passed to AVS service
	     */
	    buildRequestElement: function buildRequestElement(form, selectors) {
	      var addressObject = {
	        id: $(form).find(selectors.id).val() ? $(form).find(selectors.id).val() : '',
	        label: $(form).find(selectors.label).val() || $(form).find(selectors.label).text(),
	        line1: $(form).find(selectors.line1).val(),
	        line2: $(form).find(selectors.line2).val(),
	        line3: $(form).find(selectors.line3).val(),
	        city: $(form).find(selectors.city).val(),
	        state: $(form).find(selectors.state).val(),
	        country: $(form).find(selectors.country).val(),
	        zip: $(form).find(selectors.zip).val(),
	        fName: $(form).find(selectors.fName).length > 0 ? $(form).find(selectors.fName).val() : '',
	        lName: $(form).find(selectors.lName).length > 0 ? $(form).find(selectors.lName).val() : ''
	      };
	      return addressObject;
	    },
	    /**
	     * Match validated address with entered address by label.
	     * @param {String} label Label of the entered address
	     * @param {Array} validatedAddresses Array or validated addresses returned by AVS
	     * @return matched address by label
	     */
	    matchValidatedAddress: function matchValidatedAddress(id, validatedAddresses) {
	      var validatedAddress = null;
	      $.each(validatedAddresses, function (index, value) {
	        if (id == value.id) {
	          validatedAddress = value;
	          return false;
	        }
	      });
	      return validatedAddress;
	    },
	    /**
	     * Iterate through input address array and match address by id param.
	     * @param {String} id id of the address to be matched
	     * @param {Array} addresses Array of addresses in which we need to find one by id
	     * @return {Object} Matched address
	     */
	    findAddressById: function findAddressById(id, addresses) {
	      var matchedAddress = {};
	      $.each(addresses, function (index, value) {
	        if (value.id == id) {
	          matchedAddress = addresses[index];
	          return false;
	        }
	      });
	      return matchedAddress;
	    },
	    /**
	     * Takes an array of verified addresses and determines if any of them
	     * have returned with a result of 'NO_SUGGESTION'.
	     * @param  {Array} addresses The array of addresses to check.
	     * @return {boolean}
	     */
	    hasAnyNoSuggestion: function hasAnyNoSuggestion(addresses) {
	      return COSTCO.util.any(addresses, function (address) {
	        return address.result.includes('NO_SUGGESTION');
	      });
	    },
	    /**
	     * Takes an array of verified addresses and determines if all of them have
	     * returned with a result of 'NO_SUGGESTION'.
	     * @param  {Array} addresses The array of addresses to check.
	     * @return {boolean}
	     */
	    hasAllNoSuggestion: function hasAllNoSuggestion(addresses) {
	      return COSTCO.util.all(addresses, function (address) {
	        return address.result.includes('NO_SUGGESTION');
	      });
	    },
	    /**
	     * Takes an address object returned from the address verification service
	     * and determines if all of the entered addresses match all of the suggested
	     * addresses.
	     * @param  {Object} addressObj The address object returned from AV
	     * @return {boolean}           Are all entered == suggested?
	     */
	    hasAllSameAsSuggested: function hasAllSameAsSuggested(addressObj) {
	      var result = true;
	      for (var i = 0; i < addressObj.Address.length; i++) {
	        // To reuse isSuggestedSameAsEntered, need this data structure.
	        // This assumes we always have 1:1 entered:validated in the addressObj
	        var tempObj = {
	          Address: [addressObj.Address[i]],
	          // ensure we have the matching validated address
	          Validated_Address: [this.findAddressById(addressObj.Address[i].id, addressObj.Validated_Address)]
	        };
	        if (this.isSuggestedSameAsEntered(tempObj)) {
	          continue;
	        } else {
	          result = false;
	          break;
	        }
	      }
	      return result;
	    },
	    /**
	     * Displays the new Adress Type modal so that the user sets the address type (if in BD Truck zone)
	     * @param  {String}    form - submitted form element
	    */
	    viewAddressTypeModal: function viewAddressTypeModal(preventhtmlajax, addressOptions, message, data) {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.DELIVERY_OPTIONS,
	        body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
	        primary: messages.SET_DELIVERY_METHOD,
	        popover: true,
	        dialogclasses: 'nd-delivery-method-dialog',
	        onshow: function onshow() {
	          $('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
	          $('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
	          //			$('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Browse | Choose Delivery Method | Set Delivery Method")
	        },
	        onclose: function onclose() {
	          //			$(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
	          $('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
	          $('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
	        },
	        primary_event: function primary_event() {
	          if (document.querySelector('input[name="nd-radio-group-input"]:checked') == null) {
	            $('.addresstype-setup-notification').removeClass("hidden");
	            $('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
	          } else {
	            if (message == "suggested") {
	              COSTCO.CAddressVerification.suggested.showAddressTypePopup = false;
	            } else if (data != undefined) {
	              data.showAddressTypePopup = false;
	            } else {
	              COSTCO.CAddressVerification.entered.showAddressTypePopup = false;
	            }
	            COSTCO.CAddressVerification.useAddress(preventhtmlajax, addressOptions, message);
	          }
	        }
	      });
	      $('.close').addClass("hidden");
	    },
	    validateShowAddressTypeModal: function validateShowAddressTypeModal(verifiedAddress, addressOptions) {
	      return verifiedAddress.showAddressTypePopup == "true" && (addressOptions.addressBookReinit == undefined || addressOptions.addressBookReinit == false) && verifiedAddress.addressType == 'S' && (addressOptions.validateParams == undefined || addressOptions.validateParams != undefined && (verifiedAddress.line1 != addressOptions.validateParams[0] || verifiedAddress.zip != addressOptions.validateParams[1] || verifiedAddress.city != addressOptions.validateParams[2]));
	    },
	    handleRadioButtonEnterKey: function handleRadioButtonEnterKey(element) {
	      if (event.keyCode === 13) {
	        $(element).parent().siblings().find('input').get(0).removeAttribute('checked');
	        $(element).parent().siblings().find('div:first').get(0).removeAttribute('aria-checked');
	        $(element).children().get(0).setAttribute('checked', 'true');
	        $(element).get(0).setAttribute('aria-checked', 'true');
	        $('#costcoModalBtn2').removeClass('btn-disabled');
	      }
	    },
	    handleRadioButtonSpaceKey: function handleRadioButtonSpaceKey(element) {
	      if (event.keyCode === 32) {
	        element.click();
	        $('#costcoModalBtn2').removeClass('btn-disabled');
	      }
	    },
	
	    setRadioAttributes: function setRadioAttributes(activeElement, passiveElementParent) {
	      var passiveInput = passiveElementParent.find('input').get(0);
	      if (typeof passiveInput !== 'undefined') {
	        passiveInput.removeAttribute('checked');
	      }
	
	      var passiveLabel = passiveElementParent.find('label').get(0);
	      if (typeof passiveLabel !== 'undefined') {
	        passiveLabel.removeAttribute('aria-checked');
	      }
	
	      // set attr checked on input
	      var activeInput = activeElement.find('input').get(0);
	      if (typeof activeInput !== 'undefined') {
	        activeInput.setAttribute('checked', 'true');
	      }
	
	      // set attr aria-checked on label
	      var activeElem = activeElement.get(0);
	      if (typeof activeElem !== 'undefined') {
	        activeElem.setAttribute('aria-checked', 'true');
	      }
	    },
	    /**
	    * Displays the new Delivery Method modal so that the user sets the delivery method
	    * @param  {String}    form - submitted form element
	    */
	    viewDeliveryMethodModal: function viewDeliveryMethodModal(form, data, params, oldAddy, newAddy) {
	      var showQuestionnaireModal = false;
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.DELIVERY_OPTIONS,
	        body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
	        primary: messages.SET_DELIVERY_METHOD,
	        popover: true,
	        dialogclasses: 'nd-delivery-method-dialog',
	        onshow: function onshow() {
	          $('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
	          $('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
	          $('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Checkout | Choose Delivery Method | Set Delivery Method");
	          $('.addresstype-setup-notification').addClass("hidden");
	          $('.addresstype-setup-notification').find("div").html('');
	
	          if (data.isBDTruckZoneEnabledForWareHouse === true) {
	            $("#nd-local-delivery-modal-section").removeClass("hidden");
	          } else {
	            $("#nd-local-delivery-modal-section").addClass("hidden");
	          }
	
	          if (data.isNationalDeliveryEnabledForWareHouse === true) {
	            $("#nd-nationwide-delivery-modal-section").removeClass("hidden");
	          } else {
	            $("#nd-nationwide-delivery-modal-section").addClass("hidden");
	          }
	
	          if (data.isStorePickupEnabledForWareHouse === true) {
	            $("#store-pickup-modal-section").removeClass("hidden");
	          } else {
	            $("#store-pickup-modal-section").addClass("hidden");
	          }
	
	          $('#nd-local-delivery-radio-button').focus();
	        },
	        onclose: function onclose() {
	          $(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
	          if ($('#nd-zipcode-method-modal-body').children('fieldset').length == 0) {
	            $('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
	          }
	          $('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
	        },
	        primary_event: function primary_event() {
	          if (document.querySelector('input[name="nd-radio-group-input"]:checked') == null) {
	            $('.addresstype-setup-notification').removeClass("hidden");
	            $('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
	
	            var isFocusSet = false;
	            if (data.isBDTruckZoneEnabledForWareHouse === true) {
	              $('#nd-local-delivery-radio-button').focus();
	              isFocusSet = true;
	            }
	
	            if (data.isNationalDeliveryEnabledForWareHouse === true && isFocusSet == false) {
	              $('#nd-nationwide-delivery-radio-button').focus();
	              isFocusSet = true;
	            }
	
	            if (data.isStorePickupEnabledForWareHouse === true && isFocusSet == false) {
	              $('#store-pickup-radio-button').focus();
	            }
	          } else {
	            var deliveryMehod;
	            if ($('input[name="deliveryMethod"]').length > 0) {
	              deliveryMethod = $("input[name='deliveryMethod']:checked").val();
	            }
	            var selectedDeliveryMethod = 'Local';
	            if (document.querySelector('input[name="nd-radio-group-input"]:checked') != null) {
	              var uiSelectedDeliveryMethod = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
	              switch (uiSelectedDeliveryMethod) {
	                case "C":
	                  selectedDeliveryMethod = "Local";
	                  break;
	                case "R":
	                  selectedDeliveryMethod = "Nationwide";
	                  break;
	                case "P":
	                  selectedDeliveryMethod = "Store-Pick-Up";
	                  break;
	              }
	              $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val(selectedDeliveryMethod);
	            }
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            if (selectedDeliveryMethod === 'Local') {
	              digitalDataEvents.push({
	                browseDeliveryMethod: "Local Business Delivery"
	              });
	            } else if (selectedDeliveryMethod === 'Nationwide') {
	              digitalDataEvents.push({
	                browseDeliveryMethod: "Nationwide Delivery"
	              });
	            }
	            data.userSelectionDeliveryMethod = selectedDeliveryMethod;
	            if (oldAddy == null) {
	              //add address flow
	              COSTCO.CAddress.callAddressAddNew(params[2], params[3], newAddy, params[4], data);
	            } else {
	              COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, newAddy, data);
	            }
	          }
	          var espot = $('#delivery_address_modal_form #nd-zipcode-method-fieldset').clone();
	          $('#nd-zipcode-method-modal-body').html(espot);
	        }
	      });
	      $('.close').addClass("hidden");
	    }
	
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.CAddressVerification = CAddressVerification;
	  return CAddressVerification;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title checkout_helper.js: Feature level module
	 * @description Utility module associated with checkout
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function (address) {
	  var CAddressDisplay = {
	    createAddressDisplay: function createAddressDisplay(obj, type) {
	      var data = CAddressDisplay.buildAddressJson(obj);
	      if (obj.phone) {
	        obj.phone = COSTCO.util.formatPhone(obj.phone);
	      }
	
	      return COSTCO.util.tmpl('tmpl_address_display', obj);
	    },
	    createAddressVerificationDisplay: function createAddressVerificationDisplay(obj, template) {
	      var data = CAddressDisplay.buildAddressJson(obj);
	      if (template == null || template == '' || typeof template === 'undefined') {
	        //set default template if template is not passed in the argument
	        template = 'tmpl_address_display_verification';
	      }
	      return COSTCO.util.tmpl(template, obj);
	    },
	    buildAddressJson: function buildAddressJson(obj) {
	      var data;
	      if (typeof obj === 'number') {
	        var addressJson = address.getAddressJson(obj)[0];
	        if (addressJson.length == 0) return '';
	        data = addressJson[0];
	      } else {
	        data = obj;
	      }
	      return data;
	    }
	  };
	  if (typeof window.COSTCO === "undefined") {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.CAddressDisplay = CAddressDisplay;
	  return CAddressDisplay;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title member-verification.js: Sub-module of Account feature
	 * @description This module provides membership verification functionality.
	 * @dependency utility.js, costcodialog.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var MemberVerification = {
	
	    init: function init() {
	      this.validationRules();
	      this.maskDateInput();
	    },
	
	    membershipNumber: null,
	
	    getForm: function getForm() {
	      return $('#MemberVerificationForm');
	    },
	
	    validateNumberForm: function validateNumberForm() {
	      MemberVerification.getForm().validate({
	        rules: {
	          membershipNumberToVerify: {
	            required: true,
	            membershipNumber: true
	          }
	        },
	        messages: {
	          membershipNumberToVerify: {
	            required: messages.ERR_INVALID_MEMBERSHIP_NO,
	            membershipNumber: messages.ERR_INVALID_MEMBERSHIP_NO
	          }
	        },
	        invalidHandler: function invalidHandler(event, validator) {
	          var errors = validator.numberOfInvalids();
	          if (errors) {
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Valid Membership Number Error" });
	          }
	        }
	      });
	
	      return MemberVerification.getForm().valid();
	    },
	
	    maskDateInput: function maskDateInput() {
	      $('#employeeStartDate').mask('00/00', {
	        placeholder: 'MM/YY'
	      });
	    },
	
	    validateZipCodeForm: function validateZipCodeForm() {
	      var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : COSTCO.MemberVerification.getForm();
	
	      form.validate({
	        rules: {
	          questionLastName: {
	            required: true
	          },
	          questionZip: {
	            'required': true,
	            'postalcode': true
	          }
	        },
	        messages: {
	          questionLastName: messages.ERR_INVALID_LASTNAME,
	          questionZip: messages.ERR_ENTER_ZIPCODE
	        },
	        invalidHandler: function invalidHandler(event, validator) {
	          var errors = validator.numberOfInvalids();
	          if (errors) {
	            for (var i = 0; i < errors; i++) {
	              COSTCO.MemberVerification.fireAnalyticsEventLastNameOrZipCodeError(validator.errorList[i].element);
	            }
	          }
	        }
	      });
	
	      return form.valid();
	    },
	
	    fireAnalyticsEventLastNameOrZipCodeError: function fireAnalyticsEventLastNameOrZipCodeError(element) {
	      var test = $(element).is("input[name='questionLastName']");
	      if (test) {
	        digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Your Last Name Error" });
	      } else {
	        digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter a Valid Zip Code Error" });
	      }
	    },
	
	    validationRules: function validationRules() {
	      $.validator.addMethod('membershipNumber', function (value, element) {
	        // costco pins are 12 digits
	        return this.optional(element) || /^\d{12,16}$/.test(value);
	      }, messages.MEMBERVERIFICATION_MEMBERSHIP__InvalidMembershipNumber);
	
	      $.validator.addMethod('postalcode', function (value, element) {
	        return this.optional(element) || /^(\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1})$/.test($.trim(value));
	      }, messages.ERR_ENTER_ZIPCODE);
	    },
	    /**
	     * Submits request for membership verification steps
	     * @param  {String} urlWithParams Service URL with query string parameters appended
	     * @return {jQuery.Deferred}      The deferred object
	     */
	    submitRequest: function submitRequest(urlWithParams) {
	      return COSTCO.util.ajax({
	        type: 'POST',
	        url: urlWithParams,
	        dataType: 'json'
	      })
	      // This returns a chainable promise.
	      .then(function (data) {
	        if (data && data.CRM_ERROR_FRAMEWORK) {
	          var errorTmpl = isDmcPage ? 'tmpl_membership_dmc_verify_err_service_error' : 'tmpl_membership_verify_err_service_error';
	          var errorTmplData = {
	            membershipNumber: MemberVerification.membershipNumber
	          };
	
	          switch (data.CRM_ERROR_FRAMEWORK) {
	
	            case 'ERROR_EXCEEDED_MAX_AUTH_ATTEMPTS':
	              if (isDmcPage) {
	                errorTmpl = 'tmpl_membership_dmc_verify_err_max_retries_reached';
	              } else {
	                errorTmpl = 'tmpl_membership_verify_err_max_retries_reached';
	              }
	              break;
	
	            case 'ERROR_PRESCREEN_ATTEMPT_FAILED':
	              switch (data.CRM_MEMBER_TYPE) {
	                case 'E':
	                  errorTmpl = 'tmpl_membership_verify_err_employee_membership';
	                  break;
	
	                case 'T':
	                  errorTmpl = 'tmpl_membership_verify_err_trial_membership';
	                  break;
	
	                case 'X':
	                  errorTmpl = 'tmpl_membership_verify_err_inactive_membership';
	                  break;
	
	                default:
	                  errorTmpl = 'tmpl_membership_verify_err_try_again';
	              }
	          }
	
	          MemberVerification.doAnalytics(errorTmpl);
	
	          return $.Deferred().reject(errorTmpl, errorTmplData);
	        }
	
	        return $.Deferred().resolve(data);
	      }).fail(function (errorTmpl, errorTmplData) {
	        if (errorTmpl) {
	          MemberVerification.displayErrorInModal(errorTmpl, errorTmplData);
	        }
	      });
	    },
	
	    doAnalytics: function doAnalytics(errorTmpl) {
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      switch (errorTmpl) {
	        case 'tmpl_membership_verify_err_service_error':
	          digitalDataEvents.push({ ui: "Member Verification Flow | Not Able to Verify Error" });
	          break;
	        case 'tmpl_membership_verify_err_try_again':
	          digitalDataEvents.push({ ui: "Member Verification Flow | Information Does Not Match Records Error" });
	          break;
	        case 'tmpl_membership_verify_err_max_retries_reached':
	          digitalDataEvents.push({ uimsg: "Member Verification Flow | Exceeded Number of Attempts Error" });
	          break;
	      }
	    },
	    /**
	     * Invalidates session on backend for membership verification process
	     */
	    invalidateSession: function invalidateSession() {
	      var url = MemberVerification.makeVerificationUrl({
	        membershipNumber: MemberVerification.membershipNumber,
	        invalidSession: true
	      });
	
	      MemberVerification.submitRequest(url);
	    },
	    /**
	     * Makes URL with string params for membership account verification services
	     * @param  {Object} params  JSON obj with params to be put in URL as a query string e.g. {membershipNumber: 4444333322221111, invalidSession: true}
	     * @return {String}         URL for membership account verification services with query string paramaters
	     *                          e.g. /AjaxMembershipAccountVerificationCmd?membershipNumber=4444333322221111&invalidSession=true
	     */
	    makeVerificationUrl: function makeVerificationUrl(params) {
	      return COSTCO.util.makeUrl('/AjaxMembershipAccountVerificationCmd', params);
	    },
	    /**
	     * Opens membership verification dialog
	     * @param  {number} membershipNum Membership number
	     */
	    openMembershipVerificationDialog: function openMembershipVerificationDialog(membershipNum) {
	      MemberVerification.membershipNumber = membershipNum;
	
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      digitalDataEvents.push({ uimsg: "navName:DMC | Verify Your Membership | Verify Now" });
	
	      var doNotCloseModalFlag = false;
	      isDmcPage = typeof isDmcPage !== "undefined" && isDmcPage === "true";
	      if (isDmcPage) {
	        doNotCloseModalFlag = true;
	        $('#costcoModalBtn2').parent().removeClass().addClass('col-xs-12 col-sm-12 col-md-12 col-lg-12');
	      }
	
	      var settings = {
	        dialogclasses: 'verify-membership-dialog',
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl('tmpl_membership_verify_number', {
	          membershipNumber: MemberVerification.membershipNumber
	        }),
	        footerText: isDmcPage ? COSTCO.util.tmpl('tmpl_membership_verify_buy_membership') : '',
	        preventClose: doNotCloseModalFlag,
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        secondary: !isDmcPage ? messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText : '',
	        primary_event: function primary_event() {
	
	          if (MemberVerification.validateNumberForm()) {
	            MemberVerification.membershipNumber = parseInt($('#membershipNumberToVerify').val());
	
	            var url = MemberVerification.makeVerificationUrl({
	              membershipNumber: MemberVerification.membershipNumber
	            });
	
	            MemberVerification.submitRequest(url).then(function (data) {
	              if (isDmcPage) {
	                $('#costcoModalBtn2').parent().removeClass().addClass('col-xs-12 col-md-6');
	              }
	              if (data.CRM_AUTH_QUESTION && data.CRM_AUTH_QUESTION.answers && data.CRM_AUTH_QUESTION.answers.length > 0) {
	                MemberVerification.showQuestionsStep(data);
	              } else {
	                MemberVerification.showPrescreen(data);
	              }
	            });
	          } else {
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Valid Membership Number Error" });
	          }
	        },
	        secondary_event: function secondary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      };
	
	      COSTCO.dialog.createExtDialogBox(settings);
	    },
	    /**
	     * Shows prescreen (last name / zip code form)
	     * @param  {Object} data Data response returned from server
	     */
	    showPrescreen: function showPrescreen(data) {
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl('tmpl_membership_verify_prescreen', {}),
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	        primary_event: function primary_event() {
	          if (MemberVerification.validateZipCodeForm()) {
	            var url = MemberVerification.makeVerificationUrl({
	              lastName: $('#questionLastName').val(),
	              zipCode: $('#questionZip').val()
	            });
	
	            MemberVerification.submitRequest(url).then(MemberVerification.showQuestionsStep);
	          }
	        },
	        secondary_event: function secondary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    },
	
	    /**
	     * Updates modal with questions to select. If there is another question returned from backend, call it self again to display new question.
	     * @param  {Object} data Response data from previous step
	     */
	    showQuestionsStep: function showQuestionsStep(data) {
	      var questionsBodyTmpl = '';
	
	      if (data.CRM_AUTH_QUESTION) {
	        questionsBodyTmpl = $(COSTCO.util.tmpl('tmpl_membership_verify_questions', {
	          membershipNumber: MemberVerification.membershipNumber,
	          verificationQuestion: data.CRM_AUTH_QUESTION.question
	        }));
	
	        var questionsTmpl = questionsBodyTmpl.find('#verification-questions');
	
	        if (questionsTmpl.length) {
	          $.each(data.CRM_AUTH_QUESTION.answers, function (index, value) {
	            questionsTmpl.append(COSTCO.util.tmpl('tmpl_membership_verify_question_item', {
	              answerId: index,
	              verificationAnswer: value
	            }));
	          });
	        }
	      }
	
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: questionsBodyTmpl,
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	        primary_event: function primary_event() {
	          var selectedAnswer = $('input[name=CRManswer]:checked').val();
	
	          var url = MemberVerification.makeVerificationUrl({
	            answerNumber: selectedAnswer
	          });
	
	          var loadingTmpl = 'tmpl_membership_questions_loading';
	          if (data.CRM_AUTH_LAST_STEP) {
	            loadingTmpl = 'tmpl_membership_verify_loading';
	          }
	
	          COSTCO.dialog.updateModal({
	            title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	            body: COSTCO.util.tmpl(loadingTmpl, {}),
	            onshown: function onshown() {
	              COSTCO.util.maskMembershipInput();
	            }
	          });
	
	          MemberVerification.submitRequest(url).then(function (data) {
	            if (data.CRM_AUTH_QUESTION && data.CRM_AUTH_QUESTION.answers && data.CRM_AUTH_QUESTION.answers.length > 0) {
	              MemberVerification.showQuestionsStep(data);
	            } else if (data.CRM_AUTH_PASSED == true) {
	              MemberVerification.showSuccessStep();
	            } else {
	              MemberVerification.displayErrorInModal(isDmcPage ? 'tmpl_membership_dmc_verify_err_service_error' : 'tmpl_membership_verify_err_service_error');
	            }
	          });
	        },
	        secondary_event: function secondary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    },
	    /**
	     * Transfer request to DMC handler
	     */
	    proceedeToDMCCheck: function proceedeToDMCCheck(action, actionSuccessful) {
	
	      COSTCO.dialog.close();
	      var command = "/DMCCheck";
	
	      var queryStart = "?";
	      var queryConcat = "&";
	      var queryAction = "action=" + action;
	      var queryDeviceId = "deviceId=" + deviceId;
	      var queryVerified = "verified=" + actionSuccessful;
	      var queryRenewalCanceled = "renewCanceled=" + actionSuccessful;
	      var queryString = queryStart + queryAction + queryConcat + queryDeviceId + queryConcat;
	
	      if (action == 'renewal') queryString += queryRenewalCanceled;else queryString += queryVerified;
	
	      var newURL = window.location.protocol + "//" + window.location.host + command + queryString;
	      window.location.replace(newURL);
	    },
	    /**
	     * Update modal with succcess text
	     */
	    showSuccessStep: function showSuccessStep() {
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      digitalDataEvents.push({ uimsg: "Member Verification Process | Verification Success" });
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl('tmpl_membership_verify_success', {}),
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        primary_event: function primary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', true);
	          } else {
	            COSTCO.dialog.close();
	            location.reload();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', true);
	          } else {
	            COSTCO.dialog.close();
	            location.reload();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    },
	    /**
	     * Update modal with error text from prepared template.
	     * @param  {string} errorTemplate   Template id
	     * @param  {Object} data            Data used to populate in template
	     */
	    displayErrorInModal: function displayErrorInModal(errorTemplate, data) {
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl(errorTemplate, data),
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	          location.reload();
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            location.reload();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    }
	
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.MemberVerification = MemberVerification;
	  return MemberVerification;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title renew-membership.js: Sub-module for Account pages
	 * @description This module is used to handle renew membership tasks
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(19), __webpack_require__(21), __webpack_require__(22), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util, verification, creditcard, affForm, helper) {
	  var RenewMembership = {
	    sessionId: '',
	    authToken: '',
	    membershipData: {},
	    getForm: function getForm() {
	      return $('#StorePaymentForm');
	    },
	    renewCreditCardData: {},
	    cybersourceEnabled: false,
	    /**
	     * Initialization of the module.
	     * @return {void} [description]
	     */
	    init: function init() {
	      /**
	       * From AccountRenewMembership_Data.jsp
	       * @type {Object}
	       */
	      //feature flag for cybersource
	      this.cybersourceEnabled = $("#cybersourceEnabled").val() == 'true';
	      this.membershipData = membershipData;
	      this.validationRules();
	      this.maskInput();
	      verification.init();
	
	      this.authToken = $('[name=authToken]').val();
	
	      if (!helper.isQuickMembership && $('#auto-renew-payment').length === 0) {
	        TokenGateway.refreshGateway();
	      }
	      /**
	       * Binding header and footer links for leave page modal
	       * for given action, depending if it is purchase or renewal flow
	       */
	      COSTCO.util.activateKeyboardAccesiblePopover('co-help');
	      console.log('Renew Membership module initialized');
	
	      if (!$("#autoRenewConsentOptionDiv").is(":hidden") && $('input[name="ftc-click-to-enrole"]').length > 0) {
	        if (!$('input[type="radio"][name="ftc-click-to-enrole"]:checked').val()) {
	          COSTCO.RenewMembership.autoRenew.noConsentInfo();
	        } else {
	          $('input[type="radio"][name="ftc-click-to-enrole"]:checked').trigger('click');
	        }
	      }
	
	      reloadSessionJS();
	    },
	    autoRenew: {
	
	      /**
	       * Constants
	       */
	      constants: {
	        modeType: {
	          ADD: 'ADD_MODE',
	          EDIT: 'EDIT_MODE'
	        },
	
	        autoRenewCardBinRangeRegexPattern: '',
	        testAutoRenewExpirationDateEnabled: false,
	        testAutoRenewExpirationDate: ''
	      },
	      /**
	       * Setting autoRenewCardBinRangeRegexPattern variable
	       * @param {String} binRange - bin range that is stored in XAPPLICATION table
	       * @return {void}
	       */
	      setAutoRenewCardBinRange: function setAutoRenewCardBinRange(binRange) {
	        RenewMembership.autoRenew.constants.autoRenewCardBinRangeRegexPattern = new RegExp(binRange);
	      },
	      /**
	       * Setting testAutoRenewExpirationDateEnabled and testAutoRenewExpirationDate variable
	       * @param {String} testAutoRenewExpirationDateEnabled and testAutoRenewExpirationDate - stored in XAPPLICATION table
	       * @return {void}
	       */
	      setTestAutoRenew: function setTestAutoRenew(testAutoRenewExpirationDateEnabled, testAutoRenewExpirationDate) {
	        RenewMembership.autoRenew.constants.testAutoRenewExpirationDateEnabled = testAutoRenewExpirationDateEnabled;
	        RenewMembership.autoRenew.constants.testAutoRenewExpirationDate = testAutoRenewExpirationDate;
	      },
	      /**
	       * Hide section with last name and zip code for validate membership
	       * @return {void}
	       */
	      hideValidationFieldsForValidatedUser: function hideValidationFieldsForValidatedUser() {
	        if (sessionStorage.getItem("changeValidationFlag") != "true") {
	          $('#vallidation-questions').removeClass('hide');
	        } else {
	          $('#vallidation-questions').addClass('hide');
	        }
	      },
	      validateLastNameZipCode: function validateLastNameZipCode() {
	        var questionLastName = $("#validationQuestionLastName");
	        var lastName = $.trim(questionLastName.val());
	        isLastNameValid = false;
	        if (lastName !== undefined && lastName !== '') {
	          questionLastName.parent()[0].classList.remove("mdc-text-field--invalid");
	          questionLastName[0].classList.remove("highlightError");
	
	          questionLastName.removeProp('required');
	          questionLastName.parent()[0].nextElementSibling.children[0].innerHTML = "";
	          questionLastName.parent()[0].nextElementSibling.style.display = 'none';
	          isLastNameValid = true;
	        } else {
	          questionLastName.parent()[0].classList.add('mdc-text-field--invalid');
	          questionLastName[0].classList.add('highlightError');
	          questionLastName.prop('required', true);
	          questionLastName.parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_INVALID_LASTNAME;
	          questionLastName.parent()[0].nextElementSibling.style.display = 'block';
	          questionLastName.focus();
	          isLastNameValid = false;
	        }
	        var questionZip = $("#validationQuestionZip");
	        var zipCode = $.trim(questionZip.val());
	        isZipValid = false;
	        if (zipCode !== undefined && zipCode !== '' && COSTCO.util.POSTAL_CODE_REGEX_CA.test(zipCode)) {
	          questionZip.parent()[0].classList.remove("mdc-text-field--invalid");
	          questionZip[0].classList.remove("highlightError");
	          questionZip.removeProp('required');
	          questionZip.parent()[0].nextElementSibling.children[0].innerHTML = "";
	          questionZip.parent()[0].nextElementSibling.style.display = 'none';
	          isZipValid = true;
	        } else {
	          questionZip.parent()[0].classList.add('mdc-text-field--invalid');
	          questionZip[0].classList.add('highlightError');
	          questionZip.prop('required', true);
	          questionZip.parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_ENTER_ZIPCODE;
	          questionZip.parent()[0].nextElementSibling.style.display = 'block';
	          if (isLastNameValid) {
	            questionZip.focus();
	          }
	          isZipValid = false;
	        }
	        return isZipValid && isLastNameValid;
	      },
	
	      /**
	       * Add card for auto renew payment. Added check for zipcode and lastname to be sure user is valid and
	       * check if user has attempted to enter wrong parameters more times than allowed. 
	       * @param  {HTMLFormElement} form form Auto renew payment form
	       * @return {void}      [description]
	       */
	      addCard: function addCard(form) {
	
	        $form = $(form);
	
	        var displayMode = $form.find('input[id="displayMode"]').val();
	
	        if ($("#ftc-click-to-enrole").prop('checked') == false && displayMode == 'add') {
	          $("#ftc-enrole").addClass("critical-notification");
	          return;
	        } else {
	          $("#ftc-enrole").removeClass("critical-notification");
	        }
	
	        var sessionId = $form.find('input[id="tokenSessionId"]').val();
	
	        var lastName = $form.find('input[id="questionLastName"]').length > 0 ? $form.find('input[id="questionLastName"]').val() : '';
	        var zipCode = $form.find('input[id="questionZip"]').length > 0 ? $form.find('input[id="questionZip"]').val() : '';
	
	        var isAddAutoRenew = displayMode == 'add' ? true : false; // Default value
	        var isAddAutoRenewConsent = displayMode == 'add' ? true : false; // Default value
	
	        var isAutoRenewSelected = $form.find('input[id="cardForAutorenew"]');
	        if (isAutoRenewSelected.length == 1) {
	          isAddAutoRenew = $form.find('input[id="cardForAutorenew"]').prop('checked');
	        }
	
	        var cardHolderName = $form.find('input[id="cc_nameoncard"]').val();
	
	        var expDate = $form.find('input[id="cc_expiry_date"]').val().split('/');
	
	        var expMonth = void 0;
	        var expYear = void 0;
	        if (expDate.length == 2) {
	          expMonth = expDate[0];
	          expYear = '20' + expDate[1];
	        }
	        var data = {};
	
	        if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	          data = {
	            'action': 'create_token',
	            'sessionId': sessionId,
	            'isAddAutoRenew': isAddAutoRenew,
	            'autoRenewConsent': isAddAutoRenewConsent,
	            'cardHolderName': cardHolderName,
	            'expiryMonth': expMonth,
	            'expiryYear': expYear,
	            'authToken': RenewMembership.authToken
	          };
	        } else {
	          data = {
	            'action': 'create_token',
	            'sessionId': sessionId,
	            'isAddAutoRenew': isAddAutoRenew,
	            'cardHolderName': cardHolderName,
	            'expiryMonth': expMonth,
	            'expiryYear': expYear,
	            'authToken': RenewMembership.authToken
	          };
	        }
	
	        if (sessionStorage.getItem("changeValidationFlag") !== "true" && membershipData.validated && !membershipData.verified) {
	          var url = COSTCO.util.makeUrl('/AjaxAccountAutoRenewMembershipValidationCmd', {
	            lastName: $('#validationQuestionLastName').val().trim(),
	            zipCode: $('#validationQuestionZip').val().trim()
	          });
	
	          COSTCO.MemberVerification.submitRequest(url).then(function (data) {
	            // Check if user entered invalid parameters more times than allowed
	            if (data.memberAccountRecordCheckMaxAttempsReached != 'true') {
	              // Check if user is valid and proceed to add the card
	              if (data.memberAccountRecordMatch == 'true') {
	                sessionStorage.setItem("changeValidationFlag", true);
	                TokenGateway.updateSessionFromForm('card', function () {
	                  data.payMethodId = $('input[name=payMethodId]').val();
	                  if (RenewMembership.cybersourceEnabled) {
	                    data.sessionId = $form.find('input[id="tokenSessionId"]').val();
	                    data.number = $form.find('input[id="number"]').val();
	                  }
	                  RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	                  window.digitalDataEvents = window.digitalDataEvents || [];
	                  digitalDataEvents.push({ ui: "Account | Renew Membership | Add Payment Method" });
	                  if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	                    digitalDataEvents.push({ renewAuto: "Enrolled" });
	                  }
	                }, $form.attr('id'));
	              } else {
	                // Error message if user is not valid
	                $('#account-renew-check-error-wrapper').removeAttr('hidden');
	                // clear payment info
	                $('#card_number').val('');
	                $('#cc_expiry_date').val('');
	                $('#cc_nameoncard').val('');
	                $('#cc_nameoncard_label').removeClass('active');
	                TokenGateway.refreshGateway();
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.message], false, '#account-renew-check-error-wrapper', 'span');
	              }
	            } else {
	              // Error message if user has entered invalid parameters more times than allowed in previous 24h.
	              $('#account-renew-check-error-wrapper').removeAttr('hidden');
	              $('#renew-validate-membership').addClass('hidden');
	              COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.message], false, '#account-renew-check-error-wrapper', 'span');
	              $('.renew-membership-form-and-text').hide();
	            }
	          });
	        } else {
	          TokenGateway.updateSessionFromForm('card', function () {
	            data.payMethodId = $('input[name=payMethodId]').val();
	            if (RenewMembership.cybersourceEnabled) {
	              data.sessionId = $form.find('input[id="tokenSessionId"]').val();
	              data.number = $form.find('input[id="number"]').val();
	            }
	            RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ ui: "Account | Renew Membership | Add Payment Method" });
	            if ($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == '') {
	              digitalDataEvents.push({ renewAuto: "Enrolled" });
	            }
	          }, $form.attr('id'));
	        }
	      },
	
	      /**
	       * cancel add another card
	       */
	      cancelAddCard: function cancelAddCard(form) {
	        $('#add-another-card-form').empty();
	        $('#add-another-card-form').hide();
	        $('#add-another-card-link').show();
	
	        if ($('#selectedCardForAutoRenew').val() == '') {
	          $('#saveAutoRenewSettingBtn').show();
	          $('#cancelAutoRenewBtn').hide();
	        } else {
	          var checkboxes = document.querySelectorAll('input[type="checkbox"]');
	          var cardCheckboxes = Array.from(checkboxes).filter(function (checkbox) {
	            return checkbox.name.startsWith("cardForAutorenew_" + $('#selectedCardForAutoRenew').val()) && $(checkbox).prop("checked");
	          });
	
	          if (cardCheckboxes.length) {
	            $('#saveAutoRenewSettingBtn').hide();
	            $('#cancelAutoRenewBtn').show();
	          } else {
	            $('#saveAutoRenewSettingBtn').show();
	            $('#cancelAutoRenewBtn').hide();
	          }
	        }
	      },
	      /**
	       * Edit auto renew payment info
	       * @param  {HTMLFormElement} form   form Auto renew payment form
	       * @param  {String} cardId Card id
	       * @return {void}
	       */
	      editCard: function editCard(form, cardId) {
	        $form = $(form);
	
	        var sessionId = $form.find('input[id="tokenSessionId"]').val();
	
	        var isAddAutoRenew = $('input[name="ftc-click-to-enrole"]').length > 0 ? false : true; // Default value
	        var isAutoRenewSelected = $form.find('input[id="cardForAutorenew"]');
	        if (isAutoRenewSelected.length == 1) {
	          isAddAutoRenew = $form.find('input[id="cardForAutorenew"]').prop('checked');
	        }
	
	        var cardHolderName = $form.find('input[id="cc_nameoncard"]').val();
	
	        var expDate = $form.find('input[id="cc_expiry_date"]').val().split('/');
	
	        var number = $form.find('input[id="card_number"]').val();
	
	        var expMonth = void 0;
	        var expYear = void 0;
	        if (expDate.length == 2) {
	          expMonth = expDate[0];
	          expYear = '20' + expDate[1];
	        }
	
	        var data = {};
	        if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	          if ($("#ftc-click-to-enrole").prop('checked') != true && $('#selectedCardForAutoRenew').val() == cardId) {
	            util.notification.clearNotification($('#auto-renew-notification'));
	            util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [messages.AUTO_RENEW_CONSENT_INFORMATION_ERROR], true, $('#auto-renew-notification'), 'div');
	            $('#auto-renew-notification').addClass('cds-u-space-mb-md');
	            $('#auto-renew-notification').show();
	            $('#auto-renew-notification').focus();
	            return;
	          } else if ($('#selectedCardForAutoRenew').val() != cardId) {
	            data = {
	              'action': 'update_token',
	              'sessionId': sessionId,
	              'memberCreditAccountId': cardId,
	              'isAddAutoRenew': false,
	              'autoRenewConsent': false,
	              'cardHolderName': cardHolderName,
	              'expiryMonth': expMonth,
	              'expiryYear': expYear,
	              'authToken': RenewMembership.authToken,
	              'number': number
	            };
	          } else {
	            isAddAutoRenew = true;
	            data = {
	              'action': 'update_token',
	              'sessionId': sessionId,
	              'memberCreditAccountId': cardId,
	              'isAddAutoRenew': isAddAutoRenew,
	              'autoRenewConsent': isAddAutoRenew && $("#ftc-click-to-enrole").prop('checked') && $('#selectedCardForAutoRenew').val() != '',
	              'cardHolderName': cardHolderName,
	              'expiryMonth': expMonth,
	              'expiryYear': expYear,
	              'authToken': RenewMembership.authToken,
	              'number': number
	            };
	          }
	        } else {
	          data = {
	            'action': 'update_token',
	            'sessionId': sessionId,
	            'memberCreditAccountId': cardId,
	            'isAddAutoRenew': isAddAutoRenew,
	            'cardHolderName': cardHolderName,
	            'expiryMonth': expMonth,
	            'expiryYear': expYear,
	            'authToken': RenewMembership.authToken,
	            'number': number
	          };
	        }
	
	        TokenGateway.updateSessionFromForm('card', function () {
	          data.payMethodId = $('input[name=payMethodId]').val();
	          if (RenewMembership.cybersourceEnabled) {
	            data.sessionId = $form.find('input[id="tokenSessionId"]').val();
	            data.number = $form.find('input[id="number"]').val();
	          }
	
	          RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	          window.digitalDataEvents = window.digitalDataEvents || [];
	          digitalDataEvents.push({ ui: "Account | Renew Membership | Update Payment Method" });
	          if ($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == cardId) {
	            digitalDataEvents.push({ renewAuto: "Enrolled" });
	          }
	        }, $form.attr('id'));
	      },
	
	      /**
	       * Cancel update on canceling update of paymenr method for auto renew
	       * @param  {string} formType	Form type to show (add_another | edit)
	       * @param  {number} cardId 		Card id
	       * @return {void}
	       */
	      cancelUpdate: function cancelUpdate(formType, cardId) {
	        $('#auto-payment-item-' + cardId).removeClass('hide');
	        $('#auto-payment-form-item-' + cardId).html('');
	        if ($('#selectedCardForAutoRenew').val() == '') {
	          $('#saveAutoRenewSettingBtn').show();
	          $('#cancelAutoRenewBtn').hide();
	        } else {
	          $('#saveAutoRenewSettingBtn').hide();
	          $('#cancelAutoRenewBtn').show();
	        }
	        $('#auto-renew-notification').hide();
	        if ($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == cardId) {
	          $('#autoRenewConsentOptionDiv').hide();
	          $('#ftc-enrole-information').hide();
	        }
	      },
	      /**
	       * Remove credit card for auto renew
	       * @param {string} bodyMessage 	To be displayed in modal
	       * @param {string} cardId   			Card id to delete
	       */
	      deleteCard: function deleteCard(bodyMessage, cardId) {
	        //remove add another form and show add another link
	        $('#add-another-card-link').show();
	        $('#add-another-card-form').empty();
	        //remove update form and display update remove links opened for update
	        $('[data-card-id]').each(function (index, value) {
	          $value = $(value);
	          var currentId = $value.attr('data-card-id');
	          $('#auto-payment-item-' + currentId).removeClass('hide');
	          $('#auto-payment-form-item-' + currentId).empty();
	        });
	
	        if (RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
	          return;
	        } else if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
	          // last name and zip code is not valid, show validation prescreen
	          COSTCO.MembershipValidation.showValidationPrescreen();
	          return;
	        }
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVE_CARD,
	          body: bodyMessage,
	          primary: messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVE_CARD,
	          secondary: messages.JS_DIALOG_CANCEL,
	          dialogclasses: 'remove-card-modal',
	          primary_event: function primary_event() {
	            var data = {};
	            if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	              if ($('#selectedCardForAutoRenew').val() == cardId) {
	                data = {
	                  'action': 'delete_token',
	                  'autoRenewConsent': false,
	                  'memberCreditAccountId': $('#selectedCardForAutoRenew').val(),
	                  'authToken': RenewMembership.authToken
	                };
	              } else {
	                data = {
	                  'action': 'delete_token',
	                  'memberCreditAccountId': cardId,
	                  'autoRenewConsent': $('#selectedCardForAutoRenew').val() != '',
	                  'authToken': RenewMembership.authToken
	                };
	              }
	            } else {
	              data = {
	                'action': 'delete_token',
	                'memberCreditAccountId': cardId,
	                'authToken': RenewMembership.authToken
	              };
	            }
	
	            RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ ui: "Account | Renew Membership | Remove Payment Method" });
	            if ($('#selectedCardForAutoRenew').val() == cardId) {
	              digitalDataEvents.push({ renewAuto: "Not Enrolled" });
	            }
	
	            COSTCO.dialog.close();
	          }
	        });
	      },
	
	      /**
	       * Sets card for auto renew (on / off)
	       * @param {Element} element Input element to get if user has checked for autorenew
	       * @param {string} cardId  Card id to update
	       */
	      setAsDefaultAutoRenew: function setAsDefaultAutoRenew(element, cardId, hasPayer) {
	        if (event.type == 'click' || event.type == 'keydown' && event.code == 'Space') {
	          if ($('#add-another-card-form').is(":visible")) {
	            $('#add-another-card-form').hide();
	            $('#saveAutoRenewSettingBtn').show();
	          }
	          if ($('#add-another-card-link').is(":hidden")) {
	            $('#add-another-card-link').show();
	          }
	          var checkboxes = document.querySelectorAll('input[type="checkbox"]');
	          var cardCheckboxes = Array.from(checkboxes).filter(function (checkbox) {
	            return checkbox.name.startsWith("cardForAutorenew_" + cardId);
	          });
	          var otherCardCheckboxes = Array.from(checkboxes).filter(function (checkbox) {
	            return checkbox.name.startsWith("cardForAutorenew_") && !checkbox.name.startsWith("cardForAutorenew_" + cardId);
	          });
	          if (RenewMembership.autoRenew.hasUserReachedMaxAttempts() || !RenewMembership.autoRenew.isValidMembershipInfo() || $('input[name="ftc-click-to-enrole"]').length > 0) {
	
	            if ($('#selectedCardForAutoRenew').val() == cardId) {
	
	              if ($(window).width() > 1024 && cardCheckboxes[1].checked || $(window).width() < 1024 && !cardCheckboxes[0].checked) {
	                $('#saveAutoRenewSettingBtn').show();
	                $('#cancelAutoRenewBtn').hide();
	              } else {
	                $('#saveAutoRenewSettingBtn').hide();
	                $('#cancelAutoRenewBtn').show();
	              }
	
	              $('#autoRenewConsentOptionDiv').hide();
	              $('#ftc-enrole-information').hide();
	            } else {
	              $('#autoRenewConsentOptionDiv').show();
	              $('#saveAutoRenewSettingBtn').show();
	              $('#cancelAutoRenewBtn').hide();
	              $('#ftc-enrole-information').show();
	            }
	            if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
	              COSTCO.MembershipValidation.showValidationPrescreen();
	            }
	
	            if (cardCheckboxes.length) {
	              if ($(window).width() > 1024 && cardCheckboxes[1].checked) {
	                $("[id='cardForAutorenew_" + cardId + "']").prop("checked", false);
	              } else if ($(window).width() > 1024 && !cardCheckboxes[1].checked) {
	                $("[id='cardForAutorenew_" + cardId + "']").prop("checked", true);
	              } else if ($(window).width() < 1024 && cardCheckboxes[0].checked) {
	                $("[id='cardForAutorenew_" + cardId + "']").prop("checked", true);
	              } else if ($(window).width() < 1024 && !cardCheckboxes[0].checked) {
	                $("[id='cardForAutorenew_" + cardId + "']").prop("checked", false);
	              }
	              if (otherCardCheckboxes.length) {
	                otherCardCheckboxes.forEach(function (item) {
	                  $(item).prop("checked", false);
	                });
	              }
	            }
	
	            return;
	          }
	          if ($('input[name="ftc-click-to-enrole"]').length == 0) {
	            if (typeof hasPayer == 'undefined' && !element.checked) {
	              element.checked = true;
	
	              COSTCO.dialog.createExtDialogBox({
	                title: messages.ACCOUNT_RENEW_MEMBERSHIP_USE_CARD_FOR_AUTO_RENEW,
	                body: messages.ACCOUNT_RENEW_MEMBERSHIP_USE_CARD_FOR_AUTO_RENEW_DEFAULT_TEXT,
	                primary: messages.JS_DIALOG_YES,
	                secondary: messages.JS_DIALOG_NO,
	                dialogclasses: 'remove-card-modal',
	                primary_event: function primary_event() {
	                  var data = {
	                    'action': 'delete_renew',
	                    'memberCreditAccountId': cardId,
	                    'authToken': RenewMembership.authToken
	                  };
	
	                  RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	                  COSTCO.dialog.close();
	                },
	                secondary_event: function secondary_event() {
	                  $("[id='cardForAutorenew_" + cardId + "']").prop("checked", true);
	                  COSTCO.dialog.close();
	                }
	              });
	            } else {
	              var data = {
	                'action': 'add_renew',
	                'memberCreditAccountId': cardId,
	                'authToken': RenewMembership.authToken
	              };
	              RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	            }
	          }
	        }
	      },
	
	      /**
	       * enroll auto renew 
	       */
	      enroll: function enroll(displayMode) {
	        $('#cancelAutoRenewBtn').hide();
	        $('#displayAddEditCards').show();
	        if (displayMode == 'add') {
	          $('#saveAutoRenewSettingBtn').hide();
	        }
	        if (displayMode == 'edit' && $('#cardForAutorenew_' + $('#selectedCardForAutoRenew').val()).prop('checked') == true) {
	          RenewMembership.showCreditCardForm('edit', $('#selectedCardForAutoRenew').val(), RenewMembership.renewCreditCardData);
	
	          $('#autoRenewConsentOptionDiv').show();
	          $('#ftc-enrole-information').show();
	          $('#saveAutoRenewSettingBtn').hide();
	          $('#cancelAutoRenewBtn').hide();
	        }
	      },
	
	      noConsentInfo: function noConsentInfo() {
	
	        if ($('#selectedCardForAutoRenew').val() == '') {
	          $('#displayAddEditCards').hide();
	          $('#saveAutoRenewSettingBtn').show();
	          $('#cancelAutoRenewBtn').hide();
	          $('#autoRenewConsentOptionDiv').show();
	          $('#ftc-enrole-information').show();
	        } else {
	          $('#displayAddEditCards').show();
	          $('#saveAutoRenewSettingBtn').hide();
	          $('#cancelAutoRenewBtn').show();
	          $('#autoRenewConsentOptionDiv').hide();
	          $('#ftc-enrole-information').hide();
	        }
	        $('#auto-renew-notification').hide();
	      },
	
	      /**
	       * unenroll auto renew 
	       */
	      unenroll: function unenroll(displayMode) {
	        $('#displayAddEditCards').hide();
	        $('#saveAutoRenewSettingBtn').show();
	        $('#cancelAutoRenewBtn').hide();
	        if (displayMode == 'add') {
	          $('#card_number').val('');
	          $('#cc_expiry_date').val('');
	          $('#cc_nameoncard').val('');
	          $('#cc_nameoncard_label').removeClass('active');
	          reloadSessionJS();
	        }
	
	        if (displayMode == 'edit' && $('#cardForAutorenew_' + $('#selectedCardForAutoRenew').val()).prop('checked') == true) {
	
	          RenewMembership.autoRenew.cancelUpdate(RenewMembership.getForm(), $('#selectedCardForAutoRenew').val());
	
	          $('#autoRenewConsentOptionDiv').show();
	          $('#ftc-enrole-information').show();
	          $('#saveAutoRenewSettingBtn').show();
	          $('#cancelAutoRenewBtn').hide();
	        }
	      },
	
	      cancelAutoRenew: function cancelAutoRenew() {
	
	        if (RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
	          return;
	        } else if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
	          // last name and zip code is not valid, show validation prescreen
	          COSTCO.MembershipValidation.showValidationPrescreen();
	          return;
	        }
	        var data = {
	          'action': 'delete_renew',
	          'autoRenewConsent': false,
	          'memberCreditAccountId': $('#selectedCardForAutoRenew').val(),
	          'authToken': RenewMembership.authToken
	        };
	        RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	        $('#auto-renew-notification').show();
	        $('#auto-renew-notification').focus();
	        window.digitalDataEvents = window.digitalDataEvents || [];
	        digitalDataEvents.push({ renewAuto: "Not Enrolled" });
	      },
	
	      /**
	       * save auto renew settings 
	       */
	      saveAutoRenewSettings: function saveAutoRenewSettings() {
	
	        if (RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
	          return;
	        } else if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
	          // last name and zip code is not valid, show validation prescreen
	          COSTCO.MembershipValidation.showValidationPrescreen();
	          return;
	        }
	        var checkboxes = document.querySelectorAll('input[type="checkbox"]');
	        var selectedCheckboxes = Array.from(checkboxes).filter(function (checkbox) {
	          return checkbox.checked && checkbox.name.startsWith("cardForAutorenew_");
	        });
	        var renewCardCheckboxes = Array.from(checkboxes).filter(function (checkbox) {
	          return !checkbox.checked && checkbox.name.startsWith("cardForAutorenew_" + $('#selectedCardForAutoRenew').val());
	        });
	        if ($("#ftc-click-to-enrole").prop('checked') == true) {
	          if (selectedCheckboxes.length) {
	            var firsSelected = selectedCheckboxes[0];
	            var firstSelectedSplited = firsSelected.id.split('_');
	            if (firstSelectedSplited.length && firstSelectedSplited.length > 1) {
	              var selectedCardId = firstSelectedSplited[1];
	              var data = {
	                'action': 'add_renew',
	                'autoRenewConsent': true,
	                'memberCreditAccountId': selectedCardId,
	                'authToken': RenewMembership.authToken
	              };
	              $('#ftc-enrole-error').addClass('hide');
	              $("#ftc-enrole > label.control > div.control__indicator").removeClass("critical");
	              RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	              $('#auto-renew-notification').show();
	              $('#auto-renew-notification').focus();
	              window.digitalDataEvents = window.digitalDataEvents || [];
	              digitalDataEvents.push({ ui: "Account | Renew Membership | Save Payment Method Auto Renew Settings" });
	              digitalDataEvents.push({ renewAuto: "Enrolled" });
	            }
	          } else {
	            $('#auto-renew-notification').hide();
	            $('#ftc-enrole-error').removeClass('hide');
	            $('#ftc-enrole-error').focus();
	            $("#ftc-enrole > label.control > div.control__indicator").addClass("critical");
	          }
	        } else if ($("#ftc-click-to-enrole-not").prop('checked') == true || renewCardCheckboxes.length && !selectedCheckboxes.length && $('#selectedCardForAutoRenew').val() != "") {
	
	          var _data = {
	            'action': 'delete_renew',
	            'autoRenewConsent': false,
	            'memberCreditAccountId': $('#selectedCardForAutoRenew').val(),
	            'authToken': RenewMembership.authToken
	          };
	          RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(_data);
	          $('#auto-renew-notification').show();
	          $('#auto-renew-notification').focus();
	          window.digitalDataEvents = window.digitalDataEvents || [];
	          digitalDataEvents.push({ ui: "Account | Renew Membership | Save Payment Method Auto Renew Settings" });
	          digitalDataEvents.push({ renewAuto: "Not Enrolled" });
	        } else {
	          util.notification.clearNotification($('#auto-renew-notification'));
	          util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [messages.AUTO_RENEW_CONSENT_INFORMATION_ERROR], true, $('#auto-renew-notification'), 'div');
	          $('#auto-renew-notification').addClass('cds-u-space-mb-md');
	          $('#auto-renew-notification').show();
	          $('#auto-renew-notification').focus();
	        }
	      },
	      /**
	       * Add placeholder on expiration date 
	       * @return void
	       */
	      addPlaceHolder: function addPlaceHolder(expirationDate) {
	        expirationDate.placeholder = "MM/YY";
	      },
	      /**
	       * Remove placeholder on expiration date 
	       * @return void
	       */
	      removePlaceHolder: function removePlaceHolder(expirationDate) {
	        if (expirationDate && expirationDate.value === '') {
	          $("label[for='" + $(expirationDate).attr('id') + "']").removeClass('active');
	          expirationDate.placeholder = "";
	        }
	      },
	      services: {
	        /**
	         * Ajax modular service for handling auto renew payment
	         * @param  {object} data   JSON Object to be sent to backend
	         */
	        ajaxManageAutoRenewPayment: function ajaxManageAutoRenewPayment(data) {
	          util.notification.clearNotification($('#auto-renew-notification'));
	          $('#auto-renew-notification').removeClass('cds-u-space-mb-md');
	          RenewMembership.validateStorePaymentForm();
	          var form = RenewMembership.getForm();
	          if (form.valid()) {
	            $('.gw-proxy-number').removeClass('card-number-error');
	
	            var autoRenewAction = data.action;
	            var autoRenewCardUpdate = data.memberCreditAccountId == $('#selectedCardForAutoRenew').val();
	
	            COSTCO.Checkout.ajax_update_state({
	              method: 'POST',
	              url: '/AjaxManageAutoRenewPayment',
	              data: data,
	              dataType: 'json',
	              done: function done(data, textStatus, jqXHR, options) {
	                // Reset content of Top Notification if user is Business membership eligible for renewal
	                if ($('#business-primary-top-notification').length) {
	                  util.notification.displayNotification(util.notification.type.WARNING, [$('#business-primary-top-notification').text().trim()]);
	                }
	                if (data != undefined) {
	                  if (data.error.application.length > 0) {
	                    util.notification.displayNotification(util.notification.type.ERROR, data.error.application, true, $('#auto-renew-notification'), 'div');
	                    $('#auto-renew-notification').addClass('cds-u-space-mb-md');
	                    if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	                      if ($("#ftc-click-to-enrole").prop('checked') == true) {
	                        $("#ftc-enrole > label.control > div.control__indicator").addClass("critical");
	                      } else if ($("#ftc-click-to-enrole-not").prop('checked') == true) {
	                        $("#ftc-enrole-not > label.control > div.control__indicator").addClass("critical");
	                      }
	                    }
	                  } else {
	                    if (typeof data.payload.data.maxAttemptReached !== 'undefined' && data.payload.data.maxAttemptReached === true) {
	                      $('#notification-max-attempt-reached').removeClass('hidden');
	                      return;
	                    }
	                    COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	                    if (typeof data.payload.data.autoRenewSuccess !== 'undefined' && data.payload.data.autoRenewSuccess === 'true') {
	                      var currentDate = new Date();
	                      var expirationDate = void 0;
	                      var billingDate = void 0;
	                      var twoDayesBefooreBilling = void 0;
	
	                      if (COSTCO.RenewMembership.autoRenew.constants.testAutoRenewExpirationDateEnabled === 'true' && COSTCO.RenewMembership.autoRenew.constants.testAutoRenewExpirationDate !== 'undefined') {
	                        expirationDate = new Date(COSTCO.RenewMembership.autoRenew.constants.testAutoRenewExpirationDate);
	                      } else {
	                        expirationDate = new Date(membershipData.caller.expireDate.year.value, parseInt(membershipData.caller.expireDate.month.value) - 1, membershipData.caller.expireDate.day.value, 0, 0, 0, 0);
	                      }
	                      billingDate = new Date(expirationDate);
	                      billingDate.setMonth(billingDate.getMonth() - 1);
	
	                      twoDayesBefooreBilling = new Date(billingDate);
	                      twoDayesBefooreBilling.setDate(twoDayesBefooreBilling.getDate() - 2);
	
	                      var notificationStatus = void 0;
	                      var notificationMessage = void 0;
	                      switch (autoRenewAction) {
	                        case 'delete_renew':
	                          if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	                            notificationStatus = COSTCO.util.notification.type.SUCCESS;
	                          } else {
	                            notificationStatus = COSTCO.util.notification.type.WARNING;
	                          }
	                          if (currentDate.getTime() < billingDate.getTime()) {
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW;
	                          } else {
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW_AFTER_BILLING;
	                          }
	                          break;
	                        case 'delete_token':
	                          if ($('input[name="ftc-click-to-enrole"]').length > 0 && autoRenewCardUpdate) {
	                            notificationStatus = COSTCO.util.notification.type.SUCCESS;
	                          } else if ($('input[name="ftc-click-to-enrole"]').length > 0 && !autoRenewCardUpdate) {
	                            notificationStatus = "";
	                          } else {
	                            notificationStatus = COSTCO.util.notification.type.WARNING;
	                          }
	                          if (currentDate.getTime() < billingDate.getTime()) {
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW;
	                          } else {
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW_AFTER_BILLING;
	                          }
	
	                          break;
	                        default:
	                          if ($('input[name="ftc-click-to-enrole"]').length > 0 && !autoRenewCardUpdate && autoRenewAction == 'update_token') {
	                            notificationStatus = "";
	                            notificationMessage = "";
	                          } else if (currentDate.getTime() < twoDayesBefooreBilling.getTime()) {
	                            notificationStatus = COSTCO.util.notification.type.SUCCESS;
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_ADDED_AUTO_RENEW;
	                          } else if (currentDate.getTime() < billingDate.getTime()) {
	                            notificationStatus = COSTCO.util.notification.type.WARNING;
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_ADDED_AUTO_RENEW_TWO_DAYS_BEFORE_BILLING;
	                          } else {
	                            notificationStatus = COSTCO.util.notification.type.SUCCESS;
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_ADDED_AUTO_RENEW_AFTER_BILLING;
	                          }
	                      }
	                      if (notificationStatus && notificationMessage) {
	                        util.notification.displayNotification(notificationStatus, [notificationMessage], true, $('#auto-renew-notification'), 'div');
	                        $('#auto-renew-notification').addClass(' cds-u-space-mt-md cds-u-space-mb-md');
	                        $('#auto-renew-notification').show();
	                        $('#auto-renew-notification').focus();
	                      }
	                    }
	                  }
	                  $('input[type="radio"][name="ftc-click-to-enrole"]:checked').trigger('click');
	                }
	                TokenGateway.refreshGateway();
	              }
	            });
	          }
	        }
	      },
	      /**
	       * Opens Add Card dialog when membership is payed by someone else
	       * @param  {[type]} mode [description]
	       * @return {void}      [description]
	       */
	      openHasPayerAddCardDialog: function openHasPayerAddCardDialog(mode) {
	        var settings = {
	          title: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Add_Card_Dialog_Title_Text,
	          body: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Add_Card_Dialog_Body_Text,
	          primary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Add_Card_Button_Text,
	          secondary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Cancel_Button_Text,
	          secondary_event: function secondary_event() {
	            COSTCO.dialog.close();
	          }
	        };
	        if (mode == this.constants.modeType.ADD) {
	          settings.primary_event = function () {
	            COSTCO.RenewMembership.autoRenew.addCard($('#StorePaymentForm'));
	            COSTCO.dialog.close();
	          };
	        } else if (mode == this.constants.modeType.EDIT) {
	          settings.primary_event = function () {
	            COSTCO.RenewMembership.showCreditCardForm('add_another');
	            COSTCO.dialog.close();
	          };
	        }
	        COSTCO.dialog.createExtDialogBox(settings);
	      },
	      /**
	       * Opens Use Card dialog when membership is payed by someone else
	       * @param  {[type]} memberCreditAccountId [description]
	       * @return {void}                       [description]
	       */
	      openHasPayerUseCardDialog: function openHasPayerUseCardDialog(memberCreditAccountId) {
	        var settings = {
	          title: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Use_Card_Dialog_Title_Text,
	          body: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Use_Card_Dialog_Body_Text,
	          primary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Use_Card_Button_Text,
	          secondary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Cancel_Button_Text,
	          primary_event: function primary_event() {
	            COSTCO.RenewMembership.autoRenew.setAsDefaultAutoRenew($('#cardForAutorenew_' + memberCreditAccountId), memberCreditAccountId, true);
	            COSTCO.dialog.close();
	          },
	          secondary_event: function secondary_event() {
	            COSTCO.dialog.close();
	          }
	        };
	        COSTCO.dialog.createExtDialogBox(settings);
	      },
	
	      /**
	      * Validation to check if user already filled membership info before any action for auto renew.
	      * If not valid, dialog form will be shown
	      */
	      validateMembershipInfo: function validateMembershipInfo() {
	        if (!sessionStorage.getItem("changeValidationFlag")) {
	          COSTCO.MembershipValidation.showValidationPrescreen();
	          return false;
	        }
	        return true;
	      },
	
	      /**
	       * Validation to check if user already filled membership info before any action for auto renew.
	       */
	      isValidMembershipInfo: function isValidMembershipInfo() {
	        return membershipData.verified || sessionStorage.getItem("changeValidationFlag");
	      },
	      /**
	      * Check if user has reached max attempts to update payment info for renew membership.
	      * Needed for popup validation (check function "validateMembershipInfo")
	      * @returns boolean
	      */
	      hasUserReachedMaxAttempts: function hasUserReachedMaxAttempts() {
	        return $("#maxAttemptRetriesReached").val() === "true";
	      }
	
	    },
	
	    /**
	     * The interface to remove an affiliate from the "Renew Membership"
	     * feature (/RenewMembershipView) for business members.
	     * @param  {Number} affiliateMembershipNumber The affiliate's membership num
	     * @return {void}
	     */
	    removePerson: function removePerson(affiliateMembershipNumber, isQuickMembership) {
	      var affiliate = helper.getAffiliateFromDataBeanByNumber(this.membershipData, affiliateMembershipNumber);
	      if (isQuickMembership !== undefined && isQuickMembership !== '') {
	        helper.isQuickMembership = isQuickMembership;
	      }
	      // This is necessary because affForm.removePerson is expecting an object
	      // thats tied to how the membership application "configProduct" represents
	      // that affiliate, this will normalize that.
	      affiliate = {
	        membershipNumber: affiliate.cardNumber.value,
	        firstName: affiliate.firstName.value,
	        lastName: affiliate.lastName.value
	      };
	      affForm.removePerson({
	        affiliate: affiliate,
	        isRenew: true,
	        excludeData: true,
	        action: 'remove-affiliate',
	        isQuickMembershipCheckout: helper.isQuickMembership
	      });
	    },
	    /**
	     * The interface to remove an affiliate household from the "Renew Membership"
	     * feature (/RenewMembershipView) for business members.
	     * @param  {Number} affiliateMembershipNumber The affiliate's membership num
	     * @return {void}
	     */
	    removePersonHousehold: function removePersonHousehold(affiliateMembershipNumber) {
	      var affiliate = helper.getAffiliateFromDataBeanByNumber(this.membershipData, affiliateMembershipNumber);
	      // This is necessary because affForm.removePerson is expecting an object
	      // thats tied to how the membership application "configProduct" represents
	      // that affiliate, this will normalize that.
	      affiliate = {
	        membershipNumber: affiliate.cardNumber.value,
	        firstName: affiliate.firstName.value,
	        lastName: affiliate.lastName.value,
	        houseHold: {
	          membershipNumber: affiliate.household.cardNumber.value,
	          firstName: affiliate.household.firstName.value,
	          lastName: affiliate.household.lastName.value
	        }
	      };
	      affForm.removePerson({
	        affiliate: affiliate,
	        isRenew: true,
	        excludeData: true,
	        action: 'remove-household'
	      });
	    },
	    /**
	     * Add an affiliate using /MemberAffiliateAddCmd
	     * @method
	     * @return {void}
	     */
	    addPerson: function addPerson() {
	      affForm.openAddPersonModal({
	        isRenew: true
	      });
	    },
	    /**
	     * Add a person to a household as part of ther renew membership flow.
	     * @param  {Number} membershipNumber The Affiliate membershipNumber
	     * @return {void}
	     */
	    addPersonWithinHousehold: function addPersonWithinHousehold(membershipNumber) {
	      var affiliate = helper.getAffiliateFromDataBeanByNumber(this.membershipData, membershipNumber);
	      affForm.editPerson({
	        affiliate: affiliate,
	        action: 'update',
	        addHousehold: true,
	        isRenew: true
	      });
	    },
	    /**
	     * Validation rules
	     * @return {void} [description]
	     */
	    validationRules: function validationRules() {
	      $.validator.addMethod('membershipNumber', function (value, element) {
	        return (/^\d{12,16}$/.test(value)
	        );
	      }, messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_MembershipNumberInvalid_Text);
	
	      $.validator.addMethod('customcc', function (value, element) {
	        value = value.replace(/\s+/g, '');
	        if (value.indexOf('*') > 0 && value.length == 16) {
	          return true;
	        }
	        return this.optional(element) || /^7\d{5}\*{6}\d{4}$/.test(value) || /^\S{6}(\*{3}|\*{5})\s?\d{4}$/.test(value) || /^\S{6}\*{6}\s?\d{4}$/.test(value) || $.validator.methods.creditcard.call($.data(element.form, 'validator'), value, element);
	      });
	
	      $.validator.addMethod('autorenewcostcocc', function (value, element) {
	        return this.optional(element) || /^(2|4|5)/.test(value);
	      });
	
	      $.validator.addMethod('cobrandedcard', function (value, element) {
	        return RenewMembership.autoRenew.constants.autoRenewCardBinRangeRegexPattern.test(value);
	      });
	
	      $.validator.addMethod('checkSpecialchar', function (value, element) {
	        return this.optional(element) || !/[<>\'\"]/.test(value); // CC name shouldn't have any html tag
	      });
	
	      $.validator.addMethod('checkExpiryDate', function (value, element) {
	        return this.optional(element) || /^(0[1-9]|1[012])\/([123]\d)$/.test(value);
	      });
	
	      $.validator.addMethod('checkIsDateInPast', function (value, element) {
	        var enteredMonth = parseInt(value.split('/')[0]);
	        var enteredYear = parseInt(value.split('/')[1]);
	        var now = new Date();
	        var currentMonth = parseInt((now.getMonth() + 1).toString());
	        var currentYear = parseInt(now.getFullYear().toString().substr(-2));
	        if (enteredYear < currentYear || enteredYear == currentYear && enteredMonth < currentMonth) {
	          return false;
	        } else {
	          return true;
	        }
	      });
	      $.validator.addMethod('checkZipCode', function (value, element) {
	        var zipCode = $.trim($('#validationQuestionZip').val());
	        var langId = COSTCO.util.getLangId();
	        var regex = COSTCO.util.POSTAL_CODE_REGEX_US;
	        if (parseInt(langId) === -24 || parseInt(langId) === -25) {
	          regex = COSTCO.util.POSTAL_CODE_REGEX_CA;
	        }
	
	        return zipCode !== undefined && zipCode !== '' && regex.test($.trim(value));
	      });
	    },
	
	    /**
	     * Checks renewal date
	     * @return {void} [description]
	     */
	    checkRenewalDate: function checkRenewalDate() {
	      util.notification.clearNotification();
	      if (this.validateCheckRenewalDateForm()) {
	        COSTCO.Checkout.ajax_update_state({
	          method: 'POST',
	          url: '/AjaxMembershipCheckRenewalDateCmd',
	          data: $('#check-renewal-date').serialize(),
	          dataType: 'json',
	          done: function done(data, textStatus, jqXHR, options) {
	            var returnData = data.payload.data;
	            var statusReason = returnData.membershipStatusReason;
	            if (!returnData.isMembershipNumberValid) {
	              util.notification.displayNotification(util.notification.type.ERROR, [messages.MEMBERVERIFICATION_MEMBERSHIP__InfoDoesNotMatchOurRecords]);
	            } else {
	              if (returnData.maxAttemptReached) {
	                util.notification.displayNotification(util.notification.type.ERROR, [messages.MEMBERSHIP_UnverifiedRenewal_MaxAttemps]);
	              } else if (statusReason != '' && statusReason != 'Z10' && statusReason != 'Z24') {
	                // If we're not active ("" || Z10) or Expired (Z24), can't
	                // renew online.
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['You\'re unable to renew online, please visit a warehouse.']);
	              } else {
	                COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	              }
	            }
	          },
	          always: function always() {
	            $('.order-ajax').removeClass('ajax-busy');
	          }
	        });
	      }
	    },
	    /**
	     * Mask expiry date
	     * @return {void} [description]
	     */
	    maskInput: function maskInput() {
	      $('#cc_expiry_date').mask('00/00', {});
	      $('#card_number').mask('ZZZZ ZZZZ ZZZZ 0000', {
	        selectOnFocus: true,
	        translation: {
	          'Z': {
	            pattern: '[\\*0-9]'
	          }
	        }
	      });
	      var langId = COSTCO.util.getLangId();
	      if (parseInt(langId) === -24 || parseInt(langId) === -25) {
	        $('#validationQuestionZip').unmask().mask('S0S 0S0');
	      } else {
	        $('#validationQuestionZip').unmask().mask('00000');
	      }
	    },
	    /**
	     * Validates CheckRenewalDate form
	     * @return {[type]} [description]
	     */
	    validateCheckRenewalDateForm: function validateCheckRenewalDateForm() {
	      $('#check-renewal-date').validate({
	        rules: {
	          memberLastNameToRenew: {
	            required: true
	          },
	          membershipNumberToRenew: {
	            required: {
	              depends: function depends() {
	                $(this).val($.trim($(this).val()));
	                return true;
	              }
	            },
	            membershipNumber: true
	          }
	        },
	        messages: {
	          memberLastNameToRenew: {
	            required: messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_LastNameMissing_Text
	          },
	          membershipNumberToRenew: {
	            required: messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_MembershipNumberMissing_Text,
	            membershipNumber: messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_MembershipNumberInvalid_Text
	          }
	        }
	      });
	      return $('#check-renewal-date').valid();
	    },
	    /**
	     * Manage payment method
	     * @param  {string} action   action type (delete_renew | delete_token | )
	     * @param  {[type]} memberCreditAccountId   [member card account id]
	     * @return {void}
	     */
	    managePaymentMethods: function managePaymentMethods(action, memberCreditAccountId) {
	      COSTCO.Checkout.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxManageAutoRenewPayment',
	        data: {
	          'action': action,
	          'memberCreditAccountId': memberCreditAccountId,
	          'authToken': RenewMembership.authToken
	        },
	        dataType: 'json',
	
	        done: function done(data, textStatus, jqXHR, options) {
	          util.notification.clearNotification();
	
	          if (data != undefined) {
	            if (data.error.application.length > 0) {
	              util.notification.displayNotification(util.notification.type.ERROR, data.error.application);
	            } else {
	              COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	            }
	          }
	        },
	        always: function always(data, textStatus, jqXHR, options) {
	          $('.order-ajax').removeClass('ajax-busy');
	          // location.reload();
	        }
	      });
	    },
	    /**
	     * Validates the Payment Methods add/edit form
	     * @return {void}
	     */
	    validateStorePaymentForm: function validateStorePaymentForm() {
	      var form = RenewMembership.getForm();
	      var isCreditCardNumberValidationRequired = false;
	      //validate cc number when adding new card. Also validate on update card if cc number is changed:
	      if (displayMode.value.indexOf('add') >= 0 || displayMode.value.indexOf('edit') >= 0 && !$('#card_number').val()) isCreditCardNumberValidationRequired = true;
	      form.validate({
	        rules: {
	          cc_nameoncard: {
	            required: true,
	            checkSpecialchar: true
	          },
	          cc_expiry_date: {
	            required: true,
	            checkExpiryDate: true,
	            checkIsDateInPast: true
	          },
	          questionLastName: {
	            required: true
	          },
	          questionZip: {
	            required: true,
	            checkZipCode: true
	          }
	        },
	        messages: {
	          number: {
	            required: messages.ERR_CCNUM_REQ,
	            customcc: messages.ERR_INVALID_CREDITCARD_SHORT,
	            autorenewcostcocc: messages.MEMBERSHIP_RENEW__ERR_INVALID_CCNUM_AUTO_RENEW,
	            cobrandedcard: messages.ERR_COBRANDED_CREDITCARD
	          },
	          cc_nameoncard: {
	            required: messages.ERR_INVALID_CC_NAME,
	            checkSpecialchar: messages.ERR_INVALID_CC_NAME
	          },
	          cc_expiry_date: {
	            required: messages.ERR_EXPIRYDATE_REQ,
	            checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	            checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	          },
	          questionLastName: {
	            required: messages.ERR_INVALID_LASTNAME
	          },
	          questionZip: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            checkZipCode: messages.ERR_ENTER_ZIPCODE
	          }
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          if (element.is('#card_number_validator')) {
	            $('.gw-proxy-number').css('border', '');
	            $('.gw-proxy-number').addClass('card-number-error');
	            error.insertAfter(element);
	          } else {
	            error.insertAfter(element);
	          }
	        }
	      });
	
	      if (form.length != 0) {
	        return form.valid();
	      }
	    },
	    /**
	     * Shows credit card form on the page, and hides all other opened credit card forms
	     * @param  {string} formType	Form type to show (add_another | edit)
	     * @param  {number} cardId 		Card id
	     * @param  {[type]} data [description]
	     * @return {void}
	     */
	    showCreditCardForm: function showCreditCardForm(formType, cardId, data) {
	      if (membershipData.validated == true && membershipData.verified == false) {
	        if (RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
	          return;
	        } else if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
	          // last name and zip code is not valid, show validation prescreen
	          COSTCO.MembershipValidation.showValidationPrescreen();
	          return;
	        }
	      }
	      var formHtmlBlock = void 0;
	      var template = 'tmpl_auto_renew_membership_' + formType;
	      if (!this.cybersourceEnabled || formType === 'add_another') {
	        createTokenSessionId('true');
	      }
	      //}
	      $('#saveAutoRenewSettingBtn').hide();
	      $('#cancelAutoRenewBtn').hide();
	      $('#auto-renew-notification').hide();
	      if (formType === 'add_another') {
	        $('#add-another-card-link').hide();
	        formHtmlBlock = '#add-another-card-form';
	      } else if (formType === 'edit') {
	        if ($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == cardId) {
	          $('#autoRenewConsentOptionDiv').show();
	          $('#ftc-enrole-information').show();
	          RenewMembership.renewCreditCardData = data;
	        } else {
	          $('#autoRenewConsentOptionDiv').hide();
	          $('#ftc-enrole-information').hide();
	        }
	        $('#add-another-card-link').show();
	        $('#add-another-card-form').empty();
	        $('#auto-payment-item-' + cardId).addClass('hide');
	        formHtmlBlock = '#auto-payment-form-item-' + cardId;
	      } else {
	        return;
	      }
	      $('[data-card-id]').each(function (index, value) {
	        $value = $(value);
	        var currentId = $value.attr('data-card-id');
	        if (formType === 'add_another') {
	          $('#auto-payment-item-' + currentId).removeClass('hide');
	          $('#auto-payment-form-item-' + currentId).html('');
	        }
	        if (formType === 'edit' && currentId !== cardId) {
	          $('#auto-payment-item-' + currentId).removeClass('hide');
	          $('#auto-payment-form-item-' + currentId).html('');
	        }
	        if ($value.attr('data-type') == 'display') {
	          if (currentId == cardId) {
	            $value.hide();
	          } else {
	            $value.show();
	          }
	        } else if ($value.attr('data-type') == 'form') {
	          if (currentId == cardId) {
	            formHtmlBlock = '#' + $value.attr('id');
	          } else {
	            $value.empty();
	          }
	        }
	      });
	
	      var htmlForm = COSTCO.util.tmpl(template, data);
	      $(formHtmlBlock).html(htmlForm);
	      $(formHtmlBlock).show();
	
	      if (this.cybersourceEnabled) {
	        this.setInputFieldsEvents();
	      } else {
	        TokenGateway.reloadOnInitialize = true;
	        TokenGateway.refreshGateway();
	      }
	      this.maskInput();
	    },
	    setInputFieldsEvents: function setInputFieldsEvents() {
	      $("#card_number").keypress(function () {
	        TokenGateway.resetCardNumber(this);
	      }).keyup(function (event) {
	        if (event.keyCode === 8 || event.keyCode === 46) {
	          TokenGateway.resetCardNumber(this);
	        }
	      });
	      $("#card_number").click(function () {
	        TokenGateway.resetCardNumber(this);
	      });
	    },
	    upgradeBusinessOnclickEvent: function upgradeBusinessOnclickEvent() {
	      // Set some state to signify the user wants to upgrade. This will tell
	      // the application to use the renewAndUpgrade price returned from CRM
	      // after any CRUD operation.
	      this.isUpgrading = true;
	      // Show the user a notification about how they need to upgrade in addition
	      // to renewing.
	      util.notification.displayNotification(util.notification.type.WARNING, [$('#businessPrimaryExpiryInfoText').text() + ' ' + $('#businessForcedRenewalUpgradeText').text()]);
	      // Update the total price using the "renewAndUpgradeAmount".
	      helper.updateTotalPrice(this.membershipData, true);
	      // Show the business executive specific details
	      $('#membership-tier-price .affiliate-primary').addClass('hide');
	      $('#membership-tier-price .affiliate-primary.upgrade').removeClass('hide');
	      // Switch the add to cart link to business executive
	      $('#renew-button').attr('onclick', $('[data-renew-upgrade]').data('renew-upgrade'));
	    },
	
	    upgradeGoldStarOnclickEvent: function upgradeGoldStarOnclickEvent() {
	      // If you're renew eligible then you are sold a upgraded renewal instead of an upgrade to the current account
	      if (membershipData.caller.renewEligible) {
	        addUpgradeMembershipToCart('GoldStarExecutive', false);
	      } else {
	        addUpgradeMembershipToCart('GoldStarUpgrade', true);
	      }
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      digitalDataEvents.push({ nav: "Account | Membership | Upgrade Membership" });
	    },
	    /**
	     * Reverts the radio selection on Quick Renew Post Lockdown page
	     * @return void
	     */
	    revertRadioSelection: function revertRadioSelection(isUpgrade) {
	      $('#renew-membership-block, #upgrade-membership-block').toggleClass('radio-selected-background');
	      if (isUpgrade) {
	        $('#radio-renew-membership').prop('checked', true);
	      } else {
	        $('#radio-upgrade-membership').prop('checked', true);
	      }
	    }
	
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.RenewMembership = RenewMembership;
	  return RenewMembership;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var CreditCard = {
			initComplete: false,
			init: function init(state) {
				if (!COSTCO.CreditCard.initComplete) {
					COSTCO.CreditCard.initComplete = true;
					COSTCO.CreditCard.validationRules();
					COSTCO.CreditCard.forms.creditCardForm().validate({
						rules: {
							account: { required: true, isAmex: true, customcc: true, costcoCC: true },
							cc_cvc_validator: { required: true, cvv: true },
							cc_nameoncard: { required: true, checkSpecialchar: true },
							cc_expiry_date: { required: true, checkExpiryDate: true }
						},
						messages: {
							account: { required: messages.ERR_CCNUM_REQ, isAmex: messages._ERR_INVALID_AMEX_SELECTEDCARDTYPE, customcc: messages.ERR_INVALID_CREDITCARD_SHORT, costcoCC: messages.COSTCO_CC_DISABLED },
							cc_cvc_validator: { required: messages.ERR_CHECKOUT_PAYMENT_EMPTY_CARDNUMBE_PIN, cvv: messages.ERR_INVALID_CVV },
							cc_nameoncard: { required: messages.ERR_NAME_REQ, checkSpecialchar: messages.ERR_INVALID_CC_NAME },
							cc_expiry_date: { required: messages.ERR_EXPIRYDATE_REQ, checkExpiryDate: messages.ERR_INVALID_DATE }
						},
						errorPlacement: function errorPlacement(error, element) {
							if (element.attr('id') === 'account_validator') {
								$('#account').addClass('error-credit-card');
								$('#account_validator_err_msg').html(error.html());
								$('#account_validator_err_msg').removeClass('hide');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									if (error.html() != "" & error.html() != null) {
										$('iframe').filter('.gw-proxy-number').addClass('error-credit-card');
										$('#isAutoRenew').prop("checked", false);
									} else {
										$('iframe').filter('.gw-proxy-number').removeClass('error-credit-card');
									}
								}
								$('iframe').filter('.gw-proxy-number').focus();
							} else if (element.attr('id') === 'cc_cvc_validator') {
								COSTCO.CreditCard.isCybersourceEnabled() ? $('#cc_cvc').addClass('error') : $('#cc_cvc').addClass('error-credit-card');
								$('#cc_cvc_err_msg').html(error.html());
								$('#cc_cvc_err_msg').removeClass('hide');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									if (error.html() != "" & error.html() != null) {
										$('iframe').filter('.gw-proxy-securityCode').addClass('error-credit-card');
									} else {
										$('iframe').filter('.gw-proxy-securityCode').removeClass('error-credit-card');
									}
								}
								if (typeof TokenGateway !== "undefined" && TokenGateway.focusField != "cardNumber") {
									$('iframe').filter('.gw-proxy-securityCode').focus();
								}
							} else {
								error.insertAfter(element);
							}
						},
						success: function success(label, element) {
							var $element = $(element);
							if ($element.attr('id') === 'account_validator') {
								label.parent().removeClass('error');
								$('#account').removeClass('error-credit-card');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									$('iframe').filter('.gw-proxy-number').removeClass('error-credit-card');
								}
								label.html('');
							} else if ($element.attr('id') === 'cc_cvc_validator') {
								label.parent().removeClass('error');
								$('#cc_cvc').removeClass('error-credit-card');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									$('iframe').filter('.gw-proxy-securityCode').removeClass('error-credit-card');
								}
								label.html('');
							} else {
								label.parent().removeClass('error');
								label.remove();
							}
						}
					});
	
					$('#account').unbind('input').on('input', COSTCO.CreditCard.accountNumberChangeEvent);
	
					var cardType = COSTCO.CreditCard.forms.creditCardForm().find('input[name=payMethodId]').val();
	
					if (state == 'payment') {
						// do something if needed
					}
	
					$(".a11y-tooltip").popover();
	
					// Only need to run this onload
					var expiryDate = $('#cc_expiry_date').val();
					if (expiryDate != null && expiryDate.trim().length == 6) {
						expiryDate = '0' + expiryDate;
						$('#cc_expiry_date').val(expiryDate);
					}
	
					COSTCO.CreditCard.maskInput();
					if ($('#isBDAppVar').val() == 'BD') {
						if ($('#ach-block-form').length > 0) {
							$('#ach-block-form').validate();
						}
	
						if ($('#ar-block-form').length > 0) {
							$('#ar-block-form').validate();
						}
	
						if ($('#ordPayInsVal').length > 0) {
							var paymentType = $('#ordPayInsVal').val();
							var submitedPaymentType = $('#submitedPayMethodId').val();
							if (submitedPaymentType.length > 0) {
								paymentType = paymentType != submitedPaymentType ? submitedPaymentType : paymentType;
							}
							if (paymentType == 'Check') {
								if (!COSTCO.util.isExternalCarrierShipmode()) {
									COSTCO.wallet.showCheckOnDeliverySection();
								}
							} else if (paymentType == 'ACH') {
	
								if ($('#isBDAppVar').val() == 'BD' && COSTCO.util.isNdEnabled()) {
	
									COSTCO.wallet.showACHSection();
	
									if ($('input[name=payMethodId]').val() == 'ACH' && !COSTCO.CreditCard.isPaymentEditAreaVisible()) {
										$('#radio-ach').prop('checked', true);
										$('#save_as_default2').prop('checked', true);
									};
								} else {
									if (!COSTCO.util.isExternalCarrierShipmode()) {
										COSTCO.wallet.showACHSection();
	
										if ($('input[name=payMethodId]').val() == 'ACH' && !COSTCO.CreditCard.isPaymentEditAreaVisible()) {
											$('#radio-ach').prop('checked', true);
											$('#save_as_default2').prop('checked', true);
										};
									}
								}
							} else if (paymentType == 'LineOfCredit') {
								if (!COSTCO.util.isExternalCarrierShipmode()) {
									COSTCO.wallet.showAcctReceivableSection();
								}
							} else {
								COSTCO.wallet.showCCSection();
							}
						}
					}
				}
			},
			forms: {
				creditCardForm: function creditCardForm() {
					return $('#CheckoutPaymentForm');
				},
				achForm: function achForm() {
					return $('#ach-block-form');
				},
				arForm: function arForm() {
					return $('#ar-block-form');
				}
			},
			cardTypes: {
				VISA: 'VISA',
				AMEX: 'AMEX',
				MASTER_CARD: 'Master Card',
				DISCOVER: 'Discover',
				JCB: 'JCB',
				DINERS_CLUB: 'Discover Diners',
				CUP: 'Union Pay',
				COSTCO_CREDIT_CARD: 'Costco Credit Card',
				DEFAULT_PAYMENT: 'DefaultPayment'
			},
	
			accountNumberChangeEvent: function accountNumberChangeEvent() {
	
				var ccNumber = $(this).val();
			},
	
			updatePaymentType: function updatePaymentType(cardNumber, $cardTypeInput) {
	
				var cardType = COSTCO.CreditCard.getCardType(cardNumber);
				if (cardType != '?') {
					$cardTypeInput.val(cardType);
				}
			},
	
			isVisaCard: function isVisaCard(cardNumber) {
				return (/^(4)/.test(cardNumber)
				);
			},
			isMasterCard: function isMasterCard(cardNumber) {
				return (/^(2[2-7]|5[1-5])/.test(cardNumber)
				);
			},
			isCostcoCard: function isCostcoCard(cardNumber) {
				return (/^(7111|7003)/.test(cardNumber)
				);
			},
			isDiscoverCard: function isDiscoverCard(cardNumber) {
				return (/^(6011|65|6499|6555|6556)/.test(cardNumber)
				);
			},
			getCardType: function getCardType(a) {
	
				a = a.replace(/\s+/g, "");
	
				if (/^(34|37)/.test(a) && 15 == a.length) return COSTCO.CreditCard.cardTypes.AMEX;
				if (/^(2[2-7]|5[1-5])/.test(a) && 16 == a.length) return COSTCO.CreditCard.cardTypes.MASTER_CARD;
				if (/^(30[0-5]|3095|36[0-9]|3[8-9])/.test(a) && (14 == a.length || 16 == a.length)) return COSTCO.CreditCard.cardTypes.DINERS_CLUB;
				if (/^(3528|35[3-8]|333[7-9]|334)/.test(a) && (15 == a.length || 16 == a.length)) return COSTCO.CreditCard.cardTypes.JCB;
				if (!/^(4)/.test(a) || 13 != a.length && 16 != a.length) {
					if (/^(6011|65|6499|6555|6556|62)/.test(a) && 16 == a.length) return COSTCO.CreditCard.cardTypes.DISCOVER;
					if (/^(7111|7003)/.test(a) && 16 == a.length) return COSTCO.CreditCard.cardTypes.COSTCO_CREDIT_CARD;
					if (/^(\*)/.test(a)) return COSTCO.CreditCard.cardTypes.DEFAULT_PAYMENT;
				} else return COSTCO.CreditCard.cardTypes.VISA;
				return "?";
			},
			validationRules: function validationRules() {
	
				$.validator.setDefaults({ ignore: ".ignore,.ignoreHide" });
				$.validator.addMethod('costcoCC', function (value, element) {
					value = value.replace(/\s+/g, '');
					//check to see if value is costco cc and is disabled, otherwise return true and do normal customcc check.
					if (COSTCO.CreditCard.isCostcoCard(value)) {
						var costcoCCDisabled = $('#costcoCCDisabled').val() == 'true';
						return !costcoCCDisabled;
					}
					return true;
				});
				$.validator.addMethod("isAmex", function (value, element) {
					value = value.replace(/\s+/g, "");
					var cardTypeTmp = COSTCO.CreditCard.getCardType(value);
					if (COSTCO.CreditCard.cardTypes.AMEX == cardTypeTmp) {
						//Amex not allowed - trigger specific error message
						return false;
					} else {
						return true;
					}
				});
	
				/* Replicated $.validator.methods.creditcard() from jquery-1.10.2 for jquery-3.6.3
	   * since this is no longer defined in 3.6.3
	   * ALM 47238
	      	*/
				$.validator.addMethod('creditCard', function (value, element) {
					if (this.optional(element)) {
						return "dependency-mismatch";
					}
					if (/[^0-9 \-]+/.test(value)) {
						return false;
					}
					var n = 0,
					    i = 0,
					    r = false,
					    s,
					    o;
					value = value.replace(/\D/g, "");
					if (value.length < 13 || value.length > 19) {
						return false;
					}
					for (s = value.length - 1; s >= 0; s--) {
						o = value.charAt(s);
						i = parseInt(o, 10);
						if (r) {
							if ((i *= 2) > 9) {
								i -= 9;
							}
						}
						n += i;
						r = !r;
					}
					return n % 10 === 0;
				});
				$.validator.addMethod("customcc", function (value, element) {
	
					value = value.replace(/\s+/g, "");
					var cardTypeTmp = COSTCO.CreditCard.getCardType(value);
					if (!costcoStoreFeatures.DISCOVER_DINERSCLUB_JCB_CUP_ENABLED) {
						if (COSTCO.util.getLocale() == 'en-US' && $('#isBDAppVar').val() == 'BC' && (cardTypeTmp == COSTCO.CreditCard.cardTypes.DISCOVER || cardTypeTmp == COSTCO.CreditCard.cardTypes.DINERS_CLUB || cardTypeTmp == COSTCO.CreditCard.cardTypes.JCB || cardTypeTmp == COSTCO.CreditCard.cardTypes.CUP)) {
							return false;
						}
					}
					if ((COSTCO.util.getLocale() == 'en-CA' || COSTCO.util.getLocale() == 'fr-CA' || $('#isBDAppVar').val() == 'BD') && (cardTypeTmp == COSTCO.CreditCard.cardTypes.DISCOVER || cardTypeTmp == COSTCO.CreditCard.cardTypes.DINERS_CLUB || cardTypeTmp == COSTCO.CreditCard.cardTypes.JCB)) {
						return false;
					}
					if (value.indexOf("*") > 0 && value.length >= 14 && value.length <= 16) {
						return true;
					}
					return this.optional(element) || /^7\d{15}$/.test(value) || /^\*{11}\s?\d{4}$/.test(value) || /^\*{12}\s?\d{4}$/.test(value) || $.validator.methods.creditCard.call($.data(element.form, 'validator'), value, element);
				});
	
				$.validator.addMethod("ccTypeCheck", function (value, element) {
	
					var cc = (value + '').replace(/\s/g, ''); //remove space
					// remove spaces 
					var cardType;
					if ($('input[name=payMethodId]').val() != null) {
						cardType = $('input[name=payMethodId]').val().split(' ').join('');
					}
	
					var returnVal = false;
	
					if (this.optional(element)) {
						return this.optional(element);
					}
	
					var cardTypeTmp = COSTCO.CreditCard.getCardType(cc);
					if (cardType == cardTypeTmp || '?' != cardTypeTmp) {
						returnVal = true;
					} else if (cc.indexOf('*') != -1) {
						//This is just a safety net to catch a * in the payment type to indicate there is 
						//a default payment.  If it is falsely entered the payment gateway will catch and throw an error.
						returnVal = true;
					} else {
						returnVal = false;
					}
	
					return returnVal;
				});
	
				$.validator.addMethod("cvv", function (value, element) {
					return value.trim().length == 3;
				});
	
				$.validator.addMethod("checkSpecialchar", function (value, element) {
					// CC name shouldn't have any non-alphanumeric characters and needs at least 1 letter				
					return this.optional(element) || !COSTCO.util.CC_NAME_FIELD_REGEX.test(value) && COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
				});
	
				$.validator.addMethod("checkExpiryDate", function (value, element) {
					var success = this.optional(element) || /^(0[1-9]|1[012])\/([123]\d)$/.test(value);
					if (!success) {
						COSTCO.util.announceSRMessage(messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE);
					}
					return success;
				});
	
				$.validator.addMethod("checkIsDateInPast", function (value, element) {
					var enteredMonth = parseInt(value.split('/')[0]);
					var enteredYear = parseInt(value.split('/')[1]);
					var now = new Date();
					var currentMonth = parseInt((now.getMonth() + 1).toString());
					var currentYear = parseInt(now.getFullYear().toString().substr(-2));
					if (enteredYear < currentYear || enteredYear == currentYear && enteredMonth < currentMonth) {
						return false;
					} else {
						return true;
					}
				});
			},
			validate: {
				creditCardForm: function creditCardForm(isCvvCodeValidationIgnored) {
	
					if ($('#outstandingPrincipal').length > 0 && $('#outstandingPrincipal').val() == 0 && !COSTCO.OrderSummary.isMembershipPurchaseOptinSelected()) {
						return true;
					}
	
					var form = COSTCO.CreditCard.forms.creditCardForm();
					if ($('input[name=payMethodId]').val() == 'Costco Credit Card') {
						$('#cc_cvc_validator').val("123");
						$('#cc_expiry_date').addClass('ignore').val("");
					} else {
						$('#cc_expiry_date').removeClass('ignore');
					}
	
					//since cvv validation is only required if user clicks on change link,
					//we need to add ignore class to skip validation of blank cvv field if
					//the user does not click change.
					if ($('#cc_cvv_div').is(':hidden') || isCvvCodeValidationIgnored) {
						$('#cc_cvc_validator').addClass('ignore');
					} else {
						$('#cc_cvc_validator').removeClass('ignore');
					}
	
					if (form.length != 0) {
						return form.valid();
					}
				}
			},
			submit: {
				creditCardForm: function creditCardForm() {
					$('.order-ajax').addClass('ajax-busy');
					var form = COSTCO.CreditCard.forms.creditCardForm();
					var expDate = $(form).find('input[name=cc_expiry_date]').val().split('/');
					$('#creditCardTokenSessionId').val(modularTokenSessionId);
	
					$(form).find('input[name=expire_month]').val(expDate[0]);
					if (typeof expDate[1] != 'undefined' && expDate[1].length == 2) {
	
						$(form).find('input[name=expire_year]').val('20' + expDate[1]);
					}
					if ($('#checkoutPage').length > 0 && $('#checkoutPage').val() == 'review') {
						if ($('[name=walletCheckout]').attr('value') == 'false') {
							$(form).find('input[name=ccLastFour]').val($(form).find('input[name=account]').val().slice(-4));
						}
					}
					if (costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED !== 'undefined' && costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED && ($('input[name="isQuickPurchase"]') !== undefined && $('input[name="isQuickPurchase"]').val() === 'true' || $('input[name="isQuickPurchaseFlow"]') !== undefined && $('input[name="isQuickPurchaseFlow"]').val() === 'true')) {
	
						if ($("input[name='radio-auto-renew']:checked").val() !== undefined && $("input[name='radio-auto-renew']:checked").val() == 'optin') {
							digitalDataEvents.push({ ui: "Checkout Flow | Check | Enroll For Membership Auto Renewal" });
						} else {
							digitalDataEvents.push({ ui: "Checkout Flow | Check | Don't Enroll For Membership Auto Renewal" });
						}
					}
	
					// [0] skips jquery validation - validation must be handled in a different method
					form[0].submit();
				},
				achForm: function achForm() {
					$('.order-ajax').addClass('ajax-busy');
					var form = COSTCO.CreditCard.forms.achForm();
					form[0].submit();
				},
				arForm: function arForm() {
					$('.order-ajax').addClass('ajax-busy');
					var form = COSTCO.CreditCard.forms.arForm();
					form[0].submit();
				}
			},
			/**
	   * Uses the Jquery Mask plugin to format input fields. Use cleanVal() instead of val() to get unformatted value
	   */
			maskInput: function maskInput() {
				$('#cc_expiry_date').mask('00/00', {
					placeholder: 'MM/YY'
				});
				$('#account').mask('ZZZZ ZZZZ ZZZZ 0000', { selectOnFocus: true, translation: { 'Z': { pattern: '[\\*0-9]' } } });
				$('#cc_cvc').mask('0009');
			},
			/**
	   * Checks the state of the credit card radio button selection
	   * @return 1 if user has selected credit card radio button, otherwise returns 0
	   */
			isCreditCardOptionSelected: function isCreditCardOptionSelected() {
				return $('input[id=radio-credit-card]:checked').length || COSTCO.Checkout.displayAllPayments() && $('input[id=radio-credit-card-review]:checked').length;
			},
			showErrorBox: function showErrorBox() {
				$('#credit-card-block').addClass('error-box');
				if ($('#isBDAppVar').val() == 'BD') {
					if ($("#check-del-block") && $("#check-del-block").length > 0) {
						$('#check-del-block').addClass('error-box');
					}
					if ($("#ach-block") && $("#ach-block").length > 0) {
						$('#ach-block').addClass('error-box');
					}
					if ($("#acc-receiv-block") && $("#acc-receiv-block").length > 0) {
						$('#acc-receiv-block').addClass('error-box');
					}
				}
			},
			hideErrorBox: function hideErrorBox() {
				$('#credit-card-block').removeClass('error-box');
				if ($('#isBDAppVar').val() == 'BD') {
					if ($("#check-del-block") && $("#check-del-block").length > 0) {
						$('#check-del-block').removeClass('error-box');
					}
					if ($("#ach-block") && $("#ach-block").length > 0) {
						$('#ach-block').removeClass('error-box');
					}
					if ($("#acc-receiv-block") && $("#acc-receiv-block").length > 0) {
						$('#acc-receiv-block').removeClass('error-box');
					}
				}
			},
			isSelected: function isSelected() {
				var selected = $('#credit-card-block input[name=\'payment-radio\']:checked').val();
				return selected;
			},
			isUsed: function isUsed() {
				return $('#credit-card-info-container').length > 0 && !$('#credit-card-info-container').hasClass('hide');
			},
			isApplied: function isApplied() {
				return $('input[id=ordPayInsVal]').length > 0 && $('input[id=ordPayInsVal]').val() == 'CreditCard';
			},
			isPaymentEditAreaVisible: function isPaymentEditAreaVisible() {
				var paymentEditAreaVisible = $('#credit-card-block').length > 0 && $('#credit-card-block').attr('class') != 'hide';
				return paymentEditAreaVisible;
			},
			isCCEditAreaVisible: function isCCEditAreaVisible() {
				var creditCardEditAreaVisible = $('#credit-card-block').length > 0 && !$('#credit-card-block').hasClass('hide') && this.isCreditCardOptionSelected() > 0;
				return creditCardEditAreaVisible;
			},
			isCCEditAreaHidden: function isCCEditAreaHidden() {
				var creditCardEditAreaHidden = $('#credit-card-block').length > 0 && $('#credit-card-block').hasClass('hide') && this.isCreditCardOptionSelected() > 0;
				return creditCardEditAreaHidden;
			},
			isCybersourceEnabled: function isCybersourceEnabled() {
				return $("#cybersourceEnabled").val() === 'true';
			}
	
		};
	
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.CreditCard = CreditCard;
	
		return CreditCard;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title application-form.js: Feature level module
	 * @description Membership application form functionality
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (helper) {
	  var AffiliateForm = {
	    init: function init() {
	      // Moving this to application.js because we need to grab
	      // configProduct first (which is async) and then display
	      // this.reflectAffiliates();
	    },
	    /**
	     * This is business membership form specific. If the user has 6
	     * added affiliates, we don't allow any more.
	     * @param {Object} data - OPTIONAL Passed by thenable. Used to chain
	     * @return {Object} OPTIONAL - The data passed as an argument.
	     *                           Meant for chaining
	     */
	    checkAffiliateNumber: function checkAffiliateNumber(data) {
	      var affiliates = helper.getAffiliates();
	
	      if (COSTCO.MembershipHelper.isQuickMembership) {
	        if (affiliates.length == 0) {
	          $('#add-a-person').removeClass('hide');
	          $('#add-another-person').addClass('hide');
	        } else if (affiliates.length > 0 && affiliates.length < 6) {
	          $('#add-a-person').addClass('hide');
	          $('#add-another-person').removeClass('hide');
	        } else {
	          $('#add-a-person').addClass('hide');
	          $('#add-another-person').addClass('hide');
	        }
	      } else {
	        affiliates.length >= 6 ? $('#add-person-button').addClass('hide') : $('#add-person-button').removeClass('hide');
	      }
	
	      return data;
	    },
	    /**
	     * Uses the stored affiliate form (set by onclose events in editPerson
	     * /addPerson) to populate the #affiliate-form (modal). This is used to
	     * populate the affiliate form when the user escapes from a another modal
	     * and comes back to the affiliate modal e.g. Address Verification.
	     * @return {void}
	     */
	    populateUsingStoredForm: function populateUsingStoredForm() {
	      // When the modal is 'shown' or 'open' we
	      // try to populate the form with what the user last entered.
	      var affForm = AffiliateForm;
	      var storedForm = affForm.storedAffiliateForm;
	      helper.formWizBangs(affForm.getForm());
	      if (storedForm) {
	        COSTCO.MembershipHelper.populateByName(affForm.getForm(), storedForm.serializeArray());
	        if (storedForm.find('#affiliate-household').prop('checked')) {
	          affForm.getForm().find('#affiliate-household').prop('checked', true);
	          affForm.getForm().find('#affiliate-household').val(true);
	          affForm.householdToggle();
	        }
	      }
	      affForm.storedAffiliateForm = undefined;
	    },
	    /**
	     * Validation rules for the affiliate form
	     * @return {Boolean} Is the affiliate form valid?
	     */
	    validate: function validate() {
	      var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	      helper.goldstar.rules.dobmonth.required = dayIsOptional;
	      helper.goldstar.rules.dobyear.required = dayIsOptional;
	      var rules = helper.goldstar.rules;
	      var messages = helper.goldstar.messages();
	      var form = this.getForm().length > 0 ? this.getForm() : this.storedAffiliateForm;
	      data = COSTCO.util.objectifyArray(form.serializeArray());
	      data.householdCheckbox = data.householdCheckbox ? true : false;
	      if (data.householdCheckbox) {
	        helper.addHouseholdRules(rules, true, messages);
	      }
	      rules.email.required = false;
	      rules.emailConfirm.required = false;
	      rules.emailConfirm.equalTo = '#affiliate-email';
	      // Override validator messages
	      $.extend($.validator.messages, messages);
	      // Override $.validate.methods to accommodate affiliate context.
	      helper.addValidationMethods(this.getForm());
	      this.getForm().validate({
	        invalidHandler: COSTCO.util.invalid_handler,
	        rules: rules,
	        messages: messages
	      });
	      return this.getForm().valid();
	    },
	    /**
	     * Gets the appropriate request data for whatever CRUD operation we're
	     * performing.
	     * @param  {Object} options The object that distinguishes what CRUD op we're
	     *                          doing. Everything except 'add' action requires
	     *                          an affiliate object be attached as a property.
	     * @return {Object}         The request data to be passed to whichever cmd.
	     */
	    getRequestData: function getRequestData(options) {
	      var data = {};
	      if (options.action == 'add' || options.action == 'update') {
	        // This block takes addresses from the verification service and populates
	        // the form with that information so we can just serialize this.
	        var form = this.getForm().length > 0 ? this.getForm() : this.storedAffiliateForm;
	        addresses = Array.isArray(options.addresses) // Test if we have valid addresses
	        ? options.addresses // Using the addresses passed to "submit"
	        : helper.buildAddressArray(form, {
	          primary: helper.affiliateAddressSelectors
	        }); // using original addresse from user input
	        helper.populateAddressData(form, addresses, true);
	        // In both cases we have a form that needs to be serialized and sent.
	        data = COSTCO.util.objectifyArray(form.serializeArray());
	        data.householdCheckbox = data.householdCheckbox ? true : false;
	        var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	        if (dayIsOptional) {
	          //dobday is optional, if empty default it to "1"
	          if (!data.dobday) {
	            data.dobday = "1";
	          }
	          //householdDobDay is optional, if empty default it to "1"
	          if (!data.householdDobDay) {
	            data.householdDobDay = "1";
	          }
	        }
	        // If the flow is from renew or business details adjust the url
	        // approproiately. Uses /MemberAffiliateAddCmd.
	        if (options.isRenew || options.isBusinessDetails || options.isOutsideRenewal /* placeholder for isDetails */) {
	            options.addHousehold
	            // Adding a household to an affiliate
	            ? data.url = COSTCO.util.makeUrl('/MemberHouseholdAddCmd', {
	              'primaryNumber': options.affiliate.cardNumber.value,
	              'type': 'affiliate',
	              'authToken': COSTCO.Checkout.getAuthToken()
	            })
	            // Adding an affiliate to a business membership
	            : data.url = '/MemberAffiliateAddCmd';
	          } else {
	          // Membership Application flow
	          data.url = this.getUrl('/MemberApplicationAffiliateAddCmd');
	        }
	        data.isRenew = options.isRenew;
	        data.isBusinessDetails = options.isBusinessDetails;
	        data.isOutsideRenewal = options.isOutsideRenewal;
	        data.addHousehold = options.addHousehold;
	        this.storedAffiliateForm = undefined;
	      } else if (options.action == 'remove-household') {
	        if (options.isRenew || options.isBusinessDetails || options.isOutsideRenewal /* placeholder for isDetails */) {
	            data.url = COSTCO.util.makeUrl('/MemberHouseholdRemoveCmd', {
	              'primaryNumber': options.affiliate.membershipNumber,
	              'householdNumber': options.affiliate.houseHold.membershipNumber,
	              'type': 'affiliate',
	              'authToken': COSTCO.Checkout.getAuthToken()
	            });
	            data.isRenew = options.isRenew;
	            data.isBusinessDetails = options.isBusinessDetails;
	            data.isOutsideRenewal = options.isOutsideRenewal;
	            data.excludeData = options.excludeData;
	          } else {
	          // Membership Application flow
	          // We're removing a household from an affiliate.
	          var affiliate = options.affiliate;
	          var arr = helper.getSerializedAffiliateData(affiliate);
	          data = COSTCO.util.objectifyArray(arr);
	          data.url = this.getUrl('/MemberApplicationAffiliateAddCmd');
	          data.householdCheckbox = false;
	          // Backend is expecting action: update for this operation.
	          options.action = 'update';
	        }
	      } else if (options.action == 'remove-affiliate') {
	        // Removing a affiliate for the renew / business details flow.
	        data.url = COSTCO.util.makeUrl('/MemberAffiliateRemoveCmd', {
	          MembershipRenewUpgrade_removeAffiliate: options.affiliate.membershipNumber,
	          MembershipRenewUpgrade_isQuickMembershipCheckout: options.isQuickMembershipCheckout
	        });
	        data.isRenew = options.isRenew;
	        data.isBusinessDetails = options.isBusinessDetails;
	        data.isOutsideRenewal = options.isOutsideRenewal;
	        data.excludeData = options.excludeData;
	      } else {
	        // Removing an affiliate for the membership application flows
	        data.url = this.getUrl('/MemberApplicationAffiliateUpdateCmd');
	        $.extend(data, options.affiliate);
	      }
	      // In the case where we're modifying affiliates, send the corresponding
	      // membership numbers as part of the formdata.
	      if (options.affiliate) {
	        data.affiliateMembershipNumber = options.affiliate.affiliateMembershipNumber;
	        if (options.affiliate.houseHold) {
	          data.affiliateHouseholdMembershipNumber = options.affiliate.houseHold.membershipNumber;
	        }
	      }
	      data.action = options.action;
	      if (location.hostname == 'wcs.costco.com') {
	        // Show me what you got.
	        console.log(JSON.stringify(data, null, 2));
	      }
	      return data;
	    },
	    /**
	     * Returns a URL corresponding to the command we want to call. Could be
	     * /MemberApplicationAffiliate[Add|Update]Cmd. Requests to these commands
	     * require the orderItemsId (xorderitems.orderItemsId) and organizationId
	     * (business identifier) to be passed as query strings.
	     * @param  {String} command The command we want to make a request to.
	     * @return {String}         The url with appropriate querystrings.
	     */
	    getUrl: function getUrl(command) {
	      var configProduct = helper.getConfigProduct();
	      var urlParams = {
	        orderItemsId: configProduct.applicationTrackingCookie,
	        organizationId: configProduct.organizationId
	      };
	      // ALM 52783: If the form is on Membership Application or Quick Membership Checkout page, send the information that it's
	      // membership purchase flow (needed to correctly calculate membership total price after adding an affiliate)
	      if ($('div#membership-application').data('page') == COSTCO.QuickMembershipCheckout.constants.QUICK_MEMBERSHIP || $('div#quick-membership-checkout').data('page') == COSTCO.QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE) {
	        urlParams.fromPage = COSTCO.QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE;
	      }
	      return COSTCO.util.makeUrl(command, urlParams);
	    },
	    /**
	     * This is the primary ajax wrapper for all crud operations related to
	     * affiliates and their attached households.
	     * @param  {Object} requestData The object containing all relevant request
	     *                              data. Use this.getRequestData to get the
	     *                              correct data to be passed.
	     * @return {jQuery.Deferred}    Used to chain thenables.
	     */
	    submit: function submit(requestData) {
	      $('.order-ajax').addClass('ajax-busy');
	      var data = void 0;
	      if ((requestData.isRenew || requestData.isBusinessDetails || requestData.isOutsideRenewal) && requestData.addHousehold /* isDetails placeholder */) {
	          data = helper.transformAffiliateHouseholdInputNames(requestData);
	        } else if (requestData.isRenew || requestData.isBusinessDetails || requestData.isOutsideRenewal /* isDetails placeholder */) {
	          data = helper.transformAffiliateInputNames(requestData);
	        } else {
	        data = {
	          formdata: encodeURIComponent(JSON.stringify(requestData))
	        };
	      }
	      return COSTCO.util.ajax({
	        type: 'POST',
	        url: requestData.url, // this.getUrl(),
	        dataType: 'json',
	        global: false,
	        // If we don't need POST data, excludeData is set to true
	        // and we just pass an empty object. The request probably has
	        // the data it needs in the querystring.
	        data: requestData.excludeData ? {} : data
	      });
	    },
	    /**
	     * Returns a jQuery form object representing the Affiliate form (modal)
	     * @return {jQuery} The jQuery object represetning the form.
	     */
	    getForm: function getForm() {
	      // TRAIL - TODO: Check if better name for this form is required
	      return $('#affiliate-form');
	    },
	    /**
	     * Inline event handler for the checkbox in the add person modal to
	     * toggle hiding and showing the household form.
	     * @return {void}
	     */
	    householdToggle: function householdToggle() {
	      $('#affiliate-household-container').toggleClass('hide');
	    },
	    /**
	     * This function opens the "Add Person to Membership" modal.
	     * @param  {Object} data This is not always passed. It is passed after
	     *                       the POST to /MemberApplicationAddCmd returns. In
	     *                       the case where we're on RenewMembershipView, we
	     *                       associate the property isRenew as the contract
	     *                       with the backend is slightly different.
	     * @return {void}
	     */
	    openAddPersonModal: function openAddPersonModal(data) {
	      $('.permanent-ajax-busy').removeClass('ajax-busy');
	      if (data && data.error) {
	        // Case where we first need to POST to /MemberApplicationAddCmd
	        // before we invoke the add person modal and it returns an error.
	        // We don't want to show the modal in this case, just display the error.
	        return;
	      }
	      // 5.1 Use appropriate template for modal
	      COSTCO.dialog.modalStack({
	        title: messages.MEMBERAPPLICATION_AFFILIATE__modalAddAffiliateTitle,
	        body: COSTCO.util.tmpl('tmpl_affiliate', {
	          affiliateHousehold: COSTCO.util.tmpl('tmpl_household_info_affiliate', {})
	        }),
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.MEMBERSHIP_AddPerson,
	        primary_event: function primary_event() {
	          // user selected "Add Person"
	          // 5.3 Validate the form
	          if (AffiliateForm.validate()) {
	            var options = {
	              action: 'add',
	              isRenew: data && data.isRenew || false,
	              isBusinessDetails: data && data.isBusinessDetails || false,
	              isOutsideRenewal: data && data.isOutsideRenewal || false
	            };
	            helper
	            // Execute address verification on the affiliate address.
	            .verifyAddresses({
	              form: '#affiliate-form',
	              primary: helper.affiliateAddressSelectors
	            })
	            // Invoke the address verification modal
	            .then(function (verifyResponse) {
	              return helper.invokeMultiAVS(verifyResponse, AffiliateForm.crudSequence.bind(options));
	            })
	            // If the service fails, still submit the form.
	            .fail(AffiliateForm.crudSequence.bind(options));
	          }
	        },
	        onclose: function onclose() {
	          // We'll temporary store this form so we can serialize it after its
	          // been closed and we're looking at the address verification modal.
	          // We can also use this to populate the form.
	          AffiliateForm.storedAffiliateForm = AffiliateForm.getForm();
	        },
	        onshown: function onshown() {
	          AffiliateForm.populateUsingStoredForm();
	        }
	      });
	      // A new call to open this modal shouldn't prepopulate with the result
	      // of a previously stored form.
	      this.storedAffiliateForm = undefined;
	    },
	    /**
	     * This function handles removing an affiliate or an affiliate's attached
	     * household. application.js has decorator functions that are inline event
	     * handlers that end up calling this.
	     * @param  {Object} options Options object that contains an affiliate object
	     *                          property and a switch for removing either the
	     *                          affiliate or the affiliate's household.
	     * @return {void}
	     */
	    removePerson: function removePerson(options) {
	      var _this = this;
	
	      var action = options.action;
	      options.isRenew /* isBusinessDetails */ = options && options.isRenew || false;
	      options.isBusinessDetails /* isBusinessDetails */ = options && options.isBusinessDetails || false;
	      options.isOutsideRenewal /* isBusinessDetails */ = options && options.isOutsideRenewal || false;
	      options.excludeData /* isBusinessDetails */ = options && options.excludeData || false;
	      COSTCO.dialog.showModal({
	        title: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
	        body: COSTCO.util.tmpl(options.isOutsideRenewal ? 'tmpl_remove_affiliate_outside_renewal' : 'tmpl_remove_affiliate', {
	          affiliate: action == 'remove-household'
	          // Here we send the household object to the template
	          // because we're removing the household.. just want to show
	          // the household name.
	          ? options.affiliate.houseHold : options.affiliate,
	          newCreated: options.affiliate ? options.affiliate.newCreated : false
	        }),
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
	        primary_event: function primary_event() {
	          // user selected "Remove Person"
	          _this.crudSequence.call(options);
	          COSTCO.dialog.close();
	        }
	      });
	    },
	    editPerson: function editPerson(options) {
	      var _this2 = this;
	
	      // See application.js.addPersonWithinHousehold for explanation here.
	      var title = options.addHousehold ? COSTCO.util.capitalize(messages.ADDHOUSEHOLD_TITLE) : options.editHousehold ? messages.EDITHOUSEHOLD_TITLE : messages.MEMBERSHIP_EditPerson;
	      COSTCO.dialog.modalStack({
	        title: title,
	        body: COSTCO.util.tmpl('tmpl_affiliate', {
	          affiliateHousehold: COSTCO.util.tmpl('tmpl_household_info_affiliate', {})
	        }),
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: options.addHousehold ? messages.MEMBERSHIP_AddPerson : messages.UPDATE,
	        primary_event: function primary_event() {
	          // user selected "Edit Person"
	          // 5.3 Validate the form
	          if (_this2.validate()) {
	            if (!options.editHousehold && !options.addHousehold) {
	              // This tells onshown to use the newly editted form if the user
	              // escapes and returns back to the affiliate form.
	              options.useStored = true;
	              helper
	              // Execute address verification on the affiliate address.
	              .verifyAddresses({
	                form: '#affiliate-form',
	                primary: helper.affiliateAddressSelectors
	              })
	              // Invoke the address verification modal
	              .then(function (verifyResponse) {
	                return helper.invokeMultiAVS(verifyResponse, AffiliateForm.crudSequence.bind(options));
	              })
	              // If the service fails, still submit the form.
	              .fail(AffiliateForm.crudSequence.bind(options));
	            } else {
	              // Household doesn't require verification.
	              _this2.crudSequence.call(options);
	              COSTCO.dialog.close();
	            }
	          }
	        },
	        onclose: function onclose() {
	          // We'll temporary store this form so we can serialize it after its
	          // been closed and we're looking at the address verification modal.
	          // We can also use this to populate the form.
	          AffiliateForm.storedAffiliateForm = AffiliateForm.getForm();
	        },
	        onshown: function onshown() {
	          if (options.useStored) {
	            // Here we use the stored affiliate form to repopulate the form
	            // as the user escaped from address verification.
	            affForm.populateUsingStoredForm();
	          }
	        }
	      });
	      var affForm = AffiliateForm;
	      // Populate date of birth selects, etc.
	      helper.formWizBangs(affForm.getForm());
	      // Populate the form with information about the affiliate
	      helper.populateElement(affForm.getForm(), options.affiliate);
	      // Clear the household values as some of these inputs share the same
	      // data-configproduct attribute. We'll populate them below if exist.
	      $('#affiliate-household-container input').val('');
	      $('#affiliate-household-container select').find('option:first').prop('selected', true);
	      // If the affiliate has a household attached, show and populate
	      if (options.affiliate.houseHold) {
	        affForm.getForm().find('#affiliate-household').prop('checked', true);
	        affForm.getForm().find('#affiliate-household').val(true);
	        helper.populateElement(affForm.getForm().find('#affiliate-household-container'), options.affiliate.houseHold);
	        affForm.householdToggle();
	      }
	      // This is the varition of the modal where we're actually just adding/editing
	      // a household. We want to hide the affiliate container and show just the
	      // household inputs.
	      if (options.addHousehold || options.editHousehold) {
	        $('.affiliate-container').addClass('hide');
	        $('#affiliate-household-container').addClass('only-household');
	        affForm.getForm().find('#affiliate-household').prop('checked', true);
	        affForm.getForm().find('#affiliate-household').val(true);
	      }
	      if (options.addHousehold) {
	        affForm.householdToggle();
	      }
	    },
	    /**
	     * This represents the sequence of actions for performing CRUD operations
	     * related to affiliates. This should include several (a)sync functions
	     * like address verification and data return handling functions.
	     * @param  {Object} addresses The addresses returned from address verification
	     * @return {void}
	     */
	    crudSequence: function crudSequence(addresses) {
	      $.extend(this, {
	        addresses: addresses
	      });
	      var requestData = AffiliateForm.getRequestData(this);
	      if (requestData.isRenew /* isDetails placeholder */) {
	          // In the case where we are in the renew or business details flow,
	          // we want to reflect the newly added affiliates and change some other state.
	          COSTCO.AffiliateForm.submit(requestData)
	          // If we have errors, display them.
	          .then(function (data) {
	            if ($('#quick-membership-checkout').length != 0) {
	              window.location.reload(true);
	            } else {
	              data.retainNotification = true;
	              return helper.handleErrors(data);
	            }
	          })
	          // After a crud operation to affiliates, reflect them using the
	          // JSON response from the server.
	          .then(helper.reflectAffiliatesAlternate)
	          // If we already have 6 newly added affiliates, we dont want to allow
	          // any more for this transaction.
	          .then(helper.canAddAffiliate)
	          // Update the total price. If the user selected the link,
	          // "upgrade to a business executive membership" (business membership
	          // flow), RenewMembership.isUpgrading was set true, show the
	          // renewAndUpgradeAmount
	          .then(function (data) {
	            var isUpgrading = COSTCO.RenewMembership.isUpgrading || false;
	            return helper.updateTotalPrice(data, isUpgrading);
	          })
	          // Switch the add person link if needed
	          .then(helper.addPersonLink)
	          // Kurt TODO: Does the add to cart link change?
	          // If the command fails, handle them
	          .fail(helper.handleErrors);
	        } else if (requestData.isBusinessDetails) {
	        COSTCO.AffiliateForm.submit(requestData)
	        // If we have errors, display them.
	        .then(function (data) {
	          if ($('#quick-membership-checkout').length != 0) {
	            window.location.reload(true);
	          } else {
	            data.retainNotification = true;
	            return helper.handleErrors(data);
	          }
	        }).then(function (data) {
	          var hasErrors = data && data.error && data.errorMessages.length > 0;
	          if (!hasErrors) {
	            return location.reload(true);
	          } else {
	            return;
	          }
	        }).fail(helper.handleErrors);
	      } else if (requestData.isOutsideRenewal) {
	        // In the case where we are in the business details flow,
	        // adding additional people outside renewal period.
	        COSTCO.AffiliateForm.submit(requestData)
	        // If we have errors, display them.
	        .then(function (data) {
	          if ($('#quick-membership-checkout').length != 0) {
	            window.location.reload(true);
	          } else {
	            data.retainNotification = true;
	            return helper.handleErrors(data);
	          }
	        })
	        // After a crud operation to affiliates, reflect them using the
	        // JSON response from the server.
	        .then(helper.reflectAffiliatesBussinessOutsideRenewal)
	        // If the command fails, handle them
	        .fail(helper.handleErrors);
	      } else {
	        // This case represents the membership application flow where we want
	        // to set the config product thats stored in local storage after
	        // submitting the request.
	        COSTCO.AffiliateForm.submit(requestData)
	        // returns configProduct
	        .then(helper.setConfigProduct)
	        // If we have errors, display them.
	        .then(helper.handleErrors)
	        // When we're done, we want to show the affiliates
	        .then(function () {
	          if ($('#quick-membership-checkout').length != 0) {
	            window.location.reload(true);
	          } else {
	            helper.reflectAffiliates();
	          }
	        })
	        // If the command fails, handle them
	        .fail(helper.handleErrors);
	      }
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.AffiliateForm = AffiliateForm;
	  return AffiliateForm;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title payment-methods.js: Sub-module for Account pages
	 * @description This module is used to handle tasks on Account -> Payment Methods page
	 * @dependency checkout_helper, creditcard
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(24), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (checkoutHelper, creditCard) {
	  var PaymentMethods = {
	    sessionId: '',
	    isACHMember: $('#achMemberValue').val() == 'true',
	
	    getForm: function getForm() {
	      return $('#PaymentMethodForm');
	    },
	
	    url: {
	      AJAX_PAYMENT_METHOD_UPDATE: '/AjaxPaymentMethodUpdateCmd'
	    },
	    /**
	     * Initialization of the module.
	     */
	    init: function init() {
	      this.cybersourceEnabled = $("#cybersourceEnabled").val() == 'true';
	      this.addValidationMethods();
	      this.initValidation();
	      this.maskInput();
	      COSTCO.MemberVerification.validationRules();
	      if ((isBDApplication !== 'BD' || isBDApplication === 'BD' && !PaymentMethods.isACHMember) && this.getForm().length > 0) {
	        this.showCCSection();
	      }
	      console.log('Payment Methods module initialized.');
	    },
	
	    /**
	     * Adds validation methods for form validation
	     */
	    addValidationMethods: function addValidationMethods() {
	      $.validator.setDefaults({
	        ignore: '.ignore'
	      });
	
	      $.validator.addMethod('costcoCC', function (value, element) {
	        value = value.replace(/\s+/g, '');
	        var costcoCCSaved = $('#costcoCCSaved').val() == 'true';
	        //check to see if value is costco cc and is disabled, otherwise return true and do normal customcc check.
	        if (/^\*/.test(value) && costcoCCSaved || /^7\d{5}\*{6}\d{4}$/.test(value)) {
	          var costcoCCDisabled = $('#costcoCCDisabled').val() == 'true';
	          return !costcoCCDisabled;
	        }
	        return true;
	      });
	
	      /**
	         	* Replicated $.validator.methods.creditcard() from jquery-1.10.2 for jquery-3.6.3
	      * since this is no longer defined in 3.6.3
	      * ALM 47081
	         	*/
	      $.validator.addMethod('rxCreditCard', function (value, element) {
	        if (this.optional(element)) {
	          return "dependency-mismatch";
	        }
	        if (/[^0-9 \-]+/.test(value)) {
	          return false;
	        }
	        var n = 0,
	            i = 0,
	            r = false,
	            s,
	            o;
	        value = value.replace(/\D/g, "");
	        if (value.length < 13 || value.length > 19) {
	          return false;
	        }
	        for (s = value.length - 1; s >= 0; s--) {
	          o = value.charAt(s);
	          i = parseInt(o, 10);
	          if (r) {
	            if ((i *= 2) > 9) {
	              i -= 9;
	            }
	          }
	          n += i;
	          r = !r;
	        }
	        return n % 10 === 0;
	      });
	
	      $.validator.addMethod('customcc', function (value, element) {
	        value = value.replace(/\s+/g, '');
	        if (!costcoStoreFeatures.DISCOVER_DINERSCLUB_JCB_CUP_ENABLED && isBDApplication == 'BC' && COSTCO.util.getLocale() == 'en-US') {
	          if (/^6011\d{2}\*{6}\d{4}$/.test(value) || /^65\d{4}\*{6}\d{4}$/.test(value) || /^6499\d{2}\*{6}\d{4}$/.test(value) || /^6555\d{2}\*{6}\d{4}$/.test(value) || /^6556\d{2}\*{6}\d{4}$/.test(value) || /^(30[0-5]|3095|36[0-9]|3[8-9])/.test(value) || /^(3528|35[3-8]|333[7-9]|334)/.test(value)) {
	            return false;
	          }
	        }
	        if (COSTCO.util.getLocale() == 'en-CA' || COSTCO.util.getLocale() == 'fr-CA' || isBDApplication == 'BD') {
	          if (/^6011\d{2}\*{6}\d{4}$/.test(value) || /^65\d{4}\*{6}\d{4}$/.test(value) || /^6499\d{2}\*{6}\d{4}$/.test(value) || /^6555\d{2}\*{6}\d{4}$/.test(value) || /^6556\d{2}\*{6}\d{4}$/.test(value) || /^(30[0-5]|3095|36[0-9]|3[8-9])/.test(value) || /^(3528|35[3-8]|333[7-9]|334)/.test(value)) {
	            return false;
	          }
	        }
	
	        if (value.indexOf('*') > 0 && value.length >= 14 && value.length <= 16) {
	          return true;
	        }
	        return this.optional(element) || /^7\d{5}\*{6}\d{4}$/.test(value) || /^\S{6}(\*{3}|\*{5})\s?\d{4}$/.test(value) || /^\S{6}\*{6}\s?\d{4}$/.test(value) || $.validator.methods.rxCreditCard.call($.data(element.form, 'validator'), value, element);
	      });
	
	      $.validator.addMethod('checkSpecialchar', function (value, element) {
	        // CC name shouldn't have any non-alphanumeric characters and needs at least 1 letter				
	        return this.optional(element) || !COSTCO.util.CC_NAME_FIELD_REGEX.test(value) && COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
	      });
	
	      $.validator.addMethod('checkExpiryDate', function (value, element) {
	        return this.optional(element) || /^(0[1-9]|1[012])\/([123]\d)$/.test(value);
	      });
	
	      $.validator.addMethod("checkIsDateInPast", function (value, element) {
	        var enteredMonth = parseInt(value.split('/')[0]);
	        var enteredYear = parseInt(value.split('/')[1]);
	        var now = new Date();
	        var currentMonth = parseInt((now.getMonth() + 1).toString());
	        var currentYear = parseInt(now.getFullYear().toString().substr(-2));
	        if (enteredYear < currentYear || enteredYear == currentYear && enteredMonth < currentMonth) {
	          return false;
	        } else {
	          return true;
	        }
	      });
	
	      $.validator.addMethod("achtype", function (value, element, param) {
	        return this.optional(element) || value !== param;
	      }, "Value must not equal arg.");
	
	      $.validator.addMethod("achNoSpChar", function (value, element, param) {
	        value = value.replace(/\s+/g, "");
	        return this.optional(element) || /^\w+$/i.test(value);
	      }, messages.ERR_INVALID_ACH_SPECIAL_CHARACTERS);
	
	      $.validator.addMethod("achAccountNumber", function (value, element, param) {
	        return this.optional(element) || /^(\d{1,13}|\*{1,13}|\x{1,13})\d{4}$/.test(value);
	      }, messages.ERR_INVALID_ACCOUNTNUM);
	
	      $.validator.addMethod("achRoutingNumber", function (value, element, param) {
	        return this.optional(element) || /^\d{9}$/.test(value);
	      }, messages.ERR_INVALID_ROUTINGNUM);
	
	      $.validator.addMethod("achNameLen", function (value, element, param) {
	        return this.optional(element) || value.length == 0 || value.length < 29;
	      }, messages.ERR_INVALID_ACH_NAME);
	    },
	    validationRules: function validationRules() {
	      $.validator.setDefaults({
	        ignore: '.ignore'
	      });
	
	      $.validator.addMethod('costcoCC', function (value, element) {
	        value = value.replace(/\s+/g, '');
	        var costcoCCSaved = $('#costcoCCSaved').val() == 'true';
	        //check to see if value is costco cc and is disabled, otherwise return true and do normal customcc check.
	        if (/^\*/.test(value) && costcoCCSaved || /^7\d{5}\*{6}\d{4}$/.test(value)) {
	          var costcoCCDisabled = $('#costcoCCDisabled').val() == 'true';
	          return !costcoCCDisabled;
	        }
	        return true;
	      });
	
	      $.validator.addMethod('customcc', function (value, element) {
	        value = value.replace(/\s+/g, '');
	
	        if (value.indexOf('*') > 0 && value.length == 16) {
	          return true;
	        }
	
	        return this.optional(element) || /^7\d{5}\*{6}\d{4}$/.test(value) || /^\S{6}(\*{3}|\*{5})\s?\d{4}$/.test(value) || /^\S{6}\*{6}\s?\d{4}$/.test(value) || $.validator.methods.creditcard.call($.data(element.form, 'validator'), value, element);
	      });
	
	      $.validator.addMethod('checkSpecialchar', function (value, element) {
	        return this.optional(element) || !/[<>\'\"]/.test(value); // CC name shouldn't have any html tag
	      });
	
	      $.validator.addMethod('checkExpiryDate', function (value, element) {
	        return this.optional(element) || /^(0[1-9]|1[012])\/([123]\d)$/.test(value);
	      });
	
	      $.validator.addMethod("checkIsDateInPast", function (value, element) {
	        var enteredMonth = parseInt(value.split('/')[0]);
	        var enteredYear = parseInt(value.split('/')[1]);
	        var now = new Date();
	        var currentMonth = parseInt((now.getMonth() + 1).toString());
	        var currentYear = parseInt(now.getFullYear().toString().substr(-2));
	        if (enteredYear < currentYear || enteredYear == currentYear && enteredMonth < currentMonth) {
	          return false;
	        } else {
	          return true;
	        }
	      });
	    },
	    /**
	     * Initializes jQuery validation plugin on PaymentMethod form
	     */
	    initValidation: function initValidation() {
	      PaymentMethods.getForm().validate({
	        errorPlacement: function errorPlacement(error, element) {
	          if ($(element).is('#card_number_validator')) {
	            $('.gw-proxy-number').css('border', '');
	            $('.gw-proxy-number').addClass('tokenization-error');
	            error.insertAfter(element);
	          } else if (element.attr("name") == "ach_checkbox") {
	            element.closest(".row").find("[ach-checkbox-error]").append(error);
	          } else if ($(element).is('#ach_account_holder_validator')) {
	            $('.gw-proxy-bankAccountHolder').css('border', '');
	            $('.gw-proxy-bankAccountHolder').addClass('tokenization-error');
	            error.insertAfter(element);
	          } else if ($(element).is('#ach_routing_number_validator')) {
	            $('.gw-proxy-routingNumber').css('border', '');
	            $('.gw-proxy-routingNumber').addClass('tokenization-error');
	            error.insertAfter(element);
	          } else if ($(element).is('#ach_account_number_validator')) {
	            $('.gw-proxy-bankAccountNumber').css('border', '');
	            $('.gw-proxy-bankAccountNumber').addClass('tokenization-error');
	            error.insertAfter(element);
	          } else {
	            error.insertAfter(element);
	          }
	        },
	        success: function success(label, element) {
	          if ($(element).is('#card_number_validator')) {
	            $('.gw-proxy-number').css('border', '1px solid #ccc');
	            $('.gw-proxy-number').removeClass('tokenization-error');
	          } else if ($(element).is('#ach_account_holder_validator')) {
	            $('.gw-proxy-bankAccountHolder').css('border', '1px solid #ccc');
	            $('.gw-proxy-bankAccountHolder').removeClass('tokenization-error');
	          } else if ($(element).is('#ach_routing_number_validator')) {
	            $('.gw-proxy-routingNumber').css('border', '1px solid #ccc');
	            $('.gw-proxy-routingNumber').removeClass('tokenization-error');
	          } else if ($(element).is('#ach_account_number_validator')) {
	            $('.gw-proxy-bankAccountNumber').css('border', '1px solid #ccc');
	            $('.gw-proxy-bankAccountNumber').removeClass('tokenization-error');
	          }
	        }
	      });
	    },
	    /**
	     * Removes red borders from input fields
	     */
	    removeBorderErrors: function removeBorderErrors() {
	      PaymentMethods.getForm().find('iframe.tokenization-error, input.error').each(function (index, element) {
	        $(element).css('border', '1px solid #ccc');
	        $(element).removeClass('tokenization-error, error');
	      });
	    },
	    /**
	     * Disables/enables input fields according to selected payment method
	     * @param paymentMethodType payment method type (CreditCard | ACH)
	     * @return void
	     */
	    setupSelectedFormSection: function setupSelectedFormSection(paymentMethodType) {
	      var achInputFields = PaymentMethods.getForm().find('input[ach-input-field]');
	      var ccInputFields = PaymentMethods.getForm().find('input[cc-input-field]');
	
	      if (paymentMethodType === 'CreditCard') {
	        achInputFields.each(function () {
	          $(this).attr('disabled', 'disabled');
	        });
	        ccInputFields.each(function () {
	          $(this).removeAttr('disabled');
	        });
	      } else if (paymentMethodType === 'ACH') {
	        achInputFields.each(function () {
	          $(this).removeAttr('disabled');
	        });
	        ccInputFields.each(function () {
	          $(this).attr('disabled', 'disabled');
	        });
	      } else {
	        console.log('Unknown payment method passed to setupSelectedFormSection() function.');
	      }
	      PaymentMethods.getForm().validate().resetForm();
	    },
	    /**
	     * Validates the Payment Methods add/edit fields
	     */
	    validatePaymentMethodForm: function validatePaymentMethodForm() {
	      var form = PaymentMethods.getForm();
	
	      if (form.length != 0) {
	        return form.valid();
	      }
	    },
	    /**
	     * Validation rules for credit card input fields
	     */
	    creditCardValidationRules: {
	      number: {
	        required: true,
	        customcc: true,
	        costcoCC: true,
	        messages: {
	          required: messages.ERR_CCNUM_REQ,
	          customcc: messages.ERR_INVALID_CREDITCARD_SHORT,
	          costcoCC: messages.COSTCO_CC_DISABLED
	        }
	      },
	      nameOnCard: {
	        required: true,
	        checkSpecialchar: true,
	        messages: {
	          required: messages.ERR_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	        }
	      },
	      cc_expiry_date: {
	        required: true,
	        checkExpiryDate: true,
	        checkIsDateInPast: true,
	        messages: {
	          required: messages.ERR_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	        }
	      }
	    },
	    pharmacyCreditCardValidationRules: {
	      number: {
	        required: true,
	        customcc: true,
	        costcoCC: true,
	        messages: {
	          required: messages.ERR_PH_CCNUM_REQ,
	          customcc: messages.ERR_INVALID_PH_CREDITCARD_SHORT,
	          costcoCC: messages.COSTCO_CC_DISABLED
	        }
	      },
	      nameOnCard: {
	        required: true,
	        checkSpecialchar: true,
	        messages: {
	          required: messages.ERR_PH_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	        }
	      },
	      cc_expiry_date: {
	        required: true,
	        checkExpiryDate: true,
	        checkIsDateInPast: true,
	        messages: {
	          required: messages.ERR_PH_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	        }
	      }
	    },
	    /**
	     * Validation rules for ACH input fields
	     */
	    achValidationRules: {
	      ach_account_holder: {
	        required: true,
	        achNameLen: true,
	        messages: {
	          required: messages.ERR_ACH_NAME_REQ,
	          achNameLen: messages.ERR_INVALID_ACH_NAME
	        }
	      },
	      accountType: {
	        required: true,
	        achtype: "-1",
	        messages: {
	          required: messages.ERR_ACH_CARDTYPE_REQ,
	          achtype: messages.ERR_ACH_CARDTYPE_REQ
	        }
	      },
	      ach_routing_number: {
	        required: true,
	        achNoSpChar: true,
	        achRoutingNumber: true,
	        messages: {
	          required: messages.ERR_ROUTINGNUM_REQ,
	          achNoSpChar: messages.ERR_INVALID_ROUTINGNUM
	        }
	      },
	      ach_account_number: {
	        required: true,
	        achAccountNumber: true,
	        messages: {
	          required: messages.ERR_ACH_CCNUM_REQ,
	          achNoSpChar: messages.ERR_INVALID_ACCOUNTNUM,
	          achAccountNumber: messages.ERR_INVALID_ACCOUNTNUM
	        }
	      },
	      ach_checkbox: {
	        required: true,
	        messages: {
	          required: messages.ACH_AGREE_PROMPT
	        }
	      }
	    },
	    /**
	     * Validation rules for ACH input fields
	     */
	    achCybsValidationRules: {
	      ach_account_holder: {
	        required: true,
	        achNameLen: true,
	        messages: {
	          required: messages.ERR_ACH_NAME_REQ,
	          achNameLen: messages.ERR_INVALID_ACH_NAME
	        }
	      },
	      accountType: {
	        required: true,
	        achtype: "-1",
	        messages: {
	          required: messages.ERR_ACH_CARDTYPE_REQ,
	          achtype: messages.ERR_ACH_CARDTYPE_REQ
	        }
	      },
	      ach_checkbox: {
	        required: true,
	        messages: {
	          required: messages.ACH_AGREE_PROMPT
	        }
	      }
	    },
	    /**
	     * Helper function to remove rules from form input fields
	     */
	    removeRules: function removeRules(rulesObj) {
	      for (var item in rulesObj) {
	        if (item == 'accountType') {
	          if ($('select[name=' + item + ']').length > 0) {
	            $('select[name=' + item + ']').rules('remove');
	          }
	        } else {
	          if ($('input[name=' + item + ']').length > 0) {
	            $('input[name=' + item + ']').rules('remove');
	          }
	        }
	      }
	    },
	    /**
	     * Helper function to add rules to form input fields
	     */
	    addRules: function addRules(rulesObj) {
	      for (var item in rulesObj) {
	        if (item == 'accountType') {
	          $('select[name=' + item + ']').rules('add', rulesObj[item]);
	        } else {
	          $('input[name=' + item + ']').rules('add', rulesObj[item]);
	        }
	      }
	    },
	    /**
	     * Submits the Payment Methods add/edit form
	     */
	    submit: function submit(redirectURL) {
	      var form = PaymentMethods.getForm();
	      var expDate = $(form).find('input[name=cc_expiry_date]').val().split('/');
	      $(form).find('input[name=expMonth]').val(expDate[0]);
	      $(form).find('input[name=expYear]').val('20' + expDate[1]);
	      if (PaymentMethods.cybersourceEnabled) {
	        $(form).find('input[name=ach_account_holder]').val($("#ach_account_holder").val());
	        $("#ach_account_holder_validator").val($("#ach_account_holder").val());
	      }
	      checkoutHelper.ajax_update_state({
	        method: 'POST',
	        url: PaymentMethods.url.AJAX_PAYMENT_METHOD_UPDATE,
	        data: form.serializeArray(),
	        dataType: 'json',
	
	        done: function done(data, textStatus, jqXHR, options) {
	          checkoutHelper.ajax_update_default_done(data, textStatus, jqXHR, options);
	
	          if (data.error.application.length > 0) {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application], true);
	          } else if (data.payload.data.status === 'success') {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [data.payload.data.message], true);
	            if (redirectURL) {
	              setTimeout(function () {
	                location.href = COSTCO.util.makeUrl('/' + redirectURL, { langId: wcs.langId, storeId: wcs.storeId, catalogId: wcs.catalogId, toPrescription: true });
	              }, 2000);
	            }
	          }
	        },
	        always: function always() {
	          $('.order-ajax').removeClass('ajax-busy');
	          TokenGateway.refreshGateway();
	        }
	      });
	    },
	    /**
	     * Mask expiry date and credit card number
	     */
	    maskInput: function maskInput() {
	      $('#cc_expiry_date').mask('00/00');
	      $('#card_number').mask('ZZZZ ZZZZ ZZZZ 0000', {
	        selectOnFocus: true,
	        translation: {
	          'Z': {
	            pattern: '[\\*0-9]'
	          }
	        }
	      });
	    },
	
	    formSubmitter: function formSubmitter(redirectURL, paymentMethodType) {
	      COSTCO.PaymentMethods.validatePaymentMethodForm();
	      var form = PaymentMethods.getForm();
	      if (form.valid()) {
	        PaymentMethods.submit(redirectURL);
	      }
	    },
	
	    /**
	     * Removes the payment method from respective payment methods list
	     * @param  {String} bodyMessage   	message to be displayed in body of dialog modal
	     * @param  {String} form 			form to be submitted thru ajax
	     * @param  {String} redirectURL 	URL to redirect the user to
	     * @param  {String} type 			payment type (currently: 'CreditCard'|'ACH')
	     * @return void
	     */
	    removePaymentMethod: function removePaymentMethod(bodyMessage, form, redirectURL, type) {
	      COSTCO.dialog.createExtDialogBox({
	        title: type === 'CreditCard' ? messages.ACCOUNT_PAYMENT_METHODS_Remove_Card_Button_Text : messages.COSTCO_REMOVE,
	        body: bodyMessage,
	        primary: type === 'CreditCard' ? messages.ACCOUNT_PAYMENT_METHODS_Remove_Card_Button_Text : messages.COSTCO_REMOVE,
	        secondary: messages.JS_DIALOG_CANCEL,
	        dialogclasses: 'remove-card-modal',
	        primary_event: function primary_event() {
	          checkoutHelper.ajax_update_state({
	            method: 'POST',
	            url: PaymentMethods.url.AJAX_PAYMENT_METHOD_UPDATE,
	            data: $(form).serializeArray(),
	            dataType: 'json',
	            ajax_update_post_done: function ajax_update_post_done(data) {
	
	              // TODO: Check if we need this
	              if (PaymentMethods.cybersourceEnabled) {
	                createTokenSessionId();
	              } else {
	                TokenGateway.refreshGateway();
	              }
	
	              PaymentMethods.addValidationMethods();
	              PaymentMethods.initValidation();
	              PaymentMethods.maskInput();
	
	              if (isBDApplication !== 'BD' || isBDApplication === 'BD' && !PaymentMethods.isACHMember) {
	                PaymentMethods.showCCSection();
	              }
	
	              COSTCO.dialog.close();
	
	              if (data.payload.data.status === 'success') {
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [data.payload.data.message], true);
	                if (redirectURL) {
	                  setTimeout(function () {
	                    location.href = COSTCO.util.makeUrl('/' + redirectURL, { langId: wcs.langId, storeId: wcs.storeId, catalogId: wcs.catalogId });
	                  }, 2000);
	                }
	              } else {
	                // error
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.payload.data.message], true);
	              }
	            }
	          });
	        }
	      });
	    },
	    /**
	     * Saves payment method for a user
	     * @param {redirectURL} URL to redirect the user to
	     * @param {paymentMethodType} 'CreditCard'|'ACH'
	     * @return void
	     */
	    savePaymentMethod: function savePaymentMethod(redirectURL, paymentMethodType) {
	
	      //reset ach dropdown value
	      if ($('#ach_account_type').val() == null || $('#ach_account_type').val() == '') {
	        $('#ach_account_type').val('-1');
	      }
	
	      if (paymentMethodType === 'CreditCard') {
	        TokenGateway.updateSessionFromForm('card', function () {
	          COSTCO.PaymentMethods.formSubmitter(redirectURL, paymentMethodType);
	        }, 'PaymentMethodForm');
	      } else if (paymentMethodType === 'ACH') {
	
	        if ($('#ach_account_type').val() == '-1') {
	          $('#ach_account_type').val('');
	        }
	        TokenGateway.updateSessionFromForm('ach', function () {
	          COSTCO.PaymentMethods.formSubmitter(redirectURL, paymentMethodType);
	        }, 'PaymentMethodForm');
	      }
	
	      //Add new payment methods here
	      return false;
	    },
	    setlabelActive: function setlabelActive(data, type) {
	
	      if ($('#cc-payment-block').find('[id=card_number_validator]').val() != '') {
	        $('label[for="card_number_validator"]').addClass("active");
	      }
	      if ($('#cc-payment-block').find('[id=cc_expiry_date]').val() != '') {
	        $('label[for="cc_expiry_date"]').addClass("active");
	      }
	      if ($('#cc-payment-block').find('[id=nameOnCard]').val() != '') {
	        $('label[for="nameOnCard"]').addClass("active");
	      }
	    },
	    /**
	     * Displays credit card / ach payment form when widget in Display mode
	     * @param  {JSON Object} data	data to populate template
	     * @return {void}
	     */
	    showPharmacyPaymentForm: function showPharmacyPaymentForm(data, type) {
	      COSTCO.util.notification.clearNotification();
	
	      if (!this.cybersourceEnabled) {
	        createTokenSessionId(false, false);
	      }
	      var formHtmlBlock = '#payment-method-edit';
	      var formTemplate = 'tmpl_payment_methods_form';
	      var inputFieldsSection = '';
	      $('#payment-method-display').hide();
	
	      var htmlForm = COSTCO.util.tmpl(formTemplate, {});
	      $(formHtmlBlock).html(htmlForm);
	
	      inputFieldsSection = COSTCO.util.tmpl('tmpl_pharmacy_payment_methods_full', data);
	      $('#payment-method-container').append(inputFieldsSection);
	
	      if (!this.cybersourceEnabled) {
	        TokenGateway.refreshGateway();
	      }
	
	      PaymentMethods.addValidationMethods();
	      PaymentMethods.initValidation();
	      PaymentMethods.maskInput();
	      PaymentMethods.setlabelActive();
	
	      if (type === 'CreditCard') {
	        PaymentMethods.showCCSection();
	      } else if (type === 'ACH') {
	        PaymentMethods.showACHSection();
	      }
	
	      if (this.cybersourceEnabled) {
	        this.setInputFieldsEvents();
	      }
	    },
	    /**
	     * Displays credit card / ach payment form when widget in Display mode
	     * @param  {JSON Object} data	data to populate template
	     * @return {void}
	     */
	    showPaymentForm: function showPaymentForm(data, type) {
	
	      COSTCO.util.notification.clearNotification();
	      if (!this.cybersourceEnabled) {
	        createTokenSessionId(false, false);
	      }
	      var formHtmlBlock = '#payment-method-edit';
	      var formTemplate = 'tmpl_payment_methods_form';
	      var inputFieldsSection = '';
	      $('#payment-method-display').hide();
	
	      var htmlForm = COSTCO.util.tmpl(formTemplate, {});
	      $(formHtmlBlock).html(htmlForm);
	
	      inputFieldsSection = COSTCO.util.tmpl('tmpl_payment_methods_full', data);
	      $('#payment-method-container').append(inputFieldsSection);
	
	      if (!this.cybersourceEnabled) {
	        TokenGateway.refreshGateway();
	      }
	
	      PaymentMethods.addValidationMethods();
	      PaymentMethods.initValidation();
	      PaymentMethods.maskInput();
	
	      if (type === 'CreditCard') {
	        PaymentMethods.showCCSection();
	        if (this.cybersourceEnabled) {
	          this.setInputFieldsEvents();
	        }
	      } else if (type === 'ACH') {
	        PaymentMethods.showACHSection();
	        if (this.cybersourceEnabled) {
	          this.setACHInputFieldsEvents();
	        }
	      }
	    },
	
	    setInputFieldsEvents: function setInputFieldsEvents() {
	      $("#card_number").keypress(function () {
	        TokenGateway.resetCardNumber(this);
	      }).keyup(function (event) {
	        if (event.keyCode === 8 || event.keyCode === 46) {
	          TokenGateway.resetCardNumber(this);
	        }
	      });
	      $("#card_number").click(function () {
	        TokenGateway.resetCardNumber(this);
	      });
	    },
	
	    setACHInputFieldsEvents: function setACHInputFieldsEvents() {
	      $("#ach_account_number").keypress(function () {
	        TokenGateway.resetACHFields(this, $("#ach_routing_number"), "ach_account_number");
	      }).keyup(function (event) {
	        if (event.keyCode === 8 || event.keyCode === 46) {
	          TokenGateway.resetACHFields(this, $("#ach_routing_number"), "ach_account_number");
	        }
	      });
	      $("#ach_account_number").click(function () {
	        TokenGateway.resetACHFields(this, $("#ach_routing_number"), "ach_account_number");
	      });
	
	      $("#ach_routing_number").keypress(function () {
	        TokenGateway.resetACHFields($("#ach_account_number"), this, "ach_routing_number");
	      }).keyup(function (event) {
	        if (event.keyCode === 8 || event.keyCode === 46) {
	          TokenGateway.resetACHFields($("#ach_account_number"), this, "ach_routing_number");
	        }
	      });
	      $("#ach_routing_number").click(function () {
	        TokenGateway.resetACHFields($("#ach_account_number"), this, "ach_routing_number");
	      });
	      $("#ach_account_holder").keypress(function () {
	        PaymentMethods.resetAccountHolderField();
	      }).keyup(function (event) {
	        if (event.keyCode === 8 || event.keyCode === 46) {
	          PaymentMethods.resetAccountHolderField();
	        }
	      });
	      $("#ach_account_holder").click(function () {
	        PaymentMethods.resetAccountHolderField();
	      });
	    },
	
	    resetAccountHolderField: function resetAccountHolderField() {
	      var labelSelector = 'label[for="ach_account_holder_validator"]';
	      $(labelSelector).removeClass('error');
	      $(labelSelector).addClass('hide');
	      if ($("#ach_account_holder").prop("readonly")) {
	        $(labelSelector).html("");
	        $("#ach_account_holder").removeAttr("disabled");
	        $("#ach_account_holder").removeAttr("readonly");
	        TokenGateway.resetACHFields($("#ach_account_number"), $("#ach_routing_number"), "ach_account_holder");
	      }
	      $("#ach_account_holder").focus();
	    },
	
	    /**
	     * Shows Credit Card section on user radio selection
	     */
	    showCCSection: function showCCSection() {
	      $('#radio-credit-card').prop('checked', true);
	      $('#PaymentMethodForm #payment_type').val('CreditCard');
	      $('#ach-payment-block').addClass('hide');
	      $('#cc-payment-block').removeClass('hide');
	      PaymentMethods.removeBorderErrors();
	      PaymentMethods.setupSelectedFormSection('CreditCard');
	      if (this.cybersourceEnabled) {
	        PaymentMethods.removeRules(PaymentMethods.achCybsValidationRules);
	      } else {
	        PaymentMethods.removeRules(PaymentMethods.achValidationRules);
	      }
	
	      var isPharmacy = $('input[name="isPharmacy"]').val();
	      if (isPharmacy) {
	        if (this.cybersourceEnabled) {
	          PaymentMethods.addCybersourceRules(PaymentMethods.pharmacyCreditCardCybsValidationRules);
	        } else {
	          PaymentMethods.addRules(PaymentMethods.pharmacyCreditCardValidationRules);
	        }
	      } else {
	        if (this.cybersourceEnabled) {
	          PaymentMethods.addCybersourceRules(PaymentMethods.creditCardCybsValidationRules);
	        } else {
	          PaymentMethods.addRules(PaymentMethods.creditCardValidationRules);
	        }
	      }
	    },
	    selectACHPayment: function selectACHPayment() {
	      if (this.cybersourceEnabled) {
	        createTokenSessionId(false, false);
	      }
	      PaymentMethods.showACHSection();
	      if (this.cybersourceEnabled) {
	        this.setACHInputFieldsEvents();
	      }
	    },
	    /**
	     * Shows ACH section on user radio selection (BD only)
	     */
	    showACHSection: function showACHSection() {
	      $('#radio-ach').prop('checked', true);
	      $('#PaymentMethodForm #payment_type').val('ACH');
	      $('#ach-payment-block').removeClass('hide');
	      $('#cc-payment-block').addClass('hide');
	      PaymentMethods.removeBorderErrors();
	      PaymentMethods.setupSelectedFormSection('ACH');
	      if (this.cybersourceEnabled) {
	        PaymentMethods.removeRules(PaymentMethods.creditCardCybsValidationRules);
	        PaymentMethods.addRules(PaymentMethods.achCybsValidationRules);
	      } else {
	        PaymentMethods.removeRules(PaymentMethods.creditCardValidationRules);
	        PaymentMethods.addRules(PaymentMethods.achValidationRules);
	      }
	    },
	
	    /** Changes for Cybersource Integration starts here **/
	
	    addCybersourceRules: function addCybersourceRules(rulesObj) {
	      for (var item in rulesObj) {
	        if (item == 'accountType') {
	          $('select[name=' + item + ']').rules('add', rulesObj[item]);
	        } else {
	          $('input[name=' + item + ']').rules('add', rulesObj[item]);
	        }
	      }
	    },
	
	    creditCardCybsValidationRules: {
	      nameOnCard: {
	        required: true,
	        checkSpecialchar: true,
	        messages: {
	          required: messages.ERR_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	        }
	      },
	      cc_expiry_date: {
	        required: true,
	        checkExpiryDate: true,
	        checkIsDateInPast: true,
	        messages: {
	          required: messages.ERR_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	        }
	      }
	    },
	    pharmacyCreditCardCybsValidationRules: {
	      nameOnCard: {
	        required: true,
	        checkSpecialchar: true,
	        messages: {
	          required: messages.ERR_PH_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	        }
	      },
	      cc_expiry_date: {
	        required: true,
	        checkExpiryDate: true,
	        checkIsDateInPast: true,
	        messages: {
	          required: messages.ERR_PH_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	        }
	      }
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.PaymentMethods = PaymentMethods;
	
	  return PaymentMethods;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	* @title checkout_helper.js: Feature level module
	* @description Utility module associated with checkout
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var Checkout = {
			/**
	  * Default implementation of the done promise used by ajax_update_state.
	  * The data structure this function uses is defined in JSONLayout.jsp.
	  * Update the state of each html segment. This assumes that the
	  * property key maps to the id of the html segment to replace. Also,
	  * if there any errors defined on the response_obj.error,
	  * display them.
	  * @param  {String} data       The JSON returned as a string. Contains
	  *                             the encoded html that must be decoded
	  *                             and then is injected into the DOM.
	  * @param  {String} textStatus [description]
	  * @param  {String} jqXHR      [description]
	  * @param  {Object} options    The options object originally passed to
	  *                             ajax_update_state
	  * @return {void}
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_default_done
	  */
			ajax_update_default_done: function ajax_update_default_done(data, textStatus, jqXHR, options) {
				try {
					var response_obj = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : JSON.parse(data);
					var defaultOptions = {
						ajax_replace_content: COSTCO.Checkout.ajax_replace_content,
						ajax_handle_errors: COSTCO.Checkout.ajax_handle_errors,
						ajax_update_post_done: function ajax_update_post_done() {},
						error_container: '',
						scrollToError: true
					};
					$('body').trigger('costco.ajax.content.update.start', response_obj);
					var mergedOptions = $.extend(true, {}, defaultOptions, options);
					// Inject New Html
					mergedOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
					// Post Html Injection
					mergedOptions.ajax_update_post_done(response_obj, mergedOptions, defaultOptions);
					// Handle any Errors and perform cleanup
					mergedOptions.ajax_handle_errors(response_obj, mergedOptions, defaultOptions);
					$('body').trigger('costco.ajax.content.update.end', response_obj);
				} catch (e) {
					console.error(e);
				}
				console.log('ajax_update_default_done');
			},
	
			/**
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_replace_content
	  */
			ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
				Object.keys(response_obj.payload.html).forEach(function (key) {
					var encoded_html = response_obj.payload.html[key];
					if (mergedOptions.replaceKey) {
						if (mergedOptions.replaceKey.original == key) {
							key = mergedOptions.replaceKey.replace;
						}
					}
					$('#' + key).html(COSTCO.util.get_decoded_html(encoded_html));
					console.log('ajax_replace_content' + key);
				});
			},
	
			/**
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_handle_errors
	  */
			ajax_handle_errors: function ajax_handle_errors(response_obj, mergedOptions, defaultOptions) {
				if ($('#isBDAppVar').val() == 'BD') {
					if (COSTCO.CreditCard.isCybersourceEnabled()) {
						$('.error:not(.error-qty-increment, #cc_cvc, #cc_cvc_err_msg)').empty();
					} else {
						$('.error:not(.error-qty-increment)').empty(); // clear any errors that may be on the page
					}
				} else {
					if (COSTCO.CreditCard.isCybersourceEnabled()) {
						$('.error:not(select, #cc_cvc, #cc_cvc_err_msg)').empty();
						$('.error:not(select)').removeClass('critical-notification');
					} else {
						$('.error:not(select)').empty().removeClass('critical-notification'); // clear any errors that may be on the page
					}
	
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				var error_container = mergedOptions.error_container;
				if (Checkout.isReviewPage() || Checkout.isPaymentPage()) {
					if (typeof TokenGateway !== 'undefined') {
						TokenGateway.refreshGateway();
					}
					if (response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr) {
						error_container = '#errquantity_application_';
						$('#errquantity_application_').addClass('critical-notification');
						$('#errquantity_application_').removeClass('error');
						$("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');
	
						if ($('#errquantity_application_').html().trim() == '') {
							$('#errquantity_application_').html(response_obj.metadata.quantityUpdatedForCashCardPaymentErr);
						}
					} else {
						if (typeof COSTCO.CreditCard !== 'undefined') {
							COSTCO.CreditCard.init();
						}
						if (typeof COSTCO.wallet !== 'undefined') {
							//wallet module is not used in USBD - all other allow
							if (wcs.storeId != '11301') {
								COSTCO.wallet.init();
							}
						}
						if (typeof COSTCO.CC !== 'undefined') {
							COSTCO.CC.init();
						}
					}
				}
				var input_container = mergedOptions.input_container;
				var application = response_obj.error.application || [];
				var exception = response_obj.error.exception || [];
				var error_html = '';
				if (exception.length > 0) {
					if (wcs.langId !== -25) {
						error_html += '<p>Sorry, we are experiencing technical issues. Please try again later.</p>';
					} else {
						error_html += '<p>Désolé, nous éprouvons des difficultés techniques. Veuillez réessayer plus tard.</p>';
					}
				}
				application.forEach(function (error_message) {
					error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
				});
				// if there is a redirect, store the error in sessionStorage and redirect user,
				// otherwise error will show in error container
				if (response_obj.error.redirect) {
					if (typeof sessionStorage != 'undefined') {
						sessionStorage.setItem('errorMessage', error_html); // store error_html in sessionStorage to show on redirected page
					}
					document.location.href = '/' + response_obj.error.redirect;
					return;
				}
				if (typeof error_container === 'string') {
					error_container = $(error_container);
				}
				if (input_container) {
					if (application.length + exception.length > 0) {
						$(input_container).addClass('error');
						$(input_container).attr('aria-invalid', 'true');
					} else {
						$(input_container).removeClass('error');
						$(input_container).attr('aria-invalid', 'false');
					}
				}
				if (error_container == '' || error_container.length == 0) {
					$('body').trigger('costco.ajax.content.update.sucess', response_obj);
					return;
				}
				error_container.children().remove();
				if (response_obj.metadata.quantityUpdatedForCashCardPaymentErr && error_html.length > 0) {
					$(error_container).html('');
					COSTCO.Checkout.showPaymentEditOption($('input[name=payMethodId]').val());
				}
				if (error_html.trim() != '') {
					error_container.append("<p class=\"sr-only\">" + messages.ERROR + "</p>");
					error_container.append(error_html);
					error_container.addClass('critical-notification');
					if (mergedOptions.not_critical_notification !== undefined && mergedOptions.not_critical_notification) {
						error_container.removeClass('critical-notification');
					}
	
					// add quantity limit error at the item level for BD
					if ($('#isBDAppVar').val() == 'BD') {
						$('.order-item').each(function () {
							if ($(this).find('.itemPartNumberPurchased').html() == response_obj.error.itemNumber) {
								$(this).find('.critical-notification').append(error_html).removeClass('hide');
							}
						});
					}
	
					COSTCO.util.announceSRMessage(messages.ERROR + "&nbsp" + error_html);
				}
				// Add/remove class critical-notification for page-top error in Cart page
				if (error_container.attr('id') == 'errquantity_' && checkoutPage && checkoutPage == 'cart') {
					if (error_container.html().trim() != '') {
						error_container.addClass('critical-notification');
					} else {
						error_container.removeClass('critical-notification');
					}
				}
				if ($('#errquantity_application_').length > 0 && $('#errquantity_application_').html().trim() != '') {
					if (!COSTCO.OrderSummary.isAllPaidByCashCard()) {
						COSTCO.Checkout.showPaymentEditSection($('input[name=payMethodId]').val());
					} else {
						$('#errquantity_application_').html('');
						$('#errquantity_application_').removeClass('critical-notification');
						$('#errquantity_application_').addClass('error');
					}
					COSTCO.CC.init();
				} else if ($('#errquantity_application_').length > 0) {
					$('#errquantity_application_').removeClass('critical-notification');
					$('#errquantity_application_').addClass('error');
					//This will do the real work - I have no idea what the above code does.
					//This will place error messages in-line
				} else if ($('#isBDAppVar').val() == 'BD') {
					COSTCO.OrderItems.placeGlobalCartErrorsInLine(response_obj);
					if ($("#contractErrContainer").length > 0) {
						error_container.addClass('hide');
						if (!$("#contractErrContainer").is(':visible')) $("#contractErrContainer").removeClass('hide');
					} else {
						error_container.removeClass('hide');
					}
				}
				if (mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)) {
					$('body').trigger('costco.ajax.content.update.error', response_obj);
					$('body, html').animate({
						scrollTop: $(error_container).offset().top - 30
					}, 800);
				}
			},
	
			/**
	  * A generic function to make ajax requests. The only difference being
	  * that this function sets a default done promise that injects html
	  * into the DOM with the response data. Pass done, fail, and always
	  * functions to the options object to be called in each respective promise.
	  * @param  {Object} options Object containing options to pass to $.ajax
	  *                          and functions to call within $.ajax promises.
	  * @return {void}
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_state
	  */
			ajax_update_state: function ajax_update_state(options, page) {
				// Prevent code breaking if checkoutPage is undefined.
				//let checkoutPage = typeof window.checkoutPage == 'undefined' ? false : window.checkoutPage;
				$('.order-ajax').addClass('ajax-busy');
				var checkoutPageName = typeof checkoutPage === 'undefined' ? false : checkoutPage;
				if (options.page || checkoutPageName) {
					options.url = COSTCO.util.makeUrl(options.url, {
						'checkoutPage': options.page || checkoutPageName
					});
				}
				if (!options.done) {
					options.done = COSTCO.Checkout.ajax_update_default_done;
				}
				if (!options.always) {
					options.always = COSTCO.Checkout.ajax_update_default_always(options.inputContainer);
				}
				COSTCO.util.ajax(options);
			},
	
			/**
	  * Extracting default function out so we can perfom this and something else
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_default_always
	  */
			ajax_update_default_always: function ajax_update_default_always(inputContainer) {
				$('.order-ajax').removeClass('ajax-busy');
				COSTCO.Checkout.validator = undefined;
				// ALM 54928 Possible patch fix for issue that exists in prod, NOT PERMANENT!
				if ($('#isBDAppVar').val() == 'BD') {
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				// Create a function to focus back to the original input after
				// the ajax call is done
				// This will only be done only if there input is defined in the option payload
				// ALM 54928: Possible patch fix for issue that exists in prod, NOT PERMANENT!
				if ($('#isBDAppVar').val() == 'BD') {
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				if (inputContainer) {
					var focusInput = $(inputContainer);
					if (focusInput.length > 0) {
						// If we have the id then lets use it
						if (focusInput[0].id) {
							console.log(focusInput[0].id);
							$('#' + focusInput[0].id).focus();
						} else {
							console.log('Working for it');
							// Ok no id so now we have to do work
							if (focusInput[0].nodeName == 'INPUT') {
								if (focusInput.attr('type') == 'radio' && focusInput.attr('name')) {
									$('input:checked[name="' + focusInput.attr('name') + '"]').focus();
								}
							}
						}
					}
				}
			},
	
			/**
	  * Displays the error message stored in sessionStorage from the previous page
	  * where error was sent to client, but a redirect needed to happen
	  */
			display_error_after_redirect: function display_error_after_redirect() {
				if (typeof sessionStorage != 'undefined' && sessionStorage.getItem('errorMessage')) {
					var $container = $('#progress-meter-row').children().last();
					$container.addClass('error');
					$container.append(sessionStorage.getItem('errorMessage'));
					sessionStorage.removeItem('errorMessage');
				}
			},
	
			/**
	  * Util to give an interactive character count down
	  * @param  {ojbect} label    pass the jquery obj where you want the
	  *                           countdown to reflect
	  * @param  {object} textarea pass a 'text' input
	  *                           (input[type='text'],textarea) to count
	  * @return {void}
	  */
			character_count: function character_count(label, textarea) {
				if ($(label).length > 0 && $(textarea).length > 0) {
					var updateLabelCount = function updateLabelCount(textarea, label) {
						var count = $(textarea).val().length;
						$(label).text(max - count);
					};
	
					var max = parseInt($(textarea).attr('maxlength'));
					$(label).text(max - $(textarea).val().length);
					$(textarea).unbind('keyup').on('keyup', function () {
						updateLabelCount(this, label);
					});
					$(textarea).unbind('change').on('change', function () {
						updateLabelCount(this, label);
					});
				}
			},
	
			getAuthToken: function getAuthToken() {
				return $('[name=authToken]').first().val();
			},
	
			show_busy_indicator: function show_busy_indicator() {
				$('.order-ajax').addClass('ajax-busy');
			},
	
			remove_busy_indicator: function remove_busy_indicator() {
				$('.order-ajax').removeClass('ajax-busy');
			},
	
			/**
	  * If PAD is the only choice in div.delivery-option-radios, PAD is required.
	  * Else it ain't.
	  * @param  {object}  delivery_radios The jQuery object that maps to
	  *                                   div.delivery-option-radios
	  * @return {Boolean} Is PAD required as a shipping method for this item.
	  */
			is_pad_required: function is_pad_required(delivery_radios) {
				var $radio_containers = $(delivery_radios).children();
				return $radio_containers.length === 1 && $radio_containers.first().hasClass('pad');
			},
	
			/**
	  * Is a PAD delivery option radio selected?
	  * @param  {object}  delivery_radios The jQuery object that maps to
	  *                                   div.delivery-option-radios
	  * @return {Boolean}                 Is the PAD radio selected?
	  */
			is_pad_selected: function is_pad_selected(delivery_radios) {
				var isSelected = false;
				var $pad_input = $(delivery_radios).find('.pad input[type=radio]');
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
					var $padWithoutNextDay = $(delivery_radios).find('.individualShipBlock, .individualPharmacyShipModes');
					if ($(delivery_radios).find(".grocery-header-text").length === 0 && $(delivery_radios).find(".frozen-header-text").length === 0) {
						if ($padWithoutNextDay.length === 0) {
							$(delivery_radios).find(".selection-box-v2.pad").attr("checked");
							isSelected = true;
						} else {
							isSelected = $pad_input.length > 0 && $pad_input.prop('checked');
						}
					}
				} else {
					isSelected = $pad_input.length > 0 && $pad_input.prop('checked');
				}
				return isSelected;
			},
	
			/**
	  * Clean inputs with quantity value unit
	  */
			clear_form: function clear_form() {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
					var inputs = $('input[name^=quantity]');
					if (inputs) {
						inputs.each(function () {
							var parent = $(this).parent('div');
							parent.removeClass('error');
						});
					}
				}
			},
			/**
	  * Generic validator instance
	  * @type $.validator
	  */
			validator: undefined,
	
			/**
	  * This function is used for dynamic form validation. Its meant to be
	  * wrapped in a decorator and configured appropriately. (See how
	  * orderitems.js uses it). Everything keys off of options_obj.rule. If
	  * a rule is supplied, we're matching that rule with a single dynamic input.
	  * Otherwise, we want to validate multiple, dynamic inputs. We pass a
	  * options_obj.validate_inputs function(See orderitem.js example) that
	  * applies the rules we want. Finally, if we're valid, execute the supplied
	  * callback
	  * @param  {object} options_obj The object with the following properties:
	  *                              {
	  	*                                form: <The form we're validating>,
	  	*                                input: <optional: input to validate>,
	  	*                                validate_inputs: <The fn to add N number
	  	*                                  of rules>,
	  	*                                rule: <optional: the object that represents
	  	*                                  the rule to validate with provided input>,
	  	*                                rules_config_obj: <All of the rules to
	  	*                                  potentially pass to $.fn.validator>,
	  	*                                callback: <The function to pass on
	  	*                                  successful validation>
	  	*                              }
	  * @return {void}
	  */
			_dynamic_validate: function _dynamic_validate(options_obj) {
				var self = COSTCO.Checkout;
				var $form = options_obj.form;
				var $input = options_obj.input;
				var validate_inputs = options_obj.validate_inputs;
				var rule = options_obj.rule;
				var rules_config_obj = options_obj.rules_config_obj;
				var callback = options_obj.callback;
				//callbackParams is used in case callback function has parameters
				var callbackParams = options_obj.callbackParams;
				var options = {
					focusInvalid: false,
					errorElement: 'span'
				};
				var errorPlacement = options_obj.errorPlacement;
				if (self.validator && rule != 'quantity') {
					$form.destroyValidator(self.validator);
					COSTCO.Checkout.clear_form();
				}
				// If we're not validating a single input, we want to call the invalid
				// handler so when we throw an error we scroll to where that error is.
				if (!rule) {
					options.invalidHandler = COSTCO.util.invalid_handler;
				}
				self.validator = $form.validate(options);
				if (rule) {
					// We want a specific rule bound on the input.
					// If we're being called as an inline event handler on an input, we good, otherwise
					// use the data-id attribute of the calling DOM element to get the input.
					var $input = $input.prop('tagName') === 'INPUT' || $input.prop('tagName') === 'SELECT' ? $input : $('#' + $input.data('id'));
					$input.rules('add', rules_config_obj[rule]);
					if (!(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE)) {
						if ($('#isBDAppVar').val() == 'BD' && rule == 'quantity') {
							self.validator.settings.errorClass = self.validator.settings.errorClass + ' error-qty-increment';
						}
					}
				} else {
					// Case where we have mulitple dynamic inputs to validate
					if (validate_inputs) validate_inputs(rules_config_obj);
				}
				if (errorPlacement) {
					self.validator.settings.errorPlacement = errorPlacement;
				}
				// $.validator.form triggers form validation programmatically
				// If we're a valid form, execute the callback.
				if (self.validator.form()) {
					if (callback) {
						if (callbackParams !== undefined && callbackParams.length > 0) {
							callback(callbackParams);
						} else {
							callback();
						}
					}
				}
			},
	
			editMyAccount: function editMyAccount(view) {
				var path = "/AccountInformationView?langId=" + wcs.langId + "&storeId=" + wcs.storeId + "&catalogId=" + wcs.catalogId + "&crmSpecificView=" + view;
				window.location.href = path;
			},
	
			/**
	  * This is the inline event handler for membership application item.
	  * It needs to redirect back to the application page.
	  * @param  {[type]} partNumber  [description]
	  * @param  {[type]} orderItemId [description]
	  * @param  {[type]} orderId     [description]
	  * @return {void}
	  */
			editApplication: function editApplication(partNumber, orderItemId, orderId) {
				var path = '';
				try {
					$.cookie('APPLICATION_TRACKING_COOKIE', null, {
						path: '/'
					});
				} catch (e) {}
				if ($('#isBDAppVar').val() === 'BD' && $.cookie('cartCountCookie') > 1) {
					path = '/MembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
				} else {
					path = '/QuickMembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
				}
				$.cookie('APPLICATION_TRACKING_COOKIE', orderItemId);
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutReviewView')) {
					path += '&orderId=' + orderId;
				}
				window.location.href = path;
			},
	
			/**
	  * Opens 'Remove Memebrship/Renewal Warning Modal' dialog modal.
	  * @return {void}
	  */
			openRemoveWarningModal: function openRemoveWarningModal(isRenew, orderItemId) {
				COSTCO.dialog.createExtDialogBox({
					title: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Label : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Label,
					body: isRenew ? memberOnlyFeatureEnabled ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Body_Text : memberOnlyFeatureEnabled ? messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Body_Text,
					primary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Keep_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Keep_Membership_Button_Text,
					secondary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Remove_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Remove_Membership_Button_Text,
					dialogclasses: 'leave-page-modal',
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					},
					secondary_event: function secondary_event() {
						COSTCO.OrderItems.remove_item(orderItemId);
					}
				});
			},
	
			openRemoveWarningModal_v2: function openRemoveWarningModal_v2(isRenew, orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart) {
				COSTCO.dialog.createExtDialogBox({
					title: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Label : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Label,
					body: isRenew ? memberOnlyFeatureEnabled ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Body_Text : memberOnlyFeatureEnabled ? messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Body_Text,
					primary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Keep_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Keep_Membership_Button_Text,
					secondary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Remove_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Remove_Membership_Button_Text,
					dialogclasses: 'leave-page-modal',
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					},
					secondary_event: function secondary_event() {
						COSTCO.OrderItems.remove_item_v2(orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
					}
				});
			},
	
			deletePaymentInstructionsForOrder: function deletePaymentInstructionsForOrder() {
				return new Promise(function (resolve, reject) {
					if (Checkout.isCheckoutPage()) {
						// if we're on the checkout page
						var currentOrderId = $('INPUT[name="orderId"]').val();
						COSTCO.util.ajax({
							url: '/AjaxDeletePaymentInstructionsForOrder',
							method: 'POST',
							dataType: 'json',
							data: {
								orderId: currentOrderId
							},
							success: function success(result) {
								// if no xcreditcard id, clear everything in the form. Else, clear the piId and populate the xCreditCardId in the form
								if (result.xcreditCardId.length === 0) {
									if ($('#piIdCashCard').length > 0) {
										$('#piIdCashCard').val('');
									}
									if ($('#account').length > 0) {
										$('#account').val('');
									}
									if ($('#cc_expiry_date').length > 0) {
										$('#cc_expiry_date').val('');
									}
									if ($('#cc_nameoncard').length > 0) {
										$('#cc_nameoncard').val('');
									}
								} else {
									if ($('#piIdCashCard').length > 0) {
										$('#piIdCashCard').val('');
									}
									if ($('[name="xCreditCardId"]').length > 0) {
										$('[name="xCreditCardId"]').val(result.xcreditCardId);
									}
								}
	
								console.log('Deleted payment instructions for order ' + currentOrderId);
								resolve();
							},
							fail: function fail(error) {
								console.error('Error deleting payment instructions for order ' + currentOrderId);
								resolve();
							}
						});
					} else {
						// if we're not on the checkout page, do nothing
						resolve();
					}
				});
			},
	
			showPaymentEditOption: function showPaymentEditOption(payType, skipCreateToken) {
				if (payType == 'ACH' && hasCashCard) {
					COSTCO.CC.removeCashCard($('#remove-cash-card-link'));
				}
				if (/^(Check|LineOfCredit)$/i.test(payType)) {
					Checkout.showPaymentEditSection(payType);
				} else {
					Checkout.deletePaymentInstructionsForOrder().then(function () {
						COSTCO.Checkout.moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay();
						if (undefined == skipCreateToken) {
							createTokenSessionId().then(function () {
								Checkout.showPaymentEditSection(payType);
							});
						}
					});
				}
			},
	
			showPaymentEditSection: function showPaymentEditSection(payType) {
				$('#payment-method-radio-buttons').removeClass('hide');
				$('#cod-ach-acr-payment').removeClass('hide');
				$('#cc-payment-block-title').removeClass('hide');
				$('#cc-payment-block').removeClass('hide');
				$('#credit-card-address-block').removeClass('hide');
				$('#cc-payment-address-block').removeClass('hide');
				$('#credit-card-block').removeClass('hide');
				$('#wallet-block').removeClass('hide');
				$('#credit-card-info-container').addClass('hide');
				$('#creditcard-block-form').removeClass('display');
				$('#single-page-checkout #cc-payment-block').attr('do-not-show', 'false');
				$('.payment-method-change').addClass('hide');
				$('#applepay-payment-block').addClass('hide');
				$('#applepay-block-form').removeClass('display');
				$('#applepay-info-container').addClass('hide');
				$('#place-order-button-regular').removeAttr('do-not-show');
				$('#place-order-button-applepay').attr('do-not-show', 'true');
				$('#place-order-button-regular').removeClass('hide');
				$('#place-order-button-applepay').addClass('hide');
				if (COSTCO.Checkout.displayAllPayments()) {
					$('#credit-card-block-review').addClass('hide');
					$('input[id=usedPayMethod]').val('');
				}
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
					$('#wallet-payment-address-form').addClass('hide');
					$('#payment-address-form').removeClass('hide');
					$('#payment-address-form .address-change-link-B').removeClass('hide');
					$('input[id=appliedPayMethod]').val('');
				}
				if ($('#isBDAppVar').val() == 'BD') {
	
					if (COSTCO.util.isNdEnabled()) {
						$('#ach-block').removeClass('hide');
					} else if (!COSTCO.util.isExternalCarrierShipmode()) {
						$('#check-del-block').removeClass('hide');
						$('#ach-block').removeClass('hide');
						$('#acc-receiv-block').removeClass('hide');
					}
	
					var paymentType = $('#ordPayInsVal').length > 0 ? $('#ordPayInsVal').val() : payType;
					if (paymentType == 'Check') {
						COSTCO.wallet.showCheckOnDeliverySection();
					} else if (paymentType == 'ACH') {
						COSTCO.wallet.showACHSection();
					} else if (paymentType == 'LineOfCredit') {
						COSTCO.wallet.showAcctReceivableSection();
					} else if ($('#wallet-info-div').length && !$('#wallet-info-div').hasClass('hide')) {
						$('#wallet-info-div').addClass('hide');
						$('#wallet-change-link').addClass('hide');
						if (wcs.locale == 'en_CA' || wcs.locale == 'fr_CA') {
							COSTCO.wallet.showMasterpassSection();
						} else {
							COSTCO.wallet.disableUseExistingWallet();
							COSTCO.wallet.showVisaSection();
						}
					} else {
						COSTCO.wallet.showCCSection();
						Checkout.reValidateCVV();
					}
				} else if ($('#wallet-info-div').length && !$('#wallet-info-div').hasClass('hide')) {
					$('#wallet-info-div').addClass('hide');
					$('#wallet-change-link').addClass('hide');
					if (wcs.locale == 'en_CA' || wcs.locale == 'fr_CA') {
						COSTCO.wallet.showMasterpassSection();
					} else {
						COSTCO.wallet.disableUseExistingWallet();
						COSTCO.wallet.showVisaSection();
					}
					COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('wallet');
				} else {
					COSTCO.wallet.showCCSection();
					Checkout.reValidateCVV();
					COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('credit card');
				}
				$('#auto-renew-div').appendTo($('#save_CC').parent().parent());
				$('#auto-renew-div').removeClass('mt-16');
				$('#auto-renew-div').addClass('mt-5');
				$('#auto-renew-div').addClass('mb-16');
				$('#autorenew-invalid-saved-card-div').addClass('hide');
				return false;
			},
	
			hidePaymentEditSection: function hidePaymentEditSection() {
				$('#payment-method-radio-buttons').addClass('hide');
				$('#cod-ach-acr-payment').addClass('hide');
				$('#cc-payment-block').addClass('hide');
				$('#credit-card-block').addClass('hide');
				$('#credit-card-address-block').addClass('hide');
				$('#cc-payment-address-block').addClass('hide');
				$('#wallet-block').addClass('hide');
				if ($('#isBDAppVar').val() == 'BD') {
					$('#check-del-block').addClass('hide');
					$('#ach-block').addClass('hide');
					$('#acc-receiv-block').addClass('hide');
				}
			},
	
			clickToPayWasTriggered: function clickToPayWasTriggered() {
				var value = sessionStorage.getItem('CLICK_TO_PAY_TRIGGERED');
				return value ? true : false;
			},
	
			removeClickToPayTriggered: function removeClickToPayTriggered() {
				sessionStorage.removeItem('CLICK_TO_PAY_TRIGGERED');
			},
	
			setClickToPayTriggered: function setClickToPayTriggered() {
				sessionStorage.setItem('CLICK_TO_PAY_TRIGGERED', true);
			},
	
			moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay: function moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay() {
				if (COSTCO.Checkout.clickToPayWasTriggered()) {
					var btn = $('#orderSummaryCheckoutButton');
					if (btn.length) {
						var currentStepNumber = parseInt(btn.attr('current-step-number')),
						    finalStepNumber = CHECKOUTSTEPS.length;
						// if we're on the last checkout step
						if (currentStepNumber > 1 && currentStepNumber == finalStepNumber) {
							var previousStepIndex = currentStepNumber - 2,
							    previousStepNumber = currentStepNumber - 1;
							btn.val(CHECKOUTSTEPS[previousStepIndex].text).attr('onclick', 'COSTCO.OrderSummary.checkoutSteps.submitCheckoutStep(' + previousStepNumber + ')');
						}
					}
				}
				COSTCO.Checkout.removeClickToPayTriggered();
			},
	
			updateCheckoutForm: function updateCheckoutForm() {
				var val = this.checked ? 'on' : 'off';
				$('#isSavedPaymentAutoRenew').prop('value', val);
			},
	
			isCheckoutPage: function isCheckoutPage() {
				return $('#CheckoutPaymentForm').length ? true : false;
			},
	
			isCartPage: function isCartPage() {
				return $('#cart').length > 0;
			},
	
			isReviewPage: function isReviewPage() {
				var isReviewPage = false;
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutReviewView')) {
					isReviewPage = true;
				}
				return isReviewPage;
			},
	
			isPaymentPage: function isPaymentPage() {
				var isPaymentPage = false;
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutPaymentView')) {
					isPaymentPage = true;
				}
				return isPaymentPage;
			},
	
			reValidateCVV: function reValidateCVV() {
				if ($('#cc_expiry_date').val() != '') {
					COSTCO.CreditCard.validate.creditCardForm();
					$("label[for='cc_cvc_validator']").text(messages.CVV_REENTER);
				} else {
					$('#save_CC').prop('checked', false);
				}
			},
			toggleCartAccordion: function toggleCartAccordion(orderItemId) {
				if ($('#cart-accordion-header-1-' + orderItemId).hasClass('collapsed')) {
					$('#cart-accordion-header-1-' + orderItemId).text(messages.HIDE_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-' + orderItemId).hide();
					$('#arrow-' + orderItemId).remove();
					$('#cart-accordion-header-1-' + orderItemId).after("&nbsp;<i class='co-arrow-left rotate90' id='arrow-" + orderItemId + "'></i>");
				} else {
					$('#cart-accordion-header-1-' + orderItemId).text(messages.SHOW_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-' + orderItemId).show();
					$('#arrow-' + orderItemId).remove();
					$('#cart-accordion-header-1-' + orderItemId).after("&nbsp;<i class='co-arrow-right rotate90' id='arrow-" + orderItemId + "'></i>");
				}
			},
	
			membershipAutoRenewOptionOptedIn: function membershipAutoRenewOptionOptedIn() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				if ($("input[name='radio-auto-renew']:checked").val() !== undefined && !$('#membership-renew-error-container').hasClass('hide')) {
					$('#membership-renew-selection-error').addClass('hide');
				}
				$('input[name="isPurchaseMembershipAutoRenew"]').val('true');
				$('#wallet-block').addClass('hide');
				$('#creditcard-block-form').removeClass('display');
				if ($('#credit-card-info-container').length == 0) {
					$('#wallet-info-div').addClass('hide');
					$('#credit-card-block').removeClass('hide');
				}
				document.getElementById('credit-card-block').scrollIntoView({ behavior: 'smooth', block: 'center' });
			},
	
			membershipAutoRenewOptionOptedOut: function membershipAutoRenewOptionOptedOut() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				if ($("input[name='radio-auto-renew']:checked").val() !== undefined && !$('#membership-renew-error-container').hasClass('hide')) {
					$('#membership-renew-selection-error').addClass('hide');
				}
				$('input[name="isPurchaseMembershipAutoRenew"]').val('false');
				if (!$('#wallet-info-div').length > 0) {
					$('#wallet-block').removeClass('hide');
				}
				$('#CheckoutPaymentForm').validate().resetForm();
				$('#account').removeClass('error-credit-card');
				$('#cc_cvc').removeClass('error-credit-card');
				$('#account_validator_err_msg').html('');
				$('#cc_cvc_err_msg').html('');
				$('#cc_membership_renew_error').removeClass('critical-notification');
				$('#cc_membership_renew_error').addClass('alert-notification');
			},
	
			pageRefreshForToken: function pageRefreshForToken() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				digitalDataEvents.push({ nav: "Checkout Flow | refresh your page" });
			},
	
			toggleCartAccordionMobile: function toggleCartAccordionMobile(orderItemId) {
				if ($('#cart-accordion-header-2-' + orderItemId).hasClass('collapsed')) {
					$('#cart-accordion-header-2-' + orderItemId).text(messages.HIDE_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-2-' + orderItemId).hide();
					$('#arrow-m-' + orderItemId).remove();
					$('#cart-accordion-header-2-' + orderItemId).after("&nbsp;<i class='co-arrow-left rotate90' id='arrow-m-" + orderItemId + "'></i>");
				} else {
					$('#cart-accordion-header-2-' + orderItemId).text(messages.SHOW_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-2-' + orderItemId).show();
					$('#arrow-m-' + orderItemId).remove();
					$('#cart-accordion-header-2-' + orderItemId).after("&nbsp;<i class='co-arrow-right rotate90' id='arrow-m-" + orderItemId + "'></i>");
				}
			},
	
			/**
	  * Helper function to recompile & reload all checkout sections. Performed by ajax-modular
	  * call to '/order-prepare' without additional request parameters.
	  * @return {object} Deferred
	  */
			ajaxRefreshAllCheckoutSections: function ajaxRefreshAllCheckoutSections() {
				var deferred = $.Deferred();
				COSTCO.CreditCard.initComplete = false;
				COSTCO.AjaxModular.ajax_update_state({
					url: '/order-prepare',
					always: function always(data, textStatus, jqXHR, options) {
						deferred.resolve();
					}
				});
				return deferred.promise();
			},
	
			addScreenReaderAnnouncement: function addScreenReaderAnnouncement(adaMessage) {
				var adaMessageDiv = $('#screen-reader-announcement');
				if (adaMessageDiv.length > 0) {
					setTimeout(function () {
						adaMessageDiv.html(adaMessage);
					}, 1000);
				}
			},
			displayAllPayments: function displayAllPayments() {
				return costcoStoreFeatures.DISPLAY_ALL_PAYMENTS;
			},
			usedPayment: function usedPayment() {
				return $('input[id=usedPayMethod]').length > 0 ? $('input[id=usedPayMethod]').val() : "";
			},
			resetCheckoutPaymentFields: function resetCheckoutPaymentFields(payType) {
				$('#account').val("");
				$('#cc_cvc').val("");
				$('#cc_expiry_date').val("");
				$('#cc_nameoncard').val("");
				TokenGateway.focusField = "card.number";
				$('#cc_cvc_err_msg').addClass('hide');
				$.cookie('tkSession', 'false', { path: '/' });
				createTokenSessionId().then(function () {
					Checkout.showPaymentEditSection(payType);
				});
			}
		};
	
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.Checkout = Checkout;
		return Checkout;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title account-details.js: Sub-module for Account pages
	 * @description This module is used to handle account details tasks
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(19), __webpack_require__(26), __webpack_require__(27), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (membershipHelper, _memberVerification, secureKeyMemberVerification, linkMembership, checkoutHelper) {
	  var AccountDetails = {
	    /**
	     * Basic initial function. Sets the membership data and fires the
	     * needed validation methods.
	     * @return {void}
	     */
	    init: function init() {
	      // membershipData sourced from AccountDetails_Data.jsp
	      this.membershipData = membershipData;
	      COSTCO.util.maskMembershipInput();
	
	      this.isVerified = this.membershipData && this.membershipData.verified;
	      this.usage = this.membershipData && this.membershipData.caller.usage;
	      this.usageRole = this.membershipData && this.membershipData.caller.usageRole;
	      this.isEmployee = this.usage == 'Z030' && this.usageRole != '03';
	      this.validationRules();
	      membershipHelper.formWizBangs($('#household-form-details'));
	      membershipHelper.addValidationMethods($('#household-form-details'));
	      this.signInFormHandler();
	      // this.membershipFormHandler();
	      this.linkedMembershipFormHandler();
	      this.determinePersonalInfoHandler();
	      // this.personalInfoFormHandler();
	      this.accountManagerFormHandler();
	      this.householdFormHandler();
	      this.employeeAddOnFormHandler();
	      _memberVerification.init();
	      secureKeyMemberVerification.init();
	      membershipHelper.formWizBangs($('#employee-addon-form'));
	      this.setDob();
	
	      if (sessionStorage.getItem('from_page') == 'costco_wallet') {
	        COSTCO.AccountDetails.memberVerification();
	        sessionStorage.removeItem('from_page');
	      }
	
	      // this.initPrimaryMembershipInfoForm();
	      $('.co-help').popover();
	
	      if (isDmcPage) {
	        if (dmcDoVerification) {
	          if (COSTCO.dialog.isVisible()) {
	            $('#costcoModal').hide();
	          }
	          COSTCO.AccountDetails.memberVerification();
	        } else if (dmcRenewalFlow) {
	          if (COSTCO.dialog.isVisible()) {
	            $('#costcoModal').hide();
	          }
	          var primary_button = $(":input.primary.renew-button")[1];
	          primary_button.click();
	        }
	      }
	
	      // populate selectedMenuItem in session storage nav bar react component Account Details option to be highlighted
	      if (window.location.href.includes("AccountInformationView") || window.location.href.includes("AccountDetailsView")) {
	        COSTCO.Global.updateSelectedMenuItem("AccountDetails.label");
	      }
	
	      console.log('Account Details sub-module initialized.');
	    },
	    /**
	     * initPrimaryMembershipInfoForm is a function that is hooked into our
	     * modular ajax framework and is meant to update sections of the form. However,
	     * when we have multiple fields that are missing that are required, we need
	     * a way to update all of the required fields in relation to the backend command
	     * (MemberPrimaryInformationUpdateCmdImpl)
	     * @return {void}
	     */
	    determinePersonalInfoHandler: function determinePersonalInfoHandler() {
	      // We'll use the data attribute field-protection on each form element
	      // to determine if we have a missing required input. If so, we'll use the
	      // traditional handler to send the entire form to the backend.
	      membershipHelper.formWizBangs($('#primary-information-update'));
	      AccountDetails.setState();
	      if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	        AccountDetails.setCity();
	      }
	      if (this.anyRequiredFieldsMissing()) {
	        this.personalInfoFormHandler();
	      } else {
	        this.bindPrimaryInformationEvents();
	      }
	    },
	    /**
	     * Are any form elements with field-protection with EDITABLE_REQUIRED value
	     * missing a value?
	     * @return {boolean} The answer
	     */
	    anyRequiredFieldsMissing: function anyRequiredFieldsMissing() {
	      var answer = false;
	      $('#primary-information-update [data-field-protection]').each(function (index, el) {
	        var fieldProtection = $(el).data('field-protection');
	        if (fieldProtection === 'EDITABLE_REQUIRED' && !($(el).val() || $(el).attr('data-selected'))) {
	          answer = true;
	        }
	      });
	      return answer;
	    },
	    /**
	     * Gets jquery primary memebership information form
	     * @return {jqueryForm} form
	     */
	    getPrimaryMembershipInfoForm: function getPrimaryMembershipInfoForm() {
	      return $('#primary-information-update');
	    },
	    /**
	     * Binds specific events on the primary membership information form buttons, so that we can submit form sections independantly.
	     */
	    bindPrimaryInformationEvents: function bindPrimaryInformationEvents() {
	      $('#update-primary-nickname-btn').off().on('click', function () {
	        var data = AccountDetails.preparePrimaryNicknameData();
	        AccountDetails.ajaxUpdatePrimaryInformation(data);
	      });
	      $('#update-primary-address-btn').off().on('click', function (event) {
	        AccountDetails.validateFields(sendAddressData);
	        /**
	         * [sendAddressData description]
	         * @return {void}
	         */
	        function sendAddressData() {
	          if (AccountDetails.needsVerification()) {
	            membershipHelper
	            // Execute address verification on the primary information address.
	            .verifyAddresses({
	              form: '#primary-information-update',
	              primary: membershipHelper.primaryInformationSelectors
	            })
	            // Invoke the address verification modal
	            .then(function (verifyResponse) {
	              return membershipHelper.invokeMultiAVS(verifyResponse, function (addresses) {
	                var data = AccountDetails.preparePrimaryAddressData(addresses);
	                AccountDetails.ajaxUpdatePrimaryInformation(data);
	              });
	            }).fail(AccountDetails.failHandler);
	          } else {
	            var data = AccountDetails.preparePrimaryAddressData();
	            AccountDetails.ajaxUpdatePrimaryInformation(data);
	          }
	        }
	      });
	      $('#update-primary-phone-btn').on('click', function () {
	        AccountDetails.validateFields(sendPhoneData, 'phoneNum', $('#update-phone'));
	        /**
	         * [sendPhoneData description]
	         * @return {void} [description]
	         */
	        function sendPhoneData() {
	          var data = AccountDetails.preparePrimaryPhoneData();
	          AccountDetails.ajaxUpdatePrimaryInformation(data);
	        }
	      });
	      $('#update-primary-mobile-phone-btn').on('click', function () {
	        AccountDetails.validateFields(sendMobilePhoneData, 'mobilePhoneNum', $('#update-mobile'));
	        /**
	         * [sendMobilePhoneData description]
	         * @return {void}
	         */
	        function sendMobilePhoneData() {
	          var data = AccountDetails.preparePrimaryMobilePhoneData();
	          AccountDetails.ajaxUpdatePrimaryInformation(data);
	        }
	      });
	      $('#update-primary-email-btn').on('click', function () {
	        AccountDetails.validateFields(sendEmailData, 'email_rule', $('#update-membership-email'));
	        /**
	         * [sendEmailData description]
	         * @return {void}
	         */
	        function sendEmailData() {
	          var data = AccountDetails.preparePrimaryEmailData();
	          AccountDetails.ajaxUpdatePrimaryInformation(data);
	        }
	      });
	      $('#update-dob-btn').off().on('click', function () {
	        /** DOB fields such as Year, Month and Day validation, Error display and form submission */
	        var valid = false;
	        membershipHelper.addValidationMethods($('#primary-information-update'));
	        var rules = null;
	        var messages = null;
	        if (membershipHelper.isBusinessMembership()) {
	          rules = membershipHelper.business.rules;
	          messages = membershipHelper.business.messages();
	        } else {
	          rules = membershipHelper.goldstar.rules;
	          messages = membershipHelper.goldstar.messages();
	        }
	        if (rules && messages) {
	          $('#primary-information-update').validate({
	            invalidHandler: COSTCO.util.invalid_handler,
	            rules: rules,
	            messages: messages
	          });
	          valid = $('#primary-information-update').valid();
	        }
	
	        if (valid) {
	          var data = AccountDetails.preparePrimaryDobData();
	          AccountDetails.ajaxUpdatePrimaryInformation(data);
	        }
	      });
	    },
	    forms: {
	      getPrimaryInformationForm: function getPrimaryInformationForm() {
	        return $('#primary-information-update');
	      }
	    },
	    /**
	     * Makes the actual ajax modular request to update the primary membership information
	     * @param  {JSONObj} data JSON data to be passed to backend
	     */
	    ajaxUpdatePrimaryInformation: function ajaxUpdatePrimaryInformation(data) {
	      COSTCO.util.notification.clearNotification();
	      COSTCO.Checkout.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxMemberPrimaryInformationUpdateCmd',
	        data: data,
	        dataType: 'json',
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          if (data.error.application.length > 0) {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application]);
	            $('html, body').scrollToElem($('#notification-message'), 100);
	          } else if (data.payload.data.status === 'success') {
	            var dataJson = JSON.parse(data.payload.data.memberDataJson);
	            AccountDetails.membershipData = dataJson;
	            if (!AccountDetails.hasError(dataJson)) {
	              COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [data.payload.data.message]);
	              COSTCO.util.updateCappJson(dataJson.caller);
	              COSTCO.util.processCappLogic();
	              // AccountDetails.initPrimaryMembershipInfoForm();
	              AccountDetails.determinePersonalInfoHandler();
	            } else {
	              $('html, body').scrollToElem($('#notification-message'), 100);
	            }
	          }
	        }
	      });
	    },
	    /**
	     * Prepare JSON data obj with only primary nickname data from the primary
	     * membership information form. Other data info is get from membershipData JSON.
	     * @return {JSONObj} data JSON object to be passed to backend service
	     */
	    preparePrimaryNicknameData: function preparePrimaryNicknameData() {
	      var data = AccountDetails.getDefaultPrimaryInfoObj();
	      data.updateSection = 'nickname';
	      data.MembershipCrmCallerInfo_nickname = AccountDetails.forms.getPrimaryInformationForm().find('input[name="MembershipCrmCallerInfo_nickname"]').val();
	      return data;
	    },
	    /**
	     * Prepare JSON data obj with only primary address data from the primary
	     * membership information form. Other data info is get from membershipData JSON.
	     * @param  {Array} avsAddresses An array of AVS addresses in JSON format,
	     *  If passed as a parameter, take presedance of the address details returned by the AVS
	     * @return {JSONObj} data JSON object to be passed to backend service
	     */
	    preparePrimaryAddressData: function preparePrimaryAddressData(avsAddresses) {
	      var data = AccountDetails.getDefaultPrimaryInfoObj();
	      var $form = AccountDetails.forms.getPrimaryInformationForm();
	      // Common data
	      data.updateSection = 'address';
	      data.MembershipCrmCallerInfo_urbanizationName = $form.find('input[name="MembershipCrmCallerInfo_urbanizationName"]').val();
	      if (avsAddresses && avsAddresses.length > 0) {
	        // If AVS obj is passed get address details from it
	        var addressObj = avsAddresses[0];
	        data.MembershipCrmCallerInfo_addressLine1 = addressObj.line1;
	        data.MembershipCrmCallerInfo_addressLine2 = addressObj.line2;
	        data.MembershipCrmCallerInfo_city = addressObj.city;
	        data.MembershipCrmCallerInfo_stateDropDown_country = addressObj.country;
	        data.MembershipCrmCallerInfo_stateDropDown_state = addressObj.state;
	        data.MembershipCrmCallerInfo_zipCode = addressObj.zip;
	      } else {
	        data.MembershipCrmCallerInfo_addressLine1 = $form.find('input[name="MembershipCrmCallerInfo_addressLine1"]').val();
	        data.MembershipCrmCallerInfo_addressLine2 = $form.find('input[name="MembershipCrmCallerInfo_addressLine2"]').val();
	        data.MembershipCrmCallerInfo_zipCode = $form.find('input[name="MembershipCrmCallerInfo_zipCode"]').val();
	        data.MembershipCrmCallerInfo_city = $form.find('select[name="MembershipCrmCallerInfo_city"]').length ? $form.find('#update-city').find(':selected').val() : $form.find('input[name="MembershipCrmCallerInfo_city"]').val();
	        data.MembershipCrmCallerInfo_stateDropDown_state = $form.find('#update-state').find(':selected').val();
	        data.MembershipCrmCallerInfo_stateDropDown_country = $form.find('input[name="MembershipCrmCallerInfo_stateDropDown_country"]').val();
	      }
	      return data;
	    },
	    /**
	     * Prepare JSON data obj with only primary phone data from the primary
	     * membership information form. Other data info is get from membershipData JSON.
	     * @return {JSONObj} data JSON object to be passed to backend service
	     */
	    preparePrimaryPhoneData: function preparePrimaryPhoneData() {
	      var data = AccountDetails.getDefaultPrimaryInfoObj();
	      data.updateSection = 'phone';
	      data.MembershipCrmCallerInfo_phone = AccountDetails.forms.getPrimaryInformationForm().find('input[name="MembershipCrmCallerInfo_phone"]').val();
	      return data;
	    },
	    /**
	     * Prepare JSON data obj with only primary mobile phone data from the
	     * primary membership information form. Other data info is get from membershipData JSON.
	     * @return {JSONObj} data JSON object to be passed to backend service
	     */
	    preparePrimaryMobilePhoneData: function preparePrimaryMobilePhoneData() {
	      var data = AccountDetails.getDefaultPrimaryInfoObj();
	      data.updateSection = 'mobilePhone';
	      data.MembershipCrmCallerInfo_mobile = AccountDetails.forms.getPrimaryInformationForm().find('input[name="MembershipCrmCallerInfo_mobile"]').val();
	      return data;
	    },
	    /**
	     * Prepare JSON data obj with only primary email data from the
	     * primary membership information form. Other data info is get from membershipData JSON.
	     * @return {JSONObj} data JSON object to be passed to backend service
	     */
	    preparePrimaryEmailData: function preparePrimaryEmailData() {
	      var data = AccountDetails.getDefaultPrimaryInfoObj();
	      data.updateSection = 'email';
	      data.MembershipCrmCallerInfo_email = AccountDetails.forms.getPrimaryInformationForm().find('input[name="MembershipCrmCallerInfo_email"]').val();
	      return data;
	    },
	    /**
	     * Prepare JSON data obj with only dob data from the primary membership
	     * information form. Other data info is get from membershipData JSON.
	     * @return {JSONObj} data JSON object to be passed to backend service
	     */
	    preparePrimaryDobData: function preparePrimaryDobData() {
	      var data = AccountDetails.getDefaultPrimaryInfoObj();
	      data.updateSection = 'dob';
	      data.MembershipCrmCallerInfo_dobEditMonth = AccountDetails.forms.getPrimaryInformationForm().find('[name=MembershipCrmCallerInfo_dobEditMonth]').val();
	      data.MembershipCrmCallerInfo_dobEditDay = AccountDetails.forms.getPrimaryInformationForm().find('[name=MembershipCrmCallerInfo_dobEditDay]').val();
	      data.MembershipCrmCallerInfo_dobEditYear = AccountDetails.forms.getPrimaryInformationForm().find('[name=MembershipCrmCallerInfo_dobEditYear]').val();
	      return data;
	    },
	    /*
	     * Creates JSON primary information data object from caller
	     * @return {JSON} JSON primary information data object
	     */
	    getDefaultPrimaryInfoObj: function getDefaultPrimaryInfoObj() {
	      var c = this.membershipData.caller;
	      var data = {};
	      data.authToken = COSTCO.Checkout.getAuthToken();
	      data.MembershipCrmCallerInfo_nickname = c.nickname.value;
	      data.MembershipCrmCallerInfo_addressLine1 = c.addressLine1.value;
	      data.MembershipCrmCallerInfo_addressLine2 = c.addressLine2.value;
	      data.MembershipCrmCallerInfo_zipCode = c.zip.value;
	      data.MembershipCrmCallerInfo_city = c.city.value;
	      data.MembershipCrmCallerInfo_stateDropDown_state = c.state.value;
	      data.MembershipCrmCallerInfo_stateDropDown_country = c.country.value;
	      data.MembershipCrmCallerInfo_urbanizationName = c.urbanizationName.value;
	      data.MembershipCrmCallerInfo_phone = c.homePhone.field1.value + c.homePhone.field2.value + c.homePhone.field3.value;
	      data.MembershipCrmCallerInfo_mobile = c.mobile.field1.value + c.mobile.field2.value + c.mobile.field3.value;
	      data.MembershipCrmCallerInfo_email = c.email.value;
	      return data;
	    },
	    /**
	     * Validates a single input if passed to function,
	     * or ALL validate-able inputs validate_inputs object.
	     * @param  {Function} callback The function to be called after successful validation.
	     * @param  {string}   rule     OPTIONAL: The specific rule to validate if we're dealing with just one input
	     * @param  {string}   $input   OPTIONAL: Input field for validation against rule provided
	     * @return {void}
	     */
	    validateFields: function validateFields(callback, rule, $input) {
	      var $form = AccountDetails.forms.getPrimaryInformationForm();
	      var validateInputs = AccountDetails.attachRulesToInputFields;
	      var rulesConfigObj = AccountDetails.inputRules();
	      COSTCO.Checkout._dynamic_validate({
	        input: $input,
	        rule: rule,
	        form: $form,
	        validate_inputs: validateInputs,
	        rules_config_obj: rulesConfigObj,
	        callback: callback
	      });
	    },
	    /**
	     * Attaches rules to address input fields
	     * @return {void}
	     */
	    attachRulesToInputFields: function attachRulesToInputFields() {
	      $('#update-line1').rules('add', AccountDetails.inputRules().addressLine1);
	      $('#update-line2').rules('add', AccountDetails.inputRules().addressLine2);
	      $('#update-city').rules('add', AccountDetails.inputRules().city);
	      $('#update-state').rules('add', AccountDetails.inputRules().stateDropDown_state);
	      $('#update-zip').rules('add', AccountDetails.inputRules().zipCode);
	    },
	    /**
	     * Defines rules object for input fields/form validation
	     * @return {void}
	     */
	    inputRules: function inputRules() {
	      var rules = {};
	      rules.email_rule = {
	        required: true,
	        singleemail: true,
	        messages: {
	          required: messages.ERR_REQUIRED_EMAIL,
	          singleemail: messages.ERR_INVALID_EMAIL_ADDRESS
	        }
	      };
	      rules.addressLine1 = {
	        maxlength: 30,
	        required: true,
	        valid_address: true,
	        messages: {
	          maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
	          required: messages.ERR_INVALID_STREET_REQUIRED,
	          valid_address: messages.ERR_INVALID_ADDRESS
	        }
	      };
	      rules.addressLine2 = {
	        maxlength: 30,
	        valid_address: true,
	        messages: {
	          maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
	          valid_address: messages.ERR_INVALID_ADDRESS
	        }
	      };
	      rules.zipCode = {
	        required: true,
	        postalCode: true,
	        minlength: 5,
	        messages: {
	          required: messages.ERR_ENTER_ZIPCODE_NEW,
	          postalCode: messages.ERR_ENTER_ZIPCODE,
	          minlength: messages.ERR_VALID_ZIPCODE
	        }
	      };
	      rules.city = {
	        required: true,
	        valid_cityState: true,
	        messages: {
	          required: messages.ERR_INVALID_CITY_REQUIRED,
	          valid_cityState: messages.ERR_INVALID_CITY_NAME
	        }
	      };
	      rules.stateDropDown_state = {
	        required: true,
	        notEqual: 'NO_STATE_TYPE_SELECTED',
	        valid_cityState: true,
	        messages: {
	          required: messages.ERR_INVALID_STATE_NAME,
	          notEqual: messages.ERR_INVALID_STATE_NAME,
	          valid_cityState: messages.ERR_INVALID_STATE_NAME
	        }
	      };
	      rules.phoneNum = {
	        phone: true,
	        required: true,
	        messages: {
	          phone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          required: messages.ERR_INVALID_PHONE_10_DIGIT
	        }
	      };
	      rules.mobilePhoneNum = {
	        phone: true,
	        messages: {
	          phone: messages.ERR_INVALID_PHONE_10_DIGIT
	        }
	      };
	      rules.month = {
	        required: false,
	        dob: true
	      };
	      rules.day = {
	        required: false,
	        dob: true
	      };
	      rules.year = {
	        required: false,
	        dob: true
	      };
	      return rules;
	    },
	    /**
	     * If the user has a date of birth, set it using the data attributes
	     * attached to each select representing the month, day, year.
	     * @return {void}
	     */
	    setDob: function setDob() {
	      var $month = $('select[name=MembershipCrmCallerInfo_dobEditMonth]');
	      var $day = $('select[name=MembershipCrmCallerInfo_dobEditDay]');
	      var $year = $('select[name=MembershipCrmCallerInfo_dobEditYear]');
	      $month.data('month') !== '' ? $month.val(parseInt($month.data('month'), 10)) : void 0;
	      $day.data('day') !== '' ? $day.val(parseInt($day.data('day'), 10)) : void 0;
	      $year.data('year') !== '' ? $year.val(parseInt($year.data('year'), 10)) : void 0;
	      // Case where the select is readonly, we just want the selected option enabled.
	      $month.add($day).add($year).find('option:selected').removeAttr('disabled');
	    },
	    /**
	     * The onclick handler for the "Renew Now" button when the user doesn't
	     * have executive tier.
	     * @return {void}
	     */
	    upsellModalRenew: function upsellModalRenew(memberType) {
	
	      var doNotCloseModalFlag = false;
	      if (isDmcPage) {
	        doNotCloseModalFlag = true;
	      }
	
	      COSTCO.dialog.modalStack({
	        title: messages.RENEW_UPGRADE_UPSELL__Membership_Renewal,
	        body: COSTCO.util.tmpl('tmpl_upgrade_membership', {}),
	        preventClose: doNotCloseModalFlag,
	        primary: messages.RENEW_UPGRADE__Upgrade,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	          COSTCO.MembershipValidation.renewMembership(memberType, false, true);
	        },
	        secondary: messages.RENEW_UPGRADE__NO,
	        secondary_event: function secondary_event() {
	          COSTCO.MembershipValidation.renewMembership(memberType, false, false);
	        },
	        close: function close() {
	          if (isDmcPage) {
	            COSTCO.MemberVerification.proceedeToDMCCheck('renewal', true);
	          } else {
	            COSTCO.dialog.close();
	          }
	        }
	      });
	    },
	    /**
	     * For the user's address in the membership information, this function sets
	     * the state value asscoiated with the CRM caller.state value. You can see
	     * it with this.membershipData.
	     * @param  {string} state The two letter state "WA", "OR", etc.
	     * @return {void}
	     */
	    setState: function setState(state) {
	      $('#update-state').val(state || $('#update-state').data('selected'));
	      // Case where the select is readonly, we just want the selected option enabled.
	      $('#update-state').find('option:selected').removeAttr('disabled');
	    },
	    /**
	     * For the user's address in the membership information, this function sets
	     * the city value associated with the CRM caller.city value. You can see
	     * it with this.membershipData.
	     * @param  {string} city
	     * @return {void}
	     */
	    setCity: function setCity(city) {
	      $('#update-city').val(city || $('#update-city').data('selected'));
	      // Case where the select is readonly, we just want the selected option enabled.
	      $('#update-city').find('option:selected').removeAttr('disabled');
	    },
	    /**
	     * Is the CRM country = US?
	     * @return {boolean}
	     */
	    isUS: function isUS() {
	      return $('[name=MembershipCrmCallerInfo_stateDropDown_country]').val() === 'US';
	    },
	    /**
	     * The validation rules for the inputs on Account Details
	     * @return {void}
	     */
	    validationRules: function validationRules() {
	      // This is the only unique rule not in membership-helper.js.addValidationMethods
	      $.validator.addMethod('postalCode', function (value, element) {
	        return !COSTCO.AccountDetails.isUS() ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
	      }, messages.ERR_ENTER_ZIPCODE);
	    },
	    /**
	     * The onclick handler for the Sign In Information section on Account
	     * Details. Switches to the editable form that the user uses to update
	     * their email.
	     * @return {void}
	     */
	    editEmail: function editEmail() {
	      $('#sign-in-verbiage').hide();
	      $('#edit-email, #email-value-container').addClass('hide');
	      $('#email-update-container').removeClass('hide');
	      $('#update-email').focus();
	    },
	    /**
	     * The onclick handler for the Membership Information section on Account
	     * Details. Displays the form#membership-number-form for submission
	     * @return {void}
	     */
	    editMembership: function editMembership() {
	      $('#edit-membership, #membership-number-value-container').addClass('hide');
	      $('#membership-update-container').removeClass('hide');
	      $('#update-membership').focus();
	    },
	
	    editLinkedMembership: function editLinkedMembership() {
	      var bypassEnabled = typeof memberValidationBypassFeatureEnabled !== "undefined" && memberValidationBypassFeatureEnabled === true;
	      if (bypassEnabled) {
	        $('[for=update-linked-membership]').addClass('hide');
	      }
	      $('#edit-linked-membership, #linked-membership-number-value-container').addClass('hide');
	      $('#linked-membership-update-container').removeClass('hide');
	      $('label[for=update-linked-membership]').removeClass('margin-bottom-0');
	      $('#update-linked-membership').focus();
	    },
	    /**
	     * The onclick handler for the Membership Information section. The personal
	     * information fields like address, phone number, etc.
	     * @return {void}
	     */
	    editInfo: function editInfo() {
	      $('#language-verbiage').hide();
	      $(this).addClass('hide'); // hide yoself
	      $($(this).data('hide')).addClass('hide');
	      $($(this).data('show')).removeClass('hide');
	      $($(this).data('input')).focus();
	      if ($(this).attr('id') === 'edit-address') {
	        if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	          AccountDetails.setCityStateForEdit();
	        } else {
	          $('#city-state').removeClass('hide');
	        }
	      }
	    },
	    /**
	     * The function to make the geocodeAPI call for the zip code and populate the city and state fields
	     * @return {void}
	     */
	    setCityStateForEdit: function setCityStateForEdit() {
	      var zipSelector = '#update-zip';
	      var isBusinessInfo = $(zipSelector).attr('name') === 'MembershipCrmBusiness_zipCode';
	      var savedAddrCity = isBusinessInfo ? $('#business-city').text() : $('#membership-city').text();
	      var savedAddrState = isBusinessInfo ? $('#business-state').text() : $('#membership-state').text();
	      var cityQuery = isBusinessInfo ? '[name=MembershipCrmBusiness_city]' : '[name=MembershipCrmCallerInfo_city]';
	      var stateQuery = isBusinessInfo ? '[name=MembershipCrmBusiness_stateDropDown_state]' : '[name=MembershipCrmCallerInfo_stateDropDown_state]';
	      if (savedAddrCity && savedAddrState) {
	        COSTCO.CAddress.geocodeApiCityState(zipSelector, cityQuery, stateQuery, savedAddrCity, savedAddrState);
	      }
	    },
	    /**
	     * The onclick handler for the "Add Account Manager" button. Shows the
	     * editable fields.
	     * @return {void}
	     */
	    addAccountManager: function addAccountManager() {
	      $(this).addClass('hide');
	      $(this.form).find('.am-editable-fields').removeClass('hide');
	      $(this.form).find('[name=member_firstname]').focus();
	    },
	    /**
	     * The onclick handler for the Household "Add Person" button. Shows the
	     * editable fields.
	     * @return {void}
	     */
	    addHousehold: function addHousehold() {
	      var $container = $(this).parents('.household-container');
	      var $verbiage = $container.next();
	      // This is necessary because of the nature of the design.
	      $container.removeClass('col-lg-4').addClass('col-lg-8');
	      $verbiage.removeClass('col-lg-offset-4');
	      $(this).addClass('hide');
	      $(this.form).find('.household-fields').removeClass('hide');
	    },
	    /**
	     * The onclick handler for the Employee Add On "Add Person" button.
	     * Shows the editable fields. users.field2 must be a employee membership no.
	     * @return {void}
	     */
	    employeeAddOn: function employeeAddOn() {
	      var $container = $(this).parents('.employee-addon-container');
	      var $verbiage = $container.next();
	      // This is necessary because of the nature of the design.
	      $container.removeClass('col-lg-4').addClass('col-lg-8');
	      $verbiage.removeClass('col-lg-offset-4');
	      $(this).addClass('hide');
	      $(this.form).find('.employeeAddOn-fields').removeClass('hide');
	    },
	    /**
	     * This is the form handler for the Sign In Information form (
	     * form#sign-in-form).
	     * @return {void}
	     */
	    signInFormHandler: function signInFormHandler() {
	      $('#sign-in-form').validate({
	        rules: {
	          MembershipSignInInformation_formEmail: {
	            singleemail: true,
	            required: true,
	            maxlength: 251
	          }
	        },
	        messages: {
	          MembershipSignInInformation_formEmail: {
	            singleemail: messages.ERR_REQUIRED_EMAIL,
	            required: messages.ERR_REQUIRED_EMAIL,
	            maxlength: messages.ERR_EMAIL_MAX_LENGTH
	          }
	        },
	        submitHandler: function submitHandler(form) {
	          var formData = AccountDetails.getData(form);
	          formData.push({
	            name: 'invalidate',
	            value: membershipHelper.isInternalInvalidated(form)
	          });
	          COSTCO.util.ajax({
	            url: '/UserRegistrationUpdateAjaxCmd',
	            type: 'POST',
	            data: formData
	          }).done(COSTCO.util.safe(function (response, textStatus, jqXHR) {
	            var data = JSON.parse(response);
	            if (!AccountDetails.hasError(data)) {
	              if (location.search.includes('PharmacyManagePatientProfileCmd')) {
	                // Redirect to pharmacy
	                window.location.href = 'Pharmacy/patient-profile?selectedTab=account_and_patient_info&SuccessMessageKey=true';
	              } else {
	                data.genericMessage = true;
	                AccountDetails.successHandler(data);
	              }
	            }
	          }), 'COSTCO.AccountDetails.signInFormHandler').fail(AccountDetails.failHandler);
	        }
	      });
	    },
	    /**
	     * This is the form handler for the Membership Number form (
	     * form#membership-number-form).
	     * @return {void}
	     * @deprecated - Using linked membership form handler
	     */
	    membershipFormHandler: function membershipFormHandler() {
	      var _this = this;
	
	      $('#membership-number-form').validate({
	        rules: {
	          membershipNumber: {
	            // Accommodate users that have pre-existing long numbers?
	            minlength: this.isVerified ? 8 : 12,
	            maxlength: this.isVerified ? 25 : 16,
	            digits: true
	          }
	        },
	        messages: {
	          membershipNumber: {
	            minlength: messages.ERR_INVALID_MEMBERSHIP_NO,
	            maxlength: messages.ERR_INVALID_MEMBERSHIP_NO,
	            digits: messages.ERR_INVALID_MEMBERSHIP_NO
	          }
	        },
	        submitHandler: function submitHandler(form) {
	          _this.updateMembershipNumber();
	        }
	      });
	    },
	    /**
	     * [description]
	     * @return {void}
	     */
	    linkedMembershipFormHandler: function linkedMembershipFormHandler() {
	      var _this2 = this;
	
	      $('#linked-membership-number-form').validate({
	        rules: {
	          membershipId: {
	            // Accommodate users that have pre-existing long numbers?
	            required: true,
	            minlength: this.isVerified ? 8 : 12,
	            maxlength: this.isVerified ? 25 : 16,
	            digits: true
	          },
	          lastName: {
	            required: {
	              depends: function depends(element) {
	                if ($("[name='linkMembershipOnlyButton']")[0] !== undefined) {
	                  $("[name='linkMembershipOnlyButton']")[0].disabled = false;
	                }
	                return $('#membershipId') !== undefined && $('#membershipId').val() !== '';
	              }
	            }
	          }
	        },
	        messages: {
	          membershipId: {
	            required: messages.ERR_INVALID_MEMBERSHIP_NO,
	            minlength: messages.ERR_INVALID_MEMBERSHIP_NO,
	            maxlength: messages.ERR_INVALID_MEMBERSHIP_NO,
	            digits: messages.ERR_INVALID_MEMBERSHIP_NO
	          },
	          lastName: {
	            required: messages.ERR_INVALID_LASTNAME
	          }
	        },
	        submitHandler: function submitHandler(form) {
	          var addMembershipButton = $("input[automation-id='addMembershipButton");
	          if (typeof addMembershipButton != 'undefined' && addMembershipButton != null) {
	            addMembershipButton.attr("data-bi-tc", "ui:Account Details | Add Membership Number Only");
	          }
	
	          _this2.clearErrors();
	          if ($(form).find('#membershipId').val() === '' && ($(form).find('#lastName').val() === '' || typeof $(form).find("#lastName").val() === "undefined")) {
	            _this2.updateMembershipNumber();
	          } else {
	            if (typeof verifyMeFlowEnabled !== 'undefined' && verifyMeFlowEnabled === true && wcs.storeId !== 'undefined' && wcs.storeId === '10302' && !($.isNumeric($("#membershipNumber").val()) && $("#membershipNumber").val().length === 12)) {
	              // verify me flow enabled and CA and membership number is invalid	    	    
	              $("#membershipNumber").parent()[0].classList.add("mdc-text-field--invalid");
	              $("#membershipNumber")[0].classList.add("highlightError");
	              $("#membershipNumber").parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_INVALID_MEMBERSHIP_NO;
	              $("#membershipNumber").parent()[0].nextElementSibling.style.display = 'block';
	            } else {
	              _this2.primaryValidation(form);
	            }
	          }
	        },
	        invalidHandler: function invalidHandler(event, validator) {
	          var errors = validator.numberOfInvalids();
	          if (errors) {
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Valid Membership Number Error" });
	          }
	        }
	      });
	    },
	
	    validateMembershipNumber: function validateMembershipNumber() {
	      var membershipNumber = $("#membershipNumber").val();
	      isValid = false;
	      if (!($.isNumeric(membershipNumber) && membershipNumber.length === 12)) {
	        $("#membershipNumber").parent()[0].classList.add("mdc-text-field--invalid");
	        $("#membershipNumber")[0].classList.add("highlightError");
	        $("#membershipNumber").parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_INVALID_MEMBERSHIP_NO;
	        $("#membershipNumber").parent()[0].nextElementSibling.style.display = 'block';
	        isValid = false;
	      } else {
	        $("#membershipNumber").parent()[0].classList.remove("mdc-text-field--invalid");
	        $("#membershipNumber")[0].classList.remove("highlightError");
	        $("#membershipNumber").parent()[0].nextElementSibling.style.display = 'none';
	        isValid = true;
	      }
	
	      return isValid;
	    },
	    /**
	     * Clears error notification box and removes validation-error class from input fields.
	     */
	    clearErrors: function clearErrors() {
	      COSTCO.util.notification.clearNotification('#form-error-placeholder');
	      $('input.validation-error').removeClass('validation-error');
	    },
	    /**
	     * This is a variant of LinkMembership.performPrimaryValidation. Where
	     * that one invokes a modal, this one is inline.
	     * @param  {[type]} form [description]
	     * @return {[type]}      [description]
	     */
	    primaryValidation: function primaryValidation(form) {
	      return COSTCO.util.ajax({
	        method: 'POST',
	        url: '/AjaxMembershipPrimaryValidationCmd',
	        dataType: 'json',
	        data: $(form).serializeArray()
	      }).done(COSTCO.util.safe(function (data, textStatus, jqXHR) {
	        if (data.payload.data.status == 'success') {
	          sessionStorage.removeItem("changeValidationFlag");
	          sessionStorage.setItem('successUpdate', true);
	          if (data.payload.data.validationCompleted) {
	            COSTCO.dialog.close();
	            var url = window.location.href;
	            var secureKeySuccessParam = COSTCO.util.getParameterByName('secureKeySuccess', url);
	            if (typeof secureKeySuccessParam !== 'undefined' && secureKeySuccessParam !== '' && secureKeySuccessParam === 'true') {
	              url = COSTCO.util.removeParam("secureKeySuccess", url);
	              window.location.href = url;
	            } else {
	              location.reload();
	            }
	          } else {
	            COSTCO.AccountDetails.secondaryValidationModal(data, textStatus, jqXHR);
	          }
	        } else if (data.error.application.length > 0) {
	          if ($("[name='linkMembershipOnlyButton']")[0] != undefined) {
	            $("[name='linkMembershipOnlyButton']")[0].disabled = false;
	          }
	          var errorCode = data.payload.data.errorCode;
	          // Expired/canceled membership: exit function and redirect to appropriate page in Create Account flow.
	          if (errorCode == 'E53') {
	            COSTCO.dialog.close();
	            if (data.payload.data.URL !== undefined) {
	              window.location.href = '/MembershipSecondaryValidationView?isReturningUser=true&URL=' + encodeURIComponent(data.payload.data.URL);
	            } else {
	              window.location.href = '/MembershipSecondaryValidationView';
	            }
	            return;
	          } else if (errorCode == 'E54') {
	            var canceledMembershipNumber = data.payload.data.membershipId ? data.payload.data.membershipId : '';
	            var membershipStatusReason = data.payload.data.membershipStatusReason ? data.payload.data.membershipStatusReason : '';
	            var membership_membershipType = data.payload.data.membership_membershipType ? data.payload.data.membership_membershipType : '';
	            var isLostOrStolenCard = data.payload.data.isLostOrStolenCard ? data.payload.data.isLostOrStolenCard : '';
	            var _url = data.payload.data.URL ? data.payload.data.URL : '';
	            $form = $('<form class="hide" action="' + COSTCO.LinkMembership.constants.CANCELED_MEMBERSHIP_VIEW + '"/>');
	            $form.append('<input type="hidden" name="canceledMembershipNumber" value="' + canceledMembershipNumber + '">');
	            $form.append('<input type="hidden" name="membershipStatusReason" value="' + membershipStatusReason + '">');
	            $form.append('<input type="hidden" name="membership_membershipType" value="' + membership_membershipType + '">');
	            $form.append('<input type="hidden" name="isLostOrStolenCard" value="' + isLostOrStolenCard + '">');
	            $form.append('<input type="hidden" name="isReturningUser" value="true">');
	            $form.append('<input type="hidden" name="URL" value="' + _url + '">');
	            $('body').append($form);
	            $form.submit();
	          } else {
	            // Override this particular error message with the post-lockdown one; Remove as redundant in post-lockdown phase.
	            if (data.payload.data.errorCode == 'E07') {
	              data.error.application = [];
	              data.error.application.push(messages._ERR_MEMBERSHIP_PRIMARY_VALIDATION_MEMBERSHIP_ID_POSTLOCKDOWN);
	            }
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, data.error.application, false, '#form-error-placeholder');
	            COSTCO.LinkMembership.markErrorFields(errorCode);
	          }
	        } else {
	          COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['Unexpected error occurred.'], false, '#form-error-placeholder');
	          console.error('Unexpected error occurred.');
	        }
	      }), 'COSTCO.AccountDetails.primaryValidation').fail(AccountDetails.failHandler);
	    },
	    /**
	     * [description]
	     * @param  {[type]} data       [description]
	     * @param  {[type]} textStatus [description]
	     * @param  {[type]} jqXHR      [description]
	     * @return {void}
	     */
	    secondaryValidationModal: function secondaryValidationModal(data, textStatus, jqXHR) {
	      COSTCO.dialog.modalStack({
	        dialogclasses: 'link-membership-modal',
	        title: messages.LINK_MEMBERSHIP_TITLE,
	        body: COSTCO.util.tmpl('tmpl_membership_validation_empty', {}),
	        primary: messages.LINK_MEMBERSHIP_BUTTON,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: linkMembership.performSecondaryValidation,
	        preventClose: false,
	        onshown: function onshown() {
	          $('.modal-header, .modal-body, .modal-footer').addClass('order-ajax');
	        },
	        onclose: function onclose() {
	          if ($("input[name='linkMembershipOnlyButton']").length > 0) {
	            $("input[name='linkMembershipOnlyButton']").attr('disabled', false);
	          }
	        }
	      });
	      checkoutHelper.ajax_update_default_done(data, textStatus, jqXHR);
	    },
	    /**
	     * This is the form handler for the Personal Information form (
	     * form#primary-information-update).
	     * @return {void}
	     */
	    personalInfoFormHandler: function personalInfoFormHandler() {
	      // If we're here we want to make any of the buttons trigger validation.
	      // Meaning we need to switch the type from button to submit.
	      $('#primary-information-update input[type=button]').attr('type', 'submit');
	      $('#primary-information-update').validate({
	        ignore: 'not:hidden',
	        rules: {
	          MembershipCrmCallerInfo_addressLine1: {
	            maxlength: 30,
	            required: !this.isEmployee,
	            valid_address: true
	          },
	          MembershipCrmCallerInfo_addressLine2: {
	            maxlength: 30,
	            valid_address: true
	          },
	          MembershipCrmCallerInfo_zipCode: {
	            required: !this.isEmployee,
	            postalCode: true,
	            minlength: 5
	          },
	          MembershipCrmCallerInfo_city: {
	            required: !this.isEmployee,
	            valid_cityState: true
	          },
	          MembershipCrmCallerInfo_stateDropDown_state: {
	            required: !this.isEmployee,
	            notEqual: 'NO_STATE_TYPE_SELECTED',
	            valid_cityState: true
	          },
	          MembershipCrmCallerInfo_email: {
	            singleemail: true
	          },
	          MembershipCrmCallerInfo_phone: {
	            phone: true,
	            required: !this.isEmployee
	          },
	          MembershipCrmCallerInfo_mobile: {
	            phone: true
	          },
	          MembershipCrmCallerInfo_dobEditMonth: {
	            required: false,
	            dob: true
	          },
	          MembershipCrmCallerInfo_dobEditDay: {
	            required: false,
	            dob: true
	          },
	          MembershipCrmCallerInfo_dobEditYear: {
	            required: false,
	            dob: true
	          }
	        },
	        messages: {
	          MembershipCrmCallerInfo_addressLine1: {
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          MembershipCrmCallerInfo_addressLine2: {
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          MembershipCrmCallerInfo_zipCode: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            postalCode: messages.ERR_ENTER_ZIPCODE,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          MembershipCrmCallerInfo_city: {
	            required: messages.ERR_INVALID_CITY_REQUIRED,
	            valid_cityState: messages.ERR_INVALID_CITY_NAME
	          },
	          MembershipCrmCallerInfo_stateDropDown_state: {
	            required: messages.ERR_INVALID_STATE_NAME,
	            notEqual: messages.ERR_INVALID_STATE_NAME,
	            valid_cityState: messages.ERR_INVALID_STATE_NAME
	          },
	          MembershipCrmCallerInfo_email: {
	            singleemail: messages.ERR_INVALID_EMAIL_ADDRESS
	          },
	          MembershipCrmCallerInfo_phone: {
	            phone: messages.ERR_INVALID_PHONE1,
	            required: messages.ERR_INVALID_PHONE1
	          },
	          MembershipCrmCallerInfo_mobile: {
	            phone: messages.ERR_INVALID_PHONE1
	          }
	        },
	        submitHandler: function submitHandler(form) {
	          if (AccountDetails.needsVerification()) {
	            membershipHelper
	            // Execute address verification on the primary information address.
	            .verifyAddresses({
	              form: '#primary-information-update',
	              primary: membershipHelper.primaryInformationSelectors
	            })
	            // Invoke the address verification modal
	            .then(function (verifyResponse) {
	              return membershipHelper.invokeMultiAVS(verifyResponse, AccountDetails.updatePrimaryInformation.bind(AccountDetails));
	            })
	            // If the service fails, still submit the form.
	            .fail(AccountDetails.updatePrimaryInformation.bind(AccountDetails));
	          } else {
	            // If we didn't edit the address fields, we dont need the verification
	            // service
	            AccountDetails.updatePrimaryInformation();
	          }
	        },
	        invalidHandler: function invalidHandler(event, validator) {
	          (validator.errorList || []).forEach(function (errorObj) {
	            var $updateContainer = $(errorObj.element).parents('div[id*=\'update-container\']');
	            if ($updateContainer.hasClass('hide')) {
	              var $container = $('.' + $updateContainer.data('parent'));
	              $container.find('a').trigger('click');
	            }
	          });
	        }
	      });
	    },
	    /**
	     * This is the form handler for the Account Manager form (
	     * form#account-manager-form).
	     * @return {void}
	     */
	    accountManagerFormHandler: function accountManagerFormHandler() {
	      var _this3 = this;
	
	      membershipHelper.addValidationMethods($('.account-manager-form'));
	      $('.account-manager-form').validate({
	        rules: {
	          member_firstname: {
	            required: true,
	            firstNameValidation: true
	          },
	          member_lastname: {
	            required: true,
	            lastNameValidation: true
	          },
	          member_number: {
	            required: true,
	            notEqual: this.membershipData.caller.cardNumber.value
	          }
	        },
	        messages: {
	          member_firstname: {
	            required: messages.ERR_INVALID_FNAME_REQUIRED,
	            firstNameValidation: messages.ERR_INVALID_FNAME
	          },
	          member_lastname: {
	            required: messages.ERR_INVALID_LNAME_REQUIRED,
	            lastNameValidation: messages.ERR_INVALID_LNAME
	          },
	          member_number: {
	            required: messages.ERR_INVALID_MEMBERSHIP_NO,
	            notEqual: messages.ERR_INVALID_MEMBERSHIP_NO
	          }
	        },
	        submitHandler: function submitHandler(form) {
	          // Clear some state if the previous operation was remove.
	          $(form).find('[name=remove_member]').val('');
	          _this3.accountManagerCRUD.call(form, 'add');
	        }
	      });
	    },
	    /**
	     * This is the form handler for the Household form (
	     * form#household-form-details).
	     * @return {void}
	     */
	    householdFormHandler: function householdFormHandler() {
	      membershipHelper.addValidationMethods($('#household-form-details'));
	      var rules = {};
	      membershipHelper.addHouseholdRules(rules, true);
	      var messages = membershipHelper.goldstar.messages();
	      $('#household-form-details').validate({
	        rules: rules,
	        messages: messages,
	        submitHandler: function submitHandler(form) {
	          var requestData = AccountDetails.getData(form);
	          // Transform this array to an object so that it can be translated..
	          requestData = COSTCO.util.objectifyArray(requestData);
	          // Translate the request properties for the backend to properly read.
	          requestData = membershipHelper.transformAffiliateHouseholdInputNames(requestData);
	          var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	          if (dayIsOptional) {
	            //dobday is optional, if empty default it to "1"
	            if (!requestData.day) {
	              requestData.day = "1";
	            }
	          }
	          requestData.authToken = COSTCO.Checkout.getAuthToken();
	          COSTCO.util.ajax({
	            url: '/MemberHouseholdAddCmd',
	            type: 'POST',
	            data: requestData
	          }).done(COSTCO.util.safe(function (response, textStatus, jqXHR) {
	            var data = JSON.parse(response);
	            if (!AccountDetails.hasError(data)) {
	              AccountDetails.successHandler(data);
	            }
	          }), 'COSTCO.AccountDetails.householdFormHandler').fail(AccountDetails.failHandler);
	        }
	      });
	    },
	    /**
	     * This is the form handler for the Employee Add On form (
	     * form#employee-addon-form).
	     * @return {void}
	     */
	    employeeAddOnFormHandler: function employeeAddOnFormHandler() {
	      if (!this.isEmployee) return;
	      var rules = membershipHelper.goldstar.rules;
	      var messages = membershipHelper.goldstar.messages();
	      membershipHelper.addValidationMethods($('#employee-addon-form'));
	      $('#employee-addon-form').validate({
	        rules: rules,
	        messages: messages,
	        submitHandler: function submitHandler(form) {
	          membershipHelper
	          // Execute address verification on the primary information address.
	          .verifyAddresses({
	            form: '#employee-addon-form',
	            primary: membershipHelper.employeeAddOnSelectors
	          })
	          // Invoke the address verification modal
	          .then(function (verifyResponse) {
	            return membershipHelper.invokeMultiAVS(verifyResponse, AccountDetails.addEmployeeAddOn.bind(AccountDetails));
	          })
	          // If the service fails, still submit the form.
	          .fail(AccountDetails.addEmployeeAddOn.bind(AccountDetails));
	        }
	      });
	    },
	    /**
	     * A generic error handler that displays "Unexpected Error" at the top
	     * of the page. Maybe the response from the server is 500, etc.
	     * @param  {[type]} jqXHR       [description]
	     * @param  {[type]} textStatus  [description]
	     * @param  {[type]} errorThrown [description]
	     * @return {void}
	     */
	    failHandler: function failHandler(jqXHR, textStatus, errorThrown) {
	      $('.order-ajax').removeClass('ajax-busy');
	      membershipHelper.handleErrors({
	        error: true,
	        errorMessages: ['Unexpected Error']
	      });
	    },
	    /**
	     * Update the Capp json and refresh the page.
	     * @param  {object} data The response data returned from the server
	     * @return {void}
	     */
	    successHandler: function successHandler(data) {
	      if (typeof data.caller !== 'undefined') {
	        COSTCO.util.safe(COSTCO.util.updateCappJson)(data.caller);
	        COSTCO.util.processCappLogic();
	      }
	      var querystring = {};
	      querystring[data.genericMessage ? 'infoUpdateSuccessGeneric' : 'infoUpdateSuccess'] = true;
	      // Refresh with parameter.
	      window.location.href = COSTCO.util.makeUrl('/AccountInformationView', querystring);
	    },
	    /**
	     * Gets an account manager from the CRM caller using a membership num.
	     * @param  {number} membershipNumber The membership number of the account
	     *  manager we're after
	     * @return {object}                  The object representing the account manager
	     */
	    getAccountManager: function getAccountManager(membershipNumber) {
	      var accountManagerObj = {};
	      (this.membershipData.caller.adminAssigned || []).forEach(function (obj) {
	        if (membershipNumber == obj.adminCardNumber) {
	          accountManagerObj = obj;
	          return;
	        }
	      });
	      return accountManagerObj;
	    },
	    /**
	     * The onchange handler for the multi membership selector for verified
	     * memberships that are an admin of at least one other account. JSP is
	     * MultiMembership.jsp
	     * @return {void}
	     */
	    multiMembershipHandler: function multiMembershipHandler() {
	      var _this4 = this;
	
	      $.cookie('CRM_ADMIN_OVERRIDE', null, {
	        path: '/'
	      });
	      COSTCO.util.safe(function () {
	        var theSelected = function theSelected(memObj) {
	          return memObj.cardNumber === $(_this4).data('membership-number').toString() && memObj.adminRole === $(_this4).data('membership-adminrole') && memObj.adminType === $(_this4).data('membership-admintype');
	        };
	
	        selectedMembership = AccountDetails.membershipData.caller.adminList.find(theSelected);
	        $.cookie('CRM_ADMIN_OVERRIDE', JSON.stringify(selectedMembership));
	        location.reload();
	      })();
	    },
	    /**
	     * Invokes the "Remove Account Manager" modal.
	     * @param  {number} membershipNumber The account manager card number
	     * @return {void}
	     */
	    removeAccountManager: function removeAccountManager(membershipNumber) {
	      var _this5 = this;
	
	      var u = COSTCO.util;
	      var accountManager = AccountDetails.getAccountManager(membershipNumber);
	      var modalBody = u.tmpl('tmpl_remove_account_manager', {
	        firstName: u.capitalize(accountManager.firstName.toLowerCase()),
	        lastName: u.capitalize(accountManager.lastName.toLowerCase())
	      });
	      $(this.form).find('[name=remove_member]').val(membershipNumber);
	      COSTCO.dialog.modalStack({
	        title: messages.ACCOUNTADMIN_REMOVE_PERSON_TITLE,
	        body: modalBody,
	        primary: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	          var form = $(_this5).parents('form');
	          form.find('[name=remove_member]').val(membershipNumber);
	          AccountDetails.accountManagerCRUD.call(form, 'remove');
	        }
	      });
	    },
	    /**
	     * Invokes the "Remove Household" modal.
	     * @return {void}
	     */
	    removeHousehold: function removeHousehold() {
	      var u = COSTCO.util;
	      var household = AccountDetails.membershipData.caller.household;
	      var modalBody = u.tmpl('tmpl_remove_household', {
	        firstName: u.capitalize(household.firstName.value.toLowerCase()),
	        lastName: u.capitalize(household.lastName.value.toLowerCase())
	      });
	      COSTCO.dialog.modalStack({
	        title: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
	        body: modalBody,
	        primary: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	          COSTCO.util.ajax({
	            url: '/MemberHouseholdRemoveCmd',
	            type: 'POST',
	            data: {
	              'authToken': COSTCO.Checkout.getAuthToken(),
	              'householdNumber': AccountDetails.membershipData.caller.household.cardNumber.value
	            }
	          }).done(COSTCO.util.safe(function (response, textStatus, jqXHR) {
	            var data = JSON.parse(response);
	            if (!AccountDetails.hasError(data)) {
	              AccountDetails.successHandler(data);
	            }
	          }), 'COSTCO.AccountDetails.removeHousehold').fail(AccountDetails.failHandler);
	        }
	      });
	    },
	    /**
	     * Invokes the "Remove Employee Add On" modal.
	     * @param  {number} membershipNumber The membershipNumber of the employee to remove
	     * @return {void}
	     */
	    removeEmployeeAddOn: function removeEmployeeAddOn(membershipNumber) {
	      var u = COSTCO.util;
	      var addOn = membershipData.caller.employeeAddOn.find(function (obj) {
	        return obj.cardNumber.value == membershipNumber;
	      });
	      var modalBody = u.tmpl('tmpl_remove_employeeAddOn', {
	        firstName: u.capitalize(addOn.firstName.value.toLowerCase()),
	        lastName: u.capitalize(addOn.lastName.value.toLowerCase())
	      });
	      COSTCO.dialog.modalStack({
	        title: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
	        body: modalBody,
	        primary: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	          COSTCO.util.ajax({
	            url: COSTCO.util.makeUrl('/MemberEmployeeRemoveAddOnCmd', {
	              addonCardNumber: membershipNumber
	            }),
	            type: 'POST'
	          }).done(COSTCO.util.safe(function (response, textStatus, jqXHR) {
	            var data = JSON.parse(response);
	            if (!AccountDetails.hasError(data)) {
	              AccountDetails.successHandler(data);
	            }
	          }), 'COSTCO.AccountDetails.removeHousehold').fail(AccountDetails.failHandler);
	        }
	      });
	    },
	    /**
	     * Compare the CRM caller data to the address form fields and see if
	     * anything changed.
	     * @param  {boolean} businessInfo - true if business Address to be verified, otherwise false
	     * @return {boolean}
	     */
	    needsVerification: function needsVerification(businessInfo) {
	      var needsVerification = false;
	      var c = this.membershipData.caller;
	      if (c.usage == 'Z030' && c.usageRole != '03') {
	        // Employee Primary/Household doesnt need verification. No address.
	        // Employee Add On does.
	        return needsVerification;
	      }
	      if (businessInfo === true) {
	        c = this.membershipData.caller.businessInfo;
	      }
	      var inputArr = $('#address-update-container').find(':input').not('input.btn').map(function () {
	        return $(this).val();
	      }).toArray();
	      [c.addressLine1.value, c.addressLine2.value, c.city.value, c.state.value, c.zip.value].forEach(function (elem) {
	        if (inputArr.indexOf(elem) === -1) {
	          // A value changed, we need address verification.
	          needsVerification = true;
	          return;
	        }
	      });
	      // If any of the CRM address values are empty, we need verification
	      if (COSTCO.util.any([c.addressLine1.value, c.city.value, c.state.value, c.zip.value], function (element) {
	        return !element;
	      })) {
	        needsVerification = true;
	      }
	      return needsVerification;
	    },
	    /**
	     * Populates the Membership Address in the Membership Information
	     * section using the address object returned from the verification
	     * process.
	     * @param  {object} addressObj The addressObj returned from verification
	     * @return {void}
	     */
	    populateAddressFields: function populateAddressFields(addressObj) {
	      $('[name=MembershipCrmCallerInfo_addressLine1]').val(addressObj.line1);
	      $('[name=MembershipCrmCallerInfo_addressLine2]').val(addressObj.line2);
	      $('[name=MembershipCrmCallerInfo_zipCode]').val(addressObj.zip);
	      $('[name=MembershipCrmCallerInfo_city]').val(addressObj.city);
	      $('[name=MembershipCrmCallerInfo_stateDropDown_state]').val(addressObj.state);
	    },
	    /**
	     * Populates the Employee Add On Address in the Additional People
	     * section using the address object returned from the verification
	     * process.
	     * @param  {object} addressObj The addressObj returned from verification
	     * @return {void}
	     */
	    populateEmployeeAddressFields: function populateEmployeeAddressFields(addressObj) {
	      $('[name=employeeAddon_addressLine1]').val(addressObj.line1);
	      $('[name=employeeAddon_addressLine2]').val(addressObj.line2);
	      $('[name=employeeAddon_zip]').val(addressObj.zip);
	      $('[name=employeeAddon_city]').val(addressObj.city);
	      $('[name=employeeAddon_state]').val(addressObj.state);
	    },
	    /**
	     *
	     * @deprecated We are now using ajax modular to submit membership information form via AccountDetails.ajaxUpdatePrimaryInformation(data);
	     *
	     * Makes the actual ajax request to update the primary information, returns
	     * a promise if it doesn't refresh the page in the case where we want to
	     * do something additional after this operation.
	     * @param  {[type]} addresses [description]
	     * @return {jQuery.Deferred} Use to chain thenables.
	     */
	    updatePrimaryInformation: function updatePrimaryInformation(addresses) {
	      if (addresses && addresses.length > 0) {
	        // Case where we returned from the verification modal with the
	        // address the user selected. Populate the address inputs so
	        // they can be serialized as part of the subsequent request to
	        // MemberPrimaryInformationUpdateCmd
	        this.populateAddressFields(addresses[0]); // We'll only have one returned.
	      }
	      return COSTCO.util.ajax({
	        url: '/MemberPrimaryInformationUpdateCmd',
	        type: 'POST',
	        data: AccountDetails.getData('#primary-information-update')
	      }).then(COSTCO.util.safe(function (response, textStatus, jqXHR) {
	        var data = JSON.parse(response);
	        AccountDetails.membershipData = data;
	        if (!AccountDetails.hasError(data)) {
	          AccountDetails.successHandler(data);
	        }
	      }), 'COSTCO.AccountDetails.updatePrimaryInformation').fail(AccountDetails.failHandler);
	    },
	    /**
	     * Makes the actual ajax request to add an Employee Add On, returns
	     * a promise if it doesn't refresh the page in the case where we want to
	     * do something additional after this operation.
	     * @param  {object} addresses addresses returned from the AVS.
	     * @return {jQuery.Deferred} Use to chain thenables.
	     */
	    addEmployeeAddOn: function addEmployeeAddOn(addresses) {
	      if (addresses && addresses.length > 0) {
	        // Case where we returned from the verification modal with the
	        // address the user selected. Populate the address inputs so
	        // they can be serialized as part of the subsequent request to
	        // MemberPrimaryInformationUpdateCmd
	        this.populateEmployeeAddressFields(addresses[0]); // We'll only have one returned.
	      }
	      return COSTCO.util.ajax({
	        url: '/MemberEmployeeAddCmd',
	        type: 'POST',
	        data: AccountDetails.getData('#employee-addon-form')
	      }).then(COSTCO.util.safe(function (response, textStatus, jqXHR) {
	        var data = JSON.parse(response);
	        AccountDetails.membershipData = data;
	        if (!AccountDetails.hasError(data)) {
	          AccountDetails.successHandler(data);
	        }
	      }), 'COSTCO.AccountDetails.addEmployee').fail(AccountDetails.failHandler);
	    },
	    /**
	     * Makes the actual ajax request to update the membership number, returns
	     * a promise if it doesn't refresh the page in the case where we want to
	     * do something additional after this operation.
	     * @return {jQuery.Deferred} Use to chain thenables.
	     */
	    updateMembershipNumber: function updateMembershipNumber() {
	      return COSTCO.util.ajax({
	        url: '/MemberMembershipInformationUpdateCmd',
	        type: 'POST',
	        data: $('#membership-number-form').serializeArray()
	      }).then(COSTCO.util.safe(function (response, textStatus, jqXHR) {
	        var data = JSON.parse(response);
	        AccountDetails.membershipData = data;
	        if (!AccountDetails.hasError(data)) {
	          if (location.search.includes('PharmacyManagePatientProfileCmd')) {
	            // Redirect to pharmacy
	            window.location.href = 'Pharmacy/patient-profile?selectedTab=account_and_patient_info&SuccessMessageKey=true';
	          } else if (typeof redirectAfterMemNumUpdate !== 'undefined') {
	            // Redirect to product page referrer. (backwards capability)
	            // redriectAfterMemNumUpdate defined in AccountDetails_Data.jsp
	            window.location.href = redirectAfterMemNumUpdate;
	          } else {
	            AccountDetails.successHandler(data);
	          }
	        }
	      }), 'COSTCO.AccountDetails.updateMembershipNumber').fail(AccountDetails.failHandler);
	    },
	    /**
	     * Makes the actual ajax request to CRUD the account manager.
	     * @param  {string} operation Add/remove
	     * @return {void}
	     */
	    accountManagerCRUD: function accountManagerCRUD(operation) {
	      $(this).find('input[name=operation]').val(operation);
	      return COSTCO.util.ajax({
	        url: '/MemberAccountAdminCmd',
	        type: 'POST',
	        data: AccountDetails.getData(this)
	      }).then(COSTCO.util.safe(function (response, textStatus, jqXHR) {
	        var data = JSON.parse(response);
	        if (!AccountDetails.hasError(data)) {
	          AccountDetails.successHandler(data);
	        }
	      }), 'COSTCO.AccountDetails.accountManagerFormHandler').fail(AccountDetails.failHandler);
	    },
	
	    /**
	     * The wrapper for the member verification modal. Pass the membership num.
	     * @return {void}
	     */
	    memberVerification: function memberVerification() {
	
	      // for debug trying to find scenario when membership does not pre-prop
	      // alert('#update-membership is: '+ $('#update-membership').val());
	      // alert('#membershipId is: '+ $('#membershipId').val());
	      // alert('#membershipNumber is: '+ $('#membershipNumber').val());
	
	      var membershipButton = $("input[automation-id='verifyMembershipButton");
	      if (typeof membershipButton != 'undefined' && membershipButton != null) {
	        membershipButton.attr("data-bi-tc", "ui:Account Details | Verify Membership");
	      }
	
	      var membershipNumber = $('#update-membership').val() || $('#membershipId').val() || $('#membershipNumber').val() || $('#memberCardNumber').val();
	      var reactAccountDetailsFlag = $('#accountDetailsReactEnabled').val();
	      if (reactAccountDetailsFlag === 'true' && typeof membershipNumber === "undefined") {
	        membershipNumber = reactObj.accountDetails.membershipId;
	      }
	      if (typeof wcs.storeId !== "undefined" && wcs.storeId === "10302") {
	        secureKeyMemberVerification.openMembershipVerificationDialog(membershipNumber);
	      } else {
	        _memberVerification.openMembershipVerificationDialog(membershipNumber);
	      }
	    },
	    /**
	    * JQuery Ajax service
	    */
	    callAjaxService: function callAjaxService(httpMethod, serviceUrl, headers, data) {
	
	      if (undefined == serviceUrl || null == serviceUrl || serviceUrl == "" || undefined == httpMethod || null == httpMethod || httpMethod == "") return null;
	
	      var serviceResponse = null;
	      $.ajax({
	        url: serviceUrl,
	        type: httpMethod,
	        dataType: 'json',
	        global: false,
	        async: false,
	        contentType: 'application/json',
	        data: undefined != data && "" != data ? JSON.stringify(data) : {},
	        headers: undefined != headers && "" != headers ? headers : {},
	        success: function success(response) {
	          console.log('response: ' + response);
	          serviceResponse = response;
	        },
	        error: function error(errorResponse) {
	          console.log(errorResponse);
	        },
	        complete: function complete(request, status) {
	          console.log('complete: ' + status);
	        }
	      });
	
	      return serviceResponse;
	    },
	    /**
	     * Method to get user JWT token
	     */
	    getUserToken: function getUserToken() {
	      var userIdToken = null;
	
	      var tokenResponse = COSTCO.AccountDetails.callAjaxService('GET', '/gettoken', null, null);
	
	      if (null != tokenResponse && tokenResponse.has_logged_in && undefined != tokenResponse.id_token) {
	        userIdToken = tokenResponse.id_token;
	      }
	      if (userIdToken == null) {
	        return null;
	      } else {
	        return userIdToken;
	      }
	    },
	    getSubFromJwt: function getSubFromJwt() {
	      var jwt = COSTCO.AccountDetails.getUserToken();
	      console.log(jwt);
	      var expired = true;
	      var jwtPayload = JSON.parse(atob(jwt.split('.')[1]));
	      console.log('Sub : ' + jwtPayload.sub);
	      return jwtPayload.sub;
	    },
	    getEmailFromJwt: function getEmailFromJwt() {
	      var jwt = COSTCO.AccountDetails.getUserToken();
	      console.log(jwt);
	      var expired = true;
	      var jwtPayload = JSON.parse(atob(jwt.split('.')[1]));
	      console.log('Email : ' + jwtPayload.email);
	      return jwtPayload.email;
	    },
	    /**
	     * Interrogates the response data from the server. If theres an error,
	     * display it at the top of the UI and return true, else return false.
	     * @param  {object} data The response from the server
	     * @return {boolean}     Was there an error?
	     */
	    hasError: function hasError(data) {
	      var hasError = false;
	      if (data.errorMessage && data.errorMessage.length > 0) {
	        membershipHelper.handleErrors({
	          error: 'true',
	          errorMessages: [data.errorMessage]
	        });
	        hasError = true;
	      } else if (data.systemMessage && data.systemMessage.length > 0) {
	        membershipHelper.handleErrors({
	          error: 'true',
	          errorMessages: [data.systemMessage]
	        });
	        hasError = true;
	      } else if (data.errorMessages && data.errorMessages.length > 0) {
	        if ($('input[name="gmpFeatureEnabled"]').val() == 'true' || $('input[name="gmpCookie"]').val() == 'true') {
	          if (data.errorMessages[0] == 'ERR_GMP_USER_ALREADY_REMOVED') {
	            data.errorMessages[0] = $('.gmpUserDeletedMessageText').text();
	          }
	        }
	        membershipHelper.handleErrors(data);
	        hasError = true;
	      }
	      return hasError;
	    },
	    /**
	     * Serializes the given form as an array of objects with each of the property
	     * values trimmed of whitespace. Used to transmit well formed data to backend.
	     * @param  {jQuery.Object} form The form to serialize into array of objects
	     * @return {array}      The array of objects.
	     */
	    getData: function getData(form) {
	      return $(form).serializeArray().map(function (obj) {
	        // Lets make sure theres no trailing whitespace.
	        obj.value = $.trim(obj.value);
	        return obj;
	      });
	    },
	    /**
	     * Function that is used for verification modal in case of DMC
	     * It redirects user to join Costco page
	     * @return {void}
	     */
	    buyMembership: function buyMembership() {
	      window.location = '/join-costco.html?COSTID=Header_Membership_TOP';
	    },
	
	    /** Membership Number Info **/
	    membershipNumberInfo: function membershipNumberInfo() {
	      var modalOptions = {
	        title: messages.RWD_MEMBERSHIP_NUMBER,
	        body: COSTCO.util.tmpl('tmpl_membership_num_modal'),
	        primary: messages.CLOSE,
	        primary_button_fullspan: false,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	        }
	      };
	      COSTCO.dialog.showAndHideModal(modalOptions);
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.AccountDetails = AccountDetails;
	  return AccountDetails;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title secure-key-member-verification.js: Sub-module of Account feature
	 * @description This module provides membership verification functionality for CA.
	 * @dependency utility.js, costcodialog.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var SecureKeyMemberVerification = {
	        init: function init() {
	            if (typeof localStorage.getItem('dmcInfo') !== 'undefined' && !$.isEmptyObject(localStorage.getItem('dmcInfo'))) {
	                console.log('Retrieving  DMC Information from Local Storage');
	                var dmcInfo = localStorage.getItem('dmcInfo').split('|');
	                if (typeof dmcInfo[0] !== 'undefined') {
	                    hashedUserId = dmcInfo[0];
	                }
	                if (typeof hashedUserId !== 'undefined' && hashedUserId !== '' && typeof $.cookie('hashedUserId') !== 'undefined' && $.cookie('hashedUserId') !== '' && $.cookie('hashedUserId') === hashedUserId) {
	                    if (typeof dmcInfo[1] !== 'undefined') {
	                        isDmcPage = dmcInfo[1];
	                    }
	                    if (typeof dmcInfo[2] !== 'undefined') {
	                        deviceId = dmcInfo[2];
	                    }
	                }
	            }
	            if (document.querySelectorAll('.mdc-text-field')[0] !== undefined) {
	                new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[0]);
	            }
	            if ($('#displaySuccessPopup').val() !== undefined || $('#displayErrorPopup').val() !== undefined) {
	                var page = $('[data-page]').data('page') || '';
	                if (page !== undefined && page === 'verify-membership') {
	                    // new verify me page
	                    if ($('#displaySuccessPopup').val() !== undefined) {
	                        this.displayErrorInModal('tmpl_membership_verify_result_secure_key', ['verify-membership', 'displaySecureKeyPopUp', 'success', 'verify-membership-dialog-verifyme']);
	                    } else {
	                        this.displayErrorInModal('tmpl_membership_verify_result_secure_key', ['verify-membership', 'displaySecureKeyPopUp', 'failed', 'verify-membership-dialog-verifyme']);
	                    }
	                } else {
	                    // account details page
	                    if ($('#displaySuccessPopup').val() !== undefined) {
	                        window.digitalDataEvents = window.digitalDataEvents || [];
	                        digitalDataEvents.push({ uimsg: "Member Verification Process | Verification Success" });
	                        this.displayErrorInModal('tmpl_membership_verify_result_secure_key', ['success', 'displaySecureKeyPopUp', 'verify-membership-dialog-verifyme']);
	                    } else {
	                        window.digitalDataEvents = window.digitalDataEvents || [];
	                        digitalDataEvents.push({ uimsg: "Member Verification Flow | Information Does Not Match Records Error" });
	                        this.displayErrorInModal('tmpl_membership_verify_result_secure_key', ['failed', 'displaySecureKeyPopUp', 'verify-membership-dialog-verifyme']);
	                    }
	                }
	            }
	        },
	
	        membershipNumber: null,
	
	        getForm: function getForm() {
	            return $('#MemberVerificationForm');
	        },
	
	        getForm1: function getForm1() {
	            return $('#MemberVerificationForm1');
	        },
	
	        onKeyUpMembershipValidation: function onKeyUpMembershipValidation() {
	            //Trigger only if validation error is visible
	            if ($('#membershipNumberToVerify').parent()[0].nextElementSibling.style.display === 'block') {
	                var membershipNumber = $('#membershipNumberToVerify').val();
	                if ($.isNumeric(membershipNumber) && membershipNumber.length === 12) {
	                    $('#membershipNumberToVerify').parent()[0].classList.remove('mdc-text-field--invalid');
	                    $('#membershipNumberToVerify')[0].classList.remove('highlightError');
	                    $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__leading').css('border-color', '');
	                    $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').css('border-color', '');
	                    $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').find('label').css('color', '');
	                    $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__trailing').css('border-color', '');
	                    $('#membershipNumberToVerify').removeProp('required');
	                    $('#membershipNumberToVerify').removeAttr('minlength');
	                    $('#membershipNumberToVerify').parent()[0].nextElementSibling.style.display = 'none';
	                }
	            }
	        },
	        validateMembershipNumber: function validateMembershipNumber() {
	            var membershipNumber = $('#membershipNumberToVerify').val();
	            isValid = false;
	            if (!($.isNumeric(membershipNumber) && membershipNumber.length === 12)) {
	                window.digitalDataEvents = window.digitalDataEvents || [];
	                digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Valid Membership Number Error" });
	                $('#membershipNumberToVerify').parent()[0].classList.add('mdc-text-field--invalid');
	                $('#membershipNumberToVerify')[0].classList.add('highlightError');
	                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__leading').attr('style', 'border-color: #d32029 !important');
	                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').css({ 'cssText': 'border-color: #d32029 !important' });
	                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').find('label').attr('style', 'color: #d32029 !important');
	                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__trailing').attr('style', 'border-color: #d32029 !important');
	                $('#membershipNumberToVerify').prop('required', true);
	                $('#membershipNumberToVerify').attr('minlength', '12');
	                $('#membershipNumberToVerify').parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_INVALID_MEMBERSHIP_NO;
	                $('#membershipNumberToVerify').parent()[0].nextElementSibling.style.display = 'block';
	                $('#membershipNumberToVerify').focus();
	                isValid = false;
	            } else {
	                $('#membershipNumberToVerify').parent()[0].classList.remove('mdc-text-field--invalid');
	                $('#membershipNumberToVerify')[0].classList.remove('highlightError');
	                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__leading').css('border-color', '');
	                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').css('border-color', '');
	                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__notch').find('label').css('color', '');
	                $('#membershipNumberToVerify').parent().find('.mdc-notched-outline__trailing').css('border-color', '');
	                $('#membershipNumberToVerify').removeProp('required');
	                $('#membershipNumberToVerify').removeAttr('minlength');
	                $('#membershipNumberToVerify').parent()[0].nextElementSibling.style.display = 'none';
	                isValid = true;
	            }
	            return isValid;
	        },
	
	        validateLastName: function validateLastName() {
	            var lastName = $.trim($('#questionLastName').val());
	            isLastNameValid = false;
	            if (lastName !== undefined && lastName !== '') {
	                $("#questionLastName").parent()[0].classList.remove("mdc-text-field--invalid");
	                $("#questionLastName")[0].classList.remove("highlightError");
	                $("#questionLastName").parent()[0].nextElementSibling.children[0].innerHTML = "";
	                $("#questionLastName").parent()[0].nextElementSibling.style.display = 'none';
	                isLastNameValid = true;
	            } else {
	                $('#questionLastName').parent()[0].classList.add('mdc-text-field--invalid');
	                $('#questionLastName')[0].classList.add('highlightError');
	                $('#questionLastName').parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_INVALID_LASTNAME;
	                $('#questionLastName').parent()[0].nextElementSibling.style.display = 'block';
	                $('#questionLastName').focus();
	                isLastNameValid = false;
	            }
	            return isLastNameValid;
	        },
	
	        validateZipCode: function validateZipCode() {
	            var zipCode = $.trim($('#questionZip').val());
	            isZipValid = false;
	            if (zipCode !== undefined && zipCode !== '' && COSTCO.util.POSTAL_CODE_REGEX_CA.test(zipCode)) {
	                $("#questionZip").parent()[0].classList.remove("mdc-text-field--invalid");
	                $("#questionZip")[0].classList.remove("highlightError");
	                $("#questionZip").parent()[0].nextElementSibling.children[0].innerHTML = "";
	                $("#questionZip").parent()[0].nextElementSibling.style.display = 'none';
	                isZipValid = true;
	            } else {
	                $('#questionZip').parent()[0].classList.add('mdc-text-field--invalid');
	                $('#questionZip')[0].classList.add('highlightError');
	                $('#questionZip').parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_ENTER_ZIPCODE;
	                $('#questionZip').parent()[0].nextElementSibling.style.display = 'block';
	                $('#questionZip').focus();
	                isZipValid = false;
	            }
	            return isZipValid;
	        },
	
	        onKeyUpLastNameValidation: function onKeyUpLastNameValidation() {
	            //Trigger only if validation error is visible
	            if ($('#questionLastName').parent()[0].nextElementSibling.style.display === 'block') {
	                var lastName = $.trim($('#questionLastName').val());
	                if (lastName !== undefined && lastName !== '') {
	                    $('#questionLastName').parent()[0].classList.remove('mdc-text-field--invalid');
	                    $('#questionLastName')[0].classList.remove('highlightError');
	                    $('#questionLastName').parent().find('.mdc-notched-outline__leading').css('border-color', '');
	                    $('#questionLastName').parent().find('.mdc-notched-outline__notch').css('border-color', '');
	                    $('#questionLastName').parent().find('.mdc-notched-outline__notch').find('label').css('color', '');
	                    $('#questionLastName').parent().find('.mdc-notched-outline__trailing').css('border-color', '');
	                    $('#questionLastName').removeProp('required');
	                    $('#questionLastName').parent()[0].nextElementSibling.style.display = 'none';
	                }
	            }
	        },
	
	        onKeyUpZipCodValidation: function onKeyUpZipCodValidation() {
	            //Trigger only if validation error is visible
	            if ($('#questionZip').parent()[0].nextElementSibling.style.display === 'block') {
	                var zipCode = $.trim($('#questionZip').val());
	                if (zipCode !== undefined && zipCode !== '' && COSTCO.util.POSTAL_CODE_REGEX_CA.test(zipCode)) {
	                    $('#questionZip').parent()[0].classList.remove('mdc-text-field--invalid');
	                    $('#questionZip')[0].classList.remove('highlightError');
	                    $('#questionZip').parent().find('.mdc-notched-outline__leading').css('border-color', '');
	                    $('#questionZip').parent().find('.mdc-notched-outline__notch').css('border-color', '');
	                    $('#questionZip').parent().find('.mdc-notched-outline__notch').find('label').css('color', '');
	                    $('#questionZip').parent().find('.mdc-notched-outline__trailing').css('border-color', '');
	                    $('#questionZip').removeProp('required');
	                    $('#questionZip').parent()[0].nextElementSibling.style.display = 'none';
	                }
	            }
	        },
	
	        validateLastNameZipCode: function validateLastNameZipCode() {
	            var lastName = $.trim($('#questionLastName').val());
	            isLastNameValid = false;
	            if (lastName !== undefined && lastName !== '') {
	                $("#questionLastName").parent()[0].classList.remove("mdc-text-field--invalid");
	                $("#questionLastName")[0].classList.remove("highlightError");
	                $("#questionLastName").parent().find(".mdc-notched-outline__leading").css('border-color', '');
	                $("#questionLastName").parent().find(".mdc-notched-outline__notch").css('border-color', '');
	                $("#questionLastName").parent().find(".mdc-notched-outline__notch").find('label').css('color', '');
	                $("#questionLastName").parent().find(".mdc-notched-outline__trailing").css('border-color', '');
	                $("#questionLastName").removeProp('required');
	                $("#questionLastName").parent()[0].nextElementSibling.children[0].innerHTML = "";
	                $("#questionLastName").parent()[0].nextElementSibling.style.display = 'none';
	                isLastNameValid = true;
	            } else {
	                window.digitalDataEvents = window.digitalDataEvents || [];
	                digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Your Last Name Error" });
	                $('#questionLastName').parent()[0].classList.add('mdc-text-field--invalid');
	                $('#questionLastName')[0].classList.add('highlightError');
	                $('#questionLastName').parent().find('.mdc-notched-outline__leading').attr('style', 'border-color: #d32029 !important');
	                $('#questionLastName').parent().find('.mdc-notched-outline__notch').css({ 'cssText': 'border-color: #d32029 !important' });
	                $('#questionLastName').parent().find('.mdc-notched-outline__notch').find('label').attr('style', 'color: #d32029 !important');
	                $('#questionLastName').parent().find('.mdc-notched-outline__trailing').attr('style', 'border-color: #d32029 !important');
	                $('#questionLastName').prop('required', true);
	                $('#questionLastName').parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_INVALID_LASTNAME;
	                $('#questionLastName').parent()[0].nextElementSibling.style.display = 'block';
	                $('#questionLastName').focus();
	                isLastNameValid = false;
	            }
	            var zipCode = $.trim($('#questionZip').val());
	            isZipValid = false;
	            if (zipCode !== undefined && zipCode !== '' && COSTCO.util.POSTAL_CODE_REGEX_CA.test(zipCode)) {
	                $("#questionZip").parent()[0].classList.remove("mdc-text-field--invalid");
	                $("#questionZip")[0].classList.remove("highlightError");
	                $("#questionZip").parent().find(".mdc-notched-outline__leading").css('border-color', '');
	                $("#questionZip").parent().find(".mdc-notched-outline__notch").css('border-color', '');
	                $("#questionZip").parent().find(".mdc-notched-outline__notch").find('label').css('color', '');
	                $("#questionZip").parent().find(".mdc-notched-outline__trailing").css('border-color', '');
	                $("#questionZip").removeProp('required');
	                $("#questionZip").parent()[0].nextElementSibling.children[0].innerHTML = "";
	                $("#questionZip").parent()[0].nextElementSibling.style.display = 'none';
	                isZipValid = true;
	            } else {
	                window.digitalDataEvents = window.digitalDataEvents || [];
	                digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter a Valid Postal Code Error" });
	                $('#questionZip').parent()[0].classList.add('mdc-text-field--invalid');
	                $('#questionZip')[0].classList.add('highlightError');
	                $('#questionZip').parent().find('.mdc-notched-outline__leading').attr('style', 'border-color: #d32029 !important');
	                $('#questionZip').parent().find('.mdc-notched-outline__notch').css({ 'cssText': 'border-color: #d32029 !important' });
	                $('#questionZip').parent().find('.mdc-notched-outline__notch').find('label').attr('style', 'color: #d32029 !important');
	                $('#questionZip').parent().find('.mdc-notched-outline__trailing').attr('style', 'border-color: #d32029 !important');
	                $('#questionZip').prop('required', true);
	                $('#questionZip').parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_ENTER_ZIPCODE;
	                $('#questionZip').parent()[0].nextElementSibling.style.display = 'block';
	                if (isLastNameValid) {
	                    $('#questionZip').focus();
	                }
	                isZipValid = false;
	            }
	            return isZipValid && isLastNameValid;
	        },
	
	        /**
	         * Submits request for membership verification steps
	         * @param  {String} urlWithParams Service URL with query string parameters appended
	         * @return {jQuery.Deferred}      The deferred object
	         */
	        submitRequest: function submitRequest(urlWithParams) {
	            var _this = this;
	
	            return COSTCO.util.ajax({
	                type: 'POST',
	                url: urlWithParams,
	                dataType: 'json',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('ApplicationID', applicationId);
	                }
	            })
	            // This returns a chainable promise.
	            .then(function (data) {
	                if (data && (data.CRM_ERROR_FRAMEWORK || data.errorMessage)) {
	                    var errorTmpl = 'tmpl_membership_verify_err_service_error_secure_key';
	                    var errorTmplData = {
	                        membershipNumber: _this.membershipNumber,
	                        error: data.errorMessage
	                    };
	                    if (data.errorMessage) {
	                        errorTmpl = 'tmpl_membership_verify_err_secure_key';
	                    }
	                    switch (data.CRM_ERROR_FRAMEWORK) {
	                        case 'ERROR_EXCEEDED_MAX_AUTH_ATTEMPTS':
	                            window.digitalDataEvents = window.digitalDataEvents || [];
	                            digitalDataEvents.push({ uimsg: "Member Verification Flow | Exceeded Number of Attempts Error" });
	                            errorTmpl = 'tmpl_membership_verify_err_max_retries_reached_secure_key';
	                            break;
	                        case 'ERROR_PRESCREEN_ATTEMPT_FAILED':
	                            switch (data.CRM_MEMBER_TYPE) {
	                                case 'E':
	                                    errorTmpl = 'tmpl_membership_verify_err_employee_membership_secure_key';
	                                    break;
	                                case 'T':
	                                    errorTmpl = 'tmpl_membership_verify_err_trial_membership_secure_key';
	                                    break;
	                                case 'X':
	                                    errorTmpl = 'tmpl_membership_verify_err_inactive_membership_secure_key';
	                                    break;
	                                default:
	                                    errorTmpl = 'tmpl_membership_verify_err_try_again_secure_key';
	                            }
	                    }
	                    if (errorTmpl === 'tmpl_membership_verify_err_service_error_secure_key') {
	                        window.digitalDataEvents = window.digitalDataEvents || [];
	                        digitalDataEvents.push({ uimsg: "Member Verification Flow | Not Able to Verify Error" });
	                    }
	                    if (errorTmpl === 'tmpl_membership_verify_err_try_again_secure_key') {
	                        window.digitalDataEvents = window.digitalDataEvents || [];
	                        digitalDataEvents.push({ ui: "Member Verification Flow | Information Does Not Match Records Error" });
	                    }
	                    return $.Deferred().reject(errorTmpl, errorTmplData);
	                }
	                return $.Deferred().resolve(data);
	            }).fail(function (errorTmpl, errorTmplData) {
	                if (errorTmpl) {
	                    _this.displayErrorInModal(errorTmpl, errorTmplData);
	                }
	            });
	        },
	
	        /**
	         * Invalidates session on backend for membership verification process
	         */
	        invalidateSession: function invalidateSession() {
	            var url = this.makeVerificationUrl({
	                membershipNumber: this.membershipNumber,
	                invalidSession: true
	            });
	            this.submitRequest(url);
	        },
	
	        /**
	         * Makes URL with string params for membership account verification services
	         * @param  {Object} params  JSON obj with params to be put in URL as a query string e.g. {membershipNumber: 4444333322221111, invalidSession: true}
	         * @return {String}         URL for membership account verification services with query string paramaters
	         *                          e.g. /AjaxMembershipAccountVerificationCmd?membershipNumber=4444333322221111&invalidSession=true
	         */
	        makeVerificationUrl: function makeVerificationUrl(params) {
	            return COSTCO.util.makeUrl('/AjaxSecureKeyMembershipAccountVerificationCmd', params);
	        },
	
	        /**
	         * Opens membership verification dialog
	         * @param  {number} membershipNum Membership number
	         */
	        openMembershipVerificationDialog: function openMembershipVerificationDialog(membershipNum) {
	            var _this2 = this;
	
	            this.membershipNumber = membershipNum;
	            var doNotCloseModalFlag = false;
	
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ uimsg: "navName:DMC | Verify Your Membership | Verify Now" });
	
	            if (typeof localStorage.getItem('dmcInfo') !== 'undefined' && !$.isEmptyObject(localStorage.getItem('dmcInfo'))) {
	                console.log('Retrieving  DMC Information from Local Storage');
	                var dmcInfo = localStorage.getItem('dmcInfo').split('|');
	                if (typeof dmcInfo[0] !== 'undefined') {
	                    hashedUserId = dmcInfo[0];
	                }
	                if (typeof hashedUserId !== 'undefined' && hashedUserId !== '' && typeof $.cookie('hashedUserId') !== 'undefined' && $.cookie('hashedUserId') !== '' && $.cookie('hashedUserId') === hashedUserId) {
	                    if (typeof dmcInfo[1] !== 'undefined') {
	                        isDmcPage = dmcInfo[1];
	                    }
	                    if (typeof dmcInfo[2] !== 'undefined') {
	                        deviceId = dmcInfo[2];
	                    }
	                }
	            }
	            var settings = {
	                dialogclasses: 'verify-membership-dialog-verifyme',
	                title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	                body: COSTCO.util.tmpl('tmpl_membership_verify_number_secure_key', {
	                    membershipNumber: this.membershipNumber
	                }),
	                preventClose: doNotCloseModalFlag,
	                primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	                primary_button_style: 'rounded',
	                secondary_button_style: 'rounded',
	                secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	                primary_event: function primary_event() {
	                    if (_this2.validateMembershipNumber()) {
	                        _this2.membershipNumber = parseInt($('#membershipNumberToVerify').val());
	                        var url = _this2.makeVerificationUrl({
	                            membershipNumber: _this2.membershipNumber
	                        });
	                        _this2.submitRequest(url).then(function (data) {
	                            _this2.showPrescreen(data);
	                        });
	                    }
	                },
	                secondary_event: function secondary_event() {
	                    if (isDmcPage) {
	                        _this2.proceedeToDMCCheck('verification', false);
	                    } else {
	                        COSTCO.dialog.close();
	                    }
	                },
	                close: function close() {
	                    if (isDmcPage) {
	                        _this2.proceedeToDMCCheck('verification', false);
	                    } else {
	                        COSTCO.dialog.close();
	                    }
	                },
	                onshown: function onshown() {
	                    COSTCO.util.maskMembershipInput();
	                    if (document.querySelectorAll('.mdc-text-field')[0] !== undefined) {
	                        new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[0]);
	                    }
	                    if (document.querySelectorAll('.mdc-text-field')[1] !== undefined) {
	                        new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[1]);
	                    }
	                    $('#costcoModalBtn2').on('click', function () {
	                        $('#costcoModalBtn2').blur();
	                    });
	                }
	            };
	            COSTCO.dialog.createExtDialogBox(settings);
	        },
	
	        /**
	         * Shows prescreen (last name / zip code form)
	         * @param  {Object} data Data response returned from server
	         */
	        showPrescreen: function showPrescreen(indata) {
	            var _this3 = this;
	
	            COSTCO.dialog.updateModal({
	                title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	                body: COSTCO.util.tmpl('tmpl_membership_verify_prescreen_secure_key', {}),
	                primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	                secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	                primary_button_style: 'rounded',
	                secondary_button_style: 'rounded',
	                primary_event: function primary_event() {
	                    if (_this3.validateLastNameZipCode()) {
	                        var url = _this3.makeVerificationUrl({
	                            lastName: $('#questionLastName').val().trim(),
	                            zipCode: $('#questionZip').val().trim()
	                        });
	                        // after submit of prescreen fields to the verify command
	                        // the command will return a flag called showVerifyMeModal 
	                        // if true show the Verify Me modal
	                        // note: no API calls to Verify Me have been done yet
	                        _this3.submitRequest(url).then(function (data) {
	                            if (data) {
	                                _this3.showVerifyMeModal(data);
	                            }
	                        });
	                    }
	                },
	                secondary_event: function secondary_event() {
	                    if (isDmcPage) {
	                        _this3.proceedeToDMCCheck('verification', false);
	                    } else {
	                        COSTCO.dialog.close();
	                        _this3.invalidateSession();
	                    }
	                },
	                onshown: function onshown() {
	                    _this3.setUpKeyBindings();
	                },
	                close: function close() {
	                    if (isDmcPage) {
	                        _this3.proceedeToDMCCheck('verification', false);
	                    } else {
	                        COSTCO.dialog.close();
	                        _this3.invalidateSession();
	                    }
	                }
	            });
	            $('#questionZip').mask('S0S 0S0');
	            if (document.querySelectorAll('.mdc-text-field')[2] !== undefined) {
	                new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[2]);
	            }
	            if (document.querySelectorAll('.mdc-text-field')[1] !== undefined) {
	                new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[1]);
	            }
	            if (document.querySelectorAll('.mdc-text-field')[0] !== undefined) {
	                new mdc.textField.MDCTextField(document.querySelectorAll('.mdc-text-field')[0]);
	            }
	            COSTCO.util.focusWithoutScroll($("#costcoModal"));
	        },
	
	        /**
	         * Shows VerifyMeModal
	         * @param  {Object} data Data response returned from server
	         */
	        showVerifyMeModal: function showVerifyMeModal(data) {
	            var _this4 = this;
	
	            COSTCO.dialog.updateModal({
	                title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	                body: COSTCO.util.tmpl('tmpl_membership_verify_applink_secure_key', {}),
	                showVerifyMeModal: true,
	                showVerifyMeModalText: COSTCO.util.tmpl('tmpl_membership_continue_with_verifiedme', {}),
	                primary: '',
	                primary_button_style: 'rounded',
	                secondary_button_style: 'rounded',
	                secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	                footerText: COSTCO.util.tmpl('tmpl_membership_verify_applink_secure_key_footer'),
	                primary_event: function primary_event() {
	                    // use the fromCostcoPage for redirect if it is supplied
	                    // otherwise use the view/command name from the URL
	                    var fromPage = void 0;
	                    $.urlParam = function (name) {
	                        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
	                        if (results === null) {
	                            return null;
	                        } else {
	                            return decodeURI(results[1]) || 0;
	                        }
	                    };
	                    fromPage = $.urlParam('fromCostcoPage');
	                    if (!fromPage) {
	                        fromPage = window.location.href.split('/').pop();
	                        fromPage = fromPage.split('?').shift(1);
	                    }
	                    var url = _this4.makeVerificationUrl({
	                        continueToVerifyMe: true,
	                        fromCostcoPage: fromPage
	                    });
	                    COSTCO.dialog.updateModal({
	                        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	                        body: COSTCO.util.tmpl('tmpl_membership_verify_loading_secure_key', {}),
	                        onshown: function onshown() {
	                            COSTCO.util.maskMembershipInput();
	                        }
	                    });
	                    _this4.submitRequest(url).then(function (data) {
	                        // get applink from data that was returned by the submitRequest
	                        if (data && data.secureKeyAppLink !== undefined) {
	                            window.location.href = data.secureKeyAppLink;
	                        } else {
	                            var errorTmplData = {
	                                errorMessage: data.errorMessage
	                            };
	                            _this4.displayErrorInModal('tmpl_membership_verify_err_service_error_secure_key', errorTmplData);
	                        }
	                    });
	                },
	                secondary_event: function secondary_event() {
	                    if (isDmcPage) {
	                        _this4.proceedeToDMCCheck('verification', false);
	                    } else {
	                        COSTCO.dialog.close();
	                        _this4.invalidateSession();
	                    }
	                },
	                close: function close() {
	                    if (isDmcPage) {
	                        _this4.proceedeToDMCCheck('verification', false);
	                    } else {
	                        COSTCO.dialog.close();
	                        _this4.invalidateSession();
	                    }
	                },
	                onshown: function onshown() {
	                    _this4.setUpKeyBindings();
	                    COSTCO.util.maskMembershipInput();
	                }
	            });
	            COSTCO.util.focusWithoutScroll($("#costcoModal"));
	        },
	
	        /**
	         * Transfer request to DMC handler
	         */
	        proceedeToDMCCheck: function proceedeToDMCCheck(action, actionSuccessful) {
	            COSTCO.dialog.close();
	            var command = '/DMCCheck';
	            var queryStart = '?';
	            var queryConcat = '&';
	            var queryAction = 'action=' + action;
	            var queryDeviceId = 'deviceId=' + deviceId;
	            var queryVerified = 'verified=' + actionSuccessful;
	            var queryRenewalCanceled = 'renewCanceled=' + actionSuccessful;
	            var queryString = queryStart + queryAction + queryConcat + queryDeviceId + queryConcat;
	            if (action === 'renewal') queryString += queryRenewalCanceled;else queryString += queryVerified;
	            var newURL = window.location.protocol + '//' + window.location.host + command + queryString;
	            window.location.replace(newURL);
	        },
	
	        redirect: function redirect(data) {
	            if (data[0] === 'verify-membership') {
	                console.log('redirecting from verify flow... ');
	                if (data[2] === 'success' && !isDmcPage) {
	                    window.location.href = '/';
	                } else if (data[2] === 'success' && isDmcPage) {
	                    console.log('redirect as isDMCPage to then proceed to DMC from verification flow');
	                    if (typeof hashedUserId !== 'undefined' && hashedUserId !== '' && typeof $.cookie('hashedUserId') !== 'undefined' && $.cookie('hashedUserId') !== '' && $.cookie('hashedUserId') === hashedUserId) {
	                        localStorage.removeItem('dmcInfo');
	                    }
	                    this.proceedeToDMCCheck('verification', true);
	                } else {
	                    console.log('redirect back to verifyMembershipView interupt page');
	                    window.location.href = '/VerifyMembershipView?verifyMeBypass=false';
	                }
	            } else {
	                // adding a flag to the URL so that popup is displayed only once
	                if (data[0] === 'success') {
	                    //TODO: change to get query string and append the success into query string
	                    window.location.href = '/AccountInformationView?secureKeySuccess=true';
	                } else {
	                    //TODO: change to get query string and don't append the success into query string
	                    window.location.href = '/AccountInformationView?verifyMeBypass=false';
	                }
	            }
	        },
	
	        /**
	         * Update modal with error text from prepared template.
	         * @param  {string} errorTemplate   Template id
	         * @param  {Object} data            Data used to populate in template
	         */
	        displayErrorInModal: function displayErrorInModal(errorTemplate, data) {
	            var _this5 = this;
	
	            COSTCO.dialog.updateModal({
	                title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	                body: COSTCO.util.tmpl(errorTemplate, data),
	                primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	                primary_button_style: 'rounded',
	                dialogclasses: $.inArray('verify-membership-dialog-verifyme', data) !== -1 ? 'verify-membership-dialog-verifyme' : '',
	                primary_event: function primary_event() {
	                    COSTCO.dialog.close();
	                    if (data[1] !== undefined && data[1] === 'displaySecureKeyPopUp') {
	                        _this5.redirect(data);
	                    }
	                },
	                close: function close() {
	                    if (isDmcPage) {
	                        if (typeof hashedUserId !== 'undefined' && hashedUserId !== '' && typeof $.cookie('hashedUserId') !== 'undefined' && $.cookie('hashedUserId') !== '' && $.cookie('hashedUserId') === hashedUserId) {
	                            localStorage.removeItem('dmcInfo');
	                        }
	                        _this5.proceedeToDMCCheck('verification', false);
	                    } else {
	                        COSTCO.dialog.close();
	                        if (data[1] !== undefined && data[1] === 'displaySecureKeyPopUp') {
	                            _this5.redirect(data);
	                        }
	                    }
	                },
	                onshown: function onshown() {
	                    _this5.setUpKeyBindings();
	                    COSTCO.util.maskMembershipInput();
	                }
	            });
	            COSTCO.util.focusWithoutScroll($("#costcoModal"));
	        },
	
	        setUpKeyBindings: function setUpKeyBindings() {
	            $('#costcoModal').off('keyup');
	            $('#costcoModal').keyup(function (e) {
	                // ESCAPE key pressed
	                if (e.keyCode === 27) {
	                    $('#costcoModalBtn2').click();
	                }
	                //ENTER key pressed
	                if (e.keyCode === 13) {
	                    $('#costcoModalBtn2').click();
	                }
	            });
	        }
	
	    };
	    if (typeof window.COSTCO === 'undefined') {
	        window.COSTCO = {};
	    }
	    window.COSTCO.SecureKeyMemberVerification = SecureKeyMemberVerification;
	    return SecureKeyMemberVerification;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title link-membership.js: Sub-module for Product Details page
	 * @description This sub-module is used to handle membership validation.
	 * @dependency checkout_helper.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (checkoutHelper) {
	  var LinkMembership = {
	
	    /**
	     * Constants.
	     */
	    constants: {
	      PRIMARY_VALIDATION_FORM_ID: '#membership-primary-validation-form',
	      PRIMARY_VALIDATION_FORM_NAME: 'membershipPrimaryValidationForm',
	      SECONDARY_VALIDATION_FORM_ID: '#membership-secondary-validation-form',
	      ERROR_PLACEHOLDER_ID: '#error-placeholder',
	      AJAX_LOADER_ID: '#link-membership-loader',
	      SECONDARY_VALIDATION_VIEW: '/MembershipSecondaryValidationView',
	      CANCELED_MEMBERSHIP_VIEW: '/CanceledMembershipView'
	    },
	
	    /**
	     * Object that holds useful membership data.
	     */
	    memberData: {
	      number: ''
	    },
	
	    /**
	     * Initialization function.
	     */
	    init: function init() {
	      // 'Link Membership' button visibility is toggled in CMath.init() which executes prior to this call.
	      if ($('#link-membership, #link-membership-v2, .link-membership-btn, .link-membership-pet-meds').is(':visible')) {
	        $('#link-membership, #link-membership-v2, .link-membership-btn, #link-membership-for-price').unbind('click').click(function () {
	          COSTCO.LinkMembership.openLinkMembershipModal();
	        });
	
	        COSTCO.LinkMembership.populateMemberData();
	        COSTCO.LinkMembership.addValidationRules();
	      }
	      if ($('#ProductForm [name=purchase-membership]').is(':visible')) {
	        $('#ProductForm [name=purchase-membership]').unbind('click').click(function () {
	          COSTCO.LinkMembership.purchaseMembershipButtonClick();
	        });
	      }
	
	      console.log('Link Membership sub-module initialized.');
	    },
	
	    /**
	     * Populates this.memberData using the membershipNumber derived from
	     * wcMember persistent cookie.
	     */
	    populateMemberData: function populateMemberData() {
	      this.memberData.number = COSTCO.util.getMemberCookie().membershipNumber;
	    },
	
	    /**
	     * Mask employee start date
	     */
	    maskStartDateInput: function maskStartDateInput() {
	      $('#employeeStartDate').mask('00/00', {
	        placeholder: 'MM/YY'
	      });
	    },
	
	    /**
	     * Opens 'Link Membership for Price' dialog modal.
	     */
	
	    openLinkMembershipModal: function openLinkMembershipModal(title) {
	
	      var modalTitle = typeof title === 'undefined' ? messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceModal_Title : title;
	
	      var bypassEnabled = typeof memberValidationBypassFeatureEnabled !== "undefined" && memberValidationBypassFeatureEnabled === true;
	      var modalSettings = {
	        dialogclasses: 'link-membership-modal',
	
	        title: bypassEnabled ? messages.RWD_ADD_MEMBERSHIP_NUMBER : modalTitle,
	        body: COSTCO.util.tmpl('tmpl_membership_validation_pdp', {
	          infoText: bypassEnabled ? messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceStep1Modal_Body_InfoText_ALT : messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceStep1Modal_Body_InfoText,
	          membershipNumber: COSTCO.LinkMembership.memberData.number
	        }),
	
	        primary: bypassEnabled ? messages.RWD_ADD_MEMBERSHIP_NUMBER : messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceModal_Continue_ButtonText,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: this.performPrimaryValidation,
	        preventClose: false,
	        onshown: function onshown() {
	          $('.modal-header, .modal-body, .modal-footer').addClass('order-ajax');
	          COSTCO.util.maskMembershipInput();
	          $('.co-help').popover();
	        },
	        onclose: function onclose() {}
	      };
	
	      COSTCO.dialog.showModal(modalSettings);
	    },
	    /**
	     * Executes logic on Purchase Membership button click on PDP page.
	     */
	    purchaseMembershipButtonClick: function purchaseMembershipButtonClick() {
	      if ($.cookie('cartCountCookie') > 0) {
	        window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
	      } else {
	        window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
	      }
	    },
	    /**
	     * Validation rules for the inputs associated with creating an account.
	     */
	    addValidationRules: function addValidationRules() {
	      $.validator.addMethod('costcoMembership', function (value, element) {
	        return (/^\d{12,16}$/.test(value)
	        );
	      }, messages.ERR_INVALID_MEMBERSHIP_NO);
	    },
	
	    /**
	     * Validates the primary validation form.
	     * @param {Object} $primaryValidationForm - Form to be validated.
	     */
	    validatePrimaryValidationForm: function validatePrimaryValidationForm($primaryValidationForm) {
	      $primaryValidationForm.validate({
	
	        ignoreTitle: true,
	
	        rules: {
	          membershipId: {
	            required: true,
	            costcoMembership: true
	          },
	          lastName: {
	            // Last name is not required, i.e. for internal membership
	            // required: true,
	          }
	        },
	
	        messages: {
	          membershipId: {
	            required: messages.JS_VALID_REQUIRED,
	            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	          },
	          lastName: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        },
	        highlight: COSTCO.util.highlightWithErrorLabel,
	        unhighlight: COSTCO.util.unhighlightWithErrorLabel
	      });
	    },
	
	    /**
	     * Performs primary validation of entered data via calling Ajax Modular command.
	     */
	    performPrimaryValidation: function performPrimaryValidation() {
	      var $primaryValidationForm = $(COSTCO.LinkMembership.constants.PRIMARY_VALIDATION_FORM_ID);
	
	      COSTCO.LinkMembership.validatePrimaryValidationForm($primaryValidationForm);
	
	      if ($primaryValidationForm.valid()) {
	        COSTCO.LinkMembership.clearErrors();
	        COSTCO.LinkMembership.ajaxLoader.on();
	        checkoutHelper.ajax_update_state({
	          method: 'POST',
	          url: '/AjaxMembershipPrimaryValidationCmd',
	          data: $primaryValidationForm.serialize(),
	          dataType: 'json',
	          done: function done(data, textStatus, jqXHR, options) {
	            // COSTCO.LinkMembership.clearErrors();
	            COSTCO.LinkMembership.ajaxLoader.off();
	            if (data.payload.data.status == 'success') {
	              COSTCO.LinkMembership.memberData.number = $(COSTCO.LinkMembership.constants.PRIMARY_VALIDATION_FORM_ID + ' :input[name=membershipId]').val().trim();
	              if (data.payload.data.validationCompleted) {
	                COSTCO.dialog.close();
	                location.reload();
	              } else {
	                checkoutHelper.ajax_update_default_done(data, textStatus, jqXHR, options);
	                COSTCO.LinkMembership.maskStartDateInput();
	                $('#costcoModalBtn2').html(messages.LINK_MEMBERSHIP_BUTTON);
	                $('#costcoModalBtn2').unbind('click').bind('click', COSTCO.LinkMembership.performSecondaryValidation);
	                if ($('#error-placeholder').data('status') == 'undetermined') {
	                  $('#costcoModalBtn2').unbind('click');
	                  $('#costcoModalBtn2').prop('disabled', true);
	                }
	              }
	            } else if (data.error.application.length > 0) {
	              var errorCode = data.payload.data.errorCode;
	              // Expired Membership
	              if (errorCode == 'E53') {
	                window.location.href = LinkMembership.constants.SECONDARY_VALIDATION_VIEW;
	                // Canceled Membership
	              } else if (errorCode == 'E54') {
	                var canceledMembershipNumber = data.payload.data.membershipId ? data.payload.data.membershipId : '';
	                var membershipStatusReason = data.payload.data.membershipStatusReason ? data.payload.data.membershipStatusReason : '';
	                var membership_membershipType = data.payload.data.membership_membershipType ? data.payload.data.membership_membershipType : '';
	                var isLostOrStolenCard = data.payload.data.isLostOrStolenCard ? data.payload.data.isLostOrStolenCard : '';
	                $form = $('form[name=' + LinkMembership.constants.PRIMARY_VALIDATION_FORM_NAME + ']');
	                $form.append('<input type="hidden" name="canceledMembershipNumber" value="' + canceledMembershipNumber + '">');
	                $form.append('<input type="hidden" name="membershipStatusReason" value="' + membershipStatusReason + '">');
	                $form.append('<input type="hidden" name="membership_membershipType" value="' + membership_membershipType + '">');
	                $form.append('<input type="hidden" name="isLostOrStolenCard" value="' + isLostOrStolenCard + '">');
	                $form.append('<input type="hidden" name="isReturningUser" value="true">');
	                $form.attr('action', LinkMembership.constants.CANCELED_MEMBERSHIP_VIEW);
	                $form.submit();
	              } else {
	                // Override this particular error message with the post-lockdown one; Remove as redundant in post-lockdown phase.
	                if (errorCode == 'E07') {
	                  data.error.application = [];
	                  data.error.application.push(messages._ERR_MEMBERSHIP_PRIMARY_VALIDATION_MEMBERSHIP_ID_POSTLOCKDOWN);
	                }
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, data.error.application, false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	                COSTCO.LinkMembership.markErrorFields(errorCode);
	              }
	            } else {
	              COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['Unexpected error occurred.'], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	              console.error('Unexpected error occurred.');
	            }
	          },
	          always: function always() {
	            COSTCO.LinkMembership.ajaxLoader.off();
	            $('.order-ajax').removeClass('ajax-busy');
	          }
	        });
	      }
	    },
	
	    /**
	     * Performs secondary validation of entered data via calling Ajax Modular command.
	     */
	    performSecondaryValidation: function performSecondaryValidation() {
	      var $secondaryValidationForm = $(COSTCO.LinkMembership.constants.SECONDARY_VALIDATION_FORM_ID);
	      var action = $secondaryValidationForm.find('input[name=action]').val();
	      // If we're validating the employee primary first and last name, we set
	      // the users answer to a combination of these with a pipe.
	      if (action == 'employee_first_last_name') {
	        var firstName = $secondaryValidationForm.find('[name="usersFirstNameAnswer"]').val();
	        var lastName = $secondaryValidationForm.find('[name="usersLastNameAnswer"]').val();
	        $('#usersAnswer').val(firstName + '|' + lastName);
	      }
	
	      COSTCO.LinkMembership.ajaxLoader.on();
	
	      checkoutHelper.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxMembershipSecondaryValidationCmd',
	        data: $secondaryValidationForm.serialize(),
	        dataType: 'json',
	        done: function done(data, textStatus, jqXHR, options) {
	          COSTCO.LinkMembership.ajaxLoader.off();
	          COSTCO.LinkMembership.clearErrors();
	          if (data.status == 'success') {
	            COSTCO.dialog.close();
	            location.reload();
	          } else if (data.message) {
	            // TODO: Is there a better way to handle '&lt;' and '&gt;' from response?
	            data.message = data.message.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.message], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	          } else {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['Unexpected error occurred.'], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	            console.error('Unexpected error occurred.');
	          }
	        },
	        always: function always() {
	          COSTCO.LinkMembership.ajaxLoader.off();
	          $('.order-ajax').removeClass('ajax-busy');
	        }
	      });
	    },
	
	    /**
	     * Marks input fields with class 'validation-error' depending on error code.
	     * @param {string} errorCode
	     */
	    markErrorFields: function markErrorFields(errorCode) {
	      if (['E01', 'E02', 'E03', 'E04', 'E07', 'E51'].indexOf(errorCode) > -1) {
	        $('input[name=membershipId]').addClass('validation-error');
	      }
	
	      if (['E01', 'E02', 'E03', 'E52'].indexOf(errorCode) > -1) {
	        $('input[name=lastName]').addClass('validation-error');
	      }
	
	      if (errorCode == 'unknown') {
	        console.error('Uknnown error code.');
	      }
	
	      $('input.validation-error:first').focus();
	    },
	
	    /**
	     * Clears error notification box and removes validation-error class from input fields.
	     */
	    clearErrors: function clearErrors() {
	      COSTCO.util.notification.clearNotification(COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	      $('input.validation-error').removeClass('validation-error');
	    },
	
	    /**
	     * Turn AJAX loader on/off and disable/enable clicking appropriately.
	     */
	    ajaxLoader: {
	      on: function on() {
	        $(COSTCO.LinkMembership.constants.AJAX_LOADER_ID).show();
	        $('body').css('pointer-events', 'none');
	      },
	      off: function off() {
	        $(COSTCO.LinkMembership.constants.AJAX_LOADER_ID).hide();
	        $('body').css('pointer-events', 'auto');
	      }
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.LinkMembership = LinkMembership;
	
	  return LinkMembership;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title business-details.js: Sub-module for Account pages
	 * @description This module is used to handle business details tasks
	 * @dependency
	 * Global var on jsp:
	 * var isHousehold
	 * var isAffiliateRelated
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(25), __webpack_require__(22)], __WEBPACK_AMD_DEFINE_RESULT__ = function (membershipHelper, accountDetails, affForm) {
	  var BusinessDetails = {
	    /**
	     * Basic initial function. Sets events, form focus and fires the
	     * needed validation methods.
	     * @return {void}
	     */
	    init: function init() {
	      // membershipData  from BusinessInformation.jsp
	      accountDetails.membershipData = membershipData;
	      this.validationRules();
	      BusinessDetails.initBusinessInfo();
	      this.businessAccountManagerFormHandler();
	      // this.businessInfoFormHandler();
	    },
	    /**
	     * Initialize business information form. Needs to be invoked uppon succesfull ajax modular call of the form submition.
	     */
	    initBusinessInfo: function initBusinessInfo() {
	      membershipHelper.formWizBangs(BusinessDetails.getBusinessInfoForm());
	      accountDetails.setState();
	      if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	        accountDetails.setCity();
	      }
	      BusinessDetails.bindBusinessInfoEvents();
	      BusinessDetails.maskBusinessPhone();
	    },
	    /**
	     * Gets business information form
	     * @return {Jquery form} form
	     */
	    getBusinessInfoForm: function getBusinessInfoForm() {
	      return $('#business-information-update');
	    },
	    /**
	     * The validation rules for the inputs on Business Details
	     * "postalCode" overwritten from account-details.js because of specific State dropdown input field
	     * "phone", "singleemail", "notEqual" from membership-helper.js
	     * @return {void}
	     */
	    validationRules: function validationRules() {
	      // This rule is not in membership-helper.js and had to overwrite account-details.js because of isUS flag
	      $.validator.addMethod('postalCode', function (value, element) {
	        return !COSTCO.CAddressForm.isUS() ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
	      }, messages.ERR_ENTER_ZIPCODE);
	      membershipHelper.addValidationMethods();
	    },
	    /**
	     * Validates a single input if passed to function,
	     * or ALL validate-able inputs validate_inputs object.
	     * @param  {Function} callback The function to be called after successful validation.
	     * @param  {string}   rule     OPTIONAL: The specific rule to validate if we're dealing with just one input
	     * @param  {string}   $input   OPTIONAL: Input field for validation against rule provided
	     * @return {void}
	     */
	    validateFields: function validateFields(callback, rule, $input) {
	      var $form = BusinessDetails.getBusinessInfoForm();
	      var validate_inputs = COSTCO.BusinessDetails.attachRulesToInputFields;
	      var rules_config_obj = COSTCO.BusinessDetails.inputRules();
	      COSTCO.Checkout._dynamic_validate({
	        input: $input,
	        rule: rule,
	        form: $form,
	        validate_inputs: validate_inputs,
	        rules_config_obj: rules_config_obj,
	        callback: callback
	      });
	    },
	    /**
	     * Attaches rules to address input fields
	     * @return {void}
	     */
	    attachRulesToInputFields: function attachRulesToInputFields() {
	      $('#update-line1').rules('add', BusinessDetails.inputRules().addressLine1);
	      $('#update-line2').rules('add', BusinessDetails.inputRules().addressLine2);
	      $('#update-city').rules('add', BusinessDetails.inputRules().city);
	      $('#update-state').rules('add', BusinessDetails.inputRules().stateDropDown_state);
	      $('#update-zip').rules('add', BusinessDetails.inputRules().zipCode);
	    },
	    /**
	     * Defines rules object for input fields/form validation
	     * @return {void}
	     */
	    inputRules: function inputRules() {
	      var rules = {};
	      rules.email_rule = {
	        required: true,
	        singleemail: true,
	        messages: {
	          required: messages.ERR_REQUIRED_EMAIL,
	          singleemail: messages.ERR_INVALID_EMAIL
	        }
	      };
	      rules.addressLine1 = {
	        maxlength: 30,
	        required: true,
	        valid_address: true,
	        messages: {
	          maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
	          required: messages.ERR_INVALID_STREET_REQUIRED,
	          valid_address: messages.ERR_INVALID_ADDRESS
	        }
	      };
	      rules.addressLine2 = {
	        maxlength: 30,
	        valid_address: true,
	        messages: {
	          maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
	          valid_address: messages.ERR_INVALID_ADDRESS
	        }
	      };
	      rules.zipCode = {
	        required: true,
	        postalCode: true,
	        minlength: 5,
	        messages: {
	          required: messages.ERR_ENTER_ZIPCODE_NEW,
	          postalCode: messages.ERR_ENTER_ZIPCODE,
	          minlength: messages.ERR_VALID_ZIPCODE
	        }
	      };
	      rules.city = {
	        required: true,
	        valid_cityState: true,
	        messages: {
	          required: messages.ERR_INVALID_CITY_REQUIRED,
	          valid_cityState: messages.ERR_INVALID_CITY_NAME
	        }
	      };
	      rules.stateDropDown_state = {
	        required: true,
	        notEqual: 'NO_STATE_TYPE_SELECTED',
	        valid_cityState: true,
	        messages: {
	          required: messages.ERR_INVALID_STATE_NAME,
	          notEqual: messages.ERR_INVALID_STATE_NAME,
	          valid_cityState: messages.ERR_INVALID_STATE_NAME
	        }
	      };
	      rules.phoneNum = {
	        phone: true,
	        required: true,
	        messages: {
	          phone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          required: messages.ERR_INVALID_PHONE_10_DIGIT
	        }
	      };
	      return rules;
	    },
	    /**
	     * Update the Capp json and refresh the page.
	     * @param  {object} data The response data returned from the server
	     * @return {void}
	     */
	    sucessHandler: function sucessHandler(data) {
	      COSTCO.util.updateCappJson(data.caller);
	      COSTCO.util.processCappLogic();
	      // Refresh with parameter.
	      window.location.href = COSTCO.util.makeUrl('/BusinessDetailsView', {
	        infoUpdateSuccess: true
	      });
	    },
	    /**
	     * Form handler for the Business Account Manager form.
	     */
	    businessAccountManagerFormHandler: function businessAccountManagerFormHandler() {
	      membershipHelper.addValidationMethods($('#business-account-manager-form'));
	      $('#business-account-manager-form').validate({
	        rules: {
	          member_firstname: {
	            required: true,
	            firstNameValidation: true
	          },
	          member_lastname: {
	            required: true,
	            lastNameValidation: true
	          },
	          member_number: {
	            required: true,
	            notEqual: membershipData.caller.cardNumber.value
	          }
	        },
	        messages: {
	          member_firstname: {
	            required: messages.ERR_INVALID_FNAME_REQUIRED,
	            firstNameValidation: messages.ERR_INVALID_FNAME
	          },
	          member_lastname: {
	            required: messages.ERR_INVALID_LNAME_REQUIRED,
	            lastNameValidation: messages.ERR_INVALID_LNAME
	          },
	          member_number: {
	            required: messages.ERR_INVALID_MEMBERSHIP_NO,
	            notEqual: messages.ADMIN_MEMBER_SELF_BUSINESS
	          }
	        },
	        submitHandler: function submitHandler(form) {
	          $(form).find('[name=remove_member]').val('');
	          BusinessDetails.addOrRemoveBusinessAccountManager.call(form, 'add');
	        }
	      });
	    },
	    /**
	     * Adds or removes Business Account Manager.
	     * @param {string} operation Expected 'add' or 'remove'.
	     */
	    addOrRemoveBusinessAccountManager: function addOrRemoveBusinessAccountManager(operation) {
	      $(this).find('input[name=operation]').val(operation);
	      COSTCO.util.notification.clearNotification();
	      COSTCO.util.ajax({
	        url: '/MemberAccountAdminCmd',
	        type: 'POST',
	        data: $(this).serializeArray().map(function (obj) {
	          obj.value = $.trim(obj.value);
	          return obj;
	        })
	      }).then(COSTCO.util.safe(function (response, textStatus, jqXHR) {
	        var data = JSON.parse(response);
	        if (!accountDetails.hasError(data)) {
	          BusinessDetails.sucessHandler(data);
	        }
	      }), 'COSTCO.AccountDetails.accountManagerFormHandler').fail(accountDetails.failHandler);
	    },
	    /**
	     * Add person within household
	     */
	    addPerson: function addPerson() {
	      affForm.openAddPersonModal({
	        isBusinessDetails: true
	      });
	    },
	    /**
	     * Add household
	     */
	    addPersonWithinHousehold: function addPersonWithinHousehold(membershipNumber) {
	      var affiliate = membershipHelper.getAffiliateFromDataBeanByNumber(membershipData, membershipNumber);
	      affForm.editPerson({
	        affiliate: affiliate,
	        action: 'update',
	        addHousehold: true,
	        isBusinessDetails: true
	      });
	    },
	    /**
	     * Remove person within household
	     */
	    removePersonWithinHousehold: function removePersonWithinHousehold(affiliateMembershipNumber) {
	      var affiliate = membershipHelper.getAffByHouseholdNumber(membershipData, affiliateMembershipNumber);
	      affiliate = {
	        membershipNumber: affiliate.cardNumber.value,
	        firstName: affiliate.firstName.value,
	        lastName: affiliate.lastName.value,
	        houseHold: {
	          membershipNumber: affiliate.household.cardNumber.value,
	          lastName: affiliate.household.lastName.value,
	          firstName: affiliate.household.firstName.value
	        }
	      };
	      affForm.removePerson({
	        affiliate: affiliate,
	        isBusinessDetails: true,
	        excludeData: true,
	        action: 'remove-household'
	      });
	    },
	    /**
	     * Opens Remove Business Account Manager modal.
	     * @param {string} membershipNumber Membership number.
	     * @param {string} unformattedFullName Unformatted full name of the manager to be removed.
	     */
	    openRemoveBusinessAccountManagerModal: function openRemoveBusinessAccountManagerModal(membershipNumber, unformattedFullName) {
	      var _this = this;
	
	      COSTCO.dialog.modalStack({
	        title: messages.ACCOUNTADMIN_REMOVE_PERSON_TITLE,
	        body: COSTCO.util.tmpl('remove_business_account_manager_modal_body_tmpl', {
	          fullName: COSTCO.util.capitalize(unformattedFullName.toLowerCase())
	        }),
	        primary: messages.ACCOUNTADMIN_REMOVE_BUTTON,
	        secondary: messages.BUTTON_CANCEL,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	          var form = $(_this).parents('form');
	          form.find('[name=remove_member]').val(membershipNumber);
	          BusinessDetails.addOrRemoveBusinessAccountManager.call(form, 'remove');
	        }
	      });
	    },
	    /**
	     * Shows fields needed to add Business Account Manager.
	     */
	    showAddBusinessAccountManagerFields: function showAddBusinessAccountManagerFields() {
	      $(this).addClass('hide');
	      $(this.form).find('.add-business-account-manager-fields').removeClass('hide');
	      $(this.form).find('#business-account-manager-first-name').focus();
	    },
	    /**
	     * The method initializes the binding for business membership information form buttons
	     */
	    bindBusinessInfoEvents: function bindBusinessInfoEvents() {
	      $('#update-business-address-btn').unbind('click').click(function () {
	        BusinessDetails.validateFields(sendAddressData);
	
	        function sendAddressData() {
	          if (accountDetails.needsVerification(true)) {
	            membershipHelper
	            // Execute address verification on the primary information address.
	            .verifyAddresses({
	              form: BusinessDetails.getBusinessInfoForm().selector,
	              primary: membershipHelper.businessInformationSelectors
	            })
	            // Invoke the address verification modal
	            .then(function (verifyResponse) {
	              return membershipHelper.invokeMultiAVS(verifyResponse, function (addresses) {
	                var data = BusinessDetails.prepareBusinessAddressData(addresses);
	                BusinessDetails.ajaxUpdateBusinessInformation(data);
	              });
	            }).fail(accountDetails.failHandler);
	          } else {
	            // form is valid
	            var data = BusinessDetails.prepareBusinessAddressData();
	            BusinessDetails.ajaxUpdateBusinessInformation(data);
	          }
	        }
	      });
	      $('#update-business-phone-btn').unbind('click').click(function () {
	        BusinessDetails.validateFields(sendPhoneData, 'phoneNum', $('#update-phone'));
	
	        function sendPhoneData() {
	          var data = BusinessDetails.prepareBusinessPhoneData();
	          BusinessDetails.ajaxUpdateBusinessInformation(data);
	        }
	      });
	      $('#update-business-email-btn').unbind('click').click(function (event) {
	        BusinessDetails.validateFields(sendEmailData, 'email_rule', $('#update-membership-email'));
	
	        function sendEmailData() {
	          var data = BusinessDetails.prepareBusinessEmailData();
	          BusinessDetails.ajaxUpdateBusinessInformation(data);
	        }
	      });
	    },
	    /**
	     * Call backend using ajax modular to update business information data and corelated UI sectoin.
	     * @param  {JSON Obj} data JSON object to be passed to backend service
	     */
	    ajaxUpdateBusinessInformation: function ajaxUpdateBusinessInformation(data) {
	      COSTCO.util.notification.clearNotification();
	      COSTCO.Checkout.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxMemberBusinessInformationUpdateCmd',
	        data: data,
	        dataType: 'json',
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          if (data.error.application.length > 0) {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application]);
	          } else if (data.payload.data.status === 'success') {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [data.payload.data.message]);
	            accountDetails.membershipData = JSON.parse(data.payload.data.memberDataJson);
	            membershipData = JSON.parse(data.payload.data.memberDataJson);
	            BusinessDetails.initBusinessInfo();
	          }
	        }
	      });
	    },
	    /**
	     * Prepare JSON data obj with only business address data from the form. Other data info is get from membershipData JSON.
	     *
	     * @param  {Array of JSON objects} (Optional) avsAddresses array of JSON objects with AVS correted address
	     * @return {JSON Obj} data JSON object to be passed to backend service
	     */
	    prepareBusinessAddressData: function prepareBusinessAddressData(avsAddresses) {
	      var form = BusinessDetails.getBusinessInfoForm();
	      var data = BusinessDetails.getDefaultBusinessInfoObj();
	      // Common data
	      data.updateSection = 'address';
	      data.MembershipCrmBusiness_urbanizationName = form.find('input[name="MembershipCrmBusiness_urbanizationName"]').val();
	      if (avsAddresses && avsAddresses.length > 0) {
	        // If AVS obj is passed get address details from it
	        var addressObj = avsAddresses[0];
	        data.MembershipCrmBusiness_addressLine1 = addressObj.line1;
	        data.MembershipCrmBusiness_addressLine2 = addressObj.line2;
	        data.MembershipCrmBusiness_city = addressObj.city;
	        data.MembershipCrmBusiness_stateDropDown_country = addressObj.country;
	        data.MembershipCrmBusiness_stateDropDown_state = addressObj.state;
	        data.MembershipCrmBusiness_zipCode = addressObj.zip;
	      } else {
	        // Otherwise, get address data from form
	        data.MembershipCrmBusiness_addressLine1 = form.find('input[name="MembershipCrmBusiness_addressLine1"]').val();
	        data.MembershipCrmBusiness_addressLine2 = form.find('input[name="MembershipCrmBusiness_addressLine2"]').val();
	        data.MembershipCrmBusiness_city = form.find('input[name="MembershipCrmBusiness_city"]').val();
	        data.MembershipCrmBusiness_stateDropDown_country = form.find('input[name="MembershipCrmBusiness_stateDropDown_country"]').val();
	        data.MembershipCrmBusiness_stateDropDown_state = form.find('#update-state').find(':selected').val();
	        data.MembershipCrmBusiness_zipCode = form.find('input[name="MembershipCrmBusiness_zipCode"]').val();
	      }
	      return data;
	    },
	    /**
	     * Prepare JSON data obj with onlu business phone data from form. Other data info is get from membershipData JSON.
	     * @return {JSON Obj} data JSON object to be passed to backend service
	     */
	    prepareBusinessPhoneData: function prepareBusinessPhoneData() {
	      var data = BusinessDetails.getDefaultBusinessInfoObj();
	      data.updateSection = 'phone';
	      data.MembershipCrmBusiness_phone = BusinessDetails.getBusinessInfoForm().find('input[name="MembershipCrmBusiness_phone"]').val();
	      return data;
	    },
	    /**
	     * Prepare JSON data obj with onlu business email data from form. Other data info is get from membershipData JSON.
	     * @return {JSON Obj} data JSON object to be passed to backend service
	     */
	    prepareBusinessEmailData: function prepareBusinessEmailData() {
	      var data = BusinessDetails.getDefaultBusinessInfoObj();
	      data.updateSection = 'email';
	      data.MembershipCrmBusiness_email = BusinessDetails.getBusinessInfoForm().find('input[name="MembershipCrmBusiness_email"]').val();
	      return data;
	    },
	    /**
	     * Creates JSON business information data object from caller
	     * @return {JSON} JSON business information data object
	     */
	    getDefaultBusinessInfoObj: function getDefaultBusinessInfoObj() {
	      var c = membershipData.caller;
	      var data = {};
	      data.authToken = COSTCO.Checkout.getAuthToken();
	      data.MembershipCrmBusiness_stateDropDown_country = c.businessInfo.country.value;
	      data.MembershipCrmBusiness_urbanizationName = c.businessInfo.urbanizationName.value;
	      data.MembershipCrmBusiness_addressLine1 = c.businessInfo.addressLine1.value;
	      data.MembershipCrmBusiness_addressLine2 = c.businessInfo.addressLine2.value;
	      data.MembershipCrmBusiness_city = c.businessInfo.city.value;
	      data.MembershipCrmBusiness_stateDropDown_state = c.businessInfo.state.value;
	      data.MembershipCrmBusiness_zipCode = c.businessInfo.zip.value;
	      data.MembershipCrmBusiness_phone = c.businessInfo.homePhone.field1.value + c.businessInfo.homePhone.field2.value + c.businessInfo.homePhone.field3.value;
	      data.MembershipCrmBusiness_email = c.businessInfo.email.value;
	      return data;
	    },
	    /**
	     * Mask business info phone number in form input field
	     */
	    maskBusinessPhone: function maskBusinessPhone() {
	      $('#update-phone').unmask().mask('000-000-0000');
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.BusinessDetails = BusinessDetails;
	  return BusinessDetails;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title add-additional-people.js: Sub-module for Add Additional People Outside Renewal page
	 * @description This module is used to handle adding additional people outside renewal.
	 * @dependency
	 * Global variables from AddAdditionalPeople_Data.jsp:
	 * var membershipData
	 * var membershipType
	 * var checkoutPage
	 * var newlyAddedAffiliatesTotal 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(22)], __WEBPACK_AMD_DEFINE_RESULT__ = function (affForm) {
	
	  var AddAdditionalPeople = {
	
	    /**
	     * Basic initial function. 
	     */
	    init: function init() {
	      this.membershipData = membershipData;
	      if (newlyAddedAffiliatesTotal > 0) {
	        this.displayInfoMessageInNotification();
	      }
	      console.log('AddAdditionalPeople module initialized.');
	    },
	
	    /**
	     * Displays info-message for this page as success notification.
	     */
	    displayInfoMessageInNotification: function displayInfoMessageInNotification() {
	      if (!$('#notification-message').hasClass('critical-notification')) {
	        COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [messages.ACCOUNT_RWD__AddAdditionalPeople_AdditionalPersonCost_InfoText]);
	      }
	    },
	
	    /**
	     * Remove a newly added affiliate.
	     * @param {number} affiliateMembershipNumber The affiliate's membership number.
	     */
	    removePerson: function removePerson(affiliateMembershipNumber) {
	      var affiliate = COSTCO.MembershipHelper.getAffiliateFromDataBeanByNumber(this.membershipData, affiliateMembershipNumber);
	      // This is necessary because affForm.removePerson is expecting an object
	      // thats tied to how the membership application "configProduct" represents
	      // that affiliate, this will normalize that.
	      affiliate = {
	        membershipNumber: affiliate.cardNumber.value,
	        firstName: affiliate.firstName.value,
	        lastName: affiliate.lastName.value,
	        newCreated: true,
	        houseHold: affiliate.household && affiliate.household.cardNumber.value ? {
	          membershipNumber: affiliate.household.cardNumber.value,
	          firstName: affiliate.household.firstName.value,
	          lastName: affiliate.household.lastName.value
	        } : undefined
	      };
	      affForm.removePerson({
	        affiliate: affiliate,
	        isOutsideRenewal: true,
	        excludeData: true,
	        action: 'remove-affiliate'
	      });
	    },
	
	    /**
	     * Add an affiliate.
	     */
	    addPerson: function addPerson() {
	      affForm.openAddPersonModal({
	        isOutsideRenewal: true
	      });
	    },
	
	    /**
	     * Add a person within household to affiliate.
	     * @param {number} membershipNumber The affiliate's membership number.
	     */
	    addPersonWithinHousehold: function addPersonWithinHousehold(membershipNumber) {
	      var affiliate = COSTCO.MembershipHelper.getAffiliateFromDataBeanByNumber(this.membershipData, membershipNumber);
	      affForm.editPerson({
	        affiliate: affiliate,
	        action: 'update',
	        addHousehold: true,
	        isOutsideRenewal: true
	      });
	    },
	
	    /**
	     * The interface to remove an affiliate's household.
	     * @param {number} affiliateMembershipNumber The affiliate's membership number.
	     */
	    removePersonHousehold: function removePersonHousehold(affiliateMembershipNumber) {
	      var affiliate = COSTCO.MembershipHelper.getAffiliateFromDataBeanByNumber(this.membershipData, affiliateMembershipNumber);
	      // This is necessary because affForm.removePerson is expecting an object
	      // thats tied to how the membership application "configProduct" represents
	      // that affiliate, this will normalize that.
	      affiliate = {
	        membershipNumber: affiliate.cardNumber.value,
	        firstName: affiliate.firstName.value,
	        lastName: affiliate.lastName.value,
	        newCreated: false,
	        houseHold: {
	          membershipNumber: affiliate.household.cardNumber.value,
	          firstName: affiliate.household.firstName.value,
	          lastName: affiliate.household.lastName.value
	        }
	      };
	      affForm.removePerson({
	        affiliate: affiliate,
	        isOutsideRenewal: true,
	        excludeData: true,
	        action: 'remove-household'
	      });
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.AddAdditionalPeople = AddAdditionalPeople;
	
	  return AddAdditionalPeople;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title membership-number.js: Sub-module of Account feature
	 * @description This module provides validation and utilities regarding membership number
	 * @dependency utility.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var MembershipNumber = {
	    init: function init() {
	      this.tiresHomeUrl = 'https://tires.costco.com';
	    },
	
	    membershipNumberUpdateCmd: '/AjaxMembershipNumberUpdateCmd',
	    /**
	     * This is used by the Add Membership Modal window
	     * to build a modal and add / validate a membership
	     * to a user's account.
	     * @return {[void]}
	     */
	    start: function start() {
	      $('#membershipNumberVerifyError').hide();
	      var cancelButton = COSTCO.AddMembershipNumberStatic.CANCEL;
	      var continueButton = COSTCO.AddMembershipNumberStatic.CONTINUE;
	      $('#addMemberNumber').dialog({
	        title: COSTCO.AddMembershipNumberStatic.ADDMEMBERSHIPNUMBER_Title,
	        show: {
	          effect: 'fade',
	          duration: 500
	        },
	        hide: {
	          effect: 'fade',
	          duration: 500
	        },
	        resizable: false,
	        minHeight: 'auto',
	        width: 500,
	        draggable: false,
	        position: 'center',
	        modal: true,
	        buttons: [{
	          'text': cancelButton,
	          'class': 'rl_modalCancelButton',
	          'click': function click() {
	            $(this).dialog('close');
	          }
	        }, {
	          'text': continueButton,
	          'class': 'rl_modalButton',
	          'click': function click() {
	            COSTCO.MembershipNumber.updateMembershipNumber();
	          }
	        }],
	        open: function open(event) {
	          $('div.ui-dialog-buttonpane').css('margin', '0 0 0 0');
	          $('div.ui-dialog-content').css('padding', '0 0 0 0');
	        }
	      });
	      $('#membershipNumberToAdd').keypress(function () {
	        $('#membershipNumberToAddError').hide();
	      });
	      $('div.ui-dialog-buttonpane').css('margin', '0 0 0 0');
	      $('div.ui-dialog-content').css('padding', '0 0 0 0');
	    },
	    submitRequest: function submitRequest(urlWithParams, successFunction) {
	      COSTCO.util.LoginTimeout.checkTimeout();
	      $.ajax({
	        type: 'POST',
	        url: urlWithParams,
	        dataType: 'json',
	        success: function success(data) {
	          COSTCO.util.LoginTimeout.updateActivity();
	          successFunction(data);
	        },
	        error: function error(x, t, m) {
	          COSTCO.util.LoginTimeout.updateActivity();
	          if (t === 'timeout') {
	            console.log('Error timeout.');
	          } else {
	            console.log('Error');
	          }
	        }
	      });
	    },
	    costcoMembershipNumber: function costcoMembershipNumber(value) {
	      return (/^\d{12,16}$/.test(value)
	      );
	    },
	    updateMembershipNumber: function updateMembershipNumber() {
	      if (COSTCO.MembershipNumber.costcoMembershipNumber($('#membershipNumberToAdd').val())) {
	        var url = COSTCO.MembershipNumber.membershipNumberUpdateCmd + '?membershipNumber=' + $('#membershipNumberToAdd').val();
	        COSTCO.MembershipNumber.submitRequest(url, COSTCO.MembershipNumber.reload);
	      } else {
	        $('#membershipNumberToAddError').show();
	      }
	    },
	    reload: function reload(data) {
	      if (data.success) {
	        COSTCO.MembershipNumber.forwardToTiresURL();
	      } else {
	        $('#membershipNumberToAddError').show();
	      }
	    },
	
	    forwardToTiresURL: function forwardToTiresURL() {
	      var url = COSTCO.util.getParameterByName('URL');
	      if (url) {
	        window.location.href = DOMPurify.sanitize(url);
	      } else {
	        window.location.href = this.tiresHomeUrl;
	      }
	    },
	
	    updateMembershipNumberForTires: function updateMembershipNumberForTires() {
	      COSTCO.MembershipNumber.updateMembershipNumber();
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.MembershipNumber = MembershipNumber;
	  return MembershipNumber;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title myorders-fsa.js: Sub-module for Account pages
	 * @description This module is used to handle my orders fsa tasks
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32)], __WEBPACK_AMD_DEFINE_RESULT__ = function (myOrdersHelper) {
	
	  var MyOrdersFSA = {
	
	    /**
	     * Initialization of the module.
	     */
	    init: function init() {
	      console.log("My Orders FSA module intialized.");
	      $('#aloadmoreleft').bind("click", this, MyOrdersFSA.showMore);
	    },
	    /**
	     * show FSA orders for selected period 
	     */
	    showFSAOrdersForPeriod: function showFSAOrdersForPeriod() {
	      var selectedPeriod = $('option:selected', "#select-period").attr('data-select-option');
	      var _selectedPeriod = jQuery.parseJSON(selectedPeriod);
	      console.log("Selected period is  " + selectedPeriod);
	      console.log("Selected period is  " + _selectedPeriod.startyear);
	
	      $('#selection').val(_selectedPeriod.index);
	      $('#fromYear').val(_selectedPeriod.startyear);
	      $('#fromMonth').val(_selectedPeriod.startmonth);
	      $('#toYear').val(_selectedPeriod.endyear);
	      $('#toMonth').val(_selectedPeriod.endmonth);
	      $('#OrderStatusTableDisplayForm').submit();
	    },
	    /**
	     * expand all rows
	     */
	    expandAll: function expandAll() {
	      if ($('div > #expend-all > a').text().trim() === messages.MY_ORDERS_FSA_EXPAND_ALL) {
	        $('[id^="heading-2-"]').each(function (i, obj) {
	          if ($(this).attr('aria-expanded') === 'false') {
	            $(this).click();
	          }
	        });
	        $('div > #expend-all > a').text(messages.MY_ORDERS_FSA_COLLAPSE_ALL);
	      } else {
	        $('[id^="heading-2-"]').each(function (i, obj) {
	          if ($(this).attr('aria-expanded') === 'true') {
	            $(this).click();
	          }
	        });
	        $('div > #expend-all > a').text(messages.MY_ORDERS_FSA_EXPAND_ALL);
	      }
	    },
	    /**
	     * show more FSA orders
	     */
	    showMore: function showMore(e) {
	      if (!curPage) {
	        curPage = 0;
	      }
	      curPage++;
	      $('.order-ajax').addClass('ajax-busy');
	
	      myOrdersHelper.ajax_update_state({
	        url: '/AjaxOrderStatusCmd' + '?URL=OrderStatusSummaryFSAView&orderType=1&defaultFSA=True&currentPage=' + curPage + '&fromYear=' + fromYear + '&fromMonth=' + fromMonth + '&toYear=' + toYear + '&toMonth=' + toMonth,
	        method: 'GET',
	        data: ''
	      });
	      if (curPage >= totPages - 1) {
	        $('#aloadmoreleft').hide();
	      }
	      e.preventDefault();
	    }
	  };
	
	  if (typeof window.COSTCO === "undefined") {
	    window.COSTCO = new Object();
	  }
	
	  window.COSTCO.MyOrdersFSA = MyOrdersFSA;
	
	  return MyOrdersFSA;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title myorders_helper.js: Feature level module
	 * @description Utility module associated with my account
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var MyOrdersHelper = {
	
			/**
	   * Make the ajax call
	   * 
	   */
			ajax_update_state: function ajax_update_state(options, page) {
				if (!options.done) options.done = COSTCO.MyOrdersHelper.ajax_update_default_done;
				COSTCO.util.ajax(options);
			},
	
			/**
	  * Success call back handler
	  * 
	  */
			ajax_update_default_done: function ajax_update_default_done(data, textStatus, jqXHR, options) {
				try {
					var response_obj = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : JSON.parse(data);
					var defaultOptions = {
						ajax_append_content: COSTCO.MyOrdersHelper.ajax_append_content,
						ajax_handle_errors: COSTCO.MyOrdersHelper.ajax_handle_errors,
						ajax_update_post_done: function ajax_update_post_done() {},
						error_container: '',
						scrollToError: true
					};
					$('body').trigger('costco.ajax.content.update.start', response_obj);
					var mergedOptions = $.extend(true, {}, defaultOptions, options);
					// Inject New Html
					mergedOptions.ajax_append_content(response_obj, mergedOptions, defaultOptions);
					// Post Html Injection
					mergedOptions.ajax_update_post_done(response_obj, mergedOptions, defaultOptions);
	
					// Handle any Errors and perform cleanup
					mergedOptions.ajax_handle_errors(response_obj, mergedOptions, defaultOptions);
					$('body').trigger('costco.ajax.content.update.end', response_obj);
				} catch (e) {
					console.error(e);
				}
			},
	
			/**
	  * Append content to the end of already existing div html
	  * 
	  */
			ajax_append_content: function ajax_append_content(response_obj, mergedOptions, defaultOptions) {
				Object.keys(response_obj.payload.html).forEach(function (key) {
					var encoded_html = response_obj.payload.html[key];
					if (mergedOptions.replaceKey) {
						if (mergedOptions.replaceKey.original == key) {
							key = mergedOptions.replaceKey.replace;
						}
					}
					$('#' + key).append(COSTCO.util.get_decoded_html(encoded_html));
				});
			},
	
			/**
	  * Display errors
	  * 
	  */
			ajax_handle_errors: function ajax_handle_errors(response_obj, mergedOptions, defaultOptions) {
				$('.error').empty(); //clear any errors that may be on the page
				var error_container = mergedOptions.error_container;
				var application = response_obj.error.application || [];
				var exception = response_obj.error.exception || [];
				var error_html = "";
				if (typeof error_container === 'string') {
					error_container = $(error_container);
				}
				if (error_container == '' || error_container.length == 0) {
					$('body').trigger('costco.ajax.content.update.sucess', response_obj);
					return;
				}
				error_container.children().remove();
				if (exception.length > 0) {
					error_html += '<p>An unexpected error has occured</p>';
				}
				application.forEach(function (error_message) {
					error_html += '<p>' + error_message.replace(/''/g, "'") + '</p>';
				});
				//if there is a redirect, store the error in sessionStorage and redirect user,
				//otherwise error will show in error container
				if (response_obj.error.redirect) {
					if (typeof sessionStorage != 'undefined') {
						sessionStorage.setItem('errorMessage', error_html); //store error_html in sessionStorage to show on redirected page
					}
					document.location.href = '/' + response_obj.error.redirect;
					return;
				}
				error_container.append(error_html);
				if (mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)) {
					$('body').trigger('costco.ajax.content.update.error', response_obj);
					$('html, body').scrollTo(error_container, 100);
				}
			}
		};
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
		window.COSTCO.MyOrdersHelper = MyOrdersHelper;
		return MyOrdersHelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title membership-validation.js: Sub-module of Register User (Create Account) page
	 * @description This module provides membership validation functionality.
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var MembershipValidation = {
	
	    /**
	     * Initializes the submodule data
	     * @return void
	     */
	    init: function init() {
	      this.maskInputs();
	      this.bindEvents();
	      COSTCO.util.maskMembershipInput();
	
	      $('#AddMembershipForm').keypress(function (e) {
	        if (e.which == 13) {
	          MembershipValidation.addMembershipForm.submitForm();
	        }
	      });
	    },
	
	    /**
	     * Binds event handlers
	     * @return void
	     */
	    bindEvents: function bindEvents() {
	      $('#buy-membership-button').unbind('click').bind('click', function () {
	        if ($.cookie('cartCountCookie') > 0) {
	          window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
	        } else {
	          window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
	        }
	      });
	    },
	
	    /**
	     * Calls renew membership main logic
	     * @param  {String}  membershipType membership type
	     * @param  {Boolean} isExecutive    true | false
	     * @param  {Boolean} isUpgrade      true | false
	     * @param  {String} fromPage       source page to decide on redirection
	     * @return void
	     */
	    renewMembership: function renewMembership(memberType, isExecutive, isUpgrade, fromPage) {
	
	      var addRenewMemberhsipToCartUrl = '';
	      // Check if MembershipRenewUpgradeStatic object exists (provided externally from JSP)
	      if ((typeof MembershipRenewUpgradeStatic === 'undefined' ? 'undefined' : _typeof(MembershipRenewUpgradeStatic)) == 'object') {
	        if (memberType.toUpperCase() == 'Z010') {
	          addRenewMemberhsipToCartUrl = isExecutive || isUpgrade ? MembershipRenewUpgradeStatic.goldExecRenewAddToCart : MembershipRenewUpgradeStatic.goldBasicRenewAddToCart;
	        } else if (memberType.toUpperCase() == 'Z020') {
	          addRenewMemberhsipToCartUrl = isExecutive || isUpgrade ? MembershipRenewUpgradeStatic.bizExecRenewAddToCart : MembershipRenewUpgradeStatic.bizBasicRenewAddToCart;
	        } else {
	          console.error('Unsupported membership type');
	        }
	        if (fromPage && fromPage !== '') {
	          addRenewMemberhsipToCartUrl = addRenewMemberhsipToCartUrl + '&sourcePage=' + fromPage;
	        }
	
	        if (typeof dmcRenwalFlow != "undefined" ? dmcRenwalFlow : false) {
	          addRenewMemberhsipToCartUrl += '&dmcRenewalFlow=true&deviceId=' + deviceId;
	        }
	        this.addToCartAndRedirect(addRenewMemberhsipToCartUrl, isUpgrade);
	      } else {
	        console.error('MembershipRenewUpgradeStatic object does not exist.');
	      }
	    },
	
	    /**
	     * Calls AjaxManageShoppingCart and redirects to appropriate page
	     * @param  {String} addToCartUrl URL to call
	     * @return void
	     */
	    addToCartAndRedirect: function addToCartAndRedirect(addToCartUrl, isUpgrade) {
	      var isCartEmpty = this.isCartEmpty();
	      var requestFromPostLockdownPage = $('#membership-card-info-post-lockdown').length > 0;
	
	      if (addToCartUrl) {
	        addToCartUrl += '&unverifiedRenew=true';
	
	        if (requestFromPostLockdownPage) {
	          COSTCO.Checkout.ajax_update_state({
	            method: 'POST',
	            url: addToCartUrl,
	            dataType: 'json',
	            ajax_update_post_done: function ajax_update_post_done(data, textStatus, jqXHR, options) {
	              COSTCO.util.notification.clearNotification('#notification-message');
	              if (data.error.application.length > 0) {
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application], false, '#notification-message');
	                COSTCO.RenewMembership.revertRadioSelection(isUpgrade);
	              }
	            }
	          });
	        } else {
	          COSTCO.util.ajax({
	            type: 'POST',
	            url: addToCartUrl,
	            dataType: 'json',
	            done: function done(data) {
	              var errorObject = !$.isEmptyObject(data.orderErrMsgObj) ? data.orderErrMsgObj : !$.isEmptyObject(data.errorMessage) ? data.errorMessage : '';
	
	              if (errorObject) {
	                COSTCO.util.notification.clearNotification('#error-message-placeholder');
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [errorObject], false, '#error-message-placeholder', 'span');
	                $('.order-ajax').removeClass('ajax-busy');
	              } else {
	                if ($('#isBDAppVar').val() === 'BD') {
	                  if (isCartEmpty) {
	                    document.location.href = '/QuickMembershipCheckoutCmd?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
	                  } else {
	                    document.location.href = '/CheckoutCartView?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
	                  }
	                } else {
	                  document.location.href = '/QuickMembershipCheckoutCmd?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
	                }
	              }
	            },
	            timeout: wcs.ajaxTimeout,
	            fail: function fail(x, t, m) {
	              $('.order-ajax').removeClass('ajax-busy');
	              if (t === 'timeout') {
	                console.error('Error AJAX timeout.');
	              } else {
	                console.error('Unexpected AJAX error.');
	              }
	            }
	          });
	        }
	      } else {
	        console.error('Membership not added to cart.');
	      }
	    },
	    /**
	     * [secondaryValidationForm object for secondary validation form handling]
	     * @type {Object}
	     */
	    secondaryValidationForm: {
	
	      getForm: function getForm() {
	        return $('#SecondaryValidationForm');
	      },
	
	      inputRules: function inputRules() {
	        var rules = {};
	
	        rules.usersAnswer = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.usersFirstNameAnswer = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.usersLastNameAnswer = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.postalCode = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.employeeDate = {
	          required: true,
	          checkDate: true,
	          checkIsDateInFuture: true,
	          messages: {
	            checkDate: messages._ERR_MEMBERSHIP_SECONDARY_VALIDATION_JS_VALID_DATE,
	            required: messages.JS_VALID_REQUIRED,
	            checkIsDateInFuture: messages._ERR_MEMBERSHIP_SECONDARY_VALIDATION_JS_PAST_DATE
	          }
	        };
	
	        return rules;
	      },
	      /**
	       * validates Secondary Validation Form
	       * @return {Boolean} if form is valid or not
	       */
	      validateForm: function validateForm() {
	        var $form = MembershipValidation.secondaryValidationForm.getForm();
	        $form.validate({
	          errorPlacement: function errorPlacement(error, element) {
	            if (element.is(':radio')) {
	              error.appendTo(element.parents('.control-group'));
	            } else {
	              error.insertAfter(element);
	            }
	          }
	        });
	        $.validator.addMethod('checkDate', function (value, element) {
	          return this.optional(element) || /^(1[0-2]|0[1-9]|\d)\/(\d{2})$/.test(value);
	        });
	        $.validator.addMethod("checkIsDateInFuture", function (value, element) {
	          var isDateInFuture = false;
	          var enteredMonth = parseInt(value.split('/')[0]);
	          var enteredYear = parseInt(value.split('/')[1]);
	          var now = new Date();
	          var currentMonth = parseInt((now.getMonth() + 1).toString());
	          var currentYear = parseInt(now.getFullYear().toString().substr(-2));
	          if (enteredYear == currentYear && enteredMonth > currentMonth) {
	            isDateInFuture = true;
	          }
	          return isDateInFuture ? false : true;
	        });
	
	        var actionForm = $('#action')[0].value;
	        if (actionForm === 'primary_member_postal_code' || actionForm === 'business_postal_code') {
	          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().postalCode);
	        } else if (actionForm === 'employee_start_date') {
	          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().employeeDate);
	        } else if (actionForm === 'employee_first_last_name') {
	          $form.find('[name="usersFirstNameAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersFirstNameAnswer);
	          $form.find('[name="usersLastNameAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersLastNameAnswer);
	
	          $('#usersAnswer')[0].value = $form.find('[name="usersFirstNameAnswer"]').val() + '|' + $form.find('[name="usersLastNameAnswer"]').val();
	        } else if (actionForm === 'employee_last_name') {
	          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersAnswer);
	        }
	        return $form.valid();
	      },
	      /**
	       * Submits Secondary Validation Form
	       * @return void
	       */
	      submitForm: function submitForm() {
	        if (MembershipValidation.secondaryValidationForm.validateForm()) {
	          MembershipValidation.secondaryValidationForm.getForm().submit();
	        }
	      }
	    },
	    /**
	     * [addMembershipForm Object for Add membership Form handling]
	     * @type {Object}
	     */
	    addMembershipForm: {
	      getForm: function getForm() {
	        return $('#AddMembershipForm');
	      },
	      validateForm: function validateForm() {
	        var $form = MembershipValidation.addMembershipForm.getForm();
	
	        $.validator.addMethod('costcoMembership', function (value, element) {
	          return (/^\d{12,16}$/.test(value)
	          );
	        }, messages.ERR_INVALID_MEMBERSHIP_NO);
	
	        $form.validate({
	          rules: {
	            membershipId: {
	              required: true,
	              costcoMembership: true
	            },
	            lastName: {
	              required: true
	            }
	          },
	          messages: {
	            membershipId: {
	              required: messages.JS_VALID_REQUIRED,
	              costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	            },
	            lastName: {
	              required: messages.JS_VALID_REQUIRED
	            }
	          }
	        });
	        return $form.valid();
	      },
	      /**
	       * Submits Add Membership form
	       * @return void
	       */
	      submitForm: function submitForm() {
	        sessionStorage.removeItem("changeValidationFlag");
	        if (MembershipValidation.addMembershipForm.validateForm()) {
	          // verifyme validation
	          if (typeof verifyMeFlowEnabled !== 'undefined' && verifyMeFlowEnabled === true && wcs.storeId !== 'undefined' && wcs.storeId === '10302' && $("#membershipNumber").parent()[0] !== 'undefined' && $("#membershipNumber").parent()[0] !== undefined && (/^$/.test($('#membershipNumber').val()) || !/^\d{12,12}$/.test($('#membershipNumber').val()))) {
	            // verify me flow enabled and CA and membership number is invalid	    	    
	            $("#membershipNumber").parent()[0].classList.add("mdc-text-field--invalid");
	            $("#membershipNumber")[0].classList.add("highlightError");
	            $("#membershipNumber").parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_INVALID_MEMBERSHIP_NO;
	            $("#membershipNumber").parent()[0].nextElementSibling.style.display = 'block';
	          } else {
	            MembershipValidation.addMembershipForm.getForm().submit();
	          }
	        } else if (memberOnlyFeatureEnabled !== undefined && memberOnlyFeatureEnabled === true) {
	          $('#membershipId label.error').insertAfter($('#membershipId label.error').next());
	        }
	      }
	    },
	
	    /**
	     * Mask input fields
	     */
	    maskInputs: function maskInputs() {
	      var $form = MembershipValidation.secondaryValidationForm.getForm();
	      if ($form.length > 0) {
	        $($form).find('#employeeStartDate').mask('00/00', {
	          placeholder: 'MM/YY'
	        });
	
	        // Set initial mask input.
	        if (COSTCO.CAddressForm.isUS()) {
	          $($form).find('#postalCode').unmask().mask('00000-0000');
	        } else {
	          $($form).find('#postalCode').unmask().mask('S0S 0S0');
	        }
	
	        // Enable both CA postal-code mask and US ZIP-code mask depending on first character,
	        // as US members must be able to link membership on CA site and vice versa.
	        // CA postal-code starts with a letter, US ZIP-code starts with a digit.
	        $($form).find('#postalCode').keypress(function (event) {
	          if ($($form).find('#postalCode').val().length == 0) {
	            if (/[a-zA-Z]/.test(event.key)) {
	              $($form).find('#postalCode').unmask().mask('S0S 0S0');
	            } else if (/[0-9]/.test(event.key)) {
	              $($form).find('#postalCode').unmask().mask('00000-0000');
	            } else {
	              $($form).find('#postalCode').val('');
	              return false;
	            }
	          }
	        });
	      }
	    },
	
	    /**
	     * Checks if cart is empty.
	     * @return {Boolean}
	     *
	     */
	    isCartEmpty: function isCartEmpty() {
	      var cartEmpty = true;
	      var cartCookie = $.cookie('cartCountCookie');
	      if (cartCookie != null && cartCookie != 'undefined') {
	        if (cartCookie > 0) {
	          cartEmpty = false;
	        }
	      }
	      return cartEmpty;
	    },
	
	    /**
	     * Opens 'Upgrade Membership' dialog modal.
	     * @return {void}
	     */
	    openUpgradeMembershipModal: function openUpgradeMembershipModal(membershipType) {
	
	      var fromPage = $('#fromPage').val();
	      if (fromPage === undefined) {
	        fromPage = '';
	      }
	
	      var modalSettings = {
	        dialogclasses: '',
	        title: messages.MEMBERSHIP_VALIDATION_UpgradeMembershipModal_Title,
	        body: COSTCO.util.tmpl('tmpl_upgrade_membership', {}),
	        primary: messages.MEMBERSHIP_VALIDATION_Expired_Upgrade_Button_Text,
	        secondary: messages.MEMBERSHIP_VALIDATION_Expired_Renew_Only_Button_Text,
	        primary_event: function primary_event() {
	          COSTCO.MembershipValidation.renewMembership(membershipType, false, true, fromPage);
	          COSTCO.dialog.close();
	        },
	        secondary_event: function secondary_event() {
	          COSTCO.MembershipValidation.renewMembership(membershipType, false, false, fromPage);
	          COSTCO.dialog.close();
	        },
	        onclose: function onclose() {
	          if (typeof isDmcPage !== 'undefined' && isDmcPage) {
	            window.location = '/DMCCheck?action=renewal&renewCanceled=true';
	          }
	        },
	        onshown: function onshown() {}
	      };
	      COSTCO.dialog.showModal(modalSettings);
	    },
	
	    /**
	     * Shows last name / zip code form to validate user for editing membership info
	     * If user entered valid last name & zip code - save info as flag
	     */
	    showValidationPrescreen: function showValidationPrescreen() {
	      var settings = {};
	      if ($("#maxAttemptMemberAccountReached").val() === "false") {
	        settings = {
	          title: messages.ACCOUNT_RENEW_MEMBERSHIP_Membership_Information_Text,
	          body: COSTCO.util.tmpl("tmpl_membership_validate_prescreen", {}),
	          primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	          secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	          dialogclasses: "modal-dialog-membership verify-membership-dialog",
	          primary_button_style: "rounded",
	          secondary_button_style: "rounded",
	          primary_event: function primary_event() {
	            if (COSTCO.MemberVerification.validateZipCodeForm($("#MemberValidationForm"))) {
	              var url = COSTCO.util.makeUrl('/AjaxAccountAutoRenewMembershipValidationCmd', {
	                lastName: $('#questionLastName').val(),
	                zipCode: $('#questionZip').val()
	              });
	
	              COSTCO.MemberVerification.submitRequest(url).then(function (data) {
	                $('#questionLastName').val('');
	                $('#questionZip').val('');
	                $('#labelQuestionLastName').removeClass('active');
	                $('#labelQuestionZip').removeClass('active');
	                if (data.memberAccountRecordCheckMaxAttempsReached == 'true') {
	                  var newSettings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_locked");
	                  COSTCO.dialog.updateModal(newSettings);
	                  $("#maxAttemptMemberAccountReached").val("true");
	                } else if (data.memberAccountRecordMatch == 'true') {
	                  var _newSettings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_success");
	                  COSTCO.dialog.updateModal(_newSettings);
	                  sessionStorage.setItem("changeValidationFlag", true);
	                } else {
	                  $("#MemberValidationForm .notification").removeClass("hidden");
	                }
	              });
	            }
	          },
	          secondary_event: function secondary_event() {
	            COSTCO.dialog.close();
	          },
	          close: function close() {
	            COSTCO.dialog.close();
	          },
	          afterclose: function afterclose() {
	            $("#costcoModal").find(".modal-dialog").removeClass("modal-dialog-membership");
	            $('#costcoModalBtn2').removeClass('primary-button-v2');
	            $('.costcoModalBtn1').removeClass('secondary-button-v2');
	          },
	          onshown: function onshown() {
	            COSTCO.util.maskMembershipInput();
	          }
	        };
	      } else {
	        settings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_locked");
	      }
	      COSTCO.dialog.createExtDialogBox(settings);
	    },
	
	    /**
	     * Show different info on modal after member account check
	     * @param tmplName - template name to be loaded in modal body.
	     * @param tmplParam - parameters to be loaded for template. Default is empty.
	     */
	    updateValidationModal: function updateValidationModal(tmplName) {
	      var tmplParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return {
	        title: messages.ACCOUNT_RENEW_MEMBERSHIP_Membership_Information_Text,
	        body: COSTCO.util.tmpl(tmplName, tmplParam),
	        primary: messages.CLOSE,
	        primary_button_style: "rounded",
	        setHalfButtons: true,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	        },
	        afterclose: function afterclose() {
	          $("#costcoModal").find(".modal-dialog").removeClass("modal-dialog-membership");
	          $('#costcoModalBtn2').removeClass('primary-button-v2');
	          $('.costcoModalBtn1').removeClass('secondary-button-v2');
	        }
	      };
	    }
	  };
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.MembershipValidation = MembershipValidation;
	
	  return MembershipValidation;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title register-user.js: Sub-module for Register User (Create Account) page
	 * @description This module is used to handle registering new user account.
	 * @dependency password-strength.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (passwordStrength) {
	  var RegisterUser = {
	
	    /**
	     * Initialization function.
	     */
	    init: function init() {
	      COSTCO.util.maskMembershipInput();
	      if ($('#primary-membership-block').length != 0) {
	        this.focusInput('validation-error', 'first_name');
	      } else {
	        this.focusInput('validation-error', 'register_email1');
	      }
	      this.activatePopovers('co-help');
	      this.activatePopovers('tooltip-without-question-icon');
	      this.validationRules();
	      this.validateForm('RegisterForm');
	      sessionStorage.removeItem("changeValidationFlag");
	      passwordStrength.init();
	
	      $('#buy-membership-button').unbind('click').bind('click', function () {
	        if ($.cookie('cartCountCookie') > 0) {
	          window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
	        } else {
	          window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
	        }
	      });
	
	      console.log('Register User sub-module initialized.');
	    },
	    /**
	     * Focuses the first input field of a given class. If there is no input element with given class,
	     * focus on default input field with given id.
	     * @param {string} inputClass - HTML class attribute of the input field to be focused.
	     * @param {string} defaultInputId - HTML it attribute of the input field to be focused if class does not exist.
	     * @return {void}
	     */
	    focusInput: function focusInput(inputClass, defaultInputId) {
	      $(window).on('load', function () {
	        if ($('input.' + inputClass).length > 0) {
	          $('input.' + inputClass + ':first').focus();
	        } else {
	          $('input#' + defaultInputId).focus();
	          //          window.scrollTo(0, 0);
	        }
	      });
	    },
	    /**
	     * Activates popovers on Costco tooltips.
	     * @param {string} tooltipClass - Tooltip class.
	     * @return {void}
	     */
	    activatePopovers: function activatePopovers(tooltipClass) {
	      $('.' + tooltipClass).popover();
	    },
	    /**
	     * Validation rules for the inputs associated with creating an account.
	     * @return {void}
	     */
	    validationRules: function validationRules() {
	      $.validator.addMethod('email', function (value, element) {
	        return (/^.+@(([^.])+\.)+([^.])+$/i.test(value)
	        );
	      }, messages.JS_VALID_EMAIL);
	
	      $.validator.addMethod('passwordRule', function (value, element) {
	        return (/^[^<,>,",\\,\s,\.]{8,20}$/.test(value) && /[a-zA-Z]/.test(value)
	        );
	      }, messages.JS_VALID_REQUIRED);
	
	      $.validator.addMethod('costcoMembership', function (value, element) {
	        return (/^\d{12,16}$/.test(value)
	        );
	      }, messages.ERR_INVALID_MEMBERSHIP_NO);
	    },
	
	    /**
	     * Checks if cart is empty.
	     * @return {void}
	     *
	     * isCartEmpty: function(){
	    	let cartEmpty = true;
	    	let cartCookie = $.cookie('cartCountCookie');
	    	if(cartCookie != null && cartCookie != 'undefined'){
	    		if(cartCookie > 0) {
	    			cartEmpty = false;
	    		}
	    	}
	    	return cartEmpty;
	    },
	      */
	
	    /**
	     * Validates the given form.
	     * @param {string} formId - ID attribute of the form.
	     * @return {void}
	     */
	    validateForm: function validateForm(formId) {
	      $('#' + formId).validate({
	
	        ignoreTitle: true,
	
	        rules: {
	          email1: {
	            required: true,
	            email: true,
	            maxlength: 251
	          },
	          logonPassword: {
	            required: true,
	            passwordRule: true
	          },
	          logonPasswordVerify: {
	            required: true,
	            passwordRule: true,
	            equalTo: '#logonPassword'
	          },
	          userField2: {
	            // required: true,
	            costcoMembership: true
	          },
	          lastNameOnMembership: {
	            // required: true,
	          }
	        },
	
	        messages: {
	          email1: {
	            required: messages.ERR_REQUIRED_LOGON,
	            email: messages.ERR_INVALID_EMAIL,
	            maxlength: messages.ERR_EMAIL_MAX_LENGTH
	          },
	          logonPassword: {
	            required: messages.ERR_REQUIRED_REGISTER_PASSWORD,
	            // Password messages already handled by PasswordStrength.jsp
	            passwordRule: '' },
	          logonPasswordVerify: {
	            required: messages.ERR_REQUIRED_CONFIRM_PASSWORD,
	            // Password messages already handled by PasswordStrength.jsp
	            passwordRule: '', // messages.ERR_CREATE_ACCOUNT_PASSWORD_INVALID,
	            equalTo: '' },
	          userField2: {
	            required: messages.JS_VALID_REQUIRED,
	            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	          },
	          lastNameOnMembership: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        }
	      });
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.RegisterUser = RegisterUser;
	
	  return RegisterUser;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title costcopay-fobs.js: Sub module for Account pages
	 * @description: This module is used to hanle management of costco pay fobs
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var CostcoPayFob = {
	
			SORT_BY_FOB_NAME_ASC: '1',
			SORT_BY_FOB_NAME_DESC: '2',
	
			url: {
				MANAGE_FOB_ADD_UPDATE: '/AjaxManageCostcoPayFobCmd',
				GET_COSTCO_PAY_FOB: '/AjaxCostcoPayGetFobsCmd'
			},
	
			/**
	   * Contain the list of fobs that is associated with the user
	   * Slight weirdness UX display suspended fobs as deactivated
	   * and we do not display deactivated fobs at all
	   */
			fobs: {
				active: [],
				deactivated: []
			},
			/**
	   * Function used to get the current active costco pay fob
	   * form.
	   * If the user has no active or suspended fob the active form
	   * will be inline on the screen, however we also have the form
	   * displayed within the modal
	   */
			getForm: function getForm() {
				if ($('#add_fob_form').is(':visible') || $('#add_fob_form').css('display') != 'none') return $('#add_fob_form');else return $('#costco-pay-dialog-modal');
			},
			/**
	   *  Function used to get the next available default fobName to be displayed to the user
	   *  We will try to ensure the default fob name as unique by calculating the maximum
	   *  enumeration number in the active and deactivated fob collection and adding 1 to it
	   *  
	   */
			getDefaultFobName: function getDefaultFobName() {
				var baseFobName = messages.COSTCO_PAY_FOB_DEFAULT_NAME;
	
				var defaultFobReducer = function defaultFobReducer(accumulator, currentValue) {
					if (currentValue.fobName.startsWith(baseFobName)) {
						var currFobEnum = currentValue.fobName.substr(baseFobName.length).trim();
						return Math.max(accumulator, currFobEnum);
					}
					return accumulator;
				};
				//Calculating the max enumeration for fob between the active and deactivated ones and setting 0 as the default accumulator
				var maxDefaultFobName = Math.max(CostcoPayFob.fobs.active.reduce(defaultFobReducer, 0), CostcoPayFob.fobs.deactivated.reduce(defaultFobReducer, 0));
	
				return baseFobName + " " + (maxDefaultFobName + 1);
			},
			/**
	   * Initializer for costcoPay this function will be triggered
	   * when the page finished rendering.
	   * 
	   * If there is an associated costcoPayUserId the method will try
	   * to get the associated fobs
	   * 
	   * If we are running on the mobile app we will show the scan button on the
	   * add fob forms
	   */
			init: function init() {
				if (document.readyState == 'complete') {
					this.getCostcoPayFobs(true);
					if (COSTCO.util.isRunningOnMobileApp()) $('.fob-scan-btn').show();else $('.fob-scan-btn').hide();
				} else {
					$(window).on('load', function () {
						COSTCO.CostcoPayFob.getCostcoPayFobs(true);
						if (COSTCO.util.isRunningOnMobileApp()) $('.fob-scan-btn').show();else $('.fob-scan-btn').hide();
					});
				}
			},
			/**
	   * Helper to get the list of associated costcoPayFob
	   * associated with the costcoPayId
	   * 
	   * Upon completion we will split the fob list from the 
	   * AjaxCostcoPayGetFobsCmd into the respective fob object list entry
	   * per status. It will then render the costco fob section.
	   * 
	   * @param costcoPayId costcoPayId associated with the user
	   */
			getCostcoPayFobs: function getCostcoPayFobs(init) {
				if (typeof COSTCO.CostcoPayAccountInformation.getCostcoPayUserId() !== 'undefined' && COSTCO.CostcoPayAccountInformation.getCostcoPayUserId() !== '') {
					if (!COSTCO.CostcoPayAccountInformation.hasCostcoPayMembership()) {
						$('#add_fob_form input').prop('disabled', true);
					} else {
						$('#add_fob_form input').prop('disabled', false);
					}
					COSTCO.util.ajax({
						url: CostcoPayFob.url.GET_COSTCO_PAY_FOB,
						method: 'GET',
						dataType: 'json',
						data: {
							costcoPayId: encodeURIComponent(COSTCO.CostcoPayAccountInformation.getCostcoPayUserId())
						},
						done: function done(data, textStatus, jqXHR, options) {
							CostcoPayFob.fobs.active = [];
							CostcoPayFob.fobs.active = CostcoPayFob.fobs.active.concat(JSON.parse(data.activeFobs));
							CostcoPayFob.fobs.deactivated = [];
							CostcoPayFob.fobs.deactivated = CostcoPayFob.fobs.deactivated.concat(JSON.parse(data.deactivatedFobs));
							CostcoPayFob.populateFobSection();
							//Only try to handle the mobile deep linking on initialization
							//of the page
							if (init) {
								CostcoPayFob.handleMobileDeepLink();
							}
						}
					});
				} else {
					//User has not been registered for costcoPay so hide the manage fob
					//And disable the add single fob form
					$('#manage-fobs').hide();
					$('#add_fob_form input').prop('disabled', true);
					if (init) {
						CostcoPayFob.handleMobileDeepLink();
					}
				}
				var numFobs = CostcoPayFob.fobs.active.length + CostcoPayFob.fobs.active.length;
			},
			/**
	   * Handle an initial request with a fobId in the request parameter
	   * this will indicate the user got here by scanning the mobile qr code
	   */
			handleMobileDeepLink: function handleMobileDeepLink() {
	
				var fobId = COSTCO.util.getParameterByName('fobId');
				var numFobs = CostcoPayFob.fobs.active.length + CostcoPayFob.fobs.active.length;
	
				if (typeof fobId !== 'undefined' && fobId != null && fobId !== '') {
					if (numFobs == 0) {
						$('#add_fob_form').find('#fob_number_input').val(fobId);
						$('#add_fob_form').find('#fob_number_verify_input').val(fobId);
					} else {
						CostcoPayFob.openAddEditFobModal(fobId, 'add');
					}
				}
			},
			/**
	   * Function to render the stored fob data to the screen. Which will flow as follows
	   *   1. Hide fob sections
	   *   2. Call a helper function to reneder the fobs onscreen
	   *   3. Depending on the filter option show only the relevant fob section
	   */
			populateFobSection: function populateFobSection() {
				//Hide fob while we work on it
				var numDisplayedFobs = CostcoPayFob.fobs.active.length + CostcoPayFob.fobs.deactivated.length;
	
				if (!(COSTCO.CostcoPayAccountInformation.hasCostcoPayMembership() && COSTCO.CostcoPayAccountInformation.hasPaymentMethod())) {
					$('#add_addtl_fob_btn').prop('disabled', true);
					$('#add_fob_form input').prop('disabled', true);
				} else {
					$('#add_addtl_fob_btn').prop('disabled', false);
					$('#add_fob_form input').prop('disabled', false);
				}
	
				if (numDisplayedFobs == 0) {
					$('#manage-fobs').hide();
					$('#add_fob_form').show();
				} else {
					$('#manage-fobs').show();
					$('#add_fob_form').hide();
					CostcoPayFob.renderCostcoPayFobList('#active-fob-list', CostcoPayFob.sort(CostcoPayFob.fobs.active), messages.COSTCO_PAY_FOB_NO_ACTIVE_FOUND);
					CostcoPayFob.renderCostcoPayFobList('#deactivated-fob-list', CostcoPayFob.sort(CostcoPayFob.fobs.deactivated), messages.COSTCO_PAY_FOB_NO_DEACTIVATED_FOUND);
					//Only show the selected fob type
					var showFobType = $('option:selected', $('#fob-status-filter')).val();
					if (showFobType === 'deactivated') {
						$('#active-fobs').hide();
						$('#deactivated-fobs').show();
					} else if (showFobType === 'active') {
						$('#active-fobs').show();
						$('#deactivated-fobs').hide();
					} else {
						$('#active-fobs').show();
						$('#deactivated-fobs').show();
					}
				}
			},
			/**
	   * Function used to sort the fobList based on the sort selected by
	   * the user
	   */
			sort: function sort(fobList) {
				var sortedFobList = [];
				var sortType = $('option:selected', $('#fob-sort-by')).val();
				if (sortType === CostcoPayFob.SORT_BY_FOB_NAME_ASC) {
					sortedFobList = fobList.sort(function (elem1, elem2) {
						var name1 = elem1.fobName.toLowerCase();
						var name2 = elem2.fobName.toLowerCase();
						return name1 < name2 ? -1 : name1 > name2 ? 1 : 0;
					});
				}
				if (sortType === CostcoPayFob.SORT_BY_FOB_NAME_DESC) {
					sortedFobList = fobList.sort(function (elem1, elem2) {
						var name1 = elem1.fobName.toLowerCase();
						var name2 = elem2.fobName.toLowerCase();
						return name1 > name2 ? -1 : name1 < name2 ? 1 : 0;
					});
				}
				return sortedFobList;
			},
			/**
	   * Function used to iterate though the fobList to render each fob
	   * and append it to the given containerId
	   */
			renderCostcoPayFobList: function renderCostcoPayFobList(containerId, fobList, defaultMessage) {
				$(containerId).html('');
				if (fobList.length > 0) {
					$.each(fobList, function (index, value) {
	
						//set the value to a new object as a copy
						//so we can change the value for display but maintain
						//original value for the form
						var fobDisplay = Object.assign({}, value);
						var template = COSTCO.util.tmpl('tmpl_costco_pay_fob_box', fobDisplay);
						template = $(template);
						if (value.fobStatus.toLowerCase() === 'suspended') {
							template.addClass('deactivated');
							template.find('.deactivate-link').addClass('hide');
						} else {
							template.find('.reactivate-link').addClass('hide');
						}
						if (!(COSTCO.CostcoPayAccountInformation.hasCostcoPayMembership() && COSTCO.CostcoPayAccountInformation.hasPaymentMethod())) {
							template.find('.edit-link').addClass('hide');
							template.find('.reactivate-link').addClass('hide');
						}
	
						$(containerId).append(template);
					});
				} else {
					$(containerId).append(defaultMessage);
				}
			},
			/**
	   * Helper function used to get the raw fobData from the 
	   * fobs object given a fobNumber
	   * 
	   * if it cannot find a fob that match its fobNumber undefined is returned
	   */
			getFobData: function getFobData(fobNumber) {
				var fobData = undefined;
				if (typeof fobNumber !== 'undefined') {
					fobData = CostcoPayFob.fobs.active.find(function (element) {
						return element.fobNumber == fobNumber;
					});
					if (typeof fobData === 'undefined') {
						fobData = CostcoPayFob.fobs.deactivated.find(function (element) {
							return element.fobNumber == fobNumber;
						});
					}
				}
				return fobData;
			},
			/**
	   * Function used to open the fob edit modal under edit mode
	   */
			editFob: function editFob(element) {
				var fobNumber = $(element).data("fob-num");
				CostcoPayFob.openAddEditFobModal(fobNumber, 'edit');
			},
			/**
	   * Function used to open the fob add modal
	   * We feed -1 to the fobNumber field to ensure
	   * no data is found which will display a blank form
	   */
			addFob: function addFob(element) {
				if (CostcoPayFob.validateCostcoPayFobForm(element)) {
					if ($(element).find('[name=costcoPayUserId]').val() === "") $(element).find('[name=costcoPayUserId]').val(COSTCO.CostcoPayAccountInformation.getCostcoPayUserId());
					var newFobData = COSTCO.util.objectifyArray($(element).serializeArray());
					CostcoPayFob.manageCostcoPayFob(newFobData, 'add');
				}
			},
			/**
	   * Helper function used to suspend a fob
	   */
			deactivateFob: function deactivateFob(element) {
				var fobNumber = $(element).data("fob-num");
				var fobData = CostcoPayFob.getFobData(fobNumber);
				COSTCO.dialog.showAndHideModal({
					title: messages.COSTCO_PAY_FOB_DISABLE_MODAL_TITLE,
					body: COSTCO.util.tmpl('tmpl_disable_fob_modal', fobData),
					primary: messages.COSTCO_PAY_FOB_DISABLE_MODAL_PRIMARY,
					primary_event: function primary_event() {
						CostcoPayFob.manageCostcoPayFob(fobData, 'suspend');
						COSTCO.dialog.clearStack();
						COSTCO.dialog.close();
					},
					secondary: messages.JS_DIALOG_CANCEL
				});
			},
			/**
	   * Helper function used to activate a given fob
	   */
			activateFob: function activateFob(element) {
				var fobNumber = $(element).data("fob-num");
				var fobData = CostcoPayFob.getFobData(fobNumber);
				CostcoPayFob.manageCostcoPayFob(fobData, 'activate');
			},
			/**
	   * Function used to remove/deactivate a fob
	   * It will prompt the user to confirm that they
	   * want to complete the action as its not revertable
	   */
			removeFob: function removeFob(element) {
				var fobNumber = $(element).data("fob-num");
				var fobData = CostcoPayFob.getFobData(fobNumber);
				COSTCO.dialog.showAndHideModal({
					title: messages.COSTCO_PAY_FOB_REMOVE_MODAL_TITLE,
					body: COSTCO.util.tmpl('tmpl_remove_fob_modal', fobData),
					primary: messages.COSTCO_PAY_FOB_REMOVE_MODAL_PRIMARY,
					primary_event: function primary_event() {
						CostcoPayFob.manageCostcoPayFob(fobData, 'deactivate');
						COSTCO.dialog.clearStack();
						COSTCO.dialog.close();
					},
					secondary: messages.JS_DIALOG_CANCEL
				});
			},
			/**
	   * Open the modal for a user to be able to add, edit, or deactivate a costcoPayFob
	   * 
	   * On edit we expect to recieve the fobNumber that we want to edit which will be passed
	   * to a helper function to get the data. After which the function will use the data to 
	   * populate the template form with the necessary information
	   * 
	   * On edit mode we want to add a footer to allow the user to deactivate a fob, which have
	   * a confirmation dialog hence we are using the modal stacking method from the dialog
	   */
			openAddEditFobModal: function openAddEditFobModal(fobNumber, action) {
	
				var modalBodyTmpl = undefined;
	
				if (action === 'edit') {
					var fobData = CostcoPayFob.getFobData(fobNumber);
					modalBodyTmpl = COSTCO.util.tmpl('tmpl_costco_pay_fob_edit_dialog_box', fobData);
				} else {
					var _fobData = {};
					if (typeof fobNumber !== "undefined" && fobNumber > 0) {
						_fobData.fobNumber = fobNumber;
					} else {
						_fobData.fobNumber = "";
					}
					_fobData.fobName = CostcoPayFob.getDefaultFobName();
					modalBodyTmpl = COSTCO.util.tmpl('tmpl_costco_pay_add_dialog_box', _fobData);
					modalBodyTmpl = $(modalBodyTmpl);
					modalBodyTmpl.find('[name=costcoPayUserId]').val(COSTCO.CostcoPayAccountInformation.getCostcoPayUserId());
					modalBodyTmpl.find('[name=fobStatus]').val('active');
				}
	
				var modalOptions = {
					title: action === 'edit' ? messages.COSTCO_PAY_FOB_EDIT_MODAL_TITLE : messages.COSTCO_PAY_FOB_ADD_MODAL_TITLE,
					body: modalBodyTmpl,
					primary: messages.COSTCO_PAY_FOB_MODAL_PRIMARY,
					primary_event: function primary_event() {
						if (CostcoPayFob.validateCostcoPayFobForm(CostcoPayFob.getForm())) {
							var formFobData = COSTCO.util.objectifyArray(CostcoPayFob.getForm().serializeArray());
							CostcoPayFob.manageCostcoPayFob(formFobData, action);
						}
					},
					secondary: messages.COSTCO_PAY_FOB_MODAL_SECONDARY
				};
				COSTCO.dialog.modalStack(modalOptions);
				COSTCO.util.accesible_popover($('.co-info, .co-help'));
				if (COSTCO.util.isRunningOnMobileApp()) $('.fob-scan-btn').show();else $('.fob-scan-btn').hide();
			},
			/**
	   * Function used to populate the fob number input based on what is passed
	   * into the function.
	   * 
	   * This function will be called by the Android or iOS device to enter the
	   * scanned QR code with the fob number that was obtained from the QR code
	   */
			populateFobNumber: function populateFobNumber(fobNumberVal) {
				var form = CostcoPayFob.getForm();
				form.find('[name=fobNumber]').val(fobNumberVal);
				form.find('[name=fobNumberVerify]').val(fobNumberVal);
			},
			/**
	   * Function used to invoke the mobile app QR scanner
	   * used to populate the fobNumber from the QR Code
	   */
			showMobileQRScanner: function showMobileQRScanner() {
				console.log('Initializing QR Scanner');
				try {
					if (typeof Android != 'undefined') {
						Android.showQRScanner();
					} else if (typeof webkit != 'undefined') {
						var messageToPost = { 'callback': 'COSTCO.CostcoPayFob.populateFobNumber' };
						webkit.messageHandlers.showQRScanner.postMessage(messageToPost);
					}
				} catch (e) {
					console.warn(e);
				}
			},
			/**
	   * Validation function to send the costco pay fob form
	   * Fob name and number is always required
	   * Fob email is optional unless the user check the notify
	   */
			validateCostcoPayFobForm: function validateCostcoPayFobForm(element) {
				//Need to get the proper id for the fobNumber input as we are using the same validate
				//function for both the modal and inline form
				var fobNumberInputId = '#' + $(element).find('[name="fobNumber"]').attr('id');
				$.validator.addMethod("checkSpecialchar", function (value, element) {
					return this.optional(element) || !/([^A-Za-z0-9\.\'\-\&\s])/.test(value); // CC name shouldn't have any html tag
				});
				$(element).validate({
					rules: {
						fobName: { required: true,
							maxlength: 50,
							checkSpecialchar: true },
						fobNumber: { required: true,
							digits: true,
							minlength: 10,
							maxlength: 10 },
						fobNumberVerify: { equalTo: fobNumberInputId }
	
					},
					messages: {
						fobName: {
							required: messages.ERR_COSTCO_PAY_REQUIRED_FOB_NAME,
							maxlength: messages.ERR_COSTCO_PAY_MAXLENGTH_FOB_NAME,
							checkSpecialchar: messages.ERR_COSTCO_PAY_INVALID_FOB_NAME
						},
						fobNumber: {
							required: messages.ERR_COSTCO_PAY_REQUIRED_FOB_NUM,
							digits: messages.ERR_COSTCO_PAY_INVALID_FOB_NUM,
							minlength: messages.ERR_COSTCO_PAY_INVALID_FOB_NUM,
							maxlength: messages.ERR_COSTCO_PAY_INVALID_FOB_NUM
						},
						fobNumberVerify: {
							equalTo: messages.ERR_COSTCO_PAY_MISMATCH_FOB_NUM
						}
					},
					errorPlacement: function errorPlacement(error, element) {
						var errrorCont = undefined;
						var form = CostcoPayFob.getForm();
						if (element.attr("name") == "fobNumber") {
							errorCont = $(form).find('[name=fob_number_error]');
						} else if (element.attr("name") == "fobNumberVerify") {
							errorCont = $(form).find('[name=fob_number_verify_error]');
						} else {
							errorCont = $(form).find('[name=fob_name_error]');
						}
						errorCont.empty();
						error.appendTo(errorCont);
						errorCont.removeClass('hide');
					},
					highlight: function highlight(element, errorClass, validClass) {
						$(element).addClass(errorClass).removeClass(validClass);
						if ($(element).attr("name") == "fobNumber") {
							$('.fob-scan-btn').addClass(errorClass).removeClass(validClass);
						}
					},
					unhighlight: function unhighlight(element, errorClass, validClass) {
						$(element).addClass(validClass).removeClass(errorClass);
						if ($(element).attr("name") == "fobNumber") {
							$('.fob-scan-btn').addClass(validClass).removeClass(errorClass);
						}
					}
				});
				return $(element).valid();
			},
			/**
	   * Function used to perfom the ajax call to perfom any management action againts a 
	   * costcoPayFob. Upon completion we will re-initialize the fob list with the latest
	   * information
	   */
			manageCostcoPayFob: function manageCostcoPayFob(fobData, action) {
	
				$('#fob-section').addClass('ajax-busy');
	
				COSTCO.util.ajax({
					url: CostcoPayFob.url.MANAGE_FOB_ADD_UPDATE,
					method: 'POST',
					dataType: 'json',
					data: {
						action: action,
						costcoPayUserId: fobData.costcoPayUserId,
						costcoPayFobNum: fobData.fobNumber,
						costcoPayFobName: fobData.fobName,
						costcoPayFobStatus: fobData.fobStatus
					},
					done: function done(data) {
						if (data.errorMessage) {
							//If there is error and its duplicate fob show error next to fob number
							var form = CostcoPayFob.getForm();
							if (data.errorMessageKey == 'ERR_COSTCO_PAY_DUPLICATE_FOB_ID') {
								var _errorCont = $(form).find('[name=fob_number_error]');
								_errorCont.empty();
								_errorCont.html('<label for="fob_number_input" class="error">' + data.errorMessage + '</label>');
	
								var input = $(form).find('[name=fobNumber]');
								input.addClass('error');
								input.attr('aria-invalid', true);
							} else if (data.errorMessageKey == 'ERR_COSTCO_PAY_DUPLICATE_FOB_NAME') {
								var _errorCont2 = $(form).find('[name=fob_name_error]');
								_errorCont2.empty();
								_errorCont2.html('<label for="fob_name_error" class="error">' + data.errorMessage + '</label>');
	
								var _input = $(form).find('[name=fobName]');
								_input.addClass('error');
								_input.attr('aria-invalid', true);
							} else {
								var _errorCont3 = $(form).find('.critical-notification');
								_errorCont3.text(data.errorMessage);
								_errorCont3.removeClass('hide');
							}
						} else {
							CostcoPayFob.getCostcoPayFobs();
							if (action !== undefined && action === 'add') CostcoPayFob.showConfirmationModal(fobData);else {
								COSTCO.dialog.clearStack();
								COSTCO.dialog.close();
							}
						}
					},
					always: function always() {
						$('#fob-section').removeClass('ajax-busy');
					}
				});
			},
			/**
	   * Function to show the fob added sucessfully confirmation modal
	   * this function will be invoked when a fob has been added sucessfully
	   * the function require the fobData to be passed in so it can show then
	   */
			showConfirmationModal: function showConfirmationModal(fobData) {
	
				var modalOptions = {
					hideHeader: true,
					body: COSTCO.util.tmpl('tmpl_fob_added_confirmation_modal', fobData),
					primary: messages.COSTCO_PAY_FOB_ADDED_CONFIRM_MODAL_PRIMARY,
					primary_event: function primary_event() {
						COSTCO.dialog.clearStack();
						COSTCO.dialog.close();
					},
					secondary: messages.COSTCO_PAY_FOB_ADDED_CONFIRM_MODAL_SECONDARY,
					secondary_event: function secondary_event() {
						CostcoPayFob.openAddEditFobModal(-1, 'add');
					}
				};
				COSTCO.dialog.modalStack(modalOptions);
				$('#add_fob_form input[name=fobName]').val('');
				$('#add_fob_form input[name=fobNumber]').val('');
				$('#add_fob_form input[name=fobNumberVerify]').val('');
			}
		};
		window.COSTCO.CostcoPayFob = CostcoPayFob;
		return CostcoPayFob;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title costcopay-account-information.js: Sub module for Account pages
	 * @description: This modules is used to perform many of the action that a user can partake
	 * to manage their costco pay account information.
	 * The capability include
	 * 		Registering for Costco Pay
	 * 		Adding/Editing the saved payment information
	 * 		Removing their saved payment method
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(37), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ajaxModular, creditCard) {
		var CostcoPayAccountInformation = {
			sessionId: '',
			authToken: '',
			/**
	   * Return the active CostcoPay Payment method form 
	   */
			getPaymentMethodForm: function getPaymentMethodForm() {
				return $('#CostcoPayPaymentMethodForm');
			},
			/**
	   * Function used to get the current user's costcoPayUserId
	   * the data is stored in 2 possible location it can be either in the
	   * costcoPayPaymentObject if there is a valid payment method or a hidden input
	   * in the form when the user is registered however has no valid payment method
	   */
			getCostcoPayUserId: function getCostcoPayUserId() {
				if (typeof costcoPayPaymentObject !== 'undefined') return costcoPayPaymentObject.costcoPayUserId;else if (typeof CostcoPayAccountInformation.getPaymentMethodForm() !== 'undefined') return CostcoPayAccountInformation.getPaymentMethodForm().find('[name=costcoPayUserId]').val();
			},
			/**
	   * If the user does not have a linked membership the jsp will render the add membership form
	   */
			hasCostcoPayMembership: function hasCostcoPayMembership() {
				return $('#AddMembershipForm').length == 0;
			},
			/**
	   * Check to see if the user has a valid payment method
	   */
			hasPaymentMethod: function hasPaymentMethod() {
				var eprAccountUserId = '';
				var eprPaymentAccountId = '';
				var costcoPayReset = '';
				if (this.getPaymentMethodForm().length > 0) {
					eprAccountUserId = this.getPaymentMethodForm().find('[name=eprAccountUserId]').val();
					eprPaymentAccountId = this.getPaymentMethodForm().find('[name=eprPaymentAccountId]').val();
					costcoPayReset = this.getPaymentMethodForm().find('[name=costcoPayReset]').val();
				} else {
					eprAccountUserId = costcoPayPaymentObject.eprAccountUserId;
					eprPaymentAccountId = costcoPayPaymentObject.eprPaymentAccountId;
				}
	
				if (eprAccountUserId !== '' && eprPaymentAccountId !== '' && costcoPayReset !== 'true') {
					return true;
				}
	
				return false;
			},
			init: function init() {
				COSTCO.util.accesible_popover($('.co-info, .co-help'));
				this.maskInput();
				this.validationRules();
				this.authToken = $('[name=authToken]').val();
	
				if ($('#linked-membership-number-form').length > 0) {
					COSTCO.AccountDetails.linkedMembershipFormHandler();
	
					$('#buy-membership-button').unbind('click').bind('click', function () {
						if ($.cookie('cartCountCookie') > 0) {
							window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
						} else {
							window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
						}
					});
				}
				if (typeof CostcoPayAccountInformation.getCostcoPayUserId() !== 'undefined' && CostcoPayAccountInformation.getCostcoPayUserId() !== "") {
					$('#navigation-tabs').show();
				} else {
					$('#navigation-tabs').hide();
				}
	
				console.log('CostcoPayFob-Payment module initiated');
			},
			/**
	   * Function to mask the input of the payment method form
	   */
			maskInput: function maskInput() {
				$('#cc_expiry_date').mask('00/00', {
					placeholder: '__/__'
				});
				$('#card_number').mask('ZZZZ ZZZZ ZZZZ 0000', {
					selectOnFocus: true,
					translation: {
						'Z': {
							pattern: '[\\*0-9]'
						}
					}
				});
			},
			/**
	   * Function used to validate credit card form
	   */
			validationRules: function validationRules() {
				//Call on CreditCard module to lay down initial business rules
				COSTCO.CreditCard.validationRules();
	
				//Costco Pay only allow VISA and co-branded card
				$.validator.addMethod('checkCardType', function (value, element) {
					var ccNum = (value + '').replace(/\s/g, ''); //remove space
	
					var cardType = COSTCO.CreditCard.getCardType(ccNum);
					if (cardType != COSTCO.CreditCard.cardTypes.DEFAULT_PAYMENT) {
	
						if (cardType != COSTCO.CreditCard.cardTypes.VISA && cardType != COSTCO.CreditCard.cardTypes.COSTCO_CREDIT_CARD) {
							return false;
						}
					}
					return true;
				});
			},
			/**
	   * Validates the Payment Methods add/edit form
	   * Standard CC validation here in terms of name on card, cc number, and expiration date
	   * Additional validation that it can only be VISA card
	   * @return {void}
	   */
			validateCostcoPayPaymentForm: function validateCostcoPayPaymentForm() {
				var form = CostcoPayAccountInformation.getPaymentMethodForm();
				form.validate({
					rules: {
						number: {
							required: true,
							customcc: true,
							checkCardType: true
						},
						cc_nameoncard: {
							required: true,
							checkSpecialchar: true
						},
						cc_expiry_date: {
							required: true,
							checkExpiryDate: true,
							checkIsDateInPast: true
						}
					},
					messages: {
						number: {
							required: messages.ERR_COSTCO_PAY_REQUIRED_CARD_NUMBER,
							customcc: messages.ERR_COSTCO_PAY_INVALID_CARD_NUMBER,
							checkCardType: messages.ERR_COSTCO_PAY_INVALID_CARD_TYPE
						},
						cc_nameoncard: {
							required: messages.ERR_COSTCO_PAY_REQUIRED_NAME_ON_CARD,
							checkSpecialchar: messages.ERR_COSTCO_PAY_INVALID_NAME_ON_CARD
						},
						cc_expiry_date: {
							required: messages.ERR_COSTCO_PAY_REQUIRED_EXP_DATE,
							checkExpiryDate: messages.ERR_COSTCO_PAY_INVALID_EXP_DATE,
							checkIsDateInPast: messages.ERR_COSTCO_PAY_PAST_EXP_DATE
						}
					},
					errorPlacement: function errorPlacement(error, element) {
						if (element.is('#card_number_validator')) {
							$('.gw-proxy-number').css('border', '');
							$('.gw-proxy-number').addClass('card-number-error');
							error.insertAfter(element);
						} else {
							error.insertAfter(element);
						}
					}
				});
	
				if (form.length != 0) {
					return form.valid();
				}
			},
			/**
	   * Helper function used to prepare the payment form data and
	   * send the payment method update to the AjaxManageCostcoPayPaymentCmd
	   * Primarily this is used when user want to update their CC and remove their CC
	   */
			ajaxManageCostcoPayPayment: function ajaxManageCostcoPayPayment() {
				var form = CostcoPayAccountInformation.getPaymentMethodForm();
				var expDate = $(form).find('input[name=cc_expiry_date]').val().split('/');
	
				$(form).find('input[name=expireMonth]').val(expDate[0]);
				$(form).find('input[name=expireYear]').val('20' + expDate[1]);
	
				$('#costco-pay-payment-method').addClass('ajax-busy');
				var formData = COSTCO.util.objectifyArray(form.serializeArray());
	
				if (CostcoPayAccountInformation.validateCostcoPayPaymentForm()) {
					ajaxModular.ajax_update_state({
						method: 'POST',
						url: '/AjaxManageCostcoPayPaymentCmd',
						data: formData,
						dataType: 'json',
						done: function done(data, textStatus, jqXHR, options) {
							if (!data.errorMessage) {
								ajaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
								if (typeof CostcoPayAccountInformation.getCostcoPayUserId() !== 'undefined') {
									COSTCO.CostcoPayFob.getCostcoPayFobs();
								}
								COSTCO.util.accesible_popover($('.co-info, .co-help'));
							} else {
								var errorCont = $(form).find('.critical-notification');
								errorCont.text(data.errorMessage);
								errorCont.removeClass('hide');
							}
						},
						always: function always() {
							$('#costco-pay-payment-method').removeClass('ajax-busy');
							TokenGateway.refreshGateway();
						}
					});
				} else {
					$('#costco-pay-payment-method').removeClass('ajax-busy');
				}
			},
			/**
	   * Function to invoke the registation end poit so new user can register
	   * for a costcopay fob
	   */
			ajaxRegisterCostcoPayUser: function ajaxRegisterCostcoPayUser() {
				$('#costco-pay-payment-method').addClass('ajax-busy');
				$('#costco-pay-notification').addClass('ajax-busy');
	
				var paymentForm = CostcoPayAccountInformation.getPaymentMethodForm();
	
				var paymentData = {};
	
				//Check if the payment form exist, which mean we need to take the values from the form
				//if not user is registering with card on file so use that
				if (paymentForm.length > 0) {
					var expDate = $(paymentForm).find('input[name=cc_expiry_date]').val().split('/');
					$(paymentForm).find('input[name=expireMonth]').val(expDate[0]);
					$(paymentForm).find('input[name=expireYear]').val('20' + expDate[1]);
					if (CostcoPayAccountInformation.validateCostcoPayPaymentForm()) {
						paymentData = paymentForm.serializeArray();
					} else {
						$('#costco-pay-payment-method').removeClass('ajax-busy');
						$('#costco-pay-notification').removeClass('ajax-busy');
					}
				} else {
					paymentData.tokenSessionId = costcoPayPaymentObject.tokenSessionId;
					paymentData.authToken = costcoPayPaymentObject.authToken;
					paymentData.eprAccountUserId = costcoPayPaymentObject.eprAccountUserId;
					paymentData.eprPaymentAccountId = costcoPayPaymentObject.eprPaymentAccountId;
					paymentData.cardType = costcoPayPaymentObject.cardType;
					paymentData.number = costcoPayPaymentObject.cardNumber;
					paymentData.cc_nameoncard = costcoPayPaymentObject.cardHolderName;
					paymentData.expireMonth = costcoPayPaymentObject.cardExpireMonth;
					paymentData.expireYear = '20' + costcoPayPaymentObject.cardExpireYear;
				}
				//Check if the paymentData object is empty if it is there
				//was a problem validating the formdata so don't post
				if (!$.isEmptyObject(paymentData)) {
					ajaxModular.ajax_update_state({
						method: 'POST',
						url: '/AjaxRegisterCostcoPayUserCmd',
						data: paymentData,
						dataType: 'json',
						done: function done(data, textStatus, jqXHR, options) {
							if (!data.errorMessage) {
								ajaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
								//If we are sucessfull in registering the account lets get the fobs
								if (typeof CostcoPayAccountInformation.getCostcoPayUserId() !== 'undefined') {
									COSTCO.CostcoPayFob.getCostcoPayFobs();
								}
							} else {
								var errorCont = $('#register-crit-notification');
								errorCont.text(data.errorMessage);
								errorCont.removeClass('hide');
							}
						},
						always: function always() {
							$('#costco-pay-payment-method').removeClass('ajax-busy');
							$('#costco-pay-notification').removeClass('ajax-busy');
							TokenGateway.refreshGateway();
						}
					});
				}
			},
			/**
	   * funtion used that bind to the save card button this will invoke the proper 
	   * function to be used to send the ajax call in the back
	   */
			saveCard: function saveCard(form) {
				$form = $(form);
				var expDate = $form.find('input[name=cc_expiry_date]').val().split('/');
	
				$form.find('input[name=expireMonth]').val(expDate[0]);
				$form.find('input[name=expireYear]').val('20' + expDate[1]);
				TokenGateway.updateSessionFromForm('card', function () {
					if ($form.find('#costcoPayUserId').val() != '') CostcoPayAccountInformation.ajaxManageCostcoPayPayment();else CostcoPayAccountInformation.ajaxRegisterCostcoPayUser();
				}, $form.attr('id'));
			},
			/**
	   * function used to bind to the editCard button, will transform the current display
	   * payment method form to the edit mode
	   */
			editCard: function editCard() {
				var template = COSTCO.util.tmpl('tmpl_edit_payment_method', costcoPayPaymentObject);
				$('#costco-pay-payment-method-display').hide();
				$('#register-card-on-file-button').hide();
				$('#costco-pay-payment-method-edit').html(template);
				COSTCO.util.accesible_popover($('.co-info, .co-help'));
				this.maskInput();
				createTokenSessionId();
	
				TokenGateway.refreshGateway();
			},
			/**
	   * Function used to show the add card form when the user wants
	   * to add a new card instead of their saved payment method
	   */
			addCard: function addCard() {
				var addCardObject = costcoPayPaymentObject;
				addCardObject.eprAccountUserId = '';
				addCardObject.eprAccountUserId = '';
				addCardObject.cardType = '';
				addCardObject.cardNumber = '';
				addCardObject.cardHolderName = '';
				addCardObject.cardExpireMonth = '';
				addCardObject.cardExpireYear = '';
				var template = COSTCO.util.tmpl('tmpl_edit_payment_method', addCardObject);
				$('#costco-pay-payment-method-display').hide();
				$('#register-card-on-file-button').hide();
				$('#costco-pay-payment-method-edit').html(template);
				COSTCO.util.accesible_popover($('.co-info, .co-help'));
				this.maskInput();
			},
			/**
	   * function to open the confirmation dialog box when user wants to remove their
	   * costcoapay payment method
	   */
			deleteCard: function deleteCard() {
				var authTokenId = costcoPayPaymentObject.authToken;
				var costcoPayUserId = costcoPayPaymentObject.costcoPayUserId;
				COSTCO.dialog.createExtDialogBox({
					title: messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_TITLE,
					body: messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_BODY,
					primary: messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_PRIMARY,
					secondary: messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_SECONDARY,
					primary_event: function primary_event() {
						ajaxModular.ajax_update_state({
							method: 'POST',
							url: '/AjaxManageCostcoPayPaymentCmd',
							data: { 'authTokenId': authTokenId,
								'costcoPayUserId': costcoPayUserId,
								'action': 'delete' },
							dataType: 'json',
	
							done: function done(data, textStatus, jqXHR, options) {
								ajaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
								COSTCO.util.accesible_popover($('.co-info, .co-help'));
								if (typeof CostcoPayAccountInformation.getCostcoPayUserId() !== 'undefined') {
									COSTCO.CostcoPayFob.getCostcoPayFobs();
								}
								COSTCO.dialog.close();
							},
							always: function always() {
								$('.order-ajax').removeClass('ajax-busy');
							}
						});
					}
				});
			}
		};
		window.COSTCO.CostcoPayAccountInformation = CostcoPayAccountInformation;
		return CostcoPayAccountInformation;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title ajax-modular.js: Feature level module
	 * @description Utility module associated with ajax modular
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var AjaxModular = {
	
	    /**
	     * A generic function to make ajax requests. The only difference being
	     * that this function sets a default done promise that injects html
	     * into the DOM with the response data. Pass done, fail, and always
	     * functions to the options object to be called in each respective promise.
	     * @param  {Object} options Object containing options to pass to $.ajax
	     *                          and functions to call within $.ajax promises.
	     * @return {void}
	     */
	    ajax_update_state: function ajax_update_state(options) {
	
	      $('.order-ajax').addClass('ajax-busy');
	
	      var checkoutPageName = typeof checkoutPage === 'undefined' ? false : checkoutPage;
	      if (options.page || checkoutPageName) {
	        options.url = COSTCO.util.makeUrl(options.url, {
	          'checkoutPage': options.page || checkoutPageName
	        });
	      }
	      // For appending HTML, caller should override options property by setting
	      // ajax_replace_content: COSTCO.AjaxModular.ajax_append_content
	      // this will be reflected in ajax_update_default_done method (look below)
	      if (!options.done) options.done = COSTCO.AjaxModular.ajax_update_default_done;
	      if (!options.always) options.always = COSTCO.AjaxModular.ajax_update_default_always(options.inputContainer);
	      COSTCO.util.ajax(options);
	    },
	
	    /**
	     * Default implementation of the done promise used by ajax_update_state.
	     * The data structure this function uses is defined in JSONLayout.jsp.
	     * Update the state of each html segment. This assumes that the
	     * property key maps to the id of the html segment to replace. Also,
	     * if there any errors defined on the response_obj.error,
	     * display them.
	     * @param  {String} data       The JSON returned as a string. Contains
	     *                             the encoded html that must be decoded
	     *                             and then is injected into the DOM.
	     * @param  {String} textStatus [description]
	     * @param  {String} jqXHR      [description]
	     * @param  {Object} options    The options object originally passed to
	     *                             ajax_update_state
	     * @return {void}
	     */
	    ajax_update_default_done: function ajax_update_default_done(data, textStatus, jqXHR, options) {
	      try {
	        var response_obj = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : JSON.parse(data);
	        var defaultOptions = {
	          ajax_replace_content: COSTCO.AjaxModular.ajax_replace_content,
	          ajax_handle_errors: COSTCO.AjaxModular.ajax_handle_errors,
	          ajax_update_post_done: function ajax_update_post_done() {},
	          error_container: '',
	          scrollToError: true
	        };
	
	        //trigger start event
	        COSTCO.AjaxModular.triger_event('costco.ajax.content.update.start', response_obj, options.start_event);
	
	        //override any defaults that came from options input parameter
	        var mergedOptions = $.extend(true, {}, defaultOptions, options);
	
	        // Inject New Html
	        mergedOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
	
	        // Post Html Injection
	        mergedOptions.ajax_update_post_done(response_obj, mergedOptions, defaultOptions);
	
	        // Handle any Errors and perform cleanup
	        mergedOptions.ajax_handle_errors(response_obj, mergedOptions, defaultOptions);
	
	        //trigger end event        
	        COSTCO.AjaxModular.triger_event('costco.ajax.content.update.end', response_obj, options.end_event);
	      } catch (e) {
	        console.error(e);
	      }
	      console.log('ajax_update_default_done');
	    },
	
	    ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
	      Object.keys(response_obj.payload.html).forEach(function (key) {
	        var encoded_html = response_obj.payload.html[key];
	        if (mergedOptions.replaceKey) {
	          if (mergedOptions.replaceKey.original == key) {
	            key = mergedOptions.replaceKey.replace;
	          }
	        }
	        $('#' + key).html(COSTCO.util.get_decoded_html(encoded_html));
	        console.log('ajax_replace_content ' + key);
	      });
	    },
	
	    /**
	    * Append content to the end of already existing div html 
	    */
	    ajax_append_content: function ajax_append_content(response_obj, mergedOptions, defaultOptions) {
	      Object.keys(response_obj.payload.html).forEach(function (key) {
	        var encoded_html = response_obj.payload.html[key];
	        if (mergedOptions.replaceKey) {
	          if (mergedOptions.replaceKey.original == key) {
	            key = mergedOptions.replaceKey.replace;
	          }
	        }
	        $('#' + key).append(COSTCO.util.get_decoded_html(encoded_html));
	      });
	    },
	
	    ajax_handle_errors: function ajax_handle_errors(response_obj, mergedOptions, defaultOptions) {
	
	      if (COSTCO.util.isBusinessDelivery()) {
	        if (COSTCO.CreditCard && COSTCO.CreditCard.isCybersourceEnabled()) {
	          $('.error:not(.error-qty-increment, #cc_cvc, #cc_cvc_err_msg)').empty();
	        } else {
	          $('.error:not(.error-qty-increment)').empty(); // clear any errors that may be on the page
	        }
	      } else {
	        if (COSTCO.CreditCard && COSTCO.CreditCard.isCybersourceEnabled()) {
	          $('.error:not(select, #cc_cvc, #cc_cvc_err_msg)').empty();
	          $('.error:not(select)').removeClass('critical-notification');
	        } else {
	          $('.error:not(select)').empty().removeClass('critical-notification'); // clear any errors that may be on the page
	        }
	      }
	
	      var error_container = mergedOptions.error_container;
	
	      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
	      // ### Author: START
	
	      // if (typeof Checkout !== 'undefined' && (Checkout.isReviewPage() || Checkout.isPaymentPage())) {
	      //  if(typeof TokenGateway !== 'undefined'){
	      //     TokenGateway.refreshGateway();
	      //   }
	      //  if(response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr) {
	      //   error_container = '#errquantity_application_';
	      //   	  $('#errquantity_application_').addClass('critical-notification');
	      //   	  $('#errquantity_application_').removeClass('error');
	      //   	  $("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');
	
	      //   	  if($('#errquantity_application_').html().trim() == ''){
	      //   		  $('#errquantity_application_').html(response_obj.metadata.quantityUpdatedForCashCardPaymentErr);
	      //   	  }
	      //  }
	      //  else{
	      //   if(typeof COSTCO.CreditCard !== 'undefined'){
	      //   		  COSTCO.CreditCard.init();
	      //   	  }
	
	      //   if(typeof COSTCO.wallet !== 'undefined'){
	      // ### Author: END
	
	
	      // ### Author: START
	      // 	  //wallet module is not used in USBD - all other allow 
	      // 	  if (wcs.storeId !='11301') {
	      // 		  COSTCO.wallet.init();    				  
	      // 	  }
	      // ### Author: END
	
	      // ### Author: START
	      //   }
	      //   if(typeof COSTCO.CC !== 'undefined'){
	      // 	  COSTCO.CC.init();
	      //   }  
	      //  }
	      // }
	      // ### Author: END
	
	
	      var input_container = mergedOptions.input_container;
	      var application = response_obj.error.application || [];
	      var exception = response_obj.error.exception || [];
	      var error_html = '';
	      if (exception.length > 0) {
	        error_html += '<p>An unexpected error has occured</p>';
	      }
	      application.forEach(function (error_message) {
	        error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
	      });
	      // if there is a redirect, store the error in sessionStorage and redirect user,
	      // otherwise error will show in error container
	      if (response_obj.error.redirect) {
	        if (typeof sessionStorage != 'undefined') {
	          sessionStorage.setItem('errorMessage', error_html); // store error_html in sessionStorage to show on redirected page
	        }
	        document.location.href = '/' + response_obj.error.redirect;
	        return;
	      }
	      if (typeof error_container === 'string') {
	        error_container = $(error_container);
	      }
	      if (input_container) {
	        if (application.length + exception.length > 0) {
	          $(input_container).addClass('error');
	          $(input_container).attr('aria-invalid', 'true');
	        } else {
	          $(input_container).removeClass('error');
	          $(input_container).attr('aria-invalid', 'false');
	        }
	      }
	
	      // TODO: Rename trigger to more general name
	      if (error_container == '' || error_container.length == 0) {
	        COSTCO.AjaxModular.triger_event('costco.ajax.content.update.sucess', response_obj);
	        return;
	      }
	      error_container.children().remove();
	
	      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
	      // ### Author: START
	      // if(response_obj.metadata.quantityUpdatedForCashCardPaymentErr && error_html.length > 0){
	      //  $(error_container).html('');
	      // }
	      // ### Author: END
	
	      error_container.append(error_html);
	
	      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
	      // ### Author: START
	      // if($('#errquantity_application_').length > 0 && $('#errquantity_application_').html().trim() != ''){
	      //  if(!COSTCO.OrderSummary.isAllPaidByCashCard()){
	      //   COSTCO.Checkout.showPaymentEditSection();
	      //  } 
	      //  else{
	      //   $('#errquantity_application_').html('');
	      //   $('#errquantity_application_').removeClass('critical-notification');
	      //   	  $('#errquantity_application_').addClass('error');
	      //  }   	  
	      //  COSTCO.CC.init();
	      // }
	      // else if($('#errquantity_application_').length > 0){
	      //  $('#errquantity_application_').removeClass('critical-notification');
	      //  $('#errquantity_application_').addClass('error');
	      // }
	      // ### Author:  END
	
	
	      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
	      // ### Author: START
	      //This will do the real work - I have no idea what the above code does.
	      //This will place error messages in-line
	      // if ($('#isBDAppVar').val() == 'BD') {
	      //  COSTCO.OrderItems.placeGlobalCartErrorsInLine(response_obj);
	      // }
	      // ### Author: END
	
	      if (mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)) {
	
	        // TODO: Rename trigger to more general name
	        $('body').trigger('costco.ajax.content.update.error', response_obj);
	        $('body, html').animate({
	          scrollTop: $(error_container).offset().top - 30
	        }, 800);
	      }
	    },
	
	    /**
	     * Extracting default function out so we can perfom this and something else
	     */
	    ajax_update_default_always: function ajax_update_default_always(inputContainer) {
	      $('.order-ajax').removeClass('ajax-busy');
	      COSTCO.Checkout.validator = undefined;
	      // Create a function to focus back to the original input after
	      // the ajax call is done
	      // This will only be done only if there input is defined in the option payload
	      if (inputContainer) {
	        var focusInput = $(inputContainer);
	        // If we have the id then lets use it
	        if (focusInput[0].id) {
	          console.log(focusInput[0].id);
	          $('#' + focusInput[0].id).focus();
	        } else {
	          console.log('Working for it');
	          // Ok no id so now we have to do work
	          if (focusInput[0].nodeName == 'INPUT') {
	            if (focusInput.attr('type') == 'radio' && focusInput.attr('name')) {
	              $('input:checked[name="' + focusInput.attr('name') + '"]').focus();
	            }
	          }
	        }
	      }
	    },
	
	    /**
	     * Triggers an event
	     *
	     * @param {String}   default_event   Required parameter. It is the default name of the event
	                                         to be triggered in case that 'event' param is not passed
	     * @param {Object}   response_obj    Object to be passed to event listener
	     * @param {String}   event           Custom event name to be triggered. If not specified, 'defaultEvent' will be used
	     *
	     * @return {void}
	     */
	    triger_event: function triger_event(default_event, response_obj, event) {
	      var eName = typeof event === 'undefined' ? default_event : event;
	      $('body').trigger(eName, response_obj);
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.AjaxModular = AjaxModular;
	  return AjaxModular;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title costcopay-fobs.js: Sub module for Account pages
	 * @description: This module is used to query and handle costco pay receipts
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ajaxModular) {
		var CostcoPayTransactionHistory = {
			GET_COSTCO_PAY_TRANS_HIST: '/AjaxCostcoPayGetTransactionCmd',
			getForm: function getForm() {
				return $('#tran-history-filter');
			},
			init: function init() {
				$('#purchase-history-tab').on('shown.bs.tab', function (event) {
					CostcoPayTransactionHistory.getCostcoPayReceipts();
				});
			},
			/**
	   * Function used to query the costco pay transaction history to get a list of
	   * transaction history by calling the ajax command with the form content. 
	   * 
	   * This function will be called upon when there is a need to replace the entire content
	   * of the transaction history. Namely when filter or the sort method change.
	   */
			getCostcoPayReceipts: function getCostcoPayReceipts() {
				var form = CostcoPayTransactionHistory.getForm();
	
				var errorCont = $('#tran-history-crit-error');
				errorCont.empty();
	
				var selectedPeriod = $('#trans_hist_date_select option:selected').data("value");
				var fromMonth = parseInt(selectedPeriod.fromMonth);
				var fromYear = parseInt(selectedPeriod.fromYear);
				var endMonth = parseInt(selectedPeriod.endMonth);
				var endYear = parseInt(selectedPeriod.endYear);
	
				$(form).find('input[name=fromMonth]').val(fromMonth);
				$(form).find('input[name=fromYear]').val(fromYear);
				$(form).find('input[name=endMonth]').val(endMonth);
				$(form).find('input[name=endYear]').val(endYear);
	
				//Set offset back to 0 since we want go back to 0
				$(form).find('input[name=offset]').val(0);
	
				$('#costco-pay-transactions').addClass('ajax-busy');
				ajaxModular.ajax_update_state({
					url: CostcoPayTransactionHistory.GET_COSTCO_PAY_TRANS_HIST,
					method: 'GET',
					data: COSTCO.util.objectifyArray(form.serializeArray()),
					dataType: 'json',
					done: function done(data, textStatus, jqXHR, options) {
						if (!data.errorMessage) {
							ajaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
						} else {
							var _errorCont = $('#tran-history-crit-error');
							_errorCont.text(data.errorMessage);
							_errorCont.removeClass('hide');
						}
					},
					always: function always() {
						$('#costco-pay-transactions').removeClass('ajax-busy');
					}
				});
			},
			/**
	   * Function used to export costco pay transaction history in a csv
	   */
			exportCostcoPayReceipts: function exportCostcoPayReceipts(e) {
				var form = CostcoPayTransactionHistory.getForm();
				var param = COSTCO.util.objectifyArray(form.serializeArray());
				var downloadUrl = COSTCO.util.makeUrl('/ExportCostcoPayTransactionCmd', param);
	
				window.open(downloadUrl);
	
				e.preventDefault();
			},
			/**
	   * Function used to get the next set of record for costco pay transaction history
	   * 
	   */
			getMoreCostoPayReceipts: function getMoreCostoPayReceipts(e) {
	
				var form = CostcoPayTransactionHistory.getForm();
	
				var numRecords = $('.transaction-row').length;
				$(form).find('input[name=offset]').val(numRecords);
	
				$('#costco-pay-transactions').addClass('ajax-busy');
	
				ajaxModular.ajax_update_state({
					url: CostcoPayTransactionHistory.GET_COSTCO_PAY_TRANS_HIST,
					method: 'GET',
					data: COSTCO.util.objectifyArray(form.serializeArray()),
					dataType: 'json',
					done: function done(data, textStatus, jqXHR, options) {
						//get rid of the current load more link
						$('#pagination-footer').remove();
						ajaxModular.ajax_update_default_done(data, textStatus, jqXHR, { ajax_replace_content: COSTCO.AjaxModular.ajax_append_content });
					},
					always: function always() {
						$('#costco-pay-transactions').removeClass('ajax-busy');
					}
				});
				//Used to prevent link to go up
				e.preventDefault();
			}
		};
		window.COSTCO.CostcoPayTransactionHistory = CostcoPayTransactionHistory;
		return CostcoPayTransactionHistory;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @title timeoutModal.js: Feature level module
	 * @description The module used for displaying and handling the timeout modal
	 * 
	 */
	var WorkerInterval = function () {
		function WorkerInterval(callback, interval) {
			_classCallCheck(this, WorkerInterval);
	
			var blob = new Blob(['setInterval(() => postMessage(0), ' + interval + ');']);
			var workerScript = URL.createObjectURL(blob);
			this.worker = new Worker(workerScript);
			this.worker.onmessage = callback;
		}
	
		_createClass(WorkerInterval, [{
			key: 'stop',
			value: function stop() {
				this.worker.terminate();
			}
		}]);
	
		return WorkerInterval;
	}();
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util) {
	
		var timeoutModal = {
			/*
	   * timerCountdown is set to 5min and 5seconds
	   * the 15 second bufferTimer is needed to account 
	   * for page load + ajax delivery time
	   */
			state: null,
			timer: wcs.isPharmacy === 'true' ? 900000 : wcs.loginTimeOut,
			timerCountdown: 300000,
			bufferTimer: 15000,
			backgroundModalSettings: null,
			lastActiveElement: null,
			timerInterval: null,
			timerSetTimeout: null,
			data: null,
			START_TIME: '05',
			/*
	   * constants defined for state only
	   */
			INITIALIZED: 'Initialized',
			DISPLAYED: 'Displayed',
			TIMEDOUT: 'Timed Out',
			CLEARING: 'Clearing',
	
			/*
	   * ALM 32035
	   * Create list hydrator
	   */
			createListInputValue: null,
	
			/*
	   * On init we check if user is signed in, 
	   * if not we do not init
	   */
			init: function init() {
				var timeUntilInit = timeoutModal.timer - timeoutModal.timerCountdown - timeoutModal.bufferTimer;
				timeoutModal.state = timeoutModal.INITIALIZED;
				if (COSTCO.util.isUserLoggedIn() && (wcs.isPharmacy === 'true' || !COSTCO.Header.isKmsiSession())) {
					//start timeout modal timing
					timeoutModal.timerSetTimeout = setTimeout(function () {
						console.log('loading timeout modal wcs.loginTimeout = ' + wcs.loginTimeOut);
						timeoutModal.displayTimeoutModal();
					}, timeUntilInit);
				}
				return;
			},
	
			/*
	   * Finds any modal in the background and copies its settings,
	   * displays the timeout modal and scrolls to the appropriate section
	   */
			displayTimeoutModal: function displayTimeoutModal() {
				if (COSTCO.dialog.isVisible()) {
					timeoutModal.backgroundModalSettings = COSTCO.dialog.getSettings();
				}
				COSTCO.dialog.initializeReturnFocusListener();
				timeoutModal.lastActiveElement = document.activeElement;
				timeoutModal.checkForCreateNewList();
				COSTCO.dialog.showAndHideModal(timeoutModal.loadTimeoutModalSettings());
				window.scrollTo(0, 0);
			},
	
			/*
	   * Creates a 5min countdown timer 
	   * Modifies body text based on timeLeft 
	   * seconds and minutes are formatted to have 2 digits
	   * this function is killed in resetTimeoutModal()
	   */
			countdown: function countdown() {
				timeoutModal.state = timeoutModal.DISPLAYED;
				var timeLeft = new Date(timeoutModal.timerCountdown);
				var textBody = messages.TIMEOUT_MODAL_BODY;
				$('#timeout-modal-countdown-text').html(textBody.replace('{0}', timeoutModal.START_TIME).replace('{1}', '00'));
				timeoutModal.timerInterval = new WorkerInterval(function () {
					if (timeLeft.getSeconds() === 0 && timeLeft.getMinutes() === 0) {
						timeoutModal.state = timeoutModal.TIMEDOUT;
						timeoutModal.resetTimeoutModal();
						COSTCO.dialog.close();
						var isAddressBookDisplayView = document.location.pathname === '/AddressBookDisplayView';
						if (isAddressBookDisplayView) {
							document.location.href = 'Logoff?URL=ReLogonFormView';
						} else if (wcs.isPharmacy === 'true') {
							document.location.href = 'Logoff?usrClk=true';
						}
						return;
					}
					var seconds = timeLeft.getSeconds() < 10 ? '0' + timeLeft.getSeconds() : timeLeft.getSeconds();
					var minutes = timeLeft.getMinutes() < 10 ? '0' + timeLeft.getMinutes() : timeLeft.getMinutes();
					var textBodyCopy = textBody.replace('{0}', minutes).replace('{1}', seconds);
					$('#timeout-modal-countdown-text').html(textBodyCopy);
					timeLeft = new Date(timeLeft - 1000);
				}, 1000);
			},
	
			/*
	   * Makes an ajax call to /AjaxRefreshUserSession
	   * on success it resets and re-inits the modal sequence
	   * on failure it resets and closes the modal
	   */
			ajaxRefreshUserSession: function ajaxRefreshUserSession() {
				$.ajax({
					url: wcs.isPharmacy === 'true' ? '/AjaxRefreshUserSession?isPharmacy=true' : '/AjaxRefreshUserSession',
					success: function success(data) {
						timeoutModal.data = JSON.parse(data);
						if (timeoutModal.data.status === '1') {
							console.log("success refreeshing session");
							timeoutModal.timerInterval.stop();
						} else {
							console.log('error refreshing session');
						}
					},
					error: function error(data) {
						console.log('error making ajax call');
						COSTCO.dialog.close();
					}
				});
			},
	
			/*
	   * set of modal options - see costcodialog.js for root 
	   * 2nd onclick event listener is for the close button 
	   * necessary to setTimeout and call the function as is 
	   * because order of execution loses the other function call
	   */
			loadTimeoutModalSettings: function loadTimeoutModalSettings() {
				var modalOptions = {
					title: messages.TIMEOUT_MODAL_HEADER,
					body: COSTCO.util.tmpl('tmpl_timeout_modal'),
					hideFooter: true,
					preventClose: true,
					onshown: function onshown(e) {
						timeoutModal.countdown();
						e.preventDefault();
						$('#timeout-submit').focus();
						$('#timeout-submit').on('click', function (e) {
							e.preventDefault();
							timeoutModal.modalOnclick();
						});
						$('#timeout-cancel').on('click', function (e) {
							e.preventDefault();
							COSTCO.dialog.close();
						});
						$('#timeout-modal').parent().prev().find('.co-close').on('click', function (e) {
							COSTCO.dialog.close();
							e.preventDefault();
							$(this).unbind();
						});
					},
					close: function close() {
						COSTCO.dialog.close();
					}
				};
				return modalOptions;
			},
	
			/*
	   * general handler for closing/refreshing the timeout modal
	   * this is called on click/spacebar for any button of the timeout modal
	   */
			modalOnclick: function modalOnclick() {
				timeoutModal.ajaxRefreshUserSession();
				if (COSTCO.dialog.isVisible()) {
					timeoutModal.backgroundModalSettings === null ? COSTCO.dialog.close() : COSTCO.dialog.showAndHideModal(timeoutModal.backgroundModalSettings);
					$(timeoutModal.lastActiveElement).focus();
				}
				timeoutModal.resetTimeoutModal();
				if (timeoutModal.state !== timeoutModal.TIMEDOUT) {
					new COSTCO.timeoutModal.init();
				}
			},
	
			/*
	   * resets all values and clears state 
	   * clears intervals and timeouts 
	   */
			resetTimeoutModal: function resetTimeoutModal() {
				if (timeoutModal.state !== timeoutModal.TIMEDOUT) {
					timeoutModal.state = timeoutModal.CLEARING;
				}
				timeoutModal.backgroundModalSettings = null;
				clearInterval(timeoutModal.timerInterval);
				clearTimeout(timeoutModal.timerSetTimeout);
				if (timeoutModal.state === timeoutModal.TIMEDOUT) {
					console.log("Session timed out");
				} else {
					console.log("TIMEOUT MODAL DONE CLEARING");
				}
			},
	
			checkForCreateNewList: function checkForCreateNewList() {
				if (timeoutModal.backgroundModalSettings !== null && timeoutModal.backgroundModalSettings.primary === messages.MA_CREATELIST) {
					timeoutModal.backgroundModalSettings.onshown = function () {
						$('#listidname').val(COSTCO.timeoutModal.createListInputValue);
						$('#listidname').focus();
					};
					var listIdNameVal = $('#listidname').val();
					timeoutModal.createListInputValue = listIdNameVal;
				}
			}
		};
	
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
		/*
	  * exposing the file to global
	  * use COSTCO.timeoutModal.xxx to check
	  * any constants defined at the top
	  */
		window.COSTCO.timeoutModal = timeoutModal;
		return timeoutModal;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title digital-membership-card.js: Sub-module for Account pages
	 * @description This module is used to handle tasks on Account -> Digital Membership Card
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var DigitalMembershipCard = {
	
			//Each redirection ends up on same page -> DigitalMembershipCardView (DigitalMembershipCardBody.jsp) with different flowId
			// Depending on flow and device type user get different functionalities. 
			flowId: '',
			//Below is list of all flows that JS handles. There are some flows that are not handled by JS logic
			// There are some flows like session-expire that are still not in JS but it should be. TODO  
			FLOWS: {
				// OTP flow
				YELLOW_FLOW: 'otp',
				// After successfully received SMS token 
				YELLOW_FLOW_TOKEN: 'otpValidate',
				// ERROR Flows
				TRY_AGAIN: 'tryAgainAction',
				TRY_AGAIN_BAD_REQUEST: 'tryAgainActionBadRequest',
				OTP_TRY_AGAIN: 'tryAgainOTPAction',
				DEPROVISION_TRY_AGAIN: 'tryAgainDeprovisionAction',
				RED_FLOW: 'RED',
				// ERROR Flows in OTP flow
				MAXIMUM_ATTEMPTS_LIMIT_EXCEEDED: 'maximumAttemptsLimitExceeded',
				RED_OTP_EXPIRE: 'expireOTP',
				RED_UNVERIFIED_PHONE: 'unverifiedPhone',
				UN_AUTHORIZED: 'unAuthorized',
				INVALID_REQUEST: 'invalidRequest',
				INVALID_OTP: 'invalidOTP',
				SESSION_EXPIRE: 'sessionExpire'
	
			},
	
			// Template names
			// Cvv screen for provisioning of cards
			dmcCvvScreenTemplate: 'dmc_add_CC_form_tmpl',
			// Main template that contain image title text and action buttons. 
			dmcProvisionMainTemplate: 'dmc_CC_provisioning_form_tmpl',
			// Error template that gets loaded into main template 
			dmcProvisionRedPathTemplate: 'dmc_CC_provisioning_red_path_tmpl',
			// OTP template that contain choose buttons gets loaded into main template
			dmcProvisionOtpChooseTemplate: 'dmc_CC_provisioning_yp_choose_tmpl',
			// OTP second screen template that contains sms token form gets loaded into main template
			dmcProvisionAddSMSTokenTemplate: 'dmc_CC_provisioning_yp_add_token_tmpl',
			// Load template as body of a dialog
			dmcDialogTemplate: 'dmc_dialog_tmpl',
	
			// Selectors for div's and button
			dmcContent: '#dmc-content',
			dmcProvisioningContent: '#dmc-cc-provisioning-content',
			// Based on flow dmc actions button has different values and is binded to different actions.
			// It is used as continue button in different flows and it can be used as Back To Digital Membership button. 
			dmcActionsButton: '#dmc-cc-actions-button',
			dmcCancelButton: '#dmc-cancel-cc-button',
			dmcChooseButton: '.dmc-radio-button',
			// Back to DMC title
			dmcBackToDMCTitle: 'Return to Digital Membership',
			dmcBackToDMCClass: 'back-to-dmc',
			dmcPaymentTitle: '#dmc-payment-title',
			dmcOTPContinue: 'continue-button',
			dmcValidationCodeExpired: 'dmcValidationCodeExpired',
			dmcValidationCodeExpTime: 'dmcValidationCodeExpTime',
			dmcCountDownFinishedMessage: '0 minutes and 0 seconds',
			dmcTimer: '#timer',
			dmcAddTokenForm: '#dmc-yp-add-token-form',
			dmcDialogForm: '#dmc-dialog-form',
			dmcRedPathForm: '#dmc-red-path-form',
			dmcSmsOptions: '#dmc-sms-option',
			dmcVoiceOptions: '#dmc-voice-option',
			cvvNumber: '#cvvNumber',
			aliasId: '#aliasId',
			otpDeliveryOption: '#otpDeliveryOption',
			verificatonMethodSms: '#verificaton-method-sms',
			verificatonMethodVoice: '#verificaton-method-voice',
	
			/**
	   * Initialization of the module.
	   */
			init: function init() {
	
				// Load functionality and layout for mobile browser and mobile redirected from COSTCO app.
				$(document).ready(function () {
					$('#dmc-bottom-divider').show();
					if (COSTCO.Navigation_v2.isPhoneView()) {
						// If user comes from mobile APP provision of card should be available. 
						if ($('#deviceType').val() != 'web-app') {
							DigitalMembershipCard.flowId = $('#flowId').val();
							DigitalMembershipCard.loadDmcPaymentMobileView();
						}
					} else {
						DigitalMembershipCard.loadDmcPaymentWebView();
					}
					$('.dmc-box img').attr('alt', '');
					$('#cardExpiryDate').unmask().mask('00/00');
					$('#postalCode').unmask().mask('00000');
					$('#dmc-sms-token').unmask().mask('000000000000000');
					$('#cvvNumber').unmask().mask('000');
					// Takes max height of card and apply that height to oder cards
					$(window).on('load', function () {
						setTimeout(DigitalMembershipCard.alignCardsBox, 200);
					});
				});
				COSTCO.MemberVerification.init();
			},
	
			/**
	   *  This method contains main logic for users that are redirected from mobile application. 
	   *  Based on flowId returned from backend commands particular templates are loaded, and 
	   *  required classes and button behaviors  are changed accordingly.
	   *  Also after execution of logic binding of events is done.
	   *    
	   * */
			loadDmcPaymentMobileView: function loadDmcPaymentMobileView() {
				$('#header-title').hide();
				$('#topnav').hide();
				$('.mini-banner').hide();
				DigitalMembershipCard.dmcRemoveHiddenClass(DigitalMembershipCard.dmcActionsButton);
				DigitalMembershipCard.dmcRemoveHiddenClass('.dmc-set-as-default');
				$('#dmc-bottom-divider').hide();
	
				if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.RED_FLOW || DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.MAXIMUM_ATTEMPTS_LIMIT_EXCEEDED || DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.RED_UNVERIFIED_PHONE || DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.INVALID_REQUEST) {
	
					DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionMainTemplate, DigitalMembershipCard.dmcContent, {});
					$(DigitalMembershipCard.dmcCancelButton).hide();
					$(DigitalMembershipCard.dmcActionsButton).val(DigitalMembershipCard.dmcBackToDMCTitle);
					$(DigitalMembershipCard.dmcPaymentTitle).addClass('hidden');
	
					if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.MAXIMUM_ATTEMPTS_LIMIT_EXCEEDED) {
						DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionRedPathTemplate, DigitalMembershipCard.dmcProvisioningContent, {});
						DigitalMembershipCard.dmcRemoveHiddenClass('#dmc-max-attempts-error');
					} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.RED_FLOW) {
						DigitalMembershipCard.loadCVVTemplate();
						$(DigitalMembershipCard.dmcContent).prepend('<p>' + messages.DMC_RED_PATH_ERROR + '</p>');
						$(DigitalMembershipCard.dmcContent + ' > p:eq(0)').addClass('critical-notification');
					} else {
						DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionRedPathTemplate, DigitalMembershipCard.dmcProvisioningContent, {});
						DigitalMembershipCard.dmcRemoveHiddenClass('#dmc-payment-methods-error');
					}
					$(DigitalMembershipCard.dmcActionsButton).addClass(DigitalMembershipCard.dmcBackToDMCClass);
				} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.YELLOW_FLOW || DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.OTP_TRY_AGAIN) {
	
					$(DigitalMembershipCard.dmcActionsButton).removeClass(DigitalMembershipCard.dmcBackToDMCClass);
					$(DigitalMembershipCard.dmcPaymentTitle).addClass('hidden');
					DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionMainTemplate, DigitalMembershipCard.dmcContent, {});
					DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionOtpChooseTemplate, DigitalMembershipCard.dmcProvisioningContent, DigitalMembershipCard.parameters());
	
					if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.OTP_TRY_AGAIN) {
						$('#dmc-choose-radio-button-group').prepend('<p>' + messages.DMC_TRY_AGAIN_MESSAGE + '</p>');
						$('#dmc-choose-radio-button-group > p:eq(0)').addClass('critical-notification cds-u-space-mt-md cds-u-space-mb-md');
					}
				} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.YELLOW_FLOW_TOKEN || DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.RED_OTP_EXPIRE || DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.SESSION_EXPIRE || DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.INVALID_OTP) {
	
					$(DigitalMembershipCard.dmcPaymentTitle).addClass('hidden');
					DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionMainTemplate, DigitalMembershipCard.dmcContent, {});
					DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionAddSMSTokenTemplate, DigitalMembershipCard.dmcProvisioningContent, DigitalMembershipCard.parameters());
					$(DigitalMembershipCard.dmcActionsButton).addClass('submit-token');
	
					if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.RED_OTP_EXPIRE || DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.SESSION_EXPIRE) {
						sessionStorage.setItem(DigitalMembershipCard.dmcValidationCodeExpired, true);
						DigitalMembershipCard.dmcTokenFieldValidation();
						$('#dmc-sms-token').val($('#enteredTokenValue').val());
						$(DigitalMembershipCard.dmcTimer).text(DigitalMembershipCard.dmcCountDownFinishedMessage);
					} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.INVALID_OTP) {
						$('#dmc-sms-token').addClass('error');
						$('#dmc-sms-token-label').addClass('active');
						$('<label for="dmc-sms-token" class="error active" >' + messages.ERR_INVALID_DMC_TOKEN + '</label>').insertAfter('#dmc-sms-token');
						$('#dmc-sms-token').val($('#enteredTokenValue').val());
						DigitalMembershipCard.countDown();
					} else {
						DigitalMembershipCard.countDown();
					}
				} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.TRY_AGAIN_BAD_REQUEST) {
					DigitalMembershipCard.loadCVVTemplate($('#brand').val(), $('#displayAccountNumber').val(), $('#accountHolderName').val());
					$(DigitalMembershipCard.dmcContent).prepend('<p>' + messages.DMC_TRY_AGAIN_CVV_MESSAGE + '</p>');
					$(DigitalMembershipCard.dmcContent + ' > p:eq(0)').addClass('critical-notification');
				} else {
	
					DigitalMembershipCard.dmcRemoveHiddenClass(DigitalMembershipCard.dmcPaymentTitle);
					var dmcOneNonProvisionedCard = $('#dmc-one-non-provisioned-card').val();
					if (dmcOneNonProvisionedCard == 'true' || DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.TRY_AGAIN) {
						DigitalMembershipCard.loadCVVTemplate($('#brand').val(), $('#displayAccountNumber').val(), $('#accountHolderName').val());
						if (dmcOneNonProvisionedCard == 'true') {
							$(DigitalMembershipCard.dmcContent).append('<input id="dmc-one-non-provisioned-card" type="hidden" value="true" />');
						}
						if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.TRY_AGAIN) {
							$(DigitalMembershipCard.dmcContent).prepend('<p>' + messages.DMC_TRY_AGAIN_MESSAGE + '</p>');
							$(DigitalMembershipCard.dmcContent + ' > p:eq(0)').addClass('critical-notification');
							$('#cardExpiryDate').val($('#dmcCardExpiryDate').val());
							$('#cardExpiryDateLabel').addClass('active');
							$(DigitalMembershipCard.cvvNumber).val($('#dmcCvvNumber').val());
							$('#cvvNumberLabel').addClass('active');
							$('#postalCode').val($('#dmcPostalCode').val());
							$('#postalCodeLabel').addClass('active');
						}
					} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.DEPROVISION_TRY_AGAIN) {
						$(DigitalMembershipCard.dmcContent).prepend('<p>' + messages.DMC_TRY_AGAIN_DEPROVISION_MESSAGE + '</p>');
						$(DigitalMembershipCard.dmcContent + ' > p:eq(0)').addClass('critical-notification');
					}
				}
	
				DigitalMembershipCard.bindDmcEvents();
			},
			/**
	   * This method handles the view for users that are using web app.
	   */
			loadDmcPaymentWebView: function loadDmcPaymentWebView() {
				$('#dmc-desc-and-faq').removeClass('dmc-desc-and-faq-hidden');
				$('#dmc-desc-and-faq').addClass('dmc-desc-and-faq-visible');
				$('#dmc-download-app').show();
				$('#dmc-payment-on-application').show();
			},
	
			/**
	   *  This method is used to pass important information as parameters when different templates are loaded 
	   *  forms from those templates are submitted.
	   *  It can be called in different scenarios which requires to be called with some parameters.
	   *  
	   *  @param brand,  displayAccountNumber, accountHolderName
	   *  @return parameters 
	   * */
			parameters: function parameters(brand, displayAccountNumber, accountHolderName) {
	
				var parameters = {
					//data for forms
					ipAddress: $('#ipAddress').val(),
					geoLong: $('#geoLong').val(),
					geoLat: $('#geoLat').val(),
					deviceId: $('#deviceId').val(),
					deviceType: $('#deviceType').val(),
					memberCardNumber: $('#memberCardNumber').val(),
					dmcHash: $('#dmcHash').val(),
					profileId: $('#profileId').val(),
					displayAccountNumber: displayAccountNumber ? displayAccountNumber : $('#displayAccountNumber').val(),
					accountHolderName: accountHolderName ? accountHolderName : $('#accountHolderName').val(),
					otpDeliveryOption: $('#otpDeliveryOption').val(),
					phoneDetails: $('#phoneDetails').val(),
					aliasId: $('#aliasId').val(),
					brand: brand ? brand : $('#brand').val(),
					//testing resopnses
					otpResponse: $('#otpResponse').val(),
					otpMock: $('#otpMock').val(),
					mockresponse: $('#mockresponse').val(),
					otpToken: $('#otpToken').val(),
					doesProvisionedCardExist: $('#doesProvisionedCardExist').val()
	
				};
				return parameters;
			},
	
			/**
	   *  Cancel button on CVV screen can act differently. In one case when user has one CC it acts like back to membership
	   *  card button. In other case this method stores all CC's to hidden HTML element which is appended back to dmc-content 
	   *  if user click cancel button. 
	   *   
	   * */
			dmcCvvCancel: function dmcCvvCancel() {
				var dmcOneNonProvisionedCard = $('#dmc-one-non-provisioned-card').val();
				if (dmcOneNonProvisionedCard == 'true') {
					DigitalMembershipCard.backToDigitalMembership();
				} else {
					var dmcCobrandedCards = $('#dmc-cc-cards-hidden').html();
					$(DigitalMembershipCard.dmcContent).empty();
					DigitalMembershipCard.dmcRemoveHiddenClass($(DigitalMembershipCard.dmcContent).append(dmcCobrandedCards).find('#dmc-cc-cards-hidden'));
					$(DigitalMembershipCard.dmcActionsButton).show();
					DigitalMembershipCard.bindDmcEvents();
				}
			},
	
			/**
	   * 	Load of CVV screen can be done only for users redirected from mobile APP. It is used for provisioning of CC.
	   *  Can be called from different scenarios so it has params passed. One scenario is when user has only one CC
	   *  which is not defalt one. Other scenario is when user cancel and returns from OTP flow.
	   *  
	   *  Also calls dmcMobileValidation to validate the CVV form.
	   *  
	   *  @param brand, displayAccountNumber, accountHolderName
	   * */
			loadCVVTemplate: function loadCVVTemplate(brand, displayAccountNumber, accountHolderName) {
				// let cobrandedCards =   todo cancel button 
				$(DigitalMembershipCard.dmcActionsButton).hide();
				DigitalMembershipCard.dmcRemoveHiddenClass(DigitalMembershipCard.dmcPaymentTitle);
				DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcCvvScreenTemplate, DigitalMembershipCard.dmcContent, DigitalMembershipCard.parameters(brand, displayAccountNumber, accountHolderName));
				$('.dmc-input-field').each(function () {
					DigitalMembershipCard.addClassActive(this);
				});
				var dmcCobrandedCards = sessionStorage.getItem('dmc-cc-cards-hidden');
				$(DigitalMembershipCard.dmcContent).append('<div id="dmc-cc-cards-hidden">' + dmcCobrandedCards + '</div>').find('#dmc-cc-cards-hidden').addClass('hidden');
	
				DigitalMembershipCard.dmcMobileValidation();
				$('#cardExpiryDate').focus(function () {
					this.placeholder = 'MM/YY';
				});
				$('#cardExpiryDate').blur(function () {
					if (!$('#cardExpiryDate').val()) {
						$('#cardExpiryDateLabel').removeClass('active');
					}
					this.placeholder = '';
				});
			},
	
			/**
	   * Calls openDialog method and pass particular parameters and in this case of back to membership button call
	   * to DmcPaymentJSONResponseCmd which exits the browser and returns to mobile app. 
	   * 
	   * */
			backToDigitalMembership: function backToDigitalMembership() {
				if ($(DigitalMembershipCard.dmcRedPathForm).length > 0) {
					$(DigitalMembershipCard.dmcRedPathForm).submit();
				} else {
					DigitalMembershipCard.openDialog(messages.DMC_LEAVE_DMC_DIALOG_TITLE, messages.DMC_LEAVE_DMC_DIALOG_TEXT, messages.STAY_ON_PAGE_BUTTON, messages.LEAVE_PAGE_BUTTON, '', 'DmcPaymentJSONResponseCmd');
				}
			},
	
			/**
	   * Calls openDialog method and pass particular parameters and in this case when user don't have any CC's it will open
	   * credit-card.html page where user can apply for new cards. 
	   * 
	   * */
			dmcApply: function dmcApply() {
				DigitalMembershipCard.openDialog(messages.DMC_APPLY_DIALOG_TITLE, messages.DMC_APPLY_DIALOG_TEXT, messages.SUBMIT_CONTINUE, messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_SECONDARY, 'credit-card.html', '');
			},
	
			/**
	   * Calls openDialog method and pass particular parameters and in this case of deprovision of default card call
	   * to DmcPaymentChangeProvisionStatusCmd which calls the deprovisionDmcPayment method from DmcHelper. 
	   * 
	   * */
			removeDefaultCard: function removeDefaultCard() {
				DigitalMembershipCard.openDialog(messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_TITLE, messages.DMC_REMOVE_CARD_TEXT, messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_PRIMARY, messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_SECONDARY, 'DmcPaymentChangeProvisionStatusCmd', '');
				var membershipNumber = $('#memberCardNumber').val();
				var profileId = $('#profileId').val();
				var dmcInputHash = $('#dmcHash').val();
				var deviceType = $('#deviceType').val();
				var deviceId = $('#deviceId').val();
	
				$(DigitalMembershipCard.dmcDialogForm).append('<input name="actionProvision" type="hidden" value="deprovision"/>');
				$(DigitalMembershipCard.dmcDialogForm).append('<input name="membershipNumber" type="hidden" value="' + membershipNumber + '"/>');
				$(DigitalMembershipCard.dmcDialogForm).append('<input name="profileId" type="hidden" value="' + profileId + '"/>');
				$(DigitalMembershipCard.dmcDialogForm).append('<input name="dmcHash" type="hidden" value="' + dmcInputHash + '"/>');
				$(DigitalMembershipCard.dmcDialogForm).append('<input name="deviceType" type="hidden" value="' + deviceType + '"/>');
				$(DigitalMembershipCard.dmcDialogForm).append('<input name="deviceId" type="hidden" value="' + deviceId + '"/>');
			},
	
			/**
	   *  This method show user dialog loaded with different text and options based on parameters passed.
	   *  Based on which event is passed as empty that button will act as cancel button. Otherwise will submit 
	   *  the dialog form.
	   *  
	   * */
			openDialog: function openDialog(title, content, primaryButton, secondaryButton, primaryEvent, secondaryEvent) {
	
				var settings = {
					dialogclasses: 'dmc-dialog',
					title: title,
					body: COSTCO.util.tmpl(DigitalMembershipCard.dmcDialogTemplate, {
						content: content,
						action: primaryEvent != '' ? primaryEvent : secondaryEvent,
						target: primaryEvent == 'credit-card.html' ? '_blank' : ''
					}),
					footerText: '',
					preventClose: false,
					primary: primaryButton,
					secondary: secondaryButton,
					primary_event: function primary_event() {
						if (primaryEvent != '') {
							$(DigitalMembershipCard.dmcDialogForm).submit();
						}
						COSTCO.dialog.close();
					},
					secondary_event: function secondary_event() {
						if (secondaryEvent != '') {
							$(DigitalMembershipCard.dmcDialogForm).submit();
						}
						COSTCO.dialog.close();
					},
					close: function close() {
						COSTCO.dialog.close();
					}
				};
	
				COSTCO.dialog.createExtDialogBox(settings);
			},
	
			/**
	   * Remove class hidden for the passed selector.
	   * 
	   * @param selector
	   * */
			dmcRemoveHiddenClass: function dmcRemoveHiddenClass(selector) {
				$(selector).removeClass('hidden');
			},
	
			/**
	   * Loads template based on the name passed as parameter and appends it to the div based on div ID. 
	   * Dmc options can be used as parameters for controling the behaviour of template actions or simply as 
	   * information that needs to passed to the template.
	   * 
	   * @param templateName, dmcDivId, dmcOptions
	   * */
			appendDmcTemplate: function appendDmcTemplate(templateName, dmcDivId, dmcOptions) {
				var template = $(COSTCO.util.tmpl(templateName, dmcOptions));
				$(dmcDivId).empty();
				$(dmcDivId).append(template);
			},
	
			/**
	  * This is called from OTP flow only and it loads the template with choose buttons for user to retrieve new
	  * sms token so provision can be done. 
	  * Also invalidates session storage items entered in previous attempt. 
	  * */
			getAnotherOneSMSToken: function getAnotherOneSMSToken() {
				DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionOtpChooseTemplate, DigitalMembershipCard.dmcProvisioningContent, DigitalMembershipCard.parameters());
				$(DigitalMembershipCard.dmcActionsButton).removeClass('submit-token');
				sessionStorage.removeItem(DigitalMembershipCard.dmcValidationCodeExpired);
				sessionStorage.removeItem(DigitalMembershipCard.dmcValidationCodeExpTime);
				DigitalMembershipCard.bindDmcEvents();
			},
	
			/**
	   * Binding of different buttons. Choose button in OTP flow, Back to Membership Card button (dmcActionsButton), Cancel buttons etc..
	   * 
	   * */
			bindDmcEvents: function bindDmcEvents() {
				$(DigitalMembershipCard.dmcChooseButton).on('click keydown', function (event) {
					$(DigitalMembershipCard.dmcChooseButton).removeClass('active');
					$(this).closest(DigitalMembershipCard.dmcChooseButton).find(':radio').prop('checked', true);
					$(this).closest(DigitalMembershipCard.dmcChooseButton).addClass('active');
					$('#dmc-yp-choose-form > #dmc-hidden-inputs > #aliasId').val(this.getAttribute("aliasId"));
					$('#dmc-yp-choose-form > #dmc-hidden-inputs > #otpDeliveryOption').val(this.getAttribute("otpDeliveryOption"));
					$('#dmc-yp-add-token-form > #dmc-hidden-inputs > #otpDeliveryOption').val(this.getAttribute("otpDeliveryOption"));
				});
	
				$(DigitalMembershipCard.dmcActionsButton).on('click keydown', function (event) {
					if ($(DigitalMembershipCard.dmcActionsButton).hasClass('submit-token')) {
						DigitalMembershipCard.dmcTokenFieldValidation();
						if ($('#dmc-sms-token').val() != '') {
							$(DigitalMembershipCard.dmcAddTokenForm).submit();
						}
					} else if ($(DigitalMembershipCard.dmcActionsButton).hasClass(DigitalMembershipCard.dmcBackToDMCClass)) {
						$('#dmc-red-path-form').submit();
					} else {
						if ($(DigitalMembershipCard.dmcActionsButton).hasClass(DigitalMembershipCard.dmcOTPContinue)) {
							var aliasId = $("[type=radio][name='dmc-choose-verification-method']:checked").attr("aliasid");
							var otpDeliveryOption = $("[type=radio][name='dmc-choose-verification-method']:checked").attr("otpDeliveryOption");
							$('#dmc-yp-choose-form > #dmc-hidden-inputs > #aliasId').val(aliasId);
							$('#dmc-yp-add-token-form > #dmc-hidden-inputs > #aliasId').val(aliasId);
							$('#dmc-yp-choose-form > #dmc-hidden-inputs > #otpDeliveryOption').val(otpDeliveryOption);
							$('#dmc-yp-add-token-form > #dmc-hidden-inputs > #otpDeliveryOption').val(otpDeliveryOption);
						}
						$('#dmc-yp-choose-form').submit();
					}
					if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.YELLOW_FLOW) {
						sessionStorage.removeItem(DigitalMembershipCard.dmcValidationCodeExpired);
						sessionStorage.removeItem(DigitalMembershipCard.dmcValidationCodeExpTime);
					}
				});
	
				$(DigitalMembershipCard.dmcCancelButton).on('click keydown', function (event) {
					$('#dmc-red-path-form').submit();
				});
	
				$(DigitalMembershipCard.dmcContent).on('click keydown', '.dmc-box-regular', function (event) {
					event.stopImmediatePropagation();
					var brand = $(this).find('.brand').text();
					var displayAccountNumber = $(this).find('.display-account-number').text();
					var accountHolderName = $(this).find('.account-holder-name').text();
					var dmcCobrandedCards = $(DigitalMembershipCard.dmcContent).html();
					sessionStorage.setItem('dmc-cc-cards-hidden', dmcCobrandedCards);
					DigitalMembershipCard.loadCVVTemplate(brand, displayAccountNumber, accountHolderName);
					$('#dmc-yp-choose-form > #dmc-hidden-inputs > #displayAccountNumb').val(displayAccountNumber);
	
					DigitalMembershipCard.bindDmcEvents();
				});
	
				$('.dmc-input-field').on('focusout', function () {
					DigitalMembershipCard.addClassActive(this);
				});
			},
	
			addClassActive: function addClassActive(inputField) {
				var cvvInputField = $(inputField);
				if (cvvInputField.val() != '' && cvvInputField.val() != undefined) {
					cvvInputField.addClass('active');
				}
			},
	
			/**
	   * Align co-branded cards in same line. Gets the max height and apply it to each div that contains the card. 
	   * 
	   */
			alignCardsBox: function alignCardsBox() {
				var box = '#dmc-co-branded-cards';
				var maxHeight = '';
	
				$(box).find('.dmc-box').each(function (index, item) {
					var height = $(item).outerHeight();
					if (maxHeight < height) {
						maxHeight = height;
					}
				});
	
				$('#dmc-co-branded-cards .dmc-box').css('height', maxHeight);
				if (!COSTCO.Navigation_v2.isPhoneView()) {
					$('#dmc-co-branded-cards .dmc-box').addClass('cds-u-space-mr-xl');
				}
				if ($('#cardExpiryDate').val() !== undefined && $('#cardExpiryDate').val() !== '') {
					$('#cardExpiryDateLabel').addClass('active');
				}
				if ($('#cvvNumber').val() !== undefined && $('#cvvNumber').val() !== '') {
					$('#cvvNumberLabel').addClass('active');
				}
				if ($('#postalCode').val() !== undefined && $('#postalCode').val() !== '') {
					$('#postalCodeLabel').addClass('active');
				}
			},
	
			/**
	   * Single field validation. In OTP flow on sms Token screen.
	   *  
	   * */
			dmcTokenFieldValidation: function dmcTokenFieldValidation() {
				if ($('#dmc-sms-token').val() != '') {
					$('#dmc-sms-token').focus();
					var message = '';
					$.validator.addMethod("dmcTokenExpired", function (inputValue) {
						var isTokenExpired = sessionStorage.getItem(DigitalMembershipCard.dmcValidationCodeExpired);
						if (isTokenExpired == 'false') {
							return true;
						} else {
							return false;
						}
					}, message = messages.ERR_OTP_DMC_EXPIRED_TOKEN);
	
					if ($(DigitalMembershipCard.dmcAddTokenForm).validate()) {
						$(DigitalMembershipCard.dmcAddTokenForm).validate().resetForm();
						$(DigitalMembershipCard.dmcAddTokenForm).validate();
						$('#dmc-sms-token').rules('add', 'dmcTokenExpired');
						$('#dmc-sms-token').valid();
					}
				}
			},
	
			/**
	   * Counter that measure time from 10 minutes until the code is expired.
	   * Store the current time +Selected interval in this case 10 minutes in session storage and 
	   * call the getDistanceAndSetTimeRemaining method which return the distance from current time and stored value and checks
	   * if the distance is bigger than 0. 
	   *  
	   * */
			countDown: function countDown() {
				var now = new Date().getTime();
				var expTime = now + parseInt($('#dmcOtpTimer').val());
	
				if (typeof Storage !== "undefined") {
					if (sessionStorage.getItem(DigitalMembershipCard.dmcValidationCodeExpTime) !== null) {
						expTime = sessionStorage.getItem(DigitalMembershipCard.dmcValidationCodeExpTime);
					} else {
						sessionStorage.setItem(DigitalMembershipCard.dmcValidationCodeExpTime, expTime);
						sessionStorage.setItem(DigitalMembershipCard.dmcValidationCodeExpired, false);
					}
				}
				if (now > expTime) {
					$(DigitalMembershipCard.dmcTimer).text(DigitalMembershipCard.dmcCountDownFinishedMessage);
					sessionStorage.setItem(DigitalMembershipCard.dmcValidationCodeExpired, true);
					DigitalMembershipCard.dmcTokenFieldValidation();
				} else {
					// Update the count down every 1 second
					var x = setInterval(function () {
						var distance = DigitalMembershipCard.getDistanceAndSetTimeRemaining(expTime);
						if (distance < 0) {
							clearInterval(x);
						}
					}, 1000);
				}
			},
			/**
	   * get distance from current time and event expiration time
	   * set time remaining in minutes nad seconds
	   * 
	   * @param expirationTime
	   * @return distance
	   */
			getDistanceAndSetTimeRemaining: function getDistanceAndSetTimeRemaining(expirationTime) {
	
				var now = new Date().getTime();
				var distance = expirationTime - now;
	
				var minutes = Math.floor(distance / (1000 * 60));
				var seconds = Math.floor(distance % (1000 * 60) / 1000);
				var timeRemaining = minutes + " minutes and " + (seconds < 10 ? "0" + seconds : seconds) + " seconds";
				if (minutes > 0 || seconds > 0) {
					$(DigitalMembershipCard.dmcTimer).text(timeRemaining);
				} else {
					$(DigitalMembershipCard.dmcTimer).text(DigitalMembershipCard.dmcCountDownFinishedMessage);
					sessionStorage.setItem(DigitalMembershipCard.dmcValidationCodeExpired, true);
					DigitalMembershipCard.dmcTokenFieldValidation();
				}
	
				return distance;
			},
	
			verifyYourMembership: function verifyYourMembership() {
				COSTCO.AccountDetails.memberVerification();
			},
	
			/**
	   * Dmc validation for CVV form check for expiry date and if it is in past, cvv length and value
	   * and Zipcode pattern. 
	   * 
	   * */
			dmcMobileValidation: function dmcMobileValidation() {
				$.validator.addMethod("cvv", function (value, element) {
					if (value.trim().length == 3) return true;else {
						element.value = '';
						return false;
					}
				}, messages.ERR_INVALID_CVV);
	
				$.validator.addMethod('checkExpiryDate', function (value, element) {
					if (this.optional(element) || /^(0[1-9]|1[012])\/([123]\d)$/.test(value)) return true;else {
						element.value = '';
						return false;
					}
				}, messages.ERR_INVALID_DATE);
	
				$.validator.addMethod("checkIsDateInPast", function (value, element) {
					var enteredMonth = parseInt(value.split('/')[0]);
					var enteredYear = parseInt(value.split('/')[1]);
					var now = new Date();
					var currentMonth = parseInt((now.getMonth() + 1).toString());
					var currentYear = parseInt(now.getFullYear().toString().substr(-2));
					if (enteredYear < currentYear || enteredYear == currentYear && enteredMonth < currentMonth) {
						element.value = '';
						return false;
					} else {
						return true;
					}
				}, messages.ERR_INVALID_DATE);
	
				$.validator.addMethod('countryspecificpostalcode', function (value, element, params) {
					var zip_pattern = new RegExp(document.getElementById('zipcode_patterns').getAttribute('value'));
					if (this.optional(element) || zip_pattern.test($.trim(value))) return true;else {
						element.value = '';
						return false;
					}
				}, messages.ERR_INVALID_DELIVERY_ZIP_CODE);
	
				$('#dmc-add-cc-form').validate({
					onkeyup: false,
					rules: {
						cardExpiryDate: {
							required: true,
							checkExpiryDate: true,
							checkIsDateInPast: true
						},
						cvvNumber: {
							required: true,
							cvv: true
						},
						postalCode: {
							required: true,
							countryspecificpostalcode: true
						}
					},
					messages: {
						cardExpiryDate: {
							required: messages.ERR_INVALID_DATE
						},
						cvvNumber: {
							required: messages.ERR_INVALID_CVV
						},
						postalCode: {
							required: messages.ERR_INVALID_DELIVERY_ZIP_CODE
						}
					},
					submitHandler: function (form) {
						form.submit();
					}.bind(this)
				});
			}
		};
	
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = {};
		}
		window.COSTCO.DigitalMembershipCard = DigitalMembershipCard;
		return DigitalMembershipCard;
		return DigitalMembershipCard;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// account.module.min.js